import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, Input, ViewChild, Injectable, HostListener, TemplateRef, ContentChildren, ChangeDetectionStrategy, EventEmitter, Output, ViewChildren, Pipe, Directive, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { DatePipe, CommonModule } from '@angular/common';
import lottie from 'lottie-web';
import { trigger, transition, style, animate, group, state } from '@angular/animations';
import { BehaviorSubject } from 'rxjs';
import { map, debounceTime, distinct } from 'rxjs/operators';
import { debounce } from 'debounce';
import * as i1$1 from '@angular/platform-browser';
import * as Highcharts from 'highcharts';
import * as i1$2 from 'highcharts-angular';
import { HighchartsChartModule } from 'highcharts-angular';
import * as i2 from 'ngx-infinite-scroll';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

var NdbxIcon;
(function (NdbxIcon) {
    NdbxIcon["ArrowDownSlim"] = "arrow-down-slim";
    NdbxIcon["ArrowDown"] = "arrow-down";
    NdbxIcon["ArrowDownload"] = "arrow-download";
    NdbxIcon["ArrowFirst"] = "arrow-first";
    NdbxIcon["ArrowLast"] = "arrow-last";
    NdbxIcon["ArrowLeftSlim"] = "arrow-left-slim";
    NdbxIcon["ArrowLeft"] = "arrow-left";
    NdbxIcon["ArrowRightSlim"] = "arrow-right-slim";
    NdbxIcon["ArrowRight"] = "arrow-right";
    NdbxIcon["ArrowUpSlim"] = "arrow-up-slim";
    NdbxIcon["ArrowUp"] = "arrow-up";
    NdbxIcon["ArrowUpload"] = "arrow-upload";
    NdbxIcon["Back"] = "back";
    NdbxIcon["Bars"] = "bars";
    NdbxIcon["BellO"] = "bell-o";
    NdbxIcon["BellOffO"] = "bell-off-o";
    NdbxIcon["BellOff"] = "bell-off";
    NdbxIcon["Bell"] = "bell";
    NdbxIcon["BoardShareGraph"] = "board-share-graph";
    NdbxIcon["BoltO"] = "bolt-o";
    NdbxIcon["Bolt"] = "bolt";
    NdbxIcon["BookmarkO"] = "bookmark-o";
    NdbxIcon["Bookmark"] = "bookmark";
    NdbxIcon["CalendarDateCheckO"] = "calendar-date-check-o";
    NdbxIcon["CalendarDateCheck"] = "calendar-date-check";
    NdbxIcon["CalendarDefault"] = "calendar-default";
    NdbxIcon["CalendarReminderO"] = "calendar-reminder-o";
    NdbxIcon["CalendarReminder"] = "calendar-reminder";
    NdbxIcon["Calendar"] = "calendar";
    NdbxIcon["CardO"] = "card-o";
    NdbxIcon["CertificatePapers"] = "certificate-papers";
    NdbxIcon["ChatO"] = "chat-o";
    NdbxIcon["Chat"] = "chat";
    NdbxIcon["CheckCircle"] = "check-circle";
    NdbxIcon["Check"] = "check";
    NdbxIcon["ChevronDownSmall"] = "chevron-down-small";
    NdbxIcon["ChevronDown"] = "chevron-down";
    NdbxIcon["ChevronLeftCircleO"] = "chevron-left-circle-o";
    NdbxIcon["ChevronLeftCircle"] = "chevron-left-circle";
    NdbxIcon["ChevronLeftSmall"] = "chevron-left-small";
    NdbxIcon["ChevronLeft"] = "chevron-left";
    NdbxIcon["ChevronRightCircleO"] = "chevron-right-circle-o";
    NdbxIcon["ChevronRightCircle"] = "chevron-right-circle";
    NdbxIcon["ChevronRightSmall"] = "chevron-right-small";
    NdbxIcon["ChevronRight"] = "chevron-right";
    NdbxIcon["ChevronUpSmall"] = "chevron-up-small";
    NdbxIcon["ChevronUp"] = "chevron-up";
    NdbxIcon["ClockO"] = "clock-o";
    NdbxIcon["Clock"] = "clock";
    NdbxIcon["CloseCircleO"] = "close-circle-o";
    NdbxIcon["CloseCircle"] = "close-circle";
    NdbxIcon["Close"] = "close";
    NdbxIcon["CobrowsingO"] = "cobrowsing-o";
    NdbxIcon["CreditCardO"] = "credit-card-o";
    NdbxIcon["CreditCard"] = "credit-card";
    NdbxIcon["DocText"] = "doc-text";
    NdbxIcon["Doc"] = "doc";
    NdbxIcon["Dot"] = "dot";
    NdbxIcon["Download"] = "download";
    NdbxIcon["Duplicate"] = "duplicate";
    NdbxIcon["EMailReadO"] = "e-mail-read-o";
    NdbxIcon["EMailRead"] = "e-mail-read";
    NdbxIcon["Edit"] = "edit";
    NdbxIcon["EllipsisH"] = "ellipsis-h";
    NdbxIcon["EllipsisV"] = "ellipsis-v";
    NdbxIcon["EpsText"] = "eps-text";
    NdbxIcon["Eps"] = "eps";
    NdbxIcon["ExclamationCircleO"] = "exclamation-circle-o";
    NdbxIcon["ExclamationCircle"] = "exclamation-circle";
    NdbxIcon["ExclamationTriangleO"] = "exclamation-triangle-o";
    NdbxIcon["ExclamationTriangle"] = "exclamation-triangle";
    NdbxIcon["ExportAndShare"] = "export-and-share";
    NdbxIcon["FacebookCircle"] = "facebook-circle";
    NdbxIcon["Facebook"] = "facebook";
    NdbxIcon["FileDocument"] = "file-document";
    NdbxIcon["FileFlag"] = "file-flag";
    NdbxIcon["FileText"] = "file-text";
    NdbxIcon["File"] = "file";
    NdbxIcon["Filter"] = "filter";
    NdbxIcon["FountainPen"] = "fountain-pen";
    NdbxIcon["GoogleCircle"] = "google-circle";
    NdbxIcon["GooglePlus"] = "google-plus";
    NdbxIcon["Grapes"] = "grapes";
    NdbxIcon["HandCogWheel"] = "hand-cog-wheel";
    NdbxIcon["HandTray"] = "hand-tray";
    NdbxIcon["HelmetConstruction"] = "helmet-construction";
    NdbxIcon["HelpQuestionF"] = "help-question-f";
    NdbxIcon["ImgText"] = "img-text";
    NdbxIcon["Img"] = "img";
    NdbxIcon["InProgress"] = "in-progress";
    NdbxIcon["InfoCircleO"] = "info-circle-o";
    NdbxIcon["InfoCircle"] = "info-circle";
    NdbxIcon["InstagramCircle"] = "instagram-circle";
    NdbxIcon["Instagram"] = "instagram";
    NdbxIcon["JpgText"] = "jpg-text";
    NdbxIcon["Jpg"] = "jpg";
    NdbxIcon["LaptopCogWheel"] = "laptop-cog-wheel";
    NdbxIcon["Launch"] = "launch";
    NdbxIcon["LinkedinCircle"] = "linkedin-circle";
    NdbxIcon["Linkedin"] = "linkedin";
    NdbxIcon["List"] = "list";
    NdbxIcon["LocationO"] = "location-o";
    NdbxIcon["Location"] = "location";
    NdbxIcon["LockO"] = "lock-o";
    NdbxIcon["LockUnlockO"] = "lock-unlock-o";
    NdbxIcon["LockUnlock"] = "lock-unlock";
    NdbxIcon["Lock"] = "lock";
    NdbxIcon["MailCircle"] = "mail-circle";
    NdbxIcon["MailO"] = "mail-o";
    NdbxIcon["Mail"] = "mail";
    NdbxIcon["Manager"] = "manager";
    NdbxIcon["MessengerCircle"] = "messenger-circle";
    NdbxIcon["Messenger"] = "messenger";
    NdbxIcon["MicrophoneDefault"] = "microphone-default";
    NdbxIcon["MicrophoneMuteO"] = "microphone-mute-o";
    NdbxIcon["MicrophoneMute"] = "microphone-mute";
    NdbxIcon["Microphone"] = "microphone";
    NdbxIcon["MinusCircleO"] = "minus-circle-o";
    NdbxIcon["MinusCircle"] = "minus-circle";
    NdbxIcon["Minus"] = "minus";
    NdbxIcon["Mp3Text"] = "mp3-text";
    NdbxIcon["Mp3"] = "mp3";
    NdbxIcon["Paperclip"] = "paperclip";
    NdbxIcon["PasswordHideO"] = "password-hide-o";
    NdbxIcon["PasswordHide"] = "password-hide";
    NdbxIcon["PasswordShowO"] = "password-show-o";
    NdbxIcon["PasswordShow"] = "password-show";
    NdbxIcon["Pause"] = "pause";
    NdbxIcon["PdfText"] = "pdf-text";
    NdbxIcon["Pdf"] = "pdf";
    NdbxIcon["Pen"] = "pen";
    NdbxIcon["PhoneChatO"] = "phone-chat-o";
    NdbxIcon["PhoneChat"] = "phone-chat";
    NdbxIcon["PhoneO"] = "phone-o";
    NdbxIcon["Phone"] = "phone";
    NdbxIcon["Play"] = "play";
    NdbxIcon["PlusCircleO"] = "plus-circle-o";
    NdbxIcon["PlusCircle"] = "plus-circle";
    NdbxIcon["Plus"] = "plus";
    NdbxIcon["PodText"] = "pod-text";
    NdbxIcon["Pod"] = "pod";
    NdbxIcon["Popout"] = "popout";
    NdbxIcon["PptText"] = "ppt-text";
    NdbxIcon["Ppt"] = "ppt";
    NdbxIcon["PrintO"] = "print-o";
    NdbxIcon["Print"] = "print";
    NdbxIcon["ProductAZ"] = "product-a-z";
    NdbxIcon["ProductAnimalCat"] = "product-animal-cat";
    NdbxIcon["ProductAnimalDog"] = "product-animal-dog";
    NdbxIcon["ProductAnimalHorse"] = "product-animal-horse";
    NdbxIcon["ProductAnimalHuntingDeer"] = "product-animal-hunting-deer";
    NdbxIcon["ProductAnimalPaw"] = "product-animal-paw";
    NdbxIcon["ProductApartmentBuilding"] = "product-apartment-building";
    NdbxIcon["ProductArrowDirectionPath"] = "product-arrow-direction-path";
    NdbxIcon["ProductAtSign"] = "product-at-sign";
    NdbxIcon["ProductBalanceScale"] = "product-balance-scale";
    NdbxIcon["ProductBankMonumentInfo"] = "product-bank-monument-info";
    NdbxIcon["ProductBattery"] = "product-battery";
    NdbxIcon["ProductBed"] = "product-bed";
    NdbxIcon["ProductBereavedDependentPension"] = "product-bereaved-dependent-pension";
    NdbxIcon["ProductBike"] = "product-bike";
    NdbxIcon["ProductBlog"] = "product-blog";
    NdbxIcon["ProductBoardPaperNote"] = "product-board-paper-note";
    NdbxIcon["ProductBook"] = "product-book";
    NdbxIcon["ProductBrain"] = "product-brain";
    NdbxIcon["ProductBrokenGlass"] = "product-broken-glass";
    NdbxIcon["ProductBrokenWindow"] = "product-broken-window";
    NdbxIcon["ProductBroomClean"] = "product-broom-clean";
    NdbxIcon["ProductBuggy"] = "product-buggy";
    NdbxIcon["ProductBuilding"] = "product-building";
    NdbxIcon["ProductBullhorn"] = "product-bullhorn";
    NdbxIcon["ProductCalculator"] = "product-calculator";
    NdbxIcon["ProductCalendar"] = "product-calendar";
    NdbxIcon["ProductCamera"] = "product-camera";
    NdbxIcon["ProductCandle"] = "product-candle";
    NdbxIcon["ProductCarAccident"] = "product-car-accident";
    NdbxIcon["ProductCarFront"] = "product-car-front";
    NdbxIcon["ProductCarMobility"] = "product-car-mobility";
    NdbxIcon["ProductCarSmall"] = "product-car-small";
    NdbxIcon["ProductCarTachoFast"] = "product-car-tacho-fast";
    NdbxIcon["ProductCarTrailer"] = "product-car-trailer";
    NdbxIcon["ProductCar"] = "product-car";
    NdbxIcon["ProductCaravan"] = "product-caravan";
    NdbxIcon["ProductCareInsurance"] = "product-care-insurance";
    NdbxIcon["ProductCertificate"] = "product-certificate";
    NdbxIcon["ProductCheckPaperF"] = "product-check-paper-f";
    NdbxIcon["ProductCheckPaper"] = "product-check-paper";
    NdbxIcon["ProductCheck"] = "product-check";
    NdbxIcon["ProductCity"] = "product-city";
    NdbxIcon["ProductCleanupTrash"] = "product-cleanup-trash";
    NdbxIcon["ProductClock"] = "product-clock";
    NdbxIcon["ProductCloud"] = "product-cloud";
    NdbxIcon["ProductCogWheel"] = "product-cog-wheel";
    NdbxIcon["ProductCogWheels"] = "product-cog-wheels";
    NdbxIcon["ProductCoinsMoneyF"] = "product-coins-money-f";
    NdbxIcon["ProductCoinsMoney"] = "product-coins-money";
    NdbxIcon["ProductCommunication"] = "product-communication";
    NdbxIcon["ProductComputer"] = "product-computer";
    NdbxIcon["ProductCouch"] = "product-couch";
    NdbxIcon["ProductCreditCard"] = "product-credit-card";
    NdbxIcon["ProductCrossTriangle"] = "product-cross-triangle";
    NdbxIcon["ProductCross"] = "product-cross";
    NdbxIcon["ProductDangerF"] = "product-danger-f";
    NdbxIcon["ProductDanger"] = "product-danger";
    NdbxIcon["ProductDataExchange"] = "product-data-exchange";
    NdbxIcon["ProductDiversity"] = "product-diversity";
    NdbxIcon["ProductDollar"] = "product-dollar";
    NdbxIcon["ProductDoor"] = "product-door";
    NdbxIcon["ProductElectricPlug"] = "product-electric-plug";
    NdbxIcon["ProductExcavator"] = "product-excavator";
    NdbxIcon["ProductExpensiveObjectsJewelery"] = "product-expensive-objects-jewelery";
    NdbxIcon["ProductEyeOverviewSight"] = "product-eye-overview-sight";
    NdbxIcon["ProductFamily"] = "product-family";
    NdbxIcon["ProductFire"] = "product-fire";
    NdbxIcon["ProductFolder"] = "product-folder";
    NdbxIcon["ProductForkLiftTruck"] = "product-fork-lift-truck";
    NdbxIcon["ProductFortune"] = "product-fortune";
    NdbxIcon["ProductGarage"] = "product-garage";
    NdbxIcon["ProductGuideNavigation"] = "product-guide-navigation";
    NdbxIcon["ProductHandClickInfo"] = "product-hand-click-info";
    NdbxIcon["ProductHandFingerPointing"] = "product-hand-finger-pointing";
    NdbxIcon["ProductHandGetMoney"] = "product-hand-get-money";
    NdbxIcon["ProductHandThumbsUp"] = "product-hand-thumbs-up";
    NdbxIcon["ProductHeadsetSupport"] = "product-headset-support";
    NdbxIcon["ProductHealthBagDoctor"] = "product-health-bag-doctor";
    NdbxIcon["ProductHealthStethoscope"] = "product-health-stethoscope";
    NdbxIcon["ProductHealth"] = "product-health";
    NdbxIcon["ProductHeartEmployeeEngagement"] = "product-heart-employee-engagement";
    NdbxIcon["ProductHeart"] = "product-heart";
    NdbxIcon["ProductHelmet"] = "product-helmet";
    NdbxIcon["ProductHelpInformation"] = "product-help-information";
    NdbxIcon["ProductHelpQuestion"] = "product-help-question";
    NdbxIcon["ProductHelp"] = "product-help";
    NdbxIcon["ProductHomeOffice"] = "product-home-office";
    NdbxIcon["ProductHourglass"] = "product-hourglass";
    NdbxIcon["ProductHouseBrokenWindow"] = "product-house-broken-window";
    NdbxIcon["ProductHouseFire"] = "product-house-fire";
    NdbxIcon["ProductHouseImportant"] = "product-house-important";
    NdbxIcon["ProductHouseMoney"] = "product-house-money";
    NdbxIcon["ProductHouseSafe"] = "product-house-safe";
    NdbxIcon["ProductHouseWaterDamage"] = "product-house-water-damage";
    NdbxIcon["ProductHouse"] = "product-house";
    NdbxIcon["ProductHydroPower"] = "product-hydro-power";
    NdbxIcon["ProductImportantInfo"] = "product-important-info";
    NdbxIcon["ProductIncomePrecaution"] = "product-income-precaution";
    NdbxIcon["ProductInfoSheet"] = "product-info-sheet";
    NdbxIcon["ProductInjuryPlaster"] = "product-injury-plaster";
    NdbxIcon["ProductJobProcesses"] = "product-job-processes";
    NdbxIcon["ProductKeys"] = "product-keys";
    NdbxIcon["ProductLaptop"] = "product-laptop";
    NdbxIcon["ProductLaw"] = "product-law";
    NdbxIcon["ProductLightBulbIdea"] = "product-light-bulb-idea";
    NdbxIcon["ProductLocatePositionF"] = "product-locate-position-f";
    NdbxIcon["ProductLocatePosition"] = "product-locate-position";
    NdbxIcon["ProductLock"] = "product-lock";
    NdbxIcon["ProductMail"] = "product-mail";
    NdbxIcon["ProductMedia"] = "product-media";
    NdbxIcon["ProductMobility"] = "product-mobility";
    NdbxIcon["ProductMoneyBanknote"] = "product-money-banknote";
    NdbxIcon["ProductMoneyExchange"] = "product-money-exchange";
    NdbxIcon["ProductMoneySuitcase"] = "product-money-suitcase";
    NdbxIcon["ProductMotorcycle"] = "product-motorcycle";
    NdbxIcon["ProductMouse"] = "product-mouse";
    NdbxIcon["ProductMusic"] = "product-music";
    NdbxIcon["ProductNatureLeaf"] = "product-nature-leaf";
    NdbxIcon["ProductNewspaper"] = "product-newspaper";
    NdbxIcon["ProductNotebook"] = "product-notebook";
    NdbxIcon["ProductOfficeChair"] = "product-office-chair";
    NdbxIcon["ProductPagesDocuments"] = "product-pages-documents";
    NdbxIcon["ProductPaperDocument"] = "product-paper-document";
    NdbxIcon["ProductPaperLock"] = "product-paper-lock";
    NdbxIcon["ProductPartnerHandshake"] = "product-partner-handshake";
    NdbxIcon["ProductPen"] = "product-pen";
    NdbxIcon["ProductPensionRockerChair"] = "product-pension-rocker-chair";
    NdbxIcon["ProductPeopleCollaboration"] = "product-people-collaboration";
    NdbxIcon["ProductPeopleCommunicationExternal"] = "product-people-communication-external";
    NdbxIcon["ProductPeopleCommunicationInternal"] = "product-people-communication-internal";
    NdbxIcon["ProductPeopleConnect"] = "product-people-connect";
    NdbxIcon["ProductPersonHeartPeopleLove"] = "product-person-heart-people-love";
    NdbxIcon["ProductPerson"] = "product-person";
    NdbxIcon["ProductPetHealthInsurance"] = "product-pet-health-insurance";
    NdbxIcon["ProductPetOwnerLiability"] = "product-pet-owner-liability";
    NdbxIcon["ProductPhoneCall"] = "product-phone-call";
    NdbxIcon["ProductPlane"] = "product-plane";
    NdbxIcon["ProductPlusMinus"] = "product-plus-minus";
    NdbxIcon["ProductPlus"] = "product-plus";
    NdbxIcon["ProductPodcast"] = "product-podcast";
    NdbxIcon["ProductPowerPylon"] = "product-power-pylon";
    NdbxIcon["ProductPrecaution"] = "product-precaution";
    NdbxIcon["ProductPresent"] = "product-present";
    NdbxIcon["ProductPrivatePension"] = "product-private-pension";
    NdbxIcon["ProductPuzzlePieces"] = "product-puzzle-pieces";
    NdbxIcon["ProductPuzzle"] = "product-puzzle";
    NdbxIcon["ProductRadio"] = "product-radio";
    NdbxIcon["ProductRepair"] = "product-repair";
    NdbxIcon["ProductRewards"] = "product-rewards";
    NdbxIcon["ProductRocket"] = "product-rocket";
    NdbxIcon["ProductSave"] = "product-save";
    NdbxIcon["ProductSearchDocument"] = "product-search-document";
    NdbxIcon["ProductSearch"] = "product-search";
    NdbxIcon["ProductShareChart"] = "product-share-chart";
    NdbxIcon["ProductShareGraphArrowDown"] = "product-share-graph-arrow-down";
    NdbxIcon["ProductShareGraphArrowUp"] = "product-share-graph-arrow-up";
    NdbxIcon["ProductSharingConnect"] = "product-sharing-connect";
    NdbxIcon["ProductShieldHand"] = "product-shield-hand";
    NdbxIcon["ProductShield"] = "product-shield";
    NdbxIcon["ProductShoppingCart"] = "product-shopping-cart";
    NdbxIcon["ProductSmartphone"] = "product-smartphone";
    NdbxIcon["ProductSoccer"] = "product-Soccer";
    NdbxIcon["ProductSocialMediaFacebookMessenger"] = "product-social-media-facebook-messenger";
    NdbxIcon["ProductSocialMediaFacebook"] = "product-social-media-facebook";
    NdbxIcon["ProductSocialMediaLinkedin"] = "product-social-media-linkedin";
    NdbxIcon["ProductSocialMediaTwitter"] = "product-social-media-twitter";
    NdbxIcon["ProductSocialMediaWhatsapp"] = "product-social-media-whatsapp";
    NdbxIcon["ProductSolarPowerModules"] = "product-solar-power-modules";
    NdbxIcon["ProductSportSailingShip"] = "product-sport-sailing-ship";
    NdbxIcon["ProductSportTrainer"] = "product-sport-trainer";
    NdbxIcon["ProductSportsCar"] = "product-sports-car";
    NdbxIcon["ProductSports"] = "product-sports";
    NdbxIcon["ProductStarEvent"] = "product-star-event";
    NdbxIcon["ProductStarsSkyGalaxy"] = "product-stars-sky-galaxy";
    NdbxIcon["ProductSteeringWheel"] = "product-steering-wheel";
    NdbxIcon["ProductStockDataGraph"] = "product-stock-data-graph";
    NdbxIcon["ProductStoveCooker"] = "product-stove-cooker";
    NdbxIcon["ProductStrategy"] = "product-strategy";
    NdbxIcon["ProductStudentSchoolGraduation"] = "product-student-school-graduation";
    NdbxIcon["ProductSurvey"] = "product-survey";
    NdbxIcon["ProductSuvCar"] = "product-SUV-car";
    NdbxIcon["ProductTabletIpadApps"] = "product-tablet-ipad-apps";
    NdbxIcon["ProductTarget"] = "product-target";
    NdbxIcon["ProductTelematicCarFront"] = "product-telematic-car-front";
    NdbxIcon["ProductTelematicCarSide"] = "product-telematic-car-side";
    NdbxIcon["ProductThermalPowerPlant"] = "product-thermal-power-plant";
    NdbxIcon["ProductThermometer"] = "product-thermometer";
    NdbxIcon["ProductThief"] = "product-thief";
    NdbxIcon["ProductThunderstorm"] = "product-thunderstorm";
    NdbxIcon["ProductTiresWheel"] = "product-tires-wheel";
    NdbxIcon["ProductToDoList"] = "product-to-do-list";
    NdbxIcon["ProductTooth"] = "product-tooth";
    NdbxIcon["ProductTravel"] = "product-travel";
    NdbxIcon["ProductTruck"] = "product-truck";
    NdbxIcon["ProductTv"] = "product-tv";
    NdbxIcon["ProductUmbrellaProtection"] = "product-umbrella-protection";
    NdbxIcon["ProductVideoCamera"] = "product-video-camera";
    NdbxIcon["ProductVoiceOfTheCustomer"] = "product-voice-of-the-customer";
    NdbxIcon["ProductWallBalance"] = "product-wall-balance";
    NdbxIcon["ProductWasher"] = "product-washer";
    NdbxIcon["ProductWaterTap"] = "product-water-tap";
    NdbxIcon["ProductWateringCan"] = "product-watering-can";
    NdbxIcon["ProductWheelchair"] = "product-wheelchair";
    NdbxIcon["ProductWindTurbineOffshore"] = "product-wind-turbine-offshore";
    NdbxIcon["ProductWindTurbineOnshore"] = "product-wind-turbine-onshore";
    NdbxIcon["ProductWorldGlobe"] = "product-world-globe";
    NdbxIcon["ProductWorldWideWe"] = "product-world-wide-we";
    NdbxIcon["Refresh"] = "refresh";
    NdbxIcon["SaveO"] = "save-o";
    NdbxIcon["Search"] = "search";
    NdbxIcon["SentimentDissatisfied"] = "sentiment-dissatisfied";
    NdbxIcon["SentimentNeutral"] = "sentiment-neutral";
    NdbxIcon["SentimentSatisfied"] = "sentiment-satisfied";
    NdbxIcon["SentimentVeryDissatisfied"] = "sentiment-very-dissatisfied";
    NdbxIcon["SentimentVerySatisfied"] = "sentiment-very-satisfied";
    NdbxIcon["SetTimer"] = "set-timer";
    NdbxIcon["SettingO"] = "setting-o";
    NdbxIcon["Setting"] = "setting";
    NdbxIcon["Share"] = "share";
    NdbxIcon["SidebarLeft"] = "sidebar-left";
    NdbxIcon["SidebarRight"] = "sidebar-right";
    NdbxIcon["Skyscraper"] = "skyscraper";
    NdbxIcon["SliderGraphO"] = "slider-graph-o";
    NdbxIcon["SpeakerOffO"] = "speaker-off-o";
    NdbxIcon["SpeakerOff"] = "speaker-off";
    NdbxIcon["SpeakerOnO"] = "speaker-on-o";
    NdbxIcon["SpeakerOn"] = "speaker-on";
    NdbxIcon["SpeechBubbleDotsO"] = "speech-bubble-dots-o";
    NdbxIcon["SpeechBubbleDots"] = "speech-bubble-dots";
    NdbxIcon["SpeechBubbleO"] = "speech-bubble-o";
    NdbxIcon["SpeechBubble"] = "speech-bubble";
    NdbxIcon["StarHalfFull"] = "star-half-full";
    NdbxIcon["StarO"] = "star-o";
    NdbxIcon["Star"] = "star";
    NdbxIcon["Telegram"] = "telegram";
    NdbxIcon["TiffText"] = "tiff-text";
    NdbxIcon["Tiff"] = "tiff";
    NdbxIcon["Tractor"] = "tractor";
    NdbxIcon["TrashO"] = "trash-o";
    NdbxIcon["Trash"] = "trash";
    NdbxIcon["Trees"] = "trees";
    NdbxIcon["TvWorldGlobe"] = "tv-world-globe";
    NdbxIcon["TwitterCircle"] = "twitter-circle";
    NdbxIcon["Twitter"] = "twitter";
    NdbxIcon["TxtText"] = "txt-text";
    NdbxIcon["Txt"] = "txt";
    NdbxIcon["UserBusinessO"] = "user-business-o";
    NdbxIcon["UserBusiness"] = "user-business";
    NdbxIcon["UserO"] = "user-o";
    NdbxIcon["User"] = "user";
    NdbxIcon["UsersO"] = "users-o";
    NdbxIcon["Users"] = "users";
    NdbxIcon["VidText"] = "vid-text";
    NdbxIcon["Vid"] = "vid";
    NdbxIcon["VoiceOfTheCustomerF"] = "voice-of-the-customer-f";
    NdbxIcon["WhatsappCircle"] = "whatsapp-circle";
    NdbxIcon["Whatsapp"] = "whatsapp";
    NdbxIcon["XingCircle"] = "xing-circle";
    NdbxIcon["Xing"] = "xing";
    NdbxIcon["XlsText"] = "xls-text";
    NdbxIcon["Xls"] = "xls";
    NdbxIcon["YoutubeCirclePlay"] = "youtube-circle-play";
    NdbxIcon["YoutubeCircle"] = "youtube-circle";
    NdbxIcon["Youtube"] = "youtube";
})(NdbxIcon || (NdbxIcon = {}));
const NDBX_ICON_CODEPOINTS = {
    [NdbxIcon.ArrowDownSlim]: "61697",
    [NdbxIcon.ArrowDown]: "61698",
    [NdbxIcon.ArrowDownload]: "61699",
    [NdbxIcon.ArrowFirst]: "61700",
    [NdbxIcon.ArrowLast]: "61701",
    [NdbxIcon.ArrowLeftSlim]: "61702",
    [NdbxIcon.ArrowLeft]: "61703",
    [NdbxIcon.ArrowRightSlim]: "61704",
    [NdbxIcon.ArrowRight]: "61705",
    [NdbxIcon.ArrowUpSlim]: "61706",
    [NdbxIcon.ArrowUp]: "61707",
    [NdbxIcon.ArrowUpload]: "61708",
    [NdbxIcon.Back]: "61709",
    [NdbxIcon.Bars]: "61710",
    [NdbxIcon.BellO]: "61711",
    [NdbxIcon.BellOffO]: "61712",
    [NdbxIcon.BellOff]: "61713",
    [NdbxIcon.Bell]: "61714",
    [NdbxIcon.BoardShareGraph]: "61715",
    [NdbxIcon.BoltO]: "61716",
    [NdbxIcon.Bolt]: "61717",
    [NdbxIcon.BookmarkO]: "61718",
    [NdbxIcon.Bookmark]: "61719",
    [NdbxIcon.CalendarDateCheckO]: "61720",
    [NdbxIcon.CalendarDateCheck]: "61721",
    [NdbxIcon.CalendarDefault]: "61722",
    [NdbxIcon.CalendarReminderO]: "61723",
    [NdbxIcon.CalendarReminder]: "61724",
    [NdbxIcon.Calendar]: "61725",
    [NdbxIcon.CardO]: "61726",
    [NdbxIcon.CertificatePapers]: "61727",
    [NdbxIcon.ChatO]: "61728",
    [NdbxIcon.Chat]: "61729",
    [NdbxIcon.CheckCircle]: "61730",
    [NdbxIcon.Check]: "61731",
    [NdbxIcon.ChevronDownSmall]: "61732",
    [NdbxIcon.ChevronDown]: "61733",
    [NdbxIcon.ChevronLeftCircleO]: "61734",
    [NdbxIcon.ChevronLeftCircle]: "61735",
    [NdbxIcon.ChevronLeftSmall]: "61736",
    [NdbxIcon.ChevronLeft]: "61737",
    [NdbxIcon.ChevronRightCircleO]: "61738",
    [NdbxIcon.ChevronRightCircle]: "61739",
    [NdbxIcon.ChevronRightSmall]: "61740",
    [NdbxIcon.ChevronRight]: "61741",
    [NdbxIcon.ChevronUpSmall]: "61742",
    [NdbxIcon.ChevronUp]: "61743",
    [NdbxIcon.ClockO]: "61744",
    [NdbxIcon.Clock]: "61745",
    [NdbxIcon.CloseCircleO]: "61746",
    [NdbxIcon.CloseCircle]: "61747",
    [NdbxIcon.Close]: "61748",
    [NdbxIcon.CobrowsingO]: "61749",
    [NdbxIcon.CreditCardO]: "61750",
    [NdbxIcon.CreditCard]: "61751",
    [NdbxIcon.DocText]: "61752",
    [NdbxIcon.Doc]: "61753",
    [NdbxIcon.Dot]: "61754",
    [NdbxIcon.Download]: "61755",
    [NdbxIcon.Duplicate]: "61756",
    [NdbxIcon.EMailReadO]: "61757",
    [NdbxIcon.EMailRead]: "61758",
    [NdbxIcon.Edit]: "61759",
    [NdbxIcon.EllipsisH]: "61760",
    [NdbxIcon.EllipsisV]: "61761",
    [NdbxIcon.EpsText]: "61762",
    [NdbxIcon.Eps]: "61763",
    [NdbxIcon.ExclamationCircleO]: "61764",
    [NdbxIcon.ExclamationCircle]: "61765",
    [NdbxIcon.ExclamationTriangleO]: "61766",
    [NdbxIcon.ExclamationTriangle]: "61767",
    [NdbxIcon.ExportAndShare]: "61768",
    [NdbxIcon.FacebookCircle]: "61769",
    [NdbxIcon.Facebook]: "61770",
    [NdbxIcon.FileDocument]: "61771",
    [NdbxIcon.FileFlag]: "61772",
    [NdbxIcon.FileText]: "61773",
    [NdbxIcon.File]: "61774",
    [NdbxIcon.Filter]: "61775",
    [NdbxIcon.FountainPen]: "61776",
    [NdbxIcon.GoogleCircle]: "61777",
    [NdbxIcon.GooglePlus]: "61778",
    [NdbxIcon.Grapes]: "61779",
    [NdbxIcon.HandCogWheel]: "61780",
    [NdbxIcon.HandTray]: "61781",
    [NdbxIcon.HelmetConstruction]: "61782",
    [NdbxIcon.HelpQuestionF]: "61783",
    [NdbxIcon.ImgText]: "61784",
    [NdbxIcon.Img]: "61785",
    [NdbxIcon.InProgress]: "61786",
    [NdbxIcon.InfoCircleO]: "61787",
    [NdbxIcon.InfoCircle]: "61788",
    [NdbxIcon.InstagramCircle]: "61789",
    [NdbxIcon.Instagram]: "61790",
    [NdbxIcon.JpgText]: "61791",
    [NdbxIcon.Jpg]: "61792",
    [NdbxIcon.LaptopCogWheel]: "61793",
    [NdbxIcon.Launch]: "61794",
    [NdbxIcon.LinkedinCircle]: "61795",
    [NdbxIcon.Linkedin]: "61796",
    [NdbxIcon.List]: "61797",
    [NdbxIcon.LocationO]: "61798",
    [NdbxIcon.Location]: "61799",
    [NdbxIcon.LockO]: "61800",
    [NdbxIcon.LockUnlockO]: "61801",
    [NdbxIcon.LockUnlock]: "61802",
    [NdbxIcon.Lock]: "61803",
    [NdbxIcon.MailCircle]: "61804",
    [NdbxIcon.MailO]: "61805",
    [NdbxIcon.Mail]: "61806",
    [NdbxIcon.Manager]: "61807",
    [NdbxIcon.MessengerCircle]: "61808",
    [NdbxIcon.Messenger]: "61809",
    [NdbxIcon.MicrophoneDefault]: "61810",
    [NdbxIcon.MicrophoneMuteO]: "61811",
    [NdbxIcon.MicrophoneMute]: "61812",
    [NdbxIcon.Microphone]: "61813",
    [NdbxIcon.MinusCircleO]: "61814",
    [NdbxIcon.MinusCircle]: "61815",
    [NdbxIcon.Minus]: "61816",
    [NdbxIcon.Mp3Text]: "61817",
    [NdbxIcon.Mp3]: "61818",
    [NdbxIcon.Paperclip]: "61819",
    [NdbxIcon.PasswordHideO]: "61820",
    [NdbxIcon.PasswordHide]: "61821",
    [NdbxIcon.PasswordShowO]: "61822",
    [NdbxIcon.PasswordShow]: "61823",
    [NdbxIcon.Pause]: "61824",
    [NdbxIcon.PdfText]: "61825",
    [NdbxIcon.Pdf]: "61826",
    [NdbxIcon.Pen]: "61827",
    [NdbxIcon.PhoneChatO]: "61828",
    [NdbxIcon.PhoneChat]: "61829",
    [NdbxIcon.PhoneO]: "61830",
    [NdbxIcon.Phone]: "61831",
    [NdbxIcon.Play]: "61832",
    [NdbxIcon.PlusCircleO]: "61833",
    [NdbxIcon.PlusCircle]: "61834",
    [NdbxIcon.Plus]: "61835",
    [NdbxIcon.PodText]: "61836",
    [NdbxIcon.Pod]: "61837",
    [NdbxIcon.Popout]: "61838",
    [NdbxIcon.PptText]: "61839",
    [NdbxIcon.Ppt]: "61840",
    [NdbxIcon.PrintO]: "61841",
    [NdbxIcon.Print]: "61842",
    [NdbxIcon.ProductAZ]: "61843",
    [NdbxIcon.ProductAnimalCat]: "61844",
    [NdbxIcon.ProductAnimalDog]: "61845",
    [NdbxIcon.ProductAnimalHorse]: "61846",
    [NdbxIcon.ProductAnimalHuntingDeer]: "61847",
    [NdbxIcon.ProductAnimalPaw]: "61848",
    [NdbxIcon.ProductApartmentBuilding]: "61849",
    [NdbxIcon.ProductArrowDirectionPath]: "61850",
    [NdbxIcon.ProductAtSign]: "61851",
    [NdbxIcon.ProductBalanceScale]: "61852",
    [NdbxIcon.ProductBankMonumentInfo]: "61853",
    [NdbxIcon.ProductBattery]: "61854",
    [NdbxIcon.ProductBed]: "61855",
    [NdbxIcon.ProductBereavedDependentPension]: "61856",
    [NdbxIcon.ProductBike]: "61857",
    [NdbxIcon.ProductBlog]: "61858",
    [NdbxIcon.ProductBoardPaperNote]: "61859",
    [NdbxIcon.ProductBook]: "61860",
    [NdbxIcon.ProductBrain]: "61861",
    [NdbxIcon.ProductBrokenGlass]: "61862",
    [NdbxIcon.ProductBrokenWindow]: "61863",
    [NdbxIcon.ProductBroomClean]: "61864",
    [NdbxIcon.ProductBuggy]: "61865",
    [NdbxIcon.ProductBuilding]: "61866",
    [NdbxIcon.ProductBullhorn]: "61867",
    [NdbxIcon.ProductCalculator]: "61868",
    [NdbxIcon.ProductCalendar]: "61869",
    [NdbxIcon.ProductCamera]: "61870",
    [NdbxIcon.ProductCandle]: "61871",
    [NdbxIcon.ProductCarAccident]: "61872",
    [NdbxIcon.ProductCarFront]: "61873",
    [NdbxIcon.ProductCarMobility]: "61874",
    [NdbxIcon.ProductCarSmall]: "61875",
    [NdbxIcon.ProductCarTachoFast]: "61876",
    [NdbxIcon.ProductCarTrailer]: "61877",
    [NdbxIcon.ProductCar]: "61878",
    [NdbxIcon.ProductCaravan]: "61879",
    [NdbxIcon.ProductCareInsurance]: "61880",
    [NdbxIcon.ProductCertificate]: "61881",
    [NdbxIcon.ProductCheckPaperF]: "61882",
    [NdbxIcon.ProductCheckPaper]: "61883",
    [NdbxIcon.ProductCheck]: "61884",
    [NdbxIcon.ProductCity]: "61885",
    [NdbxIcon.ProductCleanupTrash]: "61886",
    [NdbxIcon.ProductClock]: "61887",
    [NdbxIcon.ProductCloud]: "61888",
    [NdbxIcon.ProductCogWheel]: "61889",
    [NdbxIcon.ProductCogWheels]: "61890",
    [NdbxIcon.ProductCoinsMoneyF]: "61891",
    [NdbxIcon.ProductCoinsMoney]: "61892",
    [NdbxIcon.ProductCommunication]: "61893",
    [NdbxIcon.ProductComputer]: "61894",
    [NdbxIcon.ProductCouch]: "61895",
    [NdbxIcon.ProductCreditCard]: "61896",
    [NdbxIcon.ProductCrossTriangle]: "61897",
    [NdbxIcon.ProductCross]: "61898",
    [NdbxIcon.ProductDangerF]: "61899",
    [NdbxIcon.ProductDanger]: "61900",
    [NdbxIcon.ProductDataExchange]: "61901",
    [NdbxIcon.ProductDiversity]: "61902",
    [NdbxIcon.ProductDollar]: "61903",
    [NdbxIcon.ProductDoor]: "61904",
    [NdbxIcon.ProductElectricPlug]: "61905",
    [NdbxIcon.ProductExcavator]: "61906",
    [NdbxIcon.ProductExpensiveObjectsJewelery]: "61907",
    [NdbxIcon.ProductEyeOverviewSight]: "61908",
    [NdbxIcon.ProductFamily]: "61909",
    [NdbxIcon.ProductFire]: "61910",
    [NdbxIcon.ProductFolder]: "61911",
    [NdbxIcon.ProductForkLiftTruck]: "61912",
    [NdbxIcon.ProductFortune]: "61913",
    [NdbxIcon.ProductGarage]: "61914",
    [NdbxIcon.ProductGuideNavigation]: "61915",
    [NdbxIcon.ProductHandClickInfo]: "61916",
    [NdbxIcon.ProductHandFingerPointing]: "61917",
    [NdbxIcon.ProductHandGetMoney]: "61918",
    [NdbxIcon.ProductHandThumbsUp]: "61919",
    [NdbxIcon.ProductHeadsetSupport]: "61920",
    [NdbxIcon.ProductHealthBagDoctor]: "61921",
    [NdbxIcon.ProductHealthStethoscope]: "61922",
    [NdbxIcon.ProductHealth]: "61923",
    [NdbxIcon.ProductHeartEmployeeEngagement]: "61924",
    [NdbxIcon.ProductHeart]: "61925",
    [NdbxIcon.ProductHelmet]: "61926",
    [NdbxIcon.ProductHelpInformation]: "61927",
    [NdbxIcon.ProductHelpQuestion]: "61928",
    [NdbxIcon.ProductHelp]: "61929",
    [NdbxIcon.ProductHomeOffice]: "61930",
    [NdbxIcon.ProductHourglass]: "61931",
    [NdbxIcon.ProductHouseBrokenWindow]: "61932",
    [NdbxIcon.ProductHouseFire]: "61933",
    [NdbxIcon.ProductHouseImportant]: "61934",
    [NdbxIcon.ProductHouseMoney]: "61935",
    [NdbxIcon.ProductHouseSafe]: "61936",
    [NdbxIcon.ProductHouseWaterDamage]: "61937",
    [NdbxIcon.ProductHouse]: "61938",
    [NdbxIcon.ProductHydroPower]: "61939",
    [NdbxIcon.ProductImportantInfo]: "61940",
    [NdbxIcon.ProductIncomePrecaution]: "61941",
    [NdbxIcon.ProductInfoSheet]: "61942",
    [NdbxIcon.ProductInjuryPlaster]: "61943",
    [NdbxIcon.ProductJobProcesses]: "61944",
    [NdbxIcon.ProductKeys]: "61945",
    [NdbxIcon.ProductLaptop]: "61946",
    [NdbxIcon.ProductLaw]: "61947",
    [NdbxIcon.ProductLightBulbIdea]: "61948",
    [NdbxIcon.ProductLocatePositionF]: "61949",
    [NdbxIcon.ProductLocatePosition]: "61950",
    [NdbxIcon.ProductLock]: "61951",
    [NdbxIcon.ProductMail]: "61952",
    [NdbxIcon.ProductMedia]: "61953",
    [NdbxIcon.ProductMobility]: "61954",
    [NdbxIcon.ProductMoneyBanknote]: "61955",
    [NdbxIcon.ProductMoneyExchange]: "61956",
    [NdbxIcon.ProductMoneySuitcase]: "61957",
    [NdbxIcon.ProductMotorcycle]: "61958",
    [NdbxIcon.ProductMouse]: "61959",
    [NdbxIcon.ProductMusic]: "61960",
    [NdbxIcon.ProductNatureLeaf]: "61961",
    [NdbxIcon.ProductNewspaper]: "61962",
    [NdbxIcon.ProductNotebook]: "61963",
    [NdbxIcon.ProductOfficeChair]: "61964",
    [NdbxIcon.ProductPagesDocuments]: "61965",
    [NdbxIcon.ProductPaperDocument]: "61966",
    [NdbxIcon.ProductPaperLock]: "61967",
    [NdbxIcon.ProductPartnerHandshake]: "61968",
    [NdbxIcon.ProductPen]: "61969",
    [NdbxIcon.ProductPensionRockerChair]: "61970",
    [NdbxIcon.ProductPeopleCollaboration]: "61971",
    [NdbxIcon.ProductPeopleCommunicationExternal]: "61972",
    [NdbxIcon.ProductPeopleCommunicationInternal]: "61973",
    [NdbxIcon.ProductPeopleConnect]: "61974",
    [NdbxIcon.ProductPersonHeartPeopleLove]: "61975",
    [NdbxIcon.ProductPerson]: "61976",
    [NdbxIcon.ProductPetHealthInsurance]: "61977",
    [NdbxIcon.ProductPetOwnerLiability]: "61978",
    [NdbxIcon.ProductPhoneCall]: "61979",
    [NdbxIcon.ProductPlane]: "61980",
    [NdbxIcon.ProductPlusMinus]: "61981",
    [NdbxIcon.ProductPlus]: "61982",
    [NdbxIcon.ProductPodcast]: "61983",
    [NdbxIcon.ProductPowerPylon]: "61984",
    [NdbxIcon.ProductPrecaution]: "61985",
    [NdbxIcon.ProductPresent]: "61986",
    [NdbxIcon.ProductPrivatePension]: "61987",
    [NdbxIcon.ProductPuzzlePieces]: "61988",
    [NdbxIcon.ProductPuzzle]: "61989",
    [NdbxIcon.ProductRadio]: "61990",
    [NdbxIcon.ProductRepair]: "61991",
    [NdbxIcon.ProductRewards]: "61992",
    [NdbxIcon.ProductRocket]: "61993",
    [NdbxIcon.ProductSave]: "61994",
    [NdbxIcon.ProductSearchDocument]: "61995",
    [NdbxIcon.ProductSearch]: "61996",
    [NdbxIcon.ProductShareChart]: "61997",
    [NdbxIcon.ProductShareGraphArrowDown]: "61998",
    [NdbxIcon.ProductShareGraphArrowUp]: "61999",
    [NdbxIcon.ProductSharingConnect]: "62000",
    [NdbxIcon.ProductShieldHand]: "62001",
    [NdbxIcon.ProductShield]: "62002",
    [NdbxIcon.ProductShoppingCart]: "62003",
    [NdbxIcon.ProductSmartphone]: "62004",
    [NdbxIcon.ProductSoccer]: "62005",
    [NdbxIcon.ProductSocialMediaFacebookMessenger]: "62006",
    [NdbxIcon.ProductSocialMediaFacebook]: "62007",
    [NdbxIcon.ProductSocialMediaLinkedin]: "62008",
    [NdbxIcon.ProductSocialMediaTwitter]: "62009",
    [NdbxIcon.ProductSocialMediaWhatsapp]: "62010",
    [NdbxIcon.ProductSolarPowerModules]: "62011",
    [NdbxIcon.ProductSportSailingShip]: "62012",
    [NdbxIcon.ProductSportTrainer]: "62013",
    [NdbxIcon.ProductSportsCar]: "62014",
    [NdbxIcon.ProductSports]: "62015",
    [NdbxIcon.ProductStarEvent]: "62016",
    [NdbxIcon.ProductStarsSkyGalaxy]: "62017",
    [NdbxIcon.ProductSteeringWheel]: "62018",
    [NdbxIcon.ProductStockDataGraph]: "62019",
    [NdbxIcon.ProductStoveCooker]: "62020",
    [NdbxIcon.ProductStrategy]: "62021",
    [NdbxIcon.ProductStudentSchoolGraduation]: "62022",
    [NdbxIcon.ProductSurvey]: "62023",
    [NdbxIcon.ProductSuvCar]: "62024",
    [NdbxIcon.ProductTabletIpadApps]: "62025",
    [NdbxIcon.ProductTarget]: "62026",
    [NdbxIcon.ProductTelematicCarFront]: "62027",
    [NdbxIcon.ProductTelematicCarSide]: "62028",
    [NdbxIcon.ProductThermalPowerPlant]: "62029",
    [NdbxIcon.ProductThermometer]: "62030",
    [NdbxIcon.ProductThief]: "62031",
    [NdbxIcon.ProductThunderstorm]: "62032",
    [NdbxIcon.ProductTiresWheel]: "62033",
    [NdbxIcon.ProductToDoList]: "62034",
    [NdbxIcon.ProductTooth]: "62035",
    [NdbxIcon.ProductTravel]: "62036",
    [NdbxIcon.ProductTruck]: "62037",
    [NdbxIcon.ProductTv]: "62038",
    [NdbxIcon.ProductUmbrellaProtection]: "62039",
    [NdbxIcon.ProductVideoCamera]: "62040",
    [NdbxIcon.ProductVoiceOfTheCustomer]: "62041",
    [NdbxIcon.ProductWallBalance]: "62042",
    [NdbxIcon.ProductWasher]: "62043",
    [NdbxIcon.ProductWaterTap]: "62044",
    [NdbxIcon.ProductWateringCan]: "62045",
    [NdbxIcon.ProductWheelchair]: "62046",
    [NdbxIcon.ProductWindTurbineOffshore]: "62047",
    [NdbxIcon.ProductWindTurbineOnshore]: "62048",
    [NdbxIcon.ProductWorldGlobe]: "62049",
    [NdbxIcon.ProductWorldWideWe]: "62050",
    [NdbxIcon.Refresh]: "62051",
    [NdbxIcon.SaveO]: "62052",
    [NdbxIcon.Search]: "62053",
    [NdbxIcon.SentimentDissatisfied]: "62054",
    [NdbxIcon.SentimentNeutral]: "62055",
    [NdbxIcon.SentimentSatisfied]: "62056",
    [NdbxIcon.SentimentVeryDissatisfied]: "62057",
    [NdbxIcon.SentimentVerySatisfied]: "62058",
    [NdbxIcon.SetTimer]: "62059",
    [NdbxIcon.SettingO]: "62060",
    [NdbxIcon.Setting]: "62061",
    [NdbxIcon.Share]: "62062",
    [NdbxIcon.SidebarLeft]: "62063",
    [NdbxIcon.SidebarRight]: "62064",
    [NdbxIcon.Skyscraper]: "62065",
    [NdbxIcon.SliderGraphO]: "62066",
    [NdbxIcon.SpeakerOffO]: "62067",
    [NdbxIcon.SpeakerOff]: "62068",
    [NdbxIcon.SpeakerOnO]: "62069",
    [NdbxIcon.SpeakerOn]: "62070",
    [NdbxIcon.SpeechBubbleDotsO]: "62071",
    [NdbxIcon.SpeechBubbleDots]: "62072",
    [NdbxIcon.SpeechBubbleO]: "62073",
    [NdbxIcon.SpeechBubble]: "62074",
    [NdbxIcon.StarHalfFull]: "62075",
    [NdbxIcon.StarO]: "62076",
    [NdbxIcon.Star]: "62077",
    [NdbxIcon.Telegram]: "62078",
    [NdbxIcon.TiffText]: "62079",
    [NdbxIcon.Tiff]: "62080",
    [NdbxIcon.Tractor]: "62081",
    [NdbxIcon.TrashO]: "62082",
    [NdbxIcon.Trash]: "62083",
    [NdbxIcon.Trees]: "62084",
    [NdbxIcon.TvWorldGlobe]: "62085",
    [NdbxIcon.TwitterCircle]: "62086",
    [NdbxIcon.Twitter]: "62087",
    [NdbxIcon.TxtText]: "62088",
    [NdbxIcon.Txt]: "62089",
    [NdbxIcon.UserBusinessO]: "62090",
    [NdbxIcon.UserBusiness]: "62091",
    [NdbxIcon.UserO]: "62092",
    [NdbxIcon.User]: "62093",
    [NdbxIcon.UsersO]: "62094",
    [NdbxIcon.Users]: "62095",
    [NdbxIcon.VidText]: "62096",
    [NdbxIcon.Vid]: "62097",
    [NdbxIcon.VoiceOfTheCustomerF]: "62098",
    [NdbxIcon.WhatsappCircle]: "62099",
    [NdbxIcon.Whatsapp]: "62100",
    [NdbxIcon.XingCircle]: "62101",
    [NdbxIcon.Xing]: "62102",
    [NdbxIcon.XlsText]: "62103",
    [NdbxIcon.Xls]: "62104",
    [NdbxIcon.YoutubeCirclePlay]: "62105",
    [NdbxIcon.YoutubeCircle]: "62106",
    [NdbxIcon.Youtube]: "62107",
};

var CustomIcon;
(function (CustomIcon) {
    CustomIcon["AZ"] = "A-Z";
    CustomIcon["Accident"] = "accident";
    CustomIcon["ApartmentBuilding"] = "Apartment-Building";
    CustomIcon["AppLauncher"] = "App-Launcher";
    CustomIcon["Archive"] = "Archive";
    CustomIcon["ArrowDirectionPath"] = "Arrow-Direction-Path";
    CustomIcon["ArrowDown"] = "Arrow-Down";
    CustomIcon["ArrowFirst"] = "Arrow-First";
    CustomIcon["ArrowLast"] = "Arrow-Last";
    CustomIcon["ArrowLeft"] = "Arrow-Left";
    CustomIcon["ArrowRight"] = "Arrow-Right";
    CustomIcon["ArrowUp"] = "Arrow-Up";
    CustomIcon["ArrowLeftCopy_3x"] = "arrow-left-copy-3x";
    CustomIcon["ArrowsSwitch"] = "Arrows-Switch";
    CustomIcon["AtIcon"] = "At-Icon";
    CustomIcon["BalanceScale"] = "Balance-Scale";
    CustomIcon["BankMonumentInfo"] = "Bank-Monument-Info";
    CustomIcon["Bar"] = "Bar";
    CustomIcon["Battery"] = "Battery";
    CustomIcon["Bed"] = "Bed";
    CustomIcon["BellO"] = "Bell-O";
    CustomIcon["BellOffO"] = "Bell-Off-O";
    CustomIcon["BellOff"] = "Bell-Off";
    CustomIcon["Bell"] = "Bell";
    CustomIcon["BereavedDependentPension"] = "Bereaved-Dependent-Pension";
    CustomIcon["Bike"] = "Bike";
    CustomIcon["Blog"] = "Blog";
    CustomIcon["BoardPaperNote"] = "Board-Paper-Note";
    CustomIcon["Boat"] = "boat";
    CustomIcon["BoltO"] = "Bolt-O";
    CustomIcon["Bolt"] = "Bolt";
    CustomIcon["Book"] = "Book";
    CustomIcon["BookmarkO"] = "Bookmark-O";
    CustomIcon["Bookmark"] = "Bookmark";
    CustomIcon["Brain"] = "Brain";
    CustomIcon["BrokenGlass"] = "Broken-Glass";
    CustomIcon["BrokenMirror"] = "Broken-Mirror";
    CustomIcon["BrokenWindow"] = "Broken-Window";
    CustomIcon["BroomClean"] = "Broom-Clean";
    CustomIcon["BubbleO"] = "Bubble-O";
    CustomIcon["Bubble"] = "Bubble";
    CustomIcon["Buggy"] = "Buggy";
    CustomIcon["Bullhorn"] = "Bullhorn";
    CustomIcon["BusinessProperty"] = "business-property";
    CustomIcon["Calculator"] = "Calculator";
    CustomIcon["CalendarDateCheckO"] = "Calendar-Date-Check-O";
    CustomIcon["CalendarDateCheck"] = "Calendar-Date-Check";
    CustomIcon["CalendarDefaultO"] = "Calendar-Default-O";
    CustomIcon["CalendarDefault"] = "Calendar-Default";
    CustomIcon["CalendarReminderO"] = "Calendar-Reminder-O";
    CustomIcon["CalendarReminder"] = "Calendar-Reminder";
    CustomIcon["CalendarTravel"] = "Calendar-Travel";
    CustomIcon["Calendar"] = "Calendar";
    CustomIcon["Callback"] = "Callback";
    CustomIcon["Camera"] = "Camera";
    CustomIcon["Candle"] = "Candle";
    CustomIcon["CarAccidentAbroad"] = "Car-Accident-Abroad";
    CustomIcon["CarAccident"] = "Car-Accident";
    CustomIcon["CarFront"] = "Car-Front";
    CustomIcon["CarSmall"] = "Car-Small";
    CustomIcon["CarStreetRoadMobility"] = "Car-Street-Road-Mobility";
    CustomIcon["CarTachoFast"] = "Car-Tacho-Fast";
    CustomIcon["CarTrailer"] = "Car-Trailer";
    CustomIcon["Car"] = "car";
    CustomIcon["Caravan"] = "Caravan";
    CustomIcon["Cards"] = "Cards";
    CustomIcon["CareInsurance"] = "Care-Insurance";
    CustomIcon["Cat"] = "Cat";
    CustomIcon["CertificatePapers"] = "Certificate-Papers";
    CustomIcon["Certificate"] = "Certificate";
    CustomIcon["ChatO"] = "Chat-O";
    CustomIcon["Chat"] = "Chat";
    CustomIcon["ChatbotDefault"] = "Chatbot-Default";
    CustomIcon["ChatbotJoy"] = "Chatbot-Joy";
    CustomIcon["ChatbotSlightsmile"] = "Chatbot-Slightsmile";
    CustomIcon["ChatbotThink"] = "Chatbot-Think";
    CustomIcon["ChatbotThrilled"] = "Chatbot-Thrilled";
    CustomIcon["Check_2"] = "Check-2";
    CustomIcon["CheckCircleUnchecked"] = "Check-Circle-Unchecked";
    CustomIcon["CheckCircle"] = "Check-Circle";
    CustomIcon["CheckPaper"] = "Check-Paper";
    CustomIcon["Check"] = "Check";
    CustomIcon["ChevronDownSmall"] = "Chevron-Down-Small";
    CustomIcon["ChevronDown"] = "Chevron-Down";
    CustomIcon["ChevronLeftCircleO"] = "Chevron-Left-Circle-O";
    CustomIcon["ChevronLeftCircle"] = "Chevron-Left-Circle";
    CustomIcon["ChevronLeftSmall"] = "Chevron-Left-Small";
    CustomIcon["ChevronLeft"] = "Chevron-Left";
    CustomIcon["ChevronPopout"] = "Chevron-Popout";
    CustomIcon["ChevronRightCircleO"] = "Chevron-Right-Circle-O";
    CustomIcon["ChevronRightCircle"] = "Chevron-Right-Circle";
    CustomIcon["ChevronRightSmall"] = "Chevron-Right-Small";
    CustomIcon["ChevronRight"] = "Chevron-Right";
    CustomIcon["ChevronUpSmall"] = "Chevron-Up-Small";
    CustomIcon["ChevronUp"] = "Chevron-Up";
    CustomIcon["City"] = "City";
    CustomIcon["CleanupTrash"] = "Cleanup-Trash";
    CustomIcon["Clock_2"] = "Clock-2";
    CustomIcon["ClockO"] = "Clock-O";
    CustomIcon["Clock"] = "Clock";
    CustomIcon["CloseCircleO"] = "Close-Circle-O";
    CustomIcon["CloseCircle"] = "Close-Circle";
    CustomIcon["Close"] = "Close";
    CustomIcon["Cloud"] = "Cloud";
    CustomIcon["Cobrowsing"] = "Cobrowsing";
    CustomIcon["CogWheel"] = "Cog-Wheel";
    CustomIcon["CogWheels"] = "Cog-Wheels";
    CustomIcon["CoinsMoney"] = "Coins-Money";
    CustomIcon["Communication"] = "Communication";
    CustomIcon["Compass"] = "Compass";
    CustomIcon["Computer"] = "Computer";
    CustomIcon["Couch"] = "Couch";
    CustomIcon["CreditCard_2"] = "Credit-Card-2";
    CustomIcon["CreditCardO"] = "Credit-Card-O";
    CustomIcon["CreditCard"] = "Credit-Card";
    CustomIcon["CrossTriangle"] = "Cross-Triangle";
    CustomIcon["Cross"] = "Cross";
    CustomIcon["Danger"] = "Danger";
    CustomIcon["DataExchange"] = "Data-Exchange";
    CustomIcon["DiamondJewelery"] = "Diamond-Jewelery";
    CustomIcon["Dissatisfied"] = "Dissatisfied";
    CustomIcon["Diversity"] = "Diversity";
    CustomIcon["DogPetOwnerLiability"] = "Dog-Pet-Owner-Liability";
    CustomIcon["Dog"] = "Dog";
    CustomIcon["Dollar"] = "Dollar";
    CustomIcon["Door"] = "Door";
    CustomIcon["DotsO"] = "Dots-O";
    CustomIcon["Dots"] = "Dots";
    CustomIcon["Download"] = "Download";
    CustomIcon["Duplicate"] = "Duplicate";
    CustomIcon["EMailO"] = "e-mail-o";
    CustomIcon["Edit"] = "Edit";
    CustomIcon["ElectricPlug"] = "Electric-Plug";
    CustomIcon["EllipsisHorizontal"] = "Ellipsis-Horizontal";
    CustomIcon["EllipsisVertical"] = "Ellipsis-Vertical";
    CustomIcon["Excavator"] = "Excavator";
    CustomIcon["Exchange"] = "Exchange";
    CustomIcon["ExclamationCircleO"] = "Exclamation-Circle-O";
    CustomIcon["ExclamationCircle"] = "Exclamation-Circle";
    CustomIcon["ExclamationTriangleO"] = "Exclamation-Triangle-O";
    CustomIcon["ExclamationTriangle"] = "Exclamation-Triangle";
    CustomIcon["ExportAndShare"] = "Export-and-Share";
    CustomIcon["EyeOverviewSight"] = "Eye-Overview-Sight";
    CustomIcon["FacebookCircle"] = "Facebook-Circle";
    CustomIcon["Facebook"] = "Facebook";
    CustomIcon["FactoryBuilding"] = "Factory-Building";
    CustomIcon["Family"] = "Family";
    CustomIcon["Filter"] = "Filter";
    CustomIcon["Fire"] = "Fire";
    CustomIcon["Folder"] = "Folder";
    CustomIcon["ForkLiftTruck"] = "Fork-Lift-Truck";
    CustomIcon["Fortune"] = "Fortune";
    CustomIcon["Garage"] = "Garage";
    CustomIcon["Globe"] = "Globe";
    CustomIcon["GoogleCircle"] = "Google+-Circle";
    CustomIcon["Google"] = "Google+";
    CustomIcon["Grapes"] = "Grapes";
    CustomIcon["Group_6"] = "Group-6";
    CustomIcon["Group_3x"] = "Group-3x";
    CustomIcon["GuideNavigation"] = "Guide-Navigation";
    CustomIcon["HandClickInfo"] = "Hand-Click-Info";
    CustomIcon["HandFingerPointing"] = "Hand-Finger-Pointing";
    CustomIcon["HandGetMoney"] = "Hand-Get-Money";
    CustomIcon["HandThumbsUp"] = "Hand-ThumbsUp";
    CustomIcon["HandTray"] = "Hand-Tray";
    CustomIcon["HeadsetSupport"] = "Headset-Support";
    CustomIcon["HealthBagDoctor"] = "Health-Bag-Doctor";
    CustomIcon["HealthPaw"] = "Health-Paw";
    CustomIcon["HealthStethoscope"] = "Health-Stethoscope";
    CustomIcon["Health"] = "Health";
    CustomIcon["HeartEmployeeEngagement"] = "Heart-Employee-Engagement";
    CustomIcon["Heart"] = "Heart";
    CustomIcon["HelmetConstruction"] = "Helmet-Construction";
    CustomIcon["Helmet"] = "Helmet";
    CustomIcon["HelpAccident"] = "Help-Accident";
    CustomIcon["HelpInformation"] = "Help-Information";
    CustomIcon["HelpO"] = "Help-O";
    CustomIcon["HelpQuestion"] = "Help-Question";
    CustomIcon["Help"] = "Help";
    CustomIcon["HomeOffice"] = "Home-Office";
    CustomIcon["Horse"] = "Horse";
    CustomIcon["Hourglass"] = "Hourglass";
    CustomIcon["HouseBrokenWindow"] = "House-Broken-Window";
    CustomIcon["HouseFire"] = "House-Fire";
    CustomIcon["HouseImportant"] = "House-Important";
    CustomIcon["HouseMoney"] = "House-Money";
    CustomIcon["HouseSafe"] = "House-Safe";
    CustomIcon["HouseWaterDamage"] = "House-Water-Damage";
    CustomIcon["House"] = "House";
    CustomIcon["HuntingDeer"] = "Hunting-Deer";
    CustomIcon["HydroPower"] = "Hydro-Power";
    CustomIcon["ImportantInfo"] = "Important-Info";
    CustomIcon["InProgress"] = "In-Progress";
    CustomIcon["IncomePrecaution"] = "Income-Precaution";
    CustomIcon["InfoCircleO"] = "Info-Circle-O";
    CustomIcon["InfoCircle"] = "Info-Circle";
    CustomIcon["InfoSheet"] = "Info-Sheet";
    CustomIcon["InfoCircleOCopy"] = "info-circle-o-copy";
    CustomIcon["InjuryPlaster"] = "Injury-Plaster";
    CustomIcon["InstagramCircle"] = "Instagram-Circle";
    CustomIcon["Instagram"] = "Instagram";
    CustomIcon["Interpunct"] = "Interpunct";
    CustomIcon["JobProcesses"] = "Job-Processes";
    CustomIcon["Keys"] = "Keys";
    CustomIcon["LaptopCogWheel"] = "Laptop-Cog-Wheel";
    CustomIcon["Laptop"] = "Laptop";
    CustomIcon["Launch"] = "Launch";
    CustomIcon["LawInternet"] = "Law-Internet";
    CustomIcon["LawJob"] = "Law-Job";
    CustomIcon["LawKey"] = "Law-Key";
    CustomIcon["LawLegal"] = "Law-Legal";
    CustomIcon["LawTraffic"] = "Law-Traffic";
    CustomIcon["LegalProtection"] = "Legal-Protection";
    CustomIcon["LifeV2"] = "life-v2";
    CustomIcon["LightBulbIdea"] = "Light-Bulb-Idea";
    CustomIcon["LinkedinCircle"] = "Linkedin-Circle";
    CustomIcon["Linkedin"] = "Linkedin";
    CustomIcon["List"] = "List";
    CustomIcon["LocatePosition"] = "Locate-Position";
    CustomIcon["LocationO"] = "Location-O";
    CustomIcon["Location"] = "Location";
    CustomIcon["Lock_2"] = "Lock-2";
    CustomIcon["LockO"] = "Lock-O";
    CustomIcon["Lock"] = "Lock";
    CustomIcon["Logout"] = "Logout";
    CustomIcon["Mail_2"] = "Mail-2";
    CustomIcon["MailO"] = "Mail-O";
    CustomIcon["MailReadO"] = "Mail-Read-O";
    CustomIcon["MailRead"] = "Mail-Read";
    CustomIcon["Mail"] = "Mail";
    CustomIcon["Malpraxis"] = "malpraxis";
    CustomIcon["Manager"] = "Manager";
    CustomIcon["Media"] = "Media";
    CustomIcon["MessengerCircle"] = "Messenger-Circle";
    CustomIcon["Messenger"] = "Messenger";
    CustomIcon["MicrophoneDefaultO"] = "Microphone-Default-O";
    CustomIcon["MicrophoneDefault"] = "Microphone-Default";
    CustomIcon["MicrophoneMuteO"] = "Microphone-Mute-O";
    CustomIcon["MicrophoneMute"] = "Microphone-Mute";
    CustomIcon["Minimize"] = "Minimize";
    CustomIcon["MinusCircleO"] = "Minus-Circle-O";
    CustomIcon["MinusCircle"] = "Minus-Circle";
    CustomIcon["Minus"] = "Minus";
    CustomIcon["MoneyBanknote"] = "Money-Banknote";
    CustomIcon["MoneyExchange"] = "Money-Exchange";
    CustomIcon["MoneySuitcase"] = "Money-Suitcase";
    CustomIcon["Motorcycle"] = "Motorcycle";
    CustomIcon["MountainRescue"] = "mountain-rescue";
    CustomIcon["Mouse"] = "Mouse";
    CustomIcon["Music"] = "Music";
    CustomIcon["NatureLeaf"] = "Nature-Leaf";
    CustomIcon["Neutral"] = "Neutral";
    CustomIcon["NewFile"] = "New-File";
    CustomIcon["Newspaper"] = "Newspaper";
    CustomIcon["Notebook"] = "Notebook";
    CustomIcon["OfficeChair"] = "Office-Chair";
    CustomIcon["OilTank"] = "Oil-Tank";
    CustomIcon["Other"] = "other";
    CustomIcon["PagesDocuments"] = "Pages-Documents";
    CustomIcon["PaperDocument"] = "Paper-Document";
    CustomIcon["PaperLock"] = "Paper-Lock";
    CustomIcon["Paperclip"] = "Paperclip";
    CustomIcon["PartnerHandshake"] = "Partner-Handshake";
    CustomIcon["PasswordHideO"] = "Password-Hide-O";
    CustomIcon["PasswordHide"] = "Password-Hide";
    CustomIcon["PasswordShowO"] = "Password-Show-O";
    CustomIcon["PasswordShow"] = "Password-Show";
    CustomIcon["Pause"] = "Pause";
    CustomIcon["Paw"] = "Paw";
    CustomIcon["Pen_2"] = "Pen-2";
    CustomIcon["Pen"] = "Pen";
    CustomIcon["PensionRockerChair"] = "Pension-Rocker-Chair";
    CustomIcon["PeopleCollaboration"] = "People-Collaboration";
    CustomIcon["PeopleCommunicationExternal"] = "People-Communication-External";
    CustomIcon["PeopleCommunicationInternal"] = "People-Communication-Internal";
    CustomIcon["PeopleConnect"] = "People-Connect";
    CustomIcon["PersonHeartPeopleLove"] = "Person-Heart-People-Love";
    CustomIcon["Person"] = "Person";
    CustomIcon["PetHealthInsurance"] = "Pet-Health-Insurance";
    CustomIcon["Pet"] = "pet";
    CustomIcon["PhoneCall"] = "Phone-Call";
    CustomIcon["PhoneChatO"] = "Phone-Chat-O";
    CustomIcon["PhoneChat"] = "Phone-Chat";
    CustomIcon["PhoneO"] = "Phone-O";
    CustomIcon["Phone"] = "Phone";
    CustomIcon["Plane"] = "Plane";
    CustomIcon["Play"] = "Play";
    CustomIcon["Plus_2"] = "Plus-2";
    CustomIcon["PlusCircleO"] = "Plus-Circle-O";
    CustomIcon["PlusCircle"] = "Plus-Circle";
    CustomIcon["PlusMinus"] = "Plus-Minus";
    CustomIcon["Plus"] = "Plus";
    CustomIcon["Podcast"] = "Podcast";
    CustomIcon["PowerPylon"] = "Power-Pylon";
    CustomIcon["Precaution"] = "Precaution";
    CustomIcon["Present_2"] = "Present-2";
    CustomIcon["Present"] = "present";
    CustomIcon["PrintO"] = "Print-O";
    CustomIcon["Print"] = "Print";
    CustomIcon["PrivatePension"] = "Private-Pension";
    CustomIcon["PuzzlePieces"] = "Puzzle-Pieces";
    CustomIcon["Puzzle"] = "Puzzle";
    CustomIcon["Radio"] = "Radio";
    CustomIcon["Refresh"] = "Refresh";
    CustomIcon["Repair"] = "Repair";
    CustomIcon["Rewards"] = "Rewards";
    CustomIcon["Rocket"] = "Rocket";
    CustomIcon["Satisfied"] = "Satisfied";
    CustomIcon["Save_2"] = "Save-2";
    CustomIcon["Save"] = "Save";
    CustomIcon["Search_2"] = "Search-2";
    CustomIcon["SearchDocument"] = "Search-Document";
    CustomIcon["Search"] = "Search";
    CustomIcon["Sepa"] = "Sepa";
    CustomIcon["SetTimer"] = "Set-Timer";
    CustomIcon["SettingO"] = "Setting-O";
    CustomIcon["Setting"] = "Setting";
    CustomIcon["ShareChart"] = "Share-Chart";
    CustomIcon["ShareGraphArrowDown"] = "Share-Graph-Arrow-Down";
    CustomIcon["ShareGraphArrowUp"] = "Share-Graph-Arrow-Up";
    CustomIcon["Share"] = "Share";
    CustomIcon["SharingConnect"] = "Sharing-Connect";
    CustomIcon["ShieldHand"] = "Shield-Hand";
    CustomIcon["ShieldHouse"] = "Shield-House";
    CustomIcon["ShieldKey"] = "Shield-Key";
    CustomIcon["ShieldPaw"] = "Shield-Paw";
    CustomIcon["Shield"] = "Shield";
    CustomIcon["ShoppingCart"] = "Shopping-Cart";
    CustomIcon["SidebarLeft"] = "Sidebar-Left";
    CustomIcon["SidebarRight"] = "Sidebar-Right";
    CustomIcon["SliderGraph"] = "Slider-Graph";
    CustomIcon["Smartphone"] = "Smartphone";
    CustomIcon["Soccer"] = "Soccer";
    CustomIcon["SocialMediaFacebookMessenger"] = "Social-Media-Facebook-Messenger";
    CustomIcon["SocialMediaFacebook"] = "Social-Media-Facebook";
    CustomIcon["SocialMediaLinkedin"] = "Social-Media-Linkedin";
    CustomIcon["SocialMediaTwitter"] = "Social-Media-Twitter";
    CustomIcon["SocialMediaWhatsapp"] = "Social-Media-Whatsapp";
    CustomIcon["SolarPowerModules"] = "Solar-Power-Modules";
    CustomIcon["SportSailingShip"] = "Sport-Sailing-Ship";
    CustomIcon["SportTrainer"] = "Sport-Trainer";
    CustomIcon["SportsCar"] = "Sports-Car";
    CustomIcon["Sports"] = "Sports";
    CustomIcon["StarEvent"] = "Star-Event";
    CustomIcon["StarHalfFull"] = "Star-Half-Full";
    CustomIcon["StarO"] = "Star-O";
    CustomIcon["Star"] = "Star";
    CustomIcon["StarsSkyGalaxy"] = "Stars-Sky-Galaxy";
    CustomIcon["SteeringWheel"] = "Steering-Wheel";
    CustomIcon["StockDataGraph"] = "Stock-Data-Graph";
    CustomIcon["StoveCooker"] = "Stove-Cooker";
    CustomIcon["Strategy"] = "Strategy";
    CustomIcon["StudentSchoolGraduation"] = "Student-School-Graduation";
    CustomIcon["Survey"] = "Survey";
    CustomIcon["SuvCar"] = "SUV-Car";
    CustomIcon["Switch"] = "Switch";
    CustomIcon["TabletIpadApps"] = "Tablet-ipad-Apps";
    CustomIcon["Target"] = "Target";
    CustomIcon["Telegram_0"] = "Telegram-0";
    CustomIcon["Telegram"] = "Telegram";
    CustomIcon["TelematicCarFront"] = "Telematic-Car-Front";
    CustomIcon["TelematicCarSide"] = "Telematic-Car-Side";
    CustomIcon["TextFile"] = "Text-File";
    CustomIcon["ThermalPowerPlant"] = "Thermal-Power-Plant";
    CustomIcon["Thermometer"] = "Thermometer";
    CustomIcon["Thief"] = "Thief";
    CustomIcon["Thunderstorm"] = "Thunderstorm";
    CustomIcon["TiresWheel"] = "Tires-Wheel";
    CustomIcon["ToDoList"] = "To-Do-List";
    CustomIcon["Tooth"] = "Tooth";
    CustomIcon["TowTruckMobility"] = "Tow-Truck-Mobility";
    CustomIcon["Tractor"] = "Tractor";
    CustomIcon["TrashO"] = "Trash-O";
    CustomIcon["Trash"] = "Trash";
    CustomIcon["TravelCancellation"] = "travel-cancellation";
    CustomIcon["Travel"] = "travel";
    CustomIcon["Truck"] = "Truck";
    CustomIcon["Tv"] = "TV";
    CustomIcon["TwitterCircle"] = "Twitter-Circle";
    CustomIcon["Twitter"] = "Twitter";
    CustomIcon["UmbrellaProtection"] = "Umbrella-Protection";
    CustomIcon["UnlockO"] = "Unlock-O";
    CustomIcon["Unlock"] = "Unlock";
    CustomIcon["Upload"] = "Upload";
    CustomIcon["UserBusiness"] = "User-Business";
    CustomIcon["UserO"] = "user-o";
    CustomIcon["User"] = "User";
    CustomIcon["VeryDissatisfied"] = "Very-Dissatisfied";
    CustomIcon["VerySatisfied"] = "Very-Satisfied";
    CustomIcon["VideoCamera"] = "Video-Camera";
    CustomIcon["VoiceOfTheCustomer"] = "Voice-Of-The-Customer";
    CustomIcon["WallBalance"] = "Wall-Balance";
    CustomIcon["Washer"] = "Washer";
    CustomIcon["WaterTap"] = "Water-Tap";
    CustomIcon["WateringCan"] = "Watering-Can";
    CustomIcon["WhatsappCircle"] = "Whatsapp-Circle";
    CustomIcon["Whatsapp"] = "Whatsapp";
    CustomIcon["Wheelchair"] = "Wheelchair";
    CustomIcon["WindTurbineOffshore"] = "Wind-Turbine-Offshore";
    CustomIcon["WindTurbineOnshore"] = "Wind-Turbine-Onshore";
    CustomIcon["WorldGlobe"] = "World-Globe";
    CustomIcon["WorldWideWeb"] = "World-Wide-Web";
    CustomIcon["XingCircle"] = "Xing-Circle";
    CustomIcon["Xing"] = "Xing";
    CustomIcon["YoutubeCircle"] = "Youtube-Circle";
    CustomIcon["Youtube"] = "Youtube";
})(CustomIcon || (CustomIcon = {}));
const CUSTOM_ICON_CODEPOINTS = {
    [CustomIcon.AZ]: "61697",
    [CustomIcon.Accident]: "61698",
    [CustomIcon.ApartmentBuilding]: "61699",
    [CustomIcon.AppLauncher]: "61700",
    [CustomIcon.Archive]: "61701",
    [CustomIcon.ArrowDirectionPath]: "61702",
    [CustomIcon.ArrowDown]: "61703",
    [CustomIcon.ArrowFirst]: "61704",
    [CustomIcon.ArrowLast]: "61705",
    [CustomIcon.ArrowLeft]: "61706",
    [CustomIcon.ArrowRight]: "61707",
    [CustomIcon.ArrowUp]: "61708",
    [CustomIcon.ArrowLeftCopy_3x]: "61709",
    [CustomIcon.ArrowsSwitch]: "61710",
    [CustomIcon.AtIcon]: "61711",
    [CustomIcon.BalanceScale]: "61712",
    [CustomIcon.BankMonumentInfo]: "61713",
    [CustomIcon.Bar]: "61714",
    [CustomIcon.Battery]: "61715",
    [CustomIcon.Bed]: "61716",
    [CustomIcon.BellO]: "61717",
    [CustomIcon.BellOffO]: "61718",
    [CustomIcon.BellOff]: "61719",
    [CustomIcon.Bell]: "61720",
    [CustomIcon.BereavedDependentPension]: "61721",
    [CustomIcon.Bike]: "61722",
    [CustomIcon.Blog]: "61723",
    [CustomIcon.BoardPaperNote]: "61724",
    [CustomIcon.Boat]: "61725",
    [CustomIcon.BoltO]: "61726",
    [CustomIcon.Bolt]: "61727",
    [CustomIcon.Book]: "61728",
    [CustomIcon.BookmarkO]: "61729",
    [CustomIcon.Bookmark]: "61730",
    [CustomIcon.Brain]: "61731",
    [CustomIcon.BrokenGlass]: "61732",
    [CustomIcon.BrokenMirror]: "61733",
    [CustomIcon.BrokenWindow]: "61734",
    [CustomIcon.BroomClean]: "61735",
    [CustomIcon.BubbleO]: "61736",
    [CustomIcon.Bubble]: "61737",
    [CustomIcon.Buggy]: "61738",
    [CustomIcon.Bullhorn]: "61739",
    [CustomIcon.BusinessProperty]: "61740",
    [CustomIcon.Calculator]: "61741",
    [CustomIcon.CalendarDateCheckO]: "61742",
    [CustomIcon.CalendarDateCheck]: "61743",
    [CustomIcon.CalendarDefaultO]: "61744",
    [CustomIcon.CalendarDefault]: "61745",
    [CustomIcon.CalendarReminderO]: "61746",
    [CustomIcon.CalendarReminder]: "61747",
    [CustomIcon.CalendarTravel]: "61748",
    [CustomIcon.Calendar]: "61749",
    [CustomIcon.Callback]: "61750",
    [CustomIcon.Camera]: "61751",
    [CustomIcon.Candle]: "61752",
    [CustomIcon.CarAccidentAbroad]: "61753",
    [CustomIcon.CarAccident]: "61754",
    [CustomIcon.CarFront]: "61755",
    [CustomIcon.CarSmall]: "61756",
    [CustomIcon.CarStreetRoadMobility]: "61757",
    [CustomIcon.CarTachoFast]: "61758",
    [CustomIcon.CarTrailer]: "61759",
    [CustomIcon.Car]: "61760",
    [CustomIcon.Caravan]: "61761",
    [CustomIcon.Cards]: "61762",
    [CustomIcon.CareInsurance]: "61763",
    [CustomIcon.Cat]: "61764",
    [CustomIcon.CertificatePapers]: "61765",
    [CustomIcon.Certificate]: "61766",
    [CustomIcon.ChatO]: "61767",
    [CustomIcon.Chat]: "61768",
    [CustomIcon.ChatbotDefault]: "61769",
    [CustomIcon.ChatbotJoy]: "61770",
    [CustomIcon.ChatbotSlightsmile]: "61771",
    [CustomIcon.ChatbotThink]: "61772",
    [CustomIcon.ChatbotThrilled]: "61773",
    [CustomIcon.Check_2]: "61774",
    [CustomIcon.CheckCircleUnchecked]: "61775",
    [CustomIcon.CheckCircle]: "61776",
    [CustomIcon.CheckPaper]: "61777",
    [CustomIcon.Check]: "61778",
    [CustomIcon.ChevronDownSmall]: "61779",
    [CustomIcon.ChevronDown]: "61780",
    [CustomIcon.ChevronLeftCircleO]: "61781",
    [CustomIcon.ChevronLeftCircle]: "61782",
    [CustomIcon.ChevronLeftSmall]: "61783",
    [CustomIcon.ChevronLeft]: "61784",
    [CustomIcon.ChevronPopout]: "61785",
    [CustomIcon.ChevronRightCircleO]: "61786",
    [CustomIcon.ChevronRightCircle]: "61787",
    [CustomIcon.ChevronRightSmall]: "61788",
    [CustomIcon.ChevronRight]: "61789",
    [CustomIcon.ChevronUpSmall]: "61790",
    [CustomIcon.ChevronUp]: "61791",
    [CustomIcon.City]: "61792",
    [CustomIcon.CleanupTrash]: "61793",
    [CustomIcon.Clock_2]: "61794",
    [CustomIcon.ClockO]: "61795",
    [CustomIcon.Clock]: "61796",
    [CustomIcon.CloseCircleO]: "61797",
    [CustomIcon.CloseCircle]: "61798",
    [CustomIcon.Close]: "61799",
    [CustomIcon.Cloud]: "61800",
    [CustomIcon.Cobrowsing]: "61801",
    [CustomIcon.CogWheel]: "61802",
    [CustomIcon.CogWheels]: "61803",
    [CustomIcon.CoinsMoney]: "61804",
    [CustomIcon.Communication]: "61805",
    [CustomIcon.Compass]: "61806",
    [CustomIcon.Computer]: "61807",
    [CustomIcon.Couch]: "61808",
    [CustomIcon.CreditCard_2]: "61809",
    [CustomIcon.CreditCardO]: "61810",
    [CustomIcon.CreditCard]: "61811",
    [CustomIcon.CrossTriangle]: "61812",
    [CustomIcon.Cross]: "61813",
    [CustomIcon.Danger]: "61814",
    [CustomIcon.DataExchange]: "61815",
    [CustomIcon.DiamondJewelery]: "61816",
    [CustomIcon.Dissatisfied]: "61817",
    [CustomIcon.Diversity]: "61818",
    [CustomIcon.DogPetOwnerLiability]: "61819",
    [CustomIcon.Dog]: "61820",
    [CustomIcon.Dollar]: "61821",
    [CustomIcon.Door]: "61822",
    [CustomIcon.DotsO]: "61823",
    [CustomIcon.Dots]: "61824",
    [CustomIcon.Download]: "61825",
    [CustomIcon.Duplicate]: "61826",
    [CustomIcon.EMailO]: "61827",
    [CustomIcon.Edit]: "61828",
    [CustomIcon.ElectricPlug]: "61829",
    [CustomIcon.EllipsisHorizontal]: "61830",
    [CustomIcon.EllipsisVertical]: "61831",
    [CustomIcon.Excavator]: "61832",
    [CustomIcon.Exchange]: "61833",
    [CustomIcon.ExclamationCircleO]: "61834",
    [CustomIcon.ExclamationCircle]: "61835",
    [CustomIcon.ExclamationTriangleO]: "61836",
    [CustomIcon.ExclamationTriangle]: "61837",
    [CustomIcon.ExportAndShare]: "61838",
    [CustomIcon.EyeOverviewSight]: "61839",
    [CustomIcon.FacebookCircle]: "61840",
    [CustomIcon.Facebook]: "61841",
    [CustomIcon.FactoryBuilding]: "61842",
    [CustomIcon.Family]: "61843",
    [CustomIcon.Filter]: "61844",
    [CustomIcon.Fire]: "61845",
    [CustomIcon.Folder]: "61846",
    [CustomIcon.ForkLiftTruck]: "61847",
    [CustomIcon.Fortune]: "61848",
    [CustomIcon.Garage]: "61849",
    [CustomIcon.Globe]: "61850",
    [CustomIcon.GoogleCircle]: "61851",
    [CustomIcon.Google]: "61852",
    [CustomIcon.Grapes]: "61853",
    [CustomIcon.Group_6]: "61854",
    [CustomIcon.Group_3x]: "61855",
    [CustomIcon.GuideNavigation]: "61856",
    [CustomIcon.HandClickInfo]: "61857",
    [CustomIcon.HandFingerPointing]: "61858",
    [CustomIcon.HandGetMoney]: "61859",
    [CustomIcon.HandThumbsUp]: "61860",
    [CustomIcon.HandTray]: "61861",
    [CustomIcon.HeadsetSupport]: "61862",
    [CustomIcon.HealthBagDoctor]: "61863",
    [CustomIcon.HealthPaw]: "61864",
    [CustomIcon.HealthStethoscope]: "61865",
    [CustomIcon.Health]: "61866",
    [CustomIcon.HeartEmployeeEngagement]: "61867",
    [CustomIcon.Heart]: "61868",
    [CustomIcon.HelmetConstruction]: "61869",
    [CustomIcon.Helmet]: "61870",
    [CustomIcon.HelpAccident]: "61871",
    [CustomIcon.HelpInformation]: "61872",
    [CustomIcon.HelpO]: "61873",
    [CustomIcon.HelpQuestion]: "61874",
    [CustomIcon.Help]: "61875",
    [CustomIcon.HomeOffice]: "61876",
    [CustomIcon.Horse]: "61877",
    [CustomIcon.Hourglass]: "61878",
    [CustomIcon.HouseBrokenWindow]: "61879",
    [CustomIcon.HouseFire]: "61880",
    [CustomIcon.HouseImportant]: "61881",
    [CustomIcon.HouseMoney]: "61882",
    [CustomIcon.HouseSafe]: "61883",
    [CustomIcon.HouseWaterDamage]: "61884",
    [CustomIcon.House]: "61885",
    [CustomIcon.HuntingDeer]: "61886",
    [CustomIcon.HydroPower]: "61887",
    [CustomIcon.ImportantInfo]: "61888",
    [CustomIcon.InProgress]: "61889",
    [CustomIcon.IncomePrecaution]: "61890",
    [CustomIcon.InfoCircleO]: "61891",
    [CustomIcon.InfoCircle]: "61892",
    [CustomIcon.InfoSheet]: "61893",
    [CustomIcon.InfoCircleOCopy]: "61894",
    [CustomIcon.InjuryPlaster]: "61895",
    [CustomIcon.InstagramCircle]: "61896",
    [CustomIcon.Instagram]: "61897",
    [CustomIcon.Interpunct]: "61898",
    [CustomIcon.JobProcesses]: "61899",
    [CustomIcon.Keys]: "61900",
    [CustomIcon.LaptopCogWheel]: "61901",
    [CustomIcon.Laptop]: "61902",
    [CustomIcon.Launch]: "61903",
    [CustomIcon.LawInternet]: "61904",
    [CustomIcon.LawJob]: "61905",
    [CustomIcon.LawKey]: "61906",
    [CustomIcon.LawLegal]: "61907",
    [CustomIcon.LawTraffic]: "61908",
    [CustomIcon.LegalProtection]: "61909",
    [CustomIcon.LifeV2]: "61910",
    [CustomIcon.LightBulbIdea]: "61911",
    [CustomIcon.LinkedinCircle]: "61912",
    [CustomIcon.Linkedin]: "61913",
    [CustomIcon.List]: "61914",
    [CustomIcon.LocatePosition]: "61915",
    [CustomIcon.LocationO]: "61916",
    [CustomIcon.Location]: "61917",
    [CustomIcon.Lock_2]: "61918",
    [CustomIcon.LockO]: "61919",
    [CustomIcon.Lock]: "61920",
    [CustomIcon.Logout]: "61921",
    [CustomIcon.Mail_2]: "61922",
    [CustomIcon.MailO]: "61923",
    [CustomIcon.MailReadO]: "61924",
    [CustomIcon.MailRead]: "61925",
    [CustomIcon.Mail]: "61926",
    [CustomIcon.Malpraxis]: "61927",
    [CustomIcon.Manager]: "61928",
    [CustomIcon.Media]: "61929",
    [CustomIcon.MessengerCircle]: "61930",
    [CustomIcon.Messenger]: "61931",
    [CustomIcon.MicrophoneDefaultO]: "61932",
    [CustomIcon.MicrophoneDefault]: "61933",
    [CustomIcon.MicrophoneMuteO]: "61934",
    [CustomIcon.MicrophoneMute]: "61935",
    [CustomIcon.Minimize]: "61936",
    [CustomIcon.MinusCircleO]: "61937",
    [CustomIcon.MinusCircle]: "61938",
    [CustomIcon.Minus]: "61939",
    [CustomIcon.MoneyBanknote]: "61940",
    [CustomIcon.MoneyExchange]: "61941",
    [CustomIcon.MoneySuitcase]: "61942",
    [CustomIcon.Motorcycle]: "61943",
    [CustomIcon.MountainRescue]: "61944",
    [CustomIcon.Mouse]: "61945",
    [CustomIcon.Music]: "61946",
    [CustomIcon.NatureLeaf]: "61947",
    [CustomIcon.Neutral]: "61948",
    [CustomIcon.NewFile]: "61949",
    [CustomIcon.Newspaper]: "61950",
    [CustomIcon.Notebook]: "61951",
    [CustomIcon.OfficeChair]: "61952",
    [CustomIcon.OilTank]: "61953",
    [CustomIcon.Other]: "61954",
    [CustomIcon.PagesDocuments]: "61955",
    [CustomIcon.PaperDocument]: "61956",
    [CustomIcon.PaperLock]: "61957",
    [CustomIcon.Paperclip]: "61958",
    [CustomIcon.PartnerHandshake]: "61959",
    [CustomIcon.PasswordHideO]: "61960",
    [CustomIcon.PasswordHide]: "61961",
    [CustomIcon.PasswordShowO]: "61962",
    [CustomIcon.PasswordShow]: "61963",
    [CustomIcon.Pause]: "61964",
    [CustomIcon.Paw]: "61965",
    [CustomIcon.Pen_2]: "61966",
    [CustomIcon.Pen]: "61967",
    [CustomIcon.PensionRockerChair]: "61968",
    [CustomIcon.PeopleCollaboration]: "61969",
    [CustomIcon.PeopleCommunicationExternal]: "61970",
    [CustomIcon.PeopleCommunicationInternal]: "61971",
    [CustomIcon.PeopleConnect]: "61972",
    [CustomIcon.PersonHeartPeopleLove]: "61973",
    [CustomIcon.Person]: "61974",
    [CustomIcon.PetHealthInsurance]: "61975",
    [CustomIcon.Pet]: "61976",
    [CustomIcon.PhoneCall]: "61977",
    [CustomIcon.PhoneChatO]: "61978",
    [CustomIcon.PhoneChat]: "61979",
    [CustomIcon.PhoneO]: "61980",
    [CustomIcon.Phone]: "61981",
    [CustomIcon.Plane]: "61982",
    [CustomIcon.Play]: "61983",
    [CustomIcon.Plus_2]: "61984",
    [CustomIcon.PlusCircleO]: "61985",
    [CustomIcon.PlusCircle]: "61986",
    [CustomIcon.PlusMinus]: "61987",
    [CustomIcon.Plus]: "61988",
    [CustomIcon.Podcast]: "61989",
    [CustomIcon.PowerPylon]: "61990",
    [CustomIcon.Precaution]: "61991",
    [CustomIcon.Present_2]: "61992",
    [CustomIcon.Present]: "61993",
    [CustomIcon.PrintO]: "61994",
    [CustomIcon.Print]: "61995",
    [CustomIcon.PrivatePension]: "61996",
    [CustomIcon.PuzzlePieces]: "61997",
    [CustomIcon.Puzzle]: "61998",
    [CustomIcon.Radio]: "61999",
    [CustomIcon.Refresh]: "62000",
    [CustomIcon.Repair]: "62001",
    [CustomIcon.Rewards]: "62002",
    [CustomIcon.Rocket]: "62003",
    [CustomIcon.Satisfied]: "62004",
    [CustomIcon.Save_2]: "62005",
    [CustomIcon.Save]: "62006",
    [CustomIcon.Search_2]: "62007",
    [CustomIcon.SearchDocument]: "62008",
    [CustomIcon.Search]: "62009",
    [CustomIcon.Sepa]: "62010",
    [CustomIcon.SetTimer]: "62011",
    [CustomIcon.SettingO]: "62012",
    [CustomIcon.Setting]: "62013",
    [CustomIcon.ShareChart]: "62014",
    [CustomIcon.ShareGraphArrowDown]: "62015",
    [CustomIcon.ShareGraphArrowUp]: "62016",
    [CustomIcon.Share]: "62017",
    [CustomIcon.SharingConnect]: "62018",
    [CustomIcon.ShieldHand]: "62019",
    [CustomIcon.ShieldHouse]: "62020",
    [CustomIcon.ShieldKey]: "62021",
    [CustomIcon.ShieldPaw]: "62022",
    [CustomIcon.Shield]: "62023",
    [CustomIcon.ShoppingCart]: "62024",
    [CustomIcon.SidebarLeft]: "62025",
    [CustomIcon.SidebarRight]: "62026",
    [CustomIcon.SliderGraph]: "62027",
    [CustomIcon.Smartphone]: "62028",
    [CustomIcon.Soccer]: "62029",
    [CustomIcon.SocialMediaFacebookMessenger]: "62030",
    [CustomIcon.SocialMediaFacebook]: "62031",
    [CustomIcon.SocialMediaLinkedin]: "62032",
    [CustomIcon.SocialMediaTwitter]: "62033",
    [CustomIcon.SocialMediaWhatsapp]: "62034",
    [CustomIcon.SolarPowerModules]: "62035",
    [CustomIcon.SportSailingShip]: "62036",
    [CustomIcon.SportTrainer]: "62037",
    [CustomIcon.SportsCar]: "62038",
    [CustomIcon.Sports]: "62039",
    [CustomIcon.StarEvent]: "62040",
    [CustomIcon.StarHalfFull]: "62041",
    [CustomIcon.StarO]: "62042",
    [CustomIcon.Star]: "62043",
    [CustomIcon.StarsSkyGalaxy]: "62044",
    [CustomIcon.SteeringWheel]: "62045",
    [CustomIcon.StockDataGraph]: "62046",
    [CustomIcon.StoveCooker]: "62047",
    [CustomIcon.Strategy]: "62048",
    [CustomIcon.StudentSchoolGraduation]: "62049",
    [CustomIcon.Survey]: "62050",
    [CustomIcon.SuvCar]: "62051",
    [CustomIcon.Switch]: "62052",
    [CustomIcon.TabletIpadApps]: "62053",
    [CustomIcon.Target]: "62054",
    [CustomIcon.Telegram_0]: "62055",
    [CustomIcon.Telegram]: "62056",
    [CustomIcon.TelematicCarFront]: "62057",
    [CustomIcon.TelematicCarSide]: "62058",
    [CustomIcon.TextFile]: "62059",
    [CustomIcon.ThermalPowerPlant]: "62060",
    [CustomIcon.Thermometer]: "62061",
    [CustomIcon.Thief]: "62062",
    [CustomIcon.Thunderstorm]: "62063",
    [CustomIcon.TiresWheel]: "62064",
    [CustomIcon.ToDoList]: "62065",
    [CustomIcon.Tooth]: "62066",
    [CustomIcon.TowTruckMobility]: "62067",
    [CustomIcon.Tractor]: "62068",
    [CustomIcon.TrashO]: "62069",
    [CustomIcon.Trash]: "62070",
    [CustomIcon.TravelCancellation]: "62071",
    [CustomIcon.Travel]: "62072",
    [CustomIcon.Truck]: "62073",
    [CustomIcon.Tv]: "62074",
    [CustomIcon.TwitterCircle]: "62075",
    [CustomIcon.Twitter]: "62076",
    [CustomIcon.UmbrellaProtection]: "62077",
    [CustomIcon.UnlockO]: "62078",
    [CustomIcon.Unlock]: "62079",
    [CustomIcon.Upload]: "62080",
    [CustomIcon.UserBusiness]: "62081",
    [CustomIcon.UserO]: "62082",
    [CustomIcon.User]: "62083",
    [CustomIcon.VeryDissatisfied]: "62084",
    [CustomIcon.VerySatisfied]: "62085",
    [CustomIcon.VideoCamera]: "62086",
    [CustomIcon.VoiceOfTheCustomer]: "62087",
    [CustomIcon.WallBalance]: "62088",
    [CustomIcon.Washer]: "62089",
    [CustomIcon.WaterTap]: "62090",
    [CustomIcon.WateringCan]: "62091",
    [CustomIcon.WhatsappCircle]: "62092",
    [CustomIcon.Whatsapp]: "62093",
    [CustomIcon.Wheelchair]: "62094",
    [CustomIcon.WindTurbineOffshore]: "62095",
    [CustomIcon.WindTurbineOnshore]: "62096",
    [CustomIcon.WorldGlobe]: "62097",
    [CustomIcon.WorldWideWeb]: "62098",
    [CustomIcon.XingCircle]: "62099",
    [CustomIcon.Xing]: "62100",
    [CustomIcon.YoutubeCircle]: "62101",
    [CustomIcon.Youtube]: "62102",
};

const _c0$X = ["ref"];
const DEFAULT_BORDER_STYLE = 'none';
const DEFAULT_BORDER_WIDTH = 0;
class IconComponent {
    constructor() {
        this.iconSet = 'auto';
        this.borderStyle = DEFAULT_BORDER_STYLE;
        this.borderWidth = DEFAULT_BORDER_WIDTH;
        this.selectedIconSet = 'ndbx';
        this.iconClasses = '';
        this.borderWidthStyle = '';
    }
    get getIconSet() {
        if (this.iconSet && this.iconSet !== 'auto') {
            this.selectedIconSet = this.iconSet;
            return `cpc-${this.iconSet}-icon`;
        }
        const isInNdbxIconSet = Object.values(NdbxIcon).includes(this.icon);
        const isInCustomIconSet = Object.values(CustomIcon).includes(this.icon);
        if (isInCustomIconSet) {
            this.selectedIconSet = 'custom';
            return 'cpc-custom-icon';
        }
        else if (isInNdbxIconSet) {
            this.selectedIconSet = 'ndbx';
            return 'cpc-ndbx-icon';
        }
        else {
            console.error('Unknown icon set');
            return '';
        }
    }
    ngOnInit() {
        this.getBorderClass();
    }
    ngOnChanges() {
        this.getBorderClass();
        if (!isNaN(this.borderWidth)) {
            this.borderWidthStyle = this.borderWidth ? `${this.borderWidth}px` : '0';
        }
    }
    getBorderClass() {
        const response = [];
        const borderStyleSet = this.borderStyle && this.borderStyle !== 'none';
        if (borderStyleSet) {
            response.push(`cpc-icon--border cpc-icon--border-${this.borderStyle}`);
        }
        this.iconClasses = response.join(' ');
    }
}
IconComponent.ɵfac = function IconComponent_Factory(t) { return new (t || IconComponent)(); };
IconComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: IconComponent, selectors: [["cpc-icon"]], viewQuery: function IconComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$X, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.ref = _t.first);
    } }, inputs: { icon: "icon", iconSet: "iconSet", borderStyle: "borderStyle", borderWidth: "borderWidth", color: "color", backgroundColor: "backgroundColor" }, features: [i0.ɵɵNgOnChangesFeature], decls: 2, vars: 13, consts: [["ref", ""]], template: function IconComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "i", null, 0);
    } if (rf & 2) {
        i0.ɵɵclassMapInterpolate3("cpc-icon ", ctx.getIconSet, " icon-", ctx.icon, " ", ctx.iconClasses, "");
        i0.ɵɵstyleProp("border-width", ctx.borderWidthStyle)("border-color", ctx.color)("color", ctx.color)("background-color", ctx.backgroundColor);
    } }, styles: ["cpc-icon{display:inline-flex;min-width:var(--icon-size);min-height:var(--icon-size)}.cpc-icon{display:inline-flex;padding:var(--icon-padding);font-size:var(--icon-size)}.cpc-icon.cpc-icon--border{border-color:var(--cpc-colors-resolution-blue);border-style:solid;border-width:var(--icon-size)}.cpc-icon.cpc-icon--border-circle{border-radius:1000px}.cpc-icon.cpc-icon--border-rounded{border-radius:var(--button-border-radius)}.cpc-icon.cpc-icon--border-square{border-radius:0}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IconComponent, [{
        type: Component,
        args: [{ selector: 'cpc-icon', encapsulation: ViewEncapsulation.None, template: "<i\r\n  #ref\r\n  class='cpc-icon {{this.getIconSet}} icon-{{icon}} {{iconClasses}}'\r\n  [style.borderWidth]='borderWidthStyle'\r\n  [style.borderColor]='color'\r\n  [style.color]='color'\r\n  [style.backgroundColor]='backgroundColor'\r\n></i>\r\n", styles: ["cpc-icon{display:inline-flex;min-width:var(--icon-size);min-height:var(--icon-size)}.cpc-icon{display:inline-flex;padding:var(--icon-padding);font-size:var(--icon-size)}.cpc-icon.cpc-icon--border{border-color:var(--cpc-colors-resolution-blue);border-style:solid;border-width:var(--icon-size)}.cpc-icon.cpc-icon--border-circle{border-radius:1000px}.cpc-icon.cpc-icon--border-rounded{border-radius:var(--button-border-radius)}.cpc-icon.cpc-icon--border-square{border-radius:0}\n"] }]
    }], null, { icon: [{
            type: Input
        }], iconSet: [{
            type: Input
        }], borderStyle: [{
            type: Input
        }], borderWidth: [{
            type: Input
        }], color: [{
            type: Input
        }], backgroundColor: [{
            type: Input
        }], ref: [{
            type: ViewChild,
            args: ['ref']
        }] }); })();

function AgentComponent_h2_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.title);
} }
function AgentComponent_img_3_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "img", 9);
    i0.ɵɵlistener("error", function AgentComponent_img_3_Template_img_error_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.photo = ""); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("src", ctx_r1.photo, i0.ɵɵsanitizeUrl);
} }
function AgentComponent_cpc_icon_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "cpc-icon", 10);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("icon", ctx_r2.ndbxIcons.UserO);
} }
const _c0$W = [[["", "name", ""]], "*"];
const _c1$y = ["[name]", "*"];
class AgentComponent {
    constructor() {
        this.ndbxIcons = NdbxIcon;
    }
}
AgentComponent.ɵfac = function AgentComponent_Factory(t) { return new (t || AgentComponent)(); };
AgentComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentComponent, selectors: [["cpc-agent"]], inputs: { photo: "photo", title: "title" }, ngContentSelectors: _c1$y, decls: 10, vars: 3, consts: [["class", "cpc-agent_title", 4, "ngIf"], [1, "cpc-agent"], [1, "cpc-agent-profile_photo"], ["class", "cpc-agent-profile_photo_image", "alt", "Photo of agent", 3, "src", "error", 4, "ngIf"], ["class", "cpc-agent-profile_icon", 3, "icon", 4, "ngIf"], [1, "cpc-agent-profile_info-name"], [1, "cpc-agent-profile_info"], [1, "cpc-agent-profile_info-wrapper"], [1, "cpc-agent_title"], ["alt", "Photo of agent", 1, "cpc-agent-profile_photo_image", 3, "src", "error"], [1, "cpc-agent-profile_icon", 3, "icon"]], template: function AgentComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef(_c0$W);
        i0.ɵɵtemplate(0, AgentComponent_h2_0_Template, 2, 1, "h2", 0);
        i0.ɵɵelementStart(1, "div", 1)(2, "div", 2);
        i0.ɵɵtemplate(3, AgentComponent_img_3_Template, 1, 1, "img", 3);
        i0.ɵɵtemplate(4, AgentComponent_cpc_icon_4_Template, 1, 1, "cpc-icon", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 5);
        i0.ɵɵprojection(6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 6)(8, "div", 7);
        i0.ɵɵprojection(9, 1);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.title);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.photo && ctx.photo !== "");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.photo || ctx.photo === "");
    } }, dependencies: [i1.NgIf, IconComponent], styles: ["cpc-agent{display:block}cpc-agent:not(:first-of-type){margin-top:40px}.cpc-agent_title{padding-bottom:10px;font-weight:400;font-size:24px;line-height:32px;letter-spacing:.2px;border-bottom:1px solid var(--cpc-colors-light-gray)}@media screen and (min-width: 992px){.cpc-agent_title{margin-left:16px}}@media screen and (min-width: 1760px){.cpc-agent_title{font-size:32px}}.cpc-agent{display:grid;grid-template-areas:\"photo name\" \"photo name\" \"info info\";align-items:center}@media screen and (min-width: 992px){.cpc-agent{grid-template-areas:\"photo name\" \"photo info\";grid-template-columns:1fr 8fr;margin-left:16px}}.cpc-agent-profile_photo{position:relative;display:block;grid-area:photo;width:96px;min-width:96px;height:96px;margin-bottom:16px;overflow:hidden;background:var(--cpc-colors-light-blue-2);border-radius:var(--cpc-agent-profile-photo-size)}.cpc-agent-profile_photo>.cpc-agent-profile_photo_image{position:absolute;top:50%;left:50%;display:block;width:100%;height:100%;transform:translate(-50%,-50%)}.cpc-agent-profile_photo .cpc-agent-profile_icon{display:flex;justify-content:center;width:100%;height:100%}.cpc-agent-profile_photo .cpc-agent-profile_icon .cpc-icon{align-self:center;color:var(--cpc-colors-light-blue);--icon-size: 64px}@media screen and (min-width: 992px){.cpc-agent-profile_photo{width:var(--cpc-agent-profile-photo-size);min-width:var(--cpc-agent-profile-photo-size);height:var(--cpc-agent-profile-photo-size);margin-right:40px}}.cpc-agent-profile_info-name{grid-area:name;width:100%;margin-bottom:21px;color:var(--cpc-colors-text);font-weight:600;font-size:26px;line-height:32px;letter-spacing:.3px;text-align:end}@media screen and (min-width: 992px){.cpc-agent-profile_info-name{display:flex;align-self:end;text-align:unset}}.cpc-agent-profile_info{display:grid;grid-area:info;width:100%}@media screen and (min-width: 992px){.cpc-agent-profile_info{align-self:start}}.cpc-agent-profile_info .cpc-agent-profile_info-wrapper{display:flex;flex-direction:column}@media screen and (min-width: 992px){.cpc-agent-profile_info .cpc-agent-profile_info-wrapper{flex-direction:row}}.cpc-agent-profile_info .cpc-agent-profile_info-phone{margin-right:48px}.cpc-agent-profile_info .cpc-agent-profile_info-phone a{color:#000;font-weight:700;text-decoration:none}.cpc-agent-profile_info .cpc-agent-profile_info-email{margin-right:48px}.cpc-agent-profile_info .cpc-agent-profile_info-email a{color:var(--cpc-colors-resolution-blue);font-weight:700;text-decoration:none}.cpc-agent-profile_info .cpc-agent-profile_info-website{margin-right:48px}.cpc-agent-profile_info .cpc-agent-profile_info-website a{color:var(--cpc-colors-resolution-blue);font-weight:700;text-decoration:none}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AgentComponent, [{
        type: Component,
        args: [{ selector: 'cpc-agent', encapsulation: ViewEncapsulation.None, template: "<h2 *ngIf=\"title\" class=\"cpc-agent_title\">{{title}}</h2>\r\n<div class=\"cpc-agent\">\r\n  <div class='cpc-agent-profile_photo'>\r\n    <img\r\n      *ngIf=\"photo && photo !== ''\"\r\n      [src]='photo'\r\n      (error)=\"photo = ''\"\r\n      class='cpc-agent-profile_photo_image'\r\n      alt='Photo of agent'\r\n    />\r\n    <cpc-icon *ngIf=\"!photo || photo === ''\" [icon]=\"ndbxIcons.UserO\" class=\"cpc-agent-profile_icon\"></cpc-icon>\r\n  </div>\r\n  <div class=\"cpc-agent-profile_info-name\">\r\n    <ng-content select=\"[name]\"></ng-content>\r\n  </div>\r\n  <div class=\"cpc-agent-profile_info\">\r\n    <div class=\"cpc-agent-profile_info-wrapper\">\r\n      <ng-content></ng-content>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: ["cpc-agent{display:block}cpc-agent:not(:first-of-type){margin-top:40px}.cpc-agent_title{padding-bottom:10px;font-weight:400;font-size:24px;line-height:32px;letter-spacing:.2px;border-bottom:1px solid var(--cpc-colors-light-gray)}@media screen and (min-width: 992px){.cpc-agent_title{margin-left:16px}}@media screen and (min-width: 1760px){.cpc-agent_title{font-size:32px}}.cpc-agent{display:grid;grid-template-areas:\"photo name\" \"photo name\" \"info info\";align-items:center}@media screen and (min-width: 992px){.cpc-agent{grid-template-areas:\"photo name\" \"photo info\";grid-template-columns:1fr 8fr;margin-left:16px}}.cpc-agent-profile_photo{position:relative;display:block;grid-area:photo;width:96px;min-width:96px;height:96px;margin-bottom:16px;overflow:hidden;background:var(--cpc-colors-light-blue-2);border-radius:var(--cpc-agent-profile-photo-size)}.cpc-agent-profile_photo>.cpc-agent-profile_photo_image{position:absolute;top:50%;left:50%;display:block;width:100%;height:100%;transform:translate(-50%,-50%)}.cpc-agent-profile_photo .cpc-agent-profile_icon{display:flex;justify-content:center;width:100%;height:100%}.cpc-agent-profile_photo .cpc-agent-profile_icon .cpc-icon{align-self:center;color:var(--cpc-colors-light-blue);--icon-size: 64px}@media screen and (min-width: 992px){.cpc-agent-profile_photo{width:var(--cpc-agent-profile-photo-size);min-width:var(--cpc-agent-profile-photo-size);height:var(--cpc-agent-profile-photo-size);margin-right:40px}}.cpc-agent-profile_info-name{grid-area:name;width:100%;margin-bottom:21px;color:var(--cpc-colors-text);font-weight:600;font-size:26px;line-height:32px;letter-spacing:.3px;text-align:end}@media screen and (min-width: 992px){.cpc-agent-profile_info-name{display:flex;align-self:end;text-align:unset}}.cpc-agent-profile_info{display:grid;grid-area:info;width:100%}@media screen and (min-width: 992px){.cpc-agent-profile_info{align-self:start}}.cpc-agent-profile_info .cpc-agent-profile_info-wrapper{display:flex;flex-direction:column}@media screen and (min-width: 992px){.cpc-agent-profile_info .cpc-agent-profile_info-wrapper{flex-direction:row}}.cpc-agent-profile_info .cpc-agent-profile_info-phone{margin-right:48px}.cpc-agent-profile_info .cpc-agent-profile_info-phone a{color:#000;font-weight:700;text-decoration:none}.cpc-agent-profile_info .cpc-agent-profile_info-email{margin-right:48px}.cpc-agent-profile_info .cpc-agent-profile_info-email a{color:var(--cpc-colors-resolution-blue);font-weight:700;text-decoration:none}.cpc-agent-profile_info .cpc-agent-profile_info-website{margin-right:48px}.cpc-agent-profile_info .cpc-agent-profile_info-website a{color:var(--cpc-colors-resolution-blue);font-weight:700;text-decoration:none}\n"] }]
    }], null, { photo: [{
            type: Input
        }], title: [{
            type: Input
        }] }); })();

const _c0$V = [[["", "title", ""]], "*"];
const _c1$x = ["[title]", "*"];
class AgentEntryComponent {
}
AgentEntryComponent.ɵfac = function AgentEntryComponent_Factory(t) { return new (t || AgentEntryComponent)(); };
AgentEntryComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentEntryComponent, selectors: [["cpc-agent-entry"]], inputs: { color: "color" }, ngContentSelectors: _c1$x, decls: 5, vars: 0, consts: [[1, "cpc-agent-entry"], [1, "cpc-agent-entry_title"], [1, "cpc-agent-entry_info"]], template: function AgentEntryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef(_c0$V);
        i0.ɵɵelementStart(0, "div", 0)(1, "span", 1);
        i0.ɵɵprojection(2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "span", 2);
        i0.ɵɵprojection(4, 1);
        i0.ɵɵelementEnd()();
    } }, styles: [".cpc-agent-entry{display:flex;align-items:flex-start;justify-content:space-between}@media screen and (min-width: 992px){.cpc-agent-entry{justify-content:center}}.cpc-agent-entry_title{margin-right:16px;color:var(--cpc-colors-charcoal);line-height:24px}.cpc-agent-entry_info *{color:var(--cpc-colors-resolution-blue);font-weight:700;line-height:24px;text-align:end;text-decoration:none;word-break:break-word}@media screen and (min-width: 992px){.cpc-agent-entry_info *{margin-right:12px;text-align:left}}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AgentEntryComponent, [{
        type: Component,
        args: [{ selector: 'cpc-agent-entry', encapsulation: ViewEncapsulation.None, template: "<div class=\"cpc-agent-entry\">\r\n  <span class=\"cpc-agent-entry_title\"><ng-content select=\"[title]\"></ng-content></span>\r\n  <span class=\"cpc-agent-entry_info\"><ng-content></ng-content></span>\r\n</div>\r\n\r\n", styles: [".cpc-agent-entry{display:flex;align-items:flex-start;justify-content:space-between}@media screen and (min-width: 992px){.cpc-agent-entry{justify-content:center}}.cpc-agent-entry_title{margin-right:16px;color:var(--cpc-colors-charcoal);line-height:24px}.cpc-agent-entry_info *{color:var(--cpc-colors-resolution-blue);font-weight:700;line-height:24px;text-align:end;text-decoration:none;word-break:break-word}@media screen and (min-width: 992px){.cpc-agent-entry_info *{margin-right:12px;text-align:left}}\n"] }]
    }], null, { color: [{
            type: Input
        }] }); })();

const _c0$U = ["*"];
class AgentsComponent {
}
AgentsComponent.ɵfac = function AgentsComponent_Factory(t) { return new (t || AgentsComponent)(); };
AgentsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentsComponent, selectors: [["cpc-agents"]], ngContentSelectors: _c0$U, decls: 2, vars: 0, consts: [[1, "cpc-agents"]], template: function AgentsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵprojection(1);
        i0.ɵɵelementEnd();
    } }, styles: ["cpc-agents{width:100%}.cpc-agents{margin:32px 0}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AgentsComponent, [{
        type: Component,
        args: [{ selector: 'cpc-agents', encapsulation: ViewEncapsulation.None, template: "<div class=\"cpc-agents\">\r\n  <ng-content></ng-content>\r\n</div>\r\n", styles: ["cpc-agents{width:100%}.cpc-agents{margin:32px 0}\n"] }]
    }], null, null); })();

class AllianzLogoComponent {
    constructor() {
        this.fillColor = '#004a93';
    }
}
AllianzLogoComponent.ɵfac = function AllianzLogoComponent_Factory(t) { return new (t || AllianzLogoComponent)(); };
AllianzLogoComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AllianzLogoComponent, selectors: [["cpc-allianz-logo"]], inputs: { fillColor: "fillColor", width: "width", height: "height" }, decls: 18, vars: 3, consts: [["viewBox", "0 0 592 154", "version", "1.1", "xmlns", "http://www.w3.org/2000/svg", 0, "xmlns", "xlink", "http://www.w3.org/1999/xlink", 0, "xml", "space", "preserve", 2, "display", "block"], ["id", "g39870", 1, "allianz-logo"], ["d", "M53.569,82.664l-21.699,0l11.528,-37.499l10.171,37.499Zm-31.87,37.905l6.781,-22.852l27.802,0l6.781,22.852l23.055,0l-24.412,-86.728c-1.356,-5.696 -4.068,-7.527 -10.171,-7.527l-33.905,0l0,7.798l2.713,0c4.068,0 6.103,1.289 6.103,4.408c0,1.966 0,3.255 -2.035,7.934l-24.411,74.115"], ["d", "M115.276,120.569l0,-87.338c0,-4.543 -2.713,-6.917 -7.459,-6.917l-21.021,0l0,7.798l1.356,0c4.069,0 6.103,1.696 6.103,5.357l0,81.1", 2, "fill-rule", "nonzero"], ["d", "M153.249,120.569l0,-87.338c0,-4.543 -2.712,-6.917 -7.459,-6.917l-21.021,0l0,7.798l1.356,0c4.069,0 6.103,1.696 6.103,5.357l0,81.1", 2, "fill-rule", "nonzero"], ["d", "M191.9,34.655c0,-6.239 -4.746,-9.9 -12.205,-9.9c-8.138,0 -12.206,3.661 -12.206,9.9c0,6.374 4.068,10.103 12.206,10.103c7.459,0 12.205,-3.729 12.205,-10.103m-0.678,85.914l0,-63.605c0,-4.408 -2.712,-6.984 -6.781,-6.984l-21.021,0l0,7.662l1.356,0c4.069,0 5.425,1.695 5.425,5.561l0,57.366"], ["d", "M241.401,86.325l0,14.105c-4.069,4.068 -8.815,6.374 -12.884,6.374c-4.068,0 -6.103,-1.967 -6.103,-7.256c0,-5.831 1.357,-8.069 6.103,-9.9c3.391,-1.424 6.781,-2.305 12.884,-3.323m-29.836,-16.884l2.034,-0.814c5.425,-2.17 8.815,-2.983 12.884,-3.729c2.034,-0.271 4.747,-0.543 6.103,-0.543c6.781,0 8.815,2.238 8.815,8.476l0,1.763c-9.493,1.56 -12.206,2.103 -17.63,3.255c-2.713,0.678 -5.425,1.56 -8.138,2.713c-8.815,3.526 -12.883,10.307 -12.883,20.953c0,13.358 5.424,19.732 17.63,19.732c4.747,0 9.493,-1.085 12.884,-3.255c3.39,-1.559 4.746,-2.373 8.815,-6.102l0,2.169c0,4.408 2.034,6.51 6.103,6.51l20.343,0l0,-7.255l-0.678,0c-4.069,0 -6.103,-1.831 -6.103,-5.493l0,-34.651c0,-18.037 -6.103,-24.14 -23.734,-24.14c-6.102,0 -11.527,0.678 -16.952,1.967c-5.425,1.288 -8.137,2.238 -14.24,5.425"], ["d", "M300.395,120.569l0,-47.873c4.747,-4.408 8.137,-6.103 12.884,-6.103c4.746,0 6.103,2.034 6.103,9.222l0,44.754l21.02,0l0,-48.144c0,-9.901 -1.356,-14.173 -4.068,-17.902c-3.391,-3.662 -7.459,-5.357 -13.562,-5.357c-8.137,0 -14.24,2.984 -23.733,11.189l0,-3.798c0,-4.407 -2.034,-6.577 -6.103,-6.577l-20.343,0l0,7.662l0.678,0c4.069,0 6.103,1.695 6.103,5.561l0,57.366"], ["id", "g37643"], ["id", "_clip1"], ["x", "0.003", "y", "0", "width", "591.975", "height", "153.249"], ["clip-path", "url(#_clip1)"], ["id", "path37645", "d", "M405.503,107.071l-31.192,0l29.836,-42.584l0,-14.512l-44.754,0c-5.425,0 -7.459,2.17 -7.459,7.392l0,12.816l7.459,0l0,-1.424c0,-3.866 2.034,-5.425 6.102,-5.425l16.275,0l-30.515,42.584l0,14.647l54.248,0", 2, "fill-rule", "nonzero"], ["id", "path37647", "d", "M525.525,116.7l0,-79.88c0,-6.441 -2.712,-8.544 -8.815,-8.544l-18.308,0l0,8.816l2.034,0c3.39,0 4.746,1.288 4.746,5.221l0,74.387l20.343,0Zm10.85,0l19.664,0l0,-60.283c0,-6.103 -2.712,-8.544 -8.815,-8.544l-10.849,0l0,68.827Zm-42.042,0l0,-68.827l-10.85,0c-6.102,0 -8.815,2.441 -8.815,8.544l0,60.283l19.665,0Zm84.762,-40.143c0,37.363 -27.124,64.622 -63.741,64.622c-36.617,0 -63.741,-27.259 -63.741,-64.622c0,-37.363 27.124,-64.623 63.741,-64.623c36.617,0 63.741,27.26 63.741,64.623m12.883,0c0,-43.737 -32.548,-76.557 -76.624,-76.557c-43.398,0 -76.625,32.82 -76.625,76.557c0,43.872 33.227,76.692 76.625,76.692c44.076,0 76.624,-32.82 76.624,-76.692"]], template: function AllianzLogoComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(0, "svg", 0)(1, "title");
        i0.ɵɵtext(2, "Allianz Logo");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "style");
        i0.ɵɵtext(4, " @media screen and (-ms-high-contrast: active) { .allianz-logo { fill: buttonText; } } ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "g", 1);
        i0.ɵɵelement(6, "path", 2)(7, "path", 3)(8, "path", 4)(9, "path", 5)(10, "path", 6)(11, "path", 7);
        i0.ɵɵelementStart(12, "g", 8)(13, "clipPath", 9);
        i0.ɵɵelement(14, "rect", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(15, "g", 11);
        i0.ɵɵelement(16, "path", 12)(17, "path", 13);
        i0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        i0.ɵɵattribute("width", ctx.width)("fill", ctx.fillColor)("height", ctx.height);
    } }, encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AllianzLogoComponent, [{
        type: Component,
        args: [{ selector: 'cpc-allianz-logo', template: "<svg style=\"display: block;\" [attr.width]=\"width\" [attr.fill]=\"fillColor\" [attr.height]=\"height\" viewBox=\"0 0 592 154\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xml:space=\"preserve\">\r\n  <title>Allianz Logo</title>\r\n  <style>\r\n    @media screen and (-ms-high-contrast: active) {\r\n      .allianz-logo {\r\n        fill: buttonText;\r\n      }\r\n    }\r\n  </style>\r\n  <g id=\"g39870\" class=\"allianz-logo\">\r\n    <path d=\"M53.569,82.664l-21.699,0l11.528,-37.499l10.171,37.499Zm-31.87,37.905l6.781,-22.852l27.802,0l6.781,22.852l23.055,0l-24.412,-86.728c-1.356,-5.696 -4.068,-7.527 -10.171,-7.527l-33.905,0l0,7.798l2.713,0c4.068,0 6.103,1.289 6.103,4.408c0,1.966 0,3.255 -2.035,7.934l-24.411,74.115\"/>\r\n    <path d=\"M115.276,120.569l0,-87.338c0,-4.543 -2.713,-6.917 -7.459,-6.917l-21.021,0l0,7.798l1.356,0c4.069,0 6.103,1.696 6.103,5.357l0,81.1\" style=\"fill-rule:nonzero;\"/>\r\n    <path d=\"M153.249,120.569l0,-87.338c0,-4.543 -2.712,-6.917 -7.459,-6.917l-21.021,0l0,7.798l1.356,0c4.069,0 6.103,1.696 6.103,5.357l0,81.1\" style=\"fill-rule:nonzero;\"/>\r\n    <path d=\"M191.9,34.655c0,-6.239 -4.746,-9.9 -12.205,-9.9c-8.138,0 -12.206,3.661 -12.206,9.9c0,6.374 4.068,10.103 12.206,10.103c7.459,0 12.205,-3.729 12.205,-10.103m-0.678,85.914l0,-63.605c0,-4.408 -2.712,-6.984 -6.781,-6.984l-21.021,0l0,7.662l1.356,0c4.069,0 5.425,1.695 5.425,5.561l0,57.366\"/>\r\n    <path d=\"M241.401,86.325l0,14.105c-4.069,4.068 -8.815,6.374 -12.884,6.374c-4.068,0 -6.103,-1.967 -6.103,-7.256c0,-5.831 1.357,-8.069 6.103,-9.9c3.391,-1.424 6.781,-2.305 12.884,-3.323m-29.836,-16.884l2.034,-0.814c5.425,-2.17 8.815,-2.983 12.884,-3.729c2.034,-0.271 4.747,-0.543 6.103,-0.543c6.781,0 8.815,2.238 8.815,8.476l0,1.763c-9.493,1.56 -12.206,2.103 -17.63,3.255c-2.713,0.678 -5.425,1.56 -8.138,2.713c-8.815,3.526 -12.883,10.307 -12.883,20.953c0,13.358 5.424,19.732 17.63,19.732c4.747,0 9.493,-1.085 12.884,-3.255c3.39,-1.559 4.746,-2.373 8.815,-6.102l0,2.169c0,4.408 2.034,6.51 6.103,6.51l20.343,0l0,-7.255l-0.678,0c-4.069,0 -6.103,-1.831 -6.103,-5.493l0,-34.651c0,-18.037 -6.103,-24.14 -23.734,-24.14c-6.102,0 -11.527,0.678 -16.952,1.967c-5.425,1.288 -8.137,2.238 -14.24,5.425\"/>\r\n    <path d=\"M300.395,120.569l0,-47.873c4.747,-4.408 8.137,-6.103 12.884,-6.103c4.746,0 6.103,2.034 6.103,9.222l0,44.754l21.02,0l0,-48.144c0,-9.901 -1.356,-14.173 -4.068,-17.902c-3.391,-3.662 -7.459,-5.357 -13.562,-5.357c-8.137,0 -14.24,2.984 -23.733,11.189l0,-3.798c0,-4.407 -2.034,-6.577 -6.103,-6.577l-20.343,0l0,7.662l0.678,0c4.069,0 6.103,1.695 6.103,5.561l0,57.366\"/>\r\n    <g id=\"g37643\">\r\n      <clipPath id=\"_clip1\">\r\n        <rect x=\"0.003\" y=\"0\" width=\"591.975\" height=\"153.249\"/>\r\n      </clipPath>\r\n      <g clip-path=\"url(#_clip1)\">\r\n        <path id=\"path37645\" d=\"M405.503,107.071l-31.192,0l29.836,-42.584l0,-14.512l-44.754,0c-5.425,0 -7.459,2.17 -7.459,7.392l0,12.816l7.459,0l0,-1.424c0,-3.866 2.034,-5.425 6.102,-5.425l16.275,0l-30.515,42.584l0,14.647l54.248,0\" style=\"fill-rule:nonzero;\"/>\r\n        <path id=\"path37647\" d=\"M525.525,116.7l0,-79.88c0,-6.441 -2.712,-8.544 -8.815,-8.544l-18.308,0l0,8.816l2.034,0c3.39,0 4.746,1.288 4.746,5.221l0,74.387l20.343,0Zm10.85,0l19.664,0l0,-60.283c0,-6.103 -2.712,-8.544 -8.815,-8.544l-10.849,0l0,68.827Zm-42.042,0l0,-68.827l-10.85,0c-6.102,0 -8.815,2.441 -8.815,8.544l0,60.283l19.665,0Zm84.762,-40.143c0,37.363 -27.124,64.622 -63.741,64.622c-36.617,0 -63.741,-27.259 -63.741,-64.622c0,-37.363 27.124,-64.623 63.741,-64.623c36.617,0 63.741,27.26 63.741,64.623m12.883,0c0,-43.737 -32.548,-76.557 -76.624,-76.557c-43.398,0 -76.625,32.82 -76.625,76.557c0,43.872 33.227,76.692 76.625,76.692c44.076,0 76.624,-32.82 76.624,-76.692\"/>\r\n      </g>\r\n    </g>\r\n  </g>\r\n</svg>\r\n" }]
    }], null, { fillColor: [{
            type: Input
        }], width: [{
            type: Input
        }], height: [{
            type: Input
        }] }); })();

var v = "5.5.10";
var fr = 30;
var ip = 0;
var op = 195;
var w = 120;
var h = 120;
var nm = "0.0_loader screen 1";
var ddd = 0;
var assets = [
	{
		id: "comp_0",
		layers: [
			{
				ddd: 0,
				ind: 1,
				ty: 4,
				nm: "accident Outlines",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							359,
							60,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							26.5,
							28,
							0
						],
						ix: 1
					},
					s: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.5,
										0.5,
										0.5
									],
									y: [
										1,
										1,
										1
									]
								},
								o: {
									x: [
										0.5,
										0.5,
										0.5
									],
									y: [
										0,
										0,
										0
									]
								},
								t: 120,
								s: [
									0,
									0,
									100
								]
							},
							{
								i: {
									x: [
										0.5,
										0.5,
										0.5
									],
									y: [
										1,
										1,
										1
									]
								},
								o: {
									x: [
										0.5,
										0.5,
										0.5
									],
									y: [
										0,
										0,
										0
									]
								},
								t: 135,
								s: [
									100,
									100,
									100
								]
							},
							{
								i: {
									x: [
										0.5,
										0.5,
										0.5
									],
									y: [
										1,
										1,
										1
									]
								},
								o: {
									x: [
										0.5,
										0.5,
										0.5
									],
									y: [
										0,
										0,
										0
									]
								},
								t: 150,
								s: [
									100,
									100,
									100
								]
							},
							{
								t: 165.000390625,
								s: [
									0,
									0,
									100
								]
							}
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												1.957,
												0
											],
											[
												0,
												-1.957
											],
											[
												-1.957,
												0
											],
											[
												0,
												1.957
											]
										],
										o: [
											[
												-1.957,
												0
											],
											[
												0,
												1.957
											],
											[
												1.957,
												0
											],
											[
												0,
												-1.957
											]
										],
										v: [
											[
												-17.387,
												-19.859
											],
											[
												-20.936,
												-16.31
											],
											[
												-17.387,
												-12.761
											],
											[
												-13.837,
												-16.31
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ind: 1,
								ty: "sh",
								ix: 2,
								ks: {
									a: 0,
									k: {
										i: [
											[
												-3.322,
												0
											],
											[
												0,
												-3.321
											],
											[
												3.322,
												0
											],
											[
												0,
												3.322
											]
										],
										o: [
											[
												3.322,
												0
											],
											[
												0,
												3.322
											],
											[
												-3.322,
												0
											],
											[
												0,
												-3.321
											]
										],
										v: [
											[
												-17.387,
												-22.334
											],
											[
												-11.363,
												-16.31
											],
											[
												-17.387,
												-10.286
											],
											[
												-23.411,
												-16.31
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 2",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ind: 2,
								ty: "sh",
								ix: 3,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0.381,
												0.23
											],
											[
												0.393,
												-0.221
											],
											[
												0.003,
												-0.459
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.001,
												-0.007
											],
											[
												0.002,
												-0.021
											],
											[
												0,
												0
											],
											[
												0.003,
												-0.019
											],
											[
												0.005,
												-0.021
											],
											[
												0.005,
												-0.018
											],
											[
												0.007,
												-0.02
											],
											[
												0.007,
												-0.018
											],
											[
												0.008,
												-0.018
											],
											[
												0.009,
												-0.018
											],
											[
												0,
												0
											],
											[
												0.011,
												-0.018
											],
											[
												0.011,
												-0.015
											],
											[
												0.013,
												-0.017
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.016,
												-0.014
											],
											[
												0.007,
												-0.006
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.348,
												-0.205
											],
											[
												0,
												0
											],
											[
												0.354,
												-0.512
											],
											[
												0,
												-0.001
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.005,
												-0.526
											],
											[
												0,
												0
											],
											[
												-0.656,
												0.005
											],
											[
												-0.057,
												0.641
											],
											[
												0,
												0
											],
											[
												0,
												0.003
											],
											[
												-0.002,
												0.028
											],
											[
												-0.001,
												0.013
											],
											[
												-0.005,
												0.028
											],
											[
												-0.003,
												0.013
											],
											[
												-0.006,
												0.022
											],
											[
												-0.005,
												0.017
											],
											[
												0,
												0
											],
											[
												-0.008,
												0.021
											],
											[
												-0.005,
												0.012
											],
											[
												-0.014,
												0.025
											],
											[
												-0.007,
												0.011
											],
											[
												-0.016,
												0.025
											],
											[
												-0.001,
												0.003
											],
											[
												0,
												0
											],
											[
												0,
												0.001
											],
											[
												0,
												0
											],
											[
												-0.883,
												-0.027
											],
											[
												-0.469,
												-0.78
											],
											[
												0,
												0
											],
											[
												-0.77,
												-0.175
											],
											[
												0,
												0
											],
											[
												-0.077,
												-0.035
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.063,
												-0.055
											],
											[
												0,
												0
											],
											[
												-0.655,
												0.216
											],
											[
												-0.124,
												0.64
											],
											[
												0.497,
												0.423
											],
											[
												0.003,
												0.002
											],
											[
												0.003,
												0.003
											],
											[
												0,
												0
											],
											[
												0.039,
												0.047
											],
											[
												0.357,
												0.101
											],
											[
												0.053,
												0.012
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.07,
												0.921
											],
											[
												-0.834,
												0.331
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.023,
												0.007
											],
											[
												-0.017,
												0.005
											],
											[
												0,
												0
											],
											[
												-0.02,
												0.003
											],
											[
												-0.018,
												0.002
											],
											[
												-0.022,
												0.001
											],
											[
												-0.017,
												0
											],
											[
												-0.023,
												-0.001
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.02,
												-0.003
											],
											[
												-0.018,
												-0.005
											],
											[
												-0.022,
												-0.007
											],
											[
												-0.015,
												-0.004
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.013,
												-0.005
											],
											[
												-0.022,
												-0.011
											],
											[
												-0.014,
												-0.009
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.014,
												-0.012
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.001,
												-0.002
											],
											[
												-0.629,
												0.193
											],
											[
												-0.14,
												0.632
											],
											[
												0.48,
												0.435
											],
											[
												0.001,
												0.001
											],
											[
												0,
												0
											],
											[
												1.042,
												-0.413
											],
											[
												0.001,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.329,
												0
											],
											[
												0.493,
												0.772
											],
											[
												0.005,
												0.008
											],
											[
												0.01,
												0.017
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.93,
												0.844
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.015,
												1.052
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												-0.387,
												-0.232
											],
											[
												-0.388,
												0.217
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0.008
											],
											[
												0,
												0.022
											],
											[
												0,
												0
											],
											[
												-0.003,
												0.02
											],
											[
												-0.004,
												0.021
											],
											[
												-0.005,
												0.018
											],
											[
												-0.006,
												0.021
											],
											[
												-0.005,
												0.018
											],
											[
												-0.007,
												0.019
											],
											[
												-0.008,
												0.019
											],
											[
												0,
												0
											],
											[
												-0.01,
												0.018
											],
											[
												-0.011,
												0.015
											],
											[
												-0.011,
												0.017
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.015,
												0.015
											],
											[
												-0.007,
												0.007
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.225,
												0.196
											],
											[
												0,
												0
											],
											[
												-0.532,
												0.314
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.264,
												0.453
											],
											[
												0,
												0
											],
											[
												0.06,
												0.626
											],
											[
												0.659,
												-0.006
											],
											[
												0,
												0
											],
											[
												0,
												-0.003
											],
											[
												0,
												-0.028
											],
											[
												0.001,
												-0.013
											],
											[
												0.003,
												-0.027
											],
											[
												0.002,
												-0.012
											],
											[
												0.005,
												-0.023
											],
											[
												0.004,
												-0.017
											],
											[
												0,
												0
											],
											[
												0.008,
												-0.022
											],
											[
												0.006,
												-0.012
											],
											[
												0.012,
												-0.026
											],
											[
												0.006,
												-0.011
											],
											[
												0.014,
												-0.025
											],
											[
												0.002,
												-0.002
											],
											[
												0,
												0
											],
											[
												0.001,
												0
											],
											[
												0,
												0
											],
											[
												0.511,
												-0.739
											],
											[
												0.882,
												0.028
											],
											[
												0,
												0
											],
											[
												0.415,
												0.691
											],
											[
												0,
												0
											],
											[
												0.081,
												0.018
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.073,
												0.042
											],
											[
												0,
												0
											],
											[
												0.61,
												0.451
											],
											[
												0.621,
												-0.204
											],
											[
												0.125,
												-0.644
											],
											[
												-0.003,
												-0.002
											],
											[
												-0.003,
												-0.002
											],
											[
												0,
												0
											],
											[
												-0.047,
												-0.041
											],
											[
												-0.294,
												-0.227
											],
											[
												-0.052,
												-0.005
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.873,
												-0.2
											],
											[
												-0.069,
												-0.916
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.023,
												-0.008
											],
											[
												0.018,
												-0.005
											],
											[
												0,
												0
											],
											[
												0.021,
												-0.005
											],
											[
												0.018,
												-0.003
											],
											[
												0.023,
												-0.002
											],
											[
												0.017,
												-0.001
											],
											[
												0.023,
												-0.001
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.02,
												0.003
											],
											[
												0.018,
												0.003
											],
											[
												0.022,
												0.005
											],
											[
												0.015,
												0.004
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.013,
												0.005
											],
											[
												0.022,
												0.01
											],
											[
												0.014,
												0.007
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.016,
												0.011
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.001,
												0.001
											],
											[
												0.464,
												0.435
											],
											[
												0.619,
												-0.192
											],
											[
												0.14,
												-0.632
											],
											[
												-0.005,
												-0.005
											],
											[
												0,
												0
											],
											[
												-0.825,
												-0.761
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.324,
												0.129
											],
											[
												-0.877,
												0
											],
											[
												-0.004,
												-0.008
											],
											[
												-0.01,
												-0.015
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.002,
												-0.003
											],
											[
												-0.64,
												-1.078
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.787,
												-0.71
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.011,
												-0.458
											]
										],
										v: [
											[
												-0.314,
												-25.266
											],
											[
												-1.577,
												-25.284
											],
											[
												-2.219,
												-24.17
											],
											[
												-2.219,
												-24.158
											],
											[
												-2.339,
												-16.065
											],
											[
												-2.34,
												-16.043
											],
											[
												-2.344,
												-15.978
											],
											[
												-2.35,
												-15.92
											],
											[
												-2.359,
												-15.861
											],
											[
												-2.372,
												-15.799
											],
											[
												-2.387,
												-15.746
											],
											[
												-2.406,
												-15.684
											],
											[
												-2.426,
												-15.631
											],
											[
												-2.449,
												-15.574
											],
											[
												-2.475,
												-15.519
											],
											[
												-2.503,
												-15.468
											],
											[
												-2.536,
												-15.414
											],
											[
												-2.568,
												-15.368
											],
											[
												-2.605,
												-15.317
											],
											[
												-2.643,
												-15.272
											],
											[
												-2.682,
												-15.228
											],
											[
												-2.729,
												-15.183
											],
											[
												-2.747,
												-15.164
											],
											[
												-8.048,
												-10.389
											],
											[
												-8.176,
												-10.276
											],
											[
												-9.035,
												-9.646
											],
											[
												-18.107,
												-4.298
											],
											[
												-19.46,
												-3.036
											],
											[
												-19.462,
												-3.035
											],
											[
												-19.463,
												-3.033
											],
											[
												-23.018,
												2.073
											],
											[
												-23.137,
												2.262
											],
											[
												-23.538,
												3.769
											],
											[
												-23.443,
												12.684
											],
											[
												-22.174,
												13.787
											],
											[
												-20.928,
												12.655
											],
											[
												-20.999,
												4.004
											],
											[
												-20.999,
												3.995
											],
											[
												-20.995,
												3.911
											],
											[
												-20.993,
												3.872
											],
											[
												-20.982,
												3.79
											],
											[
												-20.975,
												3.751
											],
											[
												-20.958,
												3.683
											],
											[
												-20.945,
												3.632
											],
											[
												-20.928,
												3.583
											],
											[
												-20.904,
												3.517
											],
											[
												-20.887,
												3.482
											],
											[
												-20.85,
												3.406
											],
											[
												-20.831,
												3.374
											],
											[
												-20.786,
												3.3
											],
											[
												-20.783,
												3.293
											],
											[
												-18.109,
												-0.598
											],
											[
												-18.107,
												-0.6
											],
											[
												-18.105,
												-0.601
											],
											[
												-15.846,
												-1.754
											],
											[
												-13.688,
												-0.463
											],
											[
												-7.122,
												10.471
											],
											[
												-5.258,
												11.835
											],
											[
												6.15,
												14.437
											],
											[
												6.387,
												14.517
											],
											[
												6.467,
												14.557
											],
											[
												6.495,
												14.572
											],
											[
												6.699,
												14.718
											],
											[
												16.896,
												23.703
											],
											[
												18.68,
												24.032
											],
											[
												19.885,
												22.662
											],
											[
												19.283,
												20.933
											],
											[
												19.275,
												20.926
											],
											[
												19.266,
												20.919
											],
											[
												8.714,
												11.657
											],
											[
												8.587,
												11.524
											],
											[
												7.6,
												11.027
											],
											[
												7.443,
												11.002
											],
											[
												4.602,
												10.358
											],
											[
												4.6,
												10.358
											],
											[
												3.023,
												8.485
											],
											[
												4.301,
												6.401
											],
											[
												4.301,
												6.4
											],
											[
												9.387,
												4.395
											],
											[
												9.408,
												4.387
											],
											[
												9.477,
												4.364
											],
											[
												9.529,
												4.349
											],
											[
												9.59,
												4.335
											],
											[
												9.652,
												4.324
											],
											[
												9.704,
												4.317
											],
											[
												9.773,
												4.311
											],
											[
												9.822,
												4.31
											],
											[
												9.893,
												4.31
											],
											[
												9.945,
												4.314
											],
											[
												10.01,
												4.321
											],
											[
												10.07,
												4.331
											],
											[
												10.124,
												4.342
											],
											[
												10.191,
												4.361
											],
											[
												10.236,
												4.373
											],
											[
												10.27,
												4.387
											],
											[
												10.307,
												4.401
											],
											[
												10.346,
												4.417
											],
											[
												10.413,
												4.45
											],
											[
												10.456,
												4.473
											],
											[
												10.484,
												4.49
											],
											[
												10.512,
												4.507
											],
											[
												10.561,
												4.54
											],
											[
												10.605,
												4.575
											],
											[
												10.661,
												4.62
											],
											[
												10.678,
												4.635
											],
											[
												20.227,
												13.42
											],
											[
												20.232,
												13.425
											],
											[
												20.236,
												13.429
											],
											[
												22.036,
												13.826
											],
											[
												23.266,
												12.49
											],
											[
												22.715,
												10.761
											],
											[
												22.706,
												10.754
											],
											[
												12.249,
												1.133
											],
											[
												9.176,
												0.561
											],
											[
												9.174,
												0.561
											],
											[
												2.396,
												3.258
											],
											[
												2.395,
												3.258
											],
											[
												1.408,
												3.449
											],
											[
												-0.799,
												2.238
											],
											[
												-0.814,
												2.215
											],
											[
												-0.844,
												2.168
											],
											[
												-0.844,
												2.165
											],
											[
												-5.786,
												-6.187
											],
											[
												-5.786,
												-6.188
											],
											[
												-5.788,
												-6.192
											],
											[
												-5.294,
												-9.453
											],
											[
												-5.292,
												-9.455
											],
											[
												-5.288,
												-9.458
											],
											[
												-1.066,
												-13.298
											],
											[
												0.176,
												-16.029
											],
											[
												0.296,
												-24.123
											],
											[
												0.296,
												-24.134
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 3",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ind: 3,
								ty: "sh",
								ix: 4,
								ks: {
									a: 0,
									k: {
										i: [
											[
												-1.16,
												0.653
											],
											[
												-1.147,
												-0.69
											],
											[
												0.025,
												-1.343
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												1.206,
												-1.091
											],
											[
												0.001,
												-0.001
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.025,
												-0.043
											],
											[
												0,
												0
											],
											[
												-0.001,
												-0.001
											],
											[
												0,
												0
											],
											[
												-0.076,
												0.03
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-1.519,
												-1.4
											],
											[
												0,
												0
											],
											[
												0,
												-0.001
											],
											[
												0.331,
												-1.494
											],
											[
												1.468,
												-0.453
											],
											[
												0.432,
												0
											],
											[
												0.798,
												0.742
											],
											[
												0.002,
												0.001
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.065,
												-0.015
											],
											[
												-0.674,
												-0.593
											],
											[
												-0.045,
												-0.058
											],
											[
												0,
												0
											],
											[
												0.294,
												-1.514
											],
											[
												1.468,
												-0.486
											],
											[
												0.46,
												0
											],
											[
												0.842,
												0.629
											],
											[
												0.003,
												0.002
											],
											[
												0,
												0
											],
											[
												0.01,
												0.008
											],
											[
												0.014,
												0.013
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.76,
												1.265
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.038,
												0.001
											],
											[
												0.038,
												-0.057
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.001,
												-0.014
											],
											[
												0,
												0
											],
											[
												0.001,
												-0.005
											],
											[
												1.931,
												-0.016
											],
											[
												0,
												0
											],
											[
												0.17,
												1.894
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0.014
											],
											[
												0,
												0.014
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.584,
												0.844
											],
											[
												0,
												0.001
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.836,
												0.493
											],
											[
												0,
												0
											],
											[
												-0.233,
												0.209
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0.004
											]
										],
										o: [
											[
												1.168,
												-0.656
											],
											[
												1.141,
												0.686
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.098,
												1.615
											],
											[
												-0.001,
												0.002
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.074,
												0.067
											],
											[
												0.001,
												0
											],
											[
												0,
												0.001
											],
											[
												0,
												0
											],
											[
												0.037,
												0.062
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												1.921,
												-0.762
											],
											[
												0,
												0
											],
											[
												0.001,
												0
											],
											[
												1.131,
												1.03
											],
											[
												-0.331,
												1.499
											],
											[
												-0.424,
												0.131
											],
											[
												-1.073,
												0
											],
											[
												-0.002,
												-0.002
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.065,
												0.005
											],
											[
												0.875,
												0.199
											],
											[
												0.057,
												0.049
											],
											[
												0,
												0
											],
											[
												1.169,
												1.004
											],
											[
												-0.295,
												1.518
											],
											[
												-0.478,
												0.157
											],
											[
												-0.923,
												0
											],
											[
												-0.003,
												-0.002
											],
											[
												0,
												0
											],
											[
												-0.011,
												-0.008
											],
											[
												-0.014,
												-0.012
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-1.424,
												-0.325
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.033,
												-0.055
											],
											[
												-0.041,
												-0.003
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.001,
												0.014
											],
											[
												0,
												0
											],
											[
												-0.001,
												0.006
											],
											[
												-0.149,
												1.91
											],
											[
												0,
												0
											],
											[
												-1.93,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.001,
												-0.014
											],
											[
												-0.001,
												-0.014
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.043,
												-1.023
											],
											[
												0.001,
												-0.001
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.557,
												-0.803
											],
											[
												0,
												0
											],
											[
												0.179,
												-0.106
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-0.004
											],
											[
												0.015,
												-1.345
											]
										],
										v: [
											[
												-2.792,
												-27.442
											],
											[
												0.962,
												-27.387
											],
											[
												2.77,
												-24.099
											],
											[
												2.77,
												-24.086
											],
											[
												2.65,
												-15.993
											],
											[
												2.639,
												-15.707
											],
											[
												0.603,
												-11.471
											],
											[
												0.6,
												-11.467
											],
											[
												-3.626,
												-7.624
											],
											[
												-3.63,
												-7.621
											],
											[
												-3.659,
												-7.453
											],
											[
												-3.658,
												-7.452
											],
											[
												-3.657,
												-7.45
											],
											[
												1.284,
												0.902
											],
											[
												1.482,
												0.958
											],
											[
												1.484,
												0.957
											],
											[
												8.26,
												-1.739
											],
											[
												8.262,
												-1.739
											],
											[
												13.926,
												-0.688
											],
											[
												24.383,
												8.933
											],
											[
												24.385,
												8.935
											],
											[
												25.682,
												13.025
											],
											[
												22.766,
												16.19
											],
											[
												21.477,
												16.385
											],
											[
												18.557,
												15.247
											],
											[
												18.551,
												15.243
											],
											[
												9.574,
												6.982
											],
											[
												6.41,
												8.23
											],
											[
												7.807,
												8.547
											],
											[
												8.001,
												8.575
											],
											[
												10.367,
												9.786
											],
											[
												10.518,
												9.948
											],
											[
												20.898,
												19.059
											],
											[
												22.316,
												23.134
											],
											[
												19.458,
												26.382
											],
											[
												18.051,
												26.619
											],
											[
												15.396,
												25.673
											],
											[
												15.387,
												25.666
											],
											[
												15.374,
												25.657
											],
											[
												15.344,
												25.632
											],
											[
												15.301,
												25.597
											],
											[
												5.296,
												16.781
											],
											[
												-5.809,
												14.248
											],
											[
												-9.245,
												11.746
											],
											[
												-9.245,
												11.745
											],
											[
												-15.809,
												0.812
											],
											[
												-15.926,
												0.72
											],
											[
												-16.07,
												0.808
											],
											[
												-16.072,
												0.808
											],
											[
												-18.521,
												4.373
											],
											[
												-18.452,
												12.698
											],
											[
												-18.454,
												12.745
											],
											[
												-18.456,
												12.789
											],
											[
												-18.458,
												12.815
											],
											[
												-18.46,
												12.833
											],
											[
												-22.154,
												16.261
											],
											[
												-22.186,
												16.261
											],
											[
												-25.909,
												12.901
											],
											[
												-25.911,
												12.886
											],
											[
												-25.913,
												12.85
											],
											[
												-25.915,
												12.809
											],
											[
												-25.917,
												12.769
											],
											[
												-26.014,
												3.792
											],
											[
												-26.014,
												3.79
											],
											[
												-26.008,
												3.51
											],
											[
												-25.053,
												0.664
											],
											[
												-25.053,
												0.662
											],
											[
												-25.051,
												0.661
											],
											[
												-21.493,
												-4.448
											],
											[
												-19.365,
												-6.43
											],
											[
												-10.292,
												-11.778
											],
											[
												-9.704,
												-12.228
											],
											[
												-4.805,
												-16.641
											],
											[
												-4.695,
												-24.194
											],
											[
												-4.693,
												-24.206
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 4",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ind: 4,
								ty: "sh",
								ix: 5,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												-0.301,
												-0.442
											],
											[
												0.441,
												-0.3
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.186,
												-0.238
											],
											[
												0.077,
												-0.292
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.271,
												-0.046
											],
											[
												-0.147,
												-0.233
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.301,
												0.068
											],
											[
												-0.233,
												-0.201
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.521,
												-0.115
											],
											[
												0.115,
												-0.521
											],
											[
												0,
												0
											],
											[
												0.323,
												-0.108
											],
											[
												0.258,
												0.223
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.358,
												-0.028
											],
											[
												0.026,
												0
											],
											[
												0.178,
												0.282
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.349,
												0.226
											],
											[
												-0.105,
												0.403
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.129,
												0.406
											],
											[
												-0.352,
												0.241
											]
										],
										o: [
											[
												0.441,
												-0.301
											],
											[
												0.3,
												0.441
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.301,
												-0.008
											],
											[
												0.186,
												0.239
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.215,
												-0.17
											],
											[
												0.271,
												0.046
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.122,
												-0.283
											],
											[
												0.3,
												-0.07
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.114,
												-0.522
											],
											[
												0.522,
												0.114
											],
											[
												0,
												0
											],
											[
												-0.073,
												0.333
											],
											[
												-0.324,
												0.108
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.142,
												0.33
											],
											[
												-0.025,
												0.002
											],
											[
												-0.329,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.326,
												0.259
											],
											[
												-0.349,
												-0.228
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.428,
												0.007
											],
											[
												-0.129,
												-0.407
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-17.323,
												16.278
											],
											[
												-15.979,
												16.533
											],
											[
												-16.234,
												17.876
											],
											[
												-19.038,
												19.787
											],
											[
												-14.214,
												19.715
											],
											[
												-13.439,
												20.085
											],
											[
												-13.264,
												20.927
											],
											[
												-14.174,
												24.391
											],
											[
												-9.288,
												20.498
											],
											[
												-8.523,
												20.301
											],
											[
												-7.867,
												20.739
											],
											[
												-5.243,
												24.892
											],
											[
												-3.176,
												20.084
											],
											[
												-2.503,
												19.525
											],
											[
												-1.654,
												19.736
											],
											[
												1.391,
												22.372
											],
											[
												2.236,
												18.517
											],
											[
												3.387,
												17.78
											],
											[
												4.124,
												18.931
											],
											[
												2.93,
												24.374
											],
											[
												2.292,
												25.085
											],
											[
												1.354,
												24.898
											],
											[
												-1.921,
												22.063
											],
											[
												-4.191,
												27.342
											],
											[
												-5.005,
												27.924
											],
											[
												-5.081,
												27.927
											],
											[
												-5.898,
												27.477
											],
											[
												-8.926,
												22.683
											],
											[
												-15.245,
												27.717
											],
											[
												-16.374,
												27.771
											],
											[
												-16.783,
												26.715
											],
											[
												-15.458,
												21.667
											],
											[
												-22.23,
												21.768
											],
											[
												-23.167,
												21.093
											],
											[
												-22.79,
												20.002
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 5",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "mm",
								mm: 1,
								nm: "Merge Paths 1",
								mn: "ADBE Vector Filter - Merge",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0,
										0.380000005984,
										0.573000021542,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										26.347,
										27.997
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 9,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: -2.4,
				op: 490.8,
				st: -2.4,
				bm: 0
			},
			{
				ddd: 0,
				ind: 2,
				ty: 4,
				nm: "car Outlines 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							40,
							60,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							28,
							22.5,
							0
						],
						ix: 1
					},
					s: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.5,
										0.5,
										0.5
									],
									y: [
										1,
										1,
										1
									]
								},
								o: {
									x: [
										0.5,
										0.5,
										0.5
									],
									y: [
										0,
										0,
										0
									]
								},
								t: 30,
								s: [
									100,
									100,
									100
								]
							},
							{
								t: 45.000390625,
								s: [
									0,
									0,
									100
								]
							}
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												12.042,
												-15.167
											],
											[
												-12.042,
												-15.167
											],
											[
												-15.778,
												-5.833
											],
											[
												15.778,
												-5.833
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ind: 1,
								ty: "sh",
								ix: 2,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												-0.175,
												-0.441
											],
											[
												0,
												0
											],
											[
												0.217,
												-0.319
											],
											[
												0.388,
												0
											],
											[
												0,
												0
											],
											[
												0.217,
												0.32
											],
											[
												-0.142,
												0.359
											],
											[
												0,
												0
											],
											[
												-0.477,
												0
											]
										],
										o: [
											[
												0.477,
												0
											],
											[
												0,
												0
											],
											[
												0.145,
												0.359
											],
											[
												-0.217,
												0.32
											],
											[
												0,
												0
											],
											[
												-0.387,
												0
											],
											[
												-0.217,
												-0.319
											],
											[
												0,
												0
											],
											[
												0.175,
												-0.441
											],
											[
												0,
												0
											]
										],
										v: [
											[
												12.833,
												-17.499
											],
											[
												13.916,
												-16.768
											],
											[
												18.583,
												-5.1
											],
											[
												18.466,
												-4.014
											],
											[
												17.5,
												-3.499
											],
											[
												-17.5,
												-3.499
											],
											[
												-18.466,
												-4.014
											],
											[
												-18.583,
												-5.1
											],
											[
												-13.916,
												-16.768
											],
											[
												-12.833,
												-17.499
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 2",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ind: 2,
								ty: "sh",
								ix: 3,
								ks: {
									a: 0,
									k: {
										i: [
											[
												1.288,
												0
											],
											[
												0,
												-1.286
											],
											[
												-1.288,
												0
											],
											[
												0,
												1.286
											]
										],
										o: [
											[
												-1.288,
												0
											],
											[
												0,
												1.286
											],
											[
												1.288,
												0
											],
											[
												0,
												-1.286
											]
										],
										v: [
											[
												14.044,
												1.167
											],
											[
												11.711,
												3.501
											],
											[
												14.044,
												5.833
											],
											[
												16.378,
												3.501
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 3",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ind: 3,
								ty: "sh",
								ix: 4,
								ks: {
									a: 0,
									k: {
										i: [
											[
												1.289,
												0
											],
											[
												0,
												-1.286
											],
											[
												-1.288,
												0
											],
											[
												0,
												1.286
											]
										],
										o: [
											[
												-1.288,
												0
											],
											[
												0,
												1.286
											],
											[
												1.289,
												0
											],
											[
												0,
												-1.286
											]
										],
										v: [
											[
												-13.956,
												1.167
											],
											[
												-16.289,
												3.501
											],
											[
												-13.956,
												5.833
											],
											[
												-11.623,
												3.501
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 4",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ind: 4,
								ty: "sh",
								ix: 5,
								ks: {
									a: 0,
									k: {
										i: [
											[
												-2.573,
												0
											],
											[
												0,
												-2.574
											],
											[
												2.574,
												0
											],
											[
												0,
												2.574
											]
										],
										o: [
											[
												2.574,
												0
											],
											[
												0,
												2.574
											],
											[
												-2.573,
												0
											],
											[
												0,
												-2.574
											]
										],
										v: [
											[
												14.044,
												-1.167
											],
											[
												18.711,
												3.501
											],
											[
												14.044,
												8.167
											],
											[
												9.378,
												3.501
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 5",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ind: 5,
								ty: "sh",
								ix: 6,
								ks: {
									a: 0,
									k: {
										i: [
											[
												-2.573,
												0
											],
											[
												0,
												-2.574
											],
											[
												2.574,
												0
											],
											[
												0,
												2.574
											]
										],
										o: [
											[
												2.574,
												0
											],
											[
												0,
												2.574
											],
											[
												-2.573,
												0
											],
											[
												0,
												-2.574
											]
										],
										v: [
											[
												-13.956,
												-1.167
											],
											[
												-9.289,
												3.501
											],
											[
												-13.956,
												8.167
											],
											[
												-18.623,
												3.501
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 6",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ind: 6,
								ty: "sh",
								ix: 7,
								ks: {
									a: 0,
									k: {
										i: [
											[
												1.696,
												0.168
											],
											[
												0,
												0
											],
											[
												0.504,
												-1.614
											],
											[
												0,
												0
											],
											[
												0.478,
												-0.002
											],
											[
												0,
												0
											],
											[
												0,
												-0.735
											],
											[
												-0.483,
												-0.185
											],
											[
												0,
												0
											],
											[
												0,
												-0.486
											],
											[
												0,
												0
											],
											[
												0,
												-0.098
											],
											[
												-1.286,
												0
											],
											[
												0,
												1.286
											],
											[
												0,
												0
											],
											[
												-0.644,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-0.647
											],
											[
												0,
												0
											],
											[
												-1.288,
												0
											],
											[
												0,
												1.286
											],
											[
												0.017,
												0.112
											],
											[
												0,
												0
											],
											[
												-0.453,
												0.172
											],
											[
												0,
												0
											],
											[
												0,
												0.581
											],
											[
												0.645,
												0.002
											],
											[
												0,
												0
											],
											[
												0.17,
												0.451
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												-1.584,
												0.162
											],
											[
												0,
												0
											],
											[
												-0.172,
												0.446
											],
											[
												0,
												0
											],
											[
												-0.646,
												0.005
											],
											[
												0,
												0.581
											],
											[
												0,
												0
											],
											[
												0.458,
												0.172
											],
											[
												0,
												0
											],
											[
												0.021,
												0.091
											],
											[
												0,
												1.286
											],
											[
												1.288,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-0.647
											],
											[
												0,
												0
											],
											[
												0.646,
												0
											],
											[
												0,
												0
											],
											[
												0,
												1.286
											],
											[
												1.288,
												0
											],
											[
												0,
												-0.12
											],
											[
												0,
												0
											],
											[
												0,
												-0.485
											],
											[
												0,
												0
											],
											[
												0.484,
												-0.182
											],
											[
												0,
												-0.738
											],
											[
												0,
												0
											],
											[
												-0.483,
												0
											],
											[
												0,
												0
											],
											[
												-0.532,
												-1.687
											]
										],
										v: [
											[
												13.977,
												-19.839
											],
											[
												-13.993,
												-19.833
											],
											[
												-17.943,
												-16.553
											],
											[
												-22.58,
												-4.652
											],
											[
												-23.66,
												-3.911
											],
											[
												-24.498,
												-3.906
											],
											[
												-25.666,
												-2.564
											],
											[
												-24.862,
												-1.288
											],
											[
												-24.071,
												-0.988
											],
											[
												-23.314,
												0.104
											],
											[
												-23.326,
												17.217
											],
											[
												-23.291,
												17.501
											],
											[
												-20.958,
												19.833
											],
											[
												-18.625,
												17.501
											],
											[
												-18.625,
												14.001
											],
											[
												-17.458,
												12.833
											],
											[
												17.542,
												12.833
											],
											[
												18.709,
												14.001
											],
											[
												18.709,
												17.501
											],
											[
												21.042,
												19.833
											],
											[
												23.375,
												17.501
											],
											[
												23.338,
												17.16
											],
											[
												23.313,
												0.105
											],
											[
												24.066,
												-0.988
											],
											[
												24.859,
												-1.288
											],
											[
												25.667,
												-2.564
											],
											[
												24.495,
												-3.906
											],
											[
												23.653,
												-3.908
											],
											[
												22.568,
												-4.658
											],
											[
												18.064,
												-16.475
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 7",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ind: 7,
								ty: "sh",
								ix: 8,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												-0.785,
												-2.504
											],
											[
												0,
												0
											],
											[
												0,
												-2.023
											],
											[
												1.383,
												-0.525
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-0.243
											],
											[
												2.573,
												0
											],
											[
												0,
												2.574
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												2.574,
												0
											],
											[
												0.161,
												2.431
											],
											[
												0,
												0.107
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												1.544
											],
											[
												-1.923,
												0.011
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-2.618,
												0.257
											]
										],
										o: [
											[
												2.732,
												0.262
											],
											[
												0,
												0
											],
											[
												1.93,
												0.004
											],
											[
												0,
												1.544
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.024,
												0.049
											],
											[
												0,
												2.574
											],
											[
												-2.571,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												2.574
											],
											[
												-2.469,
												0
											],
											[
												-0.031,
												-0.1
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-1.385,
												-0.524
											],
											[
												0,
												-2.017
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.754,
												-2.424
											],
											[
												0,
												0
											]
										],
										v: [
											[
												14.091,
												-22.167
											],
											[
												20.268,
												-17.238
											],
											[
												24.5,
												-6.238
											],
											[
												28,
												-2.564
											],
											[
												25.686,
												0.896
											],
											[
												25.646,
												0.911
											],
											[
												25.657,
												16.975
											],
											[
												25.709,
												17.501
											],
											[
												21.042,
												22.167
											],
											[
												16.375,
												17.501
											],
											[
												16.375,
												15.167
											],
											[
												-16.291,
												15.167
											],
											[
												-16.291,
												17.501
											],
											[
												-20.958,
												22.167
											],
											[
												-25.615,
												17.809
											],
											[
												-25.66,
												17.499
											],
											[
												-25.648,
												0.909
											],
											[
												-25.686,
												0.894
											],
											[
												-28,
												-2.564
											],
											[
												-24.512,
												-6.238
											],
											[
												-24.467,
												-6.238
											],
											[
												-20.144,
												-17.322
											],
											[
												-14.107,
												-22.161
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 8",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "mm",
								mm: 1,
								nm: "Merge Paths 1",
								mn: "ADBE Vector Filter - Merge",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0,
										0.380000005984,
										0.573000021542,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										28,
										22.833
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 10,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: -2.4,
				op: 490.8,
				st: -2.4,
				bm: 0
			},
			{
				ddd: 0,
				ind: 3,
				ty: 4,
				nm: "health Outlines",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							200,
							60,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							26,
							21,
							0
						],
						ix: 1
					},
					s: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.5,
										0.5,
										0.5
									],
									y: [
										1,
										1,
										1
									]
								},
								o: {
									x: [
										0.5,
										0.5,
										0.5
									],
									y: [
										0,
										0,
										0
									]
								},
								t: 60,
								s: [
									0,
									0,
									100
								]
							},
							{
								i: {
									x: [
										0.5,
										0.5,
										0.5
									],
									y: [
										1,
										1,
										1
									]
								},
								o: {
									x: [
										0.5,
										0.5,
										0.5
									],
									y: [
										0,
										0,
										0
									]
								},
								t: 75,
								s: [
									100,
									100,
									100
								]
							},
							{
								i: {
									x: [
										0.5,
										0.5,
										0.5
									],
									y: [
										1,
										1,
										1
									]
								},
								o: {
									x: [
										0.5,
										0.5,
										0.5
									],
									y: [
										0,
										0,
										0
									]
								},
								t: 90,
								s: [
									100,
									100,
									100
								]
							},
							{
								t: 105.000390625,
								s: [
									0,
									0,
									100
								]
							}
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												1.93,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-1.93
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												-1.93,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-1.93
											]
										],
										v: [
											[
												3.5,
												-18.667
											],
											[
												-3.5,
												-18.667
											],
											[
												-7,
												-15.167
											],
											[
												-7,
												-14
											],
											[
												7,
												-14
											],
											[
												7,
												-15.167
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ind: 1,
								ty: "sh",
								ix: 2,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.644,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-0.644
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.644,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0.644
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0.644
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.644,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-0.644
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.644,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												2.333,
												-4.667
											],
											[
												-2.333,
												-4.667
											],
											[
												-2.333,
												-1.167
											],
											[
												-3.5,
												0
											],
											[
												-7,
												0
											],
											[
												-7,
												4.666
											],
											[
												-3.5,
												4.666
											],
											[
												-2.333,
												5.833
											],
											[
												-2.333,
												9.333
											],
											[
												2.333,
												9.333
											],
											[
												2.333,
												5.833
											],
											[
												3.5,
												4.666
											],
											[
												7,
												4.666
											],
											[
												7,
												0
											],
											[
												3.5,
												0
											],
											[
												2.333,
												-1.167
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 2",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ind: 2,
								ty: "sh",
								ix: 3,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												-0.644
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-0.644
											],
											[
												0,
												0
											],
											[
												0.644,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.644,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0.643
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0.644
											],
											[
												0,
												0
											],
											[
												-0.644,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.644,
												0
											]
										],
										o: [
											[
												0.644,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.644,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0.644
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0.643
											],
											[
												0,
												0
											],
											[
												-0.644,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.644,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-0.644
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-0.644
											],
											[
												0,
												0
											]
										],
										v: [
											[
												3.5,
												-7
											],
											[
												4.667,
												-5.834
											],
											[
												4.667,
												-2.334
											],
											[
												8.167,
												-2.334
											],
											[
												9.333,
												-1.167
											],
											[
												9.333,
												5.833
											],
											[
												8.167,
												7
											],
											[
												4.667,
												7
											],
											[
												4.667,
												10.5
											],
											[
												3.5,
												11.666
											],
											[
												-3.5,
												11.666
											],
											[
												-4.667,
												10.5
											],
											[
												-4.667,
												7
											],
											[
												-8.167,
												7
											],
											[
												-9.333,
												5.833
											],
											[
												-9.333,
												-1.167
											],
											[
												-8.167,
												-2.334
											],
											[
												-4.667,
												-2.334
											],
											[
												-4.667,
												-5.834
											],
											[
												-3.5,
												-7
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 3",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ind: 3,
								ty: "sh",
								ix: 4,
								ks: {
									a: 0,
									k: {
										i: [
											[
												1.93,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-1.93
											],
											[
												0,
												0
											],
											[
												-1.93,
												0
											],
											[
												0,
												0
											],
											[
												0,
												1.93
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												-1.93,
												0
											],
											[
												0,
												0
											],
											[
												0,
												1.93
											],
											[
												0,
												0
											],
											[
												1.93,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-1.93
											]
										],
										v: [
											[
												19.833,
												-11.667
											],
											[
												-19.833,
												-11.667
											],
											[
												-23.333,
												-8.167
											],
											[
												-23.333,
												15.166
											],
											[
												-19.833,
												18.666
											],
											[
												19.833,
												18.666
											],
											[
												23.333,
												15.166
											],
											[
												23.333,
												-8.167
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 4",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ind: 4,
								ty: "sh",
								ix: 5,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												-3.215
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-3.215
											],
											[
												0,
												0
											],
											[
												3.216,
												0
											],
											[
												0,
												0
											],
											[
												0,
												3.215
											],
											[
												0,
												0
											],
											[
												-3.216,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-3.215,
												0
											]
										],
										o: [
											[
												3.215,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												3.216,
												0
											],
											[
												0,
												0
											],
											[
												0,
												3.215
											],
											[
												0,
												0
											],
											[
												-3.216,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-3.215
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-3.215
											],
											[
												0,
												0
											]
										],
										v: [
											[
												3.5,
												-21
											],
											[
												9.333,
												-15.167
											],
											[
												9.333,
												-14
											],
											[
												19.833,
												-14
											],
											[
												25.667,
												-8.167
											],
											[
												25.667,
												15.166
											],
											[
												19.833,
												21
											],
											[
												-19.833,
												21
											],
											[
												-25.667,
												15.166
											],
											[
												-25.667,
												-8.167
											],
											[
												-19.833,
												-14
											],
											[
												-9.333,
												-14
											],
											[
												-9.333,
												-15.167
											],
											[
												-3.5,
												-21
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 5",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "mm",
								mm: 1,
								nm: "Merge Paths 1",
								mn: "ADBE Vector Filter - Merge",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0,
										0.380000005984,
										0.573000021542,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										26,
										21
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 9,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: -2.4,
				op: 490.8,
				st: -2.4,
				bm: 0
			},
			{
				ddd: 0,
				ind: 4,
				ty: 4,
				nm: "home Outlines",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							120,
							58,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							26,
							27,
							0
						],
						ix: 1
					},
					s: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.5,
										0.5,
										0.5
									],
									y: [
										1,
										1,
										1
									]
								},
								o: {
									x: [
										0.5,
										0.5,
										0.5
									],
									y: [
										0,
										0,
										0
									]
								},
								t: 30,
								s: [
									0,
									0,
									100
								]
							},
							{
								i: {
									x: [
										0.5,
										0.5,
										0.5
									],
									y: [
										1,
										1,
										1
									]
								},
								o: {
									x: [
										0.5,
										0.5,
										0.5
									],
									y: [
										0,
										0,
										0
									]
								},
								t: 45,
								s: [
									100,
									100,
									100
								]
							},
							{
								i: {
									x: [
										0.5,
										0.5,
										0.5
									],
									y: [
										1,
										1,
										1
									]
								},
								o: {
									x: [
										0.5,
										0.5,
										0.5
									],
									y: [
										0,
										0,
										0
									]
								},
								t: 60,
								s: [
									100,
									100,
									100
								]
							},
							{
								t: 75.000390625,
								s: [
									0,
									0,
									100
								]
							}
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0.646,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-0.646
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.196,
												-0.394
											],
											[
												-0.441,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.645,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0.644
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.644,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0.644
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.189,
												0.418
											],
											[
												0.301,
												0.346
											],
											[
												0,
												0
											],
											[
												0.334,
												0.002
											],
											[
												0.222,
												-0.247
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												-0.644,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.264,
												0.352
											],
											[
												0.198,
												0.397
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0.644
											],
											[
												0,
												0
											],
											[
												0.646,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0.644
											],
											[
												0,
												0
											],
											[
												0.646,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.46,
												0
											],
											[
												0.191,
												-0.418
											],
											[
												0,
												0
											],
											[
												-0.22,
												-0.249
											],
											[
												-0.315,
												0.005
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-0.646
											]
										],
										v: [
											[
												-10.507,
												-19.833
											],
											[
												-17.507,
												-19.833
											],
											[
												-18.674,
												-18.667
											],
											[
												-18.674,
												-7.389
											],
											[
												-25.44,
												1.633
											],
											[
												-25.55,
												2.854
											],
											[
												-24.507,
												3.499
											],
											[
												-21.007,
												3.499
											],
											[
												-21.007,
												25.667
											],
											[
												-19.84,
												26.833
											],
											[
												-5.84,
												26.833
											],
											[
												-4.674,
												25.667
											],
											[
												-4.674,
												10.499
											],
											[
												4.66,
												10.499
											],
											[
												4.66,
												25.667
											],
											[
												5.826,
												26.833
											],
											[
												19.826,
												26.833
											],
											[
												20.993,
												25.667
											],
											[
												20.993,
												3.499
											],
											[
												24.493,
												3.499
											],
											[
												25.555,
												2.814
											],
											[
												25.373,
												1.562
											],
											[
												0.873,
												-26.438
											],
											[
												0.002,
												-26.833
											],
											[
												-0.873,
												-26.449
											],
											[
												-9.34,
												-17.042
											],
											[
												-9.34,
												-18.667
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ind: 1,
								ty: "sh",
								ix: 2,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-0.646
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.646,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-0.646
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.646,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0.252
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.451,
												-0.173
											],
											[
												-0.322,
												0.357
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.644,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-0.646
											],
											[
												0,
												0
											],
											[
												-0.645,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-0.646
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.152,
												-0.2
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0.483
											],
											[
												0.454,
												0.175
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-0.019,
												-23.91
											],
											[
												21.922,
												1.167
											],
											[
												19.826,
												1.167
											],
											[
												18.66,
												2.333
											],
											[
												18.66,
												24.499
											],
											[
												6.993,
												24.499
											],
											[
												6.993,
												9.333
											],
											[
												5.826,
												8.167
											],
											[
												-5.84,
												8.167
											],
											[
												-7.007,
												9.333
											],
											[
												-7.007,
												24.499
											],
											[
												-18.674,
												24.499
											],
											[
												-18.674,
												2.333
											],
											[
												-19.84,
												1.167
											],
											[
												-22.174,
												1.167
											],
											[
												-16.574,
												-6.303
											],
											[
												-16.34,
												-7.001
											],
											[
												-16.34,
												-17.501
											],
											[
												-11.674,
												-17.501
											],
											[
												-11.674,
												-14.001
											],
											[
												-10.924,
												-12.913
											],
											[
												-9.639,
												-13.221
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 2",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "mm",
								mm: 1,
								nm: "Merge Paths 1",
								mn: "ADBE Vector Filter - Merge",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0,
										0.380000005984,
										0.573000021542,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										26.007,
										26.833
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 4,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: -2.4,
				op: 490.8,
				st: -2.4,
				bm: 0
			},
			{
				ddd: 0,
				ind: 5,
				ty: 4,
				nm: "life Outlines",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							278,
							64,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							26,
							24,
							0
						],
						ix: 1
					},
					s: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.5,
										0.5,
										0.5
									],
									y: [
										1,
										1,
										1
									]
								},
								o: {
									x: [
										0.5,
										0.5,
										0.5
									],
									y: [
										0,
										0,
										0
									]
								},
								t: 90,
								s: [
									0,
									0,
									100
								]
							},
							{
								i: {
									x: [
										0.5,
										0.5,
										0.5
									],
									y: [
										1,
										1,
										1
									]
								},
								o: {
									x: [
										0.5,
										0.5,
										0.5
									],
									y: [
										0,
										0,
										0
									]
								},
								t: 105,
								s: [
									100,
									100,
									100
								]
							},
							{
								i: {
									x: [
										0.5,
										0.5,
										0.5
									],
									y: [
										1,
										1,
										1
									]
								},
								o: {
									x: [
										0.5,
										0.5,
										0.5
									],
									y: [
										0,
										0,
										0
									]
								},
								t: 120,
								s: [
									100,
									100,
									100
								]
							},
							{
								t: 135.000390625,
								s: [
									0,
									0,
									100
								]
							}
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												3.956,
												0
											],
											[
												2.798,
												-2.869
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												3.957,
												0
											],
											[
												2.796,
												-2.863
											],
											[
												-0.011,
												-4.034
											],
											[
												-2.797,
												-2.869
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.274,
												0
											],
											[
												-0.211,
												0.204
											],
											[
												-0.278,
												0.282
											],
											[
												0,
												0
											],
											[
												0,
												4.036
											],
											[
												2.787,
												2.86
											]
										],
										o: [
											[
												-3.954,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-2.804,
												-2.875
											],
											[
												-3.948,
												0
											],
											[
												-2.793,
												2.869
											],
											[
												0,
												4.026
											],
											[
												0,
												0
											],
											[
												0.277,
												0.282
											],
											[
												0.211,
												0.209
											],
											[
												0.271,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												2.789,
												-2.86
											],
											[
												0.011,
												-4.045
											],
											[
												-2.794,
												-2.862
											]
										],
										v: [
											[
												11.073,
												-23.661
											],
											[
												0.601,
												-19.21
											],
											[
												0.015,
												-18.613
											],
											[
												-0.59,
												-19.232
											],
											[
												-11.075,
												-23.693
											],
											[
												-21.53,
												-19.253
											],
											[
												-25.846,
												-8.549
											],
											[
												-21.509,
												2.143
											],
											[
												-1.783,
												22.372
											],
											[
												-0.773,
												23.38
											],
											[
												-0.015,
												23.693
											],
											[
												0.739,
												23.387
											],
											[
												1.751,
												22.382
											],
											[
												21.519,
												2.186
											],
											[
												25.846,
												-8.514
											],
											[
												21.541,
												-19.221
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ind: 1,
								ty: "sh",
								ix: 2,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0.086,
												-0.088
											],
											[
												0.058,
												0.061
											],
											[
												0,
												0
											],
											[
												0.186,
												0.215
											],
											[
												0,
												0
											],
											[
												-0.101,
												0.504
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.463,
												0
											],
											[
												0,
												0
											],
											[
												-0.127,
												0.455
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.36,
												0
											],
											[
												0,
												0
											],
											[
												0.213,
												-0.217
											]
										],
										o: [
											[
												-0.06,
												0.061
											],
											[
												-0.09,
												-0.092
											],
											[
												0,
												0
											],
											[
												-0.198,
												-0.205
											],
											[
												0,
												0
											],
											[
												0.512,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.149,
												0.441
											],
											[
												0,
												0
											],
											[
												0.472,
												-0.01
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.2,
												0.301
											],
											[
												0,
												0
											],
											[
												-0.196,
												0.231
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0.213,
												20.874
											],
											[
												-0.011,
												21.1
											],
											[
												-0.241,
												20.865
											],
											[
												-19.966,
												0.639
											],
											[
												-20.531,
												-0.001
											],
											[
												-14,
												-0.001
											],
											[
												-12.945,
												-0.867
											],
											[
												-11.586,
												-7.66
											],
											[
												-6.408,
												7.878
											],
											[
												-5.385,
												8.615
											],
											[
												-5.361,
												8.615
											],
											[
												-4.351,
												7.833
											],
											[
												-0.683,
												-5.004
											],
											[
												2.335,
												-0.48
											],
											[
												3.231,
												-0.001
											],
											[
												20.582,
												-0.001
											],
											[
												19.977,
												0.68
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 2",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ind: 2,
								ty: "sh",
								ix: 3,
								ks: {
									a: 0,
									k: {
										i: [
											[
												1.056,
												-1.923
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.405,
												-0.069
											],
											[
												0.116,
												-0.406
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.536,
												-0.022
											],
											[
												0.095,
												-0.478
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												2.279
											],
											[
												-2.399,
												2.462
											],
											[
												-3.362,
												0
											],
											[
												-2.395,
												-2.46
											],
											[
												0,
												0
											],
											[
												-0.291,
												0
											],
											[
												-0.203,
												0.209
											],
											[
												0,
												0
											],
											[
												-3.369,
												0
											],
											[
												-2.382,
												-2.442
											],
											[
												0.011,
												-3.481
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.235,
												-0.351
											],
											[
												-0.415,
												0.064
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.153,
												-0.461
											],
											[
												-0.489,
												0.03
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-1.075,
												-1.934
											],
											[
												-0.01,
												-3.47
											],
											[
												2.385,
												-2.442
											],
											[
												3.373,
												0
											],
											[
												0,
												0
											],
											[
												0.205,
												0.209
											],
											[
												0.288,
												0
											],
											[
												0,
												0
											],
											[
												2.386,
												-2.449
											],
											[
												3.373,
												0
											],
											[
												2.393,
												2.456
											],
											[
												0,
												2.266
											]
										],
										v: [
											[
												22.066,
												-2.154
											],
											[
												3.805,
												-2.154
											],
											[
												-0.181,
												-8.135
											],
											[
												-1.243,
												-8.602
											],
											[
												-2.113,
												-7.833
											],
											[
												-5.464,
												3.896
											],
											[
												-10.825,
												-12.186
											],
											[
												-11.913,
												-12.921
											],
											[
												-12.902,
												-12.057
											],
											[
												-14.883,
												-2.154
											],
											[
												-22.036,
												-2.154
											],
											[
												-23.693,
												-8.553
											],
											[
												-19.988,
												-17.751
											],
											[
												-11.075,
												-21.538
											],
											[
												-2.133,
												-17.727
											],
											[
												-0.758,
												-16.318
											],
											[
												0.015,
												-15.993
											],
											[
												0.784,
												-16.318
											],
											[
												2.143,
												-17.708
											],
											[
												11.073,
												-21.507
											],
											[
												19.996,
												-17.719
											],
											[
												23.692,
												-8.516
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 3",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "mm",
								mm: 1,
								nm: "Merge Paths 1",
								mn: "ADBE Vector Filter - Merge",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0,
										0.380000005984,
										0.573000021542,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										26,
										24.18
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 5,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: -2.4,
				op: 490.8,
				st: -2.4,
				bm: 0
			},
			{
				ddd: 0,
				ind: 6,
				ty: 4,
				nm: "other Outlines",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							435,
							60,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							28,
							28,
							0
						],
						ix: 1
					},
					s: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.5,
										0.5,
										0.5
									],
									y: [
										1,
										1,
										1
									]
								},
								o: {
									x: [
										0.5,
										0.5,
										0.5
									],
									y: [
										0,
										0,
										0
									]
								},
								t: 150,
								s: [
									0,
									0,
									100
								]
							},
							{
								t: 165.000390625,
								s: [
									100,
									100,
									100
								]
							}
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0.644,
												0
											],
											[
												0,
												-0.646
											],
											[
												0,
												0
											],
											[
												4.963,
												-5.192
											],
											[
												-0.366,
												-8.083
											],
											[
												-0.581,
												-0.054
											],
											[
												-0.133,
												0.567
											],
											[
												-3.864,
												0
											],
											[
												-0.042,
												-0.177
											],
											[
												-0.492,
												-0.049
											],
											[
												-0.21,
												0.45
											],
											[
												-4.086,
												0
											],
											[
												-0.48,
												-0.882
											],
											[
												0,
												0
											],
											[
												0.193,
												0
											],
											[
												0,
												1.458
											],
											[
												0.644,
												0
											],
											[
												0,
												-0.644
											],
											[
												-2.093,
												0
											],
											[
												0,
												2.518
											],
											[
												0,
												0
											],
											[
												-4.728,
												0
											],
											[
												-0.043,
												-0.172
											],
											[
												-0.592,
												0.071
											],
											[
												-0.011,
												0.588
											],
											[
												-4.739,
												0
											],
											[
												-0.005,
												-0.403
											],
											[
												-0.636,
												-0.016
											],
											[
												0,
												0
											],
											[
												-0.029,
												0.623
											],
											[
												5.389,
												5.639
											],
											[
												7.329,
												0.289
											],
											[
												0,
												0
											]
										],
										o: [
											[
												-0.646,
												0
											],
											[
												0,
												0
											],
											[
												-7.331,
												0.284
											],
											[
												-5.39,
												5.642
											],
											[
												0.028,
												0.581
											],
											[
												0.578,
												0.045
											],
											[
												0.042,
												-0.18
											],
											[
												3.873,
												0
											],
											[
												0.119,
												0.481
											],
											[
												0.474,
												0.04
											],
											[
												0.021,
												-0.044
											],
											[
												3.554,
												0
											],
											[
												0,
												0
											],
											[
												0,
												1.458
											],
											[
												-0.192,
												0
											],
											[
												0,
												-0.644
											],
											[
												-0.647,
												0
											],
											[
												0,
												2.518
											],
											[
												2.095,
												0
											],
											[
												0,
												0
											],
											[
												0.175,
												-0.613
											],
											[
												5.051,
												0
											],
											[
												0.133,
												0.572
											],
											[
												0.583,
												-0.06
											],
											[
												0.01,
												-0.415
											],
											[
												4.725,
												0
											],
											[
												-0.005,
												0.638
											],
											[
												0,
												0
											],
											[
												0.621,
												0
											],
											[
												0.366,
												-8.081
											],
											[
												-4.963,
												-5.196
											],
											[
												0,
												0
											],
											[
												0,
												-0.646
											]
										],
										v: [
											[
												0,
												-28
											],
											[
												-1.167,
												-26.833
											],
											[
												-1.167,
												-23.277
											],
											[
												-20.181,
												-14.854
											],
											[
												-27.97,
												6.429
											],
											[
												-26.91,
												7.534
											],
											[
												-25.667,
												6.641
											],
											[
												-20.743,
												2.333
											],
											[
												-15.759,
												6.65
											],
											[
												-14.74,
												7.534
											],
											[
												-13.568,
												6.869
											],
											[
												-7.315,
												2.333
											],
											[
												-1.167,
												6.666
											],
											[
												-1.167,
												24.164
											],
											[
												-3.047,
												25.667
											],
											[
												-4.926,
												24.164
											],
											[
												-6.092,
												22.997
											],
											[
												-7.259,
												24.164
											],
											[
												-3.047,
												28
											],
											[
												1.167,
												24.164
											],
											[
												1.167,
												6.526
											],
											[
												7.306,
												2.333
											],
											[
												13.479,
												6.643
											],
											[
												14.737,
												7.529
											],
											[
												15.78,
												6.391
											],
											[
												20.741,
												2.333
											],
											[
												25.637,
												6.367
											],
											[
												26.772,
												7.541
											],
											[
												26.803,
												7.541
											],
											[
												27.968,
												6.429
											],
											[
												20.179,
												-14.847
											],
											[
												1.167,
												-23.277
											],
											[
												1.167,
												-26.833
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ind: 1,
								ty: "sh",
								ix: 2,
								ks: {
									a: 0,
									k: {
										i: [
											[
												-4.783,
												-5.007
											],
											[
												-0.731,
												-5.528
											],
											[
												1.9,
												0
											],
											[
												0.985,
												-1.703
											],
											[
												3.469,
												0
											],
											[
												1.215,
												-1.918
											],
											[
												3.467,
												0
											],
											[
												1.313,
												-1.703
											],
											[
												3.213,
												0
											],
											[
												1.141,
												-1.071
											],
											[
												-3.943,
												4.128
											],
											[
												-7.142,
												0
											]
										],
										o: [
											[
												3.822,
												4.002
											],
											[
												-1.216,
												-0.898
											],
											[
												-3.491,
												0
											],
											[
												-1.314,
												-1.685
											],
											[
												-3.925,
												0
											],
											[
												-1.309,
												-1.713
											],
											[
												-3.435,
												0
											],
											[
												-1.097,
												-1.899
											],
											[
												-2.051,
												0
											],
											[
												0.644,
												-5.73
											],
											[
												4.781,
												-5.002
											],
											[
												7.143,
												0
											]
										],
										v: [
											[
												18.491,
												-13.237
											],
											[
												25.429,
												1.351
											],
											[
												20.741,
												0
											],
											[
												14.327,
												3.248
											],
											[
												7.306,
												0
											],
											[
												-0.182,
												3.913
											],
											[
												-7.315,
												0
											],
											[
												-14.408,
												3.861
											],
											[
												-20.743,
												0
											],
											[
												-25.494,
												1.871
											],
											[
												-18.494,
												-13.242
											],
											[
												-0.005,
												-21
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 2",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "mm",
								mm: 1,
								nm: "Merge Paths 1",
								mn: "ADBE Vector Filter - Merge",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0,
										0.380000005984,
										0.573000021542,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										28,
										28
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 6,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: -2.4,
				op: 490.8,
				st: -2.4,
				bm: 0
			}
		]
	}
];
var layers = [
	{
		ddd: 0,
		ind: 1,
		ty: 4,
		nm: "Shape Layer 2",
		td: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					60,
					60,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					2.606,
					1.606,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.5,
								0.5,
								0.5
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								16.667
							]
						},
						t: 10,
						s: [
							0,
							0,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 20,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								17.667
							]
						},
						o: {
							x: [
								0.5,
								0.5,
								0.5
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 180,
						s: [
							100,
							100,
							100
						]
					},
					{
						t: 190,
						s: [
							0,
							0,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								95.213,
								95.213
							],
							ix: 2
						},
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								2.606,
								1.606
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 691.2,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 2,
		ty: 0,
		nm: "ikony",
		tt: 1,
		refId: "comp_0",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.5,
							y: 0
						},
						t: 30,
						s: [
							320,
							60,
							0
						],
						to: [
							-13.167,
							0,
							0
						],
						ti: [
							13.167,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.5,
							y: 0.5
						},
						t: 45,
						s: [
							241,
							60,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.5,
							y: 0
						},
						t: 60,
						s: [
							241,
							60,
							0
						],
						to: [
							-13.333,
							0,
							0
						],
						ti: [
							13.333,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.5,
							y: 0.5
						},
						t: 75,
						s: [
							161,
							60,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.5,
							y: 0
						},
						t: 90,
						s: [
							161,
							60,
							0
						],
						to: [
							-13,
							0,
							0
						],
						ti: [
							13,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.5,
							y: 0.5
						},
						t: 105,
						s: [
							83,
							60,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.5,
							y: 0
						},
						t: 120,
						s: [
							83,
							60,
							0
						],
						to: [
							-13.333,
							0,
							0
						],
						ti: [
							13.333,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.5,
							y: 0.5
						},
						t: 135,
						s: [
							3,
							60,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.5,
							y: 0
						},
						t: 150,
						s: [
							3,
							60,
							0
						],
						to: [
							-12.833,
							0,
							0
						],
						ti: [
							12.833,
							0,
							0
						]
					},
					{
						t: 165,
						s: [
							-74,
							60,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					300,
					60,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		w: 600,
		h: 120,
		ip: 0,
		op: 450,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 3,
		ty: 4,
		nm: "Shape Layer 1",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					60,
					60,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					2.606,
					1.606,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.5,
								0.5,
								0.5
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								16.667
							]
						},
						t: 10,
						s: [
							0,
							0,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 20,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								17.667
							]
						},
						o: {
							x: [
								0.5,
								0.5,
								0.5
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 180,
						s: [
							100,
							100,
							100
						]
					},
					{
						t: 190,
						s: [
							0,
							0,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		ef: [
			{
				ty: 25,
				nm: "Drop Shadow",
				np: 8,
				mn: "ADBE Drop Shadow",
				ix: 1,
				en: 1,
				ef: [
					{
						ty: 2,
						nm: "Shadow Color",
						mn: "ADBE Drop Shadow-0001",
						ix: 1,
						v: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 1
						}
					},
					{
						ty: 0,
						nm: "Opacity",
						mn: "ADBE Drop Shadow-0002",
						ix: 2,
						v: {
							a: 0,
							k: 24.714,
							ix: 2
						}
					},
					{
						ty: 0,
						nm: "Direction",
						mn: "ADBE Drop Shadow-0003",
						ix: 3,
						v: {
							a: 0,
							k: 135,
							ix: 3
						}
					},
					{
						ty: 0,
						nm: "Distance",
						mn: "ADBE Drop Shadow-0004",
						ix: 4,
						v: {
							a: 0,
							k: 0,
							ix: 4
						}
					},
					{
						ty: 0,
						nm: "Softness",
						mn: "ADBE Drop Shadow-0005",
						ix: 5,
						v: {
							a: 0,
							k: 14.317,
							ix: 5
						}
					},
					{
						ty: 7,
						nm: "Shadow Only",
						mn: "ADBE Drop Shadow-0006",
						ix: 6,
						v: {
							a: 0,
							k: 0,
							ix: 6
						}
					}
				]
			}
		],
		shapes: [
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								95.213,
								95.213
							],
							ix: 2
						},
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								2.606,
								1.606
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 691.2,
		st: 0,
		bm: 0
	}
];
var markers = [
];
var Loader = {
	v: v,
	fr: fr,
	ip: ip,
	op: op,
	w: w,
	h: h,
	nm: nm,
	ddd: ddd,
	assets: assets,
	layers: layers,
	markers: markers
};

var AnimationLoaderLottie;
(function (AnimationLoaderLottie) {
    AnimationLoaderLottie["Loader"] = "Loader";
})(AnimationLoaderLottie || (AnimationLoaderLottie = {}));
const animationLoaderLottie = [AnimationLoaderLottie.Loader];

const animations = [
    {
        variant: AnimationLoaderLottie.Loader,
        animationData: Loader,
    },
];

const _c0$T = ["lottieElement"];
class AnimationLoaderComponent {
    constructor() {
        this.width = '100%';
    }
    ngOnChanges() {
        this.updateAnimation();
    }
    ngAfterViewInit() {
        this.updateAnimation();
    }
    ngOnDestroy() {
        lottie.destroy();
    }
    updateAnimation() {
        this.activeAnimation = animations.find((el) => {
            if (!this.name) {
                console.warn('Missing animation name');
                return;
            }
            if (el.variant.toLowerCase() === this.name.toLowerCase()) {
                return el;
            }
        });
        if (this.lottieElement?.nativeElement && this.activeAnimation && this.activeAnimation.animationData) {
            this.lottieElement.nativeElement.innerHTML = '';
            lottie.loadAnimation({
                container: this.lottieElement.nativeElement,
                renderer: 'svg',
                loop: true,
                autoplay: true,
                rendererSettings: {
                    filterSize: {
                        width: '200%',
                        height: '200%',
                        x: '-50%',
                        y: '-50%',
                    },
                },
                animationData: this.activeAnimation.animationData,
            });
        }
    }
}
AnimationLoaderComponent.ɵfac = function AnimationLoaderComponent_Factory(t) { return new (t || AnimationLoaderComponent)(); };
AnimationLoaderComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AnimationLoaderComponent, selectors: [["cpc-animation-loader"]], viewQuery: function AnimationLoaderComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$T, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.lottieElement = _t.first);
    } }, inputs: { name: "name", width: "width" }, features: [i0.ɵɵNgOnChangesFeature], decls: 2, vars: 2, consts: [[1, "cpc-animation-loader"], ["lottieElement", ""]], template: function AnimationLoaderComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "div", 0, 1);
    } if (rf & 2) {
        i0.ɵɵstyleProp("width", ctx.width);
    } }, encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AnimationLoaderComponent, [{
        type: Component,
        args: [{ selector: 'cpc-animation-loader', encapsulation: ViewEncapsulation.None, template: "<div class=\"cpc-animation-loader\" #lottieElement [style.width]=\"width\"></div>\r\n" }]
    }], null, { name: [{
            type: Input
        }], width: [{
            type: Input
        }], lottieElement: [{
            type: ViewChild,
            args: ['lottieElement', { static: false }]
        }] }); })();

const clamp = (value, min, max) => Math.min(Math.max(min, value), max);

// eslint-disable-next-line no-magic-numbers
const isWholeNumber = (value) => value % 1 === 0;

const WHOLE_NUMBER_MINIMUM_FRACTION_DIGITS = 0;
const DEFAULT_MINIMUM_FRACTION_DIGITS = 2;
const formatCurrency = (value, country, currency, showCurrency = true) => {
    if (!value) {
        return '';
    }
    const formattedValue = new Intl.NumberFormat(country, {
        style: 'currency',
        currency,
        minimumFractionDigits: isWholeNumber(value) ? WHOLE_NUMBER_MINIMUM_FRACTION_DIGITS : DEFAULT_MINIMUM_FRACTION_DIGITS,
    }).format(value);
    if (showCurrency) {
        return formattedValue;
    }
    const formattedValueNumberValueOnly = formattedValue.replace(/[^0-9|\s|,.|-]/gi, '').trim();
    return formattedValueNumberValueOnly;
};

const differenceBetweenLengthAndIndex = -1;
const nullReturn = -1;
const lengthToIndex = (value) => {
    if (typeof value === 'number') {
        return value + differenceBetweenLengthAndIndex;
    }
    return value ? value.length + differenceBetweenLengthAndIndex : nullReturn;
};

const FIRST_ENTRY_INDEX = 0;
const DEFAULT_TOTAL = 12;
const createTemplate = (total, rowWidth = DEFAULT_TOTAL) => {
    const rows = [];
    const inline = [];
    let inRow = 0;
    total.forEach((value, index) => {
        if (inRow === FIRST_ENTRY_INDEX && index === FIRST_ENTRY_INDEX) {
            rows.push([]);
        }
        if (inRow + value <= rowWidth) {
            rows[lengthToIndex(rows)].push(value);
            inRow += value;
        }
        else {
            rows.push([value]);
            inRow = value;
        }
        inline.push({ index, value, row: rows.length, col: rows[lengthToIndex(rows)].length });
    });
    return { template: rows, inline };
};

const set = (element, name, value) => {
    element.style.setProperty(`--${name}`, value);
};
const get = (element, name) => element.style.getPropertyValue(`--${name}`);
const cssVariables = {
    set,
    get,
};

const TOP_ROW = 1;
const FIRST_COL = 1;
const boolToString = (value) => (value ? '1' : '0');
const setBorders = (value, index, { inline }) => {
    const item = inline.find(({ index: inlineIndex }) => inlineIndex === index);
    if (!item) {
        throw new TypeError('Something went wrong');
    }
    const isTopRow = item.row === TOP_ROW;
    const isFirstInRow = item.col === FIRST_COL;
    const values = {
        top: !isTopRow,
        right: false,
        bottom: false,
        left: !isFirstInRow,
    };
    return `${boolToString(values.top)}${boolToString(values.right)}${boolToString(values.bottom)}${boolToString(values.left)}`;
};

/**
 * blurRefChildren
 * This functions perform blur action on each children of Angular Reference
 *
 * @param  {ElementRef<HTMLElement>} ref Angular reference object
 * @param  {boolean} recursive Blur every children of children (Defaults: False)
 * @return {void}      Components are blurred
 */
const blurRecursive = (htmlElements) => Array.from(htmlElements).forEach((child) => {
    child.blur();
    blurRecursive(child.children);
});
var blurRefChildren = (ref, recursive = false) => {
    const { nativeElement: { children }, } = ref;
    Array.from(children).forEach((child) => {
        child.blur();
        if (recursive) {
            blurRecursive(child.children);
        }
    });
};

var AngularAnimationsTypes;
(function (AngularAnimationsTypes) {
    AngularAnimationsTypes["SLIDE"] = "slide";
    AngularAnimationsTypes["SCALE"] = "scale";
    AngularAnimationsTypes["SLIDE_OR_SCALE"] = "slide-or-scale";
})(AngularAnimationsTypes || (AngularAnimationsTypes = {}));
const cpcScaleAnimation = (animationSpeed = 250) => trigger('cpcScaleAnimation', [
    transition(':enter', [style({ transform: 'scale(0)' }), animate(`${animationSpeed}ms ease-in`)]),
    transition(':leave', [style({ transform: 'scale(1)' }), animate(`${animationSpeed}ms ease-out`, style({ transform: 'scale(0)' }))]),
]);
const cpcSlideAnimation = (animationSpeed = 500, opacitySpeed = 500) => trigger('cpcSlideAnimation', [
    transition(':enter', [
        style({ height: '0', opacity: 0 }),
        group([animate(animationSpeed, style({ height: '*' })), animate(`${opacitySpeed}ms ease-in-out`, style({ opacity: '1' }))]),
    ]),
    transition(':leave', [
        style({ height: '*', opacity: 1 }),
        group([animate(animationSpeed, style({ height: 0 })), animate(`${opacitySpeed}ms ease-in-out`, style({ opacity: '0' }))]),
    ]),
    state('true', style({ height: '*', opacity: 1 })),
    state('false', style({ height: '0', opacity: 0 })),
    transition('false => true', [
        style({ height: '0', opacity: 0 }),
        group([animate(animationSpeed, style({ height: '*' })), animate(`${opacitySpeed}ms ease-in-out`, style({ opacity: '1' }))]),
    ]),
    transition('true => false', [
        style({ height: '*', opacity: 1 }),
        group([animate(animationSpeed, style({ height: 0 })), animate(`${opacitySpeed}ms ease-in-out`, style({ opacity: '0' }))]),
    ]),
]);
const cpcSlideOrScaleAnimation = (slideSpeed = 500, scaleSpeed = 250) => trigger('cpcSlideOrScaleAnimation', [
    state('slide', style({ height: '*', opacity: 1 })),
    transition('void => slide', [
        style({ height: '0', opacity: 0 }),
        group([animate(slideSpeed / 2, style({ height: '*' })), animate(`${slideSpeed}ms ease-in-out`, style({ opacity: '1' }))]),
    ]),
    transition('slide => void', [
        style({ height: '*', opacity: 1 }),
        group([animate(slideSpeed / 2, style({ height: 0 })), animate(`${slideSpeed}ms ease-in-out`, style({ opacity: '0' }))]),
    ]),
    state('scale', style({ transform: 'scale(1)' })),
    transition('void => scale', [style({ transform: 'scale(0)' }), animate(`${scaleSpeed}ms ease-in`)]),
    transition('scale => void', [style({ transform: 'scale(1)' }), animate(`${scaleSpeed}ms ease-out`, style({ transform: 'scale(0)' }))]),
]);
const animationBuilder = (animationName, animationSpeed, animationSpeed2) => {
    switch (animationName) {
        case AngularAnimationsTypes.SLIDE:
            return cpcSlideAnimation(animationSpeed, animationSpeed2);
        case AngularAnimationsTypes.SCALE:
            return cpcScaleAnimation(animationSpeed);
        case AngularAnimationsTypes.SLIDE_OR_SCALE:
            return cpcSlideOrScaleAnimation(animationSpeed, animationSpeed2);
        default:
            return null;
    }
};

var Breakpoints;
(function (Breakpoints) {
    Breakpoints["tiny"] = "0px";
    Breakpoints["small"] = "320px";
    Breakpoints["medium"] = "704px";
    Breakpoints["large"] = "992px";
    Breakpoints["xlarge"] = "1280px";
    Breakpoints["2xlarge"] = "1472px";
    Breakpoints["3xlarge"] = "1760px";
})(Breakpoints || (Breakpoints = {}));
var WidthExpression;
(function (WidthExpression) {
    WidthExpression["minWidth"] = "min-width";
    WidthExpression["maxWidth"] = "max-width";
})(WidthExpression || (WidthExpression = {}));
const setMatchMedia = (breakpoint, widthExpression = WidthExpression.minWidth) => {
    if (!window) {
        return null;
    }
    return window.matchMedia(`(${widthExpression}: ${breakpoint})`);
};

const prevSlide = (chartContainer, customOffset) => {
    const chartContainerElem = chartContainer.nativeElement;
    const currentScrollLeft = chartContainerElem.scrollLeft;
    const scrollOffset = customOffset || 100;
    chartContainerElem.scrollTo({
        left: currentScrollLeft - scrollOffset,
        behavior: 'smooth',
    });
};
const nextSlide = (chartContainer, customOffset) => {
    const chartContainerElem = chartContainer.nativeElement;
    const currentScrollLeft = chartContainerElem.scrollLeft;
    const scrollOffset = customOffset || 100;
    chartContainerElem.scrollTo({
        left: currentScrollLeft + scrollOffset,
        behavior: 'smooth',
    });
};
const scrollTo = (chartContainer, customOffset) => {
    const chartContainerElem = chartContainer.nativeElement;
    const currentScrollLeft = chartContainerElem.scrollLeft;
    const scrollOffset = customOffset || 100;
    chartContainerElem.scrollTo({
        left: currentScrollLeft + scrollOffset,
        behavior: 'smooth',
    });
};

const DEFAULT_MIN_VALUE = 1;
const INTEGER_FIX = 1;
const randomNumber = (max, min = DEFAULT_MIN_VALUE) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + INTEGER_FIX)) + min;
};

const randomString = (length, characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789') => {
    const result = Array(length)
        .fill('')
        .map(() => characters.charAt(randomNumber(lengthToIndex(characters))));
    return result.join('');
};

const MIN_VISIBILITY = 0;
const INIT_SIZE$1 = 0;
const INCREASE_SIZE = 1;
class BackdropService {
    constructor() {
        this.visibilityCount$ = new BehaviorSubject(INIT_SIZE$1);
    }
    getVisibility() {
        return this.visibilityCount$.pipe(map((visibilityCount) => visibilityCount > MIN_VISIBILITY));
    }
    openBackdrop() {
        const visibilityCount = clamp(this.visibilityCount$.value + INCREASE_SIZE, INIT_SIZE$1, Infinity);
        this.visibilityCount$.next(visibilityCount);
    }
    closeBackdrop() {
        const visibilityCount = clamp(this.visibilityCount$.value - INCREASE_SIZE, INIT_SIZE$1, Infinity);
        this.visibilityCount$.next(visibilityCount);
    }
}
BackdropService.ɵfac = function BackdropService_Factory(t) { return new (t || BackdropService)(); };
BackdropService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: BackdropService, factory: BackdropService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BackdropService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], null, null); })();

function BackdropComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 1);
} }
class BackdropComponent {
    constructor(backdropService) {
        this.backdropVisibility = backdropService.getVisibility();
    }
}
BackdropComponent.ɵfac = function BackdropComponent_Factory(t) { return new (t || BackdropComponent)(i0.ɵɵdirectiveInject(BackdropService)); };
BackdropComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: BackdropComponent, selectors: [["cpc-backdrop"]], decls: 2, vars: 3, consts: [["class", "cpc-backdrop", 4, "ngIf"], [1, "cpc-backdrop"]], template: function BackdropComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, BackdropComponent_div_0_Template, 1, 0, "div", 0);
        i0.ɵɵpipe(1, "async");
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.backdropVisibility));
    } }, dependencies: [i1.NgIf, i1.AsyncPipe], styles: [".cpc-backdrop[_ngcontent-%COMP%]{position:fixed;top:0;left:0;z-index:989;display:block;width:100%;height:100%;background:var(--cpc-colors-dark-opacity)}@media screen and (min-width: 704px){.cpc-backdrop[_ngcontent-%COMP%]{display:none!important}}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BackdropComponent, [{
        type: Component,
        args: [{ selector: 'cpc-backdrop', template: "<div *ngIf=\"backdropVisibility | async\" class='cpc-backdrop'></div>\r\n", styles: [".cpc-backdrop{position:fixed;top:0;left:0;z-index:989;display:block;width:100%;height:100%;background:var(--cpc-colors-dark-opacity)}@media screen and (min-width: 704px){.cpc-backdrop{display:none!important}}\n"] }]
    }], function () { return [{ type: BackdropService }]; }, null); })();

const _c0$S = ["badge"];
const _c1$w = function (a0, a1, a2) { return { "cpc-badge--rounded": a0, "cpc-badge--bordered": a1, "cpc-badge--min-content": a2 }; };
const _c2$c = ["*"];
const DEFAULT_OFFSET_HEIGHT = 24;
var CpcBadgeVariants;
(function (CpcBadgeVariants) {
    CpcBadgeVariants["Default"] = "default";
    CpcBadgeVariants["Warning"] = "warning";
    CpcBadgeVariants["Danger"] = "danger";
    CpcBadgeVariants["Success"] = "success";
    CpcBadgeVariants["Important"] = "important";
    CpcBadgeVariants["Inactive"] = "inactive";
})(CpcBadgeVariants || (CpcBadgeVariants = {}));
var CpcBadgeSizes;
(function (CpcBadgeSizes) {
    CpcBadgeSizes["Small"] = "small";
    CpcBadgeSizes["Medium"] = "medium";
})(CpcBadgeSizes || (CpcBadgeSizes = {}));
class BadgeComponent {
    constructor(cdr) {
        this.cdr = cdr;
        this.variant = CpcBadgeVariants.Default;
        this.size = CpcBadgeSizes.Small;
        this.rounded = true;
        this.bordered = false;
    }
    ngAfterViewInit() {
        this.detectWrap();
        this.startMutationObserver();
    }
    ngOnDestroy() {
        this.observer.disconnect();
    }
    startMutationObserver() {
        this.observer = new MutationObserver((mutations) => mutations.forEach(() => {
            this.detectWrap();
        }));
        this.observer.observe(this.badge.nativeElement, { characterData: true, subtree: true });
    }
    detectWrap() {
        if (this.badge.nativeElement.offsetHeight > DEFAULT_OFFSET_HEIGHT) {
            this.moreTextThanLine = true;
        }
        else {
            this.moreTextThanLine = false;
        }
        this.cdr.detectChanges();
    }
}
BadgeComponent.ɵfac = function BadgeComponent_Factory(t) { return new (t || BadgeComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
BadgeComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: BadgeComponent, selectors: [["cpc-badge"]], viewQuery: function BadgeComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$S, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.badge = _t.first);
    } }, inputs: { variant: "variant", size: "size", rounded: "rounded", bordered: "bordered" }, ngContentSelectors: _c2$c, decls: 3, vars: 9, consts: [[3, "ngClass"], ["badge", ""]], template: function BadgeComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div", 0, 1);
        i0.ɵɵprojection(2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵclassMapInterpolate2("cpc-badge cpc-badge--variant-", ctx.variant, " cpc-badge--size-", ctx.size, "");
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(5, _c1$w, ctx.rounded, ctx.bordered, ctx.moreTextThanLine));
    } }, dependencies: [i1.NgClass], styles: [".cpc-badge{align-items:center;justify-content:center;flex-direction:row;flex-wrap:nowrap;display:inline-flex;padding:4px 16px;color:var(--cpc-colors-text);line-height:1;background:var(--cpc-badge-background);border-radius:4px;--icon-size: 16px}.cpc-badge.cpc-badge--min-content{width:min-content}.cpc-badge.cpc-badge--variant-success{color:var(--cpc-badge-text);background:var(--cpc-badge-success)}.cpc-badge.cpc-badge--variant-warning{color:var(--cpc-colors-text);background:var(--cpc-badge-warning)}.cpc-badge.cpc-badge--variant-danger{color:var(--cpc-badge-text-danger);background:var(--cpc-badge-danger)}.cpc-badge.cpc-badge--variant-important{color:var(--cpc-colors-text);background:var(--cpc-badge-important)}.cpc-badge.cpc-badge--variant-inactive{color:var(--cpc-badge-text-inactive);background:var(--cpc-badge-inactive)}.cpc-badge.cpc-badge--size-medium{padding:8px 24px;font-size:14px}.cpc-badge.cpc-badge--rounded{border-radius:12px}.cpc-badge.cpc-badge--bordered{border:solid 1px var(--cpc-colors-sonic-silver)}.cpc-badge cpc-icon{margin-left:4px}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BadgeComponent, [{
        type: Component,
        args: [{ selector: 'cpc-badge', encapsulation: ViewEncapsulation.None, template: "<div\r\n  #badge\r\n  class=\"cpc-badge cpc-badge--variant-{{variant}} cpc-badge--size-{{size}}\"\r\n  [ngClass]=\"{ 'cpc-badge--rounded': rounded, 'cpc-badge--bordered': bordered, 'cpc-badge--min-content': moreTextThanLine }\"\r\n>\r\n  <ng-content></ng-content>\r\n</div>\r\n", styles: [".cpc-badge{align-items:center;justify-content:center;flex-direction:row;flex-wrap:nowrap;display:inline-flex;padding:4px 16px;color:var(--cpc-colors-text);line-height:1;background:var(--cpc-badge-background);border-radius:4px;--icon-size: 16px}.cpc-badge.cpc-badge--min-content{width:min-content}.cpc-badge.cpc-badge--variant-success{color:var(--cpc-badge-text);background:var(--cpc-badge-success)}.cpc-badge.cpc-badge--variant-warning{color:var(--cpc-colors-text);background:var(--cpc-badge-warning)}.cpc-badge.cpc-badge--variant-danger{color:var(--cpc-badge-text-danger);background:var(--cpc-badge-danger)}.cpc-badge.cpc-badge--variant-important{color:var(--cpc-colors-text);background:var(--cpc-badge-important)}.cpc-badge.cpc-badge--variant-inactive{color:var(--cpc-badge-text-inactive);background:var(--cpc-badge-inactive)}.cpc-badge.cpc-badge--size-medium{padding:8px 24px;font-size:14px}.cpc-badge.cpc-badge--rounded{border-radius:12px}.cpc-badge.cpc-badge--bordered{border:solid 1px var(--cpc-colors-sonic-silver)}.cpc-badge cpc-icon{margin-left:4px}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }]; }, { variant: [{
            type: Input
        }], size: [{
            type: Input
        }], rounded: [{
            type: Input
        }], bordered: [{
            type: Input
        }], badge: [{
            type: ViewChild,
            args: ['badge']
        }] }); })();

const _c0$R = function (a0, a1) { return { "cpc-button-no-horizontal-margin": a0, "cpc-button-no-vertical-margin": a1 }; };
const _c1$v = ["*"];
class ButtonComponent {
    constructor() {
        this.mode = 'primary';
        this.size = 'normal';
        this.block = false;
        this.borderStyle = 'rounded';
        this.noHorizontalMargin = false;
        this.noVerticalMargin = false;
        this.disabled = false;
        this.buttonClassNames = 'cpc-button';
    }
    ngOnInit() {
        this.updateClassName();
    }
    ngOnChanges() {
        this.updateClassName();
    }
    updateClassName() {
        const classNames = ['cpc-button'];
        classNames.push(`cpc-button--variant-${this.mode}`);
        classNames.push(`cpc-button--size-${this.size}`);
        classNames.push(`cpc-button--style-${this.borderStyle || 'rounded'}`);
        if (this.block) {
            classNames.push(`cpc-button--block`);
        }
        if (this.disabled) {
            classNames.push(`cpc--disabled`);
        }
        this.buttonClassNames = classNames.join(' ');
    }
}
ButtonComponent.ɵfac = function ButtonComponent_Factory(t) { return new (t || ButtonComponent)(); };
ButtonComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ButtonComponent, selectors: [["cpc-button"]], inputs: { mode: "mode", size: "size", block: "block", borderStyle: "borderStyle", noHorizontalMargin: "noHorizontalMargin", noVerticalMargin: "noVerticalMargin", disabled: "disabled" }, features: [i0.ɵɵNgOnChangesFeature], ngContentSelectors: _c1$v, decls: 4, vars: 7, consts: [[3, "ngClass", "disabled", "mouseup"], ["buttonElement", ""], [1, "cpc-button-content"]], template: function ButtonComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "button", 0, 1);
        i0.ɵɵlistener("mouseup", function ButtonComponent_Template_button_mouseup_0_listener() { i0.ɵɵrestoreView(_r1); const _r0 = i0.ɵɵreference(1); return i0.ɵɵresetView(_r0.blur()); });
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵprojection(3);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵclassMap(ctx.buttonClassNames);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(4, _c0$R, ctx.noHorizontalMargin, ctx.noVerticalMargin))("disabled", ctx.disabled);
    } }, dependencies: [i1.NgClass], styles: [".cpc-button{width:auto;min-height:var(--button-medium-height);margin:0 8px 16px;padding:calc(12px - var(--button-border-width)) calc(32px - var(--button-border-width));overflow:visible;font-weight:var(--button-medium-font-weight);font-size:var(--button-medium-font-size);line-height:var(--button-medium-line-height);letter-spacing:var(--button-medium-letter-spacing);vertical-align:middle;-webkit-hyphens:none;hyphens:none;border:var(--button-border-width) solid transparent;cursor:pointer;transition:background-color .2s ease,border-color .2s ease,color .2s ease,box-shadow .2s ease;-webkit-user-select:none;user-select:none;transition:all 125ms linear}.cpc-button:focus,.cpc-button.pseudo-states--focus{outline:0;box-shadow:var(--focus-box-shadow, 0 0 0 2px #fff, 0 0 0 6px #009de6)}.cpc-button:disabled,.cpc-button.cpc-button--disabled{cursor:not-allowed}.cpc-button.cpc-button--variant-primary{color:var(--button-primary-text-color);background-color:var(--button-primary-background-color);border-color:var(--button-primary-border-color)}.cpc-button.cpc-button--variant-primary:active,.cpc-button.cpc-button--variant-primary.pseudo-states--active{color:var(--button-primary-active-text-color);background-color:var(--button-primary-active-background-color);border-color:var(--button-primary-active-border-color)}.cpc-button.cpc-button--variant-primary:hover,.cpc-button.cpc-button--variant-primary.pseudo-states--hover{color:var(--button-primary-hover-text-color);background-color:var(--button-primary-hover-background-color);border-color:var(--button-primary-hover-border-color)}.cpc-button.cpc-button--variant-primary:hover:not(:disabled):not(:active),.cpc-button.cpc-button--variant-primary.pseudo-states--hover{color:var(--button-primary-hover-text-color);background-color:var(--button-primary-hover-background-color);border-color:var(--button-primary-hover-border-color)}.cpc-button.cpc-button--variant-primary:disabled,.cpc-button.cpc-button--variant-primary.cpc-button--disabled{color:var(--button-primary-disabled-text-color);background-color:var(--button-primary-disabled-background-color);border-color:var(--button-primary-disabled-border-color)}.cpc-button.cpc-button--variant-secondary{color:var(--button-secondary-text-color);background-color:var(--button-secondary-background-color);border-color:var(--button-secondary-border-color)}.cpc-button.cpc-button--variant-secondary:active,.cpc-button.cpc-button--variant-secondary.pseudo-states--active{color:var(--button-secondary-active-text-color);background-color:var(--button-secondary-active-background-color);border-color:var(--button-secondaryactiver-border-color)}.cpc-button.cpc-button--variant-secondary:hover,.cpc-button.cpc-button--variant-secondary.pseudo-states--hover{color:var(--button-secondary-hover-text-color);background-color:var(--button-secondary-hover-background-color);border-color:var(--button-secondary-hover-border-color)}.cpc-button.cpc-button--variant-secondary:hover:not(:disabled):not(:active),.cpc-button.cpc-button--variant-secondary.pseudo-states--hover{color:var(--button-secondary-hover-text-color);background-color:var(--button-secondary-hover-background-color);border-color:var(--button-secondary-hover-border-color)}.cpc-button.cpc-button--variant-secondary:disabled,.cpc-button.cpc-button--variant-secondary.cpc-button--disabled{color:var(--button-secondary-disabled-text-color);background-color:var(--button-secondary-disabled-background-color);border-color:var(--button-secondary-disabled-border-color)}.cpc-button.cpc-button--variant-tertiary{color:var(--button-tertiary-text-color);background-color:var(--button-tertiary-background-color);border-color:var(--button-tertiary-border-color)}.cpc-button.cpc-button--variant-tertiary:active,.cpc-button.cpc-button--variant-tertiary.pseudo-states--active{color:var(--button-tertiary-active-text-color);background-color:var(--button-tertiary-active-background-color);border-color:var(--button-tertiaryactiver-border-color)}.cpc-button.cpc-button--variant-tertiary:hover,.cpc-button.cpc-button--variant-tertiary.pseudo-states--hover{color:var(--button-tertiary-hover-text-color);background-color:var(--button-tertiary-hover-background-color);border-color:var(--button-tertiary-hover-border-color)}.cpc-button.cpc-button--variant-tertiary:hover:not(:disabled):not(:active),.cpc-button.cpc-button--variant-tertiary.pseudo-states--hover{color:var(--button-tertiary-hover-text-color);background-color:var(--button-tertiary-hover-background-color);border-color:var(--button-tertiary-hover-border-color)}.cpc-button.cpc-button--variant-tertiary:disabled,.cpc-button.cpc-button--variant-tertiary.cpc-button--disabled{color:var(--button-tertiary-disabled-text-color, rgba(0, 97, 146, .4));background-color:var(--button-tertiary-disabled-background-color, transparent);border-color:var(--button-tertiary-disabled-border-color, transparent)}.cpc-button.cpc-button--variant-emphasis{color:var(--button-emphasis-text-color);background-color:var(--button-emphasis-background-color);border-color:var(--button-emphasis-border-color)}.cpc-button.cpc-button--variant-emphasis:active,.cpc-button.cpc-button--variant-emphasis.pseudo-states--active{color:var(--button-emphasis-active-text-color);background-color:var(--button-emphasis-active-background-color);border-color:var(--button-emphasis-active-border-color)}.cpc-button.cpc-button--variant-emphasis:hover,.cpc-button.cpc-button--variant-emphasis.pseudo-states--hover{color:var(--button-emphasis-hover-text-color);background-color:var(--button-emphasis-hover-background-color);border-color:var(--button-emphasis-hover-border-color)}.cpc-button.cpc-button--variant-emphasis:hover:not(:disabled):not(:active),.cpc-button.cpc-button--variant-emphasis.pseudo-states--hover{color:var(--button-emphasis-hover-text-color);background-color:var(--button-emphasis-hover-background-color);border-color:var(--button-emphasis-hover-border-color)}.cpc-button.cpc-button--variant-emphasis:disabled,.cpc-button.cpc-button--variant-emphasis.pseudo-states--disabled{color:var(--button-emphasis-disabled-text-color, rgba(255, 255, 255, .4));background-color:var(--button-emphasis-disabled-background-color, rgba(248, 98, 0, .4));border-color:var(--button-emphasis-disabled-border-color, transparent)}.cpc-button.cpc-button--variant-emphasis:disabled,.cpc-button.cpc-button--variant-emphasis.cpc--disabled,.cpc-button.cpc-button--variant-emphasis.pseudo-states--disabled{color:var(--button-emphasis-disabled-text-color, rgba(255, 255, 255, .4));background-color:var(--button-emphasis-disabled-background-color, rgba(248, 98, 0, .4));border-color:var(--button-emphasis-disabled-border-color, transparent)}.cpc-button.cpc-button--variant-cta{color:var(--button-cta-text-color);background-color:var(--button-cta-background-color);border-color:var(--button-cta-border-color)}.cpc-button.cpc-button--variant-cta:active,.cpc-button.cpc-button--variant-cta.pseudo-states--active{color:var(--button-cta-active-text-color);background-color:var(--button-cta-active-background-color);border-color:var(--button-cta-active-border-color)}.cpc-button.cpc-button--variant-cta:hover,.cpc-button.cpc-button--variant-cta.pseudo-states--hover{color:var(--button-cta-hover-text-color);background-color:var(--button-cta-hover-background-color);border-color:var(--button-cta-hover-border-color)}.cpc-button.cpc-button--variant-cta:hover:not(:disabled):not(:active),.cpc-button.cpc-button--variant-cta.pseudo-states--hover{color:var(--button-cta-hover-text-color);background-color:var(--button-cta-hover-background-color);border-color:var(--button-cta-hover-border-color)}.cpc-button.cpc-button--variant-cta:disabled,.cpc-button.cpc-button--variant-cta.pseudo-states--disabled{color:var(--button-cta-disabled-text-color);background-color:var(--button-cta-disabled-background-color);border-color:var(--button-cta-disabled-border-color)}.cpc-button.cpc-button--variant-cta:disabled,.cpc-button.cpc-button--variant-cta.cpc--disabled,.cpc-button.cpc-button--variant-cta.pseudo-states--disabled{color:var(--button-cta-disabled-text-color);background-color:var(--button-cta-disabled-background-color);border-color:var(--button-cta-disabled-border-color)}.cpc-button.cpc-button--size-x-small{display:inline-block;width:auto;min-height:var(--button-small-height);margin:0 4px 16px;padding:calc(4px - var(--button-border-width)) calc(4px - var(--button-border-width));font-weight:var(--button-small-font-weight);font-size:var(--button-small-font-size);line-height:var(--button-small-line-height);letter-spacing:var(--button-small-letter-spacing)}.cpc-button.cpc-button--size-small{display:inline-block;width:auto;min-height:var(--button-small-height);padding:calc(8px - var(--button-border-width)) calc(16px - var(--button-border-width));font-weight:var(--button-small-font-weight);font-size:var(--button-small-font-size);line-height:var(--button-small-line-height);letter-spacing:var(--button-small-letter-spacing)}.cpc-button.cpc-button--size-small-medium{display:inline-block;width:auto;min-height:var(--button-small-medium-height);padding:calc(8px - var(--button-border-width)) calc(24px - var(--button-border-width));font-weight:var(--button-small-medium-font-weight);font-size:var(--button-small-medium-font-size);line-height:var(--button-small-medium-line-height);letter-spacing:var(--button-small-medium-letter-spacing)}.cpc-button.cpc-button--size-large{min-height:var(--button-large-height);padding:calc(24px - var(--button-border-width)) calc(48px - var(--button-border-width));font-weight:var(--button-large-font-weight);font-size:var(--button-large-font-size);line-height:var(--button-large-line-height);letter-spacing:var(--button-large-letter-spacing)}.cpc-button.cpc-button--style-rounded{border-radius:var(--button-border-radius)}.cpc-button.cpc-button--style-circle{border-radius:1000px}.cpc-button.cpc-button--style-square{border-radius:0}.cpc-button.cpc-button--block{display:block;width:100%}.cpc-button .cpc-button-content{position:relative;display:inline-flex;align-items:center;justify-content:center;vertical-align:bottom}.cpc-button-no-horizontal-margin{margin-right:0!important;margin-left:0!important}.cpc-button-no-vertical-margin{margin-top:0!important;margin-bottom:0!important}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ButtonComponent, [{
        type: Component,
        args: [{ selector: 'cpc-button', encapsulation: ViewEncapsulation.None, template: "<button\r\n  #buttonElement\r\n  [class]=\"buttonClassNames\"\r\n  [ngClass]=\"{ 'cpc-button-no-horizontal-margin': noHorizontalMargin, 'cpc-button-no-vertical-margin': noVerticalMargin }\"\r\n  [disabled]=\"disabled\"\r\n  (mouseup)=\"buttonElement.blur()\"\r\n>\r\n  <div class=\"cpc-button-content\">\r\n    <ng-content></ng-content>\r\n  </div>\r\n</button>\r\n", styles: [".cpc-button{width:auto;min-height:var(--button-medium-height);margin:0 8px 16px;padding:calc(12px - var(--button-border-width)) calc(32px - var(--button-border-width));overflow:visible;font-weight:var(--button-medium-font-weight);font-size:var(--button-medium-font-size);line-height:var(--button-medium-line-height);letter-spacing:var(--button-medium-letter-spacing);vertical-align:middle;-webkit-hyphens:none;hyphens:none;border:var(--button-border-width) solid transparent;cursor:pointer;transition:background-color .2s ease,border-color .2s ease,color .2s ease,box-shadow .2s ease;-webkit-user-select:none;user-select:none;transition:all 125ms linear}.cpc-button:focus,.cpc-button.pseudo-states--focus{outline:0;box-shadow:var(--focus-box-shadow, 0 0 0 2px #fff, 0 0 0 6px #009de6)}.cpc-button:disabled,.cpc-button.cpc-button--disabled{cursor:not-allowed}.cpc-button.cpc-button--variant-primary{color:var(--button-primary-text-color);background-color:var(--button-primary-background-color);border-color:var(--button-primary-border-color)}.cpc-button.cpc-button--variant-primary:active,.cpc-button.cpc-button--variant-primary.pseudo-states--active{color:var(--button-primary-active-text-color);background-color:var(--button-primary-active-background-color);border-color:var(--button-primary-active-border-color)}.cpc-button.cpc-button--variant-primary:hover,.cpc-button.cpc-button--variant-primary.pseudo-states--hover{color:var(--button-primary-hover-text-color);background-color:var(--button-primary-hover-background-color);border-color:var(--button-primary-hover-border-color)}.cpc-button.cpc-button--variant-primary:hover:not(:disabled):not(:active),.cpc-button.cpc-button--variant-primary.pseudo-states--hover{color:var(--button-primary-hover-text-color);background-color:var(--button-primary-hover-background-color);border-color:var(--button-primary-hover-border-color)}.cpc-button.cpc-button--variant-primary:disabled,.cpc-button.cpc-button--variant-primary.cpc-button--disabled{color:var(--button-primary-disabled-text-color);background-color:var(--button-primary-disabled-background-color);border-color:var(--button-primary-disabled-border-color)}.cpc-button.cpc-button--variant-secondary{color:var(--button-secondary-text-color);background-color:var(--button-secondary-background-color);border-color:var(--button-secondary-border-color)}.cpc-button.cpc-button--variant-secondary:active,.cpc-button.cpc-button--variant-secondary.pseudo-states--active{color:var(--button-secondary-active-text-color);background-color:var(--button-secondary-active-background-color);border-color:var(--button-secondaryactiver-border-color)}.cpc-button.cpc-button--variant-secondary:hover,.cpc-button.cpc-button--variant-secondary.pseudo-states--hover{color:var(--button-secondary-hover-text-color);background-color:var(--button-secondary-hover-background-color);border-color:var(--button-secondary-hover-border-color)}.cpc-button.cpc-button--variant-secondary:hover:not(:disabled):not(:active),.cpc-button.cpc-button--variant-secondary.pseudo-states--hover{color:var(--button-secondary-hover-text-color);background-color:var(--button-secondary-hover-background-color);border-color:var(--button-secondary-hover-border-color)}.cpc-button.cpc-button--variant-secondary:disabled,.cpc-button.cpc-button--variant-secondary.cpc-button--disabled{color:var(--button-secondary-disabled-text-color);background-color:var(--button-secondary-disabled-background-color);border-color:var(--button-secondary-disabled-border-color)}.cpc-button.cpc-button--variant-tertiary{color:var(--button-tertiary-text-color);background-color:var(--button-tertiary-background-color);border-color:var(--button-tertiary-border-color)}.cpc-button.cpc-button--variant-tertiary:active,.cpc-button.cpc-button--variant-tertiary.pseudo-states--active{color:var(--button-tertiary-active-text-color);background-color:var(--button-tertiary-active-background-color);border-color:var(--button-tertiaryactiver-border-color)}.cpc-button.cpc-button--variant-tertiary:hover,.cpc-button.cpc-button--variant-tertiary.pseudo-states--hover{color:var(--button-tertiary-hover-text-color);background-color:var(--button-tertiary-hover-background-color);border-color:var(--button-tertiary-hover-border-color)}.cpc-button.cpc-button--variant-tertiary:hover:not(:disabled):not(:active),.cpc-button.cpc-button--variant-tertiary.pseudo-states--hover{color:var(--button-tertiary-hover-text-color);background-color:var(--button-tertiary-hover-background-color);border-color:var(--button-tertiary-hover-border-color)}.cpc-button.cpc-button--variant-tertiary:disabled,.cpc-button.cpc-button--variant-tertiary.cpc-button--disabled{color:var(--button-tertiary-disabled-text-color, rgba(0, 97, 146, .4));background-color:var(--button-tertiary-disabled-background-color, transparent);border-color:var(--button-tertiary-disabled-border-color, transparent)}.cpc-button.cpc-button--variant-emphasis{color:var(--button-emphasis-text-color);background-color:var(--button-emphasis-background-color);border-color:var(--button-emphasis-border-color)}.cpc-button.cpc-button--variant-emphasis:active,.cpc-button.cpc-button--variant-emphasis.pseudo-states--active{color:var(--button-emphasis-active-text-color);background-color:var(--button-emphasis-active-background-color);border-color:var(--button-emphasis-active-border-color)}.cpc-button.cpc-button--variant-emphasis:hover,.cpc-button.cpc-button--variant-emphasis.pseudo-states--hover{color:var(--button-emphasis-hover-text-color);background-color:var(--button-emphasis-hover-background-color);border-color:var(--button-emphasis-hover-border-color)}.cpc-button.cpc-button--variant-emphasis:hover:not(:disabled):not(:active),.cpc-button.cpc-button--variant-emphasis.pseudo-states--hover{color:var(--button-emphasis-hover-text-color);background-color:var(--button-emphasis-hover-background-color);border-color:var(--button-emphasis-hover-border-color)}.cpc-button.cpc-button--variant-emphasis:disabled,.cpc-button.cpc-button--variant-emphasis.pseudo-states--disabled{color:var(--button-emphasis-disabled-text-color, rgba(255, 255, 255, .4));background-color:var(--button-emphasis-disabled-background-color, rgba(248, 98, 0, .4));border-color:var(--button-emphasis-disabled-border-color, transparent)}.cpc-button.cpc-button--variant-emphasis:disabled,.cpc-button.cpc-button--variant-emphasis.cpc--disabled,.cpc-button.cpc-button--variant-emphasis.pseudo-states--disabled{color:var(--button-emphasis-disabled-text-color, rgba(255, 255, 255, .4));background-color:var(--button-emphasis-disabled-background-color, rgba(248, 98, 0, .4));border-color:var(--button-emphasis-disabled-border-color, transparent)}.cpc-button.cpc-button--variant-cta{color:var(--button-cta-text-color);background-color:var(--button-cta-background-color);border-color:var(--button-cta-border-color)}.cpc-button.cpc-button--variant-cta:active,.cpc-button.cpc-button--variant-cta.pseudo-states--active{color:var(--button-cta-active-text-color);background-color:var(--button-cta-active-background-color);border-color:var(--button-cta-active-border-color)}.cpc-button.cpc-button--variant-cta:hover,.cpc-button.cpc-button--variant-cta.pseudo-states--hover{color:var(--button-cta-hover-text-color);background-color:var(--button-cta-hover-background-color);border-color:var(--button-cta-hover-border-color)}.cpc-button.cpc-button--variant-cta:hover:not(:disabled):not(:active),.cpc-button.cpc-button--variant-cta.pseudo-states--hover{color:var(--button-cta-hover-text-color);background-color:var(--button-cta-hover-background-color);border-color:var(--button-cta-hover-border-color)}.cpc-button.cpc-button--variant-cta:disabled,.cpc-button.cpc-button--variant-cta.pseudo-states--disabled{color:var(--button-cta-disabled-text-color);background-color:var(--button-cta-disabled-background-color);border-color:var(--button-cta-disabled-border-color)}.cpc-button.cpc-button--variant-cta:disabled,.cpc-button.cpc-button--variant-cta.cpc--disabled,.cpc-button.cpc-button--variant-cta.pseudo-states--disabled{color:var(--button-cta-disabled-text-color);background-color:var(--button-cta-disabled-background-color);border-color:var(--button-cta-disabled-border-color)}.cpc-button.cpc-button--size-x-small{display:inline-block;width:auto;min-height:var(--button-small-height);margin:0 4px 16px;padding:calc(4px - var(--button-border-width)) calc(4px - var(--button-border-width));font-weight:var(--button-small-font-weight);font-size:var(--button-small-font-size);line-height:var(--button-small-line-height);letter-spacing:var(--button-small-letter-spacing)}.cpc-button.cpc-button--size-small{display:inline-block;width:auto;min-height:var(--button-small-height);padding:calc(8px - var(--button-border-width)) calc(16px - var(--button-border-width));font-weight:var(--button-small-font-weight);font-size:var(--button-small-font-size);line-height:var(--button-small-line-height);letter-spacing:var(--button-small-letter-spacing)}.cpc-button.cpc-button--size-small-medium{display:inline-block;width:auto;min-height:var(--button-small-medium-height);padding:calc(8px - var(--button-border-width)) calc(24px - var(--button-border-width));font-weight:var(--button-small-medium-font-weight);font-size:var(--button-small-medium-font-size);line-height:var(--button-small-medium-line-height);letter-spacing:var(--button-small-medium-letter-spacing)}.cpc-button.cpc-button--size-large{min-height:var(--button-large-height);padding:calc(24px - var(--button-border-width)) calc(48px - var(--button-border-width));font-weight:var(--button-large-font-weight);font-size:var(--button-large-font-size);line-height:var(--button-large-line-height);letter-spacing:var(--button-large-letter-spacing)}.cpc-button.cpc-button--style-rounded{border-radius:var(--button-border-radius)}.cpc-button.cpc-button--style-circle{border-radius:1000px}.cpc-button.cpc-button--style-square{border-radius:0}.cpc-button.cpc-button--block{display:block;width:100%}.cpc-button .cpc-button-content{position:relative;display:inline-flex;align-items:center;justify-content:center;vertical-align:bottom}.cpc-button-no-horizontal-margin{margin-right:0!important;margin-left:0!important}.cpc-button-no-vertical-margin{margin-top:0!important;margin-bottom:0!important}\n"] }]
    }], null, { mode: [{
            type: Input
        }], size: [{
            type: Input
        }], block: [{
            type: Input
        }], borderStyle: [{
            type: Input
        }], noHorizontalMargin: [{
            type: Input
        }], noVerticalMargin: [{
            type: Input
        }], disabled: [{
            type: Input
        }] }); })();

const INIT_SIZE = 0;
class CardsStoreService {
    constructor() {
        this.sizes = {};
        this.sizes$ = {};
    }
    getObservableSize(type = '') {
        if (!this.sizes[type]) {
            this.sizes[type] = [INIT_SIZE];
            this.sizes$[type] = new BehaviorSubject([INIT_SIZE]);
        }
        return this.sizes$[type].pipe(debounceTime(50), distinct(), map((values) => Math.max(...values)));
    }
    clearSize(type = '') {
        this.sizes[type] = [INIT_SIZE];
        this.sizes$[type].next(this.sizes[type]);
    }
    updateSize(size, type = '') {
        if (!this.sizes[type]) {
            this.sizes[type] = [INIT_SIZE];
            this.sizes$[type] = new BehaviorSubject([INIT_SIZE]);
        }
        this.sizes[type].push(size);
        this.sizes$[type].next(this.sizes[type]);
    }
}
CardsStoreService.ɵfac = function CardsStoreService_Factory(t) { return new (t || CardsStoreService)(); };
CardsStoreService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: CardsStoreService, factory: CardsStoreService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CardsStoreService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], null, null); })();

const _c0$Q = ["cardEntryContainer"];
const _c1$u = ["firstChild"];
const _c2$b = [[["", "title", ""]], "*"];
const _c3$4 = function (a0) { return { "cpc-card-entry_margin-bottom": a0 }; };
const _c4$3 = function (a0) { return { "cpc-card-entry_bigger": a0 }; };
const _c5$1 = function (a0) { return { "cpc-card-entry_smaller": a0 }; };
const _c6$1 = ["[title]", "*"];
const DEFAULT_TIMEOUT$6 = 1;
class CardEntryComponent {
    constructor(cdr, cardsStoreService) {
        this.cdr = cdr;
        this.cardsStoreService = cardsStoreService;
        this.leftButtonBigger = false;
        this.skipFromHeightAlignment = false;
        this.cardsStoreSize = this.cardsStoreService.getObservableSize(this.type);
    }
    windowResize() {
        this.sizeUpdater();
        this.cdr.detectChanges();
    }
    ngOnChanges() {
        this.cardsStoreSize = this.cardsStoreService.getObservableSize(this.type);
        this.sizeUpdater();
        this.cdr.detectChanges();
    }
    ngAfterViewInit() {
        this.sizeUpdater();
        this.cdr.detectChanges();
    }
    ngOnDestroy() {
        this.cardsStoreService.clearSize(this.type);
    }
    sizeUpdater() {
        const element = this.cardEntryContainer?.nativeElement;
        if (!element || this.skipFromHeightAlignment) {
            return;
        }
        this.cardsStoreService.clearSize(this.type);
        setTimeout(() => {
            this.cardsStoreService.updateSize(element.clientHeight, this.type);
        }, DEFAULT_TIMEOUT$6);
    }
}
CardEntryComponent.ɵfac = function CardEntryComponent_Factory(t) { return new (t || CardEntryComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(CardsStoreService)); };
CardEntryComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CardEntryComponent, selectors: [["cpc-card-entry"]], viewQuery: function CardEntryComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$Q, 5);
        i0.ɵɵviewQuery(_c1$u, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.cardEntryContainer = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.firstChild = _t.first);
    } }, hostBindings: function CardEntryComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("resize", function CardEntryComponent_resize_HostBindingHandler($event) { return ctx.windowResize($event); }, false, i0.ɵɵresolveWindow);
    } }, inputs: { footer: "footer", leftButtonBigger: "leftButtonBigger", type: "type", skipFromHeightAlignment: "skipFromHeightAlignment" }, features: [i0.ɵɵNgOnChangesFeature], ngContentSelectors: _c6$1, decls: 8, vars: 13, consts: [[1, "cpc-card-entry", 3, "ngClass"], ["cardEntryContainer", ""], [1, "cpc-card-entry_title", 3, "ngClass"], ["firstChild", ""], [1, "cpc-card-entry_content", 3, "ngClass"]], template: function CardEntryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef(_c2$b);
        i0.ɵɵelementStart(0, "div", 0, 1);
        i0.ɵɵpipe(2, "async");
        i0.ɵɵelementStart(3, "div", 2, 3);
        i0.ɵɵprojection(5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 4);
        i0.ɵɵprojection(7, 1);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵstyleProp("min-height", i0.ɵɵpipeBind1(2, 5, ctx.cardsStoreSize) + "px");
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c3$4, !ctx.footer));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c4$3, ctx.leftButtonBigger));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c5$1, ctx.leftButtonBigger));
    } }, dependencies: [i1.NgClass, i1.AsyncPipe], styles: [":host{display:block}.cpc-card-entry{width:100%;padding:2px 0;font-size:16px;font-family:var(--font-family);display:flex;align-content:space-between;justify-content:space-between;flex-direction:row;flex-wrap:inherit;line-height:1.5}@media screen and (min-width: 704px){.cpc-card-entry .cpc-button{padding:0!important}}.cpc-card-entry_margin-bottom{margin:0 0 10px}.cpc-card-entry .cpc-button{margin:0 5px;padding:calc(4px - var(--button-border-width)) calc(16px - var(--button-border-width))!important}.cpc-card-entry_title{width:45%;max-width:300px}.cpc-card-entry_content{width:45%;max-width:200px;text-align:end}.cpc-card-entry .cpc-button-content{gap:4px;word-break:break-word}.cpc-card-entry_bigger{width:55%!important}@media screen and (max-width: 360.98px){.cpc-card-entry_bigger{width:45%!important}}.cpc-card-entry_smaller{width:40%!important}.cpc-card-entry_smaller .cpc-button{padding:calc(4px - var(--button-border-width)) calc(4px - var(--button-border-width))!important}@media screen and (max-width: 360.98px){.cpc-card-entry_smaller{width:45%!important}}.cpc-card-entry_justify-center{justify-content:center!important}.cpc-card-entry_justify-center .cpc-card-entry_title:first-of-type:not(:last-of-type),.cpc-card-entry_justify-center .cpc-card-entry_content:first-of-type:not(:last-of-type){margin-bottom:10px!important}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CardEntryComponent, [{
        type: Component,
        args: [{ selector: 'cpc-card-entry', encapsulation: ViewEncapsulation.None, template: "<div\r\n  #cardEntryContainer\r\n  [ngClass]=\"{'cpc-card-entry_margin-bottom': !footer}\"\r\n  [style.minHeight]=\"(cardsStoreSize | async) + 'px'\"\r\n  class=\"cpc-card-entry\"\r\n>\r\n  <div\r\n    #firstChild\r\n    [ngClass]=\"{'cpc-card-entry_bigger' : leftButtonBigger}\"\r\n    class=\"cpc-card-entry_title\"\r\n  >\r\n    <ng-content select=\"[title]\"></ng-content>\r\n  </div>\r\n  <div\r\n    [ngClass]=\"{'cpc-card-entry_smaller' : leftButtonBigger}\"\r\n    class=\"cpc-card-entry_content\"\r\n  >\r\n    <ng-content></ng-content>\r\n  </div>\r\n</div>\r\n", styles: [":host{display:block}.cpc-card-entry{width:100%;padding:2px 0;font-size:16px;font-family:var(--font-family);display:flex;align-content:space-between;justify-content:space-between;flex-direction:row;flex-wrap:inherit;line-height:1.5}@media screen and (min-width: 704px){.cpc-card-entry .cpc-button{padding:0!important}}.cpc-card-entry_margin-bottom{margin:0 0 10px}.cpc-card-entry .cpc-button{margin:0 5px;padding:calc(4px - var(--button-border-width)) calc(16px - var(--button-border-width))!important}.cpc-card-entry_title{width:45%;max-width:300px}.cpc-card-entry_content{width:45%;max-width:200px;text-align:end}.cpc-card-entry .cpc-button-content{gap:4px;word-break:break-word}.cpc-card-entry_bigger{width:55%!important}@media screen and (max-width: 360.98px){.cpc-card-entry_bigger{width:45%!important}}.cpc-card-entry_smaller{width:40%!important}.cpc-card-entry_smaller .cpc-button{padding:calc(4px - var(--button-border-width)) calc(4px - var(--button-border-width))!important}@media screen and (max-width: 360.98px){.cpc-card-entry_smaller{width:45%!important}}.cpc-card-entry_justify-center{justify-content:center!important}.cpc-card-entry_justify-center .cpc-card-entry_title:first-of-type:not(:last-of-type),.cpc-card-entry_justify-center .cpc-card-entry_content:first-of-type:not(:last-of-type){margin-bottom:10px!important}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: CardsStoreService }]; }, { cardEntryContainer: [{
            type: ViewChild,
            args: ['cardEntryContainer']
        }], firstChild: [{
            type: ViewChild,
            args: ['firstChild']
        }], footer: [{
            type: Input
        }], leftButtonBigger: [{
            type: Input
        }], type: [{
            type: Input
        }], skipFromHeightAlignment: [{
            type: Input
        }], windowResize: [{
            type: HostListener,
            args: ['window:resize', ['$event']]
        }] }); })();

const _c0$P = ["cardContent"];
function CardComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0)(1, "div", 1, 2);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵprojection(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 3);
    i0.ɵɵprojection(6, 1);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵstyleProp("min-height", i0.ɵɵpipeBind1(3, 2, ctx_r0.cardContentSize) + "px");
} }
const _c1$t = ["*", [["", "footer", ""]]];
const _c2$a = ["*", "[footer]"];
const DEFAULT_TIMEOUT$5 = 0;
class CardComponent {
    constructor(cdr, cardsStoreService) {
        this.cdr = cdr;
        this.cardsStoreService = cardsStoreService;
        this.type = 'entries';
        this.cardContentSize = cardsStoreService.getObservableSize(this.type);
    }
    onResize() {
        this.cardContentSize = this.cardsStoreService.getObservableSize(this.type);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        debounce(() => this.sizeUpdater(), 250)();
    }
    ngOnChanges() {
        this.cardContentSize = this.cardsStoreService.getObservableSize(this.type);
        this.sizeUpdater();
        this.cdr.detectChanges();
    }
    ngAfterViewInit() {
        this.cardContentSize = this.cardsStoreService.getObservableSize(this.type);
        setTimeout(() => {
            this.sizeUpdater();
        }, DEFAULT_TIMEOUT$5);
    }
    sizeUpdater() {
        this.cardsStoreService.clearSize(this.type);
        const element = this.cardContent?.nativeElement;
        if (!element) {
            return;
        }
        setTimeout(() => {
            this.cardsStoreService.updateSize(element.clientHeight, this.type);
        }, DEFAULT_TIMEOUT$5);
    }
}
CardComponent.ɵfac = function CardComponent_Factory(t) { return new (t || CardComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(CardsStoreService)); };
CardComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CardComponent, selectors: [["cpc-card"]], viewQuery: function CardComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(TemplateRef, 5);
        i0.ɵɵviewQuery(_c0$P, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.template = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.cardContent = _t.first);
    } }, hostBindings: function CardComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("resize", function CardComponent_resize_HostBindingHandler($event) { return ctx.onResize($event); }, false, i0.ɵɵresolveWindow);
    } }, inputs: { type: "type" }, features: [i0.ɵɵNgOnChangesFeature], ngContentSelectors: _c2$a, decls: 1, vars: 0, consts: [[1, "cpc-card"], [1, "cpc-card_content"], ["cardContent", ""], [1, "cpc-card_footer"]], template: function CardComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef(_c1$t);
        i0.ɵɵtemplate(0, CardComponent_ng_template_0_Template, 7, 4, "ng-template");
    } }, dependencies: [i1.AsyncPipe], styles: [".cpc-card{display:flex;justify-content:center;align-items:center;flex-direction:column;flex-wrap:inherit;margin-bottom:24px;padding:0 24px;overflow:hidden}.cpc-card .cpc-card_content{display:flex;flex-direction:column;align-items:center;justify-content:flex-start;width:100%}.cpc-card .cpc-card_content>*{width:100%}.cpc-card .cpc-card_footer{align-items:center;flex-direction:column;flex-wrap:inherit;display:flex;justify-content:center;width:100%;margin-top:20px}.cpc-card .cpc-card_footer>*{width:100%}.cpc-card .cpc-card_footer .cpc-card-entry{display:flex;flex-flow:row wrap;flex-shrink:0;gap:5px;align-content:stretch;align-items:flex-start;justify-content:space-between}.cpc-card .cpc-card_footer button{width:100%;margin:0}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CardComponent, [{
        type: Component,
        args: [{ selector: 'cpc-card', encapsulation: ViewEncapsulation.None, template: "<ng-template>\r\n  <div class=\"cpc-card\">\r\n    <div\r\n      #cardContent\r\n      [style.minHeight]=\"(cardContentSize | async) + 'px'\"\r\n      class=\"cpc-card_content\">\r\n      <ng-content></ng-content>\r\n    </div>\r\n    <div class=\"cpc-card_footer\">\r\n      <ng-content select=\"[footer]\"></ng-content>\r\n    </div>\r\n  </div>\r\n</ng-template>\r\n", styles: [".cpc-card{display:flex;justify-content:center;align-items:center;flex-direction:column;flex-wrap:inherit;margin-bottom:24px;padding:0 24px;overflow:hidden}.cpc-card .cpc-card_content{display:flex;flex-direction:column;align-items:center;justify-content:flex-start;width:100%}.cpc-card .cpc-card_content>*{width:100%}.cpc-card .cpc-card_footer{align-items:center;flex-direction:column;flex-wrap:inherit;display:flex;justify-content:center;width:100%;margin-top:20px}.cpc-card .cpc-card_footer>*{width:100%}.cpc-card .cpc-card_footer .cpc-card-entry{display:flex;flex-flow:row wrap;flex-shrink:0;gap:5px;align-content:stretch;align-items:flex-start;justify-content:space-between}.cpc-card .cpc-card_footer button{width:100%;margin:0}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: CardsStoreService }]; }, { type: [{
            type: Input
        }], template: [{
            type: ViewChild,
            args: [TemplateRef]
        }], cardContent: [{
            type: ViewChild,
            args: ['cardContent']
        }], onResize: [{
            type: HostListener,
            args: ['window:resize', ['$event']]
        }] }); })();

const _c0$O = ["cardsGroup"];
const _c1$s = ["cardGroupContentElement"];
function CardGroupComponent_div_7_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function CardGroupComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, CardGroupComponent_div_7_ng_container_1_Template, 1, 0, "ng-container", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const card_r4 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("cpc-card-group_content-cards-item cpc-card-group_content-cards-item--", ctx_r2.items, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", card_r4.template);
} }
const _c2$9 = function (a0) { return { "cpc-card-group_pagination-page-dot--active": a0 }; };
function CardGroupComponent_div_8_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 14);
} if (rf & 2) {
    const index_r9 = ctx.index;
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c2$9, ctx_r7.currentPage === index_r9 + 1));
} }
const _c3$3 = function (a0) { return { "cpc-card-group_buttons-left-button--disabled": a0 }; };
const _c4$2 = function (a0) { return { "cpc-card-group_buttons-right-button--disabled": a0 }; };
const _c5 = function (a0) { return { width: a0 }; };
const _c6 = function () { return []; };
function CardGroupComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7)(1, "div", 8)(2, "cpc-button", 9);
    i0.ɵɵlistener("click", function CardGroupComponent_div_8_Template_cpc_button_click_2_listener() { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r10.prevSlide()); });
    i0.ɵɵelement(3, "cpc-icon", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "cpc-button", 11);
    i0.ɵɵlistener("click", function CardGroupComponent_div_8_Template_cpc_button_click_4_listener() { i0.ɵɵrestoreView(_r11); const ctx_r12 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r12.nextSlide()); });
    i0.ɵɵelement(5, "cpc-icon", 10);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 12);
    i0.ɵɵtemplate(7, CardGroupComponent_div_8_div_7_Template, 1, 3, "div", 13);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c3$3, ctx_r3.currentPage === 1))("noVerticalMargin", true)("noHorizontalMargin", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("icon", ctx_r3.ndbxIcons.ChevronLeft)("borderWidth", 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(14, _c4$2, ctx_r3.currentPage === ctx_r3.pages))("noVerticalMargin", true)("noHorizontalMargin", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("icon", ctx_r3.ndbxIcons.ChevronRight)("borderWidth", 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(16, _c5, ctx_r3.paginationWidth + "px"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpureFunction0(18, _c6).constructor(ctx_r3.pages));
} }
const _c7 = ["*"];
var CpcCardGroupVariants;
(function (CpcCardGroupVariants) {
    CpcCardGroupVariants["Default"] = "default";
    CpcCardGroupVariants["Inactive"] = "inactive";
})(CpcCardGroupVariants || (CpcCardGroupVariants = {}));
const DEFAULT_TIMEOUT$4 = 1;
class CardGroupComponent {
    constructor(cdr, cardsStoreService) {
        this.cdr = cdr;
        this.cardsStoreService = cardsStoreService;
        this.variant = CpcCardGroupVariants.Default;
        this.width = null;
        this.items = 1;
        this.currentPage = 1;
        this.pages = 1;
        this.paginationWidth = 24;
        this.isScrolling = false;
        this.uiScrolling = false;
        this.ndbxIcons = NdbxIcon;
        this.mediaQuery = setMatchMedia(Breakpoints.large);
        this.isMobile = !this.mediaQuery?.matches;
        this.lastScrollPosition = 0;
        this.cardsStoreSize = cardsStoreService.getObservableSize('group');
    }
    onScroll(event) {
        const offsetWidth = event.target.offsetWidth;
        const offsetMultiplier = this.currentPage - 1;
        const pageOffset = offsetWidth * offsetMultiplier;
        const scrollLeft = event.target.scrollLeft;
        const errorMargin = 10;
        this.isScrolling = true;
        this.setDirection(scrollLeft);
        this.lastScrollPosition = scrollLeft;
        clearTimeout(this.userScrolling);
        if (this.uiScrolling && this.isMobile) {
            this.userScrolling = setTimeout(() => {
                this.scrollToClosest(pageOffset, scrollLeft);
            }, 50);
        }
        if ((this.scrollingDirection === 'right' && pageOffset <= scrollLeft) ||
            (this.scrollingDirection === 'left' && pageOffset >= scrollLeft - errorMargin) ||
            this.pages === this.currentPage) {
            this.updatePage(scrollLeft, offsetWidth);
            this.isScrolling = false;
            this.uiScrolling = true;
        }
    }
    onResize() {
        this.updatePagination();
    }
    ngAfterViewInit() {
        this.updateCards();
        this.updatePagination();
        this.cdr.detectChanges();
    }
    ngAfterContentInit() {
        this.updateCards();
        this.cdr.detectChanges();
    }
    ngOnDestroy() {
        this.cardsStoreService.clearSize('group');
    }
    sizeUpdater() {
        this.cardsStoreService.clearSize('group');
        const element = this.cardGroupContentElement?.nativeElement;
        if (!element) {
            return;
        }
        setTimeout(() => {
            this.cardsStoreService.updateSize(element.clientHeight, 'group');
        }, DEFAULT_TIMEOUT$4);
    }
    updateCards() {
        this.cards = this.childrenCards.toArray();
        this.items = clamp(this.cards.length, 1, 3);
    }
    updatePagination() {
        setTimeout(() => {
            this.calculatePages();
            this.paginationWidth = this.pages * 24; // Size that makes same design
        }, 0);
    }
    updatePage(scrollLeft, offsetWidth) {
        if (this.isMobile) {
            this.currentPage = Math.round(scrollLeft / offsetWidth) + 1;
        }
    }
    scrollToClosest(pageOffset, scrollLeft) {
        if (pageOffset !== scrollLeft) {
            scrollTo(this.cardsGroup, pageOffset - scrollLeft);
        }
        this.uiScrolling = false;
    }
    setDirection(scrollLeft) {
        this.scrollingDirection = this.lastScrollPosition < scrollLeft ? 'right' : 'left';
    }
    calculatePages() {
        const pagesNotRound = this.cardsGroup.nativeElement.scrollWidth / this.cardsGroup.nativeElement.offsetWidth;
        const decimal = Number((pagesNotRound % 1).toFixed(2));
        if (decimal < 0.33) {
            this.pages = Math.round(this.cardsGroup.nativeElement.scrollWidth / this.cardsGroup.nativeElement.offsetWidth);
        }
        else {
            this.pages = Math.ceil(this.cardsGroup.nativeElement.scrollWidth / this.cardsGroup.nativeElement.offsetWidth);
        }
        this.paginate = this.pages > 1;
    }
    prevSlide() {
        if (this.isScrolling) {
            return;
        }
        prevSlide(this.cardsGroup, this.cardsGroup.nativeElement.offsetWidth);
        if (this.currentPage !== 1) {
            this.currentPage -= 1;
        }
    }
    nextSlide() {
        if (this.isScrolling) {
            return;
        }
        nextSlide(this.cardsGroup, this.cardsGroup.nativeElement.offsetWidth);
        if (this.currentPage !== this.pages) {
            this.currentPage += 1;
        }
    }
}
CardGroupComponent.ɵfac = function CardGroupComponent_Factory(t) { return new (t || CardGroupComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(CardsStoreService)); };
CardGroupComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CardGroupComponent, selectors: [["cpc-card-group"]], contentQueries: function CardGroupComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        i0.ɵɵcontentQuery(dirIndex, CardComponent, 4);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.childrenCards = _t);
    } }, viewQuery: function CardGroupComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$O, 5);
        i0.ɵɵviewQuery(_c1$s, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.cardsGroup = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.cardGroupContentElement = _t.first);
    } }, hostBindings: function CardGroupComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("scroll", function CardGroupComponent_scroll_HostBindingHandler($event) { return ctx.onScroll($event); })("resize", function CardGroupComponent_resize_HostBindingHandler($event) { return ctx.onResize($event); }, false, i0.ɵɵresolveWindow);
    } }, inputs: { variant: "variant", width: "width" }, ngContentSelectors: _c7, decls: 9, vars: 10, consts: [[1, "cpc-card-group_content"], ["cardGroupContentElement", ""], [1, "cpc-card-group_content-cards", 3, "scroll"], ["cardsGroup", ""], [3, "class", 4, "ngFor", "ngForOf"], ["class", "cpc-card-group_controls", 4, "ngIf"], [4, "ngTemplateOutlet"], [1, "cpc-card-group_controls"], [1, "cpc-card-group_buttons"], ["mode", "tertiary", "size", "x-small", 1, "cpc-card-group_buttons-left-button", 3, "ngClass", "noVerticalMargin", "noHorizontalMargin", "click"], ["borderStyle", "circle", "backgroundColor", "white", 2, "--icon-size", "30px", 3, "icon", "borderWidth"], ["mode", "tertiary", "size", "x-small", 1, "cpc-card-group_buttons-right-button", 3, "ngClass", "noVerticalMargin", "noHorizontalMargin", "click"], [1, "cpc-card-group_pagination", 3, "ngStyle"], ["class", "cpc-card-group_pagination-page-dot", 3, "ngClass", 4, "ngFor", "ngForOf"], [1, "cpc-card-group_pagination-page-dot", 3, "ngClass"]], template: function CardGroupComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div")(1, "div", 0, 1);
        i0.ɵɵpipe(3, "async");
        i0.ɵɵprojection(4);
        i0.ɵɵelementStart(5, "div", 2, 3);
        i0.ɵɵlistener("scroll", function CardGroupComponent_Template_div_scroll_5_listener($event) { return ctx.onScroll($event); });
        i0.ɵɵtemplate(7, CardGroupComponent_div_7_Template, 2, 4, "div", 4);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(8, CardGroupComponent_div_8_Template, 8, 19, "div", 5);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵclassMapInterpolate2("cpc-card-group cpc-card-group--width-", ctx.width, " cpc-card-group--variant-", ctx.variant, "");
        i0.ɵɵadvance(1);
        i0.ɵɵstyleProp("min-height", i0.ɵɵpipeBind1(3, 8, ctx.cardsStoreSize) + "px");
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngForOf", ctx.cards);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.paginate);
    } }, dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet, i1.NgStyle, ButtonComponent, IconComponent, i1.AsyncPipe], styles: ["cpc-card-group{width:100%}.cpc-card-group{-ms-overflow-style:none;scrollbar-width:none;position:relative;height:100%}.cpc-card-group ::-webkit-scrollbar{display:none}.cpc-card-group:after{position:absolute;top:48px;left:0;display:block;width:100%;height:100%;height:calc(100% - 48px);background:var(--cpc-card-background);border-radius:5px;content:\"\"}.cpc-card-group .cpc-card-group_content{position:relative;z-index:1010;height:100%;overflow:hidden;transition:all 125ms;will-change:min-height}@media screen and (min-width: 992px){.cpc-card-group .cpc-card-group_content{padding:0 8px}}.cpc-card-group.cpc-card-group--variant-default .cpc-button{padding:0}@media screen and (min-width: 992px){.cpc-card-group.cpc-card-group--variant-default .cpc-button{padding:calc(8px - var(--button-border-width)) calc(16px - var(--button-border-width))!important}}.cpc-card-group.cpc-card-group--variant-inactive .cpc-button{padding:0}@media screen and (min-width: 992px){.cpc-card-group.cpc-card-group--variant-inactive .cpc-button{padding:calc(8px - var(--button-border-width)) calc(16px - var(--button-border-width))!important}}.cpc-card-group.cpc-card-group--variant-inactive:after{background:var(--cpc-card-background-inactive)}.cpc-card-group .cpc-card-group_controls{display:block}.cpc-card-group .cpc-card-group_controls .cpc-card-group_buttons{position:absolute;top:50%;z-index:1010;width:100%}.cpc-card-group .cpc-card-group_controls .cpc-card-group_buttons .cpc-card-group_buttons-left-button{position:absolute;left:-22px;z-index:1020}.cpc-card-group .cpc-card-group_controls .cpc-card-group_buttons .cpc-card-group_buttons-left-button .cpc-button{padding:0!important}.cpc-card-group .cpc-card-group_controls .cpc-card-group_buttons .cpc-card-group_buttons-left-button--disabled{pointer-events:none}.cpc-card-group .cpc-card-group_controls .cpc-card-group_buttons .cpc-card-group_buttons-left-button--disabled .cpc-icon{color:gray}.cpc-card-group .cpc-card-group_controls .cpc-card-group_buttons .cpc-card-group_buttons-right-button{position:absolute;right:-22px;z-index:1020}.cpc-card-group .cpc-card-group_controls .cpc-card-group_buttons .cpc-card-group_buttons-right-button .cpc-button{padding:0!important}.cpc-card-group .cpc-card-group_controls .cpc-card-group_buttons .cpc-card-group_buttons-right-button--disabled{pointer-events:none}.cpc-card-group .cpc-card-group_controls .cpc-card-group_buttons .cpc-card-group_buttons-right-button--disabled .cpc-icon{color:gray}.cpc-card-group .cpc-card-group_controls .cpc-card-group_pagination{position:absolute;bottom:-12px;left:50%;z-index:1010;display:flex;gap:5px;align-items:center;justify-content:center;width:56px;height:24px;background:var(--cpc-colors-white);border-radius:50px;transform:translate(-50%)}.cpc-card-group .cpc-card-group_controls .cpc-card-group_pagination .cpc-card-group_pagination-page-dot{display:inline-block;width:8px;height:8px;background-color:var(--cpc-colors-light-gray);border-radius:100%;content:\"\"}.cpc-card-group .cpc-card-group_controls .cpc-card-group_pagination .cpc-card-group_pagination-page-dot--active{background-color:var(--cpc-colors-resolution-blue)}.cpc-card-group .cpc-card-group_content-cards{position:relative;display:flex;align-items:flex-start;justify-content:flex-start;flex-direction:row;flex-wrap:nowrap;overflow-x:auto;scrollbar-width:none}.cpc-card-group .cpc-card-group_content-cards .cpc-card-group_content-cards-item{position:relative;width:100%}@media screen and (min-width: 992px){.cpc-card-group .cpc-card-group_content-cards .cpc-card-group_content-cards-item{margin-bottom:0}.cpc-card-group .cpc-card-group_content-cards .cpc-card-group_content-cards-item:after{top:0;left:100%;width:2px;height:calc(100% - 32px);transform:translate(-50%)}}.cpc-card-group .cpc-card-group_content-cards .cpc-card-group_content-cards-item.cpc-card-group_content-cards-item--2{flex:0 0 100%}@media screen and (min-width: 704px){.cpc-card-group .cpc-card-group_content-cards .cpc-card-group_content-cards-item.cpc-card-group_content-cards-item--2{flex:0 0 50%;width:50%}}.cpc-card-group .cpc-card-group_content-cards .cpc-card-group_content-cards-item.cpc-card-group_content-cards-item--3{flex:0 0 100%}@media screen and (min-width: 704px){.cpc-card-group .cpc-card-group_content-cards .cpc-card-group_content-cards-item.cpc-card-group_content-cards-item--3{flex:0 0 50%;width:50%}}@media screen and (min-width: 1280px){.cpc-card-group .cpc-card-group_content-cards .cpc-card-group_content-cards-item.cpc-card-group_content-cards-item--3{flex:0 0 33.333333%;width:33.33%}}.cpc-card-group .cpc-card-group_content-cards .cpc-card-group_content-cards-item:last-child:after{display:none}.cpc-card-group.cpc-card-group--width-full{width:100%}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CardGroupComponent, [{
        type: Component,
        args: [{ selector: 'cpc-card-group', encapsulation: ViewEncapsulation.None, template: "<div class=\"cpc-card-group cpc-card-group--width-{{width}} cpc-card-group--variant-{{variant}}\">\r\n  <div\r\n    #cardGroupContentElement\r\n    class=\"cpc-card-group_content\"\r\n    [style.minHeight]=\"(cardsStoreSize | async) + 'px'\"\r\n  >\r\n    <ng-content></ng-content>\r\n    <div\r\n      #cardsGroup\r\n      (scroll)=\"onScroll($event)\"\r\n      class=\"cpc-card-group_content-cards\"\r\n    >\r\n      <div\r\n        *ngFor=\"let card of cards; let i = index\"\r\n        class=\"cpc-card-group_content-cards-item cpc-card-group_content-cards-item--{{items}}\">\r\n        <ng-container *ngTemplateOutlet=\"card.template\"></ng-container>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"cpc-card-group_controls\" *ngIf=\"paginate\">\r\n    <div class=\"cpc-card-group_buttons\">\r\n      <cpc-button\r\n        [ngClass]=\"{'cpc-card-group_buttons-left-button--disabled': currentPage === 1}\"\r\n        [noVerticalMargin]=\"true\"\r\n        [noHorizontalMargin]=\"true\"\r\n        (click)=\"prevSlide()\"\r\n        mode='tertiary'\r\n        size='x-small'\r\n        class=\"cpc-card-group_buttons-left-button\"\r\n      >\r\n        <cpc-icon\r\n          [icon]=\"ndbxIcons.ChevronLeft\"\r\n          [borderWidth]='0'\r\n          borderStyle='circle'\r\n          backgroundColor=\"white\"\r\n          style=\"--icon-size: 30px\"\r\n        ></cpc-icon>\r\n      </cpc-button>\r\n      <cpc-button\r\n        [ngClass]=\"{'cpc-card-group_buttons-right-button--disabled': currentPage === pages}\"\r\n        [noVerticalMargin]=\"true\"\r\n        [noHorizontalMargin]=\"true\"\r\n        (click)=\"nextSlide()\"\r\n        mode='tertiary'\r\n        size='x-small'\r\n        class=\"cpc-card-group_buttons-right-button\"\r\n      >\r\n        <cpc-icon\r\n          [icon]=\"ndbxIcons.ChevronRight\"\r\n          borderStyle='circle'\r\n          backgroundColor=\"white\"\r\n          [borderWidth]='0'\r\n          style=\"--icon-size: 30px\"\r\n        ></cpc-icon>\r\n      </cpc-button>\r\n    </div>\r\n    <div\r\n      class=\"cpc-card-group_pagination\"\r\n      [ngStyle]=\"{width: paginationWidth + 'px'}\">\r\n      <div\r\n        *ngFor=\"let page of [].constructor(pages); let index = index\"\r\n        [ngClass]=\"{'cpc-card-group_pagination-page-dot--active': currentPage === index + 1}\"\r\n        class=\"cpc-card-group_pagination-page-dot\"\r\n      ></div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: ["cpc-card-group{width:100%}.cpc-card-group{-ms-overflow-style:none;scrollbar-width:none;position:relative;height:100%}.cpc-card-group ::-webkit-scrollbar{display:none}.cpc-card-group:after{position:absolute;top:48px;left:0;display:block;width:100%;height:100%;height:calc(100% - 48px);background:var(--cpc-card-background);border-radius:5px;content:\"\"}.cpc-card-group .cpc-card-group_content{position:relative;z-index:1010;height:100%;overflow:hidden;transition:all 125ms;will-change:min-height}@media screen and (min-width: 992px){.cpc-card-group .cpc-card-group_content{padding:0 8px}}.cpc-card-group.cpc-card-group--variant-default .cpc-button{padding:0}@media screen and (min-width: 992px){.cpc-card-group.cpc-card-group--variant-default .cpc-button{padding:calc(8px - var(--button-border-width)) calc(16px - var(--button-border-width))!important}}.cpc-card-group.cpc-card-group--variant-inactive .cpc-button{padding:0}@media screen and (min-width: 992px){.cpc-card-group.cpc-card-group--variant-inactive .cpc-button{padding:calc(8px - var(--button-border-width)) calc(16px - var(--button-border-width))!important}}.cpc-card-group.cpc-card-group--variant-inactive:after{background:var(--cpc-card-background-inactive)}.cpc-card-group .cpc-card-group_controls{display:block}.cpc-card-group .cpc-card-group_controls .cpc-card-group_buttons{position:absolute;top:50%;z-index:1010;width:100%}.cpc-card-group .cpc-card-group_controls .cpc-card-group_buttons .cpc-card-group_buttons-left-button{position:absolute;left:-22px;z-index:1020}.cpc-card-group .cpc-card-group_controls .cpc-card-group_buttons .cpc-card-group_buttons-left-button .cpc-button{padding:0!important}.cpc-card-group .cpc-card-group_controls .cpc-card-group_buttons .cpc-card-group_buttons-left-button--disabled{pointer-events:none}.cpc-card-group .cpc-card-group_controls .cpc-card-group_buttons .cpc-card-group_buttons-left-button--disabled .cpc-icon{color:gray}.cpc-card-group .cpc-card-group_controls .cpc-card-group_buttons .cpc-card-group_buttons-right-button{position:absolute;right:-22px;z-index:1020}.cpc-card-group .cpc-card-group_controls .cpc-card-group_buttons .cpc-card-group_buttons-right-button .cpc-button{padding:0!important}.cpc-card-group .cpc-card-group_controls .cpc-card-group_buttons .cpc-card-group_buttons-right-button--disabled{pointer-events:none}.cpc-card-group .cpc-card-group_controls .cpc-card-group_buttons .cpc-card-group_buttons-right-button--disabled .cpc-icon{color:gray}.cpc-card-group .cpc-card-group_controls .cpc-card-group_pagination{position:absolute;bottom:-12px;left:50%;z-index:1010;display:flex;gap:5px;align-items:center;justify-content:center;width:56px;height:24px;background:var(--cpc-colors-white);border-radius:50px;transform:translate(-50%)}.cpc-card-group .cpc-card-group_controls .cpc-card-group_pagination .cpc-card-group_pagination-page-dot{display:inline-block;width:8px;height:8px;background-color:var(--cpc-colors-light-gray);border-radius:100%;content:\"\"}.cpc-card-group .cpc-card-group_controls .cpc-card-group_pagination .cpc-card-group_pagination-page-dot--active{background-color:var(--cpc-colors-resolution-blue)}.cpc-card-group .cpc-card-group_content-cards{position:relative;display:flex;align-items:flex-start;justify-content:flex-start;flex-direction:row;flex-wrap:nowrap;overflow-x:auto;scrollbar-width:none}.cpc-card-group .cpc-card-group_content-cards .cpc-card-group_content-cards-item{position:relative;width:100%}@media screen and (min-width: 992px){.cpc-card-group .cpc-card-group_content-cards .cpc-card-group_content-cards-item{margin-bottom:0}.cpc-card-group .cpc-card-group_content-cards .cpc-card-group_content-cards-item:after{top:0;left:100%;width:2px;height:calc(100% - 32px);transform:translate(-50%)}}.cpc-card-group .cpc-card-group_content-cards .cpc-card-group_content-cards-item.cpc-card-group_content-cards-item--2{flex:0 0 100%}@media screen and (min-width: 704px){.cpc-card-group .cpc-card-group_content-cards .cpc-card-group_content-cards-item.cpc-card-group_content-cards-item--2{flex:0 0 50%;width:50%}}.cpc-card-group .cpc-card-group_content-cards .cpc-card-group_content-cards-item.cpc-card-group_content-cards-item--3{flex:0 0 100%}@media screen and (min-width: 704px){.cpc-card-group .cpc-card-group_content-cards .cpc-card-group_content-cards-item.cpc-card-group_content-cards-item--3{flex:0 0 50%;width:50%}}@media screen and (min-width: 1280px){.cpc-card-group .cpc-card-group_content-cards .cpc-card-group_content-cards-item.cpc-card-group_content-cards-item--3{flex:0 0 33.333333%;width:33.33%}}.cpc-card-group .cpc-card-group_content-cards .cpc-card-group_content-cards-item:last-child:after{display:none}.cpc-card-group.cpc-card-group--width-full{width:100%}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: CardsStoreService }]; }, { variant: [{
            type: Input
        }], width: [{
            type: Input
        }], childrenCards: [{
            type: ContentChildren,
            args: [CardComponent]
        }], cardsGroup: [{
            type: ViewChild,
            args: ['cardsGroup']
        }], cardGroupContentElement: [{
            type: ViewChild,
            args: ['cardGroupContentElement']
        }], onScroll: [{
            type: HostListener,
            args: ['scroll', ['$event']]
        }], onResize: [{
            type: HostListener,
            args: ['window:resize', ['$event']]
        }] }); })();

const _c0$N = ["cardHeader"];
function CardHeaderComponent_cpc_icon_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "cpc-icon", 8);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("icon", ctx_r1.ndbxIcons.CheckCircle);
} }
function CardHeaderComponent_cpc_icon_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "cpc-icon", 9);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("icon", ctx_r2.badgeIcon.name || ctx_r2.ndbxIcons.CheckCircle)("color", ctx_r2.badgeIcon.color || "#3DA556");
} }
const _c1$r = function (a0) { return { "cpc-card-header_text-title-color-gray": a0 }; };
var CpcCardHeaderVariants;
(function (CpcCardHeaderVariants) {
    CpcCardHeaderVariants["Active"] = "active";
    CpcCardHeaderVariants["EV"] = "ev";
    CpcCardHeaderVariants["Inactive"] = "inactive";
})(CpcCardHeaderVariants || (CpcCardHeaderVariants = {}));
var CpcCardHeaderTitle;
(function (CpcCardHeaderTitle) {
    CpcCardHeaderTitle["Default"] = "default";
    CpcCardHeaderTitle["Inactive"] = "inactive";
})(CpcCardHeaderTitle || (CpcCardHeaderTitle = {}));
const DEFAULT_TIMEOUT$3 = 0;
class CardHeaderComponent {
    constructor(cdr, cardsStoreService) {
        this.cdr = cdr;
        this.cardsStoreService = cardsStoreService;
        this.type = 'header-1';
        this.icon = NdbxIcon.BellO;
        this.variant = CpcBadgeVariants.Default;
        this.badge = '';
        this.title = '';
        this.titleVariant = CpcCardHeaderTitle.Default;
        this.ndbxIcons = NdbxIcon;
        this.badgeVariants = CpcBadgeVariants;
        this.cardContentSize = cardsStoreService.getObservableSize(this.type);
    }
    onResize() {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        debounce(() => this.sizeUpdater(), 300)();
    }
    ngOnChanges() {
        this.cardContentSize = this.cardsStoreService.getObservableSize(this.type);
        this.sizeUpdater();
        this.cdr.detectChanges();
    }
    ngAfterViewInit() {
        this.cardContentSize = this.cardsStoreService.getObservableSize(this.type);
        setTimeout(() => {
            this.sizeUpdater();
        }, DEFAULT_TIMEOUT$3);
    }
    ngOnDestroy() {
        this.cardsStoreService.clearSize(this.type);
    }
    sizeUpdater() {
        const element = this.cardContent?.nativeElement;
        if (!element) {
            return;
        }
        this.cardsStoreService.clearSize(this.type);
        setTimeout(() => {
            this.cardsStoreService.updateSize(element.clientHeight, this.type);
        }, DEFAULT_TIMEOUT$3);
    }
}
CardHeaderComponent.ɵfac = function CardHeaderComponent_Factory(t) { return new (t || CardHeaderComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(CardsStoreService)); };
CardHeaderComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CardHeaderComponent, selectors: [["cpc-card-header"]], viewQuery: function CardHeaderComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$N, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.cardContent = _t.first);
    } }, hostBindings: function CardHeaderComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("resize", function CardHeaderComponent_resize_HostBindingHandler($event) { return ctx.onResize($event); }, false, i0.ɵɵresolveWindow);
    } }, inputs: { type: "type", icon: "icon", badgeIcon: "badgeIcon", variant: "variant", badge: "badge", title: "title", titleVariant: "titleVariant" }, features: [i0.ɵɵNgOnChangesFeature], decls: 14, vars: 20, consts: [[1, "cpc-card-header"], ["backgroundColor", "#fff", "borderStyle", "circle", 3, "icon"], [1, "cpc-card-header_text"], [1, "cpc-card-header_text-title", 3, "ngClass"], ["cardHeader", ""], [3, "variant"], ["color", "#3DA556", 3, "icon", 4, "ngIf"], [3, "icon", "color", 4, "ngIf"], ["color", "#3DA556", 3, "icon"], [3, "icon", "color"]], template: function CardHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div");
        i0.ɵɵelement(2, "cpc-icon", 1);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 2)(4, "h2", 3, 4);
        i0.ɵɵpipe(6, "async");
        i0.ɵɵtext(7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "cpc-badge", 5);
        i0.ɵɵtext(9);
        i0.ɵɵtemplate(10, CardHeaderComponent_cpc_icon_10_Template, 1, 1, "cpc-icon", 6);
        i0.ɵɵpipe(11, "json");
        i0.ɵɵtemplate(12, CardHeaderComponent_cpc_icon_12_Template, 1, 2, "cpc-icon", 7);
        i0.ɵɵpipe(13, "json");
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵclassMapInterpolate1("cpc-card-header_symbol cpc-card-header_symbol--variant-", ctx.variant, "");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("icon", ctx.icon);
        i0.ɵɵadvance(2);
        i0.ɵɵstyleProp("min-height", i0.ɵɵpipeBind1(6, 12, ctx.cardContentSize) + "px");
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(18, _c1$r, ctx.titleVariant === "inactive"));
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.title);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("variant", ctx.variant);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.badge, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.variant === ctx.badgeVariants.Default && !ctx.badgeIcon || i0.ɵɵpipeBind1(11, 14, ctx.badgeIcon) === "{}");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.badgeIcon && i0.ɵɵpipeBind1(13, 16, ctx.badgeIcon) !== "{}");
    } }, dependencies: [i1.NgClass, i1.NgIf, BadgeComponent, IconComponent, i1.AsyncPipe, i1.JsonPipe], styles: [".cpc-card-header[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center;flex-direction:column;flex-wrap:inherit}.cpc-card-header[_ngcontent-%COMP%]   .cpc-card-header_symbol[_ngcontent-%COMP%], .cpc-card-header[_ngcontent-%COMP%]   .cpc-card-header_text[_ngcontent-%COMP%]{margin-bottom:16px}.cpc-card-header[_ngcontent-%COMP%]   .cpc-card-header_symbol[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center;flex-direction:column;flex-wrap:inherit;color:var(--cpc-badge-icon-active);--icon-size: 59px;--icon-padding: 16px}.cpc-card-header[_ngcontent-%COMP%]   .cpc-card-header_symbol.cpc-card-header_symbol--variant-inactive[_ngcontent-%COMP%]{color:var(--icon-color-inactive)}.cpc-card-header[_ngcontent-%COMP%]   .cpc-card-header_symbol.cpc-card-header_symbol--variant-ev[_ngcontent-%COMP%]{color:var(--cpc-colors-faux-green)}.cpc-card-header[_ngcontent-%COMP%]   .cpc-card-header_text[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center;flex-direction:column;flex-wrap:inherit}.cpc-card-header[_ngcontent-%COMP%]   .cpc-card-header_text-title[_ngcontent-%COMP%]{margin:0 0 12px;font-weight:700;font-size:24px;line-height:1.3333;letter-spacing:.2px;text-align:center}.cpc-card-header[_ngcontent-%COMP%]   .cpc-card-header_text-title-color-gray[_ngcontent-%COMP%]{color:var(--cpc-policy-card-header-title-color-inactive)}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CardHeaderComponent, [{
        type: Component,
        args: [{ selector: 'cpc-card-header', template: "<div class=\"cpc-card-header\">\r\n  <div class=\"cpc-card-header_symbol cpc-card-header_symbol--variant-{{variant}}\">\r\n    <cpc-icon [icon]=\"icon\" backgroundColor=\"#fff\" borderStyle=\"circle\"></cpc-icon>\r\n  </div>\r\n\r\n  <div class=\"cpc-card-header_text\">\r\n    <h2\r\n      #cardHeader\r\n      [ngClass]=\"{'cpc-card-header_text-title-color-gray': titleVariant === 'inactive'}\"\r\n      [style.minHeight]=\"(cardContentSize | async) + 'px'\"\r\n      class=\"cpc-card-header_text-title\"\r\n    >{{title}}</h2>\r\n    <cpc-badge [variant]=\"variant\">\r\n      {{badge}}\r\n      <cpc-icon *ngIf=\"variant === badgeVariants.Default && !badgeIcon || (badgeIcon | json) === '{}'\" [icon]=\"ndbxIcons.CheckCircle\" color=\"#3DA556\"></cpc-icon>\r\n      <cpc-icon *ngIf=\"badgeIcon && (badgeIcon | json) !== '{}'\" [icon]=\"badgeIcon.name || ndbxIcons.CheckCircle\" [color]=\"badgeIcon.color || '#3DA556'\"></cpc-icon>\r\n    </cpc-badge>\r\n  </div>\r\n</div>\r\n", styles: [".cpc-card-header{display:flex;justify-content:center;align-items:center;flex-direction:column;flex-wrap:inherit}.cpc-card-header .cpc-card-header_symbol,.cpc-card-header .cpc-card-header_text{margin-bottom:16px}.cpc-card-header .cpc-card-header_symbol{display:flex;justify-content:center;align-items:center;flex-direction:column;flex-wrap:inherit;color:var(--cpc-badge-icon-active);--icon-size: 59px;--icon-padding: 16px}.cpc-card-header .cpc-card-header_symbol.cpc-card-header_symbol--variant-inactive{color:var(--icon-color-inactive)}.cpc-card-header .cpc-card-header_symbol.cpc-card-header_symbol--variant-ev{color:var(--cpc-colors-faux-green)}.cpc-card-header .cpc-card-header_text{display:flex;justify-content:center;align-items:center;flex-direction:column;flex-wrap:inherit}.cpc-card-header .cpc-card-header_text-title{margin:0 0 12px;font-weight:700;font-size:24px;line-height:1.3333;letter-spacing:.2px;text-align:center}.cpc-card-header .cpc-card-header_text-title-color-gray{color:var(--cpc-policy-card-header-title-color-inactive)}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: CardsStoreService }]; }, { type: [{
            type: Input
        }], icon: [{
            type: Input
        }], badgeIcon: [{
            type: Input
        }], variant: [{
            type: Input
        }], badge: [{
            type: Input
        }], title: [{
            type: Input
        }], titleVariant: [{
            type: Input
        }], cardContent: [{
            type: ViewChild,
            args: ['cardHeader']
        }], onResize: [{
            type: HostListener,
            args: ['window:resize', ['$event']]
        }] }); })();

const DEFAULT_SIZE = 'small';
class SpinnerComponent {
    constructor(_changeDetectorRef) {
        this._changeDetectorRef = _changeDetectorRef;
        // eslint-disable-next-line no-underscore-dangle
        this._size = DEFAULT_SIZE;
    }
    get size() {
        // eslint-disable-next-line no-underscore-dangle
        return this._size;
    }
    /** Sets the size of the spinner. Default is 'small'. */
    set size(value) {
        // eslint-disable-next-line no-underscore-dangle
        if (value !== this._size) {
            // eslint-disable-next-line no-underscore-dangle
            this._size = value;
            // eslint-disable-next-line no-underscore-dangle
            this._changeDetectorRef.markForCheck();
        }
    }
}
SpinnerComponent.ɵfac = function SpinnerComponent_Factory(t) { return new (t || SpinnerComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
SpinnerComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SpinnerComponent, selectors: [["cpc-spinner"]], hostVars: 9, hostBindings: function SpinnerComponent_HostBindings(rf, ctx) { if (rf & 2) {
        i0.ɵɵattribute("role", "status")("aria-busy", "true")("aria-live", "assertive");
        i0.ɵɵclassProp("cpc-spinner--small", ctx.size === "small")("cpc-spinner--medium", ctx.size === "medium")("cpc-spinner--large", ctx.size === "large");
    } }, inputs: { size: "size" }, decls: 3, vars: 0, consts: [[1, "cpc-spinner__spin-block"], [1, "cpc-spinner__edge-left"], [1, "cpc-spinner__edge-right"]], template: function SpinnerComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelement(1, "div", 1)(2, "div", 2);
        i0.ɵɵelementEnd();
    } }, styles: ["@keyframes _ngcontent-%COMP%_spin{0%{transform:rotate(45deg)}to{transform:rotate(405deg)}}[_nghost-%COMP%]{position:relative;display:block}.cpc-spinner--small[_nghost-%COMP%]{width:8px;height:8px}.cpc-spinner--medium[_nghost-%COMP%]{width:16px;height:16px}.cpc-spinner--large[_nghost-%COMP%]{width:24px;height:24px}.cpc-spinner__spin-block[_ngcontent-%COMP%]{width:100%;height:100%;border-color:var(--cpc-spinner-background-color) var(--cpc-spinner-background-color) var(--cpc-spinner-active-color);border-style:solid;border-radius:50%;transform:rotate(45deg);animation-name:_ngcontent-%COMP%_spin;animation-duration:.8s;animation-timing-function:linear;animation-iteration-count:infinite}.cpc-spinner__edge-left[_ngcontent-%COMP%], .cpc-spinner__edge-right[_ngcontent-%COMP%]{position:absolute;top:6%;width:12%;height:12%;border-radius:50%}.cpc-spinner__edge-left[_ngcontent-%COMP%]{left:6%}.cpc-spinner__edge-right[_ngcontent-%COMP%]{right:6%}.cpc-spinner--small[_nghost-%COMP%]   .cpc-spinner__edge-left[_ngcontent-%COMP%], .cpc-spinner--small[_nghost-%COMP%]   .cpc-spinner__edge-right[_ngcontent-%COMP%]{width:10%;height:10%}.cpc-spinner--small[_nghost-%COMP%]   .cpc-spinner__spin-block[_ngcontent-%COMP%]{border-width:.8px}.cpc-spinner--medium[_nghost-%COMP%]   .cpc-spinner__spin-block[_ngcontent-%COMP%]{border-width:1.6px}.cpc-spinner--large[_nghost-%COMP%]   .cpc-spinner__spin-block[_ngcontent-%COMP%]{border-width:2.4px}@media screen and (-ms-high-contrast: active){[_nghost-%COMP%]   .cpc-spinner__spin-block[_ngcontent-%COMP%]{border-color:window highlight highlight highlight}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SpinnerComponent, [{
        type: Component,
        args: [{ selector: 'cpc-spinner', changeDetection: ChangeDetectionStrategy.OnPush, host: {
                    '[class.cpc-spinner--small]': 'size === "small"',
                    '[class.cpc-spinner--medium]': 'size === "medium"',
                    '[class.cpc-spinner--large]': 'size === "large"',
                    '[attr.role]': '"status"',
                    '[attr.aria-busy]': '"true"',
                    '[attr.aria-live]': '"assertive"',
                }, template: "<div class=\"cpc-spinner__spin-block\">\r\n  <div class=\"cpc-spinner__edge-left\"></div>\r\n  <div class=\"cpc-spinner__edge-right\"></div>\r\n</div>\r\n", styles: ["@keyframes spin{0%{transform:rotate(45deg)}to{transform:rotate(405deg)}}:host{position:relative;display:block}:host(.cpc-spinner--small){width:8px;height:8px}:host(.cpc-spinner--medium){width:16px;height:16px}:host(.cpc-spinner--large){width:24px;height:24px}.cpc-spinner__spin-block{width:100%;height:100%;border-color:var(--cpc-spinner-background-color) var(--cpc-spinner-background-color) var(--cpc-spinner-active-color);border-style:solid;border-radius:50%;transform:rotate(45deg);animation-name:spin;animation-duration:.8s;animation-timing-function:linear;animation-iteration-count:infinite}.cpc-spinner__edge-left,.cpc-spinner__edge-right{position:absolute;top:6%;width:12%;height:12%;border-radius:50%}.cpc-spinner__edge-left{left:6%}.cpc-spinner__edge-right{right:6%}:host(.cpc-spinner--small) .cpc-spinner__edge-left,:host(.cpc-spinner--small) .cpc-spinner__edge-right{width:10%;height:10%}:host(.cpc-spinner--small) .cpc-spinner__spin-block{border-width:.8px}:host(.cpc-spinner--medium) .cpc-spinner__spin-block{border-width:1.6px}:host(.cpc-spinner--large) .cpc-spinner__spin-block{border-width:2.4px}@media screen and (-ms-high-contrast: active){:host .cpc-spinner__spin-block{border-color:window highlight highlight highlight}}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }]; }, { size: [{
            type: Input
        }] }); })();

function DocumentUploadComponent_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 11);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.size, " ");
} }
function DocumentUploadComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.copyUploading, " ");
} }
function DocumentUploadComponent_cpc_icon_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "cpc-icon", 13);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("icon", ctx_r3.ndbxIcons.CheckCircle);
} }
function DocumentUploadComponent_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "cpc-spinner", 14);
} }
const _c0$M = function (a0) { return { "uploading": a0 }; };
const _c1$q = ["*"];
class DocumentUploadComponent {
    constructor() {
        this.progress = 0;
        this.isUploaded = false;
        this.copyUploading = 'uploading';
        this.clickDrop = new EventEmitter();
        this.ndbxIcons = NdbxIcon;
    }
    ngOnChanges() {
        this.updateFileValues();
    }
    drop(event) {
        event.stopPropagation();
        this.clickDrop.emit(this.name);
    }
    updateFileValues() {
        const fileArray = this.name.split('.');
        if (fileArray.length <= 1) {
            this.fileName = this.name;
            return;
        }
        const fileName = [...fileArray];
        fileName.pop();
        this.fileName = fileName.join('.');
    }
}
DocumentUploadComponent.ɵfac = function DocumentUploadComponent_Factory(t) { return new (t || DocumentUploadComponent)(); };
DocumentUploadComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DocumentUploadComponent, selectors: [["cpc-document-upload"]], inputs: { name: "name", size: "size", progress: "progress", isUploaded: "isUploaded", copyUploading: "copyUploading" }, outputs: { clickDrop: "clickDrop" }, features: [i0.ɵɵNgOnChangesFeature], ngContentSelectors: _c1$q, decls: 14, vars: 9, consts: [[1, "cpc-document-upload"], [1, "cpc-document-wrapper", 3, "ngClass"], [1, "cpc-document_name-wrapper", "cpc-document-truncate"], [1, "cpc-document_name", "cpc-document-text", "cpc-document-truncate"], ["class", "cpc-document_size", 4, "ngIf", "ngIfElse"], ["class", "cpc-document_size"], ["fileSize", ""], [1, "cpc-document_icons"], ["class", "cpc-document_icon cpc-document_icon--uploaded", 3, "icon", 4, "ngIf", "ngIfElse"], ["progress", ""], [1, "cpc-document_icon", "cpc-document_icon--drop", 3, "icon", "click"], [1, "cpc-document_size"], [1, "cpc-document_uploading"], [1, "cpc-document_icon", "cpc-document_icon--uploaded", 3, "icon"], ["size", "large", 1, "cpc-document_icon"]], template: function DocumentUploadComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "p", 3);
        i0.ɵɵtext(4);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(5, DocumentUploadComponent_span_5_Template, 2, 1, "span", 4);
        i0.ɵɵtemplate(6, DocumentUploadComponent_ng_template_6_Template, 2, 1, "ng-template", 5, 6, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementStart(8, "span", 7);
        i0.ɵɵtemplate(9, DocumentUploadComponent_cpc_icon_9_Template, 1, 1, "cpc-icon", 8);
        i0.ɵɵtemplate(10, DocumentUploadComponent_ng_template_10_Template, 1, 0, "ng-template", null, 9, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementStart(12, "cpc-icon", 10);
        i0.ɵɵlistener("click", function DocumentUploadComponent_Template_cpc_icon_click_12_listener($event) { return ctx.isUploaded && ctx.drop($event); });
        i0.ɵɵelementEnd()()();
        i0.ɵɵprojection(13);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(7);
        const _r4 = i0.ɵɵreference(11);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c0$M, !ctx.isUploaded));
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.fileName, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isUploaded)("ngIfElse", _r1);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.isUploaded)("ngIfElse", _r4);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("icon", ctx.ndbxIcons.TrashO);
    } }, dependencies: [i1.NgClass, i1.NgIf, IconComponent, SpinnerComponent], styles: [".cpc-document-upload .cpc-document_icons{display:flex;align-items:center;justify-self:flex-end;margin:0 12px 0 0}.cpc-document-upload .cpc-document_icons .cpc-document_icon{margin:0 2px}.cpc-document-upload .cpc-document_icons .cpc-document_icon--uploaded{color:var(--cpc-document-upload-success-icon-color)}.cpc-document-upload .cpc-document_icons .cpc-document_icon--drop{cursor:pointer}.cpc-document-upload .cpc-document_uploading,.cpc-document-upload .cpc-document_size{margin:0 8px 0 auto;font-size:14px}.cpc-document-upload .cpc-document-wrapper .cpc-document_name{font-weight:var(--cpc-document-upload-name-weight)}.cpc-document-upload .cpc-document-wrapper.uploading .cpc-document_icon--drop,.cpc-document-upload .cpc-document-wrapper.uploading .cpc-document_name-wrapper{opacity:.5}.cpc-document-upload .cpc-document-wrapper.uploading .cpc-document_icon--drop{cursor:not-allowed}\n"], encapsulation: 2, data: { animation: [animationBuilder(AngularAnimationsTypes.SLIDE, 300, 200)] } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DocumentUploadComponent, [{
        type: Component,
        args: [{ selector: 'cpc-document-upload', animations: [animationBuilder(AngularAnimationsTypes.SLIDE, 300, 200)], encapsulation: ViewEncapsulation.None, template: "<div class=\"cpc-document-upload\">\r\n  <div class=\"cpc-document-wrapper\" [ngClass]=\"{'uploading': !isUploaded}\">\r\n    <div class=\"cpc-document_name-wrapper cpc-document-truncate\">\r\n      <p class=\"cpc-document_name cpc-document-text cpc-document-truncate\">\r\n        {{fileName}}\r\n      </p>\r\n    </div>\r\n    <span *ngIf=\"isUploaded; else fileSize\" class=\"cpc-document_size\"> {{size}} </span>\r\n    <ng-template #fileSize class=\"cpc-document_size\">\r\n      <span class=\"cpc-document_uploading\">\r\n        {{copyUploading}}\r\n      </span>\r\n    </ng-template>\r\n    <span class=\"cpc-document_icons\">\r\n      <cpc-icon *ngIf=\"isUploaded; else progress\" class=\"cpc-document_icon cpc-document_icon--uploaded\" [icon]=\"ndbxIcons.CheckCircle\"></cpc-icon>\r\n      <ng-template #progress>\r\n        <cpc-spinner size=\"large\" class=\"cpc-document_icon\"></cpc-spinner>\r\n      </ng-template>\r\n      <cpc-icon (click)=\"isUploaded && drop($event)\" class=\"cpc-document_icon cpc-document_icon--drop\" [icon]=\"ndbxIcons.TrashO\"></cpc-icon>\r\n    </span>\r\n  </div>\r\n  <ng-content></ng-content>\r\n</div>\r\n", styles: [".cpc-document-upload .cpc-document_icons{display:flex;align-items:center;justify-self:flex-end;margin:0 12px 0 0}.cpc-document-upload .cpc-document_icons .cpc-document_icon{margin:0 2px}.cpc-document-upload .cpc-document_icons .cpc-document_icon--uploaded{color:var(--cpc-document-upload-success-icon-color)}.cpc-document-upload .cpc-document_icons .cpc-document_icon--drop{cursor:pointer}.cpc-document-upload .cpc-document_uploading,.cpc-document-upload .cpc-document_size{margin:0 8px 0 auto;font-size:14px}.cpc-document-upload .cpc-document-wrapper .cpc-document_name{font-weight:var(--cpc-document-upload-name-weight)}.cpc-document-upload .cpc-document-wrapper.uploading .cpc-document_icon--drop,.cpc-document-upload .cpc-document-wrapper.uploading .cpc-document_name-wrapper{opacity:.5}.cpc-document-upload .cpc-document-wrapper.uploading .cpc-document_icon--drop{cursor:not-allowed}\n"] }]
    }], null, { name: [{
            type: Input
        }], size: [{
            type: Input
        }], progress: [{
            type: Input
        }], isUploaded: [{
            type: Input
        }], copyUploading: [{
            type: Input
        }], clickDrop: [{
            type: Output
        }] }); })();

const _c0$L = ["documents"];
function DocumentComponent_cpc_icon_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "cpc-icon", 10);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.drawerOpenModel ? "cpc-document_icon cpc-document_icon--active" : "cpc-document_icon")("icon", ctx_r0.ndbxIcons.ChevronDown);
} }
function DocumentComponent_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 11);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.date, " ");
} }
function DocumentComponent_button_8_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 12);
    i0.ɵɵlistener("click", function DocumentComponent_button_8_Template_button_click_0_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.download($event)); });
    i0.ɵɵelement(1, "cpc-icon", 3);
    i0.ɵɵelementStart(2, "span", 13);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("icon", ctx_r2.ndbxIcons.Download);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.copyDownload, " ");
} }
const _c1$p = function () { return { cursor: "pointer" }; };
const _c2$8 = ["*"];
class DocumentComponent {
    constructor(cdr) {
        this.cdr = cdr;
        this.drawerOpenModel = false;
        this.showDate = true;
        this.isDownloadable = true;
        this.copyDownload = 'Download';
        this.drawerOpenModelChange = new EventEmitter();
        this.clickDownload = new EventEmitter();
        this.hasChilds = false;
        this.ndbxIcons = NdbxIcon;
    }
    ngOnChanges() {
        this.updateFileValues();
        this.cdr.detectChanges();
    }
    ngAfterViewInit() {
        this.hasChilds = this.documents.nativeElement.children.length !== 0;
        this.cdr.detectChanges();
    }
    handleOpen() {
        this.drawerOpenModel = !this.drawerOpenModel;
        this.drawerOpenModelChange.emit(this.drawerOpenModel);
    }
    download(event) {
        event.stopPropagation();
        this.clickDownload.emit(this.name);
    }
    updateFileValues() {
        const fileArray = this.name.split('.');
        if (fileArray.length <= 1) {
            this.fileName = this.name;
            return;
        }
        const fileName = [...fileArray];
        fileName.pop();
        this.fileName = fileName.join('.');
    }
}
DocumentComponent.ɵfac = function DocumentComponent_Factory(t) { return new (t || DocumentComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
DocumentComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DocumentComponent, selectors: [["cpc-document"]], viewQuery: function DocumentComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$L, 5);
        i0.ɵɵviewQuery(_c0$L, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.documents = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.documentsQuery = _t);
    } }, inputs: { name: "name", date: "date", drawerOpenModel: "drawerOpenModel", showDate: "showDate", isDownloadable: "isDownloadable", copyDownload: "copyDownload" }, outputs: { drawerOpenModelChange: "drawerOpenModelChange", clickDownload: "clickDownload" }, features: [i0.ɵɵNgOnChangesFeature], ngContentSelectors: _c2$8, decls: 12, vars: 8, consts: [[1, "cpc-document"], [1, "cpc-document-wrapper", 3, "ngStyle", "click"], [1, "cpc-document_name-wrapper", "cpc-document-truncate"], [1, "cpc-document_icon", 3, "icon"], [1, "cpc-document_name", "cpc-document-text", "cpc-document-truncate"], ["style", "margin-left: 8px", 3, "ngClass", "icon", 4, "ngIf"], ["class", "cpc-document_date", 4, "ngIf"], ["class", "cpc-document_download", 3, "click", 4, "ngIf"], [1, "cpc-document-list"], ["documents", ""], [2, "margin-left", "8px", 3, "ngClass", "icon"], [1, "cpc-document_date"], [1, "cpc-document_download", 3, "click"], [1, "cpc-document-download_text"]], template: function DocumentComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵlistener("click", function DocumentComponent_Template_div_click_1_listener() { return ctx.handleOpen(); });
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelement(3, "cpc-icon", 3);
        i0.ɵɵelementStart(4, "p", 4);
        i0.ɵɵtext(5);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(6, DocumentComponent_cpc_icon_6_Template, 1, 2, "cpc-icon", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(7, DocumentComponent_span_7_Template, 2, 1, "span", 6);
        i0.ɵɵtemplate(8, DocumentComponent_button_8_Template, 4, 2, "button", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "div", 8, 9);
        i0.ɵɵprojection(11);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngStyle", ctx.hasChilds ? i0.ɵɵpureFunction0(7, _c1$p) : null);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("icon", ctx.ndbxIcons.FileText);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.fileName, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.hasChilds);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showDate);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isDownloadable);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("@cpcSlideAnimation", ctx.drawerOpenModel);
    } }, dependencies: [i1.NgClass, i1.NgIf, i1.NgStyle, IconComponent], styles: ["cpc-document{width:100%}.cpc-document-wrapper{display:grid;grid-template-columns:3.5fr 1fr 1fr;align-items:center;justify-content:space-between;width:100%;padding:16px 0;color:var(--cpc-colors-charcoal);border-bottom:1px solid var(--cpc-colors-light-gray)}.cpc-document-wrapper .cpc-document-truncate{overflow:hidden;text-overflow:ellipsis}.cpc-document-wrapper .cpc-document_name-wrapper{display:flex}.cpc-document-wrapper .cpc-document-text{font-size:var(--file-list-font-size);line-height:var(--file-list-line-height);-webkit-user-select:none;user-select:none}@media screen and (min-width: 992px){.cpc-document-wrapper .cpc-document-text{white-space:nowrap}}.cpc-document-wrapper .cpc-document_icon{color:var(--cpc-colors-resolution-blue);font-size:24px;transition:transform .2s ease-out}.cpc-document-wrapper .cpc-document_icon--active{transform:rotate(180deg)}.cpc-document-wrapper .cpc-document_download{background:transparent;border:none;border-radius:0;cursor:pointer;-webkit-appearance:none;appearance:none;transition:all 125ms linear;display:flex;align-items:center;justify-content:center;margin-right:0;color:var(--cpc-colors-resolution-blue);font-weight:600;line-height:24px}.cpc-document-wrapper .cpc-document_download:focus,.cpc-document-wrapper .cpc-document_download.pseudo-states--focus{outline:0;box-shadow:var(--focus-box-shadow, 0 0 0 2px #fff, 0 0 0 6px #009de6)}.cpc-document-wrapper .cpc-document_download:disabled,.cpc-document-wrapper .cpc-document_download.pseudo-states--disabled{cursor:not-allowed;pointer-events:none}.cpc-document-wrapper .cpc-document_download:disabled,.cpc-document-wrapper .cpc-document_download.cpc--disabled,.cpc-document-wrapper .cpc-document_download.pseudo-states--disabled{cursor:not-allowed;pointer-events:none}@media screen and (min-width: 704px){.cpc-document-wrapper .cpc-document_download{margin-right:8px}}.cpc-document-wrapper .cpc-document_download .cpc-document_icon{margin-right:0;color:var(--cpc-colors-resolution-blue)!important}@media screen and (min-width: 704px){.cpc-document-wrapper .cpc-document_download .cpc-document_icon{margin-right:11px}}.cpc-document-wrapper .cpc-document-download_text{display:none;-webkit-user-select:none;user-select:none}@media screen and (min-width: 704px){.cpc-document-wrapper .cpc-document-download_text{display:block}}.cpc-document-wrapper .cpc-document_name{margin:0 0 0 12px;line-height:24px}@media screen and (min-width: 992px){.cpc-document-wrapper .cpc-document_name{margin:0 0 0 26px}}.cpc-document-wrapper .cpc-document_date{margin-left:12px;-webkit-user-select:none;user-select:none}.cpc-document-wrapper .cpc-document_size{margin:0 8px 0 auto}.cpc-document{display:flex;flex-wrap:wrap}.cpc-document .cpc-document-list{width:100%;overflow:hidden}.cpc-document .cpc-document{background-color:var(--cpc-colors-white-smoke)}.cpc-document .cpc-document .cpc-document_icon{color:var(--cpc-colors-sonic-silver)}.cpc-document .cpc-document .cpc-document-wrapper .cpc-document_name-wrapper{padding-left:16px}@media screen and (min-width: 992px){.cpc-document .cpc-document .cpc-document-wrapper .cpc-document_name-wrapper{padding-left:64px}}.cpc-documents-hidden{height:0;opacity:0}\n"], encapsulation: 2, data: { animation: [animationBuilder(AngularAnimationsTypes.SLIDE, 300, 200)] } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DocumentComponent, [{
        type: Component,
        args: [{ selector: 'cpc-document', animations: [animationBuilder(AngularAnimationsTypes.SLIDE, 300, 200)], encapsulation: ViewEncapsulation.None, template: "<div class=\"cpc-document\">\r\n  <div\r\n    [ngStyle]=\"hasChilds ? {cursor: 'pointer'} : null\"\r\n    (click)=\"handleOpen()\"\r\n    class=\"cpc-document-wrapper\"\r\n  >\r\n    <div class=\"cpc-document_name-wrapper cpc-document-truncate\">\r\n      <cpc-icon class=\"cpc-document_icon\" [icon]=\"ndbxIcons.FileText\"></cpc-icon>\r\n      <p class=\"cpc-document_name cpc-document-text cpc-document-truncate\">\r\n        {{fileName}}\r\n      </p>\r\n      <cpc-icon\r\n        *ngIf=\"hasChilds\"\r\n        [ngClass]=\"drawerOpenModel ? 'cpc-document_icon cpc-document_icon--active' : 'cpc-document_icon'\"\r\n        style=\"margin-left: 8px\"\r\n        [icon]=\"ndbxIcons.ChevronDown\"\r\n      ></cpc-icon>\r\n    </div>\r\n    <span\r\n      *ngIf=\"showDate\"\r\n      class=\"cpc-document_date\"\r\n    >\r\n      {{date}}\r\n    </span>\r\n    <button\r\n      *ngIf=\"isDownloadable\"\r\n      (click)=\"download($event)\"\r\n      class=\"cpc-document_download\"\r\n    >\r\n      <cpc-icon class=\"cpc-document_icon\" [icon]=\"ndbxIcons.Download\"></cpc-icon>\r\n      <span class=\"cpc-document-download_text\">\r\n        {{copyDownload}}\r\n      </span>\r\n    </button>\r\n  </div>\r\n  <div\r\n    [@cpcSlideAnimation]=\"drawerOpenModel\"\r\n    #documents\r\n    class=\"cpc-document-list\"\r\n  >\r\n    <ng-content></ng-content>\r\n  </div>\r\n</div>\r\n", styles: ["cpc-document{width:100%}.cpc-document-wrapper{display:grid;grid-template-columns:3.5fr 1fr 1fr;align-items:center;justify-content:space-between;width:100%;padding:16px 0;color:var(--cpc-colors-charcoal);border-bottom:1px solid var(--cpc-colors-light-gray)}.cpc-document-wrapper .cpc-document-truncate{overflow:hidden;text-overflow:ellipsis}.cpc-document-wrapper .cpc-document_name-wrapper{display:flex}.cpc-document-wrapper .cpc-document-text{font-size:var(--file-list-font-size);line-height:var(--file-list-line-height);-webkit-user-select:none;user-select:none}@media screen and (min-width: 992px){.cpc-document-wrapper .cpc-document-text{white-space:nowrap}}.cpc-document-wrapper .cpc-document_icon{color:var(--cpc-colors-resolution-blue);font-size:24px;transition:transform .2s ease-out}.cpc-document-wrapper .cpc-document_icon--active{transform:rotate(180deg)}.cpc-document-wrapper .cpc-document_download{background:transparent;border:none;border-radius:0;cursor:pointer;-webkit-appearance:none;appearance:none;transition:all 125ms linear;display:flex;align-items:center;justify-content:center;margin-right:0;color:var(--cpc-colors-resolution-blue);font-weight:600;line-height:24px}.cpc-document-wrapper .cpc-document_download:focus,.cpc-document-wrapper .cpc-document_download.pseudo-states--focus{outline:0;box-shadow:var(--focus-box-shadow, 0 0 0 2px #fff, 0 0 0 6px #009de6)}.cpc-document-wrapper .cpc-document_download:disabled,.cpc-document-wrapper .cpc-document_download.pseudo-states--disabled{cursor:not-allowed;pointer-events:none}.cpc-document-wrapper .cpc-document_download:disabled,.cpc-document-wrapper .cpc-document_download.cpc--disabled,.cpc-document-wrapper .cpc-document_download.pseudo-states--disabled{cursor:not-allowed;pointer-events:none}@media screen and (min-width: 704px){.cpc-document-wrapper .cpc-document_download{margin-right:8px}}.cpc-document-wrapper .cpc-document_download .cpc-document_icon{margin-right:0;color:var(--cpc-colors-resolution-blue)!important}@media screen and (min-width: 704px){.cpc-document-wrapper .cpc-document_download .cpc-document_icon{margin-right:11px}}.cpc-document-wrapper .cpc-document-download_text{display:none;-webkit-user-select:none;user-select:none}@media screen and (min-width: 704px){.cpc-document-wrapper .cpc-document-download_text{display:block}}.cpc-document-wrapper .cpc-document_name{margin:0 0 0 12px;line-height:24px}@media screen and (min-width: 992px){.cpc-document-wrapper .cpc-document_name{margin:0 0 0 26px}}.cpc-document-wrapper .cpc-document_date{margin-left:12px;-webkit-user-select:none;user-select:none}.cpc-document-wrapper .cpc-document_size{margin:0 8px 0 auto}.cpc-document{display:flex;flex-wrap:wrap}.cpc-document .cpc-document-list{width:100%;overflow:hidden}.cpc-document .cpc-document{background-color:var(--cpc-colors-white-smoke)}.cpc-document .cpc-document .cpc-document_icon{color:var(--cpc-colors-sonic-silver)}.cpc-document .cpc-document .cpc-document-wrapper .cpc-document_name-wrapper{padding-left:16px}@media screen and (min-width: 992px){.cpc-document .cpc-document .cpc-document-wrapper .cpc-document_name-wrapper{padding-left:64px}}.cpc-documents-hidden{height:0;opacity:0}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }]; }, { name: [{
            type: Input
        }], date: [{
            type: Input
        }], drawerOpenModel: [{
            type: Input
        }], showDate: [{
            type: Input
        }], isDownloadable: [{
            type: Input
        }], copyDownload: [{
            type: Input
        }], drawerOpenModelChange: [{
            type: Output
        }], clickDownload: [{
            type: Output
        }], documents: [{
            type: ViewChild,
            args: ['documents']
        }], documentsQuery: [{
            type: ViewChildren,
            args: ['documents']
        }] }); })();

function DocumentsComponent_label_3_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label", 3)(1, "input", 4);
    i0.ɵɵlistener("change", function DocumentsComponent_label_3_Template_input_change_1_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.fileUploaded($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "span", 5);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "cpc-icon", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("multiple", ctx_r0.isUploadMultiple)("accept", ctx_r0.uploadAccept ? ctx_r0.uploadAccept : "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.copyUpload, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("icon", ctx_r0.ndbxIcons.PlusCircleO);
} }
const _c0$K = ["*"];
class DocumentsComponent {
    constructor() {
        this.isUploadable = false;
        this.isUploadMultiple = false;
        this.copyUpload = 'Add Files';
        this.clickUpload = new EventEmitter();
        this.ndbxIcons = NdbxIcon;
    }
    fileUploaded(event) {
        const eventTarget = event.target;
        if (!eventTarget.files) {
            return;
        }
        this.clickUpload.emit(eventTarget.files);
    }
}
DocumentsComponent.ɵfac = function DocumentsComponent_Factory(t) { return new (t || DocumentsComponent)(); };
DocumentsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DocumentsComponent, selectors: [["cpc-documents"]], inputs: { title: "title", isUploadable: "isUploadable", isUploadMultiple: "isUploadMultiple", uploadAccept: "uploadAccept", copyUpload: "copyUpload" }, outputs: { clickUpload: "clickUpload" }, ngContentSelectors: _c0$K, decls: 5, vars: 2, consts: [[1, "cpc-documents"], [1, "cpc-documents_title"], ["class", "cpc-documents_upload", 4, "ngIf"], [1, "cpc-documents_upload"], ["type", "file", 3, "multiple", "accept", "change"], [1, "cpc-document_upload-text"], [1, "cpc-document_icon", 3, "icon"]], template: function DocumentsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div", 0)(1, "h2", 1);
        i0.ɵɵtext(2);
        i0.ɵɵtemplate(3, DocumentsComponent_label_3_Template, 5, 4, "label", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵprojection(4);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.title, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isUploadable);
    } }, dependencies: [i1.NgIf, IconComponent], styles: ["cpc-documents{width:100%}.cpc-documents{margin:32px 0}.cpc-documents_title{padding-bottom:10px;font-weight:400;font-size:24px;line-height:32px;letter-spacing:.2px;border-bottom:1px solid var(--cpc-colors-light-gray)}.cpc-documents_upload{background:transparent;border:none;border-radius:0;cursor:pointer;-webkit-appearance:none;appearance:none;transition:all 125ms linear;display:flex;align-items:center;justify-content:center;float:right;margin-right:0;color:var(--cpc-colors-resolution-blue);font-weight:600;font-size:16px;line-height:24px}.cpc-documents_upload:focus,.cpc-documents_upload.pseudo-states--focus{outline:0;box-shadow:var(--focus-box-shadow, 0 0 0 2px #fff, 0 0 0 6px #009de6)}.cpc-documents_upload:disabled,.cpc-documents_upload.pseudo-states--disabled{cursor:not-allowed;pointer-events:none}.cpc-documents_upload:disabled,.cpc-documents_upload.cpc--disabled,.cpc-documents_upload.pseudo-states--disabled{cursor:not-allowed;pointer-events:none}.cpc-documents_upload .cpc-document_upload-text{display:none}@media screen and (min-width: 704px){.cpc-documents_upload .cpc-document_upload-text{display:block}}.cpc-documents_upload input{display:none}.cpc-documents_upload .cpc-document_icon{margin-right:0;margin-left:8px;color:var(--cpc-colors-resolution-blue)!important;font-size:24px}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DocumentsComponent, [{
        type: Component,
        args: [{ selector: 'cpc-documents', encapsulation: ViewEncapsulation.None, template: "<div class=\"cpc-documents\">\r\n  <h2 class=\"cpc-documents_title\">\r\n    {{title}}\r\n    <label\r\n      *ngIf=\"isUploadable\"\r\n      class=\"cpc-documents_upload\"\r\n    >\r\n      <input\r\n        [multiple]=\"isUploadMultiple\"\r\n        [accept]=\"uploadAccept ? uploadAccept : '' \"\r\n        (change)=\"fileUploaded($event)\"\r\n        type=\"file\"\r\n      />\r\n      <span class=\"cpc-document_upload-text\">\r\n        {{ copyUpload }}\r\n      </span>\r\n      <cpc-icon [icon]=\"ndbxIcons.PlusCircleO\" class=\"cpc-document_icon\"></cpc-icon>\r\n    </label>\r\n  </h2>\r\n  <ng-content></ng-content>\r\n</div>\r\n", styles: ["cpc-documents{width:100%}.cpc-documents{margin:32px 0}.cpc-documents_title{padding-bottom:10px;font-weight:400;font-size:24px;line-height:32px;letter-spacing:.2px;border-bottom:1px solid var(--cpc-colors-light-gray)}.cpc-documents_upload{background:transparent;border:none;border-radius:0;cursor:pointer;-webkit-appearance:none;appearance:none;transition:all 125ms linear;display:flex;align-items:center;justify-content:center;float:right;margin-right:0;color:var(--cpc-colors-resolution-blue);font-weight:600;font-size:16px;line-height:24px}.cpc-documents_upload:focus,.cpc-documents_upload.pseudo-states--focus{outline:0;box-shadow:var(--focus-box-shadow, 0 0 0 2px #fff, 0 0 0 6px #009de6)}.cpc-documents_upload:disabled,.cpc-documents_upload.pseudo-states--disabled{cursor:not-allowed;pointer-events:none}.cpc-documents_upload:disabled,.cpc-documents_upload.cpc--disabled,.cpc-documents_upload.pseudo-states--disabled{cursor:not-allowed;pointer-events:none}.cpc-documents_upload .cpc-document_upload-text{display:none}@media screen and (min-width: 704px){.cpc-documents_upload .cpc-document_upload-text{display:block}}.cpc-documents_upload input{display:none}.cpc-documents_upload .cpc-document_icon{margin-right:0;margin-left:8px;color:var(--cpc-colors-resolution-blue)!important;font-size:24px}\n"] }]
    }], null, { title: [{
            type: Input
        }], isUploadable: [{
            type: Input
        }], isUploadMultiple: [{
            type: Input
        }], uploadAccept: [{
            type: Input
        }], copyUpload: [{
            type: Input
        }], clickUpload: [{
            type: Output
        }] }); })();

function DropdownDrawerComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵprojection(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("@cpcSlideOrScaleAnimation", ctx_r0.animationType)("@.disabled", ctx_r0.animationType === undefined);
} }
const _c0$J = function () { return { visibility: "hidden" }; };
const _c1$o = function (a0) { return { "cpc-dropdown-drawer-wrapper_mobile-border": a0 }; };
const _c2$7 = ["*"];
class DropdownDrawerComponent {
    constructor() {
        this.drawerOpenModel = true;
        this.isMobileBorder = false;
        this.drawerOpenModelChange = new EventEmitter();
    }
    get animationType() {
        this.mediaQuery = setMatchMedia(Breakpoints.large);
        if (this.mediaQuery) {
            return this.mediaQuery.matches ? 'scale' : 'slide';
        }
        else {
            return null;
        }
    }
    clickedOutside(event) {
        if (!this.drawerOpenModel) {
            return;
        }
        if (this.parentElement && this.parentElement instanceof HTMLDivElement && !this.parentElement.contains(event.target)) {
            this.drawerOpenModel = false;
            this.drawerOpenModelChange.emit(false);
        }
    }
    handleOpen() {
        this.drawerOpenModelChange.emit(this.drawerOpenModel);
    }
}
DropdownDrawerComponent.ɵfac = function DropdownDrawerComponent_Factory(t) { return new (t || DropdownDrawerComponent)(); };
DropdownDrawerComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DropdownDrawerComponent, selectors: [["cpc-dropdown-drawer"]], hostBindings: function DropdownDrawerComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("click", function DropdownDrawerComponent_click_HostBindingHandler($event) { return ctx.clickedOutside($event); }, false, i0.ɵɵresolveDocument);
    } }, inputs: { drawerOpenModel: "drawerOpenModel", isMobileBorder: "isMobileBorder", parentElement: "parentElement" }, outputs: { drawerOpenModelChange: "drawerOpenModelChange" }, ngContentSelectors: _c2$7, decls: 2, vars: 6, consts: [[1, "cpc-dropdown-drawer-wrapper", 3, "ngStyle", "ngClass"], ["class", "cpc-dropdown-drawer", 4, "ngIf"], [1, "cpc-dropdown-drawer"]], template: function DropdownDrawerComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, DropdownDrawerComponent_div_1_Template, 2, 2, "div", 1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngStyle", !ctx.drawerOpenModel ? i0.ɵɵpureFunction0(3, _c0$J) : null)("ngClass", i0.ɵɵpureFunction1(4, _c1$o, ctx.isMobileBorder));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.drawerOpenModel);
    } }, dependencies: [i1.NgClass, i1.NgIf, i1.NgStyle], styles: [".cpc-dropdown-drawer-wrapper{position:absolute;top:68px;left:0;z-index:1050;display:block;width:100%;min-width:180px}@media screen and (min-width: 992px){.cpc-dropdown-drawer-wrapper{top:calc(100% + 10px);left:50%;width:auto;transform:translate(-50%)}}.cpc-dropdown-drawer{position:relative;z-index:1030;display:block;overflow:hidden;text-align:left}@media screen and (min-width: 992px){.cpc-dropdown-drawer{padding:16px;overflow:unset;background:var(--cpc-colors-white);border:var(--cpc-border);border-radius:4px;box-shadow:0 8px 24px #41414159}.cpc-dropdown-drawer:after{position:absolute;top:-7px;left:45%;width:12px;height:12px;background:var(--cpc-colors-white);border:1px solid var(--cpc-colors-border);border-width:1px 0 0 1px;transform:rotate(45deg);content:\"\"}}.cpc-dropdown-drawer .cpc-button-content{align-items:end}.cpc-dropdown-drawer .cpc-button-content cpc-icon{margin-top:3px}.cpc-dropdown-drawer-wrapper_mobile-border{top:calc(100% + 10px);left:50%;transform:translate(-50%)}.cpc-dropdown-drawer-wrapper_mobile-border .cpc-dropdown-drawer{display:flex;flex-direction:column;background:var(--cpc-colors-white);border:var(--cpc-border);border-radius:4px}@media screen and (min-width: 0) and (max-width: 991.98px){.cpc-dropdown-drawer-wrapper_mobile-border .cpc-dropdown-drawer{padding:24px 8px}}.cpc-dropdown-drawer-wrapper_mobile-border .cpc-dropdown-drawer:after{position:absolute;top:-7px;left:45%;width:12px;height:12px;background:var(--cpc-colors-white);border:1px solid var(--cpc-colors-border);border-width:1px 0 0 1px;transform:rotate(45deg);content:\"\"}\n"], encapsulation: 2, data: { animation: [animationBuilder(AngularAnimationsTypes.SLIDE_OR_SCALE)] } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DropdownDrawerComponent, [{
        type: Component,
        args: [{ selector: 'cpc-dropdown-drawer', animations: [animationBuilder(AngularAnimationsTypes.SLIDE_OR_SCALE)], encapsulation: ViewEncapsulation.None, template: "<div\r\n  [ngStyle]=\"!drawerOpenModel ? {visibility: 'hidden'} : null\"\r\n  [ngClass]=\"{'cpc-dropdown-drawer-wrapper_mobile-border': isMobileBorder}\"\r\n  class='cpc-dropdown-drawer-wrapper'\r\n>\r\n  <div\r\n    *ngIf=\"drawerOpenModel\"\r\n    [@cpcSlideOrScaleAnimation]=\"animationType\"\r\n    [@.disabled]=\"animationType === undefined\"\r\n    class=\"cpc-dropdown-drawer\"\r\n  >\r\n    <ng-content></ng-content>\r\n  </div>\r\n</div>\r\n", styles: [".cpc-dropdown-drawer-wrapper{position:absolute;top:68px;left:0;z-index:1050;display:block;width:100%;min-width:180px}@media screen and (min-width: 992px){.cpc-dropdown-drawer-wrapper{top:calc(100% + 10px);left:50%;width:auto;transform:translate(-50%)}}.cpc-dropdown-drawer{position:relative;z-index:1030;display:block;overflow:hidden;text-align:left}@media screen and (min-width: 992px){.cpc-dropdown-drawer{padding:16px;overflow:unset;background:var(--cpc-colors-white);border:var(--cpc-border);border-radius:4px;box-shadow:0 8px 24px #41414159}.cpc-dropdown-drawer:after{position:absolute;top:-7px;left:45%;width:12px;height:12px;background:var(--cpc-colors-white);border:1px solid var(--cpc-colors-border);border-width:1px 0 0 1px;transform:rotate(45deg);content:\"\"}}.cpc-dropdown-drawer .cpc-button-content{align-items:end}.cpc-dropdown-drawer .cpc-button-content cpc-icon{margin-top:3px}.cpc-dropdown-drawer-wrapper_mobile-border{top:calc(100% + 10px);left:50%;transform:translate(-50%)}.cpc-dropdown-drawer-wrapper_mobile-border .cpc-dropdown-drawer{display:flex;flex-direction:column;background:var(--cpc-colors-white);border:var(--cpc-border);border-radius:4px}@media screen and (min-width: 0) and (max-width: 991.98px){.cpc-dropdown-drawer-wrapper_mobile-border .cpc-dropdown-drawer{padding:24px 8px}}.cpc-dropdown-drawer-wrapper_mobile-border .cpc-dropdown-drawer:after{position:absolute;top:-7px;left:45%;width:12px;height:12px;background:var(--cpc-colors-white);border:1px solid var(--cpc-colors-border);border-width:1px 0 0 1px;transform:rotate(45deg);content:\"\"}\n"] }]
    }], null, { drawerOpenModel: [{
            type: Input
        }], isMobileBorder: [{
            type: Input
        }], parentElement: [{
            type: Input
        }], drawerOpenModelChange: [{
            type: Output
        }], clickedOutside: [{
            type: HostListener,
            args: ['document:click', ['$event']]
        }] }); })();

function HelpModalContentComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵprojection(0);
} }
const _c0$I = ["*"];
class HelpModalContentComponent {
    constructor(cdr) {
        this.cdr = cdr;
    }
    ngAfterViewInit() {
        this.cdr.detectChanges();
    }
}
HelpModalContentComponent.ɵfac = function HelpModalContentComponent_Factory(t) { return new (t || HelpModalContentComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
HelpModalContentComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HelpModalContentComponent, selectors: [["cpc-help-modal-content"]], viewQuery: function HelpModalContentComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(TemplateRef, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.template = _t.first);
    } }, inputs: { title: "title" }, ngContentSelectors: _c0$I, decls: 1, vars: 0, template: function HelpModalContentComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵtemplate(0, HelpModalContentComponent_ng_template_0_Template, 1, 0, "ng-template");
    } }, encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HelpModalContentComponent, [{
        type: Component,
        args: [{ selector: 'cpc-help-modal-content', encapsulation: ViewEncapsulation.None, template: "<ng-template>\r\n  <ng-content></ng-content>\r\n</ng-template>\r\n" }]
    }], function () { return [{ type: i0.ChangeDetectorRef }]; }, { title: [{
            type: Input
        }], template: [{
            type: ViewChild,
            args: [TemplateRef]
        }] }); })();

const _c0$H = ["buttonsWrapper"];
const _c1$n = function (a0) { return { "cpc-help-modal-group_selected-index": a0 }; };
const _c2$6 = function (a0) { return { "cpc-help-modal-group_icon-selected": a0 }; };
function HelpModalGroupComponent_div_1_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 7);
    i0.ɵɵlistener("click", function HelpModalGroupComponent_div_1_button_2_Template_button_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r7); const i_r5 = restoredCtx.index; const ctx_r6 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r6.handleChangeSelectedContent(i_r5)); });
    i0.ɵɵtext(1);
    i0.ɵɵelement(2, "cpc-icon", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const button_r4 = ctx.$implicit;
    const i_r5 = ctx.index;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c1$n, i_r5 === ctx_r3.selectedContent));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", button_r4.title, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c2$6, i_r5 === ctx_r3.selectedContent))("icon", ctx_r3.ndbxIcons.ArrowRight);
} }
function HelpModalGroupComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4, 5);
    i0.ɵɵtemplate(2, HelpModalGroupComponent_div_1_button_2_Template, 3, 8, "button", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.contents);
} }
function HelpModalGroupComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
class HelpModalGroupComponent {
    constructor(cdr) {
        this.cdr = cdr;
        this.selectedContent = 0;
        this.childrenCount = 0;
        this.withoutButtons = false;
        this.questionClicked = new EventEmitter();
        this.ndbxIcons = NdbxIcon;
    }
    ngAfterContentInit() {
        this.updateContents();
    }
    ngAfterContentChecked() {
        this.updateContents();
    }
    ngOnInit() {
        this.questionClicked.emit(this.selectedContent);
    }
    updateContents() {
        this.contents = this.childrenButtons.toArray();
        this.selectedContent = clamp(this.selectedContent, 0, this.contents.length - 1);
        this.cdr.detectChanges();
    }
    handleChangeSelectedContent(selectedIndex) {
        if (this.selectedContent !== selectedIndex) {
            this.questionClicked.emit(selectedIndex);
            this.selectedContent = selectedIndex;
        }
        blurRefChildren(this.buttonsWrapper);
    }
}
HelpModalGroupComponent.ɵfac = function HelpModalGroupComponent_Factory(t) { return new (t || HelpModalGroupComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
HelpModalGroupComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HelpModalGroupComponent, selectors: [["cpc-help-modal-group"]], contentQueries: function HelpModalGroupComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        i0.ɵɵcontentQuery(dirIndex, HelpModalContentComponent, 4);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.childrenButtons = _t);
    } }, viewQuery: function HelpModalGroupComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$H, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.buttonsWrapper = _t.first);
    } }, inputs: { selectedContent: "selectedContent", childrenCount: "childrenCount", withoutButtons: "withoutButtons" }, outputs: { questionClicked: "questionClicked" }, decls: 4, vars: 2, consts: [[1, "cpc-help-modal-group"], ["class", "cpc-help-modal-group_list", 4, "ngIf"], [1, "cpc-help-modal-group_content"], [4, "ngTemplateOutlet"], [1, "cpc-help-modal-group_list"], ["buttonsWrapper", ""], ["class", "cpc-help-modal-group_list-button", 3, "ngClass", "click", 4, "ngFor", "ngForOf"], [1, "cpc-help-modal-group_list-button", 3, "ngClass", "click"], [1, "cpc-help-modal-group_icon", 3, "ngClass", "icon"]], template: function HelpModalGroupComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, HelpModalGroupComponent_div_1_Template, 3, 1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtemplate(3, HelpModalGroupComponent_ng_container_3_Template, 1, 0, "ng-container", 3);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.withoutButtons);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngTemplateOutlet", ctx.contents[ctx.selectedContent].template);
    } }, dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet, IconComponent], styles: [".cpc-help-modal-group{display:flex;flex-direction:column}@media screen and (min-width: 704px){.cpc-help-modal-group{flex-direction:row;max-height:230px;overflow:hidden}}.cpc-help-modal-group .cpc-help-modal-group_list,.cpc-help-modal-group .cpc-help-modal-group_content{width:100%;max-width:100%;margin:0 16px;padding:0 16px 32px}@media screen and (min-width: 704px){.cpc-help-modal-group .cpc-help-modal-group_list,.cpc-help-modal-group .cpc-help-modal-group_content{width:50%;min-width:370px;max-width:50%;padding:0 16px;overflow-y:auto}}.cpc-help-modal-group .cpc-help-modal-group_list{display:flex;flex-direction:column}.cpc-help-modal-group .cpc-help-modal-group_list .cpc-help-modal-group_list-button{background:transparent;border:none;border-radius:0;cursor:pointer;-webkit-appearance:none;appearance:none;transition:all 125ms linear;display:flex;align-items:center;justify-content:space-between;padding:6px 9px;color:var(--help-modal-content-color);font-size:var(--help-modal-content-list-font-size);line-height:var(--help-modal-line-height);text-align:left;border-bottom:solid 1px var(--help-modal-content-border-color);--icon-size: var(--help-modal-icon-size)}.cpc-help-modal-group .cpc-help-modal-group_list .cpc-help-modal-group_list-button:focus,.cpc-help-modal-group .cpc-help-modal-group_list .cpc-help-modal-group_list-button.pseudo-states--focus{outline:0;box-shadow:var(--focus-inset-box-shadow, inset 0 0 0 4px #009de6, inset 0 0 0 6px #fff)}.cpc-help-modal-group .cpc-help-modal-group_list .cpc-help-modal-group_list-button>*{display:inline-block}.cpc-help-modal-group .cpc-help-modal-group_list .cpc-help-modal-group_list-button:last-child{border-bottom:none}.cpc-help-modal-group .cpc-help-modal-group_list .cpc-help-modal-group_list-button.cpc-help-modal-group_selected-index{font-weight:var(--help-modal-content-selected)}.cpc-help-modal-group .cpc-help-modal-group_list .cpc-help-modal-group_icon{opacity:0}.cpc-help-modal-group .cpc-help-modal-group_list .cpc-help-modal-group_icon.cpc-help-modal-group_icon-selected{opacity:1}.cpc-help-modal-group .cpc-help-modal-group_content{padding:6px 25px;font-size:var(--help-modal-content-font-size)}@media screen and (min-width: 704px){.cpc-help-modal-group .cpc-help-modal-group_content{max-width:var(--help-modal-group-content-max-width);padding:0}}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HelpModalGroupComponent, [{
        type: Component,
        args: [{ selector: 'cpc-help-modal-group', encapsulation: ViewEncapsulation.None, template: "<div class=\"cpc-help-modal-group\">\r\n  <div *ngIf=\"!withoutButtons\"\r\n    #buttonsWrapper\r\n    class=\"cpc-help-modal-group_list\"\r\n  >\r\n    <button\r\n      *ngFor=\"let button of contents; let i = index\"\r\n      [ngClass]=\"{ 'cpc-help-modal-group_selected-index': i === selectedContent }\"\r\n      (click)=\"handleChangeSelectedContent(i)\"\r\n      class=\"cpc-help-modal-group_list-button\"\r\n    >\r\n      {{button.title}}\r\n      <cpc-icon\r\n        [ngClass]=\"{ 'cpc-help-modal-group_icon-selected': i === selectedContent }\"\r\n        [icon]=\"ndbxIcons.ArrowRight\"\r\n        class=\"cpc-help-modal-group_icon\"\r\n      ></cpc-icon>\r\n    </button>\r\n  </div>\r\n  <div class=\"cpc-help-modal-group_content\">\r\n    <ng-container *ngTemplateOutlet=\"contents[selectedContent].template\"></ng-container>\r\n  </div>\r\n</div>\r\n", styles: [".cpc-help-modal-group{display:flex;flex-direction:column}@media screen and (min-width: 704px){.cpc-help-modal-group{flex-direction:row;max-height:230px;overflow:hidden}}.cpc-help-modal-group .cpc-help-modal-group_list,.cpc-help-modal-group .cpc-help-modal-group_content{width:100%;max-width:100%;margin:0 16px;padding:0 16px 32px}@media screen and (min-width: 704px){.cpc-help-modal-group .cpc-help-modal-group_list,.cpc-help-modal-group .cpc-help-modal-group_content{width:50%;min-width:370px;max-width:50%;padding:0 16px;overflow-y:auto}}.cpc-help-modal-group .cpc-help-modal-group_list{display:flex;flex-direction:column}.cpc-help-modal-group .cpc-help-modal-group_list .cpc-help-modal-group_list-button{background:transparent;border:none;border-radius:0;cursor:pointer;-webkit-appearance:none;appearance:none;transition:all 125ms linear;display:flex;align-items:center;justify-content:space-between;padding:6px 9px;color:var(--help-modal-content-color);font-size:var(--help-modal-content-list-font-size);line-height:var(--help-modal-line-height);text-align:left;border-bottom:solid 1px var(--help-modal-content-border-color);--icon-size: var(--help-modal-icon-size)}.cpc-help-modal-group .cpc-help-modal-group_list .cpc-help-modal-group_list-button:focus,.cpc-help-modal-group .cpc-help-modal-group_list .cpc-help-modal-group_list-button.pseudo-states--focus{outline:0;box-shadow:var(--focus-inset-box-shadow, inset 0 0 0 4px #009de6, inset 0 0 0 6px #fff)}.cpc-help-modal-group .cpc-help-modal-group_list .cpc-help-modal-group_list-button>*{display:inline-block}.cpc-help-modal-group .cpc-help-modal-group_list .cpc-help-modal-group_list-button:last-child{border-bottom:none}.cpc-help-modal-group .cpc-help-modal-group_list .cpc-help-modal-group_list-button.cpc-help-modal-group_selected-index{font-weight:var(--help-modal-content-selected)}.cpc-help-modal-group .cpc-help-modal-group_list .cpc-help-modal-group_icon{opacity:0}.cpc-help-modal-group .cpc-help-modal-group_list .cpc-help-modal-group_icon.cpc-help-modal-group_icon-selected{opacity:1}.cpc-help-modal-group .cpc-help-modal-group_content{padding:6px 25px;font-size:var(--help-modal-content-font-size)}@media screen and (min-width: 704px){.cpc-help-modal-group .cpc-help-modal-group_content{max-width:var(--help-modal-group-content-max-width);padding:0}}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }]; }, { selectedContent: [{
            type: Input
        }], childrenCount: [{
            type: Input
        }], withoutButtons: [{
            type: Input
        }], questionClicked: [{
            type: Output
        }], childrenButtons: [{
            type: ContentChildren,
            args: [HelpModalContentComponent]
        }], buttonsWrapper: [{
            type: ViewChild,
            args: ['buttonsWrapper']
        }] }); })();

const _c0$G = ["button"];
function HelpModalComponent_button_0_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 2, 3);
    i0.ɵɵlistener("click", function HelpModalComponent_button_0_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.handleClickFAB()); });
    i0.ɵɵelement(2, "cpc-icon", 4);
    i0.ɵɵelementStart(3, "p", 5);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("icon", ctx_r0.ndbxIcons.InfoCircle);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.buttonText, " ");
} }
function HelpModalComponent_div_1_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 10);
    i0.ɵɵlistener("click", function HelpModalComponent_div_1_button_2_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r7.toggleHelpModalContent(false)); });
    i0.ɵɵelement(1, "cpc-icon", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("icon", ctx_r5.ndbxIcons.Close);
} }
function HelpModalComponent_div_1_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12)(1, "span", 13);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementStart(4, "a", 14);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r6.phoneText);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r6.callUsText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("href", ctx_r6.link, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r6.phoneNumber);
} }
function HelpModalComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6)(1, "div", 7);
    i0.ɵɵtemplate(2, HelpModalComponent_div_1_button_2_Template, 2, 1, "button", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵprojection(3);
    i0.ɵɵtemplate(4, HelpModalComponent_div_1_div_4_Template, 6, 4, "div", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.showCloseButton);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.phoneNumber.length !== 0);
} }
const _c1$m = ["*"];
class HelpModalComponent {
    constructor(cdr) {
        this.cdr = cdr;
        this.phoneNumber = '';
        this.callUsText = 'Call us:';
        this.phoneText = 'Need Help?';
        this.showCloseButton = true;
        this.buttonClicked = new EventEmitter();
        this.displayHelpModalContentChange = new EventEmitter();
        this.displayHelpModalContent = false;
        this.wasClicked = false;
        this.ndbxIcons = NdbxIcon;
        this.link = '';
    }
    clickedOutside(event) {
        if (this.parentElement && !this.parentElement.contains(event.target)) {
            this.displayHelpModalContent = false;
            this.displayHelpModalContentChange.emit(false);
        }
    }
    ngOnInit() {
        this.buttonClicked.emit(this.wasClicked);
    }
    ngOnChanges() {
        if (this.childrenGroupsComponents || this.childrenFooterComponents) {
            this.updateComponents();
        }
        this.link = 'tel:' + this.phoneNumberAsNumber();
    }
    ngAfterViewInit() {
        this.updateComponents();
    }
    updateComponents() {
        const groupComponents = this.childrenGroupsComponents.toArray();
        const footerComponents = this.childrenFooterComponents.toArray();
        this.components = [...groupComponents, ...footerComponents];
        this.cdr.detectChanges();
    }
    toggleHelpModalContent(visibility = !this.displayHelpModalContent) {
        this.displayHelpModalContent = visibility;
    }
    phoneNumberAsNumber() {
        return this.phoneNumber.replace(/\+/g, '00').replace(/\D+/g, '');
    }
    handleClickFAB() {
        this.toggleHelpModalContent(true);
        this.button.nativeElement.blur();
        this.wasClicked = true;
        this.buttonClicked.emit(this.wasClicked);
    }
}
HelpModalComponent.ɵfac = function HelpModalComponent_Factory(t) { return new (t || HelpModalComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
HelpModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HelpModalComponent, selectors: [["cpc-help-modal"]], contentQueries: function HelpModalComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        i0.ɵɵcontentQuery(dirIndex, HelpModalContentComponent, 4);
        i0.ɵɵcontentQuery(dirIndex, HelpModalGroupComponent, 4);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.childrenGroupsComponents = _t);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.childrenFooterComponents = _t);
    } }, viewQuery: function HelpModalComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$G, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.button = _t.first);
    } }, hostBindings: function HelpModalComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("click", function HelpModalComponent_click_HostBindingHandler($event) { return ctx.clickedOutside($event); }, false, i0.ɵɵresolveDocument);
    } }, inputs: { parentElement: "parentElement", buttonText: "buttonText", phoneNumber: "phoneNumber", callUsText: "callUsText", phoneText: "phoneText", showCloseButton: "showCloseButton" }, outputs: { buttonClicked: "buttonClicked", displayHelpModalContentChange: "displayHelpModalContentChange" }, features: [i0.ɵɵNgOnChangesFeature], ngContentSelectors: _c1$m, decls: 2, vars: 2, consts: [["class", "cpc-help-modal_fab", 3, "click", 4, "ngIf"], ["class", "cpc-help-modal", 4, "ngIf"], [1, "cpc-help-modal_fab", 3, "click"], ["button", ""], [1, "cpc-help-modal_icon-info-circle", 2, "--icon-size", "var(--help-modal-icon-info-size)", 3, "icon"], [1, "cpc-help-modal_fab-text"], [1, "cpc-help-modal"], [1, "cpc-help-modal_buttons"], ["class", "cpc-help-modal_close-button", 3, "click", 4, "ngIf"], ["class", "cpc-help-modal_phone", 4, "ngIf"], [1, "cpc-help-modal_close-button", 3, "click"], [3, "icon"], [1, "cpc-help-modal_phone"], [1, "cpc-help-modal_phone-bold"], [1, "cpc-help-modal_phone-link", 3, "href"]], template: function HelpModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵtemplate(0, HelpModalComponent_button_0_Template, 5, 2, "button", 0);
        i0.ɵɵtemplate(1, HelpModalComponent_div_1_Template, 5, 2, "div", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", !ctx.displayHelpModalContent);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.displayHelpModalContent);
    } }, dependencies: [i1.NgIf, IconComponent], styles: [".cpc-help-modal_fab{background:transparent;border:none;cursor:pointer;-webkit-appearance:none;appearance:none;position:fixed;right:20px;bottom:var(--help-modal-position-bottom);z-index:1010;height:40px;padding:0;background-color:var(--help-modal-background-color);border-radius:50%;transition:all 125ms linear}.cpc-help-modal_fab:focus,.cpc-help-modal_fab.pseudo-states--focus{outline:0;box-shadow:var(--focus-box-shadow, 0 0 0 2px #fff, 0 0 0 6px #009de6)}@media screen and (min-width: 992px){.cpc-help-modal_fab{right:40px;height:auto;padding:12px 32px;border-radius:24px;box-shadow:0 2px 12px #41414133}}.cpc-help-modal_fab-text{display:none;margin:0;color:var(--help-modal-fab-color);font-weight:var(--help-modal-font-weight);font-size:var(--help-modal-font-size);line-height:var(--help-modal-line-height);letter-spacing:var(--help-modal-letter-spacing);text-transform:uppercase}@media screen and (min-width: 992px){.cpc-help-modal_fab-text{display:block}}@media screen and (min-width: 992px){.cpc-help-modal_icon-info-circle{display:none}}.cpc-help-modal_icon-info-circle .cpc-ndbx-icon{color:var(--help-modal-icon-info-color);background:var(--help-modal-icon-info-background);border-radius:50%;--icon-size: var(--help-modal-icon-info-size)}.cpc-help-modal{position:fixed;bottom:var(--help-modal-position-bottom);z-index:1010;width:var(--help-modal-width);min-width:var(--help-modal-min-width);max-height:calc(100vh - (var(--help-modal-position-bottom)));padding:10px 12px;overflow-x:hidden;overflow-y:auto;background:var(--help-modal-background-color);border-radius:6px;box-shadow:0 0 8px 2px var(--help-modal-box-shadow-color)}@media screen and (min-width: 704px){.cpc-help-modal{right:40px;width:calc(var(--help-modal-width) - 24px);max-width:var(--help-modal-max-width);height:-moz-fit-content;height:fit-content;padding:20px 32px;overflow:hidden;transform:translate(0)}}@media screen and (min-width: 992px){.cpc-help-modal{bottom:var(--help-modal-position-bottom);width:auto}}.cpc-help-modal .cpc-help-modal_buttons{display:flex;align-items:center;justify-content:flex-end;width:100%;padding:0 0 6px}.cpc-help-modal .cpc-help-modal_buttons .cpc-help-modal_close-button{background:transparent;border:none;cursor:pointer;-webkit-appearance:none;appearance:none;padding:0;color:#414141;border-radius:6px;--icon-size: var(--help-modal-icon-size);transition:all 125ms linear}.cpc-help-modal .cpc-help-modal_buttons .cpc-help-modal_close-button:focus,.cpc-help-modal .cpc-help-modal_buttons .cpc-help-modal_close-button.pseudo-states--focus{outline:0;box-shadow:var(--focus-box-shadow, 0 0 0 2px #fff, 0 0 0 6px #009de6)}.cpc-help-modal_phone{margin:16px 16px 0;padding-top:16px;font-size:16px;line-height:24px;letter-spacing:1px;text-align:center;border-top:1px solid gray}.cpc-help-modal_phone-link{color:var(--cpc-colors-resolution-blue)!important;text-decoration:none}.cpc-help-modal_phone-bold{font-weight:700}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HelpModalComponent, [{
        type: Component,
        args: [{ selector: 'cpc-help-modal', encapsulation: ViewEncapsulation.None, template: "<button\r\n  *ngIf=\"!displayHelpModalContent\"\r\n  (click)=\"handleClickFAB()\"\r\n  #button\r\n  class=\"cpc-help-modal_fab\"\r\n>\r\n  <cpc-icon\r\n    class=\"cpc-help-modal_icon-info-circle\"\r\n    [icon]=\"ndbxIcons.InfoCircle\"\r\n    style=\"--icon-size: var(--help-modal-icon-info-size)\"\r\n  ></cpc-icon>\r\n  <p class=\"cpc-help-modal_fab-text\">\r\n    {{buttonText}}\r\n  </p>\r\n</button>\r\n\r\n<div\r\n  *ngIf=\"displayHelpModalContent\"\r\n  class=\"cpc-help-modal\"\r\n>\r\n  <div class=\"cpc-help-modal_buttons\">\r\n    <button\r\n      *ngIf=\"showCloseButton\"\r\n      (click)=\"toggleHelpModalContent(false)\"\r\n      class=\"cpc-help-modal_close-button\"\r\n    >\r\n      <cpc-icon [icon]=\"ndbxIcons.Close\"></cpc-icon>\r\n    </button>\r\n  </div>\r\n  <ng-content></ng-content>\r\n  <div\r\n    *ngIf=\"phoneNumber.length !== 0\"\r\n    class=\"cpc-help-modal_phone\"\r\n  >\r\n    <span class=\"cpc-help-modal_phone-bold\">{{phoneText}}</span>\r\n    {{callUsText}}\r\n    <a [href]=\"link\" class=\"cpc-help-modal_phone-link\">{{phoneNumber}}</a>\r\n  </div>\r\n</div>\r\n", styles: [".cpc-help-modal_fab{background:transparent;border:none;cursor:pointer;-webkit-appearance:none;appearance:none;position:fixed;right:20px;bottom:var(--help-modal-position-bottom);z-index:1010;height:40px;padding:0;background-color:var(--help-modal-background-color);border-radius:50%;transition:all 125ms linear}.cpc-help-modal_fab:focus,.cpc-help-modal_fab.pseudo-states--focus{outline:0;box-shadow:var(--focus-box-shadow, 0 0 0 2px #fff, 0 0 0 6px #009de6)}@media screen and (min-width: 992px){.cpc-help-modal_fab{right:40px;height:auto;padding:12px 32px;border-radius:24px;box-shadow:0 2px 12px #41414133}}.cpc-help-modal_fab-text{display:none;margin:0;color:var(--help-modal-fab-color);font-weight:var(--help-modal-font-weight);font-size:var(--help-modal-font-size);line-height:var(--help-modal-line-height);letter-spacing:var(--help-modal-letter-spacing);text-transform:uppercase}@media screen and (min-width: 992px){.cpc-help-modal_fab-text{display:block}}@media screen and (min-width: 992px){.cpc-help-modal_icon-info-circle{display:none}}.cpc-help-modal_icon-info-circle .cpc-ndbx-icon{color:var(--help-modal-icon-info-color);background:var(--help-modal-icon-info-background);border-radius:50%;--icon-size: var(--help-modal-icon-info-size)}.cpc-help-modal{position:fixed;bottom:var(--help-modal-position-bottom);z-index:1010;width:var(--help-modal-width);min-width:var(--help-modal-min-width);max-height:calc(100vh - (var(--help-modal-position-bottom)));padding:10px 12px;overflow-x:hidden;overflow-y:auto;background:var(--help-modal-background-color);border-radius:6px;box-shadow:0 0 8px 2px var(--help-modal-box-shadow-color)}@media screen and (min-width: 704px){.cpc-help-modal{right:40px;width:calc(var(--help-modal-width) - 24px);max-width:var(--help-modal-max-width);height:-moz-fit-content;height:fit-content;padding:20px 32px;overflow:hidden;transform:translate(0)}}@media screen and (min-width: 992px){.cpc-help-modal{bottom:var(--help-modal-position-bottom);width:auto}}.cpc-help-modal .cpc-help-modal_buttons{display:flex;align-items:center;justify-content:flex-end;width:100%;padding:0 0 6px}.cpc-help-modal .cpc-help-modal_buttons .cpc-help-modal_close-button{background:transparent;border:none;cursor:pointer;-webkit-appearance:none;appearance:none;padding:0;color:#414141;border-radius:6px;--icon-size: var(--help-modal-icon-size);transition:all 125ms linear}.cpc-help-modal .cpc-help-modal_buttons .cpc-help-modal_close-button:focus,.cpc-help-modal .cpc-help-modal_buttons .cpc-help-modal_close-button.pseudo-states--focus{outline:0;box-shadow:var(--focus-box-shadow, 0 0 0 2px #fff, 0 0 0 6px #009de6)}.cpc-help-modal_phone{margin:16px 16px 0;padding-top:16px;font-size:16px;line-height:24px;letter-spacing:1px;text-align:center;border-top:1px solid gray}.cpc-help-modal_phone-link{color:var(--cpc-colors-resolution-blue)!important;text-decoration:none}.cpc-help-modal_phone-bold{font-weight:700}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }]; }, { childrenGroupsComponents: [{
            type: ContentChildren,
            args: [HelpModalContentComponent]
        }], childrenFooterComponents: [{
            type: ContentChildren,
            args: [HelpModalGroupComponent]
        }], parentElement: [{
            type: Input
        }], buttonText: [{
            type: Input
        }], phoneNumber: [{
            type: Input
        }], callUsText: [{
            type: Input
        }], phoneText: [{
            type: Input
        }], showCloseButton: [{
            type: Input
        }], buttonClicked: [{
            type: Output
        }], button: [{
            type: ViewChild,
            args: ['button']
        }], displayHelpModalContentChange: [{
            type: Output
        }], clickedOutside: [{
            type: HostListener,
            args: ['document:click', ['$event']]
        }] }); })();

var confirmationLetter = "<svg width=\"140px\" height=\"140px\" viewBox=\"0 0 140 140\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\r\n    <title>B554F811-2295-424B-A555-417AAF4711F0</title>\r\n    <g id=\"0---LOGIN-and-REGISTER\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\r\n        <g id=\"0.0_registration_step_2\" transform=\"translate(-256.000000, -424.000000)\">\r\n            <g id=\"Group-6-Copy\" transform=\"translate(160.000000, 160.000000)\">\r\n                <g id=\"LOGIN\" transform=\"translate(96.000000, 72.000000)\">\r\n                    <g id=\"illu\" transform=\"translate(0.000000, 192.000000)\">\r\n                        <circle id=\"Oval\" fill=\"#EFF6EE\" cx=\"70\" cy=\"70\" r=\"70\"></circle>\r\n                        <g id=\"sent\" transform=\"translate(15.312500, 12.395833)\" fill-rule=\"nonzero\">\r\n                            <path d=\"M108.645833,45.8649289 L108.645833,104.413937 C108.64265,110.374041 103.780113,115.205162 97.7812506,115.208333 L10.8645889,115.208333 C8.38822808,115.211487 5.98507582,114.370284 4.05830997,112.82597 L1.57770492,110.021959 C0.543235304,108.332174 -0.00211568479,106.391503 0,104.413937 L0,45.9060404 L21.7291716,64.1858711 L47.3182348,85.712451 C51.3722944,89.1236459 57.314924,89.1215378 61.3658008,85.7071803 L86.9166679,64.1753298 L108.645833,45.8649289 Z\" id=\"Path\" fill=\"#D4F2F9\"></path>\r\n                            <polygon id=\"Path\" fill=\"#BAE6F0\" points=\"108.645833 45.5766414 86.6971801 63.8832938 86.6971801 27.3005529\"></polygon>\r\n                            <path d=\"M87.2458965,27.2159738 L87.2458965,63.8107314 L61.6520129,85.3452452 C57.5943163,88.7600251 51.6416819,88.7621335 47.5807971,85.3505165 L21.9486532,63.8212739 L21.9486532,8.55856201 C21.9497162,3.83227063 25.8118609,0.00105426976 30.5763067,0 L63.4884979,0 L63.9263635,0.0432249925 L63.9263635,14.5742251 C63.9263635,19.3005165 67.789571,23.1327871 72.5540167,23.1327871 L87.2458965,23.1327871 L87.2458965,27.2159738 Z\" id=\"Path\" fill=\"#FFFFFF\"></path>\r\n                            <path d=\"M86.6971801,22.8842979 L86.6971801,22.9324645 L72.1775788,22.9324645 C67.4690014,22.9324645 63.6510943,19.126268 63.6510943,14.4321335 L63.6510943,0 L63.6973083,0.00523568441 L86.6971801,22.8842979 Z\" id=\"Path\" fill=\"#E8E8E7\"></path>\r\n                            <polygon id=\"Path\" fill=\"#BAE6F0\" points=\"21.9486532 27.3005529 21.9486532 63.8832938 0 45.6072054\"></polygon>\r\n                            <path d=\"M106.999684,110.208836 C106.337959,111.284367 105.492659,112.23698 104.502206,113.024289 C104.380535,112.951174 104.269536,112.862165 104.171344,112.761499 L76.8207591,85.1325524 C76.0800542,84.3844496 76.0896598,83.1828223 76.8431723,82.4474351 C77.5956177,81.7109881 78.807001,81.7215846 79.5477062,82.4686278 L106.898291,110.097575 C106.933512,110.132542 106.966598,110.17069 106.999684,110.208836 Z\" id=\"Path\" fill=\"#BAE6F0\"></path>\r\n                            <path d=\"M31.3235682,85.0938682 L4.44409466,112.752646 C4.3439043,112.855573 4.23211317,112.946828 4.11188495,113.024289 L1.64614899,110.201748 C1.67673333,110.163548 1.7083725,110.130654 1.74106624,110.095638 L28.6205395,82.4368599 C29.3566746,81.7206136 30.524155,81.7237969 31.2560716,82.4432264 C31.9879882,83.1626561 32.0185725,84.3373 31.3235682,85.0938682 Z\" id=\"Path\" fill=\"#BAE6F0\"></path>\r\n                            <path d=\"M73.5279882,49.4140008 C73.5279882,39.0103421 65.0524799,30.5766193 54.5972748,30.5766193 C44.1420701,30.5766193 35.6665614,39.0103421 35.6665614,49.4140008 C35.6665614,59.8176597 44.1420701,68.2513823 54.5972748,68.2513823 C65.0524799,68.2513823 73.5279882,59.8176597 73.5279882,49.4140008 Z\" id=\"Path\" fill=\"#6FE3FF\"></path>\r\n                            <path d=\"M54.6018318,30.5766193 C63.4166047,30.5797741 71.0637528,36.6363653 73.0429027,45.1839397 C75.0220527,53.7315142 70.8090945,62.5083139 62.8850977,66.3483609 C54.9600443,70.1894596 45.4193368,68.0780647 39.8770828,61.2580906 C34.333772,54.437065 34.2566349,44.7118201 39.6889948,37.8045724 C43.2785155,33.2410992 48.7785028,30.5755682 54.6018318,30.5766193 L54.6018318,30.5766193 Z\" id=\"Path\" fill=\"#3DB39E\"></path>\r\n                            <path d=\"M51.0947481,56.239139 C50.5345858,56.239139 50.0021652,55.9978607 49.6393936,55.5764139 L44.3760036,49.4886134 C43.9193379,48.9776091 43.7763633,48.2632568 44.003629,47.6184427 C44.230895,46.9746828 44.7921239,46.5016087 45.4717872,46.3814963 C46.1514508,46.2603302 46.8439178,46.5110912 47.2835117,47.036846 L51.3348175,51.7222819 L62.148614,43.0373153 C62.6756997,42.5947958 63.404444,42.4694156 64.0531651,42.7075329 C64.7018862,42.9467041 65.1692216,43.51355 65.274852,44.1889189 C65.3804826,44.865341 65.1073369,45.5438705 64.5621123,45.9653174 L52.3004303,55.815585 C51.960065,56.0895252 51.534342,56.239139 51.0947481,56.239139 Z\" id=\"Path\" fill=\"#FFFFFF\"></path>\r\n                        </g>\r\n                    </g>\r\n                </g>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>";
var forbidden = "<svg width=\"361px\" height=\"200px\" viewBox=\"0 0 361 200\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\r\n    <title>woman_with_locked_computer</title>\r\n    <defs>\r\n        <polygon id=\"path-1\" points=\"0 0 361 0 361 36.0129355 0 36.0129355\"></polygon>\r\n    </defs>\r\n    <g id=\"0---LOGIN-and-REGISTER\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\r\n        <g id=\"0.4-403-page\" transform=\"translate(-540.000000, -234.000000)\">\r\n            <g id=\"Group\" transform=\"translate(452.000000, 234.000000)\">\r\n                <g id=\"woman_with_locked_computer\" transform=\"translate(88.000000, 0.000000)\">\r\n                    <path d=\"M85.4588561,141.922529 C55.4080279,133.970909 41.0015538,105.40556 51.6532862,90.3023211 C58.7162946,80.2853767 60.8463187,81.1305387 64.2899786,74.3071455 C67.7320266,67.4837523 62.4565299,62.0708442 65.4956222,52.1337386 C70.3318971,40.5845347 76.0764343,43.9200215 79.7264076,36.2111437 C83.3787985,28.5046852 80.3171407,7.25708549 100.923492,1.3215963 C113.718143,-2.36308441 125.825352,1.38449959 134.447799,16.0135449 C147.831571,38.7143717 182.201279,37.5692094 142.744658,93.7902275 C128.579151,113.966858 133.730538,126.922515 85.4588561,141.922529\" id=\"Fill-1\" fill=\"#1C2B2F\"></path>\r\n                    <path d=\"M97.1268429,126.657999 L97.1268429,126.657999 C97.872311,131.032196 99.3036099,135.537846 99.3036099,135.537846 L90.1339487,137.844299 L97.1268429,126.657999 M71.0991249,109.501532 C68.0253784,114.751537 64.686487,120.956381 61.1541769,128.253968 C48.804389,153.766088 41.1788543,167.886262 55.361285,170.796748 C62.2050855,172.200782 78.8310399,169.675779 98.1962874,160.032222 C97.9899741,164.604807 97.854581,166.821744 97.854581,166.821744 L202.977678,166.842712 C202.977678,166.842712 201.547185,154.680605 199.067395,133.622521 C206.577685,138.508009 222.819219,149.35318 226.257238,145.558822 C233.948051,137.07575 224.135273,106.400723 215.798118,96.868456 C206.415696,86.1434464 176.522021,60.1143909 149.24917,59.5692291 C129.611524,59.5692291 100.049078,74.5055328 90.6996986,83.4039279 C90.6666562,83.436186 90.641673,83.4660247 90.6086306,83.4990892 L90.5578582,83.4216698 C90.5578582,83.4216698 82.7397107,89.6168367 71.0991249,109.501532\" id=\"Fill-3\" fill=\"#B68C5A\"></path>\r\n                    <path d=\"M97.1268429,126.657999 C96.9052172,126.579773 98.1011899,163.299161 97.872311,166.821744 C97.872311,166.821744 144.407253,166.871745 149.066228,166.871745 C130.547993,166.871745 118.706735,125.532191 97.1268429,126.657999\" id=\"Fill-4\" fill=\"#A6784B\"></path>\r\n                    <path d=\"M205.704882,43.1546983 C207.058008,38.6458233 206.43665,36.6958215 205.160086,36.3119502 C203.886746,35.9288854 199.558195,33.9780772 197.641738,40.3619538 L197.441066,41.0280835 C195.527026,47.4103472 200.21179,48.1692189 201.487547,48.5522838 C202.763305,48.9361551 204.354981,47.6514765 205.708106,43.1409886 L205.704882,43.1546983\" id=\"Fill-5\" fill=\"#DD8677\"></path>\r\n                    <g id=\"Group-9\" transform=\"translate(0.000000, 163.987065)\">\r\n                        <mask id=\"mask-2\" fill=\"white\">\r\n                            <use xlink:href=\"#path-1\"></use>\r\n                        </mask>\r\n                        <g id=\"Clip-7\"></g>\r\n                        <path d=\"M359.204429,27.8830895 C359.204429,27.8830895 326.48281,1.28064631 326.299868,1.11290422 C325.543923,0.420968119 324.53734,0 323.434047,0 L37.4781087,0 C36.3740099,0 35.3690383,0.420968119 34.6130933,1.11290422 C34.4301514,1.28064631 1.73915703,27.8830895 1.73915703,27.8830895 L359.204429,27.8830895\" id=\"Fill-6\" fill=\"#227D81\" mask=\"url(#mask-2)\"></path>\r\n                        <path d=\"M356.478836,26.9621209 L4.47442068,26.9621209 C1.97609501,26.9621209 -0.0483546904,28.9895421 -0.0483546904,31.4903508 C-0.0483546904,33.9871272 1.97609501,36.0129355 4.47442068,36.0129355 L356.478836,36.0129355 C358.977162,36.0129355 361,33.9871272 361,31.4903508 C361,28.9895421 358.977162,26.9621209 356.478836,26.9621209\" id=\"Fill-8\" fill=\"#63B9B4\" mask=\"url(#mask-2)\"></path>\r\n                    </g>\r\n                    <path d=\"M136.812343,71.245046 C131.692387,53.2869654 131.340204,52.2192225 131.340204,52.2192225 L117.771072,56.1272905 L117.107001,56.3192262 L103.540287,60.2264878 C103.540287,60.2264878 106.333576,72.2869824 107.96877,79.1547305 C110.43486,89.5079656 140.374472,83.7369927 136.812343,71.245046\" id=\"Fill-10\" fill=\"#ED9E8B\"></path>\r\n                    <polyline id=\"Fill-11\" fill=\"#DD8677\" points=\"103.536257 60.2232619 107.909133 78.8926335 130.236105 52.6135777 103.536257 60.2232619\"></polyline>\r\n                    <path d=\"M134.923287,33.5627542 C134.56385,30.3998481 132.228319,28.0748461 129.703398,28.3554915 C128.24631,28.5232336 127.045502,29.5329119 126.362089,30.9667841 C126.470887,30.9514615 126.591773,30.9409777 126.719913,30.9224293 C126.719913,30.9224293 126.956851,30.6877516 127.417833,34.7619488 C127.900574,39.0071139 130.308637,39.8966308 131.428854,40.0837278 C133.739403,39.5393725 135.264187,36.5635633 134.923287,33.5627542\" id=\"Fill-12\" fill=\"#ED9E8B\"></path>\r\n                    <path d=\"M105.063459,13.1401553 C99.1069675,14.8546729 94.9452404,20.3288714 93.3035987,27.4538778 C92.1116556,32.6272695 92.2454369,38.6587265 94.0007121,44.7611513 C98.172916,59.2651966 110.335732,70.1724644 120.616746,67.210365 C121.144618,67.0587519 121.651536,66.8668163 122.14556,66.6498806 C131.336174,62.6369738 135.194879,47.7974444 131.236241,34.0361417 C127.064844,19.5329029 115.34689,10.1772494 105.063459,13.1401553 L105.063459,13.1401553 Z\" id=\"Fill-13\" fill=\"#ED9E8B\"></path>\r\n                    <path d=\"M128.48083,11.9990252 C128.48083,11.9990252 107.628676,33.4885606 88.9234697,38.793404 C77.8542751,41.9305036 87.0368308,18.2449986 87.0368308,18.2449986 C87.0368308,18.2449986 95.7455106,2.78288793 106.975081,2.7022427 C118.204652,2.6159523 128.48083,11.9990252 128.48083,11.9990252\" id=\"Fill-14\" fill=\"#1C2B2F\"></path>\r\n                    <path d=\"M116.426812,34.6522713 C116.110088,33.8313028 116.371204,32.9127536 117.014321,32.6079146 C117.667109,32.3111402 118.437561,32.7288825 118.766373,33.5466252 C119.083096,34.3692065 118.811504,35.2804977 118.178057,35.5942076 C117.528493,35.8950144 116.750788,35.4756591 116.426812,34.6522713\" id=\"Fill-15\" fill=\"#1C2B2F\"></path>\r\n                    <path d=\"M100.906568,39.1224366 C100.591456,38.3022746 100.85499,37.3821125 101.498107,37.0772735 C102.145254,36.7821119 102.918123,37.1990478 103.246129,38.015984 C103.563658,38.8385654 103.293678,39.7514694 102.656202,40.0651794 C102.007443,40.3659861 101.23135,39.9458244 100.906568,39.1224366\" id=\"Fill-16\" fill=\"#1C2B2F\"></path>\r\n                    <path d=\"M112.540706,49.9176076 L112.532647,49.9192205 C112.164346,50.011156 111.787179,49.78293 111.699335,49.410349 L108.626394,36.4466278 C108.537744,36.078079 108.695703,35.6788851 109.136536,35.6111431 C109.512091,35.5184011 109.891675,35.7546917 109.972266,36.129692 L113.047625,49.0845423 C113.136275,49.4595426 112.905784,49.8264784 112.540706,49.9176076\" id=\"Fill-17\" fill=\"#DD8677\"></path>\r\n                    <path d=\"M113.52553,56.5869684 L113.523112,56.5764845 C113.345812,56.2377745 113.477981,55.8208386 113.818882,55.6393869 L122.218898,51.3668024 C122.558992,51.1893829 122.980484,51.2514797 123.151337,51.6627704 C123.329444,52.0014804 123.197274,52.4248679 122.853956,52.5990616 L114.455552,56.8789041 C114.114652,57.0514849 113.701219,56.9151945 113.52553,56.5869684\" id=\"Fill-18\" fill=\"#DD8677\"></path>\r\n                    <polyline id=\"Fill-19\" fill=\"#B3D4D4\" points=\"245.346058 151.764473 191.981015 151.764473 187.579933 176.631431 249.747946 176.631431 245.346058 151.764473\"></polyline>\r\n                    <path d=\"M184.623043,174.193525 L252.70403,174.193525 C254.050708,174.193525 255.1403,175.286268 255.1403,176.632237 C255.1403,177.978206 254.050708,179.070143 252.70403,179.070143 L184.623043,179.070143 C183.277977,179.070143 182.189191,177.978206 182.189191,176.632237 C182.189191,175.286268 183.277977,174.193525 184.623043,174.193525\" id=\"Fill-20\" fill=\"#DAEDEC\"></path>\r\n                    <path d=\"M296.165225,155.692702 L141.165071,155.692702 L141.165071,50.2224465 C141.165071,47.5176054 143.355539,45.3248615 146.058566,45.3248615 L291.270119,45.3248615 C293.973952,45.3248615 296.165225,47.5176054 296.165225,50.2224465 L296.165225,155.692702\" id=\"Fill-21\" fill=\"#56636C\"></path>\r\n                    <polygon id=\"Fill-22\" fill=\"#B3D4D4\" points=\"147.537413 148.21447 289.790465 148.21447 289.790465 50.9619633 147.537413 50.9619633\"></polygon>\r\n                    <path d=\"M218.171527,49.2047037 C230.371416,49.2047037 234.744292,46.4692174 234.744292,43.3119565 C234.744292,40.1571149 236.356115,32.2321079 219.092684,32.2321079 L217.290666,32.2321079 C200.02643,32.2321079 201.638253,40.1571149 201.638253,43.3119565 C201.638253,46.4692174 206.011935,49.2047037 218.211017,49.2047037 L218.171527,49.2047037\" id=\"Fill-23\" fill=\"#ED9E8B\"></path>\r\n                    <path d=\"M263.545151,111.944276 C263.545151,111.944276 275.036643,118.623314 283.185215,130.875745 C291.333786,143.128981 295.750987,154.519314 293.051989,156.316896 C290.353797,158.112059 281.560497,149.636245 273.412732,137.383815 C265.264966,125.130578 263.545151,111.944276 263.545151,111.944276\" id=\"Fill-24\" fill=\"#19676B\"></path>\r\n                    <path d=\"M303.84395,117.553152 C302.479542,134.79349 298.295249,148.527373 294.497794,148.22576 C290.701951,147.92576 288.729886,133.704779 290.094294,116.464441 C291.457896,99.2232969 299.438838,85.7902203 299.438838,85.7902203 C299.438838,85.7902203 305.208358,100.311201 303.84395,117.553152\" id=\"Fill-25\" fill=\"#19676B\"></path>\r\n                    <path d=\"M294.150446,124.657997 C297.38054,140.71285 297.133931,154.304798 293.596785,155.016895 C290.062057,155.728993 284.57783,143.292691 281.347736,127.238645 C278.116837,111.184598 281.89898,96.8805528 281.89898,96.8805528 C281.89898,96.8805528 290.918741,108.60395 294.150446,124.657997\" id=\"Fill-26\" fill=\"#227D81\"></path>\r\n                    <path d=\"M318.490586,136.193491 C310.135701,148.307212 301.198949,156.633832 298.531381,154.791089 C295.86462,152.948345 300.473628,141.634625 308.829319,129.521711 C317.183397,117.408797 328.786911,110.925727 328.786911,110.925727 C328.786911,110.925727 326.844664,124.081384 318.490586,136.193491\" id=\"Fill-27\" fill=\"#227D81\"></path>\r\n                    <path d=\"M311.33248,129.757195 C305.443684,146.0185 297.765766,158.147543 294.184295,156.848348 C290.60363,155.54996 292.474151,141.31527 298.360528,125.054772 C304.249324,108.79508 315.506295,97.9644248 315.506295,97.9644248 C315.506295,97.9644248 317.217246,113.496697 311.33248,129.757195\" id=\"Fill-28\" fill=\"#227D81\"></path>\r\n                    <path d=\"M280.468487,164.379807 C280.468487,174.923365 287.664471,179.228207 287.664471,179.228207 L305.176122,179.228207 C305.176122,179.228207 312.3713,174.923365 312.3713,164.379807 L312.3713,157.753188 L280.468487,157.753188 L280.468487,164.379807\" id=\"Fill-29\" fill=\"#6B5B7F\"></path>\r\n                    <path d=\"M311.365522,152.828184 L281.474264,152.828184 C280.918991,152.828184 280.468487,153.278184 280.468487,153.834636 L280.468487,157.753188 L312.3713,157.753188 L312.3713,153.834636 C312.3713,153.278184 311.919989,152.828184 311.365522,152.828184\" id=\"Fill-30\" fill=\"#77648D\"></path>\r\n                    <polyline id=\"Fill-31\" fill=\"#DAEDEC\" points=\"217.833851 133.803167 235.031196 119.813638 247.185953 94.6636154 248.500395 76.9119866 240.944169 74.1168228 228.296194 67.6982686 207.762374 67.6982686 187.229361 76.7474703 189.529433 96.3071652 199.878948 119.813638 217.833851 133.803167\"></polyline>\r\n                    <path d=\"M217.834656,63.470039 L217.833045,63.470039 C196.738311,63.470039 199.997417,73.1248864 184.026669,73.1248864 C184.026669,127.398322 217.833045,136.388653 217.833045,136.388653 L217.834656,136.388653 C217.834656,136.388653 251.641032,127.398322 251.641032,73.1248864 C235.669478,73.1248864 238.92939,63.470039 217.834656,63.470039 Z M217.834656,69.1329473 C227.459658,69.1329473 230.67605,71.1894008 234.399362,73.571661 C237.305478,75.4297272 240.506559,77.4773097 245.865065,78.3523104 C245.051094,96.3232943 239.983522,110.895082 231.088677,120.714445 C225.768049,126.587031 220.372472,129.322517 217.833045,130.375744 C215.295229,129.323324 209.900458,126.58945 204.582248,120.719284 C195.684179,110.900727 190.616607,96.3265201 189.801831,78.3523104 C195.161142,77.4773097 198.362223,75.4297272 201.26834,73.571661 C204.991651,71.1894008 208.208043,69.1329473 217.834656,69.1329473 L217.834656,69.1329473 Z\" id=\"Fill-32\" fill=\"#3A6080\"></path>\r\n                    <path d=\"M226.183124,90.3684502 C226.195182,85.745059 222.533121,81.9660233 217.990197,81.9391592 C213.455333,81.9039265 209.769094,85.6313492 209.756183,90.2531275 C209.749752,93.5886144 211.659762,96.4870041 214.434516,97.8579731 L211.580783,113.866858 L224.400417,113.866858 L221.474959,97.9055537 C224.256159,96.5757138 226.177452,93.70555 226.183124,90.3684502\" id=\"Fill-33\" fill=\"#1C2B2F\"></path>\r\n                    <path d=\"M174.465335,124.210416 C175.465471,126.02816 173.971311,128.433807 170.316502,130.514454 C167.011459,132.396714 155.828631,141.403173 139.833705,141.191076 C132.463645,141.093496 126.370954,143.732208 126.370954,143.732208 C126.370954,143.732208 121.450864,136.267685 123.483373,130.92897 C130.85021,126.862031 136.381181,125.01203 140.683136,125.47332 C148.53352,126.311224 167.411997,122.233801 169.62906,121.993479 C171.846928,121.753962 173.534507,122.512834 174.465335,124.210416\" id=\"Fill-34\" fill=\"#ED9E8B\"></path>\r\n                    <path d=\"M142.882469,117.551539 C140.543713,116.379764 132.466868,123.396706 129.926635,127.972516 C139.325175,128.736227 139.325175,128.736227 139.325175,128.736227 C139.325175,128.736227 145.92962,119.07654 142.882469,117.551539\" id=\"Fill-35\" fill=\"#ED9E8B\"></path>\r\n                    <path d=\"M123.561546,129.287033 L90.1339487,137.844299 L90.313667,163.608032 C90.313667,163.608032 129.560751,145.837048 129.248058,145.9935 C122.822525,141.603174 123.561546,129.287033 123.561546,129.287033\" id=\"Fill-36\" fill=\"#B68C5A\"></path>\r\n                    <path d=\"M71.0991249,109.501532 C68.0253784,114.751537 64.686487,120.956381 61.1541769,128.253968 C48.804389,153.766088 41.1788543,167.886262 55.361285,170.796748 C61.7860115,172.115298 76.8307675,169.971747 94.6680069,161.725772\" id=\"Fill-37\" fill=\"#B68C5A\"></path>\r\n                </g>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>";
var lightbulbFloatsOverHand = "<svg width=\"79px\" height=\"60px\" viewBox=\"0 0 79 60\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\r\n    <title>We-offer-ideas</title>\r\n    <defs>\r\n        <path d=\"M14.3625974,-0.000155297759 C22.2379221,0.0363636364 28.5922078,6.44987013 28.5559995,14.3251948 C28.5132468,23.4462338 20.4924675,24.9683117 20.4602597,31.8431169 L16.8945455,31.8264935 L11.5366234,31.8015584 L7.97090909,31.7849351 C8.00311688,24.9101299 -0.00415584416,23.3132468 0.0382722001,14.1922078 C0.0737662338,6.31792208 6.48831169,-0.0363636364 14.3625974,-0.000155297759 Z\" id=\"path-1\"></path>\r\n    </defs>\r\n    <g id=\"2---MY-POLICIES\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\r\n        <g id=\"2.1_my_policy-v2-new-offer\" transform=\"translate(-224.000000, -332.000000)\">\r\n            <g id=\"BOX-/-section-/-insurance\" transform=\"translate(160.000000, 152.000000)\">\r\n                <g id=\"OFFER\" transform=\"translate(32.000000, 160.000000)\">\r\n                    <g id=\"We-offer-ideas\" transform=\"translate(32.000000, 20.000000)\">\r\n                        <g id=\"Group\" transform=\"translate(39.480519, 0.000000)\">\r\n                            <g>\r\n                                <path d=\"M16.9049351,40.0384491 C17.1833766,40.0394805 17.4576623,39.9335065 17.6446753,39.7277922 C18.9506494,38.2836364 19.7963636,36.0425974 19.8077922,33.521039 C19.8285714,29.1480519 17.3371429,25.5916883 14.2451948,25.5770981 C11.1532468,25.5625974 8.62961039,29.0961039 8.60883117,33.4690909 C8.5974026,35.9916883 9.4212987,38.24 10.7137662,39.6955844 C10.8987013,39.9044156 11.1719481,40.0124675 11.4503896,40.0135065 L16.9049351,40.0384491 Z\" id=\"Path\" fill=\"#576371\" fill-rule=\"nonzero\"></path>\r\n                                <path d=\"M19.7205195,37.2748153 L8.66077922,37.2238961 C8.26597403,37.2218182 7.94701299,36.9007792 7.94908081,36.505974 L7.97090909,31.785974 L20.4602597,31.8441558 L20.4384416,36.5641558 C20.4363636,36.9579221 20.1153247,37.2768831 19.7205195,37.2748153 Z\" id=\"Path\" fill=\"#BFD9E0\" fill-rule=\"nonzero\"></path>\r\n                                <g>\r\n                                    <g id=\"XMLID_91_-link\" fill=\"#BD8F56\" fill-rule=\"nonzero\">\r\n                                        <path d=\"M14.3625974,-0.000155297759 C22.2379221,0.0363636364 28.5922078,6.44987013 28.5559995,14.3251948 C28.5132468,23.4462338 20.4924675,24.9683117 20.4602597,31.8431169 L16.8945455,31.8264935 L11.5366234,31.8015584 L7.97090909,31.7849351 C8.00311688,24.9101299 -0.00415584416,23.3132468 0.0382722001,14.1922078 C0.0737662338,6.31792208 6.48831169,-0.0363636364 14.3625974,-0.000155297759 Z\" id=\"XMLID_91_\"></path>\r\n                                    </g>\r\n                                    <g id=\"Clipped\">\r\n                                        <mask id=\"mask-2\" fill=\"white\">\r\n                                            <use xlink:href=\"#path-1\"></use>\r\n                                        </mask>\r\n                                        <use id=\"XMLID_91_\" fill=\"#FDD25C\" fill-rule=\"nonzero\" xlink:href=\"#path-1\"></use>\r\n                                        <rect id=\"Rectangle\" fill=\"#EFBE25\" fill-rule=\"nonzero\" mask=\"url(#mask-2)\" transform=\"translate(14.205504, 33.900558) rotate(0.263559) translate(-14.205504, -33.900558) \" x=\"6.80386704\" y=\"29.6625906\" width=\"14.8032735\" height=\"8.47593383\"></rect>\r\n                                    </g>\r\n                                </g>\r\n                            </g>\r\n                            <g transform=\"translate(6.233766, 12.467532)\" id=\"Path\" stroke=\"#FFE8B0\" stroke-width=\"1.25558442\">\r\n                                <path d=\"M11.4503896,5.38181818 C11.4503896,5.38181818 3.9761039,5.38181818 3.23844156,5.38181818 C1.76415584,5.38181818 0.569350649,4.18701299 0.569350649,2.71272727 C0.569350649,1.23844156 1.76415584,0.0436363636 3.23844156,0.0436363636 C4.71272727,0.0436363636 5.90753247,1.23844156 5.90753247,2.71272727 C5.90753247,3.44935065 5.90753247,17.1844156 5.90753247,17.1844156\"></path>\r\n                                <path d=\"M11.4503896,5.38181818 C11.4503896,5.38181818 11.9615584,5.38181818 12.6992208,5.38181818 C14.1735065,5.38181818 15.3683117,4.18701299 15.3683117,2.71272727 C15.3683117,1.23844156 14.1735065,0.0436363636 12.6992208,0.0436363636 C11.2249351,0.0436363636 10.0301299,1.23844156 10.0301299,2.71272727 C10.0301299,3.44935065 10.0301299,17.2103896 10.0301299,17.2103896\"></path>\r\n                            </g>\r\n                        </g>\r\n                        <g id=\"Group\" transform=\"translate(0.000000, 36.363636)\" fill-rule=\"nonzero\">\r\n                            <g id=\"XMLID_89_-link\" transform=\"translate(19.740260, 2.077922)\" fill=\"#ECA391\">\r\n                                <path d=\"M0.343896104,17.2675325 C0.343896104,17.2675325 4.79584416,15.838961 8.72519481,15.9563636 C10.8571429,16.0197403 17.3444156,19.7381818 26.3345455,19.7402601 C35.2311688,19.7423377 47.9085714,10.5184416 54.8135065,6.82285714 C54.8135065,6.82285714 59.9293506,3.91376623 58.7937662,2.61402597 C55.3662338,-1.68519481 51.3755844,1.47948052 33.4223377,9.30493506 C28.6846753,11.1085714 0.385454545,3.36103896 0.385454545,3.36103896 L0.343896104,17.2675325 Z\" id=\"XMLID_89_\"></path>\r\n                            </g>\r\n                            <path d=\"M15.7620779,3.79220779 C15.7620779,3.79220779 19.0680519,0.457142857 27.8119481,0.459219809 C32.9984416,0.46025974 38.3636364,4.17974026 43.6976623,6 C49.6602597,8.03428571 55.3194805,8.28467532 55.3184416,10.2192208 C55.3174026,13.8846753 46.0405195,13.0711688 41.9896104,12.2846753 C37.9376623,11.4981818 31.0077922,8.75948052 21.7298701,12.2794805 C12.452987,15.7974026 15.7620779,3.79220779 15.7620779,3.79220779 Z\" id=\"Path\" fill=\"#ECA391\"></path>\r\n                            <rect id=\"Rectangle\" fill=\"#766391\" x=\"0.264935065\" y=\"0.261818182\" width=\"22.2036364\" height=\"20.6763636\"></rect>\r\n                        </g>\r\n                    </g>\r\n                </g>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>";
var manAndWomanUnderUmbrelaButDogWillGetWet = "<svg width=\"257px\" height=\"142px\" viewBox=\"0 0 257 142\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\r\n    <title>illustration / footer</title>\r\n    <defs>\r\n        <polygon id=\"path-1\" points=\"0.0341772152 0.0351647059 44.8165823 0.0351647059 44.8165823 48.7498118 0.0341772152 48.7498118\"></polygon>\r\n        <path d=\"M0.689142857,4.91925 C0.805142857,4.87433333 0.930857143,4.82358333 1.06114286,4.76991667 C1.94514286,4.40416667 3.05942857,3.87158333 3.05942857,3.87158333 C3.05942857,3.87158333 3.624,3.38216667 4.11314286,2.30766667 C4.60171429,1.23141667 6.25714286,0.567 7.38628571,0.567 C8.51485714,0.567 11.1868571,0.655083333 12.0897143,5.72483333 C12.2177143,6.30875 12.4274286,6.9475 12.6451429,7.29633333 L12.7074286,7.39025 C12.8862857,7.62708333 13.0828571,7.819 13.2931429,7.98466667 C13.6657143,8.27633333 14.0891429,8.477 14.5588571,8.65958333 C15.168,10.1511667 17.0257143,13.9393333 20.3194286,14.3803333 C23.7034286,14.8341667 27.4845714,11.59025 28.7211429,10.4253333 C29.9754286,10.479 31.352,10.7665833 32.7554286,11.2023333 C35.8057143,12.1490833 41.9662857,10.7625 43.7165714,5.01258333 C43.9782857,4.15625 44.1388571,7.47658333 43.0777143,9.16475 C41.7005714,11.3563333 36.3074286,16.0626667 29.5902857,12.8251667 L26.6291429,19.3030833 C26.6291429,19.3030833 23.1697143,18.5266667 22.3114286,19.075 C21.4537143,19.6245 19.268,21.6405 12.2988571,20.4825833 C6.75657143,19.5615 6.45085714,10.80975 6.45085714,10.80975 C6.42685714,10.7595833 6.38971429,10.68025 6.34457143,10.5805 L6.33371429,10.5554167 C6.16,10.1785833 5.864,9.52641667 5.59771429,8.96466667 C5.408,8.56216667 5.23371429,8.20808333 5.132,8.03833333 L5.12857143,8.0325 C1.32914286,7.92516667 0.538857143,7.0315 0.387428571,6.14775 L0.381142857,6.139 C0.0548571429,5.75633333 -0.206857143,5.26166667 0.689142857,4.91925\" id=\"path-3\"></path>\r\n    </defs>\r\n    <g id=\"1---HOME\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\r\n        <g id=\"1.0_home-v2\" transform=\"translate(-592.000000, -1178.000000)\">\r\n            <g id=\"footer\" transform=\"translate(0.000000, 1176.000000)\">\r\n                <g id=\"Group\" transform=\"translate(588.000000, 0.000000)\">\r\n                    <g id=\"woman_and_man_in_front_of_house_under_umbrella\" transform=\"translate(4.000000, 2.000000)\">\r\n                        <path d=\"M231.848791,29 C231.847719,29 231.847184,29 231.846113,29 C231.268232,28.9994677 230.689815,28.7689851 230.096403,28.3873314 C230.095332,28.3867991 230.09426,28.3857346 230.092654,28.3852023 C230.088905,28.3825408 230.085156,28.3798793 230.080871,28.3777502 C230.080871,28.3772179 230.080336,28.3772179 230.080336,28.3766856 C230.077122,28.3750887 230.074444,28.3729595 230.071231,28.3713627 C230.068553,28.3697658 230.066411,28.3676366 230.063733,28.3660397 C230.054628,28.3601845 230.045524,28.3543293 230.036419,28.3484741 C230.033741,28.3463449 230.030528,28.344748 230.02785,28.3426189 C230.020887,28.3383605 230.01446,28.3341022 230.007498,28.3293116 C230.005356,28.3277147 230.002678,28.3261178 230,28.3245209 C231.446041,27.8811214 231.538695,26 234.333839,26 C234.974917,26 235.528698,26.2570972 236,26.6621718 C233.787021,27.0805536 233.817013,28.9989354 231.919486,28.9989354 C231.915201,28.9994677 231.910381,28.9994677 231.905561,28.9994677 C231.886816,29 231.867535,29 231.848791,29\" id=\"Fill-1\" fill=\"#F6FAF9\"></path>\r\n                        <path d=\"M171.962622,13 C171.314549,12.6519858 170.658424,12.3110499 170,11.9789619 C172.750431,10.7508848 175.990224,10 179.80391,10 C179.86429,10 179.927545,10 179.987924,10.0005899 C182.721104,10.1038144 185.028752,10.4948879 187,11.0835627 C185.707303,10.8564687 184.302473,10.7001573 182.753882,10.6441211 C182.690627,10.6435313 182.629097,10.6435313 182.565842,10.6435313 L182.564117,10.6435313 C178.374353,10.6435313 174.878091,11.5501376 171.962622,13\" id=\"Fill-2\" fill=\"#F6FAF9\"></path>\r\n                        <path d=\"M205.00429,24 C204.241498,24 203.601868,23.7339102 203,23.2893456 C205.615453,22.4916171 207.347276,18 212.643831,18 C213.844081,18 214.956026,18.2287723 216,18.6106003 C215.812933,18.5992428 215.62819,18.588967 215.438218,18.588967 C209.6281,18.588967 208.107164,24 205.00429,24\" id=\"Fill-3\" fill=\"#F6FAF9\"></path>\r\n                        <path d=\"M242,33 L197.350459,33 C190.280516,25.0601157 181.704364,18.3609824 172,13.301207 C174.925852,11.8853455 178.434566,11 182.639252,11 L182.640983,11 C182.703309,11 182.767366,11.000576 182.829692,11.000576 C184.383799,11.0552981 185.793632,11.2079439 187.090933,11.4297123 C198.575047,13.3847302 200.571205,21.1402875 203.667299,23.6010525 C204.265165,24.0745425 204.900542,24.3579452 205.658263,24.3579452 C208.740507,24.3579452 210.251331,18.5948472 216.02282,18.5948472 C216.211529,18.5948472 216.395044,18.6057916 216.580867,18.6178881 C222.807103,19.0141911 226.688041,25.9258765 230.094033,28.2109549 C230.096918,28.212683 230.099804,28.214411 230.102112,28.2161391 C230.109614,28.2213233 230.116539,28.2259315 230.124042,28.2305396 C230.126927,28.2328437 230.13039,28.2345718 230.133275,28.2368759 C230.143086,28.2432121 230.152896,28.2495483 230.162707,28.2558846 C230.165592,28.2576127 230.167901,28.2599167 230.170786,28.2616448 C230.174249,28.2633729 230.177134,28.265677 230.180597,28.267405 C230.180597,28.267981 230.181174,28.267981 230.181174,28.2685571 C230.18579,28.2708612 230.18983,28.2737413 230.19387,28.2766214 C230.195601,28.2771974 230.196755,28.2783494 230.197909,28.2789255 C230.837326,28.6919331 231.460585,28.9413505 232.083266,28.9419265 C232.08442,28.9419265 232.084997,28.9419265 232.086151,28.9419265 C232.10635,28.9419265 232.127125,28.9419265 232.147323,28.9413505 C232.152517,28.9413505 232.157711,28.9413505 232.162327,28.9407745 C234.206961,28.9407745 234.174644,26.864792 236.559185,26.4120389 C236.850039,26.3573168 237.16917,26.3210274 237.539086,26.3210274 C240.950848,26.3210274 242,33 242,33\" id=\"Fill-4\" fill=\"#EAF4F2\"></path>\r\n                        <polyline id=\"Fill-5\" fill=\"#A4CCC6\" points=\"36 41.4224444 36 48 65 48 65 40.7982798 50.8448769 28 36 41.4224444\"></polyline>\r\n                        <polygon id=\"Fill-6\" fill=\"#E4F1F2\" points=\"50 51 51 51 51 27 50 27\"></polygon>\r\n                        <polyline id=\"Fill-7\" fill=\"#E4F1F2\" points=\"50.702798 16 71.5183972 34.4011507 71.5183972 40.6889495 71.5183972 36.8977347 113 36.8977347 113 103 26 103 26 37.2015124 50.702798 16\"></polyline>\r\n                        <path d=\"M59,40.5 C59,35.2531212 54.7468788,31 49.5,31 C44.253697,31 40,35.2531212 40,40.5 C40,45.746303 44.253697,50 49.5,50 C54.7468788,50 59,45.746303 59,40.5\" id=\"Fill-8\" fill=\"#A4CCC6\"></path>\r\n                        <polyline id=\"Fill-9\" fill=\"#31506D\" points=\"77 35.6465516 50.5849096 12 22 37.5897242 22 44 50.5849096 18.6013602 73.7481642 39.1824791 77 35.6465516\"></polyline>\r\n                        <g id=\"Group-13\" transform=\"translate(0.000000, 54.000000)\">\r\n                            <mask id=\"mask-2\" fill=\"white\">\r\n                                <use xlink:href=\"#path-1\"></use>\r\n                            </mask>\r\n                            <g id=\"Clip-11\"></g>\r\n                            <polygon id=\"Fill-10\" fill=\"#E4F1F2\" mask=\"url(#mask-2)\" points=\"2.68746835 48.7498118 42.1302532 48.7498118 42.1302532 14.4117647 2.68746835 14.4117647\"></polygon>\r\n                            <polyline id=\"Fill-12\" fill=\"#31506D\" mask=\"url(#mask-2)\" points=\"7.96556962 0.0351647059 36.7832278 0.0351647059 44.8165823 15.8800353 0 15.8800353 7.96556962 0.0351647059\"></polyline>\r\n                        </g>\r\n                        <polygon id=\"Fill-14\" fill=\"#A4CCC6\" points=\"11 93 34 93 34 76 11 76\"></polygon>\r\n                        <polygon id=\"Fill-15\" fill=\"#A4CCC6\" points=\"11 93 34 93 34 76 11 76\"></polygon>\r\n                        <polygon id=\"Fill-16\" fill=\"#E4F1F2\" points=\"11 83 35 83 35 82 11 82\"></polygon>\r\n                        <polygon id=\"Fill-17\" fill=\"#31506D\" points=\"11 94 35 94 35 92 11 92\"></polygon>\r\n                        <polygon id=\"Fill-18\" fill=\"#A4CCC6\" points=\"54 82 86 82 86 58 54 58\"></polygon>\r\n                        <polygon id=\"Fill-19\" fill=\"#E4F1F2\" points=\"53 67 87 67 87 66 53 66\"></polygon>\r\n                        <polygon id=\"Fill-20\" fill=\"#31506D\" points=\"53 83 86 83 86 81 53 81\"></polygon>\r\n                        <polygon id=\"Fill-21\" fill=\"#A4CCC6\" points=\"71 82 103 82 103 58 71 58\"></polygon>\r\n                        <polygon id=\"Fill-22\" fill=\"#E4F1F2\" points=\"70 67 104 67 104 66 70 66\"></polygon>\r\n                        <polygon id=\"Fill-23\" fill=\"#31506D\" points=\"71 83 104 83 104 81 71 81\"></polygon>\r\n                        <polygon id=\"Fill-24\" fill=\"#96CFC8\" points=\"108 116 144 116 144 95 108 95\"></polygon>\r\n                        <path d=\"M257,104 L255.213652,104 C255.213652,104 248.232527,94.1619502 237.196775,92.8716676 C237.394813,92.8654234 237.591134,92.8620175 237.787455,92.8620175 C249.396143,92.8620175 257,104 257,104 M213.217583,96.0494071 C200.335384,96.0488395 193.856795,89.7972416 183.571985,85.4802161 C181.301417,84.5271214 179.242623,84.0281515 177.301737,83.8402573 C177.931337,83.7823564 178.567806,83.7505677 179.21515,83.7505677 C181.696921,83.7505677 184.336091,84.2171811 187.346154,85.4802161 C197.309295,89.6621394 203.679708,95.5861996 215.784635,95.9693676 C214.900905,96.0232949 214.045793,96.0494071 213.217583,96.0494071 M153.38207,87.4755277 C146.196039,87.4533891 142.049261,81.0456858 130.029043,78.2590615 L130.029043,77.5534648 C144.145258,79.5975948 148.724743,86.5519511 155.78371,87.3926499 C155.009301,87.4460096 154.209136,87.4755277 153.38207,87.4755277 M128.014894,77.8418342 C125.916607,77.4563956 123.592809,77.18165 121,77.0601716 C121.552904,77.0204356 122.110386,77 122.67302,77 C122.839578,77 123.006136,77.001703 123.173839,77.0056766 C124.897799,77.0425742 126.506142,77.14532 128.014894,77.3031284 L128.014894,77.8418342\" id=\"Fill-25\" fill=\"#D0E9E4\"></path>\r\n                        <path d=\"M255,104 L84,104 C84,104 98.2718653,76.5592001 119.060941,77.0053828 C139.850016,77.4521331 144.088265,87.4481001 153.074637,87.4753479 C165.667358,87.4753479 171.76693,80.6475046 183.292355,85.4800146 C197.089867,91.2661973 204.041901,100.528177 228.757573,93.555012 C244.436459,89.1306514 255,104 255,104\" id=\"Fill-26\" fill=\"#96CFC8\"></path>\r\n                        <path d=\"M173.167156,89.9254011 L172.595055,80.4742493 L156.121225,79 L156.162006,88.4955366 L156.16958,90.5108309 C154.725345,90.9052375 153.337039,91.3811099 152,91.9272114 C153.902731,94.1273488 158.780155,97 164.33338,97 C170.66902,97 174.347479,94.4784943 177,91.0350209 C175.744524,90.5883638 174.466909,90.2124977 173.167156,89.9254011\" id=\"Fill-27\" fill=\"#ED9E8B\"></path>\r\n                        <path d=\"M172,82.4993361 L171.881334,80.4670487 L155.978404,79 L156.017772,88.4491579 L156.025083,90.454609 C154.630898,90.8470892 153.290704,91.3206374 152,91.8640716 C152.853158,92.8827311 154.332265,94.0461947 156.206175,95 L172,82.4993361\" id=\"Fill-28\" fill=\"#DD8677\"></path>\r\n                        <path d=\"M175.944761,73.9579858 C175.704034,72.8690149 174.912344,71.9347177 173.588905,73.2665035 C173.494535,70.8053725 175.314122,69.177887 174.230846,66.1918891 C174.233107,65.8688941 174.394722,64.1225602 174.333693,63.9428658 C174.22011,63.6301065 173.261719,61.3429834 172.938488,61.0808342 C174.543906,60.3296434 171.599226,60.0572585 171.487904,59.9179385 C170.601279,58.8039469 167.102813,59.8053451 163.989172,59.9401159 C160.876096,59.8053451 159.214734,59.9207817 158.940101,58.5218949 C158.546799,56.5503743 155.596469,60.7879778 155.494753,60.9523186 C155.172087,61.2161737 154.631297,62.6571409 154.518844,62.9704688 C154.454424,63.1495946 154.413737,64.4563596 154.415433,64.7799233 C153.332157,67.7653525 154.411477,70.8918078 154.319933,73.3535074 C152.995929,72.021153 152.272615,72.8690149 152.031887,73.9579858 C151.793419,75.0475253 152.960893,78.30932 153.262651,78.9052685 C153.982574,80.3240583 154.561791,78.8239511 155.285105,78.5817049 C156.665052,87.0353032 160.809416,88.7895983 163.768787,88.9960194 L163.771047,89 C166.730984,88.7935789 172.157534,87.6176041 173.537482,79.1622998 C174.260231,79.4051147 175.102214,79.1958503 175.343507,78.5731751 C175.584235,77.9527744 176.183794,75.0475253 175.944761,73.9579858\" id=\"Fill-29\" fill=\"#ED9E8B\"></path>\r\n                        <path d=\"M164.520162,54 C157.681589,54 153.696603,59.1487852 153.204467,61.6704263 C152.613106,64.6905987 153.425729,70.3390746 154.103769,73.2798298 C154.315336,74.2021128 154.950607,74.2728347 155.069792,73.292583 C155.246003,71.835828 155.092032,70.3564653 155.146777,68.8921744 C155.194109,67.7014961 155.303599,66.5056006 155.363477,65.3288347 C155.454718,63.5775985 155.024171,61.1608809 156.896339,60.2107729 C159.075878,59.1041493 161.383725,61.7191201 163.487989,62.0228764 C164.542972,62.1753342 165.247815,62.1591029 166.286261,61.8159279 C167.123405,61.5382575 168.391666,60.0907776 169.248198,59.8774526 C170.733159,59.5076119 172.19873,60.1725135 173.036444,61.4466669 C173.929473,62.8037156 173.896398,64.1097517 173.821694,65.6453442 C173.774932,66.6134224 173.753833,67.5496179 173.697947,68.5072618 C173.642061,69.4666448 173.409395,70.4457372 173.367196,71.3987436 C173.341534,71.9964015 173.22463,72.5975375 173.258846,73.1986736 C173.305037,74.0299456 173.499496,73.9105299 173.951713,73.4763439 C174.519123,72.9320173 174.73069,72.8821641 174.936555,72.0717609 C175.287835,70.6810903 175.611744,69.1872354 175.728647,67.7530883 C175.86437,66.0627192 176.43349,63.5787579 175.355126,61.3429028 C172.750173,55.9523878 171.358735,54 164.520162,54\" id=\"Fill-30\" fill=\"#1C2B2F\"></path>\r\n                        <path d=\"M168.00017,71.9852494 C168.004777,71.4338355 168.235552,70.9914287 168.51156,71.0001261 C168.786731,71.0030252 169.004941,71.455289 168.999915,72.0107617 C168.991957,72.5621756 168.764533,73.005742 168.486849,72.9999438 C168.210422,72.9906666 167.99305,72.5401423 168.00017,71.9852494\" id=\"Fill-31\" fill=\"#1C2B2F\"></path>\r\n                        <path d=\"M160,71.9962428 C160.002931,71.4452171 160.228224,70.9988458 160.50335,71 C160.779313,71.0040496 160.999162,71.4521555 161,72.005494 C160.999162,72.5542069 160.770519,72.9994218 160.496231,73 C160.220687,72.9982654 160,72.5490031 160,71.9962428\" id=\"Fill-32\" fill=\"#1C2B2F\"></path>\r\n                        <path d=\"M163.41828,78.9981013 L163.413138,78.9957142 C163.156764,78.9724405 162.973115,78.78446 163.003234,78.5761896 L164.069132,71.339838 C164.097781,71.1321644 164.291714,70.9602966 164.584083,71.0080377 C164.843395,71.0336985 165.029248,71.2228724 164.996191,71.4299493 L163.933232,78.6651074 C163.902379,78.8739745 163.670246,79.0183912 163.41828,78.9981013\" id=\"Fill-33\" fill=\"#DD8677\"></path>\r\n                        <path d=\"M165.27513,82.9935394 C164.313669,83.0481274 163.193316,82.7689132 162.118196,81.6909581 C161.969164,81.542253 161.958726,81.291274 162.100219,81.1281376 C162.237074,80.9662561 162.47193,80.956217 162.622702,81.1068044 C164.880803,83.3725178 167.308233,81.483273 167.410874,81.3998224 C167.574404,81.2693133 167.8081,81.3075876 167.928138,81.4845279 C168.050495,81.6633504 168.011643,81.9143295 167.849273,82.0435837 C167.833616,82.0573876 166.73414,82.9113438 165.27513,82.9935394\" id=\"Fill-34\" fill=\"#DD8677\"></path>\r\n                        <path d=\"M125.000074,134 C124.996652,134 125.111868,133.423421 125.289826,132.593382 C125.25047,132.788307 125.207691,132.999621 125.161491,133.227326 C125.050838,133.769954 125.001785,134 125.000074,134 M125.289826,132.593382 C125.390212,132.098754 125.469495,131.706563 125.532236,131.40042 C125.899559,129.390882 127.590727,120.711177 130,117 C129.80379,117.485263 129.618988,117.96994 129.434186,118.452276 C129.300718,118.803491 129.15299,119.155878 129.024085,119.505337 C127.631794,123.276806 126.59713,126.924764 125.835677,130.158873 C125.820276,130.224434 125.805447,130.285896 125.792898,130.350871 C125.673119,130.853109 125.562466,131.344226 125.456946,131.821293 C125.441546,131.892707 125.426146,131.963536 125.411316,132.033779 C125.368538,132.229874 125.328041,132.417189 125.289826,132.593382\" id=\"Fill-35\" fill=\"#8DB2B0\"></path>\r\n                        <path d=\"M152.505,92.5065 C152.502,92.5025 152.498,92.4975 152.495,92.4935 C152.498,92.4975 152.502,92.5025 152.505,92.5065\" id=\"Fill-36\" fill=\"#81837D\"></path>\r\n                        <path d=\"M209.07943,133.266788 L208.248182,130.440644 L208.19288,130.252004 C207.068996,126.659224 205.721025,123.147535 204.159338,119.784803 C203.997467,119.434555 203.818313,119.096959 203.651833,118.750161 C203.416802,118.266484 203.184076,117.782232 202.939828,117.305457 C202.851116,117.127745 202.76874,116.945431 202.676571,116.767144 C200.742176,113.01908 198.543947,109.49704 196.106079,106.300518 C195.69996,105.769681 195.270799,105.273352 194.85143,104.760919 C194.45856,104.278392 194.078363,103.780913 193.674548,103.315065 L193.65093,103.284583 C188.750424,97.6558747 183.041136,93.3194628 176.726989,91 C174.104207,94.5249163 170.466991,97.1060591 164.202385,97.1060591 C158.711422,97.1060591 153.888684,94.1654657 152.007286,91.9132921 C145.985199,94.4593525 141.206241,98.53696 137.400817,103.284583 L137.377199,103.315065 C136.996426,103.792415 136.620838,104.272641 136.256194,104.760919 C135.87715,105.2676 135.509626,105.779458 135.153624,106.300518 C132.86553,109.649447 131.001414,113.222673 129.480627,116.767144 C129.402859,116.948307 129.338341,117.124869 129.26403,117.305457 C129.062986,117.787983 128.87404,118.269935 128.685094,118.750161 C128.550297,119.095233 128.401098,119.441456 128.27091,119.784803 C126.864758,123.490308 125.819793,127.074461 125.050758,130.252004 C125.035205,130.316418 125.020227,130.376806 125.007554,130.440644 C124.886582,130.934098 124.774828,131.416624 124.668257,131.885348 C124.563415,132.358672 124.463758,132.820495 124.369861,133.266788 C123.284572,138.477384 123,142 123,142 C123,142 198.972533,142 211,142 C210.513809,139.072634 209.869203,136.15217 209.07943,133.266788\" id=\"Fill-37\" fill=\"#3A6080\"></path>\r\n                        <path d=\"M199,142 C196.256997,142 193.223766,142 190,142 L190.159271,120 C190.159271,120 196.840991,134.017638 199,142\" id=\"Fill-38\" fill=\"#355774\"></path>\r\n                        <path d=\"M59.3215004,124 C45.9551548,116.076841 42.4621934,93.4269655 49.6822813,87.6843828 C54.4688897,83.875916 55.376853,84.5703308 57.9796431,81.7892565 C60.5824331,79.0064746 58.7923334,75.6977588 61.6310103,71.3747421 C65.5590136,66.5292067 67.863358,68.9095695 70.6882604,65.7340448 C73.5114411,62.5590893 74.9801378,52 85.7213099,52 C92.3915692,52 97.7021792,55.4527215 99.8274563,63.6183565 C103.126428,76.2880114 119.831347,80.465884 93.0510192,101.866382 C83.438775,109.546496 84.636001,123.475205 59.3215004,124\" id=\"Fill-39\" fill=\"#431F18\"></path>\r\n                        <path d=\"M100,92.9224341 L93.3658335,89.8225558 L93.3658335,81 L78.7619913,81 L78.7700888,89.9236511 L72,94.1878296 C72.197232,99.1897769 75.9504235,109 85.889527,109 C95.8286304,109 99.8016112,97.9249493 100,92.9224341\" id=\"Fill-40\" fill=\"#ED9E8B\"></path>\r\n                        <path d=\"M88.4357203,81 L78.1707511,81 L78.1788712,89.8386353 C75.4394967,91.1111017 71.3997458,94.0430625 71.3997458,94.0430625 C69.5327023,95.4314123 69.2038382,100.354766 72.4721793,101 L90,83.3412933\" id=\"Fill-41\" fill=\"#DD8677\"></path>\r\n                        <path d=\"M97,71.6266895 C97,64.0998816 91.9908807,58 85.8103783,58 C82.2315114,58 79.0474201,60.0489199 77,63.2360652 C77.274166,63.2303483 77.5665706,63.2269182 77.8878037,63.2269182 C77.8878037,63.2269182 77.3906572,62.8461758 77.3906572,72.5505329 C77.3906572,82.6533546 83.2775784,86 86.7499559,86 C92.4897923,85.3448487 97,78.7670383 97,71.6266895\" id=\"Fill-42\" fill=\"#ED9E8B\"></path>\r\n                        <path d=\"M97.9483217,70.3047033 C98.2194753,68.7080197 97.3966038,67.2413327 96.1125949,67.0262264 C95.3673639,66.9020593 94.6315438,67.2267591 94.0904132,67.831272 C94.1480553,67.8394332 94.2086385,67.8493433 94.2756916,67.8604192 C94.2756916,67.8604192 94.4245025,67.7753094 94.0745322,69.8348504 C93.7104453,71.9771695 94.7709438,72.7507362 95.297958,72.9979044 C96.5155019,73.0579476 97.6906965,71.8197747 97.9483217,70.3047033\" id=\"Fill-43\" fill=\"#ED9E8B\"></path>\r\n                        <path d=\"M78.2652546,71.5985254 C78.2652546,61.8410192 78.2168578,63.0474164 78.2168578,63.0474164 C77.8984886,63.0474164 77.6086909,63.0508649 77.3369692,63.0566124 C76.5439616,64.3066905 75.9305469,65.7337911 75.5258798,67.2781405 C75.3118844,67.2402071 75.092058,67.2327354 74.8716486,67.2695193 C73.5981717,67.4816015 72.7824234,68.9276689 73.0512297,70.5019052 C73.2617265,71.7341661 74.0943845,72.7687135 75.0559062,73.0641342 C75.6833152,79.9921533 80.3743049,86 86.0687992,86 C86.3825036,86 86.6932927,85.9781596 87,85.9425251 C83.1865664,85.9425251 78.2652546,81.7543324 78.2652546,71.5985254\" id=\"Fill-44\" fill=\"#DD8677\"></path>\r\n                        <path d=\"M65,79 C65,79 80.8719723,68.3950509 84,56.3878276 C79.6401384,54.5744334 74.3304498,59.7088527 74.3304498,59.7088527 C74.3304498,59.7088527 65.8483276,72.645963 65,79\" id=\"Fill-45\" fill=\"#431F18\"></path>\r\n                        <path d=\"M85.3315488,75.999843 L85.3281353,75.999297 C85.1392594,75.9916526 84.9907756,75.8371269 85.000447,75.6542079 L85.3127749,69.3175638 C85.3207396,69.1357368 85.4504496,68.9757509 85.6706152,69.0030522 C85.8629045,69.0112426 86.0102505,69.1663143 85.9994413,69.3486873 L85.6871134,75.6842394 C85.6797176,75.8677045 85.5192869,76.0053033 85.3315488,75.999843\" id=\"Fill-46\" fill=\"#DD8677\"></path>\r\n                        <path d=\"M85.0063076,79.6534947 L85.0063076,79.6477193 C84.9713124,79.4130915 85.0854505,79.1806295 85.2615032,79.1344258 L89.6111344,78.0111001 C89.787187,77.9627307 89.9691619,78.0717424 89.9933894,78.3518519 C90.0294613,78.5893674 89.9142464,78.8211075 89.737117,78.8665892 L85.3885626,79.9913588 C85.2130483,80.0390063 85.0434563,79.8845129 85.0063076,79.6534947\" id=\"Fill-47\" fill=\"#DD8677\"></path>\r\n                        <path d=\"M128.999716,85 C128.447286,85 128,84.5462971 128,83.9879378 L128,1.01206221 C128,0.453127854 128.447286,0 128.999716,0 C129.551577,0 130,0.453127854 130,1.01206221 L130,83.9879378 C130,84.5462971 129.551577,85 128.999716,85\" id=\"Fill-48\" fill=\"#56636C\"></path>\r\n                        <path d=\"M130,92.5899253 C130,92.8174846 129.817571,93 129.59601,93 L127.401688,93 C127.180702,93 127,92.8174846 127,92.5899253 L127,84.4089048 C127,84.1831004 127.180702,84 127.401688,84 L129.59601,84 C129.817571,84 130,84.1831004 130,84.4089048 L130,92.5899253\" id=\"Fill-49\" fill=\"#1C2B2F\"></path>\r\n                        <path d=\"M134.762012,100 C134.803797,100.94585 134.832725,101.777896 134.847724,102.349819 C134.899687,104.574222 135.162717,105.432978 134.847724,108.116661 C134.529517,110.799182 129,106.516438 129,106.516438 L130.685319,101.035848\" id=\"Fill-50\" fill=\"#ED9E8B\"></path>\r\n                        <path d=\"M134.000578,106 C130.139804,106 127,103.027884 127,99.3750683 C127,98.615637 127.649913,98 128.452917,98 C129.255344,98 129.905257,98.615637 129.905257,99.3750683 C129.905257,101.511208 131.742923,103.25041 134.000578,103.25041 C136.257655,103.25041 138.095321,101.511208 138.095321,99.3750683 C138.095321,98.615637 138.744079,98 139.548238,98 C140.350087,98 141,98.615637 141,99.3750683 C141,103.027884 137.860196,106 134.000578,106\" id=\"Fill-51\" fill=\"#1C2B2F\"></path>\r\n                        <path d=\"M129.000573,3 C95.5097175,3 66.335199,20.3433506 51,46 L51,46 C54.0673835,43.9020048 59.8996518,42.4834315 66.5987396,42.4834315 C73.2955357,42.4834315 79.1283769,43.9020048 82.1934688,46 C85.2602794,43.9020048 91.0942664,42.4834315 97.7904896,42.4834315 C104.48614,42.4834315 110.320127,43.9020048 113.386938,46 C116.452602,43.9020048 122.285444,42.4834315 128.982813,42.4834315 C135.679036,42.4834315 141.514169,43.9020048 144.580406,46 C147.645498,43.9020048 153.478912,42.4834315 160.174563,42.4834315 C166.871359,42.4834315 172.7042,43.9020048 175.771011,46 C178.836675,43.9020048 184.670662,42.4834315 191.366886,42.4834315 C198.063682,42.4834315 203.897096,43.9020048 206.963906,46 L207,46 C191.664228,20.3433506 162.491428,3 129.000573,3\" id=\"Fill-52\" fill=\"#DA324E\"></path>\r\n                        <path d=\"M117.955136,142 C117.897584,142 50,142 50,142 C50,142 49.9643181,110.085279 71.7420066,93.2816066 C88.289942,109.048779 99.6259655,92 99.6259655,92 C99.6259655,92 109.815553,97.0113882 123.821415,115.31865 L128.115947,105.073312 L136,108.216341 L133.091896,126.787786 C133.091896,126.787786 132.511771,133.103904 127.546758,133.103904 C122.584046,133.103904 115.490183,127.214988 115.490183,127.214988 C115.490183,127.214988 117.955136,138.373695 117.955136,142\" id=\"Fill-53\" fill=\"#227D81\"></path>\r\n                        <path d=\"M116.998697,137.962382 C117.178642,139.09588 98.6568463,114.214122 102.533701,117.258406 C114.894364,126.96199 114.894364,126.96199 114.894364,126.96199 C114.894364,126.96199 116.638232,134.94598 116.998697,137.962382\" id=\"Fill-54\" fill=\"#19676B\"></path>\r\n                        <path d=\"M121,123 L122.020731,113 C123.088908,114.265122 124,115.376768 124,115.376768 L121,123\" id=\"Fill-55\" fill=\"#19676B\"></path>\r\n                        <path d=\"M130.457946,100.627082 C130.457946,100.627082 129.668327,99.9021457 128.478076,100.667932 C127.513763,101.286429 127.903331,101.990078 127.903331,101.990078 C127.903331,101.990078 126.851089,102.166134 126.165704,101.035003 C125.476826,99.9027211 124.614418,91.7517869 125.186833,90.2242419 C125.537387,89.2841257 127.935359,87 130.7986,87 C133.660094,87 134.347225,90.621231 134.520755,91.9215141 C134.645953,92.8898223 134.870144,96.5484509 135,99.2686892 L130.457946,100.627082\" id=\"Fill-56\" fill=\"#ED9E8B\"></path>\r\n                        <path d=\"M113.32202,46 C113.316267,45.9954054 113.309939,45.9913852 113.303611,45.9873649 C110.218984,43.8962616 104.37131,42.4834315 97.6612974,42.4834315 C90.9374786,42.4834315 85.0794492,43.9020048 82,46 C82,46 92.2174663,9.32155307 129,3 C128.998849,3.00057432 128.998274,3.00057432 128.998849,3.00114864 C116.832925,14.9935489 113.32202,46 113.32202,46\" id=\"Fill-57\" fill=\"#D02E4C\"></path>\r\n                        <path d=\"M67.0264082,26 L67,25.9768561 C82.8012705,11.9420297 104.149979,3.23877776 128,3 C104.344596,3.24216468 82.8965696,11.9521905 67.0264082,26\" id=\"Fill-58\" fill=\"#DEE0DB\"></path>\r\n                        <path d=\"M57.0074627,36 C57.0049751,35.9966324 57.0024876,35.993826 57,35.9898971 C58.8837065,33.9115061 60.8768657,31.9144995 62.9788557,30 L63,30.0168382 C60.8942786,31.9279701 58.8930348,33.9255379 57.0074627,36\" id=\"Fill-59\" fill=\"#C9D7D5\"></path>\r\n                        <path d=\"M51,46 C53.083789,42.5023208 55.4231264,39.160874 57.9932454,36 C57.9954969,36.0039624 57.9977485,36.0067927 58,36.0101891 C55.4231264,39.1682328 53.0821004,42.5057172 51,46\" id=\"Fill-60\" fill=\"#94B7B4\"></path>\r\n                        <path d=\"M63.0221462,29 L63,28.9846154 C64.2864354,27.9630769 65.6099984,26.9676923 66.9700375,26 L67,26.0210256 C65.6373555,26.9866667 64.3105357,27.9805128 63.0221462,29\" id=\"Fill-61\" fill=\"#2D4B63\"></path>\r\n                        <path d=\"M128,2.5045 L128,2.5045 C128.332575,2.4985 128.666856,2.4955 129,2.4955 C128.997726,2.4955 128.997726,2.4955 128.997726,2.4955 C128.665719,2.4955 128.333712,2.4985 128,2.5045\" id=\"Fill-62\" fill=\"#4E5C64\"></path>\r\n                        <path d=\"M82.1932397,46 C79.1281703,43.9020048 73.2953719,42.4834315 66.598625,42.4834315 C59.8995865,42.4834315 54.067361,43.9020048 51.0011458,46 L51,46 C53.1191947,42.4547154 55.5019281,39.0685179 58.1247108,35.8643801 C59.8617744,33.741689 61.7053993,31.69768 63.6452731,29.7421164 C64.7784894,28.600366 65.9455074,27.4873315 67.1440355,26.4058848 C82.981564,12.1133283 104.385488,3.25155267 127.992251,3.00516889 C128.328549,3.00172296 128.663129,3 129,3 C128.997708,3 128.997708,3 128.997708,3 C92.3686971,9.32155307 82.1932397,46 82.1932397,46\" id=\"Fill-63\" fill=\"#C32E4B\"></path>\r\n                        <path d=\"M82,46 C82,46 92.2174663,9.32155307 129,3 C128.997699,3 128.997699,3 128.997699,3 C92.2174663,9.32155307 82,46 82,46\" id=\"Fill-64\" fill=\"#B82E49\"></path>\r\n                        <path d=\"M144.002277,46 C144.002277,46 144.001708,45.9915074 144,45.9758288 C147.054566,43.6024824 152.834613,42 159.466408,42 C159.472102,42 159.478365,42 159.484058,42 C152.836321,42.0026131 147.046026,43.6155479 144.002277,46\" id=\"Fill-65\" fill=\"#FFFFFE\"></path>\r\n                        <path d=\"M175.988493,46 C172.90629,43.90831 167.05603,42.494509 160.344457,42.494509 C160.338128,42.494509 160.332374,42.494509 160.326045,42.494509 C160.320292,42.494509 160.313963,42.494509 160.308209,42.494509 C153.606417,42.494509 147.765363,43.9037141 144.678557,45.9908083 C144.572691,45.0773814 140.986473,14.8153774 129,3.00114896 C129.001151,3.00057448 129.000575,3.00057448 129.001151,3 C165.297155,9.23887776 175.727855,45.0365932 176,45.9925317 C175.995972,45.9948297 175.99252,45.9977021 175.988493,46\" id=\"Fill-66\" fill=\"#DD415D\"></path>\r\n                        <path d=\"M128.5,2.501 C128.499,2.5 128.5,2.5 128.498,2.499 C128.502,2.499 128.502,2.499 128.502,2.499 C128.498,2.499 128.498,2.499 128.498,2.499 C128.501,2.5 128.502,2.5 128.5,2.501\" id=\"Fill-67\" fill=\"#D43F5B\"></path>\r\n                        <path d=\"M207,46 C204.274904,41.4410649 201.113197,37.1440517 197.567593,33.1606556 L197.591085,33.1606556 C201.122365,37.1440517 204.274904,41.4410649 207,46 M170.400863,12.5515348 C158.300659,6.58591809 144.568605,3.15221341 130,3 C144.67518,3.15106463 158.402076,6.5732815 170.46561,12.5233897 C170.44441,12.5325799 170.42149,12.5423446 170.400863,12.5515348\" id=\"Fill-68\" fill=\"#FFFFFE\"></path>\r\n                        <path d=\"M171.939308,13 C171.297221,12.6679753 170.65173,12.3449243 170,12.0274818 C170.02042,12.0185081 170.043108,12.0089736 170.064095,12 C170.713556,12.31576 171.360749,12.6399327 172,12.9708357 C171.97958,12.9803702 171.959728,12.9899047 171.939308,13\" id=\"Fill-69\" fill=\"#F9FBFA\"></path>\r\n                        <path d=\"M197,33 L196.976723,33 C190.00897,24.9550851 181.54468,18.1640447 172,13.0304111 C172.020438,13.0198842 172.040309,13.0099421 172.060747,13 C181.607698,18.1371425 190.044737,24.9387099 197,33\" id=\"Fill-70\" fill=\"#F0F7F6\"></path>\r\n                        <path d=\"M175.005882,46 L175.005882,46 C175.005882,46 175.004117,45.9921607 175,45.9777887 C178.154946,43.603789 184.128993,42 190.981767,42 C190.988237,42 190.99353,42 191,42 C184.132522,42.0026131 178.152593,43.6155479 175.005882,46\" id=\"Fill-71\" fill=\"#FFFFFE\"></path>\r\n                        <path d=\"M130,2.504 C129.666667,2.5 129.334089,2.497 129,2.496 C129.334845,2.497 129.666667,2.499 130,2.504\" id=\"Fill-72\" fill=\"#717D84\"></path>\r\n                        <path d=\"M207,46 L206.997708,46 C203.931538,43.9020048 198.102263,42.4834315 191.40275,42.4834315 C191.397021,42.4834315 191.391292,42.4834315 191.38499,42.4834315 C191.378688,42.4834315 191.373532,42.4834315 191.36723,42.4834315 C184.692352,42.4834315 178.873389,43.89339 175.800344,45.9804731 C175.529361,45.0248027 165.143225,9.23712786 129,3 C129.002292,3 129.002292,3 129.002292,3 C129.084789,3 129.168433,3 129.25265,3.00057432 C129.505872,3.00114864 129.757949,3.00287161 130.010599,3.00516889 C144.577199,3.157364 158.307362,6.59065593 170.405901,12.5555556 C171.064165,12.8806213 171.716127,13.2114303 172.364652,13.5514285 C181.996276,18.5928196 190.537668,25.261837 197.568891,33.162199 C201.114007,37.1451163 204.275279,41.4416129 207,46\" id=\"Fill-73\" fill=\"#E0526A\"></path>\r\n                        <path d=\"M176,46 C175.727861,45.0438954 165.297417,9.23996152 129,3 C129.002301,3 129.002301,3 129.002301,3 C165.297417,9.23996152 175.727861,45.0438954 176,46\" id=\"Fill-74\" fill=\"#E26076\"></path>\r\n                        <path d=\"M75,61.6372055 C75,61.6372055 88.0691856,69.0397482 97.8500363,68.9998392 C103.638774,68.9758938 95.9047024,58.918835 95.9047024,58.918835 C95.9047024,58.918835 89.544181,52.7312352 84.1035864,54.2358032 C78.6635681,55.7420815 75,61.6372055 75,61.6372055\" id=\"Fill-75\" fill=\"#431F18\"></path>\r\n                        <path d=\"M90.0031587,69.1288614 C89.972384,68.5810374 90.1699667,68.0782107 90.4438173,68.0082149 C90.7176679,67.9382192 90.9620818,68.3231959 90.9968707,68.8703056 C91.0276454,69.4159869 90.8278326,69.9173852 90.556212,69.9916664 C90.2814694,70.0623764 90.0352715,69.6752569 90.0031587,69.1288614\" id=\"Fill-76\" fill=\"#431F18\"></path>\r\n                        <path d=\"M82.0029147,69.1288614 C81.9734973,68.5810374 82.1700592,68.0782107 82.4432847,68.0082149 C82.7178473,67.9382192 82.9621011,68.3231959 82.9968672,68.8703056 C83.0276218,69.4159869 82.8283855,69.9173852 82.5556057,69.9916664 C82.2814888,70.0623764 82.0358979,69.6752569 82.0029147,69.1288614\" id=\"Fill-77\" fill=\"#431F18\"></path>\r\n                        <path d=\"M217.498705,110.999851 L215.78855,110.970796 C215.78855,110.970796 215.188465,110.902628 214.959174,110.080146 C214.73046,109.256547 215.989541,109.44317 215.952,108.55252 C215.826669,105.59449 211,98.8313632 211,98.8313632 C211,98.8313632 211.235067,97.818347 213.462138,97.8563421 C215.688632,97.8943372 216.02766,95.1821579 216.19804,99.2196955 C216.203816,99.353237 217.119248,106.496315 217.567435,108.27035 C218.016777,110.044945 218.286497,111.01382 217.498705,110.999851\" id=\"Fill-78\" fill=\"#A6784B\"></path>\r\n                        <path d=\"M232.055323,111 L230.291814,110.970345 C230.291814,110.970345 229.671606,110.900978 229.435082,110.064031 C229.199749,109.225946 230.32339,109.658066 231.090159,108.386156 C231.858119,107.113677 232.949589,105.764441 232.807793,104.472631 C232.666593,103.181389 225.93964,102.159654 226.000409,97.60989 C226.033177,95.4168832 235.824824,99.5356649 236,103.643644 C236.004749,103.780102 235.012775,105.376671 234.221579,107.075014 C233.171219,109.330565 232.867371,111.014125 232.055323,111\" id=\"Fill-79\" fill=\"#A6784B\"></path>\r\n                        <path d=\"M200.614849,84.2946088 C200.73129,84.250287 200.856908,84.2002092 200.988262,84.1472533 C201.87562,83.7863473 202.994138,83.2608175 202.994138,83.2608175 C202.994138,83.2608175 203.560854,82.7778826 204.051855,81.7176133 C204.542282,80.6556171 206.203999,80 207.337431,80 C208.470289,80 211.152439,80.0869168 212.058725,85.089523 C212.187211,85.6657063 212.397722,86.2959967 212.616264,86.6402101 L212.678786,86.7328829 C212.858322,86.9665796 213.055641,87.1559546 213.266725,87.3194271 C213.640712,87.607231 214.065749,87.80524 214.537247,87.9854052 C215.148704,89.457234 217.013475,93.1952302 220.3197,93.6303896 C223.716554,94.0782124 227.512059,90.8772582 228.753328,89.7277696 C230.012378,89.7807255 231.394178,90.0645001 232.802938,90.4944791 C235.86481,91.4286903 242.048782,90.0604709 243.805716,84.3867061 C244.067851,83.541714 244.229606,86.8180729 243.164432,88.4838815 C241.782059,90.6464395 236.36843,95.2904422 229.625772,92.0958196 L226.653382,98.4879428 C226.653382,98.4879428 223.180812,97.721809 222.319266,98.2628802 C221.458294,98.8051026 219.264278,100.794403 212.268663,99.6518215 C206.705325,98.742937 206.398449,90.1070951 206.398449,90.1070951 C206.374358,90.0575928 206.337074,89.9793102 206.29176,89.8808813 L206.280861,89.8561301 C206.106487,89.4842876 205.809363,88.8407582 205.542066,88.286448 C205.351631,87.8892787 205.176683,87.5398849 205.074582,87.372383 L205.071141,87.366627 C201.25728,87.2607152 200.463992,86.3788842 200.311989,85.5068386 L200.305679,85.4982045 C199.978154,85.1206058 199.715446,84.6324905 200.614849,84.2946088\" id=\"Fill-80\" fill=\"#B68C5A\"></path>\r\n                        <g id=\"Group-85\" transform=\"translate(200.000000, 79.000000)\">\r\n                            <mask id=\"mask-4\" fill=\"white\">\r\n                                <use xlink:href=\"#path-3\"></use>\r\n                            </mask>\r\n                            <g id=\"Clip-82\"></g>\r\n                            <path d=\"M44.668,3.88616667 C44.668,3.88616667 45.5942857,10.5985833 41.9308571,12.8508333 C38.268,15.1036667 33.7582857,15.13225 31.8731429,13.64825 C31.3085714,12.4139167 29.0222857,9.92075 28.068,9.44708333 C25.42,8.0955 44.668,3.88616667 44.668,3.88616667\" id=\"Fill-81\" fill=\"#A6784B\" mask=\"url(#mask-4)\"></path>\r\n                            <polyline id=\"Fill-83\" fill=\"#101B1E\" mask=\"url(#mask-4)\" points=\"44.7948571 8.98625 41.5171429 7.50225 43.9102857 4.31841667 44.7948571 8.98625\"></polyline>\r\n                            <path d=\"M27.5331429,19.8788333 C27.5331429,19.8788333 24.6222857,17.0251667 24.8817143,15.1713333 C25.1405714,13.3175 25.0862857,16.8064167 22.084,19.23075 C22.372,19.8193333 27.5331429,19.8788333 27.5331429,19.8788333\" id=\"Fill-84\" fill=\"#A6784B\" mask=\"url(#mask-4)\"></path>\r\n                        </g>\r\n                        <path d=\"M220.694561,92.955014 C217.438589,92.4959551 215.602163,88.5526635 215,87 C215.224822,87.0922976 215.455859,87.1809518 215.703841,87.2714277 C217.155019,87.7984953 219.992979,88.8908854 222.563751,89.0457267 C224.022837,89.1337737 226.593044,88.7269358 229,88.8380572 C227.777598,90.0506771 224.039784,93.4274317 220.694561,92.955014\" id=\"Fill-86\" fill=\"#B68C5A\"></path>\r\n                        <path d=\"M200.622152,84.1090754 C200.739975,84.0762676 200.867086,84.039199 201,84 C200.963434,84.3493822 200.808464,84.7788666 200.30931,85 C199.977895,84.7204942 199.712066,84.3591819 200.622152,84.1090754\" id=\"Fill-87\" fill=\"#101B1E\"></path>\r\n                        <path d=\"M213.410871,86.0857904 C213.590771,86.3021314 213.788488,86.4774423 214,86.6287744 L207.01092,89 L207,88.977087 L213.348222,86 L213.410871,86.0857904\" id=\"Fill-88\" fill=\"#A6784B\"></path>\r\n                        <path d=\"M205.448187,88 C205.265613,87.5564127 205.097886,87.1661845 205,86.9791064 C206.015157,87.04018 206.999518,86 206.999518,86 C207.026464,86.8807457 205.916171,87.6952748 205.448187,88\" id=\"Fill-89\" fill=\"#A6784B\"></path>\r\n                        <path d=\"M209.647173,80.2610327 C210.237724,80.5224594 211.270921,81.5816353 210.933997,83.3357042 C210.598141,85.0903853 208.961044,86.1109902 208.368357,85.9903788 C206.954452,85.5422188 206.817227,81.9942854 207.153616,80.8206205 C207.490006,79.6475678 209.057156,79.999606 209.647173,80.2610327\" id=\"Fill-90\" fill=\"#101B1E\"></path>\r\n                        <path d=\"M205,82.5 C205,82.7759398 205.22406,83 205.499248,83 C205.775188,83 206,82.7759398 206,82.5 C206,82.2240602 205.775188,82 205.499248,82 C205.22406,82 205,82.2240602 205,82.5\" id=\"Fill-91\" fill=\"#101B1E\"></path>\r\n                        <polyline id=\"Fill-92\" fill=\"#3A6080\" points=\"212.416808 85 206 87.8901826 206.530688 89 213 86.0203758 212.416808 85\"></polyline>\r\n                        <path d=\"M205.625191,109.978749 C206.144077,109.978749 207.428772,108.835329 207.375777,108.181607 C207.322199,107.527294 207.003646,105.951612 207.377524,105.348814 C207.751401,104.746017 216,96.9605724 216,96.9605724 L209.235264,95 C209.235264,95 209.570123,97.9843808 209.235264,98.5403994 C208.899822,99.0964179 206.247738,103.496603 206.247738,103.496603 C206.247738,103.496603 205.590832,104.422709 205.572196,105.948059 C205.554725,107.472817 204.866954,108.344446 205.023027,109.161597 C205.179683,109.978749 205.352063,110.050398 205.625191,109.978749\" id=\"Fill-93\" fill=\"#B68C5A\"></path>\r\n                        <path d=\"M238.941138,110.983717 C239.978661,111.19206 240,109.332223 240,109.332223 C240,109.332223 239.801031,108.422631 239.470569,108.002559 C239.139531,107.583051 238.013769,102.464831 238.013769,102.464831 C238.013769,102.464831 238.013769,101.88215 237.153877,101.622428 C236.293984,101.36327 234.242584,100.392135 234.043615,99.2256441 C233.845222,98.0597175 233.910969,92.944885 231.330137,91.3216216 C228.75046,89.6983582 224,94.7476955 224,94.7476955 C224,94.7476955 228.816206,101.651788 233.447861,102.206238 C236.028692,103.501461 236.624446,104.278934 237.08813,105.639652 C237.551238,107.00037 237.484915,110.692377 238.941138,110.983717\" id=\"Fill-94\" fill=\"#B68C5A\"></path>\r\n                        <path d=\"M221.009971,92.9654119 C217.573658,92.5055514 215.635515,88.5553745 215,87 C215.237275,87.0924587 215.481108,87.1812677 215.742826,87.2719016 C217.274382,87.7998895 220.269531,88.8941871 222.982692,89.0492987 C223.973523,89.1064771 224.769408,89.0249675 225.887223,88.9434578 C226.50545,88.898445 224.540479,93.4386545 221.009971,92.9654119\" id=\"Fill-95\" fill=\"#A6784B\"></path>\r\n                    </g>\r\n                </g>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>";
var manHoldingBox = "<svg width=\"201px\" height=\"250px\" viewBox=\"0 0 201 250\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\r\n    <title>Group 9</title>\r\n    <defs>\r\n        <rect id=\"path-1\" x=\"0\" y=\"0\" width=\"197.639344\" height=\"249.57377\"></rect>\r\n        <path d=\"M5.45455738,0.253901639 C5.46177049,0.253901639 5.46754098,0.266885246 5.47042623,0.294295082 C10.9451803,39.6432787 26.6654426,62.5723279 33.1081967,70.5471475 C31.7824262,70.576 30.4191475,70.5918689 29.0241311,70.5918689 L27.8689762,70.5887604 C27.4256631,70.5861032 26.9790012,70.5818982 26.5290043,70.5760938 L27.458591,70.5854822 C27.1203495,70.5827288 26.7801587,70.5790734 26.438028,70.5744932 L26.4392954,70.574916 C25.4803294,70.5616721 24.5074312,70.5416042 23.5195418,70.5137891 L23.5185487,70.5142288 C22.214637,70.477048 20.8835758,70.4267898 19.5268389,70.3618612 L19.5278306,70.3624616 C18.1481682,70.2958828 16.7429848,70.2147559 15.3117929,70.1172703 L15.3113033,70.1179584 C13.8783306,70.01963 12.4187772,69.9055791 10.9336393,69.7739016 L0.11252459,33.9838689 C0.11252459,33.9838689 5.07514754,0.253901639 5.45455738,0.253901639 Z\" id=\"path-3\"></path>\r\n        <path d=\"M145.78859,54.7230164 L110.044721,66.3144918 C110.044721,66.3144918 89.5796721,28.447082 85.547541,20.7045246 C81.5182951,12.9619672 74.4162623,7.0212459 66.4385574,4.24996721 C58.4622951,1.47580328 37.5673443,0.520786885 37.5673443,0.520786885 C37.5673443,0.520786885 9.06111475,8.38019672 6.20039344,26.7693115 C3.33967213,45.155541 0.393836066,66.6838033 0.393836066,66.6838033 C0.393836066,66.6838033 -1.0055082,74.6990164 1.91436066,82.8339672 C4.83422951,90.9674754 18.8045902,121.461639 18.8045902,121.461639 C18.8045902,121.461639 31.3568525,117.283803 32.7994754,114.769311 C32.4388197,113.697443 32.0998033,112.644328 31.7737705,111.604197 C68.552,114.87318 89.4108852,107.361443 89.4108852,107.361443 L87.5989508,72.259541 C93.6175738,80.1304918 101.690492,89.0184918 106.282361,87.1358689 C127.778885,78.3272131 151.494164,67.4758033 151.494164,67.4758033 L145.78859,54.7230164\" id=\"path-5\"></path>\r\n        <polygon id=\"path-7\" points=\"0.129918107 0 36.914457 0 36.914457 29.4997919 0.129918107 29.4997919\"></polygon>\r\n    </defs>\r\n    <g id=\"2---MY-POLICIES\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\r\n        <g id=\"2.0_my_policie_one\" transform=\"translate(-1059.000000, -333.000000)\">\r\n            <g id=\"Group-9\" transform=\"translate(1059.000000, 333.000000)\">\r\n                <g id=\"Group-11\" transform=\"translate(101.065574, 125.000000) scale(-1, 1) translate(-101.065574, -125.000000) translate(2.065574, 0.000000)\">\r\n                    <mask id=\"mask-2\" fill=\"white\">\r\n                        <use xlink:href=\"#path-1\"></use>\r\n                    </mask>\r\n                    <g id=\"Mask\"></g>\r\n                    <g mask=\"url(#mask-2)\">\r\n                        <g transform=\"translate(2.885246, 18.754098)\">\r\n                            <polyline id=\"Fill-26\" fill=\"#0E313D\" points=\"22.6015738 171.19318 32.7792787 340.660984 53.8776393 341.240918 64.1202623 170.011672 22.6015738 171.19318\"></polyline>\r\n                            <g id=\"Group-30\" stroke-width=\"1\" fill=\"none\" transform=\"translate(28.131148, 167.344262)\">\r\n                                <path d=\"M19.9817705,4.54859016 L21.3291803,169.303344 L31.7997377,167.954492 C31.7997377,167.954492 54.6999344,97.1101639 56.794623,90.2678033 C58.8878689,83.424 61.2883934,0.626098361 61.2883934,0.626098361 L19.9817705,4.54859016\" id=\"Fill-27\" fill=\"#0E313D\"></path>\r\n                            </g>\r\n                            <g id=\"Group-35\" stroke-width=\"1\" fill=\"none\" transform=\"translate(18.754098, 101.704918)\">\r\n                                <path d=\"M18.9589508,81.3480656 C17.7933115,78.6013115 13.8621639,73.3241967 13.8621639,73.3241967 L0.562622951,78.8653115 C0.562622951,78.8653115 4.05954098,91.8806557 8.1277377,95.4006557 C12.4368525,99.1182951 19.0945574,103.006164 22.5741639,100.337311 C26.0508852,97.6641311 20.3741639,84.5391475 18.9589508,81.3480656\" id=\"Fill-32\" fill=\"#ED9E8B\"></path>\r\n                                <path d=\"M127.962098,13.6342295 C127.962098,13.6342295 128.666098,12.1872787 129.830295,10.4546885 C130.993049,8.72354098 132.506361,7.04288525 135.189639,6.23357377 C137.86859,5.42570492 141.675672,-1.83645902 144.537836,0.758819672 C146.518557,2.55921311 143.881443,6.39514754 142.072393,8.57927869 L156.028328,8.89954098 C161.530492,9.2717377 161.702164,13.088918 161.536262,14.4824918 C161.370361,15.8299016 158.423082,17.5422951 154.734295,19.042623 L154.73141,19.042623 C152.548721,19.9298361 150.102033,20.744918 147.816918,21.3652459 C147.023475,21.5801967 146.202623,21.724459 145.371672,21.8110164 C142.757639,22.5770492 140.370098,23.2695082 139.409311,23.5262951 C136.848656,24.211541 132.790557,22.7790164 132.790557,22.7790164 L129.895213,23.8379016 L126.121311,14.6887869 L127.962098,13.6342295\" id=\"Fill-34\" fill=\"#ED9E8B\"></path>\r\n                            </g>\r\n                            <path d=\"M145.78859,115.31318 L110.044721,126.904656 C110.044721,126.904656 89.5796721,89.0372459 85.547541,81.2946885 C81.5182951,73.5521311 74.4162623,67.6114098 66.4385574,64.8401311 C58.4622951,62.0659672 37.5673443,61.1109508 37.5673443,61.1109508 C37.5673443,61.1109508 9.06111475,68.9703607 6.20039344,87.3594754 C3.33967213,105.745705 0.393836066,127.273967 0.393836066,127.273967 C0.393836066,127.273967 -1.0055082,135.28918 1.91436066,143.424131 C4.83422951,151.557639 18.8045902,182.051803 18.8045902,182.051803 C18.8045902,182.051803 31.3568525,177.873967 32.7994754,175.359475 C32.4388197,174.287607 32.0998033,173.234492 31.7737705,172.194361 C68.552,175.463344 89.4108852,167.951607 89.4108852,167.951607 L87.5989508,132.849705 C93.6175738,140.720656 101.690492,149.608656 106.282361,147.726033 C127.778885,138.917377 151.494164,128.065967 151.494164,128.065967 L145.78859,115.31318\" id=\"Fill-36\" fill=\"#63B9B4\"></path>\r\n                            <g id=\"Group-39\" stroke-width=\"1\" fill=\"none\" transform=\"translate(20.918033, 102.426230)\">\r\n                                <mask id=\"mask-4\" fill=\"white\">\r\n                                    <use xlink:href=\"#path-3\"></use>\r\n                                </mask>\r\n                                <g id=\"Clip-38\"></g>\r\n                                <polygon id=\"Fill-37\" fill=\"#50AAA5\" mask=\"url(#mask-4)\" points=\"0.11252459 70.5918689 33.1081967 70.5918689 33.1081967 0.253901639 0.11252459 0.253901639\"></polygon>\r\n                            </g>\r\n                            <g id=\"Group-42\" stroke-width=\"1\" fill=\"none\" transform=\"translate(0.000000, 60.590164)\">\r\n                                <mask id=\"mask-6\" fill=\"white\">\r\n                                    <use xlink:href=\"#path-5\"></use>\r\n                                </mask>\r\n                                <g id=\"Clip-41\"></g>\r\n                                <path d=\"M101.756852,86.4578361 C97.3539672,84.1467541 91.9412459,77.9377049 87.5989508,72.259541 L87.6076066,72.4326557 L83.3057049,44.1846557 C87.6220328,63.5114754 97.4174426,79.8708197 101.756852,86.4578361\" id=\"Fill-40\" fill=\"#50AAA5\" mask=\"url(#mask-6)\"></path>\r\n                            </g>\r\n                            <path d=\"M61.829377,40.5045246 L41.3022951,35.9732459 C41.3022951,35.9732459 39.8856393,53.4910164 39.5870164,57.4207213 C39.347541,60.5295738 46.264918,69.4868197 57.1971148,68.6645246 C60.2929836,68.4308197 62.885377,64.7203934 62.4944262,57.8174426 L61.829377,40.5045246\" id=\"Fill-43\" fill=\"#ED9E8B\"></path>\r\n                            <polyline id=\"Fill-44\" fill=\"#DD8677\" points=\"47.3641967 46.0312131 62.5117377 58.1045246 61.8351475 40.4785574 47.3641967 46.0312131\"></polyline>\r\n                            <path d=\"M57.7640656,50.0013115 C41.1739016,47.3339016 39.125377,34.8624262 38.4314754,25.52 C37.9842623,19.5302295 39.1931803,6.52498361 51.5506885,6.18740984 C63.8923279,5.85560656 70.0566557,7.65022951 70.4173115,18.4987541 C70.8818361,32.2916721 65.888918,51.3068852 57.7640656,50.0013115\" id=\"Fill-45\" fill=\"#ED9E8B\"></path>\r\n                            <path d=\"M41.3282623,36.309377 C38.8123279,36.6483934 37.1807213,32.2483934 36.784,30.1897705 C36.3699672,28.0431475 37.1634098,26.1028197 38.7300984,24.9415082 C41.2157377,23.1050492 43.0420984,27.1732459 42.5429508,30.4869508 C42.0264918,33.8554754 43.4633443,36.0727869 41.3282623,36.309377\" id=\"Fill-46\" fill=\"#ED9E8B\"></path>\r\n                            <path d=\"M60.7272131,38.5122623 C60.9782295,38.4718689 61.1672131,38.2497049 61.1614426,37.9857049 L60.9695738,29.0587541 C60.960918,28.7731148 60.7243279,28.5422951 60.4285902,28.5495082 C60.127082,28.5523934 59.9135738,28.7961967 59.9135738,29.0847213 L60.1083279,38.0059016 C60.1126557,38.2987541 60.3535738,38.5310164 60.6464262,38.5180328 L60.7272131,38.5122623\" id=\"Fill-47\" fill=\"#DD8677\"></path>\r\n                            <path d=\"M65.6552131,29.3948852 C65.8110164,28.7269508 65.5152787,28.0546885 64.9815082,27.8945574 C64.4520656,27.7344262 63.9053115,28.1426885 63.7422951,28.8062951 C63.5850492,29.4641311 63.8952131,30.1392787 64.4217705,30.306623 C64.9454426,30.471082 65.5008525,30.0599344 65.6552131,29.3948852\" id=\"Fill-48\" fill=\"#101B1E\"></path>\r\n                            <g id=\"Group-52\" stroke-width=\"1\" fill=\"none\" transform=\"translate(34.622951, 0.000000)\">\r\n                                <mask id=\"mask-8\" fill=\"white\">\r\n                                    <use xlink:href=\"#path-7\"></use>\r\n                                </mask>\r\n                                <g id=\"Clip-50\"></g>\r\n                                <path d=\"M20.6078689,28.3951475 C20.6468197,27.7099016 20.2385574,27.0967869 19.6946885,27.0188852 C19.1421639,26.9539672 18.6689836,27.4372459 18.6184918,28.1239344 C18.568,28.8019672 18.984918,29.4121967 19.5287869,29.4929836 C20.0726557,29.5636721 20.5544918,29.0760656 20.6078689,28.3951475\" id=\"Fill-49\" fill=\"#101B1E\" mask=\"url(#mask-8)\"></path>\r\n                                <path d=\"M9.10295082,28.4716066 C8.26911475,29.8695082 6.66347541,26.7116066 5.96957377,26.1172459 C4.50242623,24.8462951 3.19396721,25.2112787 2.43947541,27.0405246 C2.3067541,27.4271475 -0.235147541,21.1055738 0.174557377,18.1366557 C0.57704918,15.170623 0.556852459,11.9780984 4.26872131,10.0031475 C5.69403279,6.18452459 9.39580328,0.42557377 16.6348852,0.0230819672 C23.8754098,-0.377967213 23.7239344,4.4562623 27.5944918,4.70439344 C31.9064918,4.98137705 36.4824918,7.84931148 36.9109508,16.4747541 C37.1273443,20.7881967 27.2626885,19.2417049 25.2372459,18.9127869 C22.5207869,18.4771148 19.8389508,17.8308197 17.2003934,17.048918 C16.4459016,16.8253115 14.3771803,15.6971803 13.6962623,15.9121311 C12.3575082,16.3377049 12.5378361,19.0556066 12.4671475,20.1491148 C12.343082,21.9495082 12.1627541,22.4904918 10.636459,23.496 C8.26911475,25.0540328 10.108459,26.1504262 9.20104918,28.2739672 L9.10295082,28.4716066\" id=\"Fill-51\" fill=\"#101B1E\" mask=\"url(#mask-8)\"></path>\r\n                            </g>\r\n                            <path d=\"M55.3375738,39.6014426 C56.7095082,40.8262295 58.4146885,41.0527213 58.4262295,41.0541639 L58.4262295,41.072918 C58.8171803,41.1378361 59.2485246,41.172459 59.7015082,41.1436066 C59.9900328,41.1320656 60.2511475,41.3527869 60.2626885,41.6499672 C60.28,41.941377 60.0535082,42.1967213 59.763541,42.2154754 C59.3725902,42.2356721 58.9917377,42.2241311 58.6397377,42.1837377 C57.0398689,42.0034098 55.8872131,41.3181639 55.7256393,41.1940984 L55.5150164,41.072918 C55.2135082,40.8839344 54.9148852,40.6617705 54.624918,40.4020984 C54.3998689,40.2015738 54.3825574,39.8654426 54.5773115,39.6418361 C54.7763934,39.4254426 55.1182951,39.4081311 55.3375738,39.6014426\" id=\"Fill-53\" fill=\"#DD8677\"></path>\r\n                            <polyline id=\"Fill-54\" fill=\"#63B9B4\" points=\"45.5436066 78.1901639 55.7544918 68.7611803 39.9116066 53.450623 35.540459 62.0327869 45.5436066 78.1901639\"></polyline>\r\n                            <polyline id=\"Fill-55\" fill=\"#63B9B4\" points=\"65.4590164 78.8725246 55.7285246 68.7063607 62.5506885 58.9383607 65.8268852 64.8761967 65.4590164 78.8725246\"></polyline>\r\n                            <polyline id=\"Fill-56\" fill=\"#0C2935\" points=\"63.8779016 155.692197 54.1257705 144.439738 55.1961967 77.9607869 59.2167869 77.1442623 69.8734426 144.097836 63.8779016 155.692197\"></polyline>\r\n                            <polyline id=\"Fill-57\" fill=\"#0C2935\" points=\"55.1904262 78.4974426 51.2765902 73.2664918 55.8078689 69.8777705 59.7577705 72.623082 59.2903607 77.6434098 55.1904262 78.4974426\"></polyline>\r\n                            <path d=\"M63.1176393,198.685246 L57.1798033,299.912656 C57.1798033,299.912656 69.8734426,244.627016 67.4339672,226.041705 C64.9959344,207.457836 63.1176393,198.685246 63.1176393,198.685246\" id=\"Fill-58\" fill=\"#0C2935\"></path>\r\n                        </g>\r\n                    </g>\r\n                </g>\r\n                <g id=\"Group-6\" transform=\"translate(0.000000, 77.901639)\">\r\n                    <rect id=\"Rectangle\" fill=\"#026694\" x=\"0\" y=\"0\" width=\"62.3213115\" height=\"53.6655738\"></rect>\r\n                    <rect id=\"Rectangle\" fill=\"#007AB3\" x=\"0\" y=\"0\" width=\"50.2032787\" height=\"53.6655738\"></rect>\r\n                    <polygon id=\"Star\" fill=\"#FFFFFF\" points=\"31.1606557 34.6229508 22.0027688 39.4375369 23.7517696 29.2400799 16.3428834 22.0182008 26.5817123 20.5304119 31.1606557 11.252459 35.7395992 20.5304119 45.9784281 22.0182008 38.5695419 29.2400799 40.3185427 39.4375369\"></polygon>\r\n                </g>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>";
var manHoldingCertificate = "<svg width=\"136px\" height=\"113px\" viewBox=\"0 0 136 113\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\r\n    <title>man_holding_certificate</title>\r\n    <defs>\r\n        <polygon id=\"path-1\" points=\"0.0273387097 6.07510246e-05 102.018163 6.07510246e-05 102.018163 81.8448065 0.0273387097 81.8448065\"></polygon>\r\n    </defs>\r\n    <g id=\"Symbols\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\r\n        <g id=\"BOX-/-section-/-list-of-documents\" transform=\"translate(-32.000000, -100.000000)\">\r\n            <g id=\"download-all\" transform=\"translate(0.000000, 60.000000)\">\r\n                <g id=\"man_holding_certificate\" transform=\"translate(100.000000, 96.500000) scale(-1, 1) translate(-100.000000, -96.500000) translate(32.000000, 40.000000)\">\r\n                    <path d=\"M62.5386653,62.8635403 L36.2233347,82.8463145 L18.6363427,56.4886089 L9.3133871,63.4467661 C9.3133871,63.4467661 18.9566613,97.4825484 20.0096573,100.7395 C21.0626532,103.995996 23.2319798,109.431843 29.8575161,110.221476 C36.4835081,111.01202 49.0465565,102.065427 49.0465565,102.065427 L61.1320887,94.5495605 L58.9773427,88.8672097 L62.5386653,62.8635403\" id=\"Fill-1\" fill=\"#227D81\"></path>\r\n                    <path d=\"M38.7658347,108.022532 C44.0927823,105.593944 49.0465565,102.065883 49.0465565,102.065427 L61.1320887,94.5495605 L58.9773427,88.8672097 L55.5103387,75.3340927 C55.5103387,75.3340927 35.9257984,97.371371 38.7658347,108.022532\" id=\"Fill-2\" fill=\"#19676B\"></path>\r\n                    <path d=\"M87.4023105,53.3364556 C75.6320847,53.3364556 64.2956331,60.6568508 59.9733831,65.1982661 C54.6081613,70.8341411 49.7473387,100.917202 49.7473387,113 C49.7473387,113 91.3231371,113 135.181262,113 C135.181262,113 131.96623,53.3364556 87.4023105,53.3364556\" id=\"Fill-3\" fill=\"#227D81\"></path>\r\n                    <path d=\"M77.1689758,40.2721976 L96.8633266,34.3447097 C96.8633266,34.3447097 99.5334073,51.3288831 100.113899,55.1412661 C100.572278,58.1558145 94.4087661,66.9862177 83.6837903,66.9862177 C80.6496492,66.9862177 77.9180565,63.9712137 77.792754,57.2103508 L77.1689758,40.2721976\" id=\"Fill-4\" fill=\"#ED9E8B\"></path>\r\n                    <polyline id=\"Fill-5\" fill=\"#DD8677\" points=\"91.6894758 44.6017379 77.7995887 57.4919395 77.271496 36.0661371 91.6894758 44.6017379\"></polyline>\r\n                    <path d=\"M81.84025,49.2388387 C97.822004,45.4187097 98.909629,33.1007984 98.8969794,23.935496 C98.895504,18.0572177 96.7576169,5.45862903 84.6821089,6.03912097 C72.6143468,6.61824597 66.7337903,8.8231129 67.1743992,19.4332661 C67.7352984,32.9235524 74.0058871,51.1088065 81.84025,49.2388387\" id=\"Fill-6\" fill=\"#ED9E8B\"></path>\r\n                    <path d=\"M96.862871,34.6723185 C99.3438589,34.8199476 100.610552,30.4065685 100.847944,28.3666452 C101.094903,26.2456169 100.178145,24.408 98.5633387,23.3914556 C96.0080806,21.7834839 94.5185766,25.8865685 95.2494315,29.0815524 C95.9980565,32.3289355 94.7623468,34.5994153 96.862871,34.6723185\" id=\"Fill-7\" fill=\"#ED9E8B\"></path>\r\n                    <path d=\"M78.1007702,38.2482218 C77.8542661,38.2245282 77.6537823,38.0217661 77.6382903,37.7629597 L77.1703427,29.0446452 C77.1548508,28.7657903 77.3699153,28.5206532 77.6546935,28.5065282 C77.9508629,28.4869355 78.1832419,28.7056452 78.202379,28.9895121 L78.6671371,37.7091935 C78.6830847,37.9944274 78.4666532,38.236375 78.181875,38.2482218 L78.1007702,38.2482218\" id=\"Fill-8\" fill=\"#DD8677\"></path>\r\n                    <path d=\"M72.6211815,29.7158105 C72.4220645,29.0765403 72.6644677,28.3958065 73.1697782,28.2007903 C73.6741774,28.0057742 74.2396331,28.3639113 74.4478629,28.9995363 C74.6451573,29.6301492 74.396375,30.3108831 73.894254,30.5122782 C73.3921331,30.7136734 72.8275887,30.3518911 72.6211815,29.7158105\" id=\"Fill-9\" fill=\"#1C2B2F\"></path>\r\n                    <g id=\"Group-15\">\r\n                        <mask id=\"mask-2\" fill=\"white\">\r\n                            <use xlink:href=\"#path-1\"></use>\r\n                        </mask>\r\n                        <g id=\"Clip-11\"></g>\r\n                        <path d=\"M82.7228347,27.9711452 C82.6303387,27.3109153 82.9839194,26.6798468 83.5111008,26.5654798 C84.0455726,26.4570363 84.5417702,26.8949113 84.6442903,27.5596976 C84.7390645,28.2181048 84.3795605,28.8468952 83.8560242,28.9630847 C83.3261089,29.0747177 82.8230766,28.6336532 82.7228347,27.9711452\" id=\"Fill-10\" fill=\"#1C2B2F\" mask=\"url(#mask-2)\"></path>\r\n                        <path d=\"M93.9481089,27.2020161 C94.8630444,28.5065282 96.2021855,25.3074435 96.8318871,24.6750081 C98.1728508,23.3249315 99.4696169,23.5896613 100.341266,25.3170121 C100.500742,25.6860847 102.518794,19.3280121 101.90094,16.4651935 C101.287185,13.5991855 101.077133,10.4853065 97.3089476,8.83131452 C95.6367298,5.20893548 91.6024476,-0.136693548 84.5116976,0.00273387097 C77.4186694,0.143528226 77.9244355,4.84806452 74.1630847,5.37387903 C69.9770726,5.96029435 65.7268145,9.09467742 65.9373226,17.5391492 C66.0443992,21.7643468 75.5582702,19.5321411 77.5107097,19.0641935 C80.124746,18.4367702 82.6959516,17.6125081 85.2079234,16.6538306 C85.9282984,16.3808992 87.8675242,15.1292419 88.5459798,15.289629 C89.8842097,15.6072137 89.9060806,18.2704597 90.0578105,19.3302903 C90.3102379,21.0786008 90.5239355,21.5930242 92.0895323,22.4637621 C94.510375,23.8097379 92.7957823,25.0117298 93.8378427,27.0161129 C93.8733831,27.084004 93.910746,27.1487056 93.9481089,27.2020161\" id=\"Fill-12\" fill=\"#1C2B2F\" mask=\"url(#mask-2)\"></path>\r\n                        <path d=\"M83.4409315,38.9161976 C82.1942863,40.2088629 80.5443952,40.5551532 80.5279919,40.5569758 L80.533004,40.573379 C80.1557298,40.665875 79.7379032,40.7319435 79.2954718,40.7369556 C79.0116048,40.7488024 78.775125,40.9811815 78.7824153,41.27325 C78.7865161,41.5603065 79.0261855,41.7917742 79.3146089,41.7885847 C79.6959839,41.7812944 80.0632339,41.7398306 80.407246,41.6733065 C81.9523387,41.3803266 83.0299395,40.6307903 83.1748347,40.496375 C83.2422702,40.4503548 83.3042379,40.4129919 83.372129,40.3624153 C83.6509839,40.1550968 83.9325726,39.9181613 84.1959355,39.6397621 C84.396875,39.429254 84.3886734,39.0993669 84.1813548,38.8979718 C83.9713024,38.6993105 83.6400484,38.7116129 83.4409315,38.9161976\" id=\"Fill-13\" fill=\"#DD8677\" mask=\"url(#mask-2)\"></path>\r\n                        <polyline id=\"Fill-14\" fill=\"#B3D4D4\" mask=\"url(#mask-2)\" points=\"64.3658024 68.0392137 17.734621 81.8448065 0 21.943871 46.6307258 8.13827823 64.3658024 68.0392137\"></polyline>\r\n                    </g>\r\n                    <polyline id=\"Fill-16\" fill=\"#98CAC9\" points=\"19.5900081 77.1115645 4.13315726 24.9041976 44.77625 12.8715202 60.2326452 65.0788871 19.5900081 77.1115645\"></polyline>\r\n                    <path d=\"M34.5966815,32.0865323 C33.6594194,28.921621 30.3336653,27.1149879 27.1682984,28.05225 C24.0015645,28.9890565 22.1958427,32.3152661 23.1326492,35.4810887 C24.0699113,38.6464556 27.396121,40.4535444 30.5614879,39.515371 C33.7277661,38.5790202 35.5339435,35.2528105 34.5966815,32.0865323\" id=\"Fill-17\" fill=\"#63B9B4\"></path>\r\n                    <path d=\"M47.6459032,42.6980524 C47.5406492,42.3440161 47.1688427,42.141254 46.8143508,42.2460524 L18.4148992,50.6536169 C18.0613185,50.758871 17.8585565,51.1315887 17.9638105,51.485625 C18.0681532,51.8401169 18.4413266,52.0419677 18.7949073,51.937625 L47.1939032,43.5296048 C47.5483952,43.4243508 47.750246,43.0525444 47.6459032,42.6980524\" id=\"Fill-18\" fill=\"#31506D\"></path>\r\n                    <path d=\"M49.0187621,47.3356089 C48.9139637,46.9811169 48.541246,46.7792661 48.1872097,46.8840645 L19.7886694,55.2920847 C19.4346331,55.3968831 19.231871,55.7691452 19.3362137,56.1231815 C19.4414677,56.4772177 19.8137298,56.6799798 20.1682218,56.5751815 L48.5672177,48.1667056 C48.921254,48.0619073 49.1240161,47.6896452 49.0187621,47.3356089\" id=\"Fill-19\" fill=\"#31506D\"></path>\r\n                    <path d=\"M50.3920766,51.9731653 C50.2868226,51.619129 49.9145605,51.4168226 49.5609798,51.5220766 L21.1610726,59.9296411 C20.8070363,60.0344395 20.6051855,60.4071573 20.7099839,60.7607379 C20.8147823,61.1147742 21.1870444,61.3175363 21.5410806,61.2122823 L49.9405323,52.8042621 C50.2941129,52.6999194 50.496875,52.3272016 50.3920766,51.9731653\" id=\"Fill-20\" fill=\"#31506D\"></path>\r\n                    <path d=\"M51.7644798,56.6107218 C51.6601371,56.2566855 51.287875,56.054379 50.9333831,56.1596331 L22.5343871,64.5671976 C22.1803508,64.671996 21.9780444,65.0447137 22.0828427,65.39875 C22.1876411,65.7527863 22.5599032,65.9555484 22.9139395,65.8502944 L51.3133911,57.4422742 C51.6678831,57.3370202 51.8697339,56.9652137 51.7644798,56.6107218\" id=\"Fill-21\" fill=\"#31506D\"></path>\r\n                    <path d=\"M5.86962097,41.7689919 C5.86962097,41.7689919 2.58852016,44.8445968 2.5948899,47.6295 C2.59854435,49.2502298 3.79370161,54.2395444 5.28366129,57.1839234 C7.29943548,61.168996 9.63051613,64.4569315 10.9464194,64.5398589 C12.2618669,64.621875 12.5142944,64.2113387 12.5142944,64.2113387 L5.86962097,41.7689919\" id=\"Fill-22\" fill=\"#ED9E8B\"></path>\r\n                    <path d=\"M18.3347056,57.6751089 C18.9293226,54.8943065 14.8125685,44.8382177 14.8125685,44.8382177 C14.8125685,44.8382177 14.012,42.1672258 12.3780565,42.6383629 C10.7432016,43.1095 5.86962097,46.8494355 5.86962097,46.8494355 L12.5142944,64.2113387 C12.5142944,64.2113387 17.6407581,60.9124677 18.3347056,57.6751089\" id=\"Fill-23\" fill=\"#ED9E8B\"></path>\r\n                    <path d=\"M109.235004,86.0021129 C109.235004,86.0021129 110.300758,104.418379 102.411262,113 L118.19071,113 C116.131649,102.154734 109.235004,86.0021129 109.235004,86.0021129\" id=\"Fill-24\" fill=\"#19676B\"></path>\r\n                </g>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>";
var notFound = "<svg width=\"306px\" height=\"180px\" viewBox=\"0 0 306 180\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\r\n    <title>Group</title>\r\n    <g id=\"0---LOGIN-and-REGISTER\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\r\n        <g id=\"0.4-404-page\" transform=\"translate(-567.000000, -260.000000)\">\r\n            <g id=\"Group-5\" transform=\"translate(367.500000, 260.000000)\">\r\n                <g id=\"Group\" transform=\"translate(199.500000, 0.000000)\">\r\n                    <g id=\"Group-2\" transform=\"translate(150.790457, 90.000000) rotate(3.000000) translate(-150.790457, -90.000000) translate(92.424323, 2.935328)\">\r\n                        <path d=\"M80.3316527,138.484939 C80.5694903,139.248775 80.1397868,140.061291 79.3765935,140.299224 L74.9001453,141.691207 C74.1340986,141.930564 73.3184428,141.504158 73.0820322,140.738899 L62.2924484,106.121626 C62.0531852,105.356368 62.4814617,104.545275 63.2489346,104.305918 L67.7225296,102.915358 C68.4885762,102.676001 69.3028051,103.103831 69.5406427,103.867667 L80.3316527,138.484939\" id=\"Fill-21\" fill=\"#B3D4D4\" transform=\"translate(71.311669, 122.303344) rotate(4.000000) translate(-71.311669, -122.303344) \"></path>\r\n                        <g id=\"Group-Copy-2\" opacity=\"0.384590512\" transform=\"translate(60.712640, 88.861652) rotate(3.000000) translate(-60.712640, -88.861652) translate(8.948785, 6.189773)\" fill=\"#1B3E42\">\r\n                            <path d=\"M80.6202147,135.536236 L76.1442722,136.92609 C75.3783126,137.165083 74.5624302,136.738311 74.3256531,135.972966 L63.8806045,101.297515 C63.6409747,100.53217 64.068885,99.7213035 64.836271,99.4823111 L68.9482461,98.1481617 C69.7142057,97.9091694 70.5286617,98.337364 70.7668652,99.1012859 L81.5744548,133.722455 C81.8126582,134.486377 81.3833215,135.298666 80.6202147,135.536236 Z\" id=\"Fill-21\"></path>\r\n                            <path d=\"M91.5872763,162.297131 L81.9275113,165.187062 C80.1017225,165.754076 78.15621,164.73402 77.5875217,162.906182 L62.1178778,113.158596 C61.5491895,111.330758 62.5696928,109.387523 64.3969068,108.820509 L74.0566718,105.930578 C75.8853111,105.363564 77.8279731,106.38362 78.3980866,108.210033 L93.86488,157.959044 C94.4378441,159.786882 93.4159155,161.728692 91.5872763,162.297131 Z\" id=\"Fill-22\"></path>\r\n                            <path d=\"M36.3812902,2.33710438 C9.09242516,10.7758903 -6.14178851,39.5908074 2.35226674,66.6961367 C10.8477491,93.8014661 39.8562607,108.936846 67.1451257,100.49806 C94.4339907,92.0592743 109.669631,63.2443572 101.175576,36.1376103 C92.681521,9.03228091 63.6715823,-6.10168154 36.3812902,2.33710438 Z\" id=\"Fill-23\"></path>\r\n                        </g>\r\n                        <path d=\"M90.5464767,168.150146 L79.8684644,171.478956 C78.0424694,172.046839 76.0974982,171.027655 75.5296852,169.200022 L59.5886132,118.316732 C59.0208002,116.489099 60.0421811,114.545325 61.8696014,113.977441 L72.5476137,110.648631 C74.3764592,110.080747 76.3185798,111.099932 76.8878187,112.92614 L92.8260396,163.810856 C93.3981283,165.638487 92.3753228,167.580837 90.5464767,168.150146 Z\" id=\"Fill-22\" fill=\"#404C52\" transform=\"translate(76.208248, 141.063789) rotate(4.000000) translate(-76.208248, -141.063789) \"></path>\r\n                        <path d=\"M104.640176,39.6012942 C96.1591021,12.4990311 67.1572015,-2.62192073 39.8638425,5.82984775 C12.5719105,14.2816156 -2.6753134,43.1045699 5.80576045,70.206833 C14.2882613,97.3090954 43.2887342,112.431466 70.5806662,103.979698 C97.8725982,95.5279299 113.121249,66.7049748 104.640176,39.6012942\" id=\"Fill-23\" fill=\"#404C52\" transform=\"translate(55.222902, 54.904707) rotate(4.000000) translate(-55.222902, -54.904707) \"></path>\r\n                        <path d=\"M100.601231,39.9408606 C92.6916494,14.6696321 65.6502975,0.570037092 40.2020652,8.4509522 C14.7538342,16.328987 0.538049114,43.2062209 8.44473076,68.4788909 C16.3543126,93.7501194 43.3956645,107.849714 68.8424471,99.9688 C94.2892297,92.0878856 108.510812,65.2135293 100.601231,39.9408606\" id=\"Fill-24\" fill=\"#B3D4D4\" transform=\"translate(54.523390, 54.209876) rotate(4.000000) translate(-54.523390, -54.209876) \"></path>\r\n                        <path d=\"M99.2808899,40.8048595 C91.6599318,16.448753 65.5983866,2.86143961 41.0698111,10.4560942 C16.545558,18.0493158 2.84326052,43.9523183 10.4642186,68.3084247 C18.0866173,92.6645305 44.1481618,106.253275 68.6738561,98.6586217 C93.2009917,91.0625367 106.904729,65.1609645 99.2808899,40.8048595\" id=\"Fill-25\" fill=\"#DBECEC\" transform=\"translate(54.873146, 54.557291) rotate(4.000000) translate(-54.873146, -54.557291) \"></path>\r\n                        <path d=\"M26.2654878,90.3567511 C22.2829554,87.1732122 18.8068484,83.3251648 16.0418736,78.9102423 L91.5383367,25.7049445 C94.7895055,29.5502639 97.4391221,33.9751546 99.29978,38.8876404 L26.2654878,90.3567511\" id=\"Fill-26\" fill=\"#F3F9F7\" transform=\"translate(57.670827, 58.030848) rotate(4.000000) translate(-57.670827, -58.030848) \"></path>\r\n                        <path d=\"M13.7894708,72.9880101 C13.0429339,71.3302518 12.3759239,69.6180454 11.817356,67.8399224 C11.5719932,67.0525079 11.3483133,66.2636514 11.1448714,65.4719218 L81.7700524,15.2834824 C84.017101,16.7243297 86.135409,18.362835 88.1105337,20.1732315 L13.7894708,72.9880101\" id=\"Fill-27\" fill=\"#F3F9F7\" transform=\"translate(49.627703, 44.135746) rotate(4.000000) translate(-49.627703, -44.135746) \"></path>\r\n                    </g>\r\n                    <path d=\"M77.1690387,139.225343 L77.1690387,108.068011 L96.4612983,108.068011 L96.4612983,93.4509914 L77.1690387,93.4509914 L77.1690387,10.9417608 L52.6678689,10.9417608 L0,93.4509914 L0,108.068011 L61.1564631,108.068011 L61.1564631,139.225343 L77.1690387,139.225343 Z M61.8808329,93.1516622 L17.2902327,93.1516622 L61.8808329,24.4928435 L61.8808329,93.1516622 Z\" id=\"4\" fill=\"#414141\" fill-rule=\"nonzero\"></path>\r\n                    <path d=\"M286.002777,139.225343 L286.002777,108.068011 L305.295037,108.068011 L305.295037,93.4509914 L286.002777,93.4509914 L286.002777,10.9417608 L261.501608,10.9417608 L208.833739,93.4509914 L208.833739,108.068011 L269.990202,108.068011 L269.990202,139.225343 L286.002777,139.225343 Z M270.714572,93.1516622 L226.123971,93.1516622 L270.714572,24.4928435 L270.714572,93.1516622 Z\" id=\"4-copy-4\" fill=\"#414141\" fill-rule=\"nonzero\"></path>\r\n                </g>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>";
var ok = "<!-- Generator: Adobe Illustrator 25.2.3, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\r\n<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\r\n\t viewBox=\"0 0 96 96\" style=\"enable-background:new 0 0 96 96;\" xml:space=\"preserve\">\r\n<style type=\"text/css\">\r\n\t.st0{fill:#3BA455;}\r\n</style>\r\n<path class=\"st0\" d=\"M48,0C21.49,0,0,21.49,0,48s21.49,48,48,48s48-21.49,48-48S74.51,0,48,0z M48,93.5C22.87,93.5,2.5,73.13,2.5,48\r\n\tS22.87,2.5,48,2.5S93.5,22.87,93.5,48S73.13,93.5,48,93.5z M38.41,61.11L27.48,50.22L25.72,52L38.4,64.63l31.74-31.1l-1.75-1.79\r\n\tL38.41,61.11z\"/>\r\n</svg>\r\n";
var womanInFrontOfComputer = "<svg width=\"217px\" height=\"120px\" viewBox=\"0 0 217 120\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\r\n    <title>woman_in_front_of_computer</title>\r\n    <defs>\r\n        <polygon id=\"path-1\" points=\"0.0290322581 0.0779032258 216.774194 0.0779032258 216.774194 22.7816129 0.0290322581 22.7816129\"></polygon>\r\n    </defs>\r\n    <g id=\"Symbols\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\r\n        <g id=\"0.0_log_in-step_1\" transform=\"translate(-900.000000, -656.000000)\">\r\n            <g id=\"woman_in_front_of_computer\" transform=\"translate(900.000000, 656.000000)\">\r\n                <g id=\"Group-4\" transform=\"translate(0.000000, 92.419355)\">\r\n                    <mask id=\"mask-2\" fill=\"white\">\r\n                        <use xlink:href=\"#path-1\"></use>\r\n                    </mask>\r\n                    <g id=\"Clip-2\"></g>\r\n                    <path d=\"M1.13225806,17.6574194 C1.13225806,17.6574194 21.7746774,0.883548387 21.8879032,0.777580645 C22.3683871,0.342096774 23.0008065,0.0779032258 23.6975806,0.0779032258 L193.100806,0.0779032258 C193.796129,0.0779032258 194.430484,0.342096774 194.909032,0.777580645 C195.024194,0.883548387 215.64629,17.6574194 215.64629,17.6574194 L1.13225806,17.6574194\" id=\"Fill-1\" fill=\"#63B9B4\" mask=\"url(#mask-2)\"></path>\r\n                    <path d=\"M2.85048387,17.0758065 L213.922258,17.0758065 C215.497742,17.0758065 216.774194,18.3537097 216.774194,19.9296774 C216.774194,21.5037097 215.497742,22.7816129 213.922258,22.7816129 L2.85048387,22.7816129 C1.275,22.7816129 0,21.5037097 0,19.9296774 C0,18.3537097 1.275,17.0758065 2.85048387,17.0758065\" id=\"Fill-3\" fill=\"#96CFC8\" mask=\"url(#mask-2)\"></path>\r\n                </g>\r\n                <polyline id=\"Fill-5\" fill=\"#96CFC8\" points=\"127.885645 78.8762903 151.327742 78.8762903 151.381452 95.8112903 121.754516 95.8112903 127.885645 78.8762903\"></polyline>\r\n                <path d=\"M96.3324194,77.8616129 C96.0875806,79.2290323 96.993871,80.3356452 98.3598387,80.3356452 L179.819032,80.3356452 C181.184032,80.3356452 182.488065,79.2290323 182.734355,77.8616129 L192.389032,24.0435484 C192.634355,22.6780645 191.726613,21.5704839 190.361613,21.5704839 L108.901452,21.5704839 C107.536452,21.5704839 106.232419,22.6780645 105.988065,24.0435484 L96.3324194,77.8616129\" id=\"Fill-6\" fill=\"#E4F1F2\"></path>\r\n                <path d=\"M108.587419,24.7335484 C108.190645,24.7335484 107.812742,25.0558065 107.741129,25.4540323 L98.0854839,79.2720968 C98.0143548,79.6703226 98.2766129,79.995 98.673871,79.995 L180.133065,79.995 C180.527903,79.995 180.911129,79.6703226 180.98371,79.2720968 L190.638387,25.4540323 C190.71,25.0558065 190.442903,24.7335484 190.046129,24.7335484 L108.587419,24.7335484 Z M94.5822581,79.2720968 L104.238387,25.4540323 C104.655968,23.1241935 106.887581,21.2308065 109.215,21.2308065 L190.674194,21.2308065 C193.002097,21.2308065 194.559194,23.1241935 194.140645,25.4540323 L184.485968,79.2720968 C184.067419,81.6024194 181.832903,83.4977419 179.505,83.4977419 L98.0453226,83.4977419 C95.7169355,83.4977419 94.1651613,81.6024194 94.5822581,79.2720968 L94.5822581,79.2720968 Z\" id=\"Fill-7\" fill=\"#101B1E\"></path>\r\n                <path d=\"M175.992097,101.28871 C175.992097,101.28871 178.630161,100.776774 176.645323,98.7469355 C174.500323,96.5535484 170.385,92.4483871 162.722903,92.9830645 C155.061774,93.5177419 157.354839,97.05 146.872742,96.5840323 C136.393548,96.1180645 147.304839,104.502097 147.304839,104.502097 L175.992097,101.28871\" id=\"Fill-8\" fill=\"#ED9E8B\"></path>\r\n                <path d=\"M96.9508065,16.7124194 C96.9508065,16.7124194 95.1851613,40.0480645 90.9082258,47.9220968 C75.2583871,48.4335484 77.2291935,34.8532258 76.7908065,31.1845161 C75.063871,16.7351613 96.9508065,16.7124194 96.9508065,16.7124194\" id=\"Fill-9\" fill=\"#ED9E8B\"></path>\r\n                <path d=\"M95.8916129,26.7053226 C95.5393548,30.4625806 98.2417742,31.5358065 98.2340489,33.2569355 C98.2296774,34.1608065 94.0964516,34.7235484 94.0964516,34.7235484 C94.0964516,34.7235484 96.1519355,23.9274194 95.8916129,26.7053226\" id=\"Fill-10\" fill=\"#ED9E8B\"></path>\r\n                <g id=\"Group-14\" transform=\"translate(36.774194, 0.000000)\">\r\n                    <polyline id=\"Fill-11\" fill=\"#ED9E8B\" points=\"27.0270968 49.8614516 29.3283871 41.6235484 49.3166129 43.2822581 48.3125806 54.896129 26.283871 55.2430645 27.0270968 49.8614516\"></polyline>\r\n                    <path d=\"M43.6112903,0.0237096774 C29.0743548,0.0237096774 31.0258065,12.7282258 25.4612903,16.2667742 C22.3940323,18.2182258 19.3359677,16.0751613 16.3316129,19.8532258 C13.3277419,23.6298387 16.7133871,27.5240323 12.7766129,31.826129 C8.84032258,36.1287097 2.83451613,33.6401613 0.999677419,37.9746774 C-1.28322581,43.3698387 2.86016129,46.1240323 5.24709677,46.1240323 C7.44145161,46.1240323 41.4648387,46.1240323 48.1693548,46.1240323 C50.4227419,46.1240323 50.516129,44.2925806 50.516129,44.2925806 C50.516129,39.806129 46.893871,37.4095161 46.893871,29.9264516 C46.893871,22.4429032 52.6766129,20.7377419 54.6425806,20.7377419 C56.61,20.7377419 61.0175806,20.7377419 61.0175806,20.7377419 C61.0175806,20.7377419 61.755,20.6651613 61.755,19.7104839 C61.755,-1.48887097 43.6112903,0.0237096774 43.6112903,0.0237096774\" id=\"Fill-13\" fill=\"#101B1E\"></path>\r\n                </g>\r\n                <path d=\"M94.736129,26.5504839 C94.5662903,27.1582258 94.1622581,27.5472581 93.8327419,27.4151613 C93.5090323,27.281129 93.3803226,26.6820968 93.5501613,26.0670968 C93.7214516,25.4617742 94.1264516,25.0698387 94.4540323,25.2004839 C94.7787097,25.335 94.9045161,25.9345161 94.736129,26.5504839\" id=\"Fill-15\" fill=\"#101B1E\"></path>\r\n                <path d=\"M30.798871,111.577258 C30.1059677,74.4532258 54.6377419,53.4430645 63.3406452,50.8625806 C76.3804839,51.6048387 85.8435484,56.3874194 87.9266129,57.6295161 C103.549355,65.4880645 108.389032,80.6932258 120.762097,92.0559677 C123.525,94.593871 130.946129,104.667581 124.405161,109.261452 C117.865161,113.854355 109.515,109.494677 102.446613,101.887258 C103.246452,105.664355 103.61129,107.682097 104.28629,111.577258 L30.798871,111.577258\" id=\"Fill-16\" fill=\"#227D81\"></path>\r\n                <path d=\"M49.2953226,120 L107.506935,120 C106.831935,116.105323 103.482581,104.753226 102.446613,101.887258 C102.446613,101.887258 93.6735484,91.8072581 86.3612903,81.686129 C79.0485484,71.5640323 76.7912903,120 49.2953226,120\" id=\"Fill-17\" fill=\"#19676B\"></path>\r\n                <path d=\"M62.1541935,51.2506452 L62.7919355,49.826129 C62.7919355,49.826129 63.5124194,47.9293548 64.2740323,48.1664516 C65.2616129,48.4756452 68.2466129,51.2496774 84.5467742,52.8493548 C85.5551613,52.9093548 85.7917742,53.3825806 85.9698387,53.7387097 C86.1469355,54.0943548 86.9820968,57.1045161 86.9820968,57.1045161 C86.9820968,57.1045161 68.9051613,56.9114516 62.1541935,51.2506452\" id=\"Fill-18\" fill=\"#96CFC8\"></path>\r\n                <path d=\"M120.762097,92.0559677 C120.762097,92.0559677 150.573387,94.8174194 152.926935,95.0303226 C155.281452,95.2432258 159.06629,99.4751613 156.805161,103.608871 C154.385806,106.44 120.762097,110.889677 120.762097,110.889677\" id=\"Fill-19\" fill=\"#227D81\"></path>\r\n                <path d=\"M101.07,119.988871 L72.6962903,67.4356452 C72.6962903,67.4356452 69.6532258,60.7770968 61.2827419,60.7770968 C52.9117742,60.7770968 37.6737097,60.765 37.6737097,60.765 C37.6737097,60.765 31.3533871,60.0227419 30.2753226,68.7667742 C29.1479032,77.8998387 23.2379032,120 23.2379032,120 L100.090161,120 L101.07,119.988871\" id=\"Fill-20\" fill=\"#A6784B\"></path>\r\n                <polyline id=\"Fill-21\" fill=\"#B3D4D4\" points=\"174.972097 39.8782258 117.025645 39.8782258 117.502742 37.1579032 175.449194 37.1579032 174.972097 39.8782258\"></polyline>\r\n                <polyline id=\"Fill-22\" fill=\"#B3D4D4\" points=\"173.881452 46.0954839 115.934516 46.0954839 116.412097 43.3751613 174.358548 43.3751613 173.881452 46.0954839\"></polyline>\r\n                <polyline id=\"Fill-23\" fill=\"#B3D4D4\" points=\"172.790806 52.3132258 114.843387 52.3132258 115.320968 49.5929032 173.267419 49.5929032 172.790806 52.3132258\"></polyline>\r\n                <polyline id=\"Fill-24\" fill=\"#B3D4D4\" points=\"128.579516 58.5304839 113.752742 58.5304839 114.229839 55.8101613 129.056613 55.8101613 128.579516 58.5304839\"></polyline>\r\n                <polyline id=\"Fill-25\" fill=\"#B3D4D4\" points=\"116.950161 55.8101613 115.381935 64.7477419 112.661613 64.7477419 114.229839 55.8101613 116.950161 55.8101613\"></polyline>\r\n                <polyline id=\"Fill-26\" fill=\"#B3D4D4\" points=\"129.056613 55.8101613 127.488387 64.7477419 124.768065 64.7477419 126.33629 55.8101613 129.056613 55.8101613\"></polyline>\r\n                <polyline id=\"Fill-27\" fill=\"#B3D4D4\" points=\"127.488387 64.7477419 112.661613 64.7477419 113.139194 62.0274194 127.965484 62.0274194 127.488387 64.7477419\"></polyline>\r\n                <polyline id=\"Fill-28\" fill=\"#B68C5A\" points=\"170.613387 64.7477419 131.656452 64.7477419 133.224677 55.8101613 172.181613 55.8101613 170.613387 64.7477419\"></polyline>\r\n                <polyline id=\"Fill-29\" fill=\"#E4F1F2\" points=\"166.515484 61.6393548 136.844516 61.6393548 137.321613 58.9190323 166.994032 58.9190323 166.515484 61.6393548\"></polyline>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>";
var womanLookingAtThePhone = "<svg width=\"204px\" height=\"121px\" viewBox=\"0 0 204 121\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\r\n    <title>illu@3x</title>\r\n    <defs>\r\n        <polygon id=\"path-1\" points=\"0.0288263555 0.400686342 171.908854 0.400686342 171.908854 15.1275909 0.0288263555 15.1275909\"></polygon>\r\n        <polygon id=\"path-3\" points=\"0.0840768703 -0.000480439259 81.8716128 -0.000480439259 81.8716128 119.143651 0.0840768703 119.143651\"></polygon>\r\n        <polygon id=\"path-5\" points=\"0.471106028 0.238997808 23.0481126 0.238997808 23.0481126 77.8311599 0.471106028 77.8311599\"></polygon>\r\n        <path d=\"M23.0481126,0.0254632807 L22.6834592,26.4193548 C22.6834592,26.4193548 17.4798216,48.8174331 7.84941661,45.8516815 C-1.78098833,42.8854496 0.779752917,33.9905971 0.779752917,33.9905971 L0.779752917,33.9905971 L8.45765271,0.0254632807\" id=\"path-7\"></path>\r\n    </defs>\r\n    <g id=\"Symbols\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\r\n        <g id=\"registration-part\" transform=\"translate(-186.000000, -743.000000)\">\r\n            <g id=\"illu\" transform=\"translate(186.000000, 743.000000)\">\r\n                <g id=\"Group-4\" transform=\"translate(0.000000, 89.361702)\">\r\n                    <mask id=\"mask-2\" fill=\"white\">\r\n                        <use xlink:href=\"#path-1\"></use>\r\n                    </mask>\r\n                    <g id=\"Clip-2\"></g>\r\n                    <path d=\"M171.174743,11.8019904 C171.174743,11.8019904 157.785381,0.922923816 157.708991,0.854221002 C157.400549,0.572203157 156.989774,0.400686342 156.53768,0.400686342 L15.3553191,0.400686342 C14.9041867,0.400686342 14.4924502,0.572203157 14.1830474,0.854221002 C14.1090597,0.922923816 0.731708991,11.8019904 0.731708991,11.8019904 L171.174743,11.8019904\" id=\"Fill-1\" fill=\"#63B9B4\" mask=\"url(#mask-2)\"></path>\r\n                    <path d=\"M170.059163,11.425326 L1.8516129,11.425326 C0.828277282,11.425326 0,12.2531229 0,13.2769389 C0,14.2978723 0.828277282,15.1275909 1.8516129,15.1275909 L170.059163,15.1275909 C171.082018,15.1275909 171.908854,14.2978723 171.908854,13.2769389 C171.908854,12.2531229 171.082018,11.425326 170.059163,11.425326\" id=\"Fill-3\" fill=\"#96CFC8\" mask=\"url(#mask-2)\"></path>\r\n                </g>\r\n                <polyline id=\"Fill-5\" fill=\"#49545B\" points=\"73.6210707 79.9844887 97.6391901 79.9844887 100.753397 97.1073439 70.3987646 97.1073439 73.6210707 79.9844887\"></polyline>\r\n                <path d=\"M101.610021,93.8855182 L69.145779,93.8855182 C68.2560055,93.8855182 67.5348662,94.6061771 67.5348662,95.4969115 C67.5348662,96.3847632 68.2560055,97.1073439 69.145779,97.1073439 L101.610021,97.1073439 C102.499314,97.1073439 103.219492,96.3847632 103.219492,95.4969115 C103.219492,94.6061771 102.499314,93.8855182 101.610021,93.8855182\" id=\"Fill-6\" fill=\"#56636C\"></path>\r\n                <path d=\"M41.360045,79.2878518 C41.3562114,80.6700755 42.4693892,81.7890185 43.850652,81.7890185 L126.216198,81.7890185 C127.596019,81.7890185 128.717845,80.6700755 128.72313,79.2878518 L128.889377,24.8704187 C128.894166,23.4901167 127.779067,22.3697323 126.398765,22.3697323 L44.0322581,22.3697323 C42.6514756,22.3697323 41.5310913,23.4901167 41.5272478,24.8704187 L41.360045,79.2878518\" id=\"Fill-7\" fill=\"#B3D4D4\"></path>\r\n                <path d=\"M44.2787234,25.5680165 C43.8780371,25.5680165 43.5532601,25.8942347 43.5518188,26.2968428 L43.3846211,80.7128346 C43.3831846,81.1164036 43.7055594,81.4445436 44.107687,81.4445436 L126.472752,81.4445436 C126.872958,81.4445436 127.202059,81.1164036 127.203981,80.7128346 L127.372135,26.2968428 C127.372135,25.8942347 127.045436,25.5680165 126.644269,25.5680165 L44.2787234,25.5680165 Z M39.8413734,80.7128346 L40.0100206,26.2968428 C40.0167467,23.9412491 41.9356211,22.0266987 44.2897735,22.0266987 L126.654839,22.0266987 C129.00803,22.0266987 130.920178,23.9412491 130.912992,26.2968428 L130.745779,80.7128346 C130.737612,83.0693892 128.816335,84.9863418 126.462663,84.9863418 L44.0961565,84.9863418 C41.7424846,84.9863418 39.8356211,83.0693892 39.8413734,80.7128346 L39.8413734,80.7128346 Z\" id=\"Fill-8\" fill=\"#56636C\"></path>\r\n                <polyline id=\"Fill-9\" fill=\"#DAEDEC\" points=\"114.271517 40.8824983 55.6805079 40.8824983 55.6781057 38.1310226 114.269115 38.1310226 114.271517 40.8824983\"></polyline>\r\n                <polyline id=\"Fill-10\" fill=\"#DAEDEC\" points=\"114.277282 47.1680851 55.6853123 47.1680851 55.6833905 44.4170899 114.27488 44.4170899 114.277282 47.1680851\"></polyline>\r\n                <polyline id=\"Fill-11\" fill=\"#DAEDEC\" points=\"114.282567 53.4551132 55.6905971 53.4551132 55.6886754 50.7036376 114.279204 50.7036376 114.282567 53.4551132\"></polyline>\r\n                <polyline id=\"Fill-12\" fill=\"#DAEDEC\" points=\"70.6884695 59.7411805 55.6968428 59.7411805 55.6944406 56.9906658 70.6855868 56.9906658 70.6884695 59.7411805\"></polyline>\r\n                <polyline id=\"Fill-13\" fill=\"#DAEDEC\" points=\"58.4444749 56.9906658 58.4526424 66.0272478 55.7016472 66.0272478 55.6944406 56.9906658 58.4444749 56.9906658\"></polyline>\r\n                <polyline id=\"Fill-14\" fill=\"#DAEDEC\" points=\"70.6855868 56.9906658 70.6932739 66.0272478 67.9422787 66.0272478 67.9350721 56.9906658 70.6855868 56.9906658\"></polyline>\r\n                <polyline id=\"Fill-15\" fill=\"#DAEDEC\" points=\"70.6932739 66.0272478 55.7016472 66.0272478 55.699245 63.2772135 70.6913521 63.2772135 70.6932739 66.0272478\"></polyline>\r\n                <polyline id=\"Fill-16\" fill=\"#63B9B4\" points=\"118.537817 66.0272478 74.9081675 66.0272478 74.9004804 56.9906658 118.528689 56.9906658 118.537817 66.0272478\"></polyline>\r\n                <path d=\"M108.568222,48.9557996 C108.568222,48.9557996 111.138092,48.3821551 111.377351,50.3697323 C111.615649,52.35779 109.288401,53.5175704 109.288401,53.5175704 L108.568222,48.9557996\" id=\"Fill-21\" fill=\"#DAEDEC\"></path>\r\n                <path d=\"M109.448868,52.6518188 C109.448868,52.6518188 111.921208,51.2292382 112.474194,55.4820865 C113.026699,59.7349348 110.889224,62.3970487 110.889224,62.3970487 L109.448868,52.6518188\" id=\"Fill-22\" fill=\"#DAEDEC\"></path>\r\n                <path d=\"M165.863006,51.3142759 L162.923198,39.5814688 L153.389842,17.1166095 L137.793342,13.4772821 C137.793342,13.4772821 130.961977,34.3321894 138.460192,43.8525738 C139.490734,45.1199725 144.978792,44.3065889 144.978792,44.3065889 C144.978792,44.3065889 145.400618,49.0389156 145.781606,55.3398765 C146.029032,59.4509952 165.103432,58.9561428 165.863006,51.3142759\" id=\"Fill-23\" fill=\"#ED9E8B\"></path>\r\n                <g id=\"Group-27\" transform=\"translate(121.551132, 0.000000)\">\r\n                    <mask id=\"mask-4\" fill=\"white\">\r\n                        <use xlink:href=\"#path-3\"></use>\r\n                    </mask>\r\n                    <g id=\"Clip-25\"></g>\r\n                    <path d=\"M0.0840768703,119.143651 C6.09341112,104.422512 0.958476321,73.5480439 12.4702814,61.9166095 C15.226081,59.132464 22.1780371,54.4145504 24.1829101,54.5346603 C27.1304049,54.710501 34.4129032,56.4689087 43.9193548,50.0367879 C50.7809883,52.0704873 75.6946465,86.7159231 75.6946465,119.143651 L0.0840768703,119.143651\" id=\"Fill-24\" fill=\"#77648D\" mask=\"url(#mask-4)\"></path>\r\n                    <path d=\"M23.9763212,31.2809197 C24.4308167,29.8357584 25.6280714,25.476733 23.8879204,24.5052848 C22.2621139,23.5953329 22.2400137,25.7068634 20.9308167,25.7207962 C17.8603294,25.7520247 21.6029513,20.6651338 14.7888813,19.7056966 C9.22299245,11.741455 17.7911462,4.30809883 23.345024,1.92704187 C28.8998627,-0.453054221 41.2678106,-2.39883322 48.5181194,7.44824983 C58.2234729,20.6271791 50.6181194,33.2002745 57.135278,35.4689087 C63.652917,37.7385038 74.7111874,40.7004118 80.1055594,55.2673301 C85.5018531,69.8356898 78.0776253,93.847083 64.0166095,92.8890872 C41.0179822,91.3218943 56.8008922,55.9730954 38.1142073,53.3330817 C26.5144818,51.6933425 23.8221002,31.7474262 23.8221002,31.7474262 C23.8221002,31.7474262 23.8840769,31.5744681 23.9763212,31.2809197\" id=\"Fill-26\" fill=\"#101B1E\" mask=\"url(#mask-4)\"></path>\r\n                </g>\r\n                <path d=\"M124.584146,94.2160604 L121.635209,119.143651 L149.415649,119.143651 C149.415649,119.143651 144.205765,77.3973233 124.584146,94.2160604\" id=\"Fill-28\" fill=\"#6B5B7F\"></path>\r\n                <path d=\"M109.663143,74.512766 C109.663143,74.512766 110.522169,69.6891558 112.177282,67.8082361 C113.832876,65.9277968 117.266575,55.8837337 117.266575,55.8837337 L103.449623,55.8837337 L102.160604,74.9134523 L109.663143,74.512766\" id=\"Fill-29\" fill=\"#ED9E8B\"></path>\r\n                <path d=\"M116.629993,40.2391901 C116.629993,40.2391901 118.563281,38.5811942 119.649554,43.9462594 C120.736307,49.3122855 120.495127,49.6543583 120.132395,50.5806452 C119.770144,51.5074125 117.957927,53.5560055 117.957927,53.5560055 L116.629993,40.433768\" id=\"Fill-30\" fill=\"#ED9E8B\"></path>\r\n                <path d=\"M119.884969,55.3610158 C120.065614,56.288744 119.569321,57.1573782 118.773713,57.3043926 L106.797804,59.4951956 C106.002677,59.6407687 105.210913,59.0080302 105.028826,58.080302 L100.379135,34.3321894 C100.19801,33.4049417 100.694303,32.5353466 101.48943,32.3897735 L113.46534,30.1965683 C114.260467,30.0514756 115.052711,30.6856555 115.234798,31.6119423 L119.884969,55.3610158\" id=\"Fill-31\" fill=\"#0C2935\"></path>\r\n                <polyline id=\"Fill-32\" fill=\"#96CFC8\" points=\"118.534454 54.0763212 105.801373 56.4069321 101.356349 33.710501 114.089911 31.3803706 118.534454 54.0763212\"></polyline>\r\n                <path d=\"M113.261633,56.6687714 C113.162663,56.161908 112.731229,55.8159918 112.29547,55.8947838 C111.860673,55.9750172 111.588744,56.4496911 111.687714,56.9575154 C111.787165,57.463418 112.220522,57.8098147 112.655319,57.7305422 C113.089636,57.6512697 113.361084,57.174674 113.261633,56.6687714\" id=\"Fill-33\" fill=\"#DEEBEB\"></path>\r\n                <polyline id=\"Fill-34\" fill=\"#3A6080\" points=\"114.23164 38.1699382 104.12512 39.9975292 103.30453 35.8989019 113.412011 34.0713109 114.23164 38.1699382\"></polyline>\r\n                <polyline id=\"Fill-35\" fill=\"#B68C5A\" points=\"115.333288 43.681057 105.225806 45.5086479 104.405216 41.4100206 114.511736 39.5819492 115.333288 43.681057\"></polyline>\r\n                <polyline id=\"Fill-36\" fill=\"#3A6080\" points=\"116.432533 49.1912148 106.325532 51.0197666 105.505903 46.9201784 115.611462 45.0935484 116.432533 49.1912148\"></polyline>\r\n                <g id=\"Group-40\" transform=\"translate(88.881263, 41.317776)\">\r\n                    <mask id=\"mask-6\" fill=\"white\">\r\n                        <use xlink:href=\"#path-5\"></use>\r\n                    </mask>\r\n                    <g id=\"Clip-38\"></g>\r\n                    <path d=\"M9.254221,34.094372 L11.1346603,25.836582 C11.1346603,25.836582 10.8891558,22.1693892 10.1944406,18.1980782 C9.49924502,14.2272478 9.66307481,11.9461222 10.1944406,8.18140014 C10.7258065,4.41667811 11.0400137,0.365133837 12.1315717,0.325737817 C12.1315717,0.325737817 13.5873027,-0.626012354 14.2416609,3.77577213 C14.8950583,8.17755662 15.4677419,12.6744681 15.4677419,12.6744681 C15.4677419,12.6744681 18.7640357,17.4159231 18.9144132,20.11407 C19.0652711,22.8117364 17.8387097,33.0311599 17.8387097,33.0311599 L9.254221,34.094372\" id=\"Fill-37\" fill=\"#ED9E8B\" mask=\"url(#mask-6)\"></path>\r\n                    <path d=\"M8.45765271,31.7344544 L0.779752917,65.6995882 C0.779752917,65.6995882 -1.78098833,74.5944406 7.84941661,77.5606726 C17.4798216,80.5264242 22.6834592,58.1283459 22.6834592,58.1283459 L23.0481126,31.7344544 L8.45765271,31.7344544\" id=\"Fill-39\" fill=\"#77648D\" mask=\"url(#mask-6)\"></path>\r\n                </g>\r\n                <g id=\"Group-43\" transform=\"translate(88.881263, 73.026767)\">\r\n                    <mask id=\"mask-8\" fill=\"white\">\r\n                        <use xlink:href=\"#path-7\"></use>\r\n                    </mask>\r\n                    <g id=\"Clip-42\"></g>\r\n                    <polyline id=\"Fill-41\" fill=\"#6B5B7F\" mask=\"url(#mask-8)\" points=\"21.4136582 -2.46369252 16.6246397 24.7863418 26.9886754 16.9537406 26.4520247 -3.9919698 21.4136582 -2.46369252\"></polyline>\r\n                </g>\r\n                <path d=\"M102.803432,93.6568291 L135.213384,60.8125601 L146.101098,86.0413864 C146.101098,86.0413864 109.783253,117.837337 98.4852437,119.148456 C100.628964,102.076527 102.803432,93.6568291 102.803432,93.6568291\" id=\"Fill-44\" fill=\"#77648D\"></path>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>";
var womanWithBinoculars = "<svg width=\"262px\" height=\"200px\" viewBox=\"0 0 262 200\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"\n     xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n  <title>woman_with_binoculars-empty_state@3x</title>\n  <defs>\n    <polygon id=\"path-1\" points=\"0 0 185 0 185 191 0 191\"></polygon>\n  </defs>\n  <g id=\"2---MY-POLICIES\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n    <g id=\"[AT]-2.5_my_policy-list_error\" transform=\"translate(-583.000000, -505.000000)\">\n      <g id=\"woman_with_binoculars-empty_state\" transform=\"translate(583.000000, 505.000000)\">\n        <g id=\"Group-3\">\n          <mask id=\"mask-2\" fill=\"white\">\n            <use xlink:href=\"#path-1\"></use>\n          </mask>\n          <g id=\"Clip-2\"></g>\n          <path\n            d=\"M35.0314471,191 C-10.323269,163.589091 -4.51967191,138.145557 12.5543782,126.100025 C29.6292263,114.054493 35.0314471,117.492154 43.8617242,107.865896 C52.6920013,98.2396383 43.4092782,86.8953568 53.0423078,71.9383033 C66.2869254,51.1767671 77.6738813,58.5144789 87.258235,47.5284887 C96.8425887,36.5433056 101.832262,0.82390891 138.270521,0.0121044404 C174.70878,-0.79970003 184.743185,39.0118045 184.743185,39.0118045 C184.743185,39.0118045 189.562094,124.365863 157.451198,151.560505 C125.341099,178.755955 120.925163,189.186755 35.0314471,191\"\n            id=\"Fill-1\" fill=\"#101B1E\" mask=\"url(#mask-2)\"></path>\n        </g>\n        <path\n          d=\"M183,135.881655 L166.844676,128.492408 L166.844676,98 L116.384775,98 L116.41016,128.843893 L101,136.103646 C101.681293,153.394822 134.391546,155.61232 141.013681,155.949328 L141.013681,156 C141.013681,156 141.23723,155.993565 141.615544,155.978283 C141.99304,155.993565 142.216589,156 142.216589,156 L142.216589,155.949328 C148.837905,155.61232 182.317888,153.172831 183,135.881655\"\n          id=\"Fill-4\" fill=\"#ED9E8B\"></path>\n        <path\n          d=\"M151,98 L116.156258,98 L116.181265,128.798956 L101,136.048131 C101.419483,146.83917 104.153386,151.751198 115.246301,154 L144.381036,98\"\n          id=\"Fill-5\" fill=\"#DD8677\"></path>\n        <path\n          d=\"M181,64.6106129 C181,36.6585077 163.468558,14 141.842841,14 C129.314089,14 118.167985,21.6141006 111,33.448991 C111.962086,33.4279397 112.982651,33.4157947 114.107355,33.4157947 C114.107355,33.4157947 116.304693,31.5632785 116.304693,67.6071873 C116.304693,105.128737 135.814781,115.287618 145.12483,118 C165.213291,115.566953 181,91.1320379 181,64.6106129\"\n          id=\"Fill-6\" fill=\"#ED9E8B\"></path>\n        <path\n          d=\"M114.798992,68.2821576 C114.798992,32.1595703 112.572615,34.0161303 112.572615,34.0161303 C111.433048,34.0161303 110.398996,34.0283018 109.424195,34.0493991 C104.152478,42.6595204 101,53.495404 101,65.279042 C101,93.2913509 118.763128,119 140.674639,119 C141.795538,119 142.902639,118.915611 144,118.78497 C134.566915,116.066668 114.798992,105.885611 114.798992,68.2821576\"\n          id=\"Fill-7\" fill=\"#DD8677\"></path>\n        <path\n          d=\"M113,20.6512922 C113,20.6512922 129.70425,44.136483 162.54727,43.9994022 C181.981367,43.91858 174.640443,24.684479 174.640443,24.684479 C174.640443,24.684479 153.283875,3.69447576 135.014841,8.80053769 C116.745806,13.9065996 113,20.6512922 113,20.6512922\"\n          id=\"Fill-8\" fill=\"#101B1E\"></path>\n        <path\n          d=\"M125,25.8262281 C125,25.8262281 119.803149,40.3127675 106.843754,45.5320074 C93.8835803,50.7504792 97.4492063,40.3788144 97.4492063,40.3788144 C97.4492063,40.3788144 110.999365,20.795913 125,25.8262281\"\n          id=\"Fill-9\" fill=\"#101B1E\"></path>\n        <path\n          d=\"M194,71.8262281 C194,71.8262281 188.803155,86.3135355 175.842997,91.5320074 C162.883619,96.7504792 166.449241,86.3788144 166.449241,86.3788144 C166.449241,86.3788144 179.999382,66.795913 194,71.8262281\"\n          id=\"Fill-10\" fill=\"#101B1E\"></path>\n        <path\n          d=\"M58.379951,157.615255 L102.420641,138 C102.420641,138 112.88332,154.724389 143.298571,154.724389 C173.713016,154.724389 181.499326,138 181.499326,138 L222.134463,155.431097 L227,191 L54,191 L58.379951,157.615255\"\n          id=\"Fill-11\" fill=\"#B68C5A\"></path>\n        <path\n          d=\"M112.532031,147.196579 C105.048154,142.757201 102.034835,138 102.034018,138 L57.4354349,157.615255 L53,191 L115.112425,191 L135,154.280061 C125.043551,153.194619 117.71569,150.271736 112.532031,147.196579\"\n          id=\"Fill-12\" fill=\"#A6784B\"></path>\n        <path\n          d=\"M52,143.480868 L73.7297847,107.945372 C73.7297847,107.945372 70.0563311,77.5724625 70.975305,71.4978806 C71.8934649,65.4241065 74.751319,52.3637554 78.6266376,47.8078189 C78.6266376,47.8078189 89.95061,37.1773006 96.6829687,34.4437388 C103.416141,31.7101769 110.456181,33.5325515 111.374341,34.4437388 C112.292501,35.354926 111.986448,39.9100547 108.007755,40.2145916 C104.029062,40.5183207 85.971917,47.5040898 87.1961302,58.4375295 C88.4203434,69.3717769 100.356422,86.9880644 100.356422,86.9880644 C100.356422,86.9880644 108.619862,81.5209407 109.538022,81.5209407 C110.456181,81.5209407 126.0649,69.0688556 130.043593,73.9277133 C134.022286,80.6097534 124.53382,81.596873 120.861994,88.2409469 C117.189354,94.8850209 109.843261,107.943756 94.5414096,116.752708 C88.7263967,134.065266 82.164158,156 82.164158,156 L52,143.480868\"\n          id=\"Fill-13\" fill=\"#ED9E8B\"></path>\n        <path\n          d=\"M147,48.4991652 C147,44.9102235 144.089777,42 140.5,42 C136.910223,42 134,44.9102235 134,48.4991652 C134,52.0897765 136.910223,55 140.5,55 C144.089777,55 147,52.0897765 147,48.4991652\"\n          id=\"Fill-14\" fill=\"#245B60\"></path>\n        <path\n          d=\"M227,143.480868 L205.270821,107.945372 C205.270821,107.945372 208.943496,77.5724625 208.025327,71.4978806 C207.107159,65.4241065 204.248463,52.3637554 200.373921,47.8078189 C200.373921,47.8078189 189.049841,37.1773006 182.316603,34.4437388 C175.583366,31.7101769 168.543259,33.5325515 167.62509,34.4437388 C166.707735,35.354926 167.012977,39.9100547 170.991708,40.2145916 C174.97044,40.5183207 193.027758,47.5040898 191.803533,58.4375295 C190.579308,69.3717769 178.643114,86.9880644 178.643114,86.9880644 C178.643114,86.9880644 170.38041,81.5209407 169.461427,81.5209407 C168.543259,81.5209407 152.935204,69.0688556 148.956473,73.9277133 C144.977742,80.6097534 154.465486,81.596873 158.13816,88.2409469 C161.810021,94.8850209 169.155371,107.943756 184.458183,116.752708 C190.273251,134.065266 196.835553,156 196.835553,156 L227,143.480868\"\n          id=\"Fill-15\" fill=\"#ED9E8B\"></path>\n        <path\n          d=\"M137.016378,87.9969778 C137.014587,87.9977913 137.00832,87.9961642 137.005634,87.9961642 C136.395917,87.9457241 135.94915,87.4567801 136.00466,86.9043792 L138.795389,58.9223035 C138.8509,58.3707162 139.29319,57.9069923 139.996916,58.0160081 C140.603947,58.0640076 141.051609,58.5529515 140.995204,59.1053525 L138.203579,87.0874281 C138.148964,87.6325071 137.618932,88.0392824 137.016378,87.9969778\"\n          id=\"Fill-16\" fill=\"#DD8677\"></path>\n        <path\n          d=\"M85.8357922,111.681582 C87.6620703,105.308728 73.6603406,100.51992 73.2853935,71.250909 C73.1996006,64.4738945 73.4085223,58 73.4085223,58 C72.002471,62.8841439 71.1874378,68.1545215 70.5185704,71.3690607 C68.02978,83.3162276 73.20675,108.134589 73.20675,108.134589 L52,143.980163 L60.0939308,147.451377 L67.5809557,151 C67.5809557,151 84.0103086,118.054436 85.8357922,111.681582\"\n          id=\"Fill-17\" fill=\"#DD8677\"></path>\n        <path\n          d=\"M147.506583,97.8254487 C145.225171,99.0291621 142.245721,99.5868538 138.634339,98.1250781 C138.133042,97.9207066 137.874918,97.3084581 138.059854,96.7533644 C138.245578,96.2008686 138.804323,95.9202908 139.307194,96.1203324 C146.90298,99.1954304 151.025103,91.8328612 151.195875,91.5193761 C151.470526,91.0136433 152.067832,90.849107 152.528207,91.1513343 C152.989368,91.4535616 153.138104,92.111707 152.859519,92.6165739 C152.828827,92.6719967 150.970803,95.9956312 147.506583,97.8254487\"\n          id=\"Fill-18\" fill=\"#DD8677\"></path>\n        <path\n          d=\"M129,60.0004133 C129,47.2974464 118.702739,37 106,37 C93.298088,37 83,47.2974464 83,60.0004133 C83,72.7025536 93.298088,83 106,83 C118.702739,83 129,72.7025536 129,60.0004133\"\n          id=\"Fill-19\" fill=\"#227D81\"></path>\n        <path\n          d=\"M193.029696,58 L180.101771,86.6785729 C180.101771,86.6785729 171.985036,81.1869313 171.082288,81.1869313 C170.18034,81.1869313 154.848019,68.6790035 150.939576,73.5596513 C147.031134,80.2716577 156.351266,81.2632041 159.959059,87.9370741 C163.566052,94.6109441 170.781639,107.728243 185.81411,116.576699 C191.526449,133.966898 197.97282,156 197.97282,156 L206,152.592878 C206,152.592878 206,152.592878 191.971026,114.429701 C179.227808,79.7629019 202.364221,62.2144779 193.029696,58\"\n          id=\"Fill-20\" fill=\"#DD8677\"></path>\n        <path\n          d=\"M127.330649,59 L119,53.6241489 C126.111007,43.6356395 139.434381,43.985368 140,44.0057961 L139.660114,53.5816585 C139.58115,53.5808414 131.280541,53.4525531 127.330649,59\"\n          id=\"Fill-21\" fill=\"#227D81\"></path>\n        <path\n          d=\"M150,60.0004133 C150,47.2974464 160.298088,37 173,37 C185.702739,37 196,47.2974464 196,60.0004133 C196,72.7025536 185.702739,83 173,83 C160.298088,83 150,72.7025536 150,60.0004133\"\n          id=\"Fill-22\" fill=\"#227D81\"></path>\n        <path\n          d=\"M134,48.4991652 C134,44.9102235 136.910223,42 140.5,42 C144.089777,42 147,44.9102235 147,48.4991652 C147,52.0897765 144.089777,55 140.5,55 C136.910223,55 134,52.0897765 134,48.4991652\"\n          id=\"Fill-23\" fill=\"#227D81\"></path>\n        <path\n          d=\"M150.669351,59 L159,53.6241489 C151.888993,43.6356395 138.565619,43.985368 138,44.0057961 L138.339886,53.5816585 C138.41885,53.5808414 146.719459,53.4525531 150.669351,59\"\n          id=\"Fill-24\" fill=\"#227D81\"></path>\n        <path\n          d=\"M134,48.4991156 C134,46.0147406 136.014054,44 138.499558,44 C140.985061,44 143,46.0147406 143,48.4991156 C143,50.9852594 140.985061,53 138.499558,53 C136.014054,53 134,50.9852594 134,48.4991156\"\n          id=\"Fill-25\" fill=\"#19676B\"></path>\n        <polyline id=\"Fill-26\" fill=\"#B68C5A\"\n                  points=\"227.479471 139 197 155.164404 212.240541 200 262 200 227.479471 139\"></polyline>\n        <polyline id=\"Fill-27\" fill=\"#B68C5A\"\n                  points=\"49.519774 139 80 155.164404 64.759887 200 15 200 49.519774 139\"></polyline>\n        <polyline id=\"Fill-28\" fill=\"#A6784B\" points=\"204.733793 151 197 155.117033 212.201708 200 224 200\"></polyline>\n        <polyline id=\"Fill-29\" fill=\"#A6784B\"\n                  points=\"42.3316738 200 15 200 49.6785325 139 67 148.143632 42.3316738 200\"></polyline>\n        <path\n          d=\"M190,60.7268417 C190,51.4890353 182.389095,44 173,44 C167.21328,44 162.10946,46.85019 159.038749,51.1960395 C162.082175,52.2744483 163.239052,55.1744936 165.332966,55.1744936 C167.904755,55.1744936 167.51887,54.606143 169.619801,54.606143 C173.263493,54.606143 173.949512,58.4549733 173.949512,58.4549733 L156.174623,58.4549733 C156.07172,59.199735 156,59.9537008 156,60.7268417 C156,62.5707213 156.314945,64.3409685 156.875453,66 L189.124547,66 C189.685055,64.3409685 190,62.5707213 190,60.7268417\"\n          id=\"Fill-30\" fill=\"#B3D4D4\"></path>\n        <path\n          d=\"M168.615455,53.7582418 C166.487917,53.7582418 166.87869,54.3846154 164.27433,54.3846154 C162.153897,54.3846154 160.982369,51.1885038 157.900399,50 C156.387044,52.3313609 155.374194,55.0549451 155,58 L173,58 C173,58 172.305294,53.7582418 168.615455,53.7582418\"\n          id=\"Fill-31\" fill=\"#DAEDEC\"></path>\n        <path d=\"M173,79 C180.92221,79 187.631309,73.5490892 190,66 L156,66 C158.368691,73.5490892 165.07779,79 173,79\"\n              id=\"Fill-32\" fill=\"#96CFC8\"></path>\n        <path\n          d=\"M122,60.7268417 C122,51.4890353 114.389095,44 105,44 C95.6109048,44 88,51.4890353 88,60.7268417 C88,62.5707213 88.3149447,64.3409685 88.8754528,66 L121.124547,66 C121.685835,64.3409685 122,62.5707213 122,60.7268417\"\n          id=\"Fill-33\" fill=\"#B3D4D4\"></path>\n        <path d=\"M105,79 C112.92221,79 119.632131,73.5490892 122,66 L88,66 C90.3678689,73.5490892 97.0777896,79 105,79\"\n              id=\"Fill-34\" fill=\"#96CFC8\"></path>\n        <path\n          d=\"M100,58 L119,58 C119,58 117.62844,51.9640864 112.303511,52.0001611 C108.769231,52.0001611 107.946457,55.4298974 106.120142,55.4298974 C104.293016,55.4298974 104.567004,54.9846828 103.075473,54.9846828 C100.487179,54.9846828 100,58 100,58\"\n          id=\"Fill-35\" fill=\"#DAEDEC\"></path>\n      </g>\n    </g>\n  </g>\n</svg>\n";
var womanWithComputerDisplayingChecks = "<svg width=\"280px\" height=\"157px\" viewBox=\"0 0 280 157\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\r\n    <title>woman_with_computer_displaying_checks</title>\r\n    <defs>\r\n        <polygon id=\"path-1\" points=\"0.097590587 0.616742916 279.759683 0.616742916 279.759683 30.0099271 0.097590587 30.0099271\"></polygon>\r\n        <path d=\"M26.4550617,43.8239953 L19.9733869,29.2102249 C19.9733869,29.2102249 17.6929165,31.7758538 15.2743332,31.0474215 C12.8573559,30.3206007 9.95698308,25.1023179 9.95698308,25.1023179 C9.95698308,25.1023179 6.69205621,24.7397133 6.08821336,23.1619805 C5.48276455,21.5842477 4.63642099,17.7035729 4.39552624,16.8526608 C4.15302552,16.0033603 0.0417550903,9.08808805 0.0417550903,9.08808805 C0.0417550903,9.08808805 15.5184399,-4.98419284 21.4412389,2.78037992 C27.3656438,10.5449527 39.8182965,27.7726992 39.8182965,27.7726992 L42.2352739,33.351975 L26.4550617,43.8239953\" id=\"path-3\"></path>\r\n        <polygon id=\"path-5\" points=\"0.164849863 0.000986562608 150.925588 0.000986562608 150.925588 156.242981 0.164849863 156.242981\"></polygon>\r\n    </defs>\r\n    <g id=\"Symbols\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\r\n        <g id=\"6.1_profile\" transform=\"translate(-904.000000, -703.000000)\">\r\n            <g id=\"Group-3\" transform=\"translate(160.000000, 481.000000)\">\r\n                <g id=\"woman_with_computer_displaying_checks\" transform=\"translate(744.000000, 222.000000)\">\r\n                    <g id=\"Group-4\" transform=\"translate(0.000000, 114.826498)\">\r\n                        <mask id=\"mask-2\" fill=\"white\">\r\n                            <use xlink:href=\"#path-1\"></use>\r\n                        </mask>\r\n                        <g id=\"Clip-2\"></g>\r\n                        <path d=\"M278.299077,23.3742302 C278.299077,23.3742302 251.658473,1.66096373 251.510461,1.52390974 C250.892387,0.959377869 250.074253,0.616742916 249.174793,0.616742916 L30.5523598,0.616742916 C29.6528999,0.616742916 28.8347654,0.959377869 28.2199447,1.52390974 C28.0703058,1.66096373 1.45572626,23.3742302 1.45572626,23.3742302 L278.299077,23.3742302\" id=\"Fill-1\" fill=\"#3A6080\" mask=\"url(#mask-2)\"></path>\r\n                        <path d=\"M276.078891,22.6220649 L3.68241815,22.6220649 C1.64765441,22.6220649 0,24.2765022 0,26.3176276 C0,28.3554898 1.64765441,30.0099271 3.68241815,30.0099271 L276.078891,30.0099271 C278.112028,30.0099271 279.759683,28.3554898 279.759683,26.3176276 C279.759683,24.2765022 278.112028,22.6220649 276.078891,22.6220649\" id=\"Fill-3\" fill=\"#31506D\" mask=\"url(#mask-2)\"></path>\r\n                    </g>\r\n                    <polyline id=\"Fill-5\" fill=\"#96CFC8\" points=\"114.155789 105.11041 88.9971214 105.11041 85.6782334 122.776025 117.476341 122.776025 114.155789 105.11041\"></polyline>\r\n                    <path d=\"M145.741325,105.157379 C145.741325,106.595809 144.588897,107.760252 143.16493,107.760252 L58.223083,107.760252 C56.8007318,107.760252 55.6466877,106.595809 55.6466877,105.157379 L55.6466877,48.5318416 C55.6466877,47.0950426 56.8007318,45.9305994 58.223083,45.9305994 L143.16493,45.9305994 C144.588897,45.9305994 145.741325,47.0950426 145.741325,48.5318416 L145.741325,105.157379\" id=\"Fill-6\" fill=\"#E4F0F2\"></path>\r\n                    <path d=\"M57.4355288,46.957942 C57.0200133,46.957942 56.6794535,47.2963732 56.6794535,47.714531 L56.6794535,104.208132 C56.6794535,104.62629 57.0200133,104.966348 57.4355288,104.966348 L143.069203,104.966348 C143.486348,104.966348 143.825278,104.62629 143.825278,104.208132 L143.825278,47.714531 C143.825278,47.2963732 143.486348,46.957942 143.069203,46.957942 L57.4355288,46.957942 Z M143.069203,108.643533 L57.4355288,108.643533 C54.988061,108.643533 52.9968454,106.653623 52.9968454,104.208132 L52.9968454,47.714531 C52.9968454,45.2690403 54.988061,43.2807571 57.4355288,43.2807571 L143.069203,43.2807571 C145.516671,43.2807571 147.507886,45.2690403 147.507886,47.714531 L147.507886,104.208132 C147.507886,106.653623 145.516671,108.643533 143.069203,108.643533 L143.069203,108.643533 Z\" id=\"Fill-7\" fill=\"#000206\"></path>\r\n                    <path d=\"M79.6499603,69.1382554 L79.6419617,83.6625968 L93.4762676,83.6693156 C93.4778673,83.6693156 93.479467,83.6693156 93.479467,83.6693156 L93.4826664,69.1449741 L79.6499603,69.1382554 Z M93.4762676,85.6782334 L79.6499603,85.6782334 C78.5909512,85.6782334 77.7287066,84.7745564 77.7287066,83.6625968 L77.7287066,69.1449741 C77.7287066,68.0330146 78.5909512,67.1293375 79.6499603,67.1293375 L93.4762676,67.1293375 C94.5336769,67.1293375 95.3943218,68.0330146 95.3943218,69.1449741 L95.3943218,83.6625968 C95.3943218,84.7745564 94.5336769,85.6782334 93.4762676,85.6782334 L93.4762676,85.6782334 Z\" id=\"Fill-8\" fill=\"#000206\"></path>\r\n                    <path d=\"M86.7075195,82.1422907 C86.3706524,82.1229296 86.0642638,81.9761078 85.8493105,81.7292535 L80.7273267,75.6821302 C80.2348591,75.1642202 80.2669416,74.3397591 80.8043249,73.8460506 C81.3192503,73.3507286 82.137356,73.3813837 82.6282195,73.9218816 L86.4636919,77.0712906 C86.6818535,77.2971703 87.0395742,77.2794226 87.2465069,77.0374086 L97.5402026,65.8160258 C97.9973793,65.2755278 98.8219016,65.2029236 99.3592849,65.6821114 C99.8982722,66.1387111 99.9688539,66.9712393 99.4940317,67.5101238 L87.7662447,81.6824641 C87.5176047,81.9648138 87.1695087,82.1326102 86.813392,82.1309968 C86.7700806,82.147131 86.7492269,82.147131 86.7075195,82.1422907\" id=\"Fill-9\" fill=\"#3F9B97\"></path>\r\n                    <path d=\"M106.146783,69.1382554 L106.138785,83.6625968 L119.973091,83.6693156 C119.97629,83.6693156 119.97629,83.6693156 119.97629,83.6693156 L119.981089,69.1449741 L106.146783,69.1382554 Z M119.973091,85.6782334 L106.146783,85.6782334 C105.089374,85.6782334 104.227129,84.7745564 104.227129,83.6625968 L104.227129,69.1449741 C104.227129,68.0330146 105.089374,67.1293375 106.146783,67.1293375 L119.973091,67.1293375 C121.0321,67.1293375 121.892744,68.0330146 121.892744,69.1449741 L121.892744,83.6625968 C121.892744,84.7745564 121.0321,85.6782334 119.973091,85.6782334 L119.973091,85.6782334 Z\" id=\"Fill-10\" fill=\"#000206\"></path>\r\n                    <path d=\"M113.206538,82.1422907 C112.869703,82.1229296 112.563343,81.9761078 112.348411,81.7292535 L107.226916,75.6821302 C106.732891,75.1642202 106.764971,74.3397591 107.303907,73.8460506 C107.818783,73.3507286 108.638414,73.3813837 109.127627,73.9218816 L112.962733,77.0712906 C113.180874,77.2971703 113.538561,77.2794226 113.745474,77.0374086 L124.038186,65.8160258 C124.49532,65.2755278 125.319763,65.2029236 125.857095,65.6821114 C126.396031,66.1387111 126.46821,66.9712393 125.991829,67.5101238 L114.265162,81.6824641 C114.016545,81.9648138 113.668483,82.1326102 113.3124,82.1309968 C113.269093,82.147131 113.246637,82.147131 113.206538,82.1422907\" id=\"Fill-11\" fill=\"#3F9B97\"></path>\r\n                    <path d=\"M173.16559,64.4794953 L166.652584,49.8993194 C166.652584,49.8993194 164.36109,52.4590503 161.930816,51.7322926 C159.502155,51.0071427 156.587762,45.8008558 156.587762,45.8008558 C156.587762,45.8008558 153.307053,45.4390848 152.700292,43.8649789 C152.091916,42.290873 151.241482,38.4191192 150.999422,37.5701632 C150.755749,36.7228151 146.624606,29.8234399 146.624606,29.8234399 C146.624606,29.8234399 162.176103,15.7835087 168.127532,23.5302321 C174.080574,31.2769554 186.593421,48.4650983 186.593421,48.4650983 L189.022082,54.0315483 L173.16559,64.4794953\" id=\"Fill-12\" fill=\"#ED9E8B\"></path>\r\n                    <g id=\"Group-15\" transform=\"translate(146.624606, 21.198738)\">\r\n                        <mask id=\"mask-4\" fill=\"white\">\r\n                            <use xlink:href=\"#path-3\"></use>\r\n                        </mask>\r\n                        <g id=\"Clip-14\"></g>\r\n                        <path d=\"M22.7019214,37.5291798 C22.7019214,37.5291798 26.6108403,29.476135 24.0284485,23.8726855 C21.1393175,28.1868742 19.9733869,29.2102249 19.9733869,29.2102249 C18.4429022,33.7774311 22.7019214,37.5291798 22.7019214,37.5291798\" id=\"Fill-13\" fill=\"#DD8677\" mask=\"url(#mask-4)\"></path>\r\n                    </g>\r\n                    <path d=\"M173.07398,72.4290221 L171.356467,65.6185185 C171.356467,65.6185185 177.736034,57.4720836 185.340999,55.6466877 C189.022082,62.3360367 189.022082,62.3360367 189.022082,62.3360367 L173.07398,72.4290221\" id=\"Fill-16\" fill=\"#96CFC8\"></path>\r\n                    <path d=\"M70.373437,127.364494 C70.373437,127.364494 67.7280693,127.093854 69.5166245,124.996397 C71.445267,122.730577 75.1559489,118.48059 82.759752,118.362579 C90.3619262,118.242994 88.4007053,121.797499 98.7020016,120.494653 C109.001669,119.191806 98.9463397,128.07571 98.9463397,128.07571 L70.373437,127.364494\" id=\"Fill-17\" fill=\"#ED9E8B\"></path>\r\n                    <g id=\"Group-22\" transform=\"translate(96.277603, 0.000000)\">\r\n                        <mask id=\"mask-6\" fill=\"white\">\r\n                            <use xlink:href=\"#path-5\"></use>\r\n                        </mask>\r\n                        <g id=\"Clip-19\"></g>\r\n                        <path d=\"M1.33006439,128.143998 C1.33006439,128.143998 -1.37249589,122.258423 1.45409493,119.439405 C4.27905377,116.618758 26.2422519,116.408675 43.7158708,110.366759 C56.1254531,106.075532 63.37308,90.0147831 65.7084446,85.7251853 C68.0405452,81.433959 76.7634828,66.8437894 91.8756254,60.2237382 C106.987768,53.6036869 112.392889,86.0916088 112.392889,86.0916088 C112.392889,86.0916088 65.075236,125.823316 62.7219197,127.600063 C60.3669713,129.375181 57.9304239,130.555879 53.5909869,130.371853 C49.2515498,130.186199 1.33006439,128.143998 1.33006439,128.143998\" id=\"Fill-18\" fill=\"#B68C5A\" mask=\"url(#mask-6)\"></path>\r\n                        <path d=\"M58.3139394,27.1430244 L51.702785,30.6786041 C51.702785,30.6786041 49.8586467,31.6589905 49.2450219,30.1884109 C48.6297651,28.7162027 44.8223538,20.0116088 49.3674205,11.4307847 C53.9124871,2.84833202 64.8467587,-0.33873817 71.2359637,0.0293138801 C77.6235367,0.397365931 87.4529573,2.84833202 90.2779162,14.7399961 C93.104507,26.6332886 89.9107205,31.1687973 109.812727,43.4285134 C129.714733,55.6882295 143.475596,58.6293888 138.80813,83.2725907 C134.137401,107.915793 105.024495,83.5233872 105.024495,83.5233872 C105.024495,83.5233872 93.6675404,81.3981309 89.2660881,64.6810765 C86.3334185,53.5450591 85.522324,46.7637815 82.4509361,45.4153431 C79.3811801,44.0669046 72.2298401,43.5734543 71.3599943,37.5429377 C70.783905,33.5692784 70.4983084,24.180694 64.2331339,26.3873778 C62.1605183,27.3091364 63.4889507,30.8675158 63.0042524,31.9032729 C62.953661,32.0807847 62.1441985,32.7631467 61.0377154,31.0450276 C60.1662377,29.6917035 59.11361,27.9719558 58.7464143,27.2830797 C58.6125919,27.0306546 58.3139394,27.1430244 58.3139394,27.1430244\" id=\"Fill-20\" fill=\"#1C2B2F\" mask=\"url(#mask-6)\"></path>\r\n                        <path d=\"M50.3923044,156.326037 L87.0416982,84.2529771 C87.0416982,84.2529771 90.97314,75.672153 101.783381,75.672153 C112.595254,75.672153 132.280207,75.6558675 132.280207,75.6558675 C132.280207,75.6558675 140.441743,74.6999093 141.835455,85.9694677 C143.292814,97.7422476 150.925588,156.340694 150.925588,156.340694 L51.6587216,156.340694 L50.3923044,156.326037\" id=\"Fill-21\" fill=\"#3F9B97\" mask=\"url(#mask-6)\"></path>\r\n                    </g>\r\n                </g>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>";
var womanWithLaptopTalkingOnThePhone = "<svg width=\"264px\" height=\"146px\" viewBox=\"0 0 264 146\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\r\n    <title>woman_with_laptop_talking_on_the_phone</title>\r\n    <defs>\r\n        <polygon id=\"path-1\" points=\"0.220123613 0 97.629656 0 97.629656 116.016379 0.220123613 116.016379\"></polygon>\r\n        <path d=\"M17.694493,84.8548744 L3.0006416,61.9395473 C3.0006416,61.9395473 -1.37740153,43.4945999 0.765745856,31.2650151 C2.90889325,19.0360185 6.56471217,12.6065764 6.56471217,12.6065764 C6.56471217,12.6065764 16.491178,2.67834611 27.8079843,0.62929959 C34.1527357,-0.519319194 53.4639993,15.5060595 59.1371057,44.2509357 C64.8108002,72.9940474 67.6191232,84.8548744 67.6191232,84.8548744 L17.694493,84.8548744\" id=\"path-3\"></path>\r\n        <polygon id=\"path-5\" points=\"0.0352878275 0.492853324 211.694618 0.492853324 211.694618 22.9370879 0.0352878275 22.9370879\"></polygon>\r\n    </defs>\r\n    <g id=\"2---MY-POLICIES\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\r\n        <g id=\"2.1_my_policy_new-offer/non-editable-data-copy-3\" transform=\"translate(-783.000000, -532.000000)\">\r\n            <g id=\"woman_with_laptop_talking_on_the_phone\" transform=\"translate(783.000000, 532.000000)\">\r\n                <g id=\"Group-4\" transform=\"translate(165.852789, 0.000000)\">\r\n                    <mask id=\"mask-2\" fill=\"white\">\r\n                        <use xlink:href=\"#path-1\"></use>\r\n                    </mask>\r\n                    <g id=\"Clip-2\"></g>\r\n                    <path d=\"M19.8682231,49.9952058 C19.8682231,49.9952058 20.6504366,57.5115131 18.7737124,61.4125824 C16.8946355,65.3118874 15.923044,69.5229014 15.923044,69.5229014 C15.923044,69.5229014 8.14266619,69.0606309 5.02733916,66.9633577 C4.31334878,66.4828551 6.26417751,61.8336838 5.91306363,61.2673142 C3.88989485,56.9345571 0.858082338,51.587275 0.858082338,51.587275 C0.858082338,51.587275 -0.0105863482,48.9847977 0.279361968,47.9738015 C0.568134022,46.9645696 2.48779184,40.6651043 3.16884691,38.4390305 C3.84990198,36.2117804 7.10343967,36.0353413 8.69256817,35.1690251 C10.2828729,34.2997683 10.8257173,33.6704687 10.8257173,33.6704687 L13.8598824,35.1160934 L19.8682231,49.9952058\" id=\"Fill-1\" fill=\"#ED9E8B\" mask=\"url(#mask-2)\"></path>\r\n                    <path d=\"M58.5854393,116.016379 C58.5854393,116.016379 97.5867225,105.325343 97.6297574,83.8527001 C97.7008198,48.1684726 60.2733737,59.0518268 60.2733737,34.6285332 C60.2733737,4.76268045 34.5544288,-2.13020852 21.8766886,0.520495455 C-0.473445019,5.19495634 -5.29964356,49.432365 42.4847799,58.6689538 C79.1217786,65.7512208 58.5854393,116.016379 58.5854393,116.016379\" id=\"Fill-3\" fill=\"#431F18\" mask=\"url(#mask-2)\"></path>\r\n                </g>\r\n                <polyline id=\"Fill-5\" fill=\"#6B5B7F\" points=\"183.210283 66.8033862 170.148494 62.064231 150.757245 121.505988 177.183711 123.841454 193.11146 121.043718 190.233149 88.6124399 176.794368 106.013456 183.210283 66.8033862\"></polyline>\r\n                <path d=\"M201.779326,143.07979 L187.085475,120.164463 C187.085475,120.164463 182.707432,101.719515 184.850579,89.4899305 C186.993727,77.2609339 190.649546,70.8314917 190.649546,70.8314917 C190.649546,70.8314917 200.576011,60.9032615 211.892818,58.8542149 C218.237569,57.7055962 237.548833,73.7309749 243.221939,102.475851 C248.895634,131.218963 251.703957,143.07979 251.703957,143.07979 L201.779326,143.07979\" id=\"Fill-6\" fill=\"#77648D\"></path>\r\n                <g id=\"Group-9\" transform=\"translate(184.084833, 58.224915)\">\r\n                    <mask id=\"mask-4\" fill=\"white\">\r\n                        <use xlink:href=\"#path-3\"></use>\r\n                    </mask>\r\n                    <g id=\"Clip-8\"></g>\r\n                    <path d=\"M27.5309749,31.4273392 L36.2882374,69.5640706 C36.2882374,69.5640706 2.95417929,63.9144894 13.6887364,63.0669934 C24.4232935,62.2194974 18.208519,32.8400285 27.5309749,31.4273392\" id=\"Fill-7\" fill=\"#6B5B7F\" mask=\"url(#mask-4)\"></path>\r\n                </g>\r\n                <path d=\"M169.518018,48.2214044 C169.103974,48.8095348 169.244538,49.6229193 169.832668,50.0369631 L179.429193,56.7939939 C180.016147,57.2074497 180.829531,57.0662983 181.244163,56.4781679 L194.997006,36.9481198 C195.41105,36.3594012 195.268134,35.5454286 194.681768,35.1331492 L185.085831,28.3755302 C184.497113,27.9614864 183.684905,28.1014614 183.270273,28.6907681 L169.518018,48.2214044\" id=\"Fill-10\" fill=\"#0C2935\"></path>\r\n                <path d=\"M190.073766,56.3076101 L190.747175,70.7356264 C190.97831,75.7976653 213.027321,67.5538407 211.892818,60.7462306 C210.757726,53.9380324 208.14231,41.9201747 208.14231,41.9201747 C208.14231,41.9201747 209.140367,40.1599002 209.996685,34.8590804 C213.132597,34.3697558 213.019676,22.8782748 209.168597,24.0357156 C207.435377,24.5485653 205.967403,27.48216 205.967403,27.48216 C202.252771,31.7325789 194.232436,29.1795045 188.21645,24.1668687 C182.202228,19.1542328 177.389556,17.8779897 177.389556,17.8779897 C177.389556,17.8779897 172.176368,48.6236856 190.073766,56.3076101\" id=\"Fill-11\" fill=\"#ED9E8B\"></path>\r\n                <path d=\"M190.073766,56.3076101 L190.365479,62.7805739 C190.365479,62.7805739 202.247478,60.7891641 205.798022,45.8706469 C196.250312,60.1863304 190.073766,56.3076101 190.073766,56.3076101\" id=\"Fill-12\" fill=\"#DD8677\"></path>\r\n                <path d=\"M181.892871,32.5612547 C181.759954,31.7237569 181.18535,31.1215113 180.611335,31.2203172 C180.027321,31.2950098 179.670326,32.0536981 179.792069,32.8911959 C179.924399,33.7239886 180.508412,34.3315274 181.082427,34.2374265 C181.665853,34.1480307 182.023436,33.3999287 181.892871,32.5612547\" id=\"Fill-13\" fill=\"#431F18\"></path>\r\n                <path d=\"M193.172037,31.5779006 C193.04853,30.7398146 192.479219,30.1275708 191.904616,30.2175548 C191.326484,30.2969524 190.958902,31.0497594 191.071823,31.8884334 C191.198859,32.7212262 191.769346,33.3340581 192.342773,33.2487792 C192.927375,33.1640884 193.289075,32.4248084 193.172037,31.5779006\" id=\"Fill-14\" fill=\"#431F18\"></path>\r\n                <path d=\"M186.212689,42.7012119 L186.222099,42.697095 C186.533809,42.697095 186.792586,42.4477277 186.788469,42.1418998 L186.816111,31.300303 C186.816111,30.9791837 186.618499,30.7021743 186.252094,30.7304046 C185.939797,30.7304046 185.686313,30.9791837 185.686313,31.2950098 L185.658082,42.1371948 C185.658082,42.4430226 185.90745,42.697095 186.212689,42.7012119\" id=\"Fill-15\" fill=\"#DD8677\"></path>\r\n                <path d=\"M190.03142,48.4454821 C191.47234,48.1202459 193.020888,47.2692212 194.183621,45.361326 C194.343593,45.0890216 194.264195,44.7402602 193.990127,44.5802887 C193.73723,44.4156122 193.383176,44.505008 193.214382,44.7684905 C190.76129,48.7983604 186.453235,47.2309927 186.269738,47.160417 C185.98273,47.0516129 185.652789,47.2027624 185.539868,47.4991802 C185.43224,47.791481 185.582802,48.1155409 185.875102,48.2237569 C185.903333,48.2384602 187.842399,48.9442167 190.03142,48.4454821\" id=\"Fill-16\" fill=\"#DD8677\"></path>\r\n                <g id=\"Group-20\" transform=\"translate(0.000000, 122.919266)\">\r\n                    <mask id=\"mask-6\" fill=\"white\">\r\n                        <use xlink:href=\"#path-5\"></use>\r\n                    </mask>\r\n                    <g id=\"Clip-18\"></g>\r\n                    <path d=\"M210.830654,18.0855997 C210.830654,18.0855997 190.169631,1.28859383 190.054358,1.18508287 C189.581501,0.753983247 188.956318,0.492853324 188.268793,0.492853324 L23.4040634,0.492853324 C22.7165389,0.492853324 22.0884156,0.753983247 21.616735,1.18508287 C21.5026377,1.28859383 1.11450722,17.8709321 1.11450722,17.8709321 L210.830654,18.0855997\" id=\"Fill-17\" fill=\"#96CFC8\" mask=\"url(#mask-6)\"></path>\r\n                    <path d=\"M208.874532,17.2945642 L2.82067368,17.2945642 C1.26330422,17.2945642 0,18.5590447 0,20.1181786 C0,21.6743718 1.26330422,22.9370879 2.82067368,22.9370879 L208.874532,22.9370879 C210.431902,22.9370879 211.694618,21.6743718 211.694618,20.1181786 C211.694618,18.5590447 210.431902,17.2945642 208.874532,17.2945642\" id=\"Fill-19\" fill=\"#63B9B4\" mask=\"url(#mask-6)\"></path>\r\n                </g>\r\n                <path d=\"M10.1411335,66.7275174 C10.1411335,66.7275174 20.9515594,73.0081625 28.6166637,84.5261094 C36.2835323,96.0452326 40.4392622,106.753324 37.900303,108.442435 C35.36252,110.131545 27.089877,102.162377 19.4247728,90.6450187 C11.7590804,79.1247193 10.1411335,66.7275174 10.1411335,66.7275174\" id=\"Fill-21\" fill=\"#19676B\"></path>\r\n                <path d=\"M48.0520228,72.0018713 C46.7693103,88.2101586 42.8329531,101.121387 39.2600606,100.836731 C35.6895206,100.554429 33.8327927,87.1856354 35.1172696,70.9767599 C36.3999822,54.7696489 43.9074675,42.1407236 43.9074675,42.1407236 C43.9074675,42.1407236 49.3359116,55.793584 48.0520228,72.0018713\" id=\"Fill-22\" fill=\"#19676B\"></path>\r\n                <path d=\"M38.9324719,78.6806808 C41.9719301,93.7732846 41.7390305,106.551007 38.4125646,107.222064 C35.0878631,107.890768 29.9270184,96.1987346 26.8881483,81.1067189 C23.8492782,66.0141151 27.4080556,52.5671003 27.4080556,52.5671003 C27.4080556,52.5671003 35.8930137,63.5886651 38.9324719,78.6806808\" id=\"Fill-23\" fill=\"#227D81\"></path>\r\n                <path d=\"M61.8295669,89.5258065 C53.9703796,100.914365 45.5636428,108.741793 43.0552664,107.007984 C40.5463019,105.276528 44.8819996,94.640777 52.7417751,83.2539832 C60.6015505,71.8654251 71.5172518,65.7706291 71.5172518,65.7706291 C71.5172518,65.7706291 69.6893424,78.1384245 61.8295669,89.5258065\" id=\"Fill-24\" fill=\"#227D81\"></path>\r\n                <path d=\"M55.0954732,83.4745322 C49.5576368,98.7618072 42.3342185,110.165657 38.9654072,108.942934 C35.596596,107.721975 37.3562823,94.3402424 42.895295,79.0547318 C48.4343076,63.7674568 59.0241846,53.5851542 59.0241846,53.5851542 C59.0241846,53.5851542 60.6333096,68.1884334 55.0954732,83.4745322\" id=\"Fill-25\" fill=\"#227D81\"></path>\r\n                <path d=\"M26.061825,116.022848 C26.061825,125.935199 32.8306184,129.982713 32.8306184,129.982713 L49.3047407,129.982713 C49.3047407,129.982713 56.0741223,125.935199 56.0741223,116.022848 L56.0741223,109.794546 L26.061825,109.794546 L26.061825,116.022848\" id=\"Fill-26\" fill=\"#31506D\"></path>\r\n                <path d=\"M55.1278204,105.163607 L27.0081269,105.163607 C26.4852789,105.163607 26.061825,105.587061 26.061825,106.109909 L26.061825,109.794546 L56.0741223,109.794546 L56.0741223,106.109909 C56.0741223,105.587061 55.6500802,105.163607 55.1278204,105.163607\" id=\"Fill-27\" fill=\"#A6784B\"></path>\r\n                <polyline id=\"Fill-28\" fill=\"#0C2935\" points=\"144.261932 125.051239 169.089859 97.6414186 166.833791 95.600606 142.105846 122.901622 140.467902 126.917377 144.261932 125.051239\"></polyline>\r\n                <path d=\"M110.10802,127.040884 C110.10802,127.704295 110.645571,128.243023 111.30957,128.243023 L128.918196,128.243023 C129.580431,128.243023 130.119747,127.704295 130.119747,127.040884 L130.119747,103.647407 C130.119747,102.983408 129.580431,102.445268 128.918196,102.445268 L111.30957,102.445268 C110.645571,102.445268 110.10802,102.983408 110.10802,103.647407 L110.10802,127.040884\" id=\"Fill-29\" fill=\"#A6784B\"></path>\r\n                <path d=\"M104.979522,114.154946 C104.979522,116.982677 107.280289,119.283443 110.10802,119.283443 C112.935163,119.283443 115.238282,116.982677 115.238282,114.154946 C115.238282,111.327214 112.935163,109.025272 110.10802,109.025272 C107.280289,109.025272 104.979522,111.327214 104.979522,114.154946 Z M102.59583,114.154946 C102.59583,110.012743 105.965817,106.640403 110.10802,106.640403 C114.251987,106.640403 117.623151,110.012743 117.623151,114.154946 C117.623151,118.297737 114.251987,121.668312 110.10802,121.668312 C105.965817,121.668312 102.59583,118.297737 102.59583,114.154946 L102.59583,114.154946 Z\" id=\"Fill-30\" fill=\"#A6784B\"></path>\r\n                <path d=\"M223.807164,133.615594 C223.692479,133.460328 215.872696,121.785938 215.75213,121.635377 C213.25728,122.060595 165.734575,122.496988 163.536143,121.372483 C160.444341,119.782766 155.033541,115.222402 151.883515,114.626626 C146.384495,113.588576 143.836125,115.095954 140.716682,119.63044 C137.596061,124.164926 138.582356,132.916895 143.450312,132.916895 C148.31768,132.916895 172.338692,132.834557 172.338692,132.834557 C172.338692,132.834557 225.322189,135.635234 223.807164,133.615594\" id=\"Fill-31\" fill=\"#ED9E8B\"></path>\r\n                <path d=\"M102.537017,128.63707 L90.3850651,79.8892889 C89.9022099,77.9584566 87.9943147,76.4469613 86.0446623,76.4469613 L43.1217252,76.4469613 C42.0519159,76.4469613 41.0867938,76.900998 40.4698449,77.6902691 C39.8376047,78.4989485 39.6329353,79.5793441 39.9005347,80.6597398 L52.0530743,129.406345 C52.5359294,131.338353 54.4426484,132.849849 56.3934771,132.849849 L99.319943,132.849849 C100.386812,132.849849 101.351934,132.394636 101.967706,131.605953 C102.599947,130.797861 102.804616,129.718054 102.537017,128.63707\" id=\"Fill-32\" fill=\"#FFFFFE\"></path>\r\n                <path d=\"M86.0446623,76.4469613 L43.1217252,76.4469613 C42.0519159,76.4469613 41.0867938,76.900998 40.4698449,77.6902691 C39.8376047,78.4989485 39.6329353,79.5793441 39.9005347,80.6597398 L52.0530743,129.406345 C52.5359294,131.338353 54.4426484,132.849849 56.3934771,132.849849 L99.319943,132.849849 C100.386812,132.849849 101.351934,132.394636 101.967706,131.605953 C102.599947,130.797861 102.804616,129.718054 102.537017,128.63707 L90.3850651,79.8892889 C89.9022099,77.9584566 87.9943147,76.4469613 86.0446623,76.4469613 Z M86.0223133,80.5474069 C86.1546427,80.5785778 86.3704865,80.7673677 86.4063625,80.881465 L98.3389414,128.749403 L56.424648,128.751167 C56.2934949,128.726466 56.068241,128.531795 56.0317769,128.414169 L44.0980217,80.5474069 L86.0223133,80.5474069 L86.0223133,80.5474069 Z\" id=\"Fill-33\" fill=\"#56636C\"></path>\r\n                <path d=\"M57.0186598,132.849849 L132.001176,132.849849 L132.001176,132.845732 C132.013527,132.845732 132.020585,132.849849 132.029407,132.849849 C133.582071,132.849849 134.840082,131.589485 134.840082,130.037409 C134.840082,128.488273 133.582071,127.229086 132.029407,127.229086 C132.020585,127.229086 132.013527,127.232615 132.001176,127.232615 L132.001176,127.229086 L54.7190697,127.229086\" id=\"Fill-34\" fill=\"#56636C\"></path>\r\n                <polyline id=\"Fill-35\" fill=\"#DA324E\" points=\"61.631367 93.1022278 53.9933167 93.1022278 52.6823739 87.8678667 60.319836 87.8678667 61.631367 93.1022278\"></polyline>\r\n                <polyline id=\"Fill-36\" fill=\"#DA324E\" points=\"69.2600071 93.1022278 61.6219569 93.1022278 60.3104259 87.8678667 67.9484762 87.8678667 69.2600071 93.1022278\"></polyline>\r\n                <polyline id=\"Fill-37\" fill=\"#DA324E\" points=\"76.8892354 93.1022278 69.250597 93.1022278 67.9390661 87.8678667 75.5777045 87.8678667 76.8892354 93.1022278\"></polyline>\r\n                <polyline id=\"Fill-38\" fill=\"#DA324E\" points=\"84.5296382 93.1022278 76.8909998 93.1022278 75.5788808 87.8678667 83.2175192 87.8678667 84.5296382 93.1022278\"></polyline>\r\n                <polyline id=\"Fill-39\" fill=\"#DAEDEC\" points=\"62.9934771 101.418981 56.8828016 101.418981 55.3748351 95.3088932 61.4855106 95.3088932 62.9934771 101.418981\"></polyline>\r\n                <polyline id=\"Fill-40\" fill=\"#B3D4D4\" points=\"70.6221173 101.418981 64.5120299 101.418981 63.0034753 95.3088932 69.1141508 95.3088932 70.6221173 101.418981\"></polyline>\r\n                <polyline id=\"Fill-41\" fill=\"#DAEDEC\" points=\"78.2519337 101.418981 72.1412582 101.418981 70.6332917 95.3088932 76.7433791 95.3088932 78.2519337 101.418981\"></polyline>\r\n                <polyline id=\"Fill-42\" fill=\"#B3D4D4\" points=\"85.8911602 101.418981 79.7804848 101.418981 78.2725183 95.3088932 84.3831937 95.3088932 85.8911602 101.418981\"></polyline>\r\n                <polyline id=\"Fill-43\" fill=\"#B3D4D4\" points=\"64.8796115 109.058795 58.7683479 109.058795 57.2609695 102.947532 63.3710569 102.947532 64.8796115 109.058795\"></polyline>\r\n                <polyline id=\"Fill-44\" fill=\"#DA324E\" points=\"72.5076635 109.058795 66.3969881 109.058795 64.8896097 102.947532 70.9991089 102.947532 72.5076635 109.058795\"></polyline>\r\n                <polyline id=\"Fill-45\" fill=\"#B3D4D4\" points=\"80.1368918 109.058795 74.0268045 109.058795 72.5182499 102.947532 78.6289253 102.947532 80.1368918 109.058795\"></polyline>\r\n                <polyline id=\"Fill-46\" fill=\"#DAEDEC\" points=\"87.7767065 109.058795 81.6654429 109.058795 80.1580645 102.947532 86.26874 102.947532 87.7767065 109.058795\"></polyline>\r\n                <polyline id=\"Fill-47\" fill=\"#DAEDEC\" points=\"66.7645696 116.697434 60.653306 116.697434 59.1453395 110.587346 65.2566031 110.587346 66.7645696 116.697434\"></polyline>\r\n                <polyline id=\"Fill-48\" fill=\"#B3D4D4\" points=\"74.3932098 116.697434 68.2819462 116.697434 66.7739797 110.587346 72.8852433 110.587346 74.3932098 116.697434\"></polyline>\r\n                <polyline id=\"Fill-49\" fill=\"#DAEDEC\" points=\"82.0224381 116.697434 75.9117626 116.697434 74.4037961 110.587346 80.5138834 110.587346 82.0224381 116.697434\"></polyline>\r\n                <polyline id=\"Fill-50\" fill=\"#B3D4D4\" points=\"89.6622527 116.697434 83.5521654 116.697434 82.0441989 110.587346 88.1536981 110.587346 89.6622527 116.697434\"></polyline>\r\n                <path d=\"M168.585831,48.237872 C168.585831,48.237872 172.914472,46.6581536 174.841775,45.4889503 C176.769079,44.3203351 177.147835,43.1193727 178.792247,39.7140973 C180.43666,36.3076457 181.024202,33.6387097 178.913402,34.0474603 C176.660274,34.483265 172.757441,35.8394939 172.757441,35.8394939 L168.585831,48.237872\" id=\"Fill-51\" fill=\"#ED9E8B\"></path>\r\n                <polyline id=\"Fill-52\" fill=\"#77648D\" points=\"167.467795 119.644555 167.732454 133.899073 225.697416 135.75933 228.282837 116.206933 167.467795 119.644555\"></polyline>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>";
var svgList = {
	confirmationLetter: confirmationLetter,
	forbidden: forbidden,
	lightbulbFloatsOverHand: lightbulbFloatsOverHand,
	manAndWomanUnderUmbrelaButDogWillGetWet: manAndWomanUnderUmbrelaButDogWillGetWet,
	manHoldingBox: manHoldingBox,
	manHoldingCertificate: manHoldingCertificate,
	notFound: notFound,
	ok: ok,
	womanInFrontOfComputer: womanInFrontOfComputer,
	womanLookingAtThePhone: womanLookingAtThePhone,
	womanWithBinoculars: womanWithBinoculars,
	womanWithComputerDisplayingChecks: womanWithComputerDisplayingChecks,
	womanWithLaptopTalkingOnThePhone: womanWithLaptopTalkingOnThePhone
};

const _c0$F = ["svgContainer"];
class IllustrationComponent {
    constructor() {
        this.name = 'manAndWomanUnderUmbrelaButDogWillGetWet';
        this.width = '100%';
    }
    ngOnInit() {
        this.updateSVG();
    }
    ngOnChanges() {
        this.updateSVG();
    }
    ngAfterViewInit() {
        this.updateSVG();
    }
    getBackwardCompatibleName() {
        return this.name
            .split('-')
            .map((entry, index) => (index > 0 ? `${entry[0].toUpperCase()}${entry.substr(1)}` : entry))
            .join('');
    }
    selectSVGContent() {
        return svgList[this.getBackwardCompatibleName()];
    }
    updateSVG() {
        if (!this.svgContainer) {
            return;
        }
        const { nativeElement } = this.svgContainer;
        if (!nativeElement) {
            return;
        }
        nativeElement.innerHTML = this.selectSVGContent();
    }
}
IllustrationComponent.ɵfac = function IllustrationComponent_Factory(t) { return new (t || IllustrationComponent)(); };
IllustrationComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: IllustrationComponent, selectors: [["cpc-illustration"]], viewQuery: function IllustrationComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$F, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.svgContainer = _t.first);
    } }, inputs: { name: "name", width: "width" }, features: [i0.ɵɵNgOnChangesFeature], decls: 3, vars: 2, consts: [[1, "cpc-illustration"], [2, "display", "flex"], ["svgContainer", ""]], template: function IllustrationComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "figure", 0);
        i0.ɵɵelement(1, "div", 1, 2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵstyleMap("width: " + ctx.width);
    } }, styles: [".cpc-illustration{margin:0;padding:0}.cpc-illustration svg{width:100%;height:auto}\n"], encapsulation: 3 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IllustrationComponent, [{
        type: Component,
        args: [{ selector: 'cpc-illustration', encapsulation: ViewEncapsulation.ShadowDom, template: "<figure class=\"cpc-illustration\" [style]=\"'width: ' + width\">\r\n  <div #svgContainer style=\"display: flex\">\r\n  </div>\r\n</figure>\r\n", styles: [".cpc-illustration{margin:0;padding:0}.cpc-illustration svg{width:100%;height:auto}\n"] }]
    }], null, { name: [{
            type: Input
        }], width: [{
            type: Input
        }], svgContainer: [{
            type: ViewChild,
            args: ['svgContainer']
        }] }); })();

const _c0$E = ["languageSwitch"];
function LanguageSwitchComponent_cpc_icon_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "cpc-icon", 10);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("icon", ctx_r1.ndbxIcons.ProductWorldGlobe);
} }
function LanguageSwitchComponent_li_10_cpc_icon_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "cpc-icon", 13);
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("icon", ctx_r4.ndbxIcons.Check);
} }
const _c1$l = function (a0) { return { "cpc-language-switch-language-name--active": a0 }; };
function LanguageSwitchComponent_li_10_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 11);
    i0.ɵɵlistener("click", function LanguageSwitchComponent_li_10_Template_li_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r6); const language_r3 = restoredCtx.$implicit; const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.setActiveLanguage(language_r3)); });
    i0.ɵɵtemplate(1, LanguageSwitchComponent_li_10_cpc_icon_1_Template, 1, 1, "cpc-icon", 12);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const language_r3 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c1$l, ctx_r2.activeLanguage.name === language_r3.name));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", language_r3.name === ctx_r2.activeLanguage.name);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", language_r3.name, " ");
} }
class LanguageSwitchComponent {
    constructor(elementRef, backdropService) {
        this.elementRef = elementRef;
        this.backdropService = backdropService;
        this.activeLanguage = { name: '', code: '' };
        this.languages = [{ name: '', code: '' }];
        this.hideGlobe = false; // Hide globe icon(need for mobile)
        this.disableOutsideClose = false; // Prevent closing when clicked outside(need in mobile menu)
        this.changeLanguage = new EventEmitter();
        this.expandList = false;
        this.ndbxIcons = NdbxIcon;
    }
    get parentElement() {
        if (this.disableOutsideClose) {
            return false;
        }
        return this.elementRef.nativeElement;
    }
    changeDrawer(nextVisibility) {
        if (nextVisibility) {
            this.backdropService.openBackdrop();
        }
        else {
            this.backdropService.closeBackdrop();
        }
    }
    toggleList(nextVisibility = !this.expandList) {
        this.changeDrawer(nextVisibility);
        this.expandList = nextVisibility;
    }
    setActiveLanguage(language) {
        this.activeLanguage = language;
        this.languageSwitchElement.nativeElement.blur();
        this.changeLanguage.emit(language);
        this.toggleList();
    }
}
LanguageSwitchComponent.ɵfac = function LanguageSwitchComponent_Factory(t) { return new (t || LanguageSwitchComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(BackdropService)); };
LanguageSwitchComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LanguageSwitchComponent, selectors: [["cpc-language-switch"]], viewQuery: function LanguageSwitchComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$E, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.languageSwitchElement = _t.first);
    } }, inputs: { activeLanguage: "activeLanguage", languages: "languages", hideGlobe: "hideGlobe", disableOutsideClose: "disableOutsideClose" }, outputs: { changeLanguage: "changeLanguage" }, decls: 11, vars: 8, consts: [[1, "cpc-language-switch"], ["languageSwitch", ""], [3, "ngClass", "click"], [1, "cpc-language-switch-active-language"], ["class", "cpc-language-switch-icon-world-globe", 3, "icon", 4, "ngIf"], [1, "cpc-language-switch-language-code"], [3, "ngClass", "icon"], [3, "drawerOpenModel", "parentElement", "drawerOpenModelChange"], [1, "cpc-language-switch-languages-list"], ["class", "cpc-language-switch-language-name", 3, "ngClass", "click", 4, "ngFor", "ngForOf"], [1, "cpc-language-switch-icon-world-globe", 3, "icon"], [1, "cpc-language-switch-language-name", 3, "ngClass", "click"], ["class", "cpc-language-switch-icon-check", 3, "icon", 4, "ngIf"], [1, "cpc-language-switch-icon-check", 3, "icon"]], template: function LanguageSwitchComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "button", 0, 1)(2, "div", 2);
        i0.ɵɵlistener("click", function LanguageSwitchComponent_Template_div_click_2_listener() { return ctx.toggleList(); });
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵtemplate(4, LanguageSwitchComponent_cpc_icon_4_Template, 1, 1, "cpc-icon", 4);
        i0.ɵɵelementStart(5, "div", 5);
        i0.ɵɵtext(6);
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(7, "cpc-icon", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "cpc-dropdown-drawer", 7);
        i0.ɵɵlistener("drawerOpenModelChange", function LanguageSwitchComponent_Template_cpc_dropdown_drawer_drawerOpenModelChange_8_listener($event) { return ctx.expandList = $event; })("drawerOpenModelChange", function LanguageSwitchComponent_Template_cpc_dropdown_drawer_drawerOpenModelChange_8_listener($event) { return ctx.changeDrawer($event); });
        i0.ɵɵelementStart(9, "ul", 8);
        i0.ɵɵtemplate(10, LanguageSwitchComponent_li_10_Template, 3, 5, "li", 9);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", ctx.expandList ? "cpc-language-switch-dropdown cpc-language-switch-dropdown--active" : "cpc-language-switch-dropdown");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.hideGlobe);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.activeLanguage.code);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", ctx.expandList ? "cpc-language-switch-icon cpc-language-switch-icon--active" : "cpc-language-switch-icon")("icon", ctx.ndbxIcons.ChevronDown);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("drawerOpenModel", ctx.expandList)("parentElement", ctx.parentElement);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.languages);
    } }, dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, DropdownDrawerComponent, IconComponent], styles: [".cpc-language-switch{cursor:pointer;-webkit-appearance:none;display:flex;justify-content:center;width:100%;height:100%;padding:0;color:inherit;font-family:var(--font-family);background:transparent;border:none;border-radius:2px;outline:0;appearance:none}.cpc-language-switch .cpc-language-switch-dropdown{display:flex;align-items:center;justify-content:space-between;height:100%;color:inherit;cursor:pointer}.cpc-language-switch .cpc-language-switch-dropdown:disabled,.cpc-language-switch .cpc-language-switch-dropdown.pseudo-states--disabled{cursor:not-allowed;pointer-events:none}.cpc-language-switch .cpc-language-switch-dropdown:disabled,.cpc-language-switch .cpc-language-switch-dropdown.cpc--disabled,.cpc-language-switch .cpc-language-switch-dropdown.pseudo-states--disabled{cursor:not-allowed;pointer-events:none}.cpc-language-switch .cpc-language-switch-dropdown--active{color:var(--cpc-colors-resolution-blue)}@media screen and (min-width: 992px){.cpc-language-switch .cpc-language-switch-dropdown{justify-content:unset;width:-moz-fit-content;width:fit-content;color:var(--cpc-colors-text)}.cpc-language-switch .cpc-language-switch-dropdown:hover,.cpc-language-switch .cpc-language-switch-dropdown.pseudo-states--hover{color:var(--cpc-colors-hover)}.cpc-language-switch .cpc-language-switch-dropdown:hover:not(:disabled):not(:active),.cpc-language-switch .cpc-language-switch-dropdown.pseudo-states--hover{color:var(--cpc-colors-hover)}.cpc-language-switch .cpc-language-switch-dropdown--active{color:var(--cpc-colors-blue)}.cpc-language-switch .cpc-language-switch-dropdown:active,.cpc-language-switch .cpc-language-switch-dropdown.pseudo-states--active{color:var(--cpc-colors-dark-cerulian)}}.cpc-language-switch .cpc-language-switch-active-language{display:flex;align-items:center;justify-content:center;width:-moz-fit-content;width:fit-content;margin-right:8px}.cpc-language-switch .cpc-language-switch-icon{font-size:24px;transition:transform .2s ease-out}@media screen and (min-width: 992px){.cpc-language-switch .cpc-language-switch-icon{font-size:20px}}.cpc-language-switch .cpc-language-switch-icon--active{transform:rotate(180deg)}.cpc-language-switch .cpc-language-switch-icon-world-globe{height:var(--button-medium-icon-size);margin-right:8px;font-size:var(--button-medium-icon-size)}@media screen and (min-width: 704px){.cpc-language-switch .cpc-language-switch-icon-world-globe{display:flex}}.cpc-language-switch .cpc-language-switch-icon-world-globe:before{position:relative;top:-2px}.cpc-language-switch .cpc-language-switch-language-code{font-weight:600;font-size:16px;line-height:24px;letter-spacing:1px}.cpc-language-switch .cpc-language-switch-languages-list{margin:0;padding:24px 30px;list-style:none;border-bottom:1px solid var(--cpc-colors-border)}@media screen and (min-width: 992px){.cpc-language-switch .cpc-language-switch-languages-list{width:-moz-fit-content;width:fit-content;padding:10px 0;border-bottom:unset}}.cpc-language-switch .cpc-language-switch-language-name{position:relative;display:flex;align-items:center;width:-moz-fit-content;width:fit-content;font-size:16px;text-align:left;cursor:pointer}.cpc-language-switch .cpc-language-switch-language-name--active{padding-left:28px;color:var(--cpc-colors-charcoal)}.cpc-language-switch .cpc-language-switch-language-name:hover,.cpc-language-switch .cpc-language-switch-language-name.pseudo-states--hover{color:var(--cpc-colors-hover)}.cpc-language-switch .cpc-language-switch-language-name:hover:not(:disabled):not(:active),.cpc-language-switch .cpc-language-switch-language-name.pseudo-states--hover{color:var(--cpc-colors-hover)}.cpc-language-switch .cpc-language-switch-language-name:active,.cpc-language-switch .cpc-language-switch-language-name.pseudo-states--active{color:var(--cpc-colors-dark-cerulian)}.cpc-language-switch .cpc-language-switch-language-name:not(:last-child){margin-bottom:16px}@media screen and (min-width: 992px){.cpc-language-switch .cpc-language-switch-language-name{width:unset;text-align:unset}.cpc-language-switch .cpc-language-switch-language-name--active{color:var(--cpc-colors-blue)}}.cpc-language-switch .cpc-language-switch-icon-check{position:absolute;top:50%;margin-left:-32px;font-size:24px;transform:translateY(-50%)}@media screen and (min-width: 992px){.cpc-language-switch .cpc-language-switch-icon-check{margin-left:-32px}}.cpc-language-switch .cpc-language-switch-arrow-box{position:absolute;z-index:1050;display:inline-block;margin-top:50px;background:#fff;border:var(--cpc-border);border-radius:4px;box-shadow:0 8px 24px #41414159}.cpc-language-switch .cpc-language-switch-arrow-box:after,.cpc-language-switch .cpc-language-switch-arrow-box:before{position:absolute;bottom:100%;left:50%;width:0;height:0;border:solid transparent;content:\"\";pointer-events:none}.cpc-language-switch .cpc-language-switch-arrow-box:after{margin-left:-8px;border-color:#fff0;border-width:8px;border-bottom-color:#fff}.cpc-language-switch .cpc-language-switch-arrow-box:before{margin-left:-9px;border-color:#d9d9d900;border-width:9px;border-bottom-color:var(--adc-colors-light-gray)}@media screen and (min-width: 992px){.cpc-language-switch{position:relative}}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LanguageSwitchComponent, [{
        type: Component,
        args: [{ selector: 'cpc-language-switch', encapsulation: ViewEncapsulation.None, template: "<button class=\"cpc-language-switch\" #languageSwitch>\r\n  <div (click)=\"toggleList()\" [ngClass]=\"expandList ? 'cpc-language-switch-dropdown cpc-language-switch-dropdown--active' : 'cpc-language-switch-dropdown'\">\r\n    <div class=\"cpc-language-switch-active-language\">\r\n      <cpc-icon *ngIf=\"!hideGlobe\" [icon]=\"ndbxIcons.ProductWorldGlobe\" class=\"cpc-language-switch-icon-world-globe\"></cpc-icon>\r\n      <div class=\"cpc-language-switch-language-code\">{{ activeLanguage.code }}</div>\r\n    </div>\r\n    <cpc-icon [ngClass]=\"expandList ? 'cpc-language-switch-icon cpc-language-switch-icon--active' : 'cpc-language-switch-icon'\" [icon]=\"ndbxIcons.ChevronDown\"></cpc-icon>\r\n  </div>\r\n  <cpc-dropdown-drawer\r\n    [(drawerOpenModel)]=\"expandList\"\r\n    [parentElement]=\"parentElement\"\r\n    (drawerOpenModelChange)=\"changeDrawer($event)\"\r\n  >\r\n    <ul class=\"cpc-language-switch-languages-list\">\r\n      <li\r\n        *ngFor=\"let language of languages\"\r\n        (click)=\"setActiveLanguage(language)\"\r\n        [ngClass]=\"{ 'cpc-language-switch-language-name--active': activeLanguage.name === language.name }\"\r\n        class=\"cpc-language-switch-language-name\"\r\n      >\r\n        <cpc-icon\r\n          *ngIf=\"language.name === activeLanguage.name\"\r\n          [icon]=\"ndbxIcons.Check\"\r\n          class=\"cpc-language-switch-icon-check\"\r\n        ></cpc-icon>\r\n        {{ language.name }}\r\n      </li>\r\n    </ul>\r\n  </cpc-dropdown-drawer>\r\n</button>\r\n", styles: [".cpc-language-switch{cursor:pointer;-webkit-appearance:none;display:flex;justify-content:center;width:100%;height:100%;padding:0;color:inherit;font-family:var(--font-family);background:transparent;border:none;border-radius:2px;outline:0;appearance:none}.cpc-language-switch .cpc-language-switch-dropdown{display:flex;align-items:center;justify-content:space-between;height:100%;color:inherit;cursor:pointer}.cpc-language-switch .cpc-language-switch-dropdown:disabled,.cpc-language-switch .cpc-language-switch-dropdown.pseudo-states--disabled{cursor:not-allowed;pointer-events:none}.cpc-language-switch .cpc-language-switch-dropdown:disabled,.cpc-language-switch .cpc-language-switch-dropdown.cpc--disabled,.cpc-language-switch .cpc-language-switch-dropdown.pseudo-states--disabled{cursor:not-allowed;pointer-events:none}.cpc-language-switch .cpc-language-switch-dropdown--active{color:var(--cpc-colors-resolution-blue)}@media screen and (min-width: 992px){.cpc-language-switch .cpc-language-switch-dropdown{justify-content:unset;width:-moz-fit-content;width:fit-content;color:var(--cpc-colors-text)}.cpc-language-switch .cpc-language-switch-dropdown:hover,.cpc-language-switch .cpc-language-switch-dropdown.pseudo-states--hover{color:var(--cpc-colors-hover)}.cpc-language-switch .cpc-language-switch-dropdown:hover:not(:disabled):not(:active),.cpc-language-switch .cpc-language-switch-dropdown.pseudo-states--hover{color:var(--cpc-colors-hover)}.cpc-language-switch .cpc-language-switch-dropdown--active{color:var(--cpc-colors-blue)}.cpc-language-switch .cpc-language-switch-dropdown:active,.cpc-language-switch .cpc-language-switch-dropdown.pseudo-states--active{color:var(--cpc-colors-dark-cerulian)}}.cpc-language-switch .cpc-language-switch-active-language{display:flex;align-items:center;justify-content:center;width:-moz-fit-content;width:fit-content;margin-right:8px}.cpc-language-switch .cpc-language-switch-icon{font-size:24px;transition:transform .2s ease-out}@media screen and (min-width: 992px){.cpc-language-switch .cpc-language-switch-icon{font-size:20px}}.cpc-language-switch .cpc-language-switch-icon--active{transform:rotate(180deg)}.cpc-language-switch .cpc-language-switch-icon-world-globe{height:var(--button-medium-icon-size);margin-right:8px;font-size:var(--button-medium-icon-size)}@media screen and (min-width: 704px){.cpc-language-switch .cpc-language-switch-icon-world-globe{display:flex}}.cpc-language-switch .cpc-language-switch-icon-world-globe:before{position:relative;top:-2px}.cpc-language-switch .cpc-language-switch-language-code{font-weight:600;font-size:16px;line-height:24px;letter-spacing:1px}.cpc-language-switch .cpc-language-switch-languages-list{margin:0;padding:24px 30px;list-style:none;border-bottom:1px solid var(--cpc-colors-border)}@media screen and (min-width: 992px){.cpc-language-switch .cpc-language-switch-languages-list{width:-moz-fit-content;width:fit-content;padding:10px 0;border-bottom:unset}}.cpc-language-switch .cpc-language-switch-language-name{position:relative;display:flex;align-items:center;width:-moz-fit-content;width:fit-content;font-size:16px;text-align:left;cursor:pointer}.cpc-language-switch .cpc-language-switch-language-name--active{padding-left:28px;color:var(--cpc-colors-charcoal)}.cpc-language-switch .cpc-language-switch-language-name:hover,.cpc-language-switch .cpc-language-switch-language-name.pseudo-states--hover{color:var(--cpc-colors-hover)}.cpc-language-switch .cpc-language-switch-language-name:hover:not(:disabled):not(:active),.cpc-language-switch .cpc-language-switch-language-name.pseudo-states--hover{color:var(--cpc-colors-hover)}.cpc-language-switch .cpc-language-switch-language-name:active,.cpc-language-switch .cpc-language-switch-language-name.pseudo-states--active{color:var(--cpc-colors-dark-cerulian)}.cpc-language-switch .cpc-language-switch-language-name:not(:last-child){margin-bottom:16px}@media screen and (min-width: 992px){.cpc-language-switch .cpc-language-switch-language-name{width:unset;text-align:unset}.cpc-language-switch .cpc-language-switch-language-name--active{color:var(--cpc-colors-blue)}}.cpc-language-switch .cpc-language-switch-icon-check{position:absolute;top:50%;margin-left:-32px;font-size:24px;transform:translateY(-50%)}@media screen and (min-width: 992px){.cpc-language-switch .cpc-language-switch-icon-check{margin-left:-32px}}.cpc-language-switch .cpc-language-switch-arrow-box{position:absolute;z-index:1050;display:inline-block;margin-top:50px;background:#fff;border:var(--cpc-border);border-radius:4px;box-shadow:0 8px 24px #41414159}.cpc-language-switch .cpc-language-switch-arrow-box:after,.cpc-language-switch .cpc-language-switch-arrow-box:before{position:absolute;bottom:100%;left:50%;width:0;height:0;border:solid transparent;content:\"\";pointer-events:none}.cpc-language-switch .cpc-language-switch-arrow-box:after{margin-left:-8px;border-color:#fff0;border-width:8px;border-bottom-color:#fff}.cpc-language-switch .cpc-language-switch-arrow-box:before{margin-left:-9px;border-color:#d9d9d900;border-width:9px;border-bottom-color:var(--adc-colors-light-gray)}@media screen and (min-width: 992px){.cpc-language-switch{position:relative}}\n"] }]
    }], function () { return [{ type: i0.ElementRef }, { type: BackdropService }]; }, { languageSwitchElement: [{
            type: ViewChild,
            args: ['languageSwitch']
        }], activeLanguage: [{
            type: Input
        }], languages: [{
            type: Input
        }], hideGlobe: [{
            type: Input
        }], disableOutsideClose: [{
            type: Input
        }], changeLanguage: [{
            type: Output
        }] }); })();

const _c0$D = ["*"];
class CheckboxComponent {
    constructor() {
        this.changeDetection = new EventEmitter();
        this.checkedChange = new EventEmitter(false);
    }
    set disabled(value) {
        const newValue = Boolean(value);
        if (newValue !== this.disabled) {
            this.disabled = newValue;
        }
    }
    onChange(event) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        this.checkedChange.emit(this.checked);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        this.changeDetection.emit({ event, id: this.id });
    }
    onInputClick(event) {
        // stop the propagation of the native click on the checkbox input so that a click is not triggered twice
        event.stopPropagation();
        if (!this.disabled) {
            this.toggle();
        }
    }
    toggle() {
        this.checked = !this.checked;
    }
}
CheckboxComponent.ɵfac = function CheckboxComponent_Factory(t) { return new (t || CheckboxComponent)(); };
CheckboxComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CheckboxComponent, selectors: [["cpc-checkbox"]], inputs: { value: "value", id: "id", checked: "checked", disabled: "disabled" }, outputs: { changeDetection: "changeDetection", checkedChange: "checkedChange" }, ngContentSelectors: _c0$D, decls: 5, vars: 2, consts: [[1, "cpc-checkbox", "cpc-checkbox-checkbox"], [1, "cpc-checkbox_control"], ["type", "checkbox", 3, "value", "checked", "change", "click"], [1, "cpc-checkbox_indicator"]], template: function CheckboxComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "label", 0)(1, "span", 1)(2, "input", 2);
        i0.ɵɵlistener("change", function CheckboxComponent_Template_input_change_2_listener($event) { return ctx.onChange($event); })("click", function CheckboxComponent_Template_input_click_2_listener($event) { return ctx.onInputClick($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelement(3, "div", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵprojection(4);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("value", ctx.value)("checked", ctx.checked);
    } }, styles: ["cpc-checkbox{width:100%}.cpc-checkbox_indicator{position:absolute;top:2px;left:0;width:24px;height:24px;background:transparent;border:2px solid #767676;border-radius:4px}.cpc-checkbox_indicator:after{position:absolute;display:none;box-sizing:unset;content:\"\"}.cpc-checkbox-checkbox .cpc-checkbox_indicator:after{top:2px;left:7px;width:4px;height:12px;border:solid var(--cpc-colors-white);border-width:0 2px 2px 0;transform:rotate(45deg)}.cpc-checkbox{background:transparent;border:none;border-radius:0;-webkit-appearance:none;appearance:none;position:relative;display:flex;justify-self:baseline;width:-moz-fit-content;width:fit-content;height:24px;cursor:pointer}.cpc-checkbox:hover input~.cpc-checkbox_indicator{border-color:var(--cpc-colors-resolution-blue)}.cpc-checkbox input:checked~.cpc-checkbox_indicator:after{display:block}.cpc-checkbox input{position:absolute;z-index:-1;opacity:0}.cpc-checkbox input:checked~.cpc-checkbox_indicator{background:#007ab3;border-color:#007ab3}.cpc-checkbox input:disabled~.cpc-checkbox_indicator{background:#ececec;border-color:#767676;cursor:not-allowed}.cpc-checkbox input:checked:hover~.cpc-checkbox_indicator{background:var(--cpc-colors-resolution-blue);border-color:var(--cpc-colors-resolution-blue)}.cpc-checkbox input:checked:disabled~.cpc-checkbox_indicator{background:#c2c2c2!important;border-color:#c2c2c2!important}.cpc-checkbox:hover input:not([disabled]):checked~.cpc-checkbox_indicator{background:var(--cpc-colors-resolution-blue);border-color:var(--cpc-colors-resolution-blue)}.cpc-checkbox-checkbox input:disabled~.cpc-checkbox_indicator:after{border-color:var(--cpc-colors-white);cursor:not-allowed}.cpc-checkbox_control{width:24px}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CheckboxComponent, [{
        type: Component,
        args: [{ selector: 'cpc-checkbox', encapsulation: ViewEncapsulation.None, template: "<label class=\"cpc-checkbox cpc-checkbox-checkbox\">\r\n  <span class=\"cpc-checkbox_control\">\r\n    <input\r\n      type=\"checkbox\"\r\n      [value]=\"value\"\r\n      [checked]=\"checked\"\r\n      (change)=\"onChange($event)\"\r\n      (click)=\"onInputClick($event)\"\r\n    />\r\n    <div class=\"cpc-checkbox_indicator\"></div>\r\n  </span>\r\n  <ng-content></ng-content>\r\n</label>\r\n", styles: ["cpc-checkbox{width:100%}.cpc-checkbox_indicator{position:absolute;top:2px;left:0;width:24px;height:24px;background:transparent;border:2px solid #767676;border-radius:4px}.cpc-checkbox_indicator:after{position:absolute;display:none;box-sizing:unset;content:\"\"}.cpc-checkbox-checkbox .cpc-checkbox_indicator:after{top:2px;left:7px;width:4px;height:12px;border:solid var(--cpc-colors-white);border-width:0 2px 2px 0;transform:rotate(45deg)}.cpc-checkbox{background:transparent;border:none;border-radius:0;-webkit-appearance:none;appearance:none;position:relative;display:flex;justify-self:baseline;width:-moz-fit-content;width:fit-content;height:24px;cursor:pointer}.cpc-checkbox:hover input~.cpc-checkbox_indicator{border-color:var(--cpc-colors-resolution-blue)}.cpc-checkbox input:checked~.cpc-checkbox_indicator:after{display:block}.cpc-checkbox input{position:absolute;z-index:-1;opacity:0}.cpc-checkbox input:checked~.cpc-checkbox_indicator{background:#007ab3;border-color:#007ab3}.cpc-checkbox input:disabled~.cpc-checkbox_indicator{background:#ececec;border-color:#767676;cursor:not-allowed}.cpc-checkbox input:checked:hover~.cpc-checkbox_indicator{background:var(--cpc-colors-resolution-blue);border-color:var(--cpc-colors-resolution-blue)}.cpc-checkbox input:checked:disabled~.cpc-checkbox_indicator{background:#c2c2c2!important;border-color:#c2c2c2!important}.cpc-checkbox:hover input:not([disabled]):checked~.cpc-checkbox_indicator{background:var(--cpc-colors-resolution-blue);border-color:var(--cpc-colors-resolution-blue)}.cpc-checkbox-checkbox input:disabled~.cpc-checkbox_indicator:after{border-color:var(--cpc-colors-white);cursor:not-allowed}.cpc-checkbox_control{width:24px}\n"] }]
    }], null, { value: [{
            type: Input
        }], id: [{
            type: Input
        }], checked: [{
            type: Input
        }], changeDetection: [{
            type: Output
        }], checkedChange: [{
            type: Output
        }], disabled: [{
            type: Input
        }] }); })();

function MailItemComponent_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 8);
} }
const _c0$C = function (a0) { return { "cpc-icon--variant-unread": a0 }; };
function MailItemComponent_cpc_icon_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "cpc-icon", 9);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0$C, ctx_r1.variant === "unread"))("icon", ctx_r1.ndbxIcons.Paperclip);
} }
const _c1$k = [[["", "name", ""]], [["", "title", ""]], [["", "date", ""]]];
const _c2$5 = function (a0) { return { "cpc-mail-item-attachment--variant-read": a0 }; };
const _c3$2 = function (a0) { return { "cpc-mail-item-date--variant-read": a0 }; };
const _c4$1 = ["[name]", "[title]", "[date]"];
var CpcMailVariants;
(function (CpcMailVariants) {
    CpcMailVariants["Read"] = "read";
    CpcMailVariants["Unread"] = "unread";
})(CpcMailVariants || (CpcMailVariants = {}));
class MailItemComponent {
    constructor() {
        this.variant = CpcMailVariants.Read;
        this.attachment = false;
        this.changeDetection = new EventEmitter();
        this.ndbxIcons = NdbxIcon;
    }
    onCheckboxChange(data) {
        this.changeDetection.emit({ ...data, checked: this.checkbox.checked, value: this.checkbox.value });
    }
}
MailItemComponent.ɵfac = function MailItemComponent_Factory(t) { return new (t || MailItemComponent)(); };
MailItemComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MailItemComponent, selectors: [["cpc-mail-item"]], inputs: { variant: "variant", attachment: "attachment", checkbox: "checkbox" }, outputs: { changeDetection: "changeDetection" }, ngContentSelectors: _c4$1, decls: 12, vars: 14, consts: [[1, "cpc-mail-item_control", 3, "checked", "value", "id", "checkedChange", "changeDetection"], [1, "cpc-mail-item-name"], [1, "cpc-mail-item-title-wrapper"], ["class", "cpc-mail-item-title-dot", 4, "ngIf"], [1, "cpc-mail-item-title"], [1, "cpc-mail-item-attachment", 3, "ngClass"], [3, "ngClass", "icon", 4, "ngIf"], [1, "cpc-mail-item-date", 3, "ngClass"], [1, "cpc-mail-item-title-dot"], [3, "ngClass", "icon"]], template: function MailItemComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef(_c1$k);
        i0.ɵɵelementStart(0, "div")(1, "cpc-checkbox", 0);
        i0.ɵɵlistener("checkedChange", function MailItemComponent_Template_cpc_checkbox_checkedChange_1_listener($event) { return ctx.checkbox.checked = $event; })("changeDetection", function MailItemComponent_Template_cpc_checkbox_changeDetection_1_listener($event) { return ctx.onCheckboxChange($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "span", 1);
        i0.ɵɵprojection(3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 2);
        i0.ɵɵtemplate(5, MailItemComponent_span_5_Template, 1, 0, "span", 3);
        i0.ɵɵelementStart(6, "span", 4);
        i0.ɵɵprojection(7, 1);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(8, "div", 5);
        i0.ɵɵtemplate(9, MailItemComponent_cpc_icon_9_Template, 1, 4, "cpc-icon", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "span", 7);
        i0.ɵɵprojection(11, 2);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵclassMapInterpolate1("cpc-mail-item cpc-mail-item--variant-", ctx.variant, "");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("checked", ctx.checkbox.checked)("value", ctx.checkbox.value)("id", ctx.checkbox.id);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.variant === "unread");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c2$5, ctx.variant === "read"));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.attachment);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c3$2, ctx.variant === "read"));
    } }, dependencies: [i1.NgClass, i1.NgIf, IconComponent, CheckboxComponent], styles: [".cpc-mail-item-wrapper{display:flex;border:var(--cpc-border);border-width:1px 1px 0px 1px}.cpc-mail-item-wrapper:first-child{border-top-left-radius:4px;border-top-right-radius:4px}.cpc-mail-item-wrapper:last-child{border-bottom:1px solid var(--cpc-colors-border);border-bottom-right-radius:4px;border-bottom-left-radius:4px}.cpc-mail-item{display:inline-grid;grid-template-areas:\"checkbox name name name name name attachment date date\" \"checkbox title title title title title title title title\";grid-template-columns:max-content;align-content:center;align-items:center;justify-items:center;width:100%;min-height:89px;cursor:pointer;transition:all 125ms linear}@media screen and (min-width: 704px){.cpc-mail-item{grid-template-areas:unset;grid-template-columns:1fr 3.5fr 6fr .5fr 2fr}.cpc-mail-item .control-checkbox,.cpc-mail-item .cpc-mail-item-name,.cpc-mail-item .cpc-mail-item-attachment,.cpc-mail-item .cpc-mail-item-date,.cpc-mail-item .cpc-mail-item-title-wrapper{grid-area:unset!important}.cpc-mail-item .cpc-mail-item-title-dot{position:absolute;margin-left:-12px}}.cpc-mail-item>div{display:flex}.cpc-mail-item:focus,.cpc-mail-item.pseudo-states--focus{outline:0;box-shadow:var(--focus-box-shadow, 0 0 0 2px #fff, 0 0 0 6px #009de6)}.cpc-mail-item:active,.cpc-mail-item.pseudo-states--active{background-color:var(--cpc-colors-light-blue-2)}.cpc-mail-item:hover,.cpc-mail-item.pseudo-states--hover{background-color:var(--cpc-colors-white-smoke)}.cpc-mail-item:hover:not(:disabled):not(:active),.cpc-mail-item.pseudo-states--hover{background-color:var(--cpc-colors-white-smoke)}.cpc-mail-item .cpc-mail-item-name{display:flex;grid-area:name;justify-self:flex-start;width:100%;padding-right:50px;overflow:hidden;line-height:24px}.cpc-mail-item .cpc-mail-item-name *{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.cpc-mail-item .cpc-mail-item-title-wrapper{display:flex;grid-area:title;align-items:center;justify-self:flex-start}.cpc-mail-item .cpc-mail-item-title-dot{display:inline-block;width:6px;height:6px;margin-right:8px;padding-right:6px;background-color:var(--button-primary-background-color);border-radius:50%}.cpc-mail-item .cpc-mail-item-title-spacer{margin-right:8px}.cpc-mail-item .cpc-mail-item-title{display:-webkit-box;overflow:hidden;line-height:20px;-webkit-line-clamp:2;-webkit-box-orient:vertical;text-overflow:ellipsis}.cpc-mail-item .cpc-mail-item-attachment{grid-area:attachment;justify-self:flex-end}.cpc-mail-item .cpc-mail-item-date{grid-area:date;font-weight:400;font-size:14px;line-height:24px}.cpc-mail-item .cpc-mail-item-date--variant-read,.cpc-mail-item .cpc-mail-item-attachment--variant-read{color:var(--cpc-colors-dark-gray)}.cpc-mail-item .cpc-icon{transform:rotate(270deg);--icon-size: 24px}.cpc-mail-item .cpc-icon--variant-unread{color:var(--cpc-colors-resolution-blue)}.cpc-mail-item--variant-unread{font-weight:700}.cpc-mail-item_control{position:relative;display:flex;grid-area:checkbox;justify-self:baseline;width:24px;height:24px;margin:0 15px;cursor:pointer}@media screen and (min-width: 704px){.cpc-mail-item_control{grid-area:unset;margin:0 20px}}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MailItemComponent, [{
        type: Component,
        args: [{ selector: 'cpc-mail-item', encapsulation: ViewEncapsulation.None, template: "<div class=\"cpc-mail-item cpc-mail-item--variant-{{variant}}\">\r\n  <cpc-checkbox\r\n    [(checked)]=\"checkbox.checked\"\r\n    [value]=\"checkbox.value\"\r\n    [id]=\"checkbox.id\"\r\n    (changeDetection)=\"onCheckboxChange($event)\"\r\n    class=\"cpc-mail-item_control\"></cpc-checkbox>\r\n  <span class=\"cpc-mail-item-name\">\r\n    <ng-content select=\"[name]\"></ng-content>\r\n  </span>\r\n  <div class=\"cpc-mail-item-title-wrapper\">\r\n    <span\r\n      *ngIf=\"variant === 'unread'\"\r\n      class=\"cpc-mail-item-title-dot\">\r\n    </span>\r\n    <span class=\"cpc-mail-item-title\">\r\n      <ng-content select=\"[title]\"></ng-content>\r\n    </span>\r\n  </div>\r\n  <div\r\n    [ngClass]=\"{'cpc-mail-item-attachment--variant-read': variant === 'read'}\"\r\n    class=\"cpc-mail-item-attachment\"\r\n  >\r\n    <cpc-icon\r\n      *ngIf=\"attachment\"\r\n      [ngClass]=\"{'cpc-icon--variant-unread' : variant === 'unread'}\"\r\n      [icon]=\"ndbxIcons.Paperclip\"\r\n    ></cpc-icon>\r\n  </div>\r\n  <span\r\n    [ngClass]=\"{'cpc-mail-item-date--variant-read' : variant === 'read'}\"\r\n    class=\"cpc-mail-item-date\"\r\n  >\r\n    <ng-content select=\"[date]\"></ng-content>\r\n  </span>\r\n</div>\r\n", styles: [".cpc-mail-item-wrapper{display:flex;border:var(--cpc-border);border-width:1px 1px 0px 1px}.cpc-mail-item-wrapper:first-child{border-top-left-radius:4px;border-top-right-radius:4px}.cpc-mail-item-wrapper:last-child{border-bottom:1px solid var(--cpc-colors-border);border-bottom-right-radius:4px;border-bottom-left-radius:4px}.cpc-mail-item{display:inline-grid;grid-template-areas:\"checkbox name name name name name attachment date date\" \"checkbox title title title title title title title title\";grid-template-columns:max-content;align-content:center;align-items:center;justify-items:center;width:100%;min-height:89px;cursor:pointer;transition:all 125ms linear}@media screen and (min-width: 704px){.cpc-mail-item{grid-template-areas:unset;grid-template-columns:1fr 3.5fr 6fr .5fr 2fr}.cpc-mail-item .control-checkbox,.cpc-mail-item .cpc-mail-item-name,.cpc-mail-item .cpc-mail-item-attachment,.cpc-mail-item .cpc-mail-item-date,.cpc-mail-item .cpc-mail-item-title-wrapper{grid-area:unset!important}.cpc-mail-item .cpc-mail-item-title-dot{position:absolute;margin-left:-12px}}.cpc-mail-item>div{display:flex}.cpc-mail-item:focus,.cpc-mail-item.pseudo-states--focus{outline:0;box-shadow:var(--focus-box-shadow, 0 0 0 2px #fff, 0 0 0 6px #009de6)}.cpc-mail-item:active,.cpc-mail-item.pseudo-states--active{background-color:var(--cpc-colors-light-blue-2)}.cpc-mail-item:hover,.cpc-mail-item.pseudo-states--hover{background-color:var(--cpc-colors-white-smoke)}.cpc-mail-item:hover:not(:disabled):not(:active),.cpc-mail-item.pseudo-states--hover{background-color:var(--cpc-colors-white-smoke)}.cpc-mail-item .cpc-mail-item-name{display:flex;grid-area:name;justify-self:flex-start;width:100%;padding-right:50px;overflow:hidden;line-height:24px}.cpc-mail-item .cpc-mail-item-name *{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.cpc-mail-item .cpc-mail-item-title-wrapper{display:flex;grid-area:title;align-items:center;justify-self:flex-start}.cpc-mail-item .cpc-mail-item-title-dot{display:inline-block;width:6px;height:6px;margin-right:8px;padding-right:6px;background-color:var(--button-primary-background-color);border-radius:50%}.cpc-mail-item .cpc-mail-item-title-spacer{margin-right:8px}.cpc-mail-item .cpc-mail-item-title{display:-webkit-box;overflow:hidden;line-height:20px;-webkit-line-clamp:2;-webkit-box-orient:vertical;text-overflow:ellipsis}.cpc-mail-item .cpc-mail-item-attachment{grid-area:attachment;justify-self:flex-end}.cpc-mail-item .cpc-mail-item-date{grid-area:date;font-weight:400;font-size:14px;line-height:24px}.cpc-mail-item .cpc-mail-item-date--variant-read,.cpc-mail-item .cpc-mail-item-attachment--variant-read{color:var(--cpc-colors-dark-gray)}.cpc-mail-item .cpc-icon{transform:rotate(270deg);--icon-size: 24px}.cpc-mail-item .cpc-icon--variant-unread{color:var(--cpc-colors-resolution-blue)}.cpc-mail-item--variant-unread{font-weight:700}.cpc-mail-item_control{position:relative;display:flex;grid-area:checkbox;justify-self:baseline;width:24px;height:24px;margin:0 15px;cursor:pointer}@media screen and (min-width: 704px){.cpc-mail-item_control{grid-area:unset;margin:0 20px}}\n"] }]
    }], null, { variant: [{
            type: Input
        }], attachment: [{
            type: Input
        }], checkbox: [{
            type: Input
        }], changeDetection: [{
            type: Output
        }] }); })();

const _c0$B = ["*"];
class MailListComponent {
}
MailListComponent.ɵfac = function MailListComponent_Factory(t) { return new (t || MailListComponent)(); };
MailListComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MailListComponent, selectors: [["cpc-mail-list"]], ngContentSelectors: _c0$B, decls: 2, vars: 0, consts: [[1, "cpc-mail-list"]], template: function MailListComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵprojection(1);
        i0.ɵɵelementEnd();
    } }, encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MailListComponent, [{
        type: Component,
        args: [{ selector: 'cpc-mail-list', encapsulation: ViewEncapsulation.None, template: "<div class=\"cpc-mail-list\">\r\n  <ng-content></ng-content>\r\n</div>\r\n" }]
    }], null, null); })();

const _c0$A = ["*"];
class MenuComponent {
    ngOnChanges() {
        this.mediaQuery = setMatchMedia(Breakpoints.large);
    }
}
MenuComponent.ɵfac = function MenuComponent_Factory(t) { return new (t || MenuComponent)(); };
MenuComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MenuComponent, selectors: [["cpc-menu"]], features: [i0.ɵɵNgOnChangesFeature], ngContentSelectors: _c0$A, decls: 3, vars: 2, consts: [[1, "cpc-menu"], [1, "cpc-menu-list"]], template: function MenuComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "nav", 0)(1, "ul", 1);
        i0.ɵɵprojection(2);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("@cpcSlideAnimation", undefined)("@.disabled", ctx.mediaQuery && ctx.mediaQuery.matches);
    } }, styles: ["@media screen and (min-width: 992px){cpc-menu{display:flex;align-items:center;height:100%;max-height:48px}}.cpc-menu{position:absolute;top:68px;left:0;z-index:990;width:100%;background:var(--cpc-colors-white)}@media screen and (min-width: 992px){.cpc-menu{position:unset;top:unset;left:unset;display:flex;justify-content:center;width:-moz-fit-content;width:fit-content}}.cpc-menu-list{margin:0;padding:0}@media screen and (min-width: 992px){.cpc-menu-list{display:inline-flex}}\n"], encapsulation: 2, data: { animation: [animationBuilder(AngularAnimationsTypes.SLIDE, 700)] } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MenuComponent, [{
        type: Component,
        args: [{ selector: 'cpc-menu', animations: [animationBuilder(AngularAnimationsTypes.SLIDE, 700)], encapsulation: ViewEncapsulation.None, template: "<nav class=\"cpc-menu\">\r\n  <ul \r\n    [@cpcSlideAnimation]\r\n    [@.disabled]=\"mediaQuery && mediaQuery.matches\"\r\n    class=\"cpc-menu-list\"\r\n  >\r\n    <ng-content></ng-content>\r\n  </ul>\r\n</nav>\r\n", styles: ["@media screen and (min-width: 992px){cpc-menu{display:flex;align-items:center;height:100%;max-height:48px}}.cpc-menu{position:absolute;top:68px;left:0;z-index:990;width:100%;background:var(--cpc-colors-white)}@media screen and (min-width: 992px){.cpc-menu{position:unset;top:unset;left:unset;display:flex;justify-content:center;width:-moz-fit-content;width:fit-content}}.cpc-menu-list{margin:0;padding:0}@media screen and (min-width: 992px){.cpc-menu-list{display:inline-flex}}\n"] }]
    }], null, null); })();

const _c0$z = ["*"];
class MenuItemComponent {
}
MenuItemComponent.ɵfac = function MenuItemComponent_Factory(t) { return new (t || MenuItemComponent)(); };
MenuItemComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MenuItemComponent, selectors: [["cpc-menu-item"]], ngContentSelectors: _c0$z, decls: 1, vars: 0, template: function MenuItemComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
    } }, styles: ["cpc-menu-item{position:relative;display:flex}@media screen and (min-width: 992px){cpc-menu-item{align-items:center}}.cpc-dropdown-drawer-wrapper{background:var(--cpc-colors-white-smoke)}@media screen and (min-width: 992px){.cpc-dropdown-drawer-wrapper{position:absolute!important;background:unset}}.cpc-menu-list-item{display:flex;flex-direction:column;justify-content:center;width:100%;min-height:72px;color:var(--adc-colors-charcoal);line-height:24px;white-space:nowrap;list-style:none;border-bottom:1px solid var(--cpc-colors-border);cursor:pointer;-webkit-user-select:none;user-select:none}.cpc-menu-list-item--selected{color:var(--cpc-colors-white);background-color:var(--cpc-colors-dark-cerulian)}.cpc-menu-list-item:not(cpc-user-profile-dropdown){transition:all 125ms linear}.cpc-menu-list-item:not(cpc-user-profile-dropdown):focus,.cpc-menu-list-item:not(cpc-user-profile-dropdown).pseudo-states--focus{outline:0;box-shadow:var(--focus-box-shadow, 0 0 0 2px #fff, 0 0 0 6px #009de6)}.cpc-menu-list-item:not(cpc-user-profile-dropdown):active,.cpc-menu-list-item:not(cpc-user-profile-dropdown).pseudo-states--active{color:var(--cpc-colors-white);background-color:var(--cpc-colors-dark-cerulian)}.cpc-menu-list-item .cpc-menu-list-item_icon{font-size:24px;transition:transform .2s ease-out}.cpc-menu-list-item .cpc-menu-list-item_icon--active{transform:rotate(180deg)}.cpc-menu-list-item--active{color:var(--cpc-colors-resolution-blue)}.cpc-menu-list-item .cpc-menu-list-item_text{display:flex;align-items:center;justify-content:space-between;width:100%;padding:0 24px}@media screen and (min-width: 992px){.cpc-menu-list-item .cpc-menu-list-item_text{padding:0}}@media screen and (min-width: 992px){.cpc-menu-list-item{display:inline-block;width:-moz-fit-content;width:fit-content;height:unset;min-height:unset;margin:0 16px -4px;padding:0;border-bottom:4px solid transparent;outline:none}.cpc-menu-list-item:after{display:block;height:0;overflow:hidden;font-weight:700;visibility:hidden;content:attr(title)}.cpc-menu-list-item--selected{padding-bottom:0;color:var(--button-secondary-text-color);font-weight:700;text-decoration:none;background-color:unset;border-bottom:4px solid var(--button-secondary-border-color)}.cpc-menu-list-item:hover,.cpc-menu-list-item:active,.cpc-menu-list-item--active{padding-bottom:0;color:var(--button-secondary-text-color);text-decoration:none;text-shadow:.5px 0px .1px,-.5px 0px .1px;background-color:unset;border-bottom:4px solid var(--button-secondary-border-color)}.cpc-menu-list-item .cpc-menu-list-item_icon{justify-content:flex-end;margin-right:8px;font-size:unset}}@media screen and (min-width: 992px) and (min-width: 992px){.cpc-menu-list-item .cpc-menu-list-item_icon{margin-right:0;margin-left:8px}}.cpc-menu-list-item .cpc-language-switch{flex-direction:column;margin:0!important}.cpc-menu-list-item .cpc-language-switch .cpc-language-switch-dropdown{width:100%;height:72px;padding:0 24px}.cpc-menu-list-item .cpc-language-switch .cpc-language-switch-languages-list{padding:24px 30px;color:var(--cpc-colors-charcoal);border-bottom:unset}.cpc-menu-list-item .cpc-language-switch .cpc-language-switch-icon-check{margin-left:-28px;font-size:16px}.cpc-menu-list-item .cpc-dropdown-drawer-wrapper{border-top:1px solid var(--cpc-colors-border)}@media screen and (min-width: 992px){.cpc-menu-list-item .cpc-dropdown-drawer-wrapper{border-top:unset}}.cpc-menu-list-item_icon-highlighted{color:var(--cpc-colors-resolution-blue);font-weight:700}cpc-user-profile-dropdown{padding:0 24px}.cpc-user-profile-dropdown{padding:0}@media screen and (min-width: 992px){.cpc-user-profile-dropdown{padding:8px 16px}}.cpc-menu-list-item_sub-menu{flex-direction:column}cpc-dropdown-drawer{width:100%}cpc-dropdown-drawer .cpc-menu-list-item{padding:0 24px}@media screen and (min-width: 992px){cpc-dropdown-drawer{width:unset}}@media screen and (min-width: 992px){.cpc-dropdown-drawer .cpc-menu-list-item{border:0}.cpc-dropdown-drawer .cpc-menu-list-item:hover,.cpc-dropdown-drawer .cpc-menu-list-item.pseudo-states--hover{font-weight:400;border:0}.cpc-dropdown-drawer .cpc-menu-list-item:hover:not(:disabled):not(:active),.cpc-dropdown-drawer .cpc-menu-list-item.pseudo-states--hover{font-weight:400;border:0}.cpc-dropdown-drawer .cpc-menu-list-item:active,.cpc-dropdown-drawer .cpc-menu-list-item.pseudo-states--active{font-weight:400;border:0}}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MenuItemComponent, [{
        type: Component,
        args: [{ selector: 'cpc-menu-item', encapsulation: ViewEncapsulation.None, template: "<ng-content></ng-content>\r\n", styles: ["cpc-menu-item{position:relative;display:flex}@media screen and (min-width: 992px){cpc-menu-item{align-items:center}}.cpc-dropdown-drawer-wrapper{background:var(--cpc-colors-white-smoke)}@media screen and (min-width: 992px){.cpc-dropdown-drawer-wrapper{position:absolute!important;background:unset}}.cpc-menu-list-item{display:flex;flex-direction:column;justify-content:center;width:100%;min-height:72px;color:var(--adc-colors-charcoal);line-height:24px;white-space:nowrap;list-style:none;border-bottom:1px solid var(--cpc-colors-border);cursor:pointer;-webkit-user-select:none;user-select:none}.cpc-menu-list-item--selected{color:var(--cpc-colors-white);background-color:var(--cpc-colors-dark-cerulian)}.cpc-menu-list-item:not(cpc-user-profile-dropdown){transition:all 125ms linear}.cpc-menu-list-item:not(cpc-user-profile-dropdown):focus,.cpc-menu-list-item:not(cpc-user-profile-dropdown).pseudo-states--focus{outline:0;box-shadow:var(--focus-box-shadow, 0 0 0 2px #fff, 0 0 0 6px #009de6)}.cpc-menu-list-item:not(cpc-user-profile-dropdown):active,.cpc-menu-list-item:not(cpc-user-profile-dropdown).pseudo-states--active{color:var(--cpc-colors-white);background-color:var(--cpc-colors-dark-cerulian)}.cpc-menu-list-item .cpc-menu-list-item_icon{font-size:24px;transition:transform .2s ease-out}.cpc-menu-list-item .cpc-menu-list-item_icon--active{transform:rotate(180deg)}.cpc-menu-list-item--active{color:var(--cpc-colors-resolution-blue)}.cpc-menu-list-item .cpc-menu-list-item_text{display:flex;align-items:center;justify-content:space-between;width:100%;padding:0 24px}@media screen and (min-width: 992px){.cpc-menu-list-item .cpc-menu-list-item_text{padding:0}}@media screen and (min-width: 992px){.cpc-menu-list-item{display:inline-block;width:-moz-fit-content;width:fit-content;height:unset;min-height:unset;margin:0 16px -4px;padding:0;border-bottom:4px solid transparent;outline:none}.cpc-menu-list-item:after{display:block;height:0;overflow:hidden;font-weight:700;visibility:hidden;content:attr(title)}.cpc-menu-list-item--selected{padding-bottom:0;color:var(--button-secondary-text-color);font-weight:700;text-decoration:none;background-color:unset;border-bottom:4px solid var(--button-secondary-border-color)}.cpc-menu-list-item:hover,.cpc-menu-list-item:active,.cpc-menu-list-item--active{padding-bottom:0;color:var(--button-secondary-text-color);text-decoration:none;text-shadow:.5px 0px .1px,-.5px 0px .1px;background-color:unset;border-bottom:4px solid var(--button-secondary-border-color)}.cpc-menu-list-item .cpc-menu-list-item_icon{justify-content:flex-end;margin-right:8px;font-size:unset}}@media screen and (min-width: 992px) and (min-width: 992px){.cpc-menu-list-item .cpc-menu-list-item_icon{margin-right:0;margin-left:8px}}.cpc-menu-list-item .cpc-language-switch{flex-direction:column;margin:0!important}.cpc-menu-list-item .cpc-language-switch .cpc-language-switch-dropdown{width:100%;height:72px;padding:0 24px}.cpc-menu-list-item .cpc-language-switch .cpc-language-switch-languages-list{padding:24px 30px;color:var(--cpc-colors-charcoal);border-bottom:unset}.cpc-menu-list-item .cpc-language-switch .cpc-language-switch-icon-check{margin-left:-28px;font-size:16px}.cpc-menu-list-item .cpc-dropdown-drawer-wrapper{border-top:1px solid var(--cpc-colors-border)}@media screen and (min-width: 992px){.cpc-menu-list-item .cpc-dropdown-drawer-wrapper{border-top:unset}}.cpc-menu-list-item_icon-highlighted{color:var(--cpc-colors-resolution-blue);font-weight:700}cpc-user-profile-dropdown{padding:0 24px}.cpc-user-profile-dropdown{padding:0}@media screen and (min-width: 992px){.cpc-user-profile-dropdown{padding:8px 16px}}.cpc-menu-list-item_sub-menu{flex-direction:column}cpc-dropdown-drawer{width:100%}cpc-dropdown-drawer .cpc-menu-list-item{padding:0 24px}@media screen and (min-width: 992px){cpc-dropdown-drawer{width:unset}}@media screen and (min-width: 992px){.cpc-dropdown-drawer .cpc-menu-list-item{border:0}.cpc-dropdown-drawer .cpc-menu-list-item:hover,.cpc-dropdown-drawer .cpc-menu-list-item.pseudo-states--hover{font-weight:400;border:0}.cpc-dropdown-drawer .cpc-menu-list-item:hover:not(:disabled):not(:active),.cpc-dropdown-drawer .cpc-menu-list-item.pseudo-states--hover{font-weight:400;border:0}.cpc-dropdown-drawer .cpc-menu-list-item:active,.cpc-dropdown-drawer .cpc-menu-list-item.pseudo-states--active{font-weight:400;border:0}}\n"] }]
    }], null, null); })();

class MessagePreviewAttachmentComponent {
    constructor() {
        this.download = 'Download';
        this.clickDownload = new EventEmitter();
        this.ndbxIcons = NdbxIcon;
    }
    ngOnChanges() {
        this.updateFileValues();
    }
    updateFileValues() {
        const fileArray = this.name.split('.');
        if (fileArray.length <= 1) {
            this.fileName = this.name;
            return;
        }
        const fileName = [...fileArray];
        fileName.pop();
        this.fileName = fileName.join('.');
    }
}
MessagePreviewAttachmentComponent.ɵfac = function MessagePreviewAttachmentComponent_Factory(t) { return new (t || MessagePreviewAttachmentComponent)(); };
MessagePreviewAttachmentComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MessagePreviewAttachmentComponent, selectors: [["cpc-message-preview-attachment"]], inputs: { name: "name", download: "download" }, outputs: { clickDownload: "clickDownload" }, features: [i0.ɵɵNgOnChangesFeature], decls: 9, vars: 4, consts: [[1, "cpc-message-preview-attachment"], [1, "cpc-message-preview-attachment_name-wrapper", "cpc-message-preview-attachment-truncate"], [1, "cpc-message-preview-attachment_icon", 3, "icon"], [1, "cpc-message-preview-attachment_name", "cpc-message-preview-attachment-text", "cpc-message-preview-attachment-truncate"], [1, "cpc-message-preview-attachment_download", 3, "click"], [1, "cpc-message-preview-attachment-download_text"]], template: function MessagePreviewAttachmentComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵelement(2, "cpc-icon", 2);
        i0.ɵɵelementStart(3, "p", 3);
        i0.ɵɵtext(4);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(5, "button", 4);
        i0.ɵɵlistener("click", function MessagePreviewAttachmentComponent_Template_button_click_5_listener() { return ctx.clickDownload.emit(ctx.name); });
        i0.ɵɵelement(6, "cpc-icon", 2);
        i0.ɵɵelementStart(7, "span", 5);
        i0.ɵɵtext(8);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("icon", ctx.ndbxIcons.FileText);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.fileName, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("icon", ctx.ndbxIcons.Download);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.download);
    } }, dependencies: [IconComponent], styles: [".cpc-message-preview-attachment{display:flex;align-items:center;justify-content:space-between;width:100%;padding:16px 0;color:var(--cpc-colors-charcoal);border-bottom:1px solid var(--cpc-colors-light-gray)}.cpc-message-preview-attachment .cpc-message-preview-attachment-truncate{overflow:hidden;text-overflow:ellipsis}.cpc-message-preview-attachment .cpc-message-preview-attachment_name-wrapper{display:flex}.cpc-message-preview-attachment .cpc-message-preview-attachment-text{font-size:var(--file-list-font-size);line-height:var(--file-list-line-height);white-space:nowrap;-webkit-user-select:none;user-select:none}.cpc-message-preview-attachment .cpc-message-preview-attachment_icon{color:var(--cpc-colors-resolution-blue);font-size:24px}.cpc-message-preview-attachment .cpc-message-preview-attachment_download{background:transparent;border:none;border-radius:0;cursor:pointer;-webkit-appearance:none;appearance:none;transition:all 125ms linear;display:flex;align-items:center;justify-content:center;margin-right:0;color:var(--cpc-colors-resolution-blue);font-weight:600;line-height:24px}.cpc-message-preview-attachment .cpc-message-preview-attachment_download:focus,.cpc-message-preview-attachment .cpc-message-preview-attachment_download.pseudo-states--focus{outline:0;box-shadow:var(--focus-box-shadow, 0 0 0 2px #fff, 0 0 0 6px #009de6)}.cpc-message-preview-attachment .cpc-message-preview-attachment_download:disabled,.cpc-message-preview-attachment .cpc-message-preview-attachment_download.pseudo-states--disabled{cursor:not-allowed;pointer-events:none}.cpc-message-preview-attachment .cpc-message-preview-attachment_download:disabled,.cpc-message-preview-attachment .cpc-message-preview-attachment_download.cpc--disabled,.cpc-message-preview-attachment .cpc-message-preview-attachment_download.pseudo-states--disabled{cursor:not-allowed;pointer-events:none}@media screen and (min-width: 704px){.cpc-message-preview-attachment .cpc-message-preview-attachment_download{margin-right:8px}}.cpc-message-preview-attachment .cpc-message-preview-attachment_download .cpc-message-preview-attachment_icon{margin-right:0}@media screen and (min-width: 704px){.cpc-message-preview-attachment .cpc-message-preview-attachment_download .cpc-message-preview-attachment_icon{margin-right:11px}}.cpc-message-preview-attachment .cpc-message-preview-attachment-download_text{display:none}@media screen and (min-width: 704px){.cpc-message-preview-attachment .cpc-message-preview-attachment-download_text{display:block}}.cpc-message-preview-attachment .cpc-message-preview-attachment_name{margin:0 0 0 26px;line-height:24px}.cpc-message-preview-attachment .cpc-message-preview-attachment_size{margin:0 8px 0 auto}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MessagePreviewAttachmentComponent, [{
        type: Component,
        args: [{ selector: 'cpc-message-preview-attachment', encapsulation: ViewEncapsulation.None, template: "<div class=\"cpc-message-preview-attachment\">\r\n  <div class=\"cpc-message-preview-attachment_name-wrapper cpc-message-preview-attachment-truncate\">\r\n    <cpc-icon class=\"cpc-message-preview-attachment_icon\" [icon]=\"ndbxIcons.FileText\"></cpc-icon>\r\n    <p class=\"cpc-message-preview-attachment_name cpc-message-preview-attachment-text cpc-message-preview-attachment-truncate\">\r\n      {{fileName}}\r\n    </p>\r\n  </div>\r\n  <button class=\"cpc-message-preview-attachment_download\" (click)=\"clickDownload.emit(name)\">\r\n    <cpc-icon class=\"cpc-message-preview-attachment_icon\" [icon]=\"ndbxIcons.Download\"></cpc-icon>\r\n    <span class=\"cpc-message-preview-attachment-download_text\">{{download}}</span>\r\n  </button>\r\n</div>\r\n", styles: [".cpc-message-preview-attachment{display:flex;align-items:center;justify-content:space-between;width:100%;padding:16px 0;color:var(--cpc-colors-charcoal);border-bottom:1px solid var(--cpc-colors-light-gray)}.cpc-message-preview-attachment .cpc-message-preview-attachment-truncate{overflow:hidden;text-overflow:ellipsis}.cpc-message-preview-attachment .cpc-message-preview-attachment_name-wrapper{display:flex}.cpc-message-preview-attachment .cpc-message-preview-attachment-text{font-size:var(--file-list-font-size);line-height:var(--file-list-line-height);white-space:nowrap;-webkit-user-select:none;user-select:none}.cpc-message-preview-attachment .cpc-message-preview-attachment_icon{color:var(--cpc-colors-resolution-blue);font-size:24px}.cpc-message-preview-attachment .cpc-message-preview-attachment_download{background:transparent;border:none;border-radius:0;cursor:pointer;-webkit-appearance:none;appearance:none;transition:all 125ms linear;display:flex;align-items:center;justify-content:center;margin-right:0;color:var(--cpc-colors-resolution-blue);font-weight:600;line-height:24px}.cpc-message-preview-attachment .cpc-message-preview-attachment_download:focus,.cpc-message-preview-attachment .cpc-message-preview-attachment_download.pseudo-states--focus{outline:0;box-shadow:var(--focus-box-shadow, 0 0 0 2px #fff, 0 0 0 6px #009de6)}.cpc-message-preview-attachment .cpc-message-preview-attachment_download:disabled,.cpc-message-preview-attachment .cpc-message-preview-attachment_download.pseudo-states--disabled{cursor:not-allowed;pointer-events:none}.cpc-message-preview-attachment .cpc-message-preview-attachment_download:disabled,.cpc-message-preview-attachment .cpc-message-preview-attachment_download.cpc--disabled,.cpc-message-preview-attachment .cpc-message-preview-attachment_download.pseudo-states--disabled{cursor:not-allowed;pointer-events:none}@media screen and (min-width: 704px){.cpc-message-preview-attachment .cpc-message-preview-attachment_download{margin-right:8px}}.cpc-message-preview-attachment .cpc-message-preview-attachment_download .cpc-message-preview-attachment_icon{margin-right:0}@media screen and (min-width: 704px){.cpc-message-preview-attachment .cpc-message-preview-attachment_download .cpc-message-preview-attachment_icon{margin-right:11px}}.cpc-message-preview-attachment .cpc-message-preview-attachment-download_text{display:none}@media screen and (min-width: 704px){.cpc-message-preview-attachment .cpc-message-preview-attachment-download_text{display:block}}.cpc-message-preview-attachment .cpc-message-preview-attachment_name{margin:0 0 0 26px;line-height:24px}.cpc-message-preview-attachment .cpc-message-preview-attachment_size{margin:0 8px 0 auto}\n"] }]
    }], null, { name: [{
            type: Input
        }], download: [{
            type: Input
        }], clickDownload: [{
            type: Output
        }] }); })();

const _c0$y = function (a0) { return { "cpc-message-preview-attachments-reply": a0 }; };
const _c1$j = ["*"];
class MessagePreviewAttachmentsComponent {
}
MessagePreviewAttachmentsComponent.ɵfac = function MessagePreviewAttachmentsComponent_Factory(t) { return new (t || MessagePreviewAttachmentsComponent)(); };
MessagePreviewAttachmentsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MessagePreviewAttachmentsComponent, selectors: [["cpc-message-preview-attachments"]], inputs: { isInReply: "isInReply" }, ngContentSelectors: _c1$j, decls: 2, vars: 3, consts: [[1, "cpc-message-preview-attachments", 3, "ngClass"]], template: function MessagePreviewAttachmentsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵprojection(1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c0$y, ctx.isInReply));
    } }, dependencies: [i1.NgClass], styles: ["cpc-message-preview-attachments{width:100%}.cpc-message-preview-attachments{margin:32px 16px;border-top:1px solid var(--cpc-colors-light-gray)}@media screen and (min-width: 704px){.cpc-message-preview-attachments{margin:0 32px 32px}}.cpc-message-preview-attachments-reply{display:none}@media screen and (min-width: 704px){.cpc-message-preview-attachments-reply{display:flex}}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MessagePreviewAttachmentsComponent, [{
        type: Component,
        args: [{ selector: 'cpc-message-preview-attachments', encapsulation: ViewEncapsulation.None, template: "<div class=\"cpc-message-preview-attachments\" [ngClass]=\"{ 'cpc-message-preview-attachments-reply': isInReply }\">\r\n  <ng-content></ng-content>\r\n</div>\r\n", styles: ["cpc-message-preview-attachments{width:100%}.cpc-message-preview-attachments{margin:32px 16px;border-top:1px solid var(--cpc-colors-light-gray)}@media screen and (min-width: 704px){.cpc-message-preview-attachments{margin:0 32px 32px}}.cpc-message-preview-attachments-reply{display:none}@media screen and (min-width: 704px){.cpc-message-preview-attachments-reply{display:flex}}\n"] }]
    }], null, { isInReply: [{
            type: Input
        }] }); })();

class SafeHtmlPipe {
    constructor(sanitized) {
        this.sanitized = sanitized;
    }
    transform(value) {
        return this.sanitized.bypassSecurityTrustHtml(value);
    }
}
SafeHtmlPipe.ɵfac = function SafeHtmlPipe_Factory(t) { return new (t || SafeHtmlPipe)(i0.ɵɵdirectiveInject(i1$1.DomSanitizer, 16)); };
SafeHtmlPipe.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "safeHtml", type: SafeHtmlPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SafeHtmlPipe, [{
        type: Pipe,
        args: [{
                name: 'safeHtml',
            }]
    }], function () { return [{ type: i1$1.DomSanitizer }]; }, null); })();

function MessagePreviewContentComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "div", 3);
    i0.ɵɵpipe(2, "safeHtml");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 1, ctx_r0.emailTemplate), i0.ɵɵsanitizeHtml);
} }
function MessagePreviewContentComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵprojection(0);
} }
const _c0$x = function (a0) { return { "cpc-message-preview-content-reply": a0 }; };
const _c1$i = ["*"];
class MessagePreviewContentComponent {
}
MessagePreviewContentComponent.ɵfac = function MessagePreviewContentComponent_Factory(t) { return new (t || MessagePreviewContentComponent)(); };
MessagePreviewContentComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MessagePreviewContentComponent, selectors: [["cpc-message-preview-content"]], inputs: { isInReply: "isInReply", emailTemplate: "emailTemplate" }, ngContentSelectors: _c1$i, decls: 4, vars: 5, consts: [[1, "cpc-message-preview-content", 3, "ngClass"], [4, "ngIf", "ngIfElse"], ["text", ""], [3, "innerHTML"]], template: function MessagePreviewContentComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, MessagePreviewContentComponent_ng_container_1_Template, 3, 3, "ng-container", 1);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(2, MessagePreviewContentComponent_ng_template_2_Template, 1, 0, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(3);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c0$x, ctx.isInReply));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.emailTemplate)("ngIfElse", _r1);
    } }, dependencies: [i1.NgClass, i1.NgIf, SafeHtmlPipe], styles: ["cpc-message-preview-content{width:100%}.cpc-message-preview-content{margin:0 32.5px 32.5px;word-break:break-word}.cpc-message-preview-content-reply{display:none}@media screen and (min-width: 704px){.cpc-message-preview-content-reply{display:flex}}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MessagePreviewContentComponent, [{
        type: Component,
        args: [{ selector: 'cpc-message-preview-content', encapsulation: ViewEncapsulation.None, template: "<div class=\"cpc-message-preview-content\" [ngClass]=\"{ 'cpc-message-preview-content-reply': isInReply }\">\r\n  <ng-container *ngIf=\"emailTemplate;else text\">\r\n    <div [innerHTML]=\"emailTemplate | safeHtml\">\r\n    </div>\r\n  </ng-container>\r\n</div>\r\n\r\n<ng-template #text>\r\n  <ng-content></ng-content>\r\n</ng-template>\r\n", styles: ["cpc-message-preview-content{width:100%}.cpc-message-preview-content{margin:0 32.5px 32.5px;word-break:break-word}.cpc-message-preview-content-reply{display:none}@media screen and (min-width: 704px){.cpc-message-preview-content-reply{display:flex}}\n"] }]
    }], null, { isInReply: [{
            type: Input
        }], emailTemplate: [{
            type: Input
        }] }); })();

function MessagePreviewFooterComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 4)(2, "button", 5);
    i0.ɵɵlistener("click", function MessagePreviewFooterComponent_div_1_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.clickAttachment.emit()); });
    i0.ɵɵelement(3, "cpc-icon", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "button", 7);
    i0.ɵɵlistener("click", function MessagePreviewFooterComponent_div_1_Template_button_click_4_listener() { i0.ɵɵrestoreView(_r3); const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.clickDelete.emit()); });
    i0.ɵɵelement(5, "cpc-icon", 8);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "cpc-button", 9);
    i0.ɵɵlistener("click", function MessagePreviewFooterComponent_div_1_Template_cpc_button_click_6_listener() { i0.ɵɵrestoreView(_r3); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.clickSend.emit()); });
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("icon", ctx_r0.ndbxIcons.Paperclip);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("icon", ctx_r0.ndbxIcons.TrashO);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("block", true)("noVerticalMargin", true)("noHorizontalMargin", true);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.textData.send, " ");
} }
function MessagePreviewFooterComponent_cpc_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cpc-button", 9);
    i0.ɵɵlistener("click", function MessagePreviewFooterComponent_cpc_button_2_Template_cpc_button_click_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.clickReply.emit()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("block", true)("noVerticalMargin", true)("noHorizontalMargin", true);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.textData.reply, " ");
} }
const _c0$w = function (a0) { return { "cpc-message-preview-footer-reply": a0 }; };
class MessagePreviewFooterComponent {
    constructor() {
        this.isInReply = false;
        this.textData = {
            send: 'Send',
            reply: 'Reply',
        };
        this.clickAttachment = new EventEmitter();
        this.clickDelete = new EventEmitter();
        this.clickReply = new EventEmitter();
        this.clickSend = new EventEmitter();
        this.ndbxIcons = NdbxIcon;
    }
}
MessagePreviewFooterComponent.ɵfac = function MessagePreviewFooterComponent_Factory(t) { return new (t || MessagePreviewFooterComponent)(); };
MessagePreviewFooterComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MessagePreviewFooterComponent, selectors: [["cpc-message-preview-footer"]], inputs: { isInReply: "isInReply", textData: "textData" }, outputs: { clickAttachment: "clickAttachment", clickDelete: "clickDelete", clickReply: "clickReply", clickSend: "clickSend" }, decls: 3, vars: 5, consts: [[1, "cpc-message-preview-footer", 3, "ngClass"], ["class", "cpc-message-preview-footer_send", 4, "ngIf"], ["size", "small", "class", "cpc-message-preview-footer-button", 3, "block", "noVerticalMargin", "noHorizontalMargin", "click", 4, "ngIf"], [1, "cpc-message-preview-footer_send"], [1, "cpc-message-preview-footer_send-wrapper"], [1, "cpc-message-preview-button", "cpc-message-preview-button-border", 3, "click"], [3, "icon"], [1, "cpc-message-preview-button", 3, "click"], [1, "cpc-message-preview-icon", 3, "icon"], ["size", "small", 1, "cpc-message-preview-footer-button", 3, "block", "noVerticalMargin", "noHorizontalMargin", "click"]], template: function MessagePreviewFooterComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "footer", 0);
        i0.ɵɵtemplate(1, MessagePreviewFooterComponent_div_1_Template, 8, 6, "div", 1);
        i0.ɵɵtemplate(2, MessagePreviewFooterComponent_cpc_button_2_Template, 2, 4, "cpc-button", 2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c0$w, ctx.isInReply));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isInReply);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isInReply);
    } }, dependencies: [i1.NgClass, i1.NgIf, ButtonComponent, IconComponent], styles: ["cpc-message-preview-footer{position:sticky;bottom:0;width:100%}@media screen and (min-width: 704px){cpc-message-preview-footer{position:unset}}.cpc-message-preview-footer{display:flex;align-items:center;justify-content:flex-end;width:100%;min-height:88px;background-color:var(--cpc-colors-light-blue-2);border-top:1px solid var(--cpc-colors-light-blue)}@media screen and (min-width: 704px){.cpc-message-preview-footer{background:none;border-top:1px solid var(--cpc-colors-light-gray)}}.cpc-message-preview-footer .cpc-message-preview-footer-button{width:100%;margin:0 24px}@media screen and (min-width: 704px){.cpc-message-preview-footer .cpc-message-preview-footer-button{display:block;width:144px;margin-right:32.5px}}.cpc-message-preview-footer .cpc-message-preview-footer_send{display:flex;align-items:center;justify-content:space-between;width:100%;margin-left:32.5px}.cpc-message-preview-footer .cpc-message-preview-footer_send .cpc-message-preview-footer_send-wrapper{display:flex;align-items:center;height:40px}.cpc-message-preview-footer .cpc-message-preview-footer_send .cpc-message-preview-button{display:flex;background:transparent;border:none;border-radius:0;-webkit-appearance:none;appearance:none;transition:all 125ms linear;color:var(--cpc-colors-resolution-blue);font-size:24px;cursor:pointer}.cpc-message-preview-footer .cpc-message-preview-footer_send .cpc-message-preview-button:first-of-type{padding:0 16px 0 0}.cpc-message-preview-footer .cpc-message-preview-footer_send .cpc-message-preview-button:last-of-type{padding:0 0 0 16px}.cpc-message-preview-footer .cpc-message-preview-footer_send .cpc-message-preview-button:focus,.cpc-message-preview-footer .cpc-message-preview-footer_send .cpc-message-preview-button.pseudo-states--focus{outline:0;box-shadow:var(--focus-box-shadow, 0 0 0 2px #fff, 0 0 0 6px #009de6)}.cpc-message-preview-footer .cpc-message-preview-footer_send .cpc-message-preview-button:active,.cpc-message-preview-footer .cpc-message-preview-footer_send .cpc-message-preview-button.pseudo-states--active{color:var(--cpc-colors-dark-cerulian)}.cpc-message-preview-footer .cpc-message-preview-footer_send .cpc-message-preview-button-border{border:var(--cpc-border);border-width:0 1px 0 0}.cpc-message-preview-footer-reply{background:none}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MessagePreviewFooterComponent, [{
        type: Component,
        args: [{ selector: 'cpc-message-preview-footer', encapsulation: ViewEncapsulation.None, template: "<footer [ngClass]=\"{ 'cpc-message-preview-footer-reply': isInReply}\" class=\"cpc-message-preview-footer\">\r\n  <div *ngIf=\"isInReply\" class=\"cpc-message-preview-footer_send\">\r\n    <div class=\"cpc-message-preview-footer_send-wrapper\">\r\n      <button\r\n        (click)=\"clickAttachment.emit()\"\r\n        class=\"cpc-message-preview-button cpc-message-preview-button-border\">\r\n        <cpc-icon [icon]=\"ndbxIcons.Paperclip\"></cpc-icon>\r\n      </button>\r\n      <button\r\n        (click)=\"clickDelete.emit()\"\r\n        class=\"cpc-message-preview-button\">\r\n        <cpc-icon class=\"cpc-message-preview-icon\" [icon]=\"ndbxIcons.TrashO\"></cpc-icon>\r\n      </button>\r\n    </div>\r\n\r\n    <cpc-button\r\n      [block]=\"true\"\r\n      [noVerticalMargin]=\"true\"\r\n      [noHorizontalMargin]=\"true\"\r\n      size=\"small\"\r\n      (click)=\"clickSend.emit()\"\r\n      class=\"cpc-message-preview-footer-button\"\r\n    >\r\n      {{textData.send}}\r\n    </cpc-button>\r\n  </div>\r\n\r\n  <cpc-button\r\n    *ngIf=\"!isInReply\"\r\n    size=\"small\"\r\n    [block]=\"true\"\r\n    [noVerticalMargin]=\"true\"\r\n    [noHorizontalMargin]=\"true\"\r\n    (click)=\"clickReply.emit()\"\r\n    class=\"cpc-message-preview-footer-button\"\r\n  >\r\n    {{textData.reply}}\r\n  </cpc-button>\r\n</footer>\r\n", styles: ["cpc-message-preview-footer{position:sticky;bottom:0;width:100%}@media screen and (min-width: 704px){cpc-message-preview-footer{position:unset}}.cpc-message-preview-footer{display:flex;align-items:center;justify-content:flex-end;width:100%;min-height:88px;background-color:var(--cpc-colors-light-blue-2);border-top:1px solid var(--cpc-colors-light-blue)}@media screen and (min-width: 704px){.cpc-message-preview-footer{background:none;border-top:1px solid var(--cpc-colors-light-gray)}}.cpc-message-preview-footer .cpc-message-preview-footer-button{width:100%;margin:0 24px}@media screen and (min-width: 704px){.cpc-message-preview-footer .cpc-message-preview-footer-button{display:block;width:144px;margin-right:32.5px}}.cpc-message-preview-footer .cpc-message-preview-footer_send{display:flex;align-items:center;justify-content:space-between;width:100%;margin-left:32.5px}.cpc-message-preview-footer .cpc-message-preview-footer_send .cpc-message-preview-footer_send-wrapper{display:flex;align-items:center;height:40px}.cpc-message-preview-footer .cpc-message-preview-footer_send .cpc-message-preview-button{display:flex;background:transparent;border:none;border-radius:0;-webkit-appearance:none;appearance:none;transition:all 125ms linear;color:var(--cpc-colors-resolution-blue);font-size:24px;cursor:pointer}.cpc-message-preview-footer .cpc-message-preview-footer_send .cpc-message-preview-button:first-of-type{padding:0 16px 0 0}.cpc-message-preview-footer .cpc-message-preview-footer_send .cpc-message-preview-button:last-of-type{padding:0 0 0 16px}.cpc-message-preview-footer .cpc-message-preview-footer_send .cpc-message-preview-button:focus,.cpc-message-preview-footer .cpc-message-preview-footer_send .cpc-message-preview-button.pseudo-states--focus{outline:0;box-shadow:var(--focus-box-shadow, 0 0 0 2px #fff, 0 0 0 6px #009de6)}.cpc-message-preview-footer .cpc-message-preview-footer_send .cpc-message-preview-button:active,.cpc-message-preview-footer .cpc-message-preview-footer_send .cpc-message-preview-button.pseudo-states--active{color:var(--cpc-colors-dark-cerulian)}.cpc-message-preview-footer .cpc-message-preview-footer_send .cpc-message-preview-button-border{border:var(--cpc-border);border-width:0 1px 0 0}.cpc-message-preview-footer-reply{background:none}\n"] }]
    }], null, { isInReply: [{
            type: Input
        }], textData: [{
            type: Input
        }], clickAttachment: [{
            type: Output
        }], clickDelete: [{
            type: Output
        }], clickReply: [{
            type: Output
        }], clickSend: [{
            type: Output
        }] }); })();

function MessagePreviewHeaderComponent_cpc_icon_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "cpc-icon", 10);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("icon", ctx_r0.ndbxIcons.Paperclip);
} }
const _c0$v = [[["", "name", ""]], [["", "position", ""]]];
const _c1$h = function (a0) { return { "cpc-message-preview-header-reply": a0 }; };
const _c2$4 = ["[name]", "[position]"];
class MessagePreviewHeaderComponent {
    constructor() {
        this.attachments = false;
        this.dateFormatDesktop = 'dd.MM.YYYY; HH:mm';
        this.dateFormatMobile = 'dd.MM.yyyy';
        this.isInReply = false;
        this.ndbxIcons = NdbxIcon;
    }
}
MessagePreviewHeaderComponent.ɵfac = function MessagePreviewHeaderComponent_Factory(t) { return new (t || MessagePreviewHeaderComponent)(); };
MessagePreviewHeaderComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MessagePreviewHeaderComponent, selectors: [["cpc-message-preview-header"]], inputs: { photo: "photo", attachments: "attachments", date: "date", dateFormatDesktop: "dateFormatDesktop", dateFormatMobile: "dateFormatMobile", isInReply: "isInReply" }, ngContentSelectors: _c2$4, decls: 17, vars: 13, consts: [[1, "cpc-message-preview-header", 3, "ngClass"], [1, "cpc-message-preview_photo"], ["alt", "User logo", 1, "cpc-message-preview_photo_image", 3, "src"], [1, "cpc-message-preview-name-wrapper"], [1, "cpc-message-preview-name"], [1, "cpc-message-preview-position"], [1, "cpc-message-preview-date"], ["class", "cpc-message-preview-icon", 3, "icon", 4, "ngIf"], [1, "cpc-message-preview-date_text"], [1, "cpc-message-preview-date_text-mobile"], [1, "cpc-message-preview-icon", 3, "icon"]], template: function MessagePreviewHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef(_c0$v);
        i0.ɵɵelementStart(0, "div", 0)(1, "div")(2, "div", 1);
        i0.ɵɵelement(3, "img", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 3)(5, "span", 4);
        i0.ɵɵprojection(6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "span", 5);
        i0.ɵɵprojection(8, 1);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(9, "div", 6);
        i0.ɵɵtemplate(10, MessagePreviewHeaderComponent_cpc_icon_10_Template, 1, 1, "cpc-icon", 7);
        i0.ɵɵelementStart(11, "span", 8);
        i0.ɵɵtext(12);
        i0.ɵɵpipe(13, "date");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "span", 9);
        i0.ɵɵtext(15);
        i0.ɵɵpipe(16, "date");
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c1$h, ctx.isInReply));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("src", ctx.photo, i0.ɵɵsanitizeUrl);
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("ngIf", ctx.attachments);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(13, 5, ctx.date, ctx.dateFormatDesktop));
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(16, 8, ctx.date, ctx.dateFormatMobile));
    } }, dependencies: [i1.NgClass, i1.NgIf, IconComponent, i1.DatePipe], styles: ["cpc-message-preview-header{width:100%}.cpc-message-preview-header{display:inline-flex;align-items:center;justify-content:space-between;width:100%;min-height:73px;margin-bottom:8px;padding:0 17px;color:var(--cpc-colors-charcoal);cursor:pointer}.cpc-message-preview-header>div{display:flex;align-items:center}.cpc-message-preview-header .cpc-message-preview-attachment{justify-self:flex-end}.cpc-message-preview-header .cpc-message-preview-date{display:flex;flex-direction:column-reverse;align-items:flex-end}.cpc-message-preview-header .cpc-message-preview-date span{padding-top:7px;font-size:13px;line-height:16px}.cpc-message-preview-header .cpc-message-preview-date .cpc-message-preview-date_text{display:none}@media screen and (min-width: 704px){.cpc-message-preview-header .cpc-message-preview-date{flex-direction:unset;align-items:unset}.cpc-message-preview-header .cpc-message-preview-date span{padding-top:0;font-size:14px;line-height:24px}.cpc-message-preview-header .cpc-message-preview-date .cpc-message-preview-date_text{display:block}.cpc-message-preview-header .cpc-message-preview-date .cpc-message-preview-date_text-mobile{display:none}}.cpc-message-preview-header .cpc-message-preview-icon{margin-right:0;color:var(--cpc-colors-dark-gray);transform:rotate(270deg);--icon-size: 24px}@media screen and (min-width: 704px){.cpc-message-preview-header .cpc-message-preview-icon{margin-right:16px}}@media screen and (min-width: 704px){.cpc-message-preview-header{min-height:81px;padding:0 32px}}.cpc-message-preview-header-reply{display:none}@media screen and (min-width: 704px){.cpc-message-preview-header-reply{display:inline-flex}}.cpc-message-preview_photo{position:relative;display:block;width:40px;height:40px;margin-right:15px;overflow:hidden;border-radius:50%}@media screen and (min-width: 704px){.cpc-message-preview_photo{width:44px;height:44px;margin-right:16px}}.cpc-message-preview_photo>.cpc-message-preview_photo_image{position:absolute;top:50%;left:50%;display:block;width:100%;height:auto;transform:translate(-50%,-50%)}.cpc-message-preview-name-wrapper{display:flex;justify-content:flex-start;align-items:flex-start;flex-direction:column;flex-wrap:inherit}.cpc-message-preview-name-wrapper .cpc-message-preview-name{font-weight:600;font-size:16px;line-height:20px}@media screen and (min-width: 704px){.cpc-message-preview-name-wrapper .cpc-message-preview-name{line-height:24px}}.cpc-message-preview-name-wrapper .cpc-message-preview-position{color:var(--cpc-colors-dark-gray);font-size:12px;line-height:15px}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MessagePreviewHeaderComponent, [{
        type: Component,
        args: [{ selector: 'cpc-message-preview-header', encapsulation: ViewEncapsulation.None, template: "<div\r\n  [ngClass]=\"{ 'cpc-message-preview-header-reply': isInReply}\"\r\n  class=\"cpc-message-preview-header\"\r\n>\r\n  <div>\r\n    <div class=\"cpc-message-preview_photo\">\r\n      <img\r\n        class=\"cpc-message-preview_photo_image\"\r\n        [src]=\"photo\" alt=\"User logo\"\r\n      />\r\n    </div>\r\n    <div class=\"cpc-message-preview-name-wrapper\">\r\n      <span class=\"cpc-message-preview-name\"><ng-content select=\"[name]\"></ng-content></span>\r\n      <span class=\"cpc-message-preview-position\"><ng-content select=\"[position]\"></ng-content></span>\r\n    </div>\r\n  </div>\r\n  <div class=\"cpc-message-preview-date\">\r\n    <cpc-icon *ngIf=\"attachments\" [icon]=\"ndbxIcons.Paperclip\" class=\"cpc-message-preview-icon\"></cpc-icon>\r\n    <span class=\"cpc-message-preview-date_text\">{{date | date: dateFormatDesktop}}</span>\r\n    <span class=\"cpc-message-preview-date_text-mobile\">{{date | date: dateFormatMobile}}</span>\r\n  </div>\r\n</div>\r\n", styles: ["cpc-message-preview-header{width:100%}.cpc-message-preview-header{display:inline-flex;align-items:center;justify-content:space-between;width:100%;min-height:73px;margin-bottom:8px;padding:0 17px;color:var(--cpc-colors-charcoal);cursor:pointer}.cpc-message-preview-header>div{display:flex;align-items:center}.cpc-message-preview-header .cpc-message-preview-attachment{justify-self:flex-end}.cpc-message-preview-header .cpc-message-preview-date{display:flex;flex-direction:column-reverse;align-items:flex-end}.cpc-message-preview-header .cpc-message-preview-date span{padding-top:7px;font-size:13px;line-height:16px}.cpc-message-preview-header .cpc-message-preview-date .cpc-message-preview-date_text{display:none}@media screen and (min-width: 704px){.cpc-message-preview-header .cpc-message-preview-date{flex-direction:unset;align-items:unset}.cpc-message-preview-header .cpc-message-preview-date span{padding-top:0;font-size:14px;line-height:24px}.cpc-message-preview-header .cpc-message-preview-date .cpc-message-preview-date_text{display:block}.cpc-message-preview-header .cpc-message-preview-date .cpc-message-preview-date_text-mobile{display:none}}.cpc-message-preview-header .cpc-message-preview-icon{margin-right:0;color:var(--cpc-colors-dark-gray);transform:rotate(270deg);--icon-size: 24px}@media screen and (min-width: 704px){.cpc-message-preview-header .cpc-message-preview-icon{margin-right:16px}}@media screen and (min-width: 704px){.cpc-message-preview-header{min-height:81px;padding:0 32px}}.cpc-message-preview-header-reply{display:none}@media screen and (min-width: 704px){.cpc-message-preview-header-reply{display:inline-flex}}.cpc-message-preview_photo{position:relative;display:block;width:40px;height:40px;margin-right:15px;overflow:hidden;border-radius:50%}@media screen and (min-width: 704px){.cpc-message-preview_photo{width:44px;height:44px;margin-right:16px}}.cpc-message-preview_photo>.cpc-message-preview_photo_image{position:absolute;top:50%;left:50%;display:block;width:100%;height:auto;transform:translate(-50%,-50%)}.cpc-message-preview-name-wrapper{display:flex;justify-content:flex-start;align-items:flex-start;flex-direction:column;flex-wrap:inherit}.cpc-message-preview-name-wrapper .cpc-message-preview-name{font-weight:600;font-size:16px;line-height:20px}@media screen and (min-width: 704px){.cpc-message-preview-name-wrapper .cpc-message-preview-name{line-height:24px}}.cpc-message-preview-name-wrapper .cpc-message-preview-position{color:var(--cpc-colors-dark-gray);font-size:12px;line-height:15px}\n"] }]
    }], null, { photo: [{
            type: Input
        }], attachments: [{
            type: Input
        }], date: [{
            type: Input
        }], dateFormatDesktop: [{
            type: Input
        }], dateFormatMobile: [{
            type: Input
        }], isInReply: [{
            type: Input
        }] }); })();

function MessagePreviewItemComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵprojection(1, 3);
    i0.ɵɵprojection(2, 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("@cpcSlideAnimation", undefined);
} }
const _c0$u = [[["", "header", ""]], [["", "textarea", ""]], [["", "footer", ""]], [["", "content", ""]], [["", "attachments", ""]]];
const _c1$g = ["[header]", "[textarea]", "[footer]", "[content]", "[attachments]"];
class MessagePreviewItemComponent {
    constructor() {
        this.isDrawerOpen = false;
    }
    handleOpen() {
        this.isDrawerOpen = !this.isDrawerOpen;
    }
}
MessagePreviewItemComponent.ɵfac = function MessagePreviewItemComponent_Factory(t) { return new (t || MessagePreviewItemComponent)(); };
MessagePreviewItemComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MessagePreviewItemComponent, selectors: [["cpc-message-preview-item"]], inputs: { isDrawerOpen: "isDrawerOpen" }, ngContentSelectors: _c1$g, decls: 6, vars: 1, consts: [[1, "cpc-message-preview-item"], [2, "width", "100%", 3, "click"], ["class", "cpc-message-preview-data", 4, "ngIf"], [1, "cpc-message-preview-data"]], template: function MessagePreviewItemComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef(_c0$u);
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵlistener("click", function MessagePreviewItemComponent_Template_div_click_1_listener() { return ctx.handleOpen(); });
        i0.ɵɵprojection(2);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(3, MessagePreviewItemComponent_div_3_Template, 3, 1, "div", 2);
        i0.ɵɵprojection(4, 1);
        i0.ɵɵprojection(5, 2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.isDrawerOpen);
    } }, dependencies: [i1.NgIf], styles: ["cpc-message-preview-item{border-bottom:1px solid var(--cpc-colors-light-gray)}cpc-message-preview-item:last-of-type{border-bottom:unset}.cpc-message-preview-item{display:flex;flex-direction:column}\n"], encapsulation: 2, data: { animation: [animationBuilder(AngularAnimationsTypes.SLIDE, 300, 200)] } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MessagePreviewItemComponent, [{
        type: Component,
        args: [{ selector: 'cpc-message-preview-item', animations: [animationBuilder(AngularAnimationsTypes.SLIDE, 300, 200)], encapsulation: ViewEncapsulation.None, template: "<div class=\"cpc-message-preview-item\">\r\n  <div style=\"width: 100%\" (click)=\"handleOpen()\">\r\n    <ng-content select=\"[header]\"></ng-content>\r\n  </div>\r\n  <div *ngIf=\"isDrawerOpen\"\r\n       [@cpcSlideAnimation]\r\n       class=\"cpc-message-preview-data\" >\r\n    <ng-content select=\"[content]\"></ng-content>\r\n    <ng-content select=\"[attachments]\"></ng-content>\r\n  </div>\r\n  <ng-content select=\"[textarea]\"></ng-content>\r\n  <ng-content select=\"[footer]\"></ng-content>\r\n</div>\r\n", styles: ["cpc-message-preview-item{border-bottom:1px solid var(--cpc-colors-light-gray)}cpc-message-preview-item:last-of-type{border-bottom:unset}.cpc-message-preview-item{display:flex;flex-direction:column}\n"] }]
    }], null, { isDrawerOpen: [{
            type: Input
        }] }); })();

function MessagePreviewTextareaComponent_textarea_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "textarea", 1);
    i0.ɵɵlistener("blur", function MessagePreviewTextareaComponent_textarea_0_Template_textarea_blur_0_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.saveLastCaretPosition($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("placeholder", ctx_r0.placeholderMessage);
    i0.ɵɵattribute("data-caret", ctx_r0.lastCaretPosition);
} }
class MessagePreviewTextareaComponent {
    constructor() {
        this.isInReply = true;
        this.placeholderMessage = 'Write your message here...';
        this.lastCaretPosition = 0;
    }
    saveLastCaretPosition(event) {
        const textArea = event.target;
        this.lastCaretPosition = textArea.selectionStart;
    }
}
MessagePreviewTextareaComponent.ɵfac = function MessagePreviewTextareaComponent_Factory(t) { return new (t || MessagePreviewTextareaComponent)(); };
MessagePreviewTextareaComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MessagePreviewTextareaComponent, selectors: [["cpc-message-preview-textarea"]], inputs: { isInReply: "isInReply", placeholderMessage: "placeholderMessage" }, decls: 1, vars: 1, consts: [["id", "message-preview-text-area", "class", "cpc-message-preview-textarea", 3, "placeholder", "blur", 4, "ngIf"], ["id", "message-preview-text-area", 1, "cpc-message-preview-textarea", 3, "placeholder", "blur"]], template: function MessagePreviewTextareaComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, MessagePreviewTextareaComponent_textarea_0_Template, 1, 2, "textarea", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.isInReply);
    } }, dependencies: [i1.NgIf], styles: ["cpc-message-preview-textarea{display:flex;width:100%}.cpc-message-preview-textarea{display:block;width:100%;min-height:302px;margin:0;padding:24.5px 34.5px;overflow:auto;color:var(--cpc-colors-charcoal);font-size:1rem;font-family:var(--font-family);background-color:var(--cpc-colors-light-blue-2);border:none;outline:none;box-shadow:none;resize:none}.cpc-message-preview-textarea::placeholder{color:var(--cpc-colors-dark-gray)}@media screen and (min-width: 704px){.cpc-message-preview-textarea{height:100%;min-height:236px}}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MessagePreviewTextareaComponent, [{
        type: Component,
        args: [{ selector: 'cpc-message-preview-textarea', encapsulation: ViewEncapsulation.None, template: "<textarea *ngIf=\"isInReply\"\r\n          id=\"message-preview-text-area\"\r\n          class=\"cpc-message-preview-textarea\"\r\n          [attr.data-caret]=\"lastCaretPosition\"\r\n          (blur)=\"saveLastCaretPosition($event)\"\r\n          placeholder=\"{{placeholderMessage}}\"\r\n></textarea>\r\n\r\n", styles: ["cpc-message-preview-textarea{display:flex;width:100%}.cpc-message-preview-textarea{display:block;width:100%;min-height:302px;margin:0;padding:24.5px 34.5px;overflow:auto;color:var(--cpc-colors-charcoal);font-size:1rem;font-family:var(--font-family);background-color:var(--cpc-colors-light-blue-2);border:none;outline:none;box-shadow:none;resize:none}.cpc-message-preview-textarea::placeholder{color:var(--cpc-colors-dark-gray)}@media screen and (min-width: 704px){.cpc-message-preview-textarea{height:100%;min-height:236px}}\n"] }]
    }], null, { isInReply: [{
            type: Input
        }], placeholderMessage: [{
            type: Input
        }] }); })();

const _c0$t = ["*"];
class MessagePreviewComponent {
}
MessagePreviewComponent.ɵfac = function MessagePreviewComponent_Factory(t) { return new (t || MessagePreviewComponent)(); };
MessagePreviewComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MessagePreviewComponent, selectors: [["cpc-message-preview"]], ngContentSelectors: _c0$t, decls: 2, vars: 0, consts: [[1, "cpc-message-preview"]], template: function MessagePreviewComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵprojection(1);
        i0.ɵɵelementEnd();
    } }, styles: [".cpc-message-preview{display:flex;flex-direction:column;border-top:var(--cpc-border)}@media screen and (min-width: 704px){.cpc-message-preview{border:var(--cpc-border);border-radius:4px}}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MessagePreviewComponent, [{
        type: Component,
        args: [{ selector: 'cpc-message-preview', encapsulation: ViewEncapsulation.None, template: "<div class=\"cpc-message-preview\">\r\n  <ng-content></ng-content>\r\n</div>\r\n\r\n", styles: [".cpc-message-preview{display:flex;flex-direction:column;border-top:var(--cpc-border)}@media screen and (min-width: 704px){.cpc-message-preview{border:var(--cpc-border);border-radius:4px}}\n"] }]
    }], null, null); })();

const _c0$s = [[["", "left-col", ""]], [["", "right-col", ""]]];
const _c1$f = ["[left-col]", "[right-col]"];
class ModalContentComponent {
}
ModalContentComponent.ɵfac = function ModalContentComponent_Factory(t) { return new (t || ModalContentComponent)(); };
ModalContentComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ModalContentComponent, selectors: [["cpc-modal-content"]], ngContentSelectors: _c1$f, decls: 5, vars: 0, consts: [[1, "cpc-modal-content"], [1, "cpc-modal-content__column", "cpc-modal-content__column--yellow"], [1, "cpc-modal-content__column"]], template: function ModalContentComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef(_c0$s);
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵprojection(2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 2);
        i0.ɵɵprojection(4, 1);
        i0.ɵɵelementEnd()();
    } }, styles: [".cpc-modal-content[_ngcontent-%COMP%]{display:flex;width:100%;height:100%}.cpc-modal-content__column[_ngcontent-%COMP%]{flex:1;padding:64px}.cpc-modal-content__column--yellow[_ngcontent-%COMP%]{background-color:var(--cpc-colors-light-yellow)}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ModalContentComponent, [{
        type: Component,
        args: [{ selector: 'cpc-modal-content', template: "<div class=\"cpc-modal-content\">\r\n  <div class=\"cpc-modal-content__column cpc-modal-content__column--yellow\">\r\n    <ng-content select=\"[left-col]\"></ng-content>\r\n  </div>\r\n  <div class=\"cpc-modal-content__column\">\r\n    <ng-content select=\"[right-col]\"></ng-content>\r\n  </div>\r\n</div>\r\n", styles: [".cpc-modal-content{display:flex;width:100%;height:100%}.cpc-modal-content__column{flex:1;padding:64px}.cpc-modal-content__column--yellow{background-color:var(--cpc-colors-light-yellow)}\n"] }]
    }], null, null); })();

const _c0$r = ["*"];
class NavItemComponent {
    constructor() {
        this.disabled = false;
    }
}
NavItemComponent.ɵfac = function NavItemComponent_Factory(t) { return new (t || NavItemComponent)(); };
NavItemComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: NavItemComponent, selectors: [["cpc-nav-item"]], inputs: { icon: "icon", disabled: "disabled" }, ngContentSelectors: _c0$r, decls: 4, vars: 2, consts: [[1, "cpc-nav-item", 3, "disabled"], [1, "cpc-nav-item-icon", 3, "icon"], [1, "cpc-nav-item-text"]], template: function NavItemComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "button", 0);
        i0.ɵɵelement(1, "cpc-icon", 1);
        i0.ɵɵelementStart(2, "span", 2);
        i0.ɵɵprojection(3);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("disabled", ctx.disabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("icon", ctx.icon);
    } }, dependencies: [IconComponent], styles: ["cpc-nav-item{display:table-cell;white-space:nowrap;vertical-align:middle}.cpc-nav-item{background:transparent;border:none;border-radius:0;cursor:pointer;-webkit-appearance:none;appearance:none;position:relative;display:flex;align-items:center;width:100%;height:40px;padding:0 8px;color:var(--cpc-colors-resolution-blue);border-bottom:1px solid transparent;transition:all 125ms linear}.cpc-nav-item--selected{border-bottom:1px solid var(--cpc-colors-resolution-blue)}.cpc-nav-item--selected .cpc-nav-item-icon{display:flex}@media screen and (min-width: 704px){.cpc-nav-item--selected{color:var(--cpc-colors-resolution-blue);font-weight:700;background-color:var(--cpc-colors-active-background);border-bottom:unset}.cpc-nav-item--selected:before{position:absolute;left:0;width:6px;height:inherit;background-color:var(--cpc-colors-resolution-blue);content:\"\"}}.cpc-nav-item:focus,.cpc-nav-item.pseudo-states--focus{outline:0;box-shadow:var(--focus-box-shadow, 0 0 0 2px #fff, 0 0 0 6px #009de6)}.cpc-nav-item:hover,.cpc-nav-item.pseudo-states--hover{border-bottom:1px solid var(--cpc-colors-resolution-blue)}.cpc-nav-item:hover:not(:disabled):not(:active),.cpc-nav-item.pseudo-states--hover{border-bottom:1px solid var(--cpc-colors-resolution-blue)}.cpc-nav-item:active,.cpc-nav-item.pseudo-states--active{border-bottom:1px solid var(--cpc-colors-resolution-blue)}.cpc-nav-item:active .cpc-nav-item-icon,.cpc-nav-item.pseudo-states--active .cpc-nav-item-icon{display:flex}.cpc-nav-item .cpc-nav-item-icon{--icon-size: 24px;display:none}.cpc-nav-item .cpc-nav-item-text{margin-left:8px;font-size:16px;font-family:var(--font-family);line-height:24px}@media screen and (min-width: 704px){.cpc-nav-item .cpc-nav-item-text{margin-left:16px}}@media screen and (min-width: 704px){.cpc-nav-item{padding-left:32px;color:var(--cpc-colors-charcoal);border-bottom:unset}.cpc-nav-item .cpc-nav-item-icon{display:flex}.cpc-nav-item:hover,.cpc-nav-item.pseudo-states--hover{color:var(--cpc-colors-resolution-blue);border-bottom:unset}.cpc-nav-item:hover:not(:disabled):not(:active),.cpc-nav-item.pseudo-states--hover{color:var(--cpc-colors-resolution-blue);border-bottom:unset}.cpc-nav-item:active,.cpc-nav-item.pseudo-states--active{color:var(--cpc-colors-resolution-blue);font-weight:700;background-color:var(--cpc-colors-active-background);border-bottom:unset}.cpc-nav-item:active:before,.cpc-nav-item.pseudo-states--active:before{position:absolute;left:0;width:6px;height:inherit;background-color:var(--cpc-colors-resolution-blue);content:\"\"}}.cpc-nav-item:disabled,.cpc-nav-item.pseudo-states--disabled{cursor:not-allowed;pointer-events:none}.cpc-nav-item:disabled,.cpc-nav-item.cpc--disabled,.cpc-nav-item.pseudo-states--disabled{cursor:not-allowed;pointer-events:none}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NavItemComponent, [{
        type: Component,
        args: [{ selector: 'cpc-nav-item', encapsulation: ViewEncapsulation.None, template: "<button class='cpc-nav-item' [disabled]=\"disabled\">\r\n  <cpc-icon class=\"cpc-nav-item-icon\" [icon]='icon'></cpc-icon>\r\n  <span class='cpc-nav-item-text'>\r\n    <ng-content></ng-content>\r\n  </span>\r\n</button>\r\n", styles: ["cpc-nav-item{display:table-cell;white-space:nowrap;vertical-align:middle}.cpc-nav-item{background:transparent;border:none;border-radius:0;cursor:pointer;-webkit-appearance:none;appearance:none;position:relative;display:flex;align-items:center;width:100%;height:40px;padding:0 8px;color:var(--cpc-colors-resolution-blue);border-bottom:1px solid transparent;transition:all 125ms linear}.cpc-nav-item--selected{border-bottom:1px solid var(--cpc-colors-resolution-blue)}.cpc-nav-item--selected .cpc-nav-item-icon{display:flex}@media screen and (min-width: 704px){.cpc-nav-item--selected{color:var(--cpc-colors-resolution-blue);font-weight:700;background-color:var(--cpc-colors-active-background);border-bottom:unset}.cpc-nav-item--selected:before{position:absolute;left:0;width:6px;height:inherit;background-color:var(--cpc-colors-resolution-blue);content:\"\"}}.cpc-nav-item:focus,.cpc-nav-item.pseudo-states--focus{outline:0;box-shadow:var(--focus-box-shadow, 0 0 0 2px #fff, 0 0 0 6px #009de6)}.cpc-nav-item:hover,.cpc-nav-item.pseudo-states--hover{border-bottom:1px solid var(--cpc-colors-resolution-blue)}.cpc-nav-item:hover:not(:disabled):not(:active),.cpc-nav-item.pseudo-states--hover{border-bottom:1px solid var(--cpc-colors-resolution-blue)}.cpc-nav-item:active,.cpc-nav-item.pseudo-states--active{border-bottom:1px solid var(--cpc-colors-resolution-blue)}.cpc-nav-item:active .cpc-nav-item-icon,.cpc-nav-item.pseudo-states--active .cpc-nav-item-icon{display:flex}.cpc-nav-item .cpc-nav-item-icon{--icon-size: 24px;display:none}.cpc-nav-item .cpc-nav-item-text{margin-left:8px;font-size:16px;font-family:var(--font-family);line-height:24px}@media screen and (min-width: 704px){.cpc-nav-item .cpc-nav-item-text{margin-left:16px}}@media screen and (min-width: 704px){.cpc-nav-item{padding-left:32px;color:var(--cpc-colors-charcoal);border-bottom:unset}.cpc-nav-item .cpc-nav-item-icon{display:flex}.cpc-nav-item:hover,.cpc-nav-item.pseudo-states--hover{color:var(--cpc-colors-resolution-blue);border-bottom:unset}.cpc-nav-item:hover:not(:disabled):not(:active),.cpc-nav-item.pseudo-states--hover{color:var(--cpc-colors-resolution-blue);border-bottom:unset}.cpc-nav-item:active,.cpc-nav-item.pseudo-states--active{color:var(--cpc-colors-resolution-blue);font-weight:700;background-color:var(--cpc-colors-active-background);border-bottom:unset}.cpc-nav-item:active:before,.cpc-nav-item.pseudo-states--active:before{position:absolute;left:0;width:6px;height:inherit;background-color:var(--cpc-colors-resolution-blue);content:\"\"}}.cpc-nav-item:disabled,.cpc-nav-item.pseudo-states--disabled{cursor:not-allowed;pointer-events:none}.cpc-nav-item:disabled,.cpc-nav-item.cpc--disabled,.cpc-nav-item.pseudo-states--disabled{cursor:not-allowed;pointer-events:none}\n"] }]
    }], null, { icon: [{
            type: Input
        }], disabled: [{
            type: Input
        }] }); })();

const _c0$q = ["ref"];
function SelectComponent_span_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 9);
    i0.ɵɵlistener("click", function SelectComponent_span_1_Template_span_click_0_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.handleClickInput($event)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.title, ": ");
} }
function SelectComponent_option_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 10);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("selected", !ctx_r2.value);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r2.title);
} }
function SelectComponent_option_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 11);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("selected", ctx_r3.value);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r3.value);
} }
function SelectComponent_div_8_button_4_cpc_icon_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "cpc-icon", 7);
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("icon", ctx_r10.ndbxIcons.Check);
} }
function SelectComponent_div_8_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 16);
    i0.ɵɵlistener("click", function SelectComponent_div_8_button_4_Template_button_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r12); const option_r9 = restoredCtx.$implicit; const ctx_r11 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r11.handleChangeValue(option_r9)); });
    i0.ɵɵelementStart(1, "div", 17);
    i0.ɵɵtemplate(2, SelectComponent_div_8_button_4_cpc_icon_2_Template, 1, 1, "cpc-icon", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r9 = ctx.$implicit;
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", option_r9 === ctx_r8.value);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", option_r9, " ");
} }
function SelectComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12)(1, "span", 13);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 14);
    i0.ɵɵtemplate(4, SelectComponent_div_8_button_4_Template, 4, 2, "button", 15);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r4.title);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r4.options);
} }
const _c1$e = function (a0) { return { "cpc-mode-compact": a0 }; };
class SelectComponent {
    constructor() {
        this.width = '100%';
        this.options = [];
        this.value = '';
        this.mode = 'default';
        this.changeValue = new EventEmitter();
        this.drawerVisible = false;
        this.ndbxIcons = NdbxIcon;
    }
    handleClickChevron() {
        this.ref?.nativeElement.focus();
    }
    handleClickInput(event) {
        event.preventDefault();
        this.drawerVisible = true;
        this.ref?.nativeElement.blur();
    }
    handleChangeValue(event) {
        this.drawerVisible = false;
        if (typeof event === 'string') {
            this.value = event;
            this.changeValue.emit(event);
            return;
        }
        const { target } = event;
        const { value } = target;
        this.value = value;
        this.changeValue.emit(value);
    }
}
SelectComponent.ɵfac = function SelectComponent_Factory(t) { return new (t || SelectComponent)(); };
SelectComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SelectComponent, selectors: [["cpc-select"]], viewQuery: function SelectComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$q, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.ref = _t.first);
    } }, inputs: { title: "title", width: "width", options: "options", value: "value", mode: "mode" }, outputs: { changeValue: "changeValue" }, decls: 9, vars: 11, consts: [[1, "cpc-select", 3, "ngClass"], [3, "click", 4, "ngIf"], [1, "cpc-select-wrapper", 3, "click"], ["disabled", "", 1, "cpc-select-input", 3, "value", "change"], ["ref", ""], ["disabled", "", 3, "selected", 4, "ngIf"], [3, "selected", 4, "ngFor", "ngForOf"], [3, "icon"], ["class", "cpc-select-dropdown", 4, "ngIf"], [3, "click"], ["disabled", "", 3, "selected"], [3, "selected"], [1, "cpc-select-dropdown"], [1, "cpc-select-dropdown-title"], [1, "cpc-select-dropdown-items"], ["class", "cpc-select-dropdown-items-item", 3, "click", 4, "ngFor", "ngForOf"], [1, "cpc-select-dropdown-items-item", 3, "click"], [1, "cpc-select-dropdown-items-check"], [3, "icon", 4, "ngIf"]], template: function SelectComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, SelectComponent_span_1_Template, 2, 1, "span", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵlistener("click", function SelectComponent_Template_div_click_2_listener($event) { return ctx.handleClickInput($event); });
        i0.ɵɵelementStart(3, "select", 3, 4);
        i0.ɵɵlistener("change", function SelectComponent_Template_select_change_3_listener($event) { return ctx.handleChangeValue($event); });
        i0.ɵɵtemplate(5, SelectComponent_option_5_Template, 2, 2, "option", 5);
        i0.ɵɵtemplate(6, SelectComponent_option_6_Template, 2, 2, "option", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(7, "cpc-icon", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(8, SelectComponent_div_8_Template, 5, 2, "div", 8);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c1$e, ctx.mode === "compact"));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.mode === "compact");
        i0.ɵɵadvance(1);
        i0.ɵɵstyleProp("width", ctx.width);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("value", ctx.value);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.mode !== "compact");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.options);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("icon", ctx.ndbxIcons.ChevronDown);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.drawerVisible);
    } }, dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, IconComponent], styles: [".cpc-select{position:relative;width:100%;cursor:pointer}.cpc-select select:disabled{color:unset;opacity:1}.cpc-select .cpc-select-wrapper{display:flex;align-items:center}.cpc-select .cpc-select-wrapper>cpc-icon{right:0;margin-left:12px;font-size:24px}.cpc-select .cpc-select-input{background:transparent;border:none;border-radius:0;cursor:pointer;-webkit-appearance:none;appearance:none;width:100%;padding:12px 0;font-weight:600;font-size:16px;font-family:Allianz Neo,sans-serif;letter-spacing:.2px;text-align:center;text-align-last:center;border-bottom:solid 1px var(--cpc-colors-charcoal)}.cpc-select .cpc-select-input:focus{color:var(--cpc-colors-resolution-blue);border-bottom-color:var(--cpc-colors-resolution-blue);outline:none}.cpc-select .cpc-select-input:focus~cpc-icon{color:var(--cpc-colors-resolution-blue)}.cpc-select.cpc-mode-compact{display:flex;align-items:center;justify-content:flex-start;flex-direction:row;flex-wrap:inherit;color:var(--cpc-colors-resolution-blue);white-space:nowrap}.cpc-select.cpc-mode-compact .cpc-select-input{padding:0 0 0 4px;color:var(--paging-input-color);text-align:left;text-align-last:left;border-bottom:none}.cpc-select.cpc-mode-compact .cpc-select-input~cpc-icon{display:none}.cpc-select .cpc-select-dropdown{position:absolute;top:0;left:0;z-index:9999;display:block;width:100%;background:var(--cpc-colors-white);border:solid 1px var(--cpc-colors-whisper);border-radius:4px}.cpc-select .cpc-select-dropdown .cpc-select-dropdown-title{display:block;width:100%;padding:8px 32px;font-weight:600;font-size:12px;font-family:Allianz Neo,sans-serif;background:var(--cpc-colors-whisper);border-radius:4px 4px 0 0}.cpc-select .cpc-select-dropdown .cpc-select-dropdown-items{display:flex;justify-content:flex-start;align-items:flex-start;flex-direction:column;flex-wrap:inherit;max-height:300px;overflow-y:scroll}.cpc-select .cpc-select-dropdown .cpc-select-dropdown-items .cpc-select-dropdown-items-item{background:transparent;border:none;border-radius:0;-webkit-appearance:none;appearance:none;width:100%;padding:8px 32px 8px 8px;font-weight:400;font-size:20px;font-family:Allianz Neo,sans-serif;letter-spacing:.2px;white-space:pre;text-align:left;cursor:pointer}.cpc-select .cpc-select-dropdown .cpc-select-dropdown-items .cpc-select-dropdown-items-item:focus{color:var(--cpc-colors-resolution-blue);outline:none}.cpc-select .cpc-select-dropdown .cpc-select-dropdown-items .cpc-select-dropdown-items-item .cpc-select-dropdown-items-check{display:inline-block;width:24px;height:24px}.cpc-select .cpc-select-dropdown .cpc-select-dropdown-items .cpc-select-dropdown-items-item .cpc-select-dropdown-items-check>cpc-icon{display:inline-block;transform:translateY(3px)}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SelectComponent, [{
        type: Component,
        args: [{ selector: 'cpc-select', encapsulation: ViewEncapsulation.None, template: "<div class=\"cpc-select\" [ngClass]='{ \"cpc-mode-compact\": mode === \"compact\" }'>\r\n  <span *ngIf='mode === \"compact\"' (click)='handleClickInput($event)'>\r\n    {{title}}:\r\n  </span>\r\n  <div\r\n    [style.width]=\"width\"\r\n    (click)=\"handleClickInput($event)\"\r\n    class=\"cpc-select-wrapper\"\r\n  >\r\n    <select\r\n    class=\"cpc-select-input\"\r\n    [value]=\"value\"\r\n    (change)=\"handleChangeValue($event)\"\r\n    disabled\r\n    #ref\r\n    >\r\n      <option *ngIf='mode !== \"compact\"' disabled [selected]=\"!value\">{{title}}</option>\r\n      <option *ngFor=\"let option of options\" [selected]=\"value\">{{ value }}</option>\r\n    </select>\r\n    <cpc-icon [icon]=\"ndbxIcons.ChevronDown\"></cpc-icon>\r\n  </div>\r\n  <div class=\"cpc-select-dropdown\" *ngIf=\"drawerVisible\">\r\n    <span class=\"cpc-select-dropdown-title\">{{ title }}</span>\r\n    <div class=\"cpc-select-dropdown-items\">\r\n      <button\r\n        *ngFor=\"let option of options\"\r\n        class=\"cpc-select-dropdown-items-item\"\r\n        (click)=\"handleChangeValue(option)\"\r\n      >\r\n        <div class=\"cpc-select-dropdown-items-check\">\r\n          <cpc-icon *ngIf=\"option === value\" [icon]=\"ndbxIcons.Check\"></cpc-icon>\r\n        </div>\r\n        {{option}}\r\n      </button>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".cpc-select{position:relative;width:100%;cursor:pointer}.cpc-select select:disabled{color:unset;opacity:1}.cpc-select .cpc-select-wrapper{display:flex;align-items:center}.cpc-select .cpc-select-wrapper>cpc-icon{right:0;margin-left:12px;font-size:24px}.cpc-select .cpc-select-input{background:transparent;border:none;border-radius:0;cursor:pointer;-webkit-appearance:none;appearance:none;width:100%;padding:12px 0;font-weight:600;font-size:16px;font-family:Allianz Neo,sans-serif;letter-spacing:.2px;text-align:center;text-align-last:center;border-bottom:solid 1px var(--cpc-colors-charcoal)}.cpc-select .cpc-select-input:focus{color:var(--cpc-colors-resolution-blue);border-bottom-color:var(--cpc-colors-resolution-blue);outline:none}.cpc-select .cpc-select-input:focus~cpc-icon{color:var(--cpc-colors-resolution-blue)}.cpc-select.cpc-mode-compact{display:flex;align-items:center;justify-content:flex-start;flex-direction:row;flex-wrap:inherit;color:var(--cpc-colors-resolution-blue);white-space:nowrap}.cpc-select.cpc-mode-compact .cpc-select-input{padding:0 0 0 4px;color:var(--paging-input-color);text-align:left;text-align-last:left;border-bottom:none}.cpc-select.cpc-mode-compact .cpc-select-input~cpc-icon{display:none}.cpc-select .cpc-select-dropdown{position:absolute;top:0;left:0;z-index:9999;display:block;width:100%;background:var(--cpc-colors-white);border:solid 1px var(--cpc-colors-whisper);border-radius:4px}.cpc-select .cpc-select-dropdown .cpc-select-dropdown-title{display:block;width:100%;padding:8px 32px;font-weight:600;font-size:12px;font-family:Allianz Neo,sans-serif;background:var(--cpc-colors-whisper);border-radius:4px 4px 0 0}.cpc-select .cpc-select-dropdown .cpc-select-dropdown-items{display:flex;justify-content:flex-start;align-items:flex-start;flex-direction:column;flex-wrap:inherit;max-height:300px;overflow-y:scroll}.cpc-select .cpc-select-dropdown .cpc-select-dropdown-items .cpc-select-dropdown-items-item{background:transparent;border:none;border-radius:0;-webkit-appearance:none;appearance:none;width:100%;padding:8px 32px 8px 8px;font-weight:400;font-size:20px;font-family:Allianz Neo,sans-serif;letter-spacing:.2px;white-space:pre;text-align:left;cursor:pointer}.cpc-select .cpc-select-dropdown .cpc-select-dropdown-items .cpc-select-dropdown-items-item:focus{color:var(--cpc-colors-resolution-blue);outline:none}.cpc-select .cpc-select-dropdown .cpc-select-dropdown-items .cpc-select-dropdown-items-item .cpc-select-dropdown-items-check{display:inline-block;width:24px;height:24px}.cpc-select .cpc-select-dropdown .cpc-select-dropdown-items .cpc-select-dropdown-items-item .cpc-select-dropdown-items-check>cpc-icon{display:inline-block;transform:translateY(3px)}\n"] }]
    }], null, { title: [{
            type: Input
        }], width: [{
            type: Input
        }], options: [{
            type: Input
        }], value: [{
            type: Input
        }], mode: [{
            type: Input
        }], changeValue: [{
            type: Output
        }], ref: [{
            type: ViewChild,
            args: ['ref', { static: false }]
        }] }); })();

function PaginationComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 4);
    i0.ɵɵtext(2);
    i0.ɵɵelementStart(3, "cpc-select", 5);
    i0.ɵɵlistener("changeValue", function PaginationComponent_ng_container_2_Template_cpc_select_changeValue_3_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.handleChangeItemsPerPage($event)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 6)(5, "cpc-button", 7);
    i0.ɵɵlistener("click", function PaginationComponent_ng_container_2_Template_cpc_button_click_5_listener() { i0.ɵɵrestoreView(_r4); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.changePage.emit(ctx_r5.claimsTablePaginationDirections.Prev)); });
    i0.ɵɵelement(6, "cpc-icon", 8);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "span", 9);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "cpc-button", 10);
    i0.ɵɵlistener("click", function PaginationComponent_ng_container_2_Template_cpc_button_click_10_listener() { i0.ɵɵrestoreView(_r4); const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.changePage.emit(ctx_r6.claimsTablePaginationDirections.Next)); });
    i0.ɵɵtext(11);
    i0.ɵɵelement(12, "cpc-icon", 8);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.copyItemPerPage, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("value", ctx_r0.itemsPerPage)("options", ctx_r0.options);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r0.page === 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("icon", ctx_r0.ndbxIcons.ArrowLeft);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.copyPrev, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate3(" ", ctx_r0.page + 1, " ", ctx_r0.copyOf, " ", ctx_r0.maxPage + 1, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r0.page === ctx_r0.maxPage);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.copyNext, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("icon", ctx_r0.ndbxIcons.ArrowRight);
} }
function PaginationComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 6)(2, "cpc-button", 11);
    i0.ɵɵlistener("click", function PaginationComponent_ng_container_3_Template_cpc_button_click_2_listener() { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r7.changePage.emit(ctx_r7.claimsTablePaginationDirections.Prev)); });
    i0.ɵɵelement(3, "cpc-icon", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 9);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "cpc-button", 12);
    i0.ɵɵlistener("click", function PaginationComponent_ng_container_3_Template_cpc_button_click_6_listener() { i0.ɵɵrestoreView(_r8); const ctx_r9 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r9.changePage.emit(ctx_r9.claimsTablePaginationDirections.Next)); });
    i0.ɵɵelement(7, "cpc-icon", 8);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r1.page === 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("icon", ctx_r1.ndbxIcons.ArrowLeft);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate3(" ", ctx_r1.page + 1, " ", ctx_r1.copyOf, " ", ctx_r1.maxPage + 1, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r1.page === ctx_r1.maxPage);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("icon", ctx_r1.ndbxIcons.ArrowRight);
} }
function PaginationComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 6)(2, "cpc-button", 13);
    i0.ɵɵlistener("click", function PaginationComponent_ng_container_4_Template_cpc_button_click_2_listener() { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r10.changePage.emit(ctx_r10.claimsTablePaginationDirections.First)); });
    i0.ɵɵelement(3, "cpc-icon", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "cpc-button", 13);
    i0.ɵɵlistener("click", function PaginationComponent_ng_container_4_Template_cpc_button_click_4_listener() { i0.ɵɵrestoreView(_r11); const ctx_r12 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r12.changePage.emit(ctx_r12.claimsTablePaginationDirections.Prev)); });
    i0.ɵɵelement(5, "cpc-icon", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span", 9);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "cpc-button", 14);
    i0.ɵɵlistener("click", function PaginationComponent_ng_container_4_Template_cpc_button_click_8_listener() { i0.ɵɵrestoreView(_r11); const ctx_r13 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r13.changePage.emit(ctx_r13.claimsTablePaginationDirections.Next)); });
    i0.ɵɵelement(9, "cpc-icon", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "cpc-button", 13);
    i0.ɵɵlistener("click", function PaginationComponent_ng_container_4_Template_cpc_button_click_10_listener() { i0.ɵɵrestoreView(_r11); const ctx_r14 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r14.changePage.emit(ctx_r14.claimsTablePaginationDirections.Last)); });
    i0.ɵɵelement(11, "cpc-icon", 8);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r2.page === 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("icon", ctx_r2.ndbxIcons.ArrowFirst);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r2.page === 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("icon", ctx_r2.ndbxIcons.ArrowLeft);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate3(" ", ctx_r2.page + 1, " ", ctx_r2.copyOf, " ", ctx_r2.maxPage + 1, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r2.page === ctx_r2.maxPage);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("icon", ctx_r2.ndbxIcons.ArrowRight);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r2.page === ctx_r2.maxPage);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("icon", ctx_r2.ndbxIcons.ArrowLeft);
} }
const _c0$p = function (a0) { return { "cpc-pagination--center": a0 }; };
var PaginationDirections;
(function (PaginationDirections) {
    PaginationDirections["Next"] = "Next";
    PaginationDirections["Prev"] = "Prev";
    PaginationDirections["First"] = "First";
    PaginationDirections["Last"] = "Last";
})(PaginationDirections || (PaginationDirections = {}));
class PaginationComponent {
    constructor() {
        this.page = 0;
        this.maxPage = 0;
        this.itemsPerPage = 5;
        this.copyItemPerPage = 'Show per page:';
        this.variant = 'default';
        this.copyPrev = 'PREVIOUS';
        this.copyOf = 'of';
        this.copyNext = 'NEXT';
        this.options = ['5', '10', '25', '50', '100'];
        this.changeItemsPerPage = new EventEmitter();
        this.changePage = new EventEmitter();
        this.mediaQuery = setMatchMedia(Breakpoints.medium);
        this.isMobile = !this.mediaQuery?.matches;
        this.ndbxIcons = NdbxIcon;
        this.claimsTablePaginationDirections = PaginationDirections;
        this.userVariant = this.variant;
    }
    onResize() {
        this.isMobile = !this.mediaQuery?.matches;
        this.handleChangeToMobile();
    }
    ngOnChanges() {
        this.userVariant = this.variant;
        this.isPageGreaterMaxPage();
        this.handleChangeToMobile();
        if (!this.options.includes(String(this.itemsPerPage))) {
            this.itemsPerPage = Number(this.options[0]);
        }
        this.changeItemsPerPage.emit(this.itemsPerPage);
    }
    handleChangeToMobile() {
        if (this.isMobile) {
            this.variant = 'shortExtended';
        }
        else {
            this.variant = this.userVariant;
        }
    }
    isPageGreaterMaxPage() {
        if (Number(this.page) > Number(this.maxPage)) {
            this.page = this.maxPage;
        }
    }
    handleChangeItemsPerPage(value) {
        const valueAsNumber = Number(value);
        this.itemsPerPage = valueAsNumber;
        this.changeItemsPerPage.emit(valueAsNumber);
    }
}
PaginationComponent.ɵfac = function PaginationComponent_Factory(t) { return new (t || PaginationComponent)(); };
PaginationComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PaginationComponent, selectors: [["cpc-pagination"]], hostBindings: function PaginationComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("resize", function PaginationComponent_resize_HostBindingHandler($event) { return ctx.onResize($event); }, false, i0.ɵɵresolveWindow);
    } }, inputs: { page: "page", maxPage: "maxPage", itemsPerPage: "itemsPerPage", copyItemPerPage: "copyItemPerPage", variant: "variant", copyPrev: "copyPrev", copyOf: "copyOf", copyNext: "copyNext", options: "options" }, outputs: { changeItemsPerPage: "changeItemsPerPage", changePage: "changePage" }, features: [i0.ɵɵNgOnChangesFeature], decls: 5, vars: 6, consts: [[1, "cpc-pagination", 3, "ngClass"], [3, "ngSwitch"], [4, "ngSwitchDefault"], [4, "ngSwitchCase"], [1, "cpc-pagination-item-per-page"], ["width", "100px", 3, "value", "options", "changeValue"], [1, "cpc-pagination-nav"], ["mode", "tertiary", "size", "small-medium", 1, "cpc-pagination-nav-prev", 3, "disabled", "click"], [3, "icon"], [1, "cpc-pagination-nav-info"], ["mode", "tertiary", "size", "small-medium", 1, "cpc-pagination-nav-next", 3, "disabled", "click"], ["mode", "tertiary", "size", "small", 1, "cpc-pagination-nav-prev", 3, "disabled", "click"], ["mode", "tertiary", "size", "small", 1, "cpc-pagination-nav-next", 3, "disabled", "click"], ["mode", "tertiary", "size", "x-small", 1, "cpc-pagination-nav-prev", 3, "disabled", "click"], ["mode", "tertiary", "size", "x-small", 1, "cpc-pagination-nav-next", 3, "disabled", "click"]], template: function PaginationComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementContainerStart(1, 1);
        i0.ɵɵtemplate(2, PaginationComponent_ng_container_2_Template, 13, 12, "ng-container", 2);
        i0.ɵɵtemplate(3, PaginationComponent_ng_container_3_Template, 8, 7, "ng-container", 3);
        i0.ɵɵtemplate(4, PaginationComponent_ng_container_4_Template, 12, 11, "ng-container", 3);
        i0.ɵɵelementContainerEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c0$p, ctx.isMobile));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitch", ctx.variant);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngSwitchCase", "short");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitchCase", "shortExtended");
    } }, dependencies: [i1.NgClass, i1.NgSwitch, i1.NgSwitchCase, i1.NgSwitchDefault, ButtonComponent, IconComponent, SelectComponent], styles: [".cpc-pagination{display:flex;align-items:center;justify-content:space-between;flex-direction:row;flex-wrap:inherit;width:100%}.cpc-pagination--center{justify-content:center}.cpc-pagination .cpc-pagination-item-per-page{display:flex;align-items:center;justify-content:center;flex-direction:row;flex-wrap:inherit}.cpc-pagination .cpc-pagination-item-per-page .cpc-select{margin-left:8px}.cpc-pagination .cpc-pagination-nav{display:flex;align-items:center;justify-content:center;flex-direction:row;flex-wrap:inherit}.cpc-pagination .cpc-pagination-nav button{margin-bottom:0}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PaginationComponent, [{
        type: Component,
        args: [{ selector: 'cpc-pagination', encapsulation: ViewEncapsulation.None, template: "<div\r\n  [ngClass]=\"{'cpc-pagination--center' : isMobile}\"\r\n  class=\"cpc-pagination\">\r\n  <ng-container [ngSwitch]=\"variant\">\r\n    <ng-container *ngSwitchDefault>\r\n      <div class=\"cpc-pagination-item-per-page\">\r\n        {{copyItemPerPage}}\r\n        <cpc-select\r\n          width=\"100px\"\r\n          [value]=\"itemsPerPage\"\r\n          [options]=\"options\"\r\n          (changeValue)=\"handleChangeItemsPerPage($event)\"\r\n        ></cpc-select>\r\n      </div>\r\n      <div class=\"cpc-pagination-nav\">\r\n        <cpc-button\r\n          mode=\"tertiary\"\r\n          size=\"small-medium\"\r\n          [disabled]=\"page === 0\"\r\n          (click)=\"changePage.emit(claimsTablePaginationDirections.Prev)\"\r\n          class=\"cpc-pagination-nav-prev\"\r\n        >\r\n          <cpc-icon [icon]=\"ndbxIcons.ArrowLeft\"></cpc-icon>\r\n          {{ copyPrev }}\r\n        </cpc-button>\r\n        <span class=\"cpc-pagination-nav-info\">\r\n      {{ page + 1 }} {{copyOf}} {{ maxPage + 1 }}\r\n    </span>\r\n        <cpc-button\r\n          mode=\"tertiary\"\r\n          size=\"small-medium\"\r\n          [disabled]=\"page === maxPage\"\r\n          (click)=\"changePage.emit(claimsTablePaginationDirections.Next)\"\r\n          class=\"cpc-pagination-nav-next\"\r\n        >\r\n          {{ copyNext }}\r\n          <cpc-icon [icon]=\"ndbxIcons.ArrowRight\"></cpc-icon>\r\n        </cpc-button>\r\n      </div>\r\n    </ng-container>\r\n    <ng-container *ngSwitchCase=\"'short'\">\r\n      <div class=\"cpc-pagination-nav\">\r\n        <cpc-button\r\n          mode=\"tertiary\"\r\n          size=\"small\"\r\n          [disabled]=\"page === 0\"\r\n          (click)=\"changePage.emit(claimsTablePaginationDirections.Prev)\"\r\n          class=\"cpc-pagination-nav-prev\"\r\n        >\r\n          <cpc-icon [icon]=\"ndbxIcons.ArrowLeft\"></cpc-icon>\r\n        </cpc-button>\r\n        <span class=\"cpc-pagination-nav-info\">\r\n      {{ page + 1 }} {{copyOf}} {{ maxPage + 1 }}\r\n    </span>\r\n        <cpc-button\r\n          mode=\"tertiary\"\r\n          size=\"small\"\r\n          [disabled]=\"page === maxPage\"\r\n          (click)=\"changePage.emit(claimsTablePaginationDirections.Next)\"\r\n          class=\"cpc-pagination-nav-next\"\r\n        >\r\n          <cpc-icon [icon]=\"ndbxIcons.ArrowRight\"></cpc-icon>\r\n        </cpc-button>\r\n      </div>\r\n    </ng-container>\r\n    <ng-container *ngSwitchCase=\"'shortExtended'\">\r\n      <div class=\"cpc-pagination-nav\">\r\n        <cpc-button\r\n          mode=\"tertiary\"\r\n          size=\"x-small\"\r\n          [disabled]=\"page === 0\"\r\n          (click)=\"changePage.emit(claimsTablePaginationDirections.First)\"\r\n          class=\"cpc-pagination-nav-prev\"\r\n        >\r\n          <cpc-icon [icon]=\"ndbxIcons.ArrowFirst\"></cpc-icon>\r\n        </cpc-button>\r\n        <cpc-button\r\n          mode=\"tertiary\"\r\n          size=\"x-small\"\r\n          [disabled]=\"page === 0\"\r\n          (click)=\"changePage.emit(claimsTablePaginationDirections.Prev)\"\r\n          class=\"cpc-pagination-nav-prev\"\r\n        >\r\n          <cpc-icon [icon]=\"ndbxIcons.ArrowLeft\"></cpc-icon>\r\n        </cpc-button>\r\n        <span class=\"cpc-pagination-nav-info\">\r\n      {{ page + 1 }} {{copyOf}} {{ maxPage + 1 }}\r\n    </span>\r\n        <cpc-button\r\n          mode=\"tertiary\"\r\n          size=\"x-small\"\r\n          [disabled]=\"page === maxPage\"\r\n          (click)=\"changePage.emit(claimsTablePaginationDirections.Next)\"\r\n          class=\"cpc-pagination-nav-next\"\r\n        >\r\n          <cpc-icon [icon]=\"ndbxIcons.ArrowRight\"></cpc-icon>\r\n        </cpc-button>\r\n        <cpc-button\r\n          mode=\"tertiary\"\r\n          size=\"x-small\"\r\n          [disabled]=\"page === maxPage\"\r\n          (click)=\"changePage.emit(claimsTablePaginationDirections.Last)\"\r\n          class=\"cpc-pagination-nav-prev\"\r\n        >\r\n          <cpc-icon [icon]=\"ndbxIcons.ArrowLeft\"></cpc-icon>\r\n        </cpc-button>\r\n      </div>\r\n    </ng-container>\r\n  </ng-container>\r\n</div>\r\n", styles: [".cpc-pagination{display:flex;align-items:center;justify-content:space-between;flex-direction:row;flex-wrap:inherit;width:100%}.cpc-pagination--center{justify-content:center}.cpc-pagination .cpc-pagination-item-per-page{display:flex;align-items:center;justify-content:center;flex-direction:row;flex-wrap:inherit}.cpc-pagination .cpc-pagination-item-per-page .cpc-select{margin-left:8px}.cpc-pagination .cpc-pagination-nav{display:flex;align-items:center;justify-content:center;flex-direction:row;flex-wrap:inherit}.cpc-pagination .cpc-pagination-nav button{margin-bottom:0}\n"] }]
    }], null, { page: [{
            type: Input
        }], maxPage: [{
            type: Input
        }], itemsPerPage: [{
            type: Input
        }], copyItemPerPage: [{
            type: Input
        }], variant: [{
            type: Input
        }], copyPrev: [{
            type: Input
        }], copyOf: [{
            type: Input
        }], copyNext: [{
            type: Input
        }], options: [{
            type: Input
        }], changeItemsPerPage: [{
            type: Output
        }], changePage: [{
            type: Output
        }], onResize: [{
            type: HostListener,
            args: ['window:resize', ['$event']]
        }] }); })();

var PanelComponentPropBackground;
(function (PanelComponentPropBackground) {
    PanelComponentPropBackground["white"] = "white";
    PanelComponentPropBackground["lightBlue"] = "light-blue";
    PanelComponentPropBackground["lightPeach"] = "light-peach";
    PanelComponentPropBackground["lightGreen"] = "light-green";
    PanelComponentPropBackground["darkYellow"] = "dark-yellow";
})(PanelComponentPropBackground || (PanelComponentPropBackground = {}));

const _c0$o = ["refSingle"];
const _c1$d = function (a0, a1) { return { "cpc-panel_padding-x-default": a0, "cpc-panel_padding-y-default": a1 }; };
function PanelComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0, 1);
    i0.ɵɵprojection(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const border_r1 = ctx.border;
    const row_r2 = ctx.row;
    const ref_r3 = ctx.ref;
    const _r4 = i0.ɵɵreference(1);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate2("cpc-panel cpc-panel_background-", ctx_r0.background, " cpc-panel_col-", ctx_r0.col, "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(6, _c1$d, ctx_r0.paddingXvalue === "true", ctx_r0.paddingYvalue === "true"))("ngStyle", ctx_r0.styles(ref_r3, _r4, border_r1, row_r2, ctx_r0.paddingXvalue, ctx_r0.paddingYvalue));
} }
const _c2$3 = ["*"];
const DEFAULT_COL_SIZE = 12;
const DIRECTIONS = ['Top', 'Right', 'Bottom', 'Left'];
const DEFAULT_TIMEOUT$2 = 1;
var Breakpoint;
(function (Breakpoint) {
    Breakpoint[Breakpoint["Tiny"] = 0] = "Tiny";
    Breakpoint[Breakpoint["Small"] = 320] = "Small";
    Breakpoint[Breakpoint["Medium"] = 704] = "Medium";
    Breakpoint[Breakpoint["Large"] = 992] = "Large";
    Breakpoint[Breakpoint["Xlarge"] = 1280] = "Xlarge";
    Breakpoint[Breakpoint["Xxlarge"] = 1472] = "Xxlarge";
    Breakpoint[Breakpoint["Xxxlarge"] = 1760] = "Xxxlarge";
})(Breakpoint || (Breakpoint = {}));
class PanelComponent {
    constructor() {
        this.background = PanelComponentPropBackground.white;
        this.col = DEFAULT_COL_SIZE;
        this.paddingX = true;
        this.paddingY = true;
        this.paddingXvalue = 'true';
        this.paddingYvalue = 'true';
        this.colsAsArray = [];
    }
    windowResize() {
        this.changeColSize(this.colsAsArray);
    }
    ngOnChanges(changes) {
        this.changeColSize(this.colsAsArray);
        if ('paddingX' in changes) {
            this.paddingXvalue = this.paddingX ? String(this.paddingX) : '0';
        }
        if ('paddingY' in changes) {
            this.paddingYvalue = this.paddingY ? String(this.paddingY) : '0';
        }
    }
    ngOnInit() {
        this.setColSize();
        this.changeColSize(this.colsAsArray);
    }
    styles(ref, refSingle, bordersValues, row, padX, padY) {
        if (ref && refSingle) {
            const { nativeElement } = ref;
            const variableName = `cpc-row-${row}`;
            const cssHeight = parseInt(cssVariables.get(nativeElement, variableName), 10);
            const currentHeight = refSingle.clientHeight;
            const nextHeight = Math.max(currentHeight, cssHeight);
            cssVariables.set(nativeElement, variableName, `${nextHeight}px`);
        }
        const borders = bordersValues.split('').map((value, index) => ({ direction: DIRECTIONS[index], value: value !== '0' ? '1px' : '0' }));
        return {
            minHeight: `var(--cpc-row-${row})`,
            paddingTop: padY,
            paddingRight: padX,
            paddingBottom: padY,
            paddingLeft: padX,
            borderTopWidth: borders.find(({ direction }) => direction === 'Top')?.value || '0',
            borderRightWidth: borders.find(({ direction }) => direction === 'Right')?.value || '0',
            borderBottomWidth: borders.find(({ direction }) => direction === 'Bottom')?.value || '0',
            borderLeftWidth: borders.find(({ direction }) => direction === 'Left')?.value || '0',
        };
    }
    setColSize() {
        this.colsAsArray = this.col.toString().split(',').map(Number);
    }
    changeColSize(cols) {
        setTimeout(() => {
            switch (true) {
                case window.innerWidth < Breakpoint.Small:
                    this.col = cols[0];
                    break;
                case window.innerWidth >= Breakpoint.Small && window.innerWidth < Breakpoint.Medium && Boolean(cols[1]):
                    this.col = cols[1];
                    break;
                case window.innerWidth >= Breakpoint.Medium && window.innerWidth < Breakpoint.Large && Boolean(cols[2]):
                    this.col = cols[2];
                    break;
                case window.innerWidth >= Breakpoint.Large && window.innerWidth < Breakpoint.Xlarge && Boolean(cols[3]):
                    this.col = cols[3];
                    break;
                case window.innerWidth >= Breakpoint.Xlarge && window.innerWidth < Breakpoint.Xxlarge && Boolean(cols[4]):
                    this.col = cols[4];
                    break;
                case window.innerWidth >= Breakpoint.Xxlarge && window.innerWidth < Breakpoint.Xxxlarge && Boolean(cols[5]):
                    this.col = cols[5];
                    break;
                case window.innerWidth >= Breakpoint.Xxxlarge && Boolean(cols[6]):
                    this.col = cols[6];
                    break;
                default:
                    this.col = cols[cols.length - 1];
                    break;
            }
        }, DEFAULT_TIMEOUT$2);
    }
}
PanelComponent.ɵfac = function PanelComponent_Factory(t) { return new (t || PanelComponent)(); };
PanelComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PanelComponent, selectors: [["cpc-panel"]], viewQuery: function PanelComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(TemplateRef, 5);
        i0.ɵɵviewQuery(_c0$o, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.template = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.refSingle = _t.first);
    } }, hostBindings: function PanelComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("resize", function PanelComponent_resize_HostBindingHandler($event) { return ctx.windowResize($event); }, false, i0.ɵɵresolveWindow);
    } }, inputs: { background: "background", col: "col", paddingX: "paddingX", paddingY: "paddingY" }, features: [i0.ɵɵNgOnChangesFeature], ngContentSelectors: _c2$3, decls: 1, vars: 0, consts: [[3, "ngClass", "ngStyle"], ["refSingle", ""]], template: function PanelComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵtemplate(0, PanelComponent_ng_template_0_Template, 3, 9, "ng-template");
    } }, dependencies: [i1.NgClass, i1.NgStyle], styles: [".cpc-panel{--cpc-panel-selected-color: var(--cpc-colors-white);--cpc-panel-selected-border-color: var(--cpc-colors-border);position:relative;background:var(--cpc-panel-selected-color);border-radius:4px;box-shadow:0 0 0 1px var(--cpc-panel-selected-border-color)}.cpc-panel.cpc-panel_background-light-blue{--cpc-panel-selected-color: var(--cpc-colors-light-blue-2);--cpc-panel-selected-border-color: var(--cpc-colors-light-blue)}.cpc-panel.cpc-panel_background-light-green{--cpc-panel-selected-color: var(--cpc-colors-light-green-2);--cpc-panel-selected-border-color: var(--cpc-colors-light-green)}.cpc-panel.cpc-panel_background-light-peach{--cpc-panel-selected-color: var(--cpc-colors-light-peach-2);--cpc-panel-selected-border-color: var(--cpc-colors-light-peach)}.cpc-panel.cpc-panel_background-light-teal{--cpc-panel-selected-color: var(--cpc-colors-light-teal);--cpc-panel-selected-border-color: var(--cpc-colors-border)}.cpc-panel.cpc-panel_background-dark-yellow{--cpc-panel-selected-color: var(--cpc-colors-dark-yellow);--cpc-panel-selected-border-color: var(--cpc-colors-banana-mania)}.cpc-panel.cpc-panel_padding-x-default{padding-right:24px;padding-left:24px}@media screen and (min-width: 992px){.cpc-panel.cpc-panel_padding-x-default{padding-right:32px;padding-left:32px}}.cpc-panel.cpc-panel_padding-y-default{padding-top:24px;padding-bottom:24px}@media screen and (min-width: 992px){.cpc-panel.cpc-panel_padding-y-default{padding-top:32px;padding-bottom:32px}}.cpc-panel.cpc-panel_col-1{width:8.3333333333%;max-width:8.3333333333%}.cpc-panel.cpc-panel_col-2{width:16.6666666667%;max-width:16.6666666667%}.cpc-panel.cpc-panel_col-3{width:25%;max-width:25%}.cpc-panel.cpc-panel_col-4{width:33.3333333333%;max-width:33.3333333333%}.cpc-panel.cpc-panel_col-5{width:41.6666666667%;max-width:41.6666666667%}.cpc-panel.cpc-panel_col-6{width:50%;max-width:50%}.cpc-panel.cpc-panel_col-7{width:58.3333333333%;max-width:58.3333333333%}.cpc-panel.cpc-panel_col-8{width:66.6666666667%;max-width:66.6666666667%}.cpc-panel.cpc-panel_col-9{width:75%;max-width:75%}.cpc-panel.cpc-panel_col-10{width:83.3333333333%;max-width:83.3333333333%}.cpc-panel.cpc-panel_col-11{width:91.6666666667%;max-width:91.6666666667%}.cpc-panel.cpc-panel_col-12{width:100%;max-width:100%}.cpc-panel .cpc-panel_indent-shape{position:absolute;top:100%;left:50%;z-index:1020;display:block;color:var(--cpc-panel-selected-color);font-size:22px;line-height:1;text-shadow:0px -1px var(--cpc-colors-border);transform:translateY(-4px) scaleX(2.5) rotate(180deg)}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PanelComponent, [{
        type: Component,
        args: [{ selector: 'cpc-panel', encapsulation: ViewEncapsulation.None, template: "<ng-template let-border=\"border\" let-row=\"row\" let-ref=\"ref\">\r\n  <div\r\n    #refSingle\r\n    class='cpc-panel cpc-panel_background-{{background}} cpc-panel_col-{{col}}'\r\n    [ngClass]='{\r\n      \"cpc-panel_padding-x-default\": paddingXvalue === \"true\",\r\n      \"cpc-panel_padding-y-default\": paddingYvalue === \"true\"\r\n    }'\r\n    [ngStyle]='styles(ref, refSingle, border, row, paddingXvalue, paddingYvalue)'\r\n  >\r\n    <ng-content></ng-content>\r\n  </div>\r\n</ng-template>\r\n", styles: [".cpc-panel{--cpc-panel-selected-color: var(--cpc-colors-white);--cpc-panel-selected-border-color: var(--cpc-colors-border);position:relative;background:var(--cpc-panel-selected-color);border-radius:4px;box-shadow:0 0 0 1px var(--cpc-panel-selected-border-color)}.cpc-panel.cpc-panel_background-light-blue{--cpc-panel-selected-color: var(--cpc-colors-light-blue-2);--cpc-panel-selected-border-color: var(--cpc-colors-light-blue)}.cpc-panel.cpc-panel_background-light-green{--cpc-panel-selected-color: var(--cpc-colors-light-green-2);--cpc-panel-selected-border-color: var(--cpc-colors-light-green)}.cpc-panel.cpc-panel_background-light-peach{--cpc-panel-selected-color: var(--cpc-colors-light-peach-2);--cpc-panel-selected-border-color: var(--cpc-colors-light-peach)}.cpc-panel.cpc-panel_background-light-teal{--cpc-panel-selected-color: var(--cpc-colors-light-teal);--cpc-panel-selected-border-color: var(--cpc-colors-border)}.cpc-panel.cpc-panel_background-dark-yellow{--cpc-panel-selected-color: var(--cpc-colors-dark-yellow);--cpc-panel-selected-border-color: var(--cpc-colors-banana-mania)}.cpc-panel.cpc-panel_padding-x-default{padding-right:24px;padding-left:24px}@media screen and (min-width: 992px){.cpc-panel.cpc-panel_padding-x-default{padding-right:32px;padding-left:32px}}.cpc-panel.cpc-panel_padding-y-default{padding-top:24px;padding-bottom:24px}@media screen and (min-width: 992px){.cpc-panel.cpc-panel_padding-y-default{padding-top:32px;padding-bottom:32px}}.cpc-panel.cpc-panel_col-1{width:8.3333333333%;max-width:8.3333333333%}.cpc-panel.cpc-panel_col-2{width:16.6666666667%;max-width:16.6666666667%}.cpc-panel.cpc-panel_col-3{width:25%;max-width:25%}.cpc-panel.cpc-panel_col-4{width:33.3333333333%;max-width:33.3333333333%}.cpc-panel.cpc-panel_col-5{width:41.6666666667%;max-width:41.6666666667%}.cpc-panel.cpc-panel_col-6{width:50%;max-width:50%}.cpc-panel.cpc-panel_col-7{width:58.3333333333%;max-width:58.3333333333%}.cpc-panel.cpc-panel_col-8{width:66.6666666667%;max-width:66.6666666667%}.cpc-panel.cpc-panel_col-9{width:75%;max-width:75%}.cpc-panel.cpc-panel_col-10{width:83.3333333333%;max-width:83.3333333333%}.cpc-panel.cpc-panel_col-11{width:91.6666666667%;max-width:91.6666666667%}.cpc-panel.cpc-panel_col-12{width:100%;max-width:100%}.cpc-panel .cpc-panel_indent-shape{position:absolute;top:100%;left:50%;z-index:1020;display:block;color:var(--cpc-panel-selected-color);font-size:22px;line-height:1;text-shadow:0px -1px var(--cpc-colors-border);transform:translateY(-4px) scaleX(2.5) rotate(180deg)}\n"] }]
    }], null, { background: [{
            type: Input
        }], col: [{
            type: Input
        }], paddingX: [{
            type: Input
        }], paddingY: [{
            type: Input
        }], template: [{
            type: ViewChild,
            args: [TemplateRef]
        }], refSingle: [{
            type: ViewChild,
            args: ['refSingle']
        }], windowResize: [{
            type: HostListener,
            args: ['window:resize', ['$event']]
        }] }); })();

const _c0$n = ["ref"];
function PanelGroupComponent_ng_container_2_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function PanelGroupComponent_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PanelGroupComponent_ng_container_2_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    const panel_r2 = ctx_r6.$implicit;
    const index_r3 = ctx_r6.index;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", panel_r2.template)("ngTemplateOutletContext", ctx_r4.getContext(index_r3));
} }
function PanelGroupComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PanelGroupComponent_ng_container_2_ng_container_1_Template, 2, 2, "ng-container", 3);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const panel_r2 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", panel_r2 && panel_r2.template);
} }
const AFTER_CONTENT_INIT_TIMEOUT_IN_MS = 0;
class PanelGroupComponent {
    constructor(cdRef) {
        this.cdRef = cdRef;
        this.panels = [];
        this.context = { border: '1010' };
    }
    ngAfterContentInit() {
        setTimeout(() => {
            if (!this.childrenPanels) {
                return;
            }
            this.panels = this.childrenPanels.toArray();
            this.cdRef.detectChanges();
        }, AFTER_CONTENT_INIT_TIMEOUT_IN_MS);
    }
    getContext(index) {
        const panel = this.panels[index];
        const panelsCol = this.panels.map(({ col }) => Number(col));
        const template = createTemplate(panelsCol);
        const current = template.inline[index];
        return {
            border: setBorders(Number(panel.col), index, template),
            row: current.row,
            ref: this.ref,
        };
    }
}
PanelGroupComponent.ɵfac = function PanelGroupComponent_Factory(t) { return new (t || PanelGroupComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
PanelGroupComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PanelGroupComponent, selectors: [["cpc-panel-group"]], contentQueries: function PanelGroupComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        i0.ɵɵcontentQuery(dirIndex, PanelComponent, 4);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.childrenPanels = _t);
    } }, viewQuery: function PanelGroupComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$n, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.ref = _t.first);
    } }, decls: 3, vars: 1, consts: [[1, "cpc-panel-group"], ["ref", ""], [4, "ngFor", "ngForOf"], [4, "ngIf"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"]], template: function PanelGroupComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0, 1);
        i0.ɵɵtemplate(2, PanelGroupComponent_ng_container_2_Template, 2, 1, "ng-container", 2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.panels);
    } }, dependencies: [i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet], styles: [".cpc-panel-group{position:relative;width:100%;display:flex;justify-content:stretch;align-items:center;flex-direction:column;flex-wrap:wrap;border-radius:4px}@media screen and (min-width: 320px){.cpc-panel-group{width:auto;display:flex;align-items:stretch;justify-content:center;flex-direction:row;flex-wrap:wrap}}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PanelGroupComponent, [{
        type: Component,
        args: [{ selector: 'cpc-panel-group', encapsulation: ViewEncapsulation.None, template: "<div class=\"cpc-panel-group\" #ref>\r\n  <ng-container *ngFor=\"let panel of panels; let index = index\">\r\n    <ng-container\r\n      *ngIf=\"panel && panel.template\">\r\n      <ng-container *ngTemplateOutlet=\"panel.template; context: getContext(index)\"></ng-container>\r\n    </ng-container>\r\n  </ng-container>\r\n</div>\r\n", styles: [".cpc-panel-group{position:relative;width:100%;display:flex;justify-content:stretch;align-items:center;flex-direction:column;flex-wrap:wrap;border-radius:4px}@media screen and (min-width: 320px){.cpc-panel-group{width:auto;display:flex;align-items:stretch;justify-content:center;flex-direction:row;flex-wrap:wrap}}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }]; }, { childrenPanels: [{
            type: ContentChildren,
            args: [PanelComponent]
        }], ref: [{
            type: ViewChild,
            args: ['ref']
        }] }); })();

const _c0$m = function (a0, a1) { return { selected: a0, disabled: a1 }; };
const _c1$c = ["*"];
class PaymentButtonComponent {
    constructor() {
        this.selected = false;
        this.disabled = false;
        this.size = 'flexible';
    }
    ngOnChanges() {
        const classListArray = ['cpc-payment-button'];
        if (this.size) {
            classListArray.push(`cpc-payment-button_size-${this.size}`);
        }
        this.classList = classListArray.join(' ');
    }
}
PaymentButtonComponent.ɵfac = function PaymentButtonComponent_Factory(t) { return new (t || PaymentButtonComponent)(); };
PaymentButtonComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PaymentButtonComponent, selectors: [["cpc-payment-button"]], inputs: { selected: "selected", disabled: "disabled", size: "size" }, features: [i0.ɵɵNgOnChangesFeature], ngContentSelectors: _c1$c, decls: 2, vars: 7, consts: [[3, "ngClass", "disabled"]], template: function PaymentButtonComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "button", 0);
        i0.ɵɵprojection(1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵclassMap(ctx.classList);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(4, _c0$m, ctx.selected, ctx.disabled))("disabled", ctx.disabled);
    } }, dependencies: [i1.NgClass], styles: [".cpc-payment-button[_ngcontent-%COMP%]{display:flex;flex-direction:column;flex-wrap:nowrap;align-items:center;justify-content:center;width:auto;height:auto;padding:40px 16px;font-weight:400;font-size:14px;background:transparent;border:solid 1px var(--cpc-colors-resolution-blue);border-radius:6px;cursor:pointer;transition:all 125ms linear}.cpc-payment-button[_ngcontent-%COMP%]:hover, .cpc-payment-button[_ngcontent-%COMP%]:active{background:var(--cpc-colors-light-blue-2)}.cpc-payment-button.selected[_ngcontent-%COMP%], .cpc-payment-button[_ngcontent-%COMP%]:active{padding:39px 15px;font-weight:700;font-size:14px;background:var(--cpc-colors-light-blue-2);border-color:var(--cpc-colors-blue);border-width:2px}.cpc-payment-button[_ngcontent-%COMP%]:focus, .cpc-payment-button.pseudo-states--focus[_ngcontent-%COMP%]{outline:0;box-shadow:var(--focus-box-shadow, 0 0 0 2px #fff, 0 0 0 6px #009de6)}.cpc-payment-button.disabled[_ngcontent-%COMP%]{padding:40px 16px!important;font-weight:400!important;font-size:14px!important;background:transparent!important;border:solid 1px var(--cpc-colors-resolution-blue)!important;cursor:default!important;opacity:.7!important}.cpc-payment-button.cpc-payment-button_size-small[_ngcontent-%COMP%]{min-width:140px;min-height:80px}.cpc-payment-button.cpc-payment-button_size-flexible-small[_ngcontent-%COMP%]{width:100%;min-height:80px}.cpc-payment-button.cpc-payment-button_size-flexible[_ngcontent-%COMP%]{width:100%}.cpc-payment-button.cpc-payment-button_size-flexible-big[_ngcontent-%COMP%]{width:100%;min-height:144px}.cpc-payment-button.cpc-payment-button_size-big[_ngcontent-%COMP%]{min-width:140px;min-height:144px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PaymentButtonComponent, [{
        type: Component,
        args: [{ selector: 'cpc-payment-button', template: "<button\r\n  [ngClass]=\"{ selected: selected, disabled: disabled }\"\r\n  [disabled]=\"disabled\"\r\n  [class]=\"classList\"\r\n>\r\n  <ng-content></ng-content>\r\n</button>\r\n", styles: [".cpc-payment-button{display:flex;flex-direction:column;flex-wrap:nowrap;align-items:center;justify-content:center;width:auto;height:auto;padding:40px 16px;font-weight:400;font-size:14px;background:transparent;border:solid 1px var(--cpc-colors-resolution-blue);border-radius:6px;cursor:pointer;transition:all 125ms linear}.cpc-payment-button:hover,.cpc-payment-button:active{background:var(--cpc-colors-light-blue-2)}.cpc-payment-button.selected,.cpc-payment-button:active{padding:39px 15px;font-weight:700;font-size:14px;background:var(--cpc-colors-light-blue-2);border-color:var(--cpc-colors-blue);border-width:2px}.cpc-payment-button:focus,.cpc-payment-button.pseudo-states--focus{outline:0;box-shadow:var(--focus-box-shadow, 0 0 0 2px #fff, 0 0 0 6px #009de6)}.cpc-payment-button.disabled{padding:40px 16px!important;font-weight:400!important;font-size:14px!important;background:transparent!important;border:solid 1px var(--cpc-colors-resolution-blue)!important;cursor:default!important;opacity:.7!important}.cpc-payment-button.cpc-payment-button_size-small{min-width:140px;min-height:80px}.cpc-payment-button.cpc-payment-button_size-flexible-small{width:100%;min-height:80px}.cpc-payment-button.cpc-payment-button_size-flexible{width:100%}.cpc-payment-button.cpc-payment-button_size-flexible-big{width:100%;min-height:144px}.cpc-payment-button.cpc-payment-button_size-big{min-width:140px;min-height:144px}\n"] }]
    }], null, { selected: [{
            type: Input
        }], disabled: [{
            type: Input
        }], size: [{
            type: Input
        }] }); })();

function PaymentsRowComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7)(1, "span", 1);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵprojection(3, 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.headerColLabels && ctx_r0.headerColLabels.date);
} }
function PaymentsRowComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "span", 1);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵprojection(3, 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.headerColLabels && ctx_r1.headerColLabels.method);
} }
function PaymentsRowComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵprojection(1, 5);
    i0.ɵɵelementEnd();
} }
const _c0$l = [[["", "badge", ""]], [["", "due", ""]], [["", "amount", ""]], [["", "date", ""]], [["", "method", ""]], [["", "pay", ""]]];
const _c1$b = ["[badge]", "[due]", "[amount]", "[date]", "[method]", "[pay]"];
var CpcPaymentsRowVariants;
(function (CpcPaymentsRowVariants) {
    CpcPaymentsRowVariants["Success"] = "success";
    CpcPaymentsRowVariants["Danger"] = "danger";
    CpcPaymentsRowVariants["Warning"] = "warning";
})(CpcPaymentsRowVariants || (CpcPaymentsRowVariants = {}));
class PaymentsRowComponent {
    constructor() {
        this.variant = CpcPaymentsRowVariants.Success;
        this.headerColLabels = {
            status: 'Status',
            due: 'Due date',
            date: 'Payment date',
            method: 'Payment method',
            amount: 'Amount',
        };
        this.paymentsVariants = CpcPaymentsRowVariants;
    }
}
PaymentsRowComponent.ɵfac = function PaymentsRowComponent_Factory(t) { return new (t || PaymentsRowComponent)(); };
PaymentsRowComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PaymentsRowComponent, selectors: [["cpc-payment-row"]], inputs: { variant: "variant", headerColLabels: "headerColLabels" }, ngContentSelectors: _c1$b, decls: 16, vars: 9, consts: [[1, "cpc-payment-row-badge"], [1, "cpc-payment-row-badge_text"], [1, "cpc-payment-row-due"], ["class", "cpc-payment-row-date", 4, "ngIf"], ["class", "cpc-payment-row-method", 4, "ngIf"], [1, "cpc-payment-row-amount"], ["class", "cpc-payment-row-pay", 4, "ngIf"], [1, "cpc-payment-row-date"], [1, "cpc-payment-row-method"], [1, "cpc-payment-row-pay"]], template: function PaymentsRowComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef(_c0$l);
        i0.ɵɵelementStart(0, "div")(1, "div", 0)(2, "span", 1);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵprojection(4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 2)(6, "span", 1);
        i0.ɵɵtext(7);
        i0.ɵɵelementEnd();
        i0.ɵɵprojection(8, 1);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(9, PaymentsRowComponent_div_9_Template, 4, 1, "div", 3);
        i0.ɵɵtemplate(10, PaymentsRowComponent_div_10_Template, 4, 1, "div", 4);
        i0.ɵɵelementStart(11, "div", 5)(12, "span", 1);
        i0.ɵɵtext(13);
        i0.ɵɵelementEnd();
        i0.ɵɵprojection(14, 2);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(15, PaymentsRowComponent_div_15_Template, 2, 0, "div", 6);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵclassMapInterpolate1("cpc-payment-row cpc-payment-row--variant-", ctx.variant, "");
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.headerColLabels && ctx.headerColLabels.status);
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate(ctx.headerColLabels && ctx.headerColLabels.due);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.variant === "success");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.variant === "success");
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.headerColLabels && ctx.headerColLabels.amount);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.variant !== "success");
    } }, dependencies: [i1.NgIf], styles: [".cpc-payment-row-wrapper{display:flex}.cpc-payment-row{display:inline-grid;grid-row-gap:8px;grid-template-rows:1fr 1fr 1fr 1fr 1fr;align-items:center;justify-items:center;width:100%;min-height:89px;padding:32px 0 24px}.cpc-payment-row .cpc-button{width:100%!important;min-width:120px}.cpc-payment-row>div{display:flex;align-items:center;justify-content:space-between;justify-items:stretch;width:100%}.cpc-payment-row>div>span{font-weight:700}@media screen and (min-width: 704px){.cpc-payment-row{grid-template-rows:unset;grid-template-columns:2fr 2fr 2fr 2fr 2fr;border:var(--cpc-border);border-radius:4px}.cpc-payment-row :last-child{justify-content:flex-end}.cpc-payment-row>div{padding:0 24.5px}.cpc-payment-row>div>span{font-weight:400}}.cpc-payment-row-amount>span:not(:first-of-type){font-weight:700!important}.cpc-payment-row--variant-danger{grid-template-rows:1fr 1fr 1fr;grid-template-columns:unset;padding:32px 24px 24px;background:var(--cpc-payments-background-danger-panel);border:1px solid var(--cpc-payments-danger-border);border-top-left-radius:4px;border-top-right-radius:4px}.cpc-payment-row--variant-danger .cpc-payment-row-badge{order:-1}@media screen and (min-width: 704px){.cpc-payment-row--variant-danger .cpc-payment-row-badge{order:unset}}.cpc-payment-row--variant-danger .cpc-payment-row-amount{order:-1}@media screen and (min-width: 704px){.cpc-payment-row--variant-danger .cpc-payment-row-amount{justify-content:flex-end;order:unset;padding:0}}@media screen and (min-width: 704px){.cpc-payment-row--variant-danger{grid-template-rows:unset;grid-template-columns:3fr 7fr 2fr 3fr!important;padding:32px 0 24px}}.cpc-payment-row--variant-warning{grid-template-rows:1fr 1fr 1fr;grid-template-columns:unset}.cpc-payment-row--variant-warning .cpc-payment-row-badge,.cpc-payment-row--variant-warning .cpc-payment-row-amount{order:-1}@media screen and (min-width: 704px){.cpc-payment-row--variant-warning .cpc-payment-row-amount{justify-content:flex-end;order:unset;padding:0}}@media screen and (min-width: 704px){.cpc-payment-row--variant-warning{grid-template-rows:unset;grid-template-columns:3fr 7fr 2fr 3fr!important}}.cpc-payment-row-pay{display:flex;justify-content:flex-end!important}@media screen and (min-width: 704px){.cpc-payment-row-pay .cpc-button{padding:0!important}}@media screen and (min-width: 992px){.cpc-payment-row-pay .cpc-button{padding:calc(8px - var(--button-border-width)) calc(16px - var(--button-border-width))!important}}.cpc-payment-row-badge_text{font-weight:400!important}@media screen and (min-width: 704px){.cpc-payment-row-badge_text{display:none}}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PaymentsRowComponent, [{
        type: Component,
        args: [{ selector: 'cpc-payment-row', encapsulation: ViewEncapsulation.None, template: "<div class=\"cpc-payment-row cpc-payment-row--variant-{{variant}}\">\r\n  <div class=\"cpc-payment-row-badge\">\r\n    <span class=\"cpc-payment-row-badge_text\">{{ headerColLabels && headerColLabels.status }}</span>\r\n    <ng-content select=\"[badge]\"></ng-content>\r\n  </div>\r\n  <div class=\"cpc-payment-row-due\">\r\n    <span class=\"cpc-payment-row-badge_text\">{{ headerColLabels && headerColLabels.due }}</span>\r\n    <ng-content select=\"[due]\"></ng-content>\r\n  </div>\r\n  <div *ngIf=\"variant === 'success'\" class=\"cpc-payment-row-date\">\r\n    <span class=\"cpc-payment-row-badge_text\">{{ headerColLabels && headerColLabels.date }}</span>\r\n    <ng-content select=\"[date]\"></ng-content>\r\n  </div>\r\n  <div *ngIf=\"variant === 'success'\" class=\"cpc-payment-row-method\">\r\n    <span class=\"cpc-payment-row-badge_text\">{{ headerColLabels && headerColLabels.method }}</span>\r\n    <ng-content select=\"[method]\"></ng-content>\r\n  </div>\r\n  <div class=\"cpc-payment-row-amount\">\r\n    <span class=\"cpc-payment-row-badge_text\">{{ headerColLabels && headerColLabels.amount }}</span>\r\n    <ng-content select=\"[amount]\"></ng-content>\r\n  </div>\r\n  <div *ngIf=\"variant !== 'success'\" class=\"cpc-payment-row-pay\">\r\n    <ng-content select=\"[pay]\"></ng-content>\r\n  </div>\r\n</div>\r\n", styles: [".cpc-payment-row-wrapper{display:flex}.cpc-payment-row{display:inline-grid;grid-row-gap:8px;grid-template-rows:1fr 1fr 1fr 1fr 1fr;align-items:center;justify-items:center;width:100%;min-height:89px;padding:32px 0 24px}.cpc-payment-row .cpc-button{width:100%!important;min-width:120px}.cpc-payment-row>div{display:flex;align-items:center;justify-content:space-between;justify-items:stretch;width:100%}.cpc-payment-row>div>span{font-weight:700}@media screen and (min-width: 704px){.cpc-payment-row{grid-template-rows:unset;grid-template-columns:2fr 2fr 2fr 2fr 2fr;border:var(--cpc-border);border-radius:4px}.cpc-payment-row :last-child{justify-content:flex-end}.cpc-payment-row>div{padding:0 24.5px}.cpc-payment-row>div>span{font-weight:400}}.cpc-payment-row-amount>span:not(:first-of-type){font-weight:700!important}.cpc-payment-row--variant-danger{grid-template-rows:1fr 1fr 1fr;grid-template-columns:unset;padding:32px 24px 24px;background:var(--cpc-payments-background-danger-panel);border:1px solid var(--cpc-payments-danger-border);border-top-left-radius:4px;border-top-right-radius:4px}.cpc-payment-row--variant-danger .cpc-payment-row-badge{order:-1}@media screen and (min-width: 704px){.cpc-payment-row--variant-danger .cpc-payment-row-badge{order:unset}}.cpc-payment-row--variant-danger .cpc-payment-row-amount{order:-1}@media screen and (min-width: 704px){.cpc-payment-row--variant-danger .cpc-payment-row-amount{justify-content:flex-end;order:unset;padding:0}}@media screen and (min-width: 704px){.cpc-payment-row--variant-danger{grid-template-rows:unset;grid-template-columns:3fr 7fr 2fr 3fr!important;padding:32px 0 24px}}.cpc-payment-row--variant-warning{grid-template-rows:1fr 1fr 1fr;grid-template-columns:unset}.cpc-payment-row--variant-warning .cpc-payment-row-badge,.cpc-payment-row--variant-warning .cpc-payment-row-amount{order:-1}@media screen and (min-width: 704px){.cpc-payment-row--variant-warning .cpc-payment-row-amount{justify-content:flex-end;order:unset;padding:0}}@media screen and (min-width: 704px){.cpc-payment-row--variant-warning{grid-template-rows:unset;grid-template-columns:3fr 7fr 2fr 3fr!important}}.cpc-payment-row-pay{display:flex;justify-content:flex-end!important}@media screen and (min-width: 704px){.cpc-payment-row-pay .cpc-button{padding:0!important}}@media screen and (min-width: 992px){.cpc-payment-row-pay .cpc-button{padding:calc(8px - var(--button-border-width)) calc(16px - var(--button-border-width))!important}}.cpc-payment-row-badge_text{font-weight:400!important}@media screen and (min-width: 704px){.cpc-payment-row-badge_text{display:none}}\n"] }]
    }], null, { variant: [{
            type: Input
        }], headerColLabels: [{
            type: Input
        }] }); })();

function PaymentsTableComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6)(1, "div", 7);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 8);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 9);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 10);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 11);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.headerColLabels && ctx_r0.headerColLabels.status);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.headerColLabels && ctx_r0.headerColLabels.due);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.headerColLabels && ctx_r0.headerColLabels.date);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.headerColLabels && ctx_r0.headerColLabels.method);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.headerColLabels && ctx_r0.headerColLabels.amount);
} }
function PaymentsTableComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12)(1, "div", 7);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 8);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 11);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(7, "div", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.headerColLabels && ctx_r1.headerColLabels.status);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.headerColLabels && ctx_r1.headerColLabels.due);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.headerColLabels && ctx_r1.headerColLabels.amount);
} }
function PaymentsTableComponent_cpc_payment_row_4_cpc_badge_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "cpc-badge", 22);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "titlecase");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const paymentItem_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("variant", paymentItem_r3.badgeVariant);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.titleCase ? i0.ɵɵpipeBind1(2, 2, paymentItem_r3.variant) : paymentItem_r3.variant, " ");
} }
function PaymentsTableComponent_cpc_payment_row_4_ng_template_2_cpc_badge_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "cpc-badge", 22);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "titlecase");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const paymentItem_r3 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵproperty("variant", ctx_r8.variantRow);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r8.titleCase ? i0.ɵɵpipeBind1(2, 2, paymentItem_r3.variant) : paymentItem_r3.variant, " ");
} }
function PaymentsTableComponent_cpc_payment_row_4_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, PaymentsTableComponent_cpc_payment_row_4_ng_template_2_cpc_badge_0_Template, 3, 4, "cpc-badge", 23);
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r6.variantRow);
} }
function PaymentsTableComponent_cpc_payment_row_4_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cpc-payment-row", 14);
    i0.ɵɵtemplate(1, PaymentsTableComponent_cpc_payment_row_4_cpc_badge_1_Template, 3, 4, "cpc-badge", 15);
    i0.ɵɵtemplate(2, PaymentsTableComponent_cpc_payment_row_4_ng_template_2_Template, 1, 1, "ng-template", null, 16, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementStart(4, "span", 17);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span", 18);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "span", 19);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "span", 20);
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "cpc-button", 21);
    i0.ɵɵlistener("click", function PaymentsTableComponent_cpc_payment_row_4_Template_cpc_button_click_12_listener() { const restoredCtx = i0.ɵɵrestoreView(_r11); const paymentItem_r3 = restoredCtx.$implicit; const ctx_r10 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r10.handlePay(paymentItem_r3)); });
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const paymentItem_r3 = ctx.$implicit;
    const _r5 = i0.ɵɵreference(3);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("variant", paymentItem_r3.badgeVariant ? paymentItem_r3.badgeVariant : ctx_r2.variantRow)("headerColLabels", ctx_r2.headerColLabels);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", paymentItem_r3.badgeVariant)("ngIfElse", _r5);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(paymentItem_r3.due);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(paymentItem_r3.date);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(paymentItem_r3.method);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(paymentItem_r3.amount);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("noVerticalMargin", true)("noHorizontalMargin", true)("disabled", ctx_r2.variant === "past");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.variant === "upcoming" ? ctx_r2.copyPayNow : ctx_r2.copyPaid, " ");
} }
var CpcPaymentsGroupVariants;
(function (CpcPaymentsGroupVariants) {
    CpcPaymentsGroupVariants["Past"] = "past";
    CpcPaymentsGroupVariants["Upcoming"] = "upcoming";
    CpcPaymentsGroupVariants["Overdue"] = "overdue";
})(CpcPaymentsGroupVariants || (CpcPaymentsGroupVariants = {}));
class PaymentsTableComponent {
    constructor(cdr) {
        this.cdr = cdr;
        this.variant = CpcPaymentsGroupVariants.Past;
        this.copyItemPerPage = 'Show per page:';
        this.copyPrev = 'PREVIOUS';
        this.copyOf = 'of';
        this.copyNext = 'NEXT';
        this.copyTotal = 'TOTAL';
        this.copyClaims = 'CLAIMS';
        this.copySortBy = 'Sort by';
        this.copyPayNow = 'Pay now';
        this.copyPaid = 'Paid';
        this.itemsPerPage = 5;
        this.titleCase = true;
        this.paginationOptions = ['5', '10', '25', '50', '100'];
        this.clickPay = new EventEmitter();
        this.paymentsVariants = CpcPaymentsGroupVariants;
        this.paymentsTableVariants = CpcPaymentsRowVariants;
        this.page = 0;
        this.variantRow = CpcPaymentsRowVariants.Success;
    }
    ngAfterViewInit() {
        this.cdr.detectChanges();
    }
    ngOnChanges() {
        this.updateMaxPage();
        this.updatePaymentsFiltered();
        this.handleRowVariants(this.variant);
    }
    updateMaxPage() {
        this.maxPage = Math.ceil(this.paymentsList.length / this.itemsPerPage - 1);
        this.updatePaymentsFiltered();
    }
    handleChangePage(page) {
        const minPage = 0;
        this.updateMaxPage();
        switch (page) {
            case PaginationDirections.Next:
                this.page = clamp(this.page + 1, minPage, this.maxPage);
                break;
            case PaginationDirections.Prev:
                this.page = clamp(this.page - 1, minPage, this.maxPage);
                break;
            default:
                this.page = clamp(this.page, minPage, this.maxPage);
        }
        this.updatePaymentsFiltered();
    }
    handleChangeItemsPerPage(value) {
        this.itemsPerPage = value;
        this.updateMaxPage();
    }
    updatePaymentsFiltered() {
        let startValue = this.page * this.itemsPerPage;
        const itemsToShowAmount = this.itemsPerPage;
        if (startValue > this.paymentsList.length) {
            startValue = 0;
        }
        this.paymentsFiltered = this.paymentsList.slice(startValue, startValue + itemsToShowAmount);
    }
    handlePay(paymentItem) {
        if (this.variant === CpcPaymentsGroupVariants.Past) {
            return;
        }
        this.clickPay.emit(paymentItem);
    }
    handleRowVariants(tableVariant) {
        switch (tableVariant) {
            case CpcPaymentsGroupVariants.Past:
                this.variantRow = CpcPaymentsRowVariants.Success;
                break;
            case CpcPaymentsGroupVariants.Upcoming:
                this.variantRow = CpcPaymentsRowVariants.Warning;
                break;
            default:
                this.variantRow = CpcPaymentsRowVariants.Success;
        }
    }
}
PaymentsTableComponent.ɵfac = function PaymentsTableComponent_Factory(t) { return new (t || PaymentsTableComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
PaymentsTableComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PaymentsTableComponent, selectors: [["cpc-payment-group"]], inputs: { variant: "variant", headerColLabels: "headerColLabels", copyItemPerPage: "copyItemPerPage", copyPrev: "copyPrev", copyOf: "copyOf", copyNext: "copyNext", copyTotal: "copyTotal", copyClaims: "copyClaims", copySortBy: "copySortBy", copyPayNow: "copyPayNow", copyPaid: "copyPaid", paymentsList: "paymentsList", itemsPerPage: "itemsPerPage", titleCase: "titleCase", paginationOptions: "paginationOptions" }, outputs: { clickPay: "clickPay" }, features: [i0.ɵɵNgOnChangesFeature], decls: 6, vars: 11, consts: [[1, "cpc-payment-group"], [1, "cpc-payment-group-header-wrapper"], ["class", "cpc-payment-group-header", 4, "ngIf"], ["class", "cpc-payment-group-header cpc-payment-group-header--variant-warning", 4, "ngIf"], [3, "variant", "headerColLabels", 4, "ngFor", "ngForOf"], [3, "page", "maxPage", "itemsPerPage", "copyItemPerPage", "copyPrev", "copyOf", "copyNext", "options", "changePage", "changeItemsPerPage"], [1, "cpc-payment-group-header"], [1, "cpc-payment-row-status"], [1, "cpc-payment-row-due"], [1, "cpc-payment-row-date"], [1, "cpc-payment-row-method"], [1, "cpc-payment-row-amount"], [1, "cpc-payment-group-header", "cpc-payment-group-header--variant-warning"], [1, "cpc-payment-row-pay"], [3, "variant", "headerColLabels"], ["badge", "", 3, "variant", 4, "ngIf", "ngIfElse"], ["variantEl", ""], ["due", ""], ["date", ""], ["method", ""], ["amount", ""], ["pay", "", "size", "small", 3, "noVerticalMargin", "noHorizontalMargin", "disabled", "click"], ["badge", "", 3, "variant"], ["badge", "", 3, "variant", 4, "ngIf"]], template: function PaymentsTableComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵtemplate(2, PaymentsTableComponent_div_2_Template, 11, 5, "div", 2);
        i0.ɵɵtemplate(3, PaymentsTableComponent_div_3_Template, 8, 3, "div", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, PaymentsTableComponent_cpc_payment_row_4_Template, 14, 12, "cpc-payment-row", 4);
        i0.ɵɵelementStart(5, "cpc-pagination", 5);
        i0.ɵɵlistener("changePage", function PaymentsTableComponent_Template_cpc_pagination_changePage_5_listener($event) { return ctx.handleChangePage($event); })("changeItemsPerPage", function PaymentsTableComponent_Template_cpc_pagination_changeItemsPerPage_5_listener($event) { return ctx.handleChangeItemsPerPage($event); });
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.variant === "past");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.variant === ctx.paymentsVariants.Upcoming || ctx.variant === ctx.paymentsVariants.Overdue);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.paymentsFiltered);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("page", ctx.page)("maxPage", ctx.maxPage)("itemsPerPage", ctx.itemsPerPage)("copyItemPerPage", ctx.copyItemPerPage)("copyPrev", ctx.copyPrev)("copyOf", ctx.copyOf)("copyNext", ctx.copyNext)("options", ctx.paginationOptions);
    } }, styles: [".cpc-payment-group-header-wrapper{display:none;justify-content:center;width:100%;min-height:39px;padding:0 24px;border-bottom:1px solid var(--cpc-colors-border)}@media screen and (min-width: 704px){.cpc-payment-group-header-wrapper{display:flex}}.cpc-payment-group-header{display:inline-grid;grid-template-columns:2fr 2fr 2fr 2fr 2fr;align-items:center;justify-items:center;width:100%;font-weight:600}.cpc-payment-group-header>div{display:flex;align-items:center;justify-content:space-between;justify-items:stretch;width:100%;padding-left:var(--invesments-row-padding-left);white-space:nowrap}.cpc-payment-group-header>div:last-of-type{padding-right:24.5px}@media screen and (min-width: 704px){.cpc-payment-group-header :last-child{justify-content:flex-end}}.cpc-payment-group-header--variant-warning{grid-template-columns:3fr 7fr 2fr 3fr!important}.cpc-payment-group-header--variant-warning .cpc-payment-row-amount{justify-content:flex-end!important;padding:0!important}@media screen and (min-width: 704px){.cpc-payment-group-header--variant-warning{grid-template-columns:1.5fr 1.5fr 2fr 4fr 2fr}}cpc-payment-row{display:flex}cpc-payment-row .cpc-payment-row{border-bottom:1px solid var(--cpc-colors-border)}cpc-payment-row .cpc-payment-row--variant-danger{border-bottom:1px solid var(--cpc-payments-danger-border)}@media screen and (min-width: 704px){cpc-payment-row{margin:24px}}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PaymentsTableComponent, [{
        type: Component,
        args: [{ selector: 'cpc-payment-group', encapsulation: ViewEncapsulation.None, template: "<div class=\"cpc-payment-group\">\r\n  <div class=\"cpc-payment-group-header-wrapper \">\r\n    <div\r\n      *ngIf=\"variant === 'past'\"\r\n      class=\"cpc-payment-group-header\"\r\n    >\r\n      <div class=\"cpc-payment-row-status\">{{ headerColLabels && headerColLabels.status }}</div>\r\n      <div class=\"cpc-payment-row-due\">{{ headerColLabels && headerColLabels.due }}</div>\r\n      <div class=\"cpc-payment-row-date\">{{ headerColLabels && headerColLabels.date }}</div>\r\n      <div class=\"cpc-payment-row-method\">{{ headerColLabels && headerColLabels.method }}</div>\r\n      <div class=\"cpc-payment-row-amount\">{{ headerColLabels && headerColLabels.amount }}</div>\r\n    </div>\r\n\r\n    <div\r\n      *ngIf=\"variant === paymentsVariants.Upcoming || variant === paymentsVariants.Overdue\"\r\n      class=\"cpc-payment-group-header cpc-payment-group-header--variant-warning\"\r\n    >\r\n      <div class=\"cpc-payment-row-status\">{{ headerColLabels && headerColLabels.status }}</div>\r\n      <div class=\"cpc-payment-row-due\">{{ headerColLabels && headerColLabels.due }}</div>\r\n      <div class=\"cpc-payment-row-amount\">{{ headerColLabels && headerColLabels.amount }}</div>\r\n      <div class=\"cpc-payment-row-pay\"></div>\r\n    </div>\r\n  </div>\r\n\r\n  <cpc-payment-row\r\n    *ngFor=\"let paymentItem of paymentsFiltered;\"\r\n    [variant]=\"paymentItem.badgeVariant ? paymentItem.badgeVariant : variantRow\"\r\n    [headerColLabels]=\"headerColLabels\"\r\n  >\r\n    <cpc-badge\r\n      *ngIf=\"paymentItem.badgeVariant; else variantEl\"\r\n      [variant]=\"paymentItem.badgeVariant\"\r\n      badge\r\n    >\r\n      {{ titleCase ? (paymentItem.variant | titlecase) : paymentItem.variant }}\r\n    </cpc-badge>\r\n    <ng-template #variantEl>\r\n      <cpc-badge\r\n        *ngIf=\"variantRow\"\r\n        [variant]=\"variantRow\"\r\n        badge\r\n      >\r\n        {{ titleCase ? (paymentItem.variant | titlecase) : paymentItem.variant }}\r\n      </cpc-badge>\r\n    </ng-template>\r\n    <span due>{{ paymentItem.due }}</span>\r\n    <span date>{{ paymentItem.date }}</span>\r\n    <span method>{{ paymentItem.method }}</span>\r\n    <span amount>{{ paymentItem.amount }}</span>\r\n    <cpc-button\r\n      pay size=\"small\"\r\n      [noVerticalMargin]=\"true\"\r\n      [noHorizontalMargin]=\"true\"\r\n      [disabled]=\"variant === 'past'\"\r\n      (click)=\"handlePay(paymentItem)\"\r\n    >\r\n      {{ variant === 'upcoming' ? copyPayNow : copyPaid }}\r\n    </cpc-button>\r\n  </cpc-payment-row>\r\n\r\n  <cpc-pagination\r\n    [page]='page'\r\n    [maxPage]='maxPage'\r\n    [itemsPerPage]='itemsPerPage'\r\n    [copyItemPerPage]='copyItemPerPage'\r\n    [copyPrev]='copyPrev'\r\n    [copyOf]='copyOf'\r\n    [copyNext]='copyNext'\r\n    [options]=\"paginationOptions\"\r\n    (changePage)='handleChangePage($event)'\r\n    (changeItemsPerPage)='handleChangeItemsPerPage($event)'\r\n  ></cpc-pagination>\r\n</div>\r\n", styles: [".cpc-payment-group-header-wrapper{display:none;justify-content:center;width:100%;min-height:39px;padding:0 24px;border-bottom:1px solid var(--cpc-colors-border)}@media screen and (min-width: 704px){.cpc-payment-group-header-wrapper{display:flex}}.cpc-payment-group-header{display:inline-grid;grid-template-columns:2fr 2fr 2fr 2fr 2fr;align-items:center;justify-items:center;width:100%;font-weight:600}.cpc-payment-group-header>div{display:flex;align-items:center;justify-content:space-between;justify-items:stretch;width:100%;padding-left:var(--invesments-row-padding-left);white-space:nowrap}.cpc-payment-group-header>div:last-of-type{padding-right:24.5px}@media screen and (min-width: 704px){.cpc-payment-group-header :last-child{justify-content:flex-end}}.cpc-payment-group-header--variant-warning{grid-template-columns:3fr 7fr 2fr 3fr!important}.cpc-payment-group-header--variant-warning .cpc-payment-row-amount{justify-content:flex-end!important;padding:0!important}@media screen and (min-width: 704px){.cpc-payment-group-header--variant-warning{grid-template-columns:1.5fr 1.5fr 2fr 4fr 2fr}}cpc-payment-row{display:flex}cpc-payment-row .cpc-payment-row{border-bottom:1px solid var(--cpc-colors-border)}cpc-payment-row .cpc-payment-row--variant-danger{border-bottom:1px solid var(--cpc-payments-danger-border)}@media screen and (min-width: 704px){cpc-payment-row{margin:24px}}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }]; }, { variant: [{
            type: Input
        }], headerColLabels: [{
            type: Input
        }], copyItemPerPage: [{
            type: Input
        }], copyPrev: [{
            type: Input
        }], copyOf: [{
            type: Input
        }], copyNext: [{
            type: Input
        }], copyTotal: [{
            type: Input
        }], copyClaims: [{
            type: Input
        }], copySortBy: [{
            type: Input
        }], copyPayNow: [{
            type: Input
        }], copyPaid: [{
            type: Input
        }], paymentsList: [{
            type: Input
        }], itemsPerPage: [{
            type: Input
        }], titleCase: [{
            type: Input
        }], paginationOptions: [{
            type: Input
        }], clickPay: [{
            type: Output
        }] }); })();

const _c0$k = function (a0) { return { "cpc-phone-link_min": a0 }; };
class PhoneLinkComponent {
    constructor() {
        this.phoneNumber = '';
        this.label = '';
        this.link = '';
    }
    ngOnChanges() {
        this.link = 'tel:' + this.phoneNumberAsNumber();
    }
    phoneNumberAsNumber() {
        return this.phoneNumber.replace(/\+/g, '00').replace(/\D+/g, '');
    }
}
PhoneLinkComponent.ɵfac = function PhoneLinkComponent_Factory(t) { return new (t || PhoneLinkComponent)(); };
PhoneLinkComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PhoneLinkComponent, selectors: [["cpc-phone-link"]], inputs: { phoneNumber: "phoneNumber", label: "label", variant: "variant" }, features: [i0.ɵɵNgOnChangesFeature], decls: 6, vars: 6, consts: [[1, "cpc-phone-link", 3, "href", "ngClass"], [1, "cpc-phone-link__title"], ["aria-hidden", "true", 1, "cpc-ndbx-icon", "icon-phone-o"], [1, "cpc-phone-link__number"]], template: function PhoneLinkComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "a", 0)(1, "span", 1);
        i0.ɵɵelement(2, "i", 2);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "span", 3);
        i0.ɵɵtext(5);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵpropertyInterpolate("href", ctx.link, i0.ɵɵsanitizeUrl);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c0$k, ctx.variant === "min"));
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.label, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.phoneNumber, " ");
    } }, dependencies: [i1.NgClass], styles: [".cpc-phone-link{display:inline-flex;align-items:center;color:var(--cpc-colors-text);text-decoration:none;border-radius:4px;transition:all 125ms linear}.cpc-phone-link:focus,.cpc-phone-link.pseudo-states--focus{outline:0;box-shadow:var(--focus-box-shadow, 0 0 0 2px #fff, 0 0 0 6px #009de6)}.cpc-phone-link:hover .cpc-phone-link__title,.cpc-phone-link.pseudo-states--hover .cpc-phone-link__title{color:var(--cpc-colors-hover);text-decoration:none}.cpc-phone-link:hover:not(:disabled):not(:active) .cpc-phone-link__title,.cpc-phone-link.pseudo-states--hover .cpc-phone-link__title{color:var(--cpc-colors-hover);text-decoration:none}.cpc-phone-link:active .cpc-phone-link__title,.cpc-phone-link.pseudo-states--active .cpc-phone-link__title{color:var(--cpc-colors-hover);text-decoration:none}.cpc-phone-link .cpc-ndbx-icon{display:inline-block;margin-right:8px;font-size:24px;vertical-align:middle}.cpc-phone-link .cpc-phone-link__title{display:inline-flex;height:24px;margin-right:8px;color:var(--cpc-colors-sonic-silver);font-size:16px;line-height:24px;letter-spacing:1px}.cpc-phone-link .cpc-phone-link__title .cpc-ndbx-icon{color:var(--cpc-colors-text)}.cpc-phone-link .cpc-phone-link__number{position:relative;color:var(--cpc-colors-text);font-weight:600;font-size:16px;line-height:24px;letter-spacing:.8px;white-space:nowrap;text-decoration:none}.cpc-phone-link.cpc-phone-link_min .cpc-phone-link__number{display:none}@media screen and (min-width: 704px){.cpc-phone-link.cpc-phone-link_min .cpc-phone-link__number{display:inline-block}}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PhoneLinkComponent, [{
        type: Component,
        args: [{ selector: 'cpc-phone-link', encapsulation: ViewEncapsulation.None, template: "<a\r\n  href=\"{{link}}\"\r\n  [ngClass]=\"{ 'cpc-phone-link_min': variant === 'min' }\"\r\n  class=\"cpc-phone-link\"\r\n>\r\n  <span class=\"cpc-phone-link__title\">\r\n    <i class=\"cpc-ndbx-icon icon-phone-o\" aria-hidden=\"true\"></i>\r\n    {{label}}\r\n  </span>\r\n\r\n  <span class=\"cpc-phone-link__number\">\r\n    {{phoneNumber}}\r\n  </span>\r\n</a>\r\n", styles: [".cpc-phone-link{display:inline-flex;align-items:center;color:var(--cpc-colors-text);text-decoration:none;border-radius:4px;transition:all 125ms linear}.cpc-phone-link:focus,.cpc-phone-link.pseudo-states--focus{outline:0;box-shadow:var(--focus-box-shadow, 0 0 0 2px #fff, 0 0 0 6px #009de6)}.cpc-phone-link:hover .cpc-phone-link__title,.cpc-phone-link.pseudo-states--hover .cpc-phone-link__title{color:var(--cpc-colors-hover);text-decoration:none}.cpc-phone-link:hover:not(:disabled):not(:active) .cpc-phone-link__title,.cpc-phone-link.pseudo-states--hover .cpc-phone-link__title{color:var(--cpc-colors-hover);text-decoration:none}.cpc-phone-link:active .cpc-phone-link__title,.cpc-phone-link.pseudo-states--active .cpc-phone-link__title{color:var(--cpc-colors-hover);text-decoration:none}.cpc-phone-link .cpc-ndbx-icon{display:inline-block;margin-right:8px;font-size:24px;vertical-align:middle}.cpc-phone-link .cpc-phone-link__title{display:inline-flex;height:24px;margin-right:8px;color:var(--cpc-colors-sonic-silver);font-size:16px;line-height:24px;letter-spacing:1px}.cpc-phone-link .cpc-phone-link__title .cpc-ndbx-icon{color:var(--cpc-colors-text)}.cpc-phone-link .cpc-phone-link__number{position:relative;color:var(--cpc-colors-text);font-weight:600;font-size:16px;line-height:24px;letter-spacing:.8px;white-space:nowrap;text-decoration:none}.cpc-phone-link.cpc-phone-link_min .cpc-phone-link__number{display:none}@media screen and (min-width: 704px){.cpc-phone-link.cpc-phone-link_min .cpc-phone-link__number{display:inline-block}}\n"] }]
    }], null, { phoneNumber: [{
            type: Input
        }], label: [{
            type: Input
        }], variant: [{
            type: Input
        }] }); })();

const _c0$j = function (a0) { return { "cpc-policy-card-content_border-bottom": a0 }; };
const _c1$a = ["*"];
class PolicyCardContentComponent {
    constructor() {
        this.borderBottom = true;
    }
}
PolicyCardContentComponent.ɵfac = function PolicyCardContentComponent_Factory(t) { return new (t || PolicyCardContentComponent)(); };
PolicyCardContentComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PolicyCardContentComponent, selectors: [["cpc-policy-card-content"]], inputs: { borderBottom: "borderBottom" }, ngContentSelectors: _c1$a, decls: 2, vars: 3, consts: [[1, "cpc-policy-card-content", 3, "ngClass"]], template: function PolicyCardContentComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵprojection(1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c0$j, ctx.borderBottom));
    } }, dependencies: [i1.NgClass], styles: [".cpc-policy-card-content[_ngcontent-%COMP%]{margin:24px 24px 16px}@media screen and (min-width: 320px){.cpc-policy-card-content[_ngcontent-%COMP%]{margin:24px 32px 16px}}.cpc-policy-card-content_border-bottom[_ngcontent-%COMP%]{border-bottom:var(--cpc-policy-card-border)}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PolicyCardContentComponent, [{
        type: Component,
        args: [{ selector: 'cpc-policy-card-content', template: "<div\r\n  [ngClass]=\"{ 'cpc-policy-card-content_border-bottom': borderBottom }\"\r\n  class=\"cpc-policy-card-content\"\r\n>\r\n  <ng-content></ng-content>\r\n</div>\r\n", styles: [".cpc-policy-card-content{margin:24px 24px 16px}@media screen and (min-width: 320px){.cpc-policy-card-content{margin:24px 32px 16px}}.cpc-policy-card-content_border-bottom{border-bottom:var(--cpc-policy-card-border)}\n"] }]
    }], null, { borderBottom: [{
            type: Input
        }] }); })();

const _c0$i = ["element"];
const _c1$9 = [[["", "title", ""]], [["", "center", ""]], "*"];
const _c2$2 = function (a0) { return { "cpc-policy-card-entry_title-full-width": a0 }; };
const _c3$1 = function (a0) { return { "cpc-policy-card-entry_content-full-width": a0 }; };
const _c4 = ["[title]", "[center]", "*"];
const DEFAULT_TIMEOUT$1 = 10;
const MIN_TITLE_SIZE = 0.3;
const MAX_TITLE_SIZE = 0.7;
class PolicyCardEntryComponent {
    constructor(cardsStoreService) {
        this.cardsStoreService = cardsStoreService;
        this.type = 'policy-entry-1';
        this.footer = false;
        this.skipFromHeightAligment = false;
        this.align = 'left';
        this.alignY = 'top';
        this.overflowTitle = 'hidden';
        this.overflowContent = 'hidden';
        this.titleSize = 0.3;
        this.fullWidth = false;
        this.cardContentSize = cardsStoreService.getObservableSize(this.type);
    }
    onResize() {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        debounce(() => this.sizeUpdater(), 500)();
    }
    ngAfterViewInit() {
        this.cardContentSize = this.cardsStoreService.getObservableSize(this.type);
        setTimeout(() => {
            this.sizeUpdater();
        }, DEFAULT_TIMEOUT$1);
    }
    getTitleSize() {
        if (this.titleSize < MIN_TITLE_SIZE) {
            console.warn(`Policy card entry:: Title size value must be above ${MIN_TITLE_SIZE}`);
        }
        if (this.titleSize > MAX_TITLE_SIZE) {
            console.warn(`Policy card entry:: Title size value must be below ${MAX_TITLE_SIZE}`);
        }
        return clamp(this.titleSize, MIN_TITLE_SIZE, MAX_TITLE_SIZE);
    }
    sizeUpdater() {
        const element = this.element?.nativeElement;
        if (this.footer !== false || this.skipFromHeightAligment !== false || !element) {
            return;
        }
        setTimeout(() => {
            this.cardsStoreService.updateSize(element.clientHeight, this.type);
        }, DEFAULT_TIMEOUT$1);
    }
}
PolicyCardEntryComponent.ɵfac = function PolicyCardEntryComponent_Factory(t) { return new (t || PolicyCardEntryComponent)(i0.ɵɵdirectiveInject(CardsStoreService)); };
PolicyCardEntryComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PolicyCardEntryComponent, selectors: [["cpc-policy-card-entry"]], viewQuery: function PolicyCardEntryComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$i, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.element = _t.first);
    } }, hostBindings: function PolicyCardEntryComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("resize", function PolicyCardEntryComponent_resize_HostBindingHandler($event) { return ctx.onResize($event); }, false, i0.ɵɵresolveWindow);
    } }, inputs: { type: "type", footer: "footer", skipFromHeightAligment: "skipFromHeightAligment", align: "align", alignY: "alignY", overflowTitle: "overflowTitle", overflowContent: "overflowContent", titleSize: "titleSize", fullWidth: "fullWidth" }, ngContentSelectors: _c4, decls: 9, vars: 23, consts: [["element", ""], [3, "ngClass"], [1, "cpc-policy-card-entry_center"]], template: function PolicyCardEntryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef(_c1$9);
        i0.ɵɵelementStart(0, "div", null, 0);
        i0.ɵɵpipe(2, "async");
        i0.ɵɵelementStart(3, "div", 1);
        i0.ɵɵprojection(4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 2);
        i0.ɵɵprojection(6, 1);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 1);
        i0.ɵɵprojection(8, 2);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵstyleMapInterpolate1("--cpc-policy-card-entry-size: ", ctx.getTitleSize(), "");
        i0.ɵɵclassMapInterpolate2("cpc-policy-card-entry cpc-policy-card-entry--align-", ctx.align, "\n  cpc-policy-card-entry--align-y-", ctx.alignY, "");
        i0.ɵɵstyleProp("min-height", i0.ɵɵpipeBind1(2, 17, ctx.cardContentSize) + "px");
        i0.ɵɵadvance(3);
        i0.ɵɵclassMapInterpolate1("cpc-policy-card-entry_title\n        cpc-policy-card-entry_content--overflow-", ctx.overflowTitle, "");
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(19, _c2$2, ctx.fullWidth));
        i0.ɵɵadvance(4);
        i0.ɵɵclassMapInterpolate1("cpc-policy-card-entry_content\n     cpc-policy-card-entry_content--overflow-", ctx.overflowContent, "");
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(21, _c3$1, ctx.fullWidth));
    } }, dependencies: [i1.NgClass, i1.AsyncPipe], styles: ["cpc-policy-card-entry{width:100%}cpc-policy-card-entry .cpc-policy-card-entry{display:flex;align-content:space-between;justify-content:space-between;flex-direction:row;flex-wrap:inherit;width:100%;margin-bottom:6px;padding:2px 0;font-size:16px;line-height:1.5}cpc-policy-card-entry .cpc-policy-card-entry .cpc-policy-card-entry_title{grid-area:title;margin-right:auto}cpc-policy-card-entry .cpc-policy-card-entry .cpc-policy-card-entry_center{display:flex;flex-direction:column;grid-area:center}cpc-policy-card-entry .cpc-policy-card-entry .cpc-policy-card-entry_center>div{display:flex;justify-content:space-between}cpc-policy-card-entry .cpc-policy-card-entry .cpc-policy-card-entry_center span:last-of-type{font-weight:700}cpc-policy-card-entry .cpc-policy-card-entry .cpc-policy-card-entry_content{position:relative;grid-area:content;margin-left:auto}cpc-policy-card-entry .cpc-policy-card-entry .cpc-policy-card-entry_content cpc-dropdown-drawer>div{top:calc(100% + 15px)!important;width:210px}cpc-policy-card-entry .cpc-policy-card-entry .cpc-policy-card-entry_content cpc-dropdown-drawer>div:after{position:absolute;top:-7px;left:45%;z-index:inherit;width:12px;height:12px;background:var(--cpc-colors-white);border:1px solid var(--cpc-colors-border);border-width:1px 0 0 1px;transform:rotate(45deg);content:\"\"}cpc-policy-card-entry .cpc-policy-card-entry .cpc-policy-card-entry_content cpc-dropdown-drawer>div .cpc-dropdown-drawer{word-break:break-word;box-shadow:0 8px 24px #41414159}cpc-policy-card-entry .cpc-policy-card-entry .cpc-policy-card-entry_content cpc-dropdown-drawer>div .cpc-dropdown-drawer .cpc-button-content{align-items:flex-start}cpc-policy-card-entry .cpc-policy-card-entry .cpc-policy-card-entry_content--overflow-hidden{overflow:hidden}cpc-policy-card-entry .cpc-policy-card-entry .cpc-policy-card-entry_content--overflow-visible{overflow:visible}cpc-policy-card-entry .cpc-policy-card-entry .cpc-policy-card-entry_content--overflow-auto{overflow:auto}cpc-policy-card-entry .cpc-policy-card-entry .cpc-policy-card-entry_content,cpc-policy-card-entry .cpc-policy-card-entry .cpc-policy-card-entry_title{max-width:100%}cpc-policy-card-entry .cpc-policy-card-entry[fullWidth] .cpc-policy-card-entry_content{width:100%}cpc-policy-card-entry .cpc-policy-card-entry.cpc-policy-card-entry--align-left .cpc-policy-card-entry_title{max-width:30%;word-break:break-word}@media screen and (min-width: 704px){cpc-policy-card-entry .cpc-policy-card-entry.cpc-policy-card-entry--align-left .cpc-policy-card-entry_title{width:30%;width:calc(var(--cpc-policy-card-entry-size) * 100%);max-width:30%;max-width:calc(var(--cpc-policy-card-entry-size) * 100%);margin-right:4px}}cpc-policy-card-entry .cpc-policy-card-entry.cpc-policy-card-entry--align-left .cpc-policy-card-entry_title-full-width{width:unset;max-width:unset;margin:0}cpc-policy-card-entry .cpc-policy-card-entry.cpc-policy-card-entry--align-left .cpc-policy-card-entry_content{width:-moz-fit-content;width:fit-content;word-break:break-word}@media screen and (min-width: 704px){cpc-policy-card-entry .cpc-policy-card-entry.cpc-policy-card-entry--align-left .cpc-policy-card-entry_content{width:70%;width:calc((1 - var(--cpc-policy-card-entry-size)) * 100%);max-width:70%;max-width:calc((1 - var(--cpc-policy-card-entry-size)) * 100%);margin-left:4px}}cpc-policy-card-entry .cpc-policy-card-entry.cpc-policy-card-entry--align-left .cpc-policy-card-entry_content-full-width{width:100%;max-width:unset;margin:0}cpc-policy-card-entry .cpc-policy-card-entry.cpc-policy-card-entry--align-y-top{align-items:flex-start}cpc-policy-card-entry .cpc-policy-card-entry.cpc-policy-card-entry--align-y-center{align-items:center}cpc-policy-card-entry .cpc-policy-card-entry.cpc-policy-card-entry--align-y-bottom{align-items:flex-end}cpc-policy-card-entry[footer] .cpc-policy-card-entry{display:grid;grid-template-areas:\"center center\" \"title content\";gap:24px}@media screen and (min-width: 704px){cpc-policy-card-entry[footer] .cpc-policy-card-entry{display:flex}}cpc-policy-card-entry[footer] .cpc-policy-card-entry .cpc-button{padding:0 4px}@media screen and (min-width: 704px){cpc-policy-card-entry[footer] .cpc-policy-card-entry .cpc-button{padding:calc(8px - var(--button-border-width)) calc(16px - var(--button-border-width))}}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PolicyCardEntryComponent, [{
        type: Component,
        args: [{ selector: 'cpc-policy-card-entry', encapsulation: ViewEncapsulation.None, template: "<div\r\n  #element\r\n  class=\"cpc-policy-card-entry cpc-policy-card-entry--align-{{align}}\r\n  cpc-policy-card-entry--align-y-{{alignY}}\"\r\n  [style.minHeight]=\"(cardContentSize | async) + 'px'\"\r\n  style=\"--cpc-policy-card-entry-size: {{getTitleSize()}}\"\r\n>\r\n  <div [ngClass]=\"{'cpc-policy-card-entry_title-full-width': fullWidth}\"\r\n       class=\"cpc-policy-card-entry_title\r\n        cpc-policy-card-entry_content--overflow-{{overflowTitle}}\">\r\n    <ng-content select=\"[title]\"></ng-content>\r\n  </div>\r\n  <div class=\"cpc-policy-card-entry_center\">\r\n    <ng-content select=\"[center]\"></ng-content>\r\n  </div>\r\n  <div [ngClass]=\"{'cpc-policy-card-entry_content-full-width': fullWidth}\"\r\n       class=\"cpc-policy-card-entry_content\r\n     cpc-policy-card-entry_content--overflow-{{overflowContent}}\">\r\n    <ng-content></ng-content>\r\n  </div>\r\n</div>\r\n", styles: ["cpc-policy-card-entry{width:100%}cpc-policy-card-entry .cpc-policy-card-entry{display:flex;align-content:space-between;justify-content:space-between;flex-direction:row;flex-wrap:inherit;width:100%;margin-bottom:6px;padding:2px 0;font-size:16px;line-height:1.5}cpc-policy-card-entry .cpc-policy-card-entry .cpc-policy-card-entry_title{grid-area:title;margin-right:auto}cpc-policy-card-entry .cpc-policy-card-entry .cpc-policy-card-entry_center{display:flex;flex-direction:column;grid-area:center}cpc-policy-card-entry .cpc-policy-card-entry .cpc-policy-card-entry_center>div{display:flex;justify-content:space-between}cpc-policy-card-entry .cpc-policy-card-entry .cpc-policy-card-entry_center span:last-of-type{font-weight:700}cpc-policy-card-entry .cpc-policy-card-entry .cpc-policy-card-entry_content{position:relative;grid-area:content;margin-left:auto}cpc-policy-card-entry .cpc-policy-card-entry .cpc-policy-card-entry_content cpc-dropdown-drawer>div{top:calc(100% + 15px)!important;width:210px}cpc-policy-card-entry .cpc-policy-card-entry .cpc-policy-card-entry_content cpc-dropdown-drawer>div:after{position:absolute;top:-7px;left:45%;z-index:inherit;width:12px;height:12px;background:var(--cpc-colors-white);border:1px solid var(--cpc-colors-border);border-width:1px 0 0 1px;transform:rotate(45deg);content:\"\"}cpc-policy-card-entry .cpc-policy-card-entry .cpc-policy-card-entry_content cpc-dropdown-drawer>div .cpc-dropdown-drawer{word-break:break-word;box-shadow:0 8px 24px #41414159}cpc-policy-card-entry .cpc-policy-card-entry .cpc-policy-card-entry_content cpc-dropdown-drawer>div .cpc-dropdown-drawer .cpc-button-content{align-items:flex-start}cpc-policy-card-entry .cpc-policy-card-entry .cpc-policy-card-entry_content--overflow-hidden{overflow:hidden}cpc-policy-card-entry .cpc-policy-card-entry .cpc-policy-card-entry_content--overflow-visible{overflow:visible}cpc-policy-card-entry .cpc-policy-card-entry .cpc-policy-card-entry_content--overflow-auto{overflow:auto}cpc-policy-card-entry .cpc-policy-card-entry .cpc-policy-card-entry_content,cpc-policy-card-entry .cpc-policy-card-entry .cpc-policy-card-entry_title{max-width:100%}cpc-policy-card-entry .cpc-policy-card-entry[fullWidth] .cpc-policy-card-entry_content{width:100%}cpc-policy-card-entry .cpc-policy-card-entry.cpc-policy-card-entry--align-left .cpc-policy-card-entry_title{max-width:30%;word-break:break-word}@media screen and (min-width: 704px){cpc-policy-card-entry .cpc-policy-card-entry.cpc-policy-card-entry--align-left .cpc-policy-card-entry_title{width:30%;width:calc(var(--cpc-policy-card-entry-size) * 100%);max-width:30%;max-width:calc(var(--cpc-policy-card-entry-size) * 100%);margin-right:4px}}cpc-policy-card-entry .cpc-policy-card-entry.cpc-policy-card-entry--align-left .cpc-policy-card-entry_title-full-width{width:unset;max-width:unset;margin:0}cpc-policy-card-entry .cpc-policy-card-entry.cpc-policy-card-entry--align-left .cpc-policy-card-entry_content{width:-moz-fit-content;width:fit-content;word-break:break-word}@media screen and (min-width: 704px){cpc-policy-card-entry .cpc-policy-card-entry.cpc-policy-card-entry--align-left .cpc-policy-card-entry_content{width:70%;width:calc((1 - var(--cpc-policy-card-entry-size)) * 100%);max-width:70%;max-width:calc((1 - var(--cpc-policy-card-entry-size)) * 100%);margin-left:4px}}cpc-policy-card-entry .cpc-policy-card-entry.cpc-policy-card-entry--align-left .cpc-policy-card-entry_content-full-width{width:100%;max-width:unset;margin:0}cpc-policy-card-entry .cpc-policy-card-entry.cpc-policy-card-entry--align-y-top{align-items:flex-start}cpc-policy-card-entry .cpc-policy-card-entry.cpc-policy-card-entry--align-y-center{align-items:center}cpc-policy-card-entry .cpc-policy-card-entry.cpc-policy-card-entry--align-y-bottom{align-items:flex-end}cpc-policy-card-entry[footer] .cpc-policy-card-entry{display:grid;grid-template-areas:\"center center\" \"title content\";gap:24px}@media screen and (min-width: 704px){cpc-policy-card-entry[footer] .cpc-policy-card-entry{display:flex}}cpc-policy-card-entry[footer] .cpc-policy-card-entry .cpc-button{padding:0 4px}@media screen and (min-width: 704px){cpc-policy-card-entry[footer] .cpc-policy-card-entry .cpc-button{padding:calc(8px - var(--button-border-width)) calc(16px - var(--button-border-width))}}\n"] }]
    }], function () { return [{ type: CardsStoreService }]; }, { type: [{
            type: Input
        }], element: [{
            type: ViewChild,
            args: ['element']
        }], footer: [{
            type: Input
        }], skipFromHeightAligment: [{
            type: Input
        }], align: [{
            type: Input
        }], alignY: [{
            type: Input
        }], overflowTitle: [{
            type: Input
        }], overflowContent: [{
            type: Input
        }], titleSize: [{
            type: Input
        }], fullWidth: [{
            type: Input
        }], onResize: [{
            type: HostListener,
            args: ['window:resize', ['$event']]
        }] }); })();

const _c0$h = function (a0) { return { "cpc-policy-card-footer--border-top": a0 }; };
const _c1$8 = ["*"];
class PolicyCardFooterComponent {
    constructor() {
        this.borderTop = false;
    }
}
PolicyCardFooterComponent.ɵfac = function PolicyCardFooterComponent_Factory(t) { return new (t || PolicyCardFooterComponent)(); };
PolicyCardFooterComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PolicyCardFooterComponent, selectors: [["cpc-policy-card-footer"]], inputs: { borderTop: "borderTop" }, ngContentSelectors: _c1$8, decls: 2, vars: 3, consts: [[1, "cpc-policy-card-footer", 3, "ngClass"]], template: function PolicyCardFooterComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵprojection(1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c0$h, ctx.borderTop));
    } }, dependencies: [i1.NgClass], styles: [".cpc-policy-card-footer[_ngcontent-%COMP%]{margin:0 24px;padding-bottom:18px}@media screen and (min-width: 320px){.cpc-policy-card-footer[_ngcontent-%COMP%]{margin:0 32px}}.cpc-policy-card-footer.cpc-policy-card-footer--border-top[_ngcontent-%COMP%]{margin-top:20px;border-top:solid 1px var(--cpc-colors-light-gray)}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PolicyCardFooterComponent, [{
        type: Component,
        args: [{ selector: 'cpc-policy-card-footer', template: "<div\r\n  class=\"cpc-policy-card-footer\"\r\n  [ngClass]=\"{ 'cpc-policy-card-footer--border-top': borderTop }\"\r\n>\r\n  <ng-content></ng-content>\r\n</div>\r\n", styles: [".cpc-policy-card-footer{margin:0 24px;padding-bottom:18px}@media screen and (min-width: 320px){.cpc-policy-card-footer{margin:0 32px}}.cpc-policy-card-footer.cpc-policy-card-footer--border-top{margin-top:20px;border-top:solid 1px var(--cpc-colors-light-gray)}\n"] }]
    }], null, { borderTop: [{
            type: Input
        }] }); })();

const _c0$g = ["headerEl"];
const _c1$7 = [[["", "left", ""]], [["", "center", ""]], [["", "right", ""]], [["", "right", ""]]];
const _c2$1 = function (a0) { return { "cpc-policy-card-header_item--center--row": a0 }; };
const _c3 = ["[left]", "[center]", "[right]", "[right]"];
const DEFAULT_TIMEOUT = 10;
var PolicyCardHeaderVariants;
(function (PolicyCardHeaderVariants) {
    PolicyCardHeaderVariants["Primary"] = "primary";
    PolicyCardHeaderVariants["Secondary"] = "secondary";
})(PolicyCardHeaderVariants || (PolicyCardHeaderVariants = {}));
class PolicyCardHeaderComponent {
    constructor(cardsStoreService) {
        this.cardsStoreService = cardsStoreService;
        this.type = `policy-header-1`;
        this.variant = PolicyCardHeaderVariants.Primary;
        this.skipFromHeightAligment = false;
        this.isDirectionCol = false;
        this.mediaQuery = setMatchMedia(Breakpoints.medium);
        this.cardContentSize = cardsStoreService.getObservableSize(this.type);
    }
    onResize() {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        debounce(() => this.sizeUpdater(), 500)();
    }
    ngAfterViewInit() {
        this.cardContentSize = this.cardsStoreService.getObservableSize(this.type);
        setTimeout(() => {
            this.sizeUpdater();
        }, DEFAULT_TIMEOUT);
    }
    sizeUpdater() {
        const isMobile = !this.mediaQuery?.matches;
        if (isMobile) {
            return;
        }
        const element = this.element?.nativeElement;
        if (!element || this.skipFromHeightAligment !== false) {
            return;
        }
        this.cardsStoreService.clearSize(this.type);
        setTimeout(() => {
            this.cardsStoreService.updateSize(element.offsetHeight, this.type);
        }, DEFAULT_TIMEOUT);
    }
}
PolicyCardHeaderComponent.ɵfac = function PolicyCardHeaderComponent_Factory(t) { return new (t || PolicyCardHeaderComponent)(i0.ɵɵdirectiveInject(CardsStoreService)); };
PolicyCardHeaderComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PolicyCardHeaderComponent, selectors: [["cpc-policy-card-header"]], viewQuery: function PolicyCardHeaderComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$g, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.element = _t.first);
    } }, hostBindings: function PolicyCardHeaderComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("resize", function PolicyCardHeaderComponent_resize_HostBindingHandler($event) { return ctx.onResize($event); }, false, i0.ɵɵresolveWindow);
    } }, inputs: { type: "type", variant: "variant", skipFromHeightAligment: "skipFromHeightAligment", isDirectionCol: "isDirectionCol" }, ngContentSelectors: _c3, decls: 12, vars: 16, consts: [[1, "cpc-policy-card-header_item", "cpc-policy-card-header_item--left"], [3, "ngClass"], [1, "cpc-policy-card-header_main-item"], ["headerEl", ""], [1, "cpc-policy-card-header_item", "cpc-policy-card-header_item--right"]], template: function PolicyCardHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef(_c1$7);
        i0.ɵɵelementStart(0, "div")(1, "div", 0);
        i0.ɵɵprojection(2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 1)(4, "div", 2, 3);
        i0.ɵɵpipe(6, "async");
        i0.ɵɵprojection(7, 1);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div");
        i0.ɵɵprojection(9, 2);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(10, "div", 4);
        i0.ɵɵprojection(11, 3);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵclassMapInterpolate1("cpc-policy-card-header cpc-policy-card-header--", ctx.variant, "");
        i0.ɵɵadvance(3);
        i0.ɵɵclassMapInterpolate1("cpc-policy-card-header_item cpc-policy-card-header_item--center cpc-policy-card-header--", ctx.variant, "");
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(14, _c2$1, !ctx.isDirectionCol));
        i0.ɵɵadvance(1);
        i0.ɵɵstyleProp("min-height", i0.ɵɵpipeBind1(6, 12, ctx.cardContentSize) + "px");
        i0.ɵɵadvance(4);
        i0.ɵɵclassMapInterpolate1("cpc-policy-card-header_sub-item cpc-policy-card-header--", ctx.variant, "");
    } }, dependencies: [i1.NgClass, i1.AsyncPipe], styles: [".cpc-policy-card-header{position:relative;display:flex;align-items:center;justify-content:center;flex-direction:row;flex-wrap:inherit;padding:24px;background:var(--cpc-policy-card-header-background);border-bottom:var(--cpc-policy-card-border-mobile);border-radius:4px 4px 0 0}@media screen and (min-width: 704px){.cpc-policy-card-header{justify-content:flex-start;padding:24px 32px}.cpc-policy-card-header.cpc-policy-card-header--secondary{padding:24px 0}}.cpc-policy-card-header p,.cpc-policy-card-header h1,.cpc-policy-card-header h2,.cpc-policy-card-header h3,.cpc-policy-card-header h4,.cpc-policy-card-header h5,.cpc-policy-card-header h6{margin:0;padding:0}.cpc-policy-card-header p{font-size:16px;line-height:1.5}.cpc-policy-card-header h1,.cpc-policy-card-header h2,.cpc-policy-card-header h3,.cpc-policy-card-header h4,.cpc-policy-card-header h5,.cpc-policy-card-header h6{font-weight:600;font-size:24px;line-height:1.33;letter-spacing:.2px}.cpc-policy-card-header .cpc-policy-card-header_item{margin:0 12px}@media screen and (min-width: 704px){.cpc-policy-card-header .cpc-policy-card-header_item{margin:0 24px}}.cpc-policy-card-header .cpc-policy-card-header_item--left{order:2;margin-right:0;--icon-padding: 14px;--icon-size: 39px}@media screen and (min-width: 704px){.cpc-policy-card-header .cpc-policy-card-header_item--left{order:0;margin-right:24px;margin-left:0}}.cpc-policy-card-header .cpc-policy-card-header_item--center{display:flex;flex-direction:column;order:1;width:100%;max-width:100%;margin-right:0;margin-left:0}@media screen and (min-width: 704px){.cpc-policy-card-header .cpc-policy-card-header_item--center--row{flex-direction:row}}@media screen and (min-width: 704px){.cpc-policy-card-header .cpc-policy-card-header_item--center--row .cpc-policy-card-header_sub-item{top:0;right:0;align-self:flex-end;margin:0}.cpc-policy-card-header .cpc-policy-card-header_item--center--row .cpc-policy-card-header_sub-item.cpc-policy-card-header--secondary{top:inherit;bottom:0;margin:0}}.cpc-policy-card-header .cpc-policy-card-header_item--center .cpc-policy-card-header_main-item{flex-grow:1}.cpc-policy-card-header .cpc-policy-card-header_item--center .cpc-policy-card-header_sub-item{display:block;margin-top:16px}.cpc-policy-card-header .cpc-policy-card-header_item--center.cpc-policy-card-header--secondary p{color:var(--cpc-colors-dark-gray)}.cpc-policy-card-header .cpc-policy-card-header_item--right{display:none}@media screen and (min-width: 704px){.cpc-policy-card-header .cpc-policy-card-header_item--right{display:block;order:2;margin-right:0}}.cpc-policy-card-header .cpc-badge{line-height:1}.cpc-policy-card-header_inactive>div{background-color:var(--cpc-policy-card-header-background-inactive);border-bottom:var(--cpc-policy-card-border)}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PolicyCardHeaderComponent, [{
        type: Component,
        args: [{ selector: 'cpc-policy-card-header', encapsulation: ViewEncapsulation.None, template: "<div\r\n  class=\"cpc-policy-card-header cpc-policy-card-header--{{variant}}\"\r\n>\r\n  <div class=\"cpc-policy-card-header_item cpc-policy-card-header_item--left\">\r\n    <ng-content select=\"[left]\"></ng-content>\r\n  </div>\r\n  <div\r\n    [ngClass]=\"{'cpc-policy-card-header_item--center--row': !isDirectionCol}\"\r\n    class=\"cpc-policy-card-header_item cpc-policy-card-header_item--center cpc-policy-card-header--{{variant}}\"\r\n  >\r\n    <div\r\n      #headerEl\r\n      [style.minHeight]=\"(cardContentSize | async) + 'px'\"\r\n      class=\"cpc-policy-card-header_main-item\">\r\n      <ng-content select=\"[center]\"></ng-content>\r\n    </div>\r\n    <div class=\"cpc-policy-card-header_sub-item cpc-policy-card-header--{{variant}}\">\r\n      <ng-content select=\"[right]\"></ng-content>\r\n    </div>\r\n  </div>\r\n  <div class=\"cpc-policy-card-header_item cpc-policy-card-header_item--right\">\r\n    <ng-content select=\"[right]\"></ng-content>\r\n  </div>\r\n</div>\r\n", styles: [".cpc-policy-card-header{position:relative;display:flex;align-items:center;justify-content:center;flex-direction:row;flex-wrap:inherit;padding:24px;background:var(--cpc-policy-card-header-background);border-bottom:var(--cpc-policy-card-border-mobile);border-radius:4px 4px 0 0}@media screen and (min-width: 704px){.cpc-policy-card-header{justify-content:flex-start;padding:24px 32px}.cpc-policy-card-header.cpc-policy-card-header--secondary{padding:24px 0}}.cpc-policy-card-header p,.cpc-policy-card-header h1,.cpc-policy-card-header h2,.cpc-policy-card-header h3,.cpc-policy-card-header h4,.cpc-policy-card-header h5,.cpc-policy-card-header h6{margin:0;padding:0}.cpc-policy-card-header p{font-size:16px;line-height:1.5}.cpc-policy-card-header h1,.cpc-policy-card-header h2,.cpc-policy-card-header h3,.cpc-policy-card-header h4,.cpc-policy-card-header h5,.cpc-policy-card-header h6{font-weight:600;font-size:24px;line-height:1.33;letter-spacing:.2px}.cpc-policy-card-header .cpc-policy-card-header_item{margin:0 12px}@media screen and (min-width: 704px){.cpc-policy-card-header .cpc-policy-card-header_item{margin:0 24px}}.cpc-policy-card-header .cpc-policy-card-header_item--left{order:2;margin-right:0;--icon-padding: 14px;--icon-size: 39px}@media screen and (min-width: 704px){.cpc-policy-card-header .cpc-policy-card-header_item--left{order:0;margin-right:24px;margin-left:0}}.cpc-policy-card-header .cpc-policy-card-header_item--center{display:flex;flex-direction:column;order:1;width:100%;max-width:100%;margin-right:0;margin-left:0}@media screen and (min-width: 704px){.cpc-policy-card-header .cpc-policy-card-header_item--center--row{flex-direction:row}}@media screen and (min-width: 704px){.cpc-policy-card-header .cpc-policy-card-header_item--center--row .cpc-policy-card-header_sub-item{top:0;right:0;align-self:flex-end;margin:0}.cpc-policy-card-header .cpc-policy-card-header_item--center--row .cpc-policy-card-header_sub-item.cpc-policy-card-header--secondary{top:inherit;bottom:0;margin:0}}.cpc-policy-card-header .cpc-policy-card-header_item--center .cpc-policy-card-header_main-item{flex-grow:1}.cpc-policy-card-header .cpc-policy-card-header_item--center .cpc-policy-card-header_sub-item{display:block;margin-top:16px}.cpc-policy-card-header .cpc-policy-card-header_item--center.cpc-policy-card-header--secondary p{color:var(--cpc-colors-dark-gray)}.cpc-policy-card-header .cpc-policy-card-header_item--right{display:none}@media screen and (min-width: 704px){.cpc-policy-card-header .cpc-policy-card-header_item--right{display:block;order:2;margin-right:0}}.cpc-policy-card-header .cpc-badge{line-height:1}.cpc-policy-card-header_inactive>div{background-color:var(--cpc-policy-card-header-background-inactive);border-bottom:var(--cpc-policy-card-border)}\n"] }]
    }], function () { return [{ type: CardsStoreService }]; }, { type: [{
            type: Input
        }], element: [{
            type: ViewChild,
            args: ['headerEl']
        }], variant: [{
            type: Input
        }], skipFromHeightAligment: [{
            type: Input
        }], isDirectionCol: [{
            type: Input
        }], onResize: [{
            type: HostListener,
            args: ['window:resize', ['$event']]
        }] }); })();

const _c0$f = ["*"];
var CpcPolicyCardVariant;
(function (CpcPolicyCardVariant) {
    CpcPolicyCardVariant["Active"] = "active";
    CpcPolicyCardVariant["Inactive"] = "inactive";
})(CpcPolicyCardVariant || (CpcPolicyCardVariant = {}));
class PolicyCardComponent {
    constructor() {
        this.variant = CpcPolicyCardVariant.Active;
    }
}
PolicyCardComponent.ɵfac = function PolicyCardComponent_Factory(t) { return new (t || PolicyCardComponent)(); };
PolicyCardComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PolicyCardComponent, selectors: [["cpc-policy-card"]], inputs: { variant: "variant" }, ngContentSelectors: _c0$f, decls: 2, vars: 0, consts: [[1, "cpc-policy-card"]], template: function PolicyCardComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵprojection(1);
        i0.ɵɵelementEnd();
    } }, styles: [".cpc-policy-card[_ngcontent-%COMP%]{background:var(--cpc-colors-white);border:var(--cpc-border);border-radius:4px}.cpc-policy-card-entry_content[_ngcontent-%COMP%]{text-align:right}@media screen and (min-width: 704px){.cpc-policy-card-entry_content[_ngcontent-%COMP%]{text-align:left}}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PolicyCardComponent, [{
        type: Component,
        args: [{ selector: 'cpc-policy-card', template: "<div class=\"cpc-policy-card\">\r\n  <ng-content></ng-content>\r\n</div>\r\n", styles: [".cpc-policy-card{background:var(--cpc-colors-white);border:var(--cpc-border);border-radius:4px}.cpc-policy-card-entry_content{text-align:right}@media screen and (min-width: 704px){.cpc-policy-card-entry_content{text-align:left}}\n"] }]
    }], null, { variant: [{
            type: Input
        }] }); })();

function PolicyProgressComponent_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 6);
} }
function PolicyProgressComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtemplate(1, PolicyProgressComponent_div_1_div_1_Template, 1, 0, "div", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.isActiveBar);
} }
class PolicyProgressComponent {
    constructor() {
        this.isActiveBar = true;
        this.dateFormat = 'dd.MM.yyyy';
        this.copyStart = 'Start:';
        this.copyEnd = 'End:';
        this.progress = 50;
    }
    ngOnChanges(changes) {
        if ('startDate' in changes || 'endDate' in changes) {
            this.updateProgress();
        }
    }
    ngOnInit() {
        this.updateProgress();
    }
    updateProgress() {
        if (!this.endDate || !this.startDate) {
            this.progress = 0;
            return;
        }
        const now = new Date();
        const startDate = new Date(this.startDate);
        const endDate = new Date(this.endDate);
        const todayDiff = now.getTime() - startDate.getTime();
        const fullDiff = endDate.getTime() - startDate.getTime();
        const progress = clamp(todayDiff / fullDiff, 0, 1);
        this.progress = progress * 100;
    }
}
PolicyProgressComponent.ɵfac = function PolicyProgressComponent_Factory(t) { return new (t || PolicyProgressComponent)(); };
PolicyProgressComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PolicyProgressComponent, selectors: [["cpc-policy-progress"]], inputs: { isActiveBar: "isActiveBar", startDate: "startDate", endDate: "endDate", dateFormat: "dateFormat", copyStart: "copyStart", copyEnd: "copyEnd" }, features: [i0.ɵɵNgOnChangesFeature], decls: 13, vars: 14, consts: [[1, "cpc-policy-progress"], ["class", "cpc-policy-progress_progress", 4, "ngIf"], [1, "cpc-policy-progress_dates"], [1, "cpc-policy-progress_dates-start"], [1, "cpc-policy-progress_progress"], ["class", "cpc-policy-progress_progress-bar", 4, "ngIf"], [1, "cpc-policy-progress_progress-bar"]], template: function PolicyProgressComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, PolicyProgressComponent_div_1_Template, 2, 1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2)(3, "p", 3);
        i0.ɵɵtext(4);
        i0.ɵɵelementStart(5, "strong");
        i0.ɵɵtext(6);
        i0.ɵɵpipe(7, "date");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(8, "p", 3);
        i0.ɵɵtext(9);
        i0.ɵɵelementStart(10, "strong");
        i0.ɵɵtext(11);
        i0.ɵɵpipe(12, "date");
        i0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        i0.ɵɵstyleMapInterpolate1("--progress: ", ctx.progress, "%");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.startDate && ctx.endDate);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.copyStart, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(7, 8, ctx.startDate, ctx.dateFormat), " ");
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.copyEnd, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(12, 11, ctx.endDate, ctx.dateFormat), " ");
    } }, dependencies: [i1.NgIf, i1.DatePipe], styles: [".cpc-policy-progress[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center;flex-direction:column;flex-wrap:inherit}.cpc-policy-progress[_ngcontent-%COMP%]   .cpc-policy-progress_progress[_ngcontent-%COMP%]{display:block;width:100%;height:8px;margin-bottom:8px;background:var(--cpc-policy-progress-track);border-radius:2px}.cpc-policy-progress[_ngcontent-%COMP%]   .cpc-policy-progress_progress[_ngcontent-%COMP%]   .cpc-policy-progress_progress-bar[_ngcontent-%COMP%]{width:var(--progress);height:100%;background:var(--cpc-policy-progress-progress);border-radius:2px}.cpc-policy-progress[_ngcontent-%COMP%]   .cpc-policy-progress_dates[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:space-between;flex-direction:row;flex-wrap:inherit;width:100%;font-size:14px}.cpc-policy-progress[_ngcontent-%COMP%]   .cpc-policy-progress_dates[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin:0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PolicyProgressComponent, [{
        type: Component,
        args: [{ selector: 'cpc-policy-progress', template: "<div\r\n  class=\"cpc-policy-progress\"\r\n  style=\"--progress: {{progress}}%\"\r\n>\r\n  <div\r\n    *ngIf=\"startDate && endDate\"\r\n    class=\"cpc-policy-progress_progress\"\r\n  >\r\n    <div\r\n      *ngIf=\"isActiveBar\"\r\n      class=\"cpc-policy-progress_progress-bar\">\r\n    </div>\r\n  </div>\r\n  <div class=\"cpc-policy-progress_dates\">\r\n    <p class=\"cpc-policy-progress_dates-start\">\r\n      {{ copyStart }}\r\n      <strong>\r\n        {{ startDate | date: dateFormat }}\r\n      </strong>\r\n    </p>\r\n    <p class=\"cpc-policy-progress_dates-start\">\r\n      {{ copyEnd }}\r\n      <strong>\r\n        {{ endDate | date: dateFormat }}\r\n      </strong>\r\n    </p>\r\n  </div>\r\n</div>\r\n", styles: [".cpc-policy-progress{display:flex;justify-content:center;align-items:center;flex-direction:column;flex-wrap:inherit}.cpc-policy-progress .cpc-policy-progress_progress{display:block;width:100%;height:8px;margin-bottom:8px;background:var(--cpc-policy-progress-track);border-radius:2px}.cpc-policy-progress .cpc-policy-progress_progress .cpc-policy-progress_progress-bar{width:var(--progress);height:100%;background:var(--cpc-policy-progress-progress);border-radius:2px}.cpc-policy-progress .cpc-policy-progress_dates{display:flex;align-items:center;justify-content:space-between;flex-direction:row;flex-wrap:inherit;width:100%;font-size:14px}.cpc-policy-progress .cpc-policy-progress_dates p{margin:0}\n"] }]
    }], null, { isActiveBar: [{
            type: Input
        }], startDate: [{
            type: Input
        }], endDate: [{
            type: Input
        }], dateFormat: [{
            type: Input
        }], copyStart: [{
            type: Input
        }], copyEnd: [{
            type: Input
        }] }); })();

const _c0$e = ["*"];
class SideNavComponent {
}
SideNavComponent.ɵfac = function SideNavComponent_Factory(t) { return new (t || SideNavComponent)(); };
SideNavComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SideNavComponent, selectors: [["cpc-side-nav"]], ngContentSelectors: _c0$e, decls: 3, vars: 0, consts: [[1, "cpc-menu-wrapper"], [1, "cpc-menu"]], template: function SideNavComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵprojection(2);
        i0.ɵɵelementEnd()();
    } }, styles: [".cpc-menu-wrapper[_ngcontent-%COMP%]{display:flex;justify-content:center;width:100%;height:100%}.cpc-menu[_ngcontent-%COMP%]{display:inline-table;width:-moz-fit-content;width:fit-content;height:100%;border-bottom:1px solid var(--cpc-colors-resolution-blue);border-collapse:collapse}@media screen and (min-width: 704px){.cpc-menu[_ngcontent-%COMP%]{display:flex;flex-direction:column;width:100%;height:-moz-fit-content;height:fit-content;border-bottom:unset}}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SideNavComponent, [{
        type: Component,
        args: [{ selector: 'cpc-side-nav', template: "<div class=\"cpc-menu-wrapper\">\r\n  <div class='cpc-menu'>\r\n    <ng-content></ng-content>\r\n  </div>\r\n</div>\r\n\r\n", styles: [".cpc-menu-wrapper{display:flex;justify-content:center;width:100%;height:100%}.cpc-menu{display:inline-table;width:-moz-fit-content;width:fit-content;height:100%;border-bottom:1px solid var(--cpc-colors-resolution-blue);border-collapse:collapse}@media screen and (min-width: 704px){.cpc-menu{display:flex;flex-direction:column;width:100%;height:-moz-fit-content;height:fit-content;border-bottom:unset}}\n"] }]
    }], null, null); })();

const _c0$d = function (a0, a1) { return { "cpc-star-rating_star-filled": a0, "cpc-star-rating--interactive": a1 }; };
function StarRatingComponent_cpc_icon_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cpc-icon", 2);
    i0.ɵɵlistener("click", function StarRatingComponent_cpc_icon_1_Template_cpc_icon_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r4); const index_r2 = restoredCtx.index; const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.handleValueChanged(index_r2 + 1)); })("mouseover", function StarRatingComponent_cpc_icon_1_Template_cpc_icon_mouseover_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r4); const index_r2 = restoredCtx.index; const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.handleHover(index_r2 + 1)); })("mouseout", function StarRatingComponent_cpc_icon_1_Template_cpc_icon_mouseout_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.handleHover()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const value_r1 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("icon", ctx_r0.handleIcon(value_r1))("ngClass", i0.ɵɵpureFunction2(2, _c0$d, value_r1, ctx_r0.interactive));
} }
class StarRatingComponent {
    constructor() {
        this.max = 5;
        this.interactive = false;
        this.valueChanged = new EventEmitter();
        this.values = [];
    }
    ngOnInit() {
        this.updateValues();
    }
    ngOnChanges(changes) {
        if (Object.keys(changes).some((value) => ['value', 'max'].includes(value))) {
            this.updateValues();
        }
    }
    updateValues(nextValue) {
        const value = clamp(nextValue || this.value || 0, 0, Infinity);
        const max = clamp(this.max, 0, Infinity);
        this.values = Array(max)
            .fill(false)
            .map((_, index) => index < value);
    }
    handleValueChanged(value) {
        if (!this.interactive) {
            return;
        }
        this.value = value;
        this.valueChanged.emit({
            value,
            max: this.max,
            percentage: value / this.max,
        });
    }
    handleIcon(value) {
        return value ? NdbxIcon.Star : NdbxIcon.StarO;
    }
    handleHover(value) {
        if (!this.interactive) {
            return;
        }
        this.updateValues(value);
    }
}
StarRatingComponent.ɵfac = function StarRatingComponent_Factory(t) { return new (t || StarRatingComponent)(); };
StarRatingComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: StarRatingComponent, selectors: [["cpc-star-rating"]], inputs: { value: "value", max: "max", interactive: "interactive" }, outputs: { valueChanged: "valueChanged" }, features: [i0.ɵɵNgOnChangesFeature], decls: 2, vars: 1, consts: [[1, "cpc-star-rating"], ["class", "cpc-star-rating_star", "role", "button", 3, "icon", "ngClass", "click", "mouseover", "mouseout", 4, "ngFor", "ngForOf"], ["role", "button", 1, "cpc-star-rating_star", 3, "icon", "ngClass", "click", "mouseover", "mouseout"]], template: function StarRatingComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, StarRatingComponent_cpc_icon_1_Template, 1, 5, "cpc-icon", 1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.values);
    } }, dependencies: [i1.NgClass, i1.NgForOf, IconComponent], styles: [".cpc-star-rating[_ngcontent-%COMP%]{--icon-size: 16px}.cpc-star-rating[_ngcontent-%COMP%]   .cpc-star-rating_star[_ngcontent-%COMP%]{margin-left:1px;color:var(--cpc-colors-cerulean)}.cpc-star-rating[_ngcontent-%COMP%]   .cpc-star-rating_star.cpc-star-rating--interactive[_ngcontent-%COMP%]{cursor:pointer}.cpc-star-rating[_ngcontent-%COMP%]   .cpc-star-rating_star-filled[_ngcontent-%COMP%]{color:var(--cpc-colors-gold-orange)}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StarRatingComponent, [{
        type: Component,
        args: [{ selector: 'cpc-star-rating', template: "<div class=\"cpc-star-rating\">\r\n  <cpc-icon\r\n    *ngFor=\"let value of values; let index = index\" [icon]=\"handleIcon(value)\"\r\n    class=\"cpc-star-rating_star\"\r\n    [ngClass]=\"{ 'cpc-star-rating_star-filled': value, 'cpc-star-rating--interactive': interactive }\"\r\n    (click)=\"handleValueChanged(index + 1)\"\r\n    (mouseover)=\"handleHover(index + 1)\"\r\n    (mouseout)=\"handleHover()\"\r\n    role=\"button\"\r\n  ></cpc-icon>\r\n</div>\r\n", styles: [".cpc-star-rating{--icon-size: 16px}.cpc-star-rating .cpc-star-rating_star{margin-left:1px;color:var(--cpc-colors-cerulean)}.cpc-star-rating .cpc-star-rating_star.cpc-star-rating--interactive{cursor:pointer}.cpc-star-rating .cpc-star-rating_star-filled{color:var(--cpc-colors-gold-orange)}\n"] }]
    }], null, { value: [{
            type: Input
        }], max: [{
            type: Input
        }], interactive: [{
            type: Input
        }], valueChanged: [{
            type: Output
        }] }); })();

const _c0$c = ["*"];
class TopbarMobileComponent {
    constructor() {
        this.logoClicked = new EventEmitter();
        this.isDrawerOpen = false;
    }
    handleLogoClick() {
        this.logoClicked.emit();
    }
    handleOpen() {
        this.isDrawerOpen = !this.isDrawerOpen;
    }
}
TopbarMobileComponent.ɵfac = function TopbarMobileComponent_Factory(t) { return new (t || TopbarMobileComponent)(); };
TopbarMobileComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TopbarMobileComponent, selectors: [["cpc-topbar-mobile"]], outputs: { logoClicked: "logoClicked" }, ngContentSelectors: _c0$c, decls: 3, vars: 0, consts: [[1, "cpc-topbar-mobile"], ["width", "98", "height", "24", 1, "cpc-allianz-logo", 3, "click"]], template: function TopbarMobileComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "header", 0)(1, "cpc-allianz-logo", 1);
        i0.ɵɵlistener("click", function TopbarMobileComponent_Template_cpc_allianz_logo_click_1_listener() { return ctx.handleLogoClick(); });
        i0.ɵɵelementEnd();
        i0.ɵɵprojection(2);
        i0.ɵɵelementEnd();
    } }, dependencies: [AllianzLogoComponent], styles: [".cpc-topbar-mobile{position:relative;z-index:990;display:inline-flex;align-items:flex-end;justify-content:space-between;width:100%;height:68px;background:var(--cpc-colors-white);border-bottom:1px solid var(--cpc-colors-border)}.cpc-topbar-mobile .cpc-language-switch{margin:12px 24px;overflow:hidden}.cpc-topbar-mobile .cpc-dropdown-drawer{background:var(--cpc-colors-white)}.cpc-allianz-logo{margin:12px 24px}@media screen and (min-width: 992px){.cpc-allianz-logo{margin:0}}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TopbarMobileComponent, [{
        type: Component,
        args: [{ selector: 'cpc-topbar-mobile', encapsulation: ViewEncapsulation.None, template: "<header class=\"cpc-topbar-mobile\">\r\n  <cpc-allianz-logo\r\n    width=\"98\"\r\n    height=\"24\"\r\n    (click)=\"handleLogoClick()\"\r\n    class=\"cpc-allianz-logo\"\r\n  ></cpc-allianz-logo>\r\n  <ng-content></ng-content>\r\n</header>\r\n\r\n", styles: [".cpc-topbar-mobile{position:relative;z-index:990;display:inline-flex;align-items:flex-end;justify-content:space-between;width:100%;height:68px;background:var(--cpc-colors-white);border-bottom:1px solid var(--cpc-colors-border)}.cpc-topbar-mobile .cpc-language-switch{margin:12px 24px;overflow:hidden}.cpc-topbar-mobile .cpc-dropdown-drawer{background:var(--cpc-colors-white)}.cpc-allianz-logo{margin:12px 24px}@media screen and (min-width: 992px){.cpc-allianz-logo{margin:0}}\n"] }]
    }], null, { logoClicked: [{
            type: Output
        }] }); })();

const _c0$b = [[["", "desktop", ""]], [["", "mobile", ""]]];
const _c1$6 = ["[desktop]", "[mobile]"];
class TopbarComponent {
    constructor() {
        this.logoClicked = new EventEmitter();
    }
    handleLogoClick() {
        this.logoClicked.emit();
    }
}
TopbarComponent.ɵfac = function TopbarComponent_Factory(t) { return new (t || TopbarComponent)(); };
TopbarComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TopbarComponent, selectors: [["cpc-topbar"]], outputs: { logoClicked: "logoClicked" }, ngContentSelectors: _c1$6, decls: 7, vars: 0, consts: [[1, "cpc-topbar"], ["width", "129.5", "height", "32", 1, "cpc-allianz-logo", 3, "click"], [3, "logoClicked"]], template: function TopbarComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef(_c0$b);
        i0.ɵɵelementContainerStart(0);
        i0.ɵɵelementStart(1, "header", 0)(2, "cpc-allianz-logo", 1);
        i0.ɵɵlistener("click", function TopbarComponent_Template_cpc_allianz_logo_click_2_listener() { return ctx.handleLogoClick(); });
        i0.ɵɵelementEnd();
        i0.ɵɵprojection(3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "cpc-topbar-mobile", 2);
        i0.ɵɵlistener("logoClicked", function TopbarComponent_Template_cpc_topbar_mobile_logoClicked_4_listener() { return ctx.handleLogoClick(); });
        i0.ɵɵprojection(5, 1);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(6, "cpc-backdrop");
        i0.ɵɵelementContainerEnd();
    } }, dependencies: [AllianzLogoComponent, BackdropComponent, TopbarMobileComponent], styles: [".cpc-topbar{display:none;align-items:center;justify-content:space-between;width:100%;height:80px}@media screen and (min-width: 992px){.cpc-topbar{display:inline-flex}}@media screen and (min-width: 992px){.cpc-topbar-mobile{display:none!important}}.cpc-allianz-logo{cursor:pointer}.cpc-topbar-user-wrapper{display:inline-flex;align-items:flex-end;justify-items:flex-end;height:48px;margin-bottom:12px}@media screen and (min-width: 992px){.cpc-topbar-user-wrapper{align-items:center;margin-bottom:0}}.cpc-topbar-icon{display:inherit;margin-right:24px;font-size:var(--button-medium-icon-size);cursor:pointer}.cpc-topbar-icon:hover,.cpc-topbar-icon.pseudo-states--hover{color:var(--cpc-colors-hover)}.cpc-topbar-icon:hover:not(:disabled):not(:active),.cpc-topbar-icon.pseudo-states--hover{color:var(--cpc-colors-hover)}.cpc-topbar-icon:active,.cpc-topbar-icon.pseudo-states--active{color:var(--cpc-colors-dark-cerulian)}.cpc-topbar-icon--active{color:var(--cpc-colors-hover)}@media screen and (min-width: 992px){cpc-language-switch{height:100%;max-height:48px}}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TopbarComponent, [{
        type: Component,
        args: [{ selector: 'cpc-topbar', encapsulation: ViewEncapsulation.None, template: "<ng-container>\r\n  <header class=\"cpc-topbar\">\r\n    <cpc-allianz-logo\r\n      width=\"129.5\"\r\n      height=\"32\"\r\n      (click)=\"handleLogoClick()\"\r\n      class=\"cpc-allianz-logo\"\r\n    ></cpc-allianz-logo>\r\n    <ng-content select=\"[desktop]\"></ng-content>\r\n  </header>\r\n\r\n  <cpc-topbar-mobile (logoClicked)=\"handleLogoClick()\">\r\n    <ng-content select=\"[mobile]\"></ng-content>\r\n  </cpc-topbar-mobile>\r\n\r\n  <cpc-backdrop></cpc-backdrop>\r\n</ng-container>\r\n", styles: [".cpc-topbar{display:none;align-items:center;justify-content:space-between;width:100%;height:80px}@media screen and (min-width: 992px){.cpc-topbar{display:inline-flex}}@media screen and (min-width: 992px){.cpc-topbar-mobile{display:none!important}}.cpc-allianz-logo{cursor:pointer}.cpc-topbar-user-wrapper{display:inline-flex;align-items:flex-end;justify-items:flex-end;height:48px;margin-bottom:12px}@media screen and (min-width: 992px){.cpc-topbar-user-wrapper{align-items:center;margin-bottom:0}}.cpc-topbar-icon{display:inherit;margin-right:24px;font-size:var(--button-medium-icon-size);cursor:pointer}.cpc-topbar-icon:hover,.cpc-topbar-icon.pseudo-states--hover{color:var(--cpc-colors-hover)}.cpc-topbar-icon:hover:not(:disabled):not(:active),.cpc-topbar-icon.pseudo-states--hover{color:var(--cpc-colors-hover)}.cpc-topbar-icon:active,.cpc-topbar-icon.pseudo-states--active{color:var(--cpc-colors-dark-cerulian)}.cpc-topbar-icon--active{color:var(--cpc-colors-hover)}@media screen and (min-width: 992px){cpc-language-switch{height:100%;max-height:48px}}\n"] }]
    }], null, { logoClicked: [{
            type: Output
        }] }); })();

function UserProfileDropdownComponent_img_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 9);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate1("alt", "Photo of ", ctx_r0.name, "");
    i0.ɵɵproperty("src", ctx_r0.photo, i0.ɵɵsanitizeUrl);
} }
function UserProfileDropdownComponent_cpc_icon_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "cpc-icon", 10);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("icon", ctx_r1.ndbxIcons.UserO);
} }
const _c0$a = ["*"];
class UserProfileDropdownComponent {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.isDrawerOpen = false;
        this.ndbxIcons = NdbxIcon;
    }
    get parentElement() {
        return this.elementRef.nativeElement;
    }
    handleOpen() {
        this.isDrawerOpen = !this.isDrawerOpen;
    }
}
UserProfileDropdownComponent.ɵfac = function UserProfileDropdownComponent_Factory(t) { return new (t || UserProfileDropdownComponent)(i0.ɵɵdirectiveInject(i0.ElementRef)); };
UserProfileDropdownComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: UserProfileDropdownComponent, selectors: [["cpc-user-profile-dropdown"]], inputs: { photo: "photo", name: "name" }, ngContentSelectors: _c0$a, decls: 11, vars: 8, consts: [[1, "cpc-user-profile-dropdown-wrapper"], [3, "ngClass", "click"], [1, "cpc-user-profile-dropdown_photo"], ["class", "cpc-user-profile-dropdown_photo_image", 3, "src", "alt", 4, "ngIf"], ["class", "cpc-user-profile-dropdown_icon", 3, "icon", 4, "ngIf"], [1, "cpc-user-profile-dropdown_details"], [1, "cpc-user-profile-dropdown_details_text"], [3, "ngClass", "icon"], [1, "cpc-user-profile-dropdown-drawer", 3, "drawerOpenModel", "parentElement", "drawerOpenModelChange"], [1, "cpc-user-profile-dropdown_photo_image", 3, "src", "alt"], [1, "cpc-user-profile-dropdown_icon", 3, "icon"]], template: function UserProfileDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵlistener("click", function UserProfileDropdownComponent_Template_div_click_1_listener() { return ctx.handleOpen(); });
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtemplate(3, UserProfileDropdownComponent_img_3_Template, 1, 2, "img", 3);
        i0.ɵɵtemplate(4, UserProfileDropdownComponent_cpc_icon_4_Template, 1, 1, "cpc-icon", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 5)(6, "span", 6);
        i0.ɵɵtext(7);
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(8, "cpc-icon", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "cpc-dropdown-drawer", 8);
        i0.ɵɵlistener("drawerOpenModelChange", function UserProfileDropdownComponent_Template_cpc_dropdown_drawer_drawerOpenModelChange_9_listener($event) { return ctx.isDrawerOpen = $event; });
        i0.ɵɵprojection(10);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", ctx.isDrawerOpen ? "cpc-user-profile-dropdown cpc-user-profile-dropdown--active" : "cpc-user-profile-dropdown");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.photo);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.photo);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.name);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", ctx.isDrawerOpen ? "cpc-user-profile-dropdown-icon cpc-user-profile-dropdown-icon--active" : "cpc-user-profile-dropdown-icon")("icon", ctx.ndbxIcons.ChevronDown);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("drawerOpenModel", ctx.isDrawerOpen)("parentElement", ctx.parentElement);
    } }, dependencies: [i1.NgClass, i1.NgIf, DropdownDrawerComponent, IconComponent], styles: [".cpc-user-profile-dropdown-wrapper{position:relative;width:-moz-fit-content;width:fit-content;cursor:pointer;-webkit-user-select:none;user-select:none}.cpc-user-profile-dropdown{display:inherit;margin-right:24px;padding:0;color:var(--cpc-colors-text);border:unset;border-radius:4px;pointer-events:none;transition:all 125ms linear;display:flex;align-items:center;justify-content:center;flex-direction:row;flex-wrap:inherit}.cpc-user-profile-dropdown--active{color:var(--cpc-colors-blue)}.cpc-user-profile-dropdown:active,.cpc-user-profile-dropdown.pseudo-states--active{color:var(--cpc-colors-dark-cerulian)}.cpc-user-profile-dropdown:disabled,.cpc-user-profile-dropdown.pseudo-states--disabled{cursor:not-allowed;pointer-events:none}.cpc-user-profile-dropdown:disabled,.cpc-user-profile-dropdown.cpc--disabled,.cpc-user-profile-dropdown.pseudo-states--disabled{cursor:not-allowed;pointer-events:none}.cpc-user-profile-dropdown:focus,.cpc-user-profile-dropdown.pseudo-states--focus{outline:0;box-shadow:var(--focus-box-shadow, 0 0 0 2px #fff, 0 0 0 6px #009de6)}.cpc-user-profile-dropdown .cpc-user-profile-dropdown_photo{position:relative;display:block;width:var(--cpc-user-profile-photo-size);height:var(--cpc-user-profile-photo-size);margin-right:10px;overflow:hidden;background:var(--cpc-colors-light-blue-2);border-radius:var(--cpc-user-profile-photo-size)}.cpc-user-profile-dropdown .cpc-user-profile-dropdown_photo>.cpc-user-profile-dropdown_photo_image{position:absolute;top:50%;left:50%;display:block;width:100%;height:auto;transform:translate(-50%,-50%)}.cpc-user-profile-dropdown .cpc-user-profile-dropdown_photo .cpc-user-profile-dropdown_icon{display:flex;justify-content:center;width:100%;height:100%;font-size:24px}.cpc-user-profile-dropdown .cpc-user-profile-dropdown_photo .cpc-user-profile-dropdown_icon .cpc-icon{align-self:center;color:var(--cpc-colors-light-blue)}.cpc-user-profile-dropdown .cpc-user-profile-dropdown_details{display:flex;justify-content:flex-start;align-items:flex-start;flex-direction:column;flex-wrap:inherit;margin-right:11px}.cpc-user-profile-dropdown .cpc-user-profile-dropdown_details .cpc-user-profile-dropdown_details_text{font-size:14px;line-height:1.2142857143}.cpc-user-profile-dropdown .cpc-user-profile-dropdown-icon{display:none}@media screen and (min-width: 992px){.cpc-user-profile-dropdown .cpc-user-profile-dropdown-icon{display:inline-flex;font-size:20px;transition:transform .2s ease-out}}.cpc-user-profile-dropdown .cpc-user-profile-dropdown-icon--active{transform:rotate(180deg)}.cpc-user-profile-dropdown .cpc-user-profile-dropdown-drawer{color:var(--cpc-colors-charcoal)}@media screen and (min-width: 992px){.cpc-user-profile-dropdown{padding:0 20px;border-color:var(--cpc-colors-light-gray);border-style:solid;border-width:0 1px 0 1px;border-radius:0!important;pointer-events:all}.cpc-user-profile-dropdown:hover,.cpc-user-profile-dropdown.pseudo-states--hover{color:var(--cpc-colors-hover)}.cpc-user-profile-dropdown:hover:not(:disabled):not(:active),.cpc-user-profile-dropdown.pseudo-states--hover{color:var(--cpc-colors-hover)}}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UserProfileDropdownComponent, [{
        type: Component,
        args: [{ selector: 'cpc-user-profile-dropdown', encapsulation: ViewEncapsulation.None, template: "<div class='cpc-user-profile-dropdown-wrapper'>\r\n  <div [ngClass]=\"isDrawerOpen ? 'cpc-user-profile-dropdown cpc-user-profile-dropdown--active' : 'cpc-user-profile-dropdown'\" (click)='handleOpen()'>\r\n    <div class='cpc-user-profile-dropdown_photo'>\r\n      <img\r\n        *ngIf=\"photo\"\r\n        [src]='photo'\r\n        class='cpc-user-profile-dropdown_photo_image'\r\n        alt='Photo of {{name}}'\r\n      />\r\n      <cpc-icon *ngIf=\"!photo\" [icon]=\"ndbxIcons.UserO\" class=\"cpc-user-profile-dropdown_icon\"></cpc-icon>\r\n    </div>\r\n    <div class='cpc-user-profile-dropdown_details'>\r\n      <span class='cpc-user-profile-dropdown_details_text'>{{name}}</span>\r\n    </div>\r\n    <cpc-icon\r\n      [ngClass]=\"isDrawerOpen ? 'cpc-user-profile-dropdown-icon cpc-user-profile-dropdown-icon--active' : 'cpc-user-profile-dropdown-icon'\"\r\n      [icon]=\"ndbxIcons.ChevronDown\"></cpc-icon>\r\n  </div>\r\n  <cpc-dropdown-drawer\r\n    [(drawerOpenModel)]=\"isDrawerOpen\"\r\n    [parentElement]=\"parentElement\"\r\n    class=\"cpc-user-profile-dropdown-drawer\"\r\n  >\r\n    <ng-content></ng-content>\r\n  </cpc-dropdown-drawer>\r\n</div>\r\n", styles: [".cpc-user-profile-dropdown-wrapper{position:relative;width:-moz-fit-content;width:fit-content;cursor:pointer;-webkit-user-select:none;user-select:none}.cpc-user-profile-dropdown{display:inherit;margin-right:24px;padding:0;color:var(--cpc-colors-text);border:unset;border-radius:4px;pointer-events:none;transition:all 125ms linear;display:flex;align-items:center;justify-content:center;flex-direction:row;flex-wrap:inherit}.cpc-user-profile-dropdown--active{color:var(--cpc-colors-blue)}.cpc-user-profile-dropdown:active,.cpc-user-profile-dropdown.pseudo-states--active{color:var(--cpc-colors-dark-cerulian)}.cpc-user-profile-dropdown:disabled,.cpc-user-profile-dropdown.pseudo-states--disabled{cursor:not-allowed;pointer-events:none}.cpc-user-profile-dropdown:disabled,.cpc-user-profile-dropdown.cpc--disabled,.cpc-user-profile-dropdown.pseudo-states--disabled{cursor:not-allowed;pointer-events:none}.cpc-user-profile-dropdown:focus,.cpc-user-profile-dropdown.pseudo-states--focus{outline:0;box-shadow:var(--focus-box-shadow, 0 0 0 2px #fff, 0 0 0 6px #009de6)}.cpc-user-profile-dropdown .cpc-user-profile-dropdown_photo{position:relative;display:block;width:var(--cpc-user-profile-photo-size);height:var(--cpc-user-profile-photo-size);margin-right:10px;overflow:hidden;background:var(--cpc-colors-light-blue-2);border-radius:var(--cpc-user-profile-photo-size)}.cpc-user-profile-dropdown .cpc-user-profile-dropdown_photo>.cpc-user-profile-dropdown_photo_image{position:absolute;top:50%;left:50%;display:block;width:100%;height:auto;transform:translate(-50%,-50%)}.cpc-user-profile-dropdown .cpc-user-profile-dropdown_photo .cpc-user-profile-dropdown_icon{display:flex;justify-content:center;width:100%;height:100%;font-size:24px}.cpc-user-profile-dropdown .cpc-user-profile-dropdown_photo .cpc-user-profile-dropdown_icon .cpc-icon{align-self:center;color:var(--cpc-colors-light-blue)}.cpc-user-profile-dropdown .cpc-user-profile-dropdown_details{display:flex;justify-content:flex-start;align-items:flex-start;flex-direction:column;flex-wrap:inherit;margin-right:11px}.cpc-user-profile-dropdown .cpc-user-profile-dropdown_details .cpc-user-profile-dropdown_details_text{font-size:14px;line-height:1.2142857143}.cpc-user-profile-dropdown .cpc-user-profile-dropdown-icon{display:none}@media screen and (min-width: 992px){.cpc-user-profile-dropdown .cpc-user-profile-dropdown-icon{display:inline-flex;font-size:20px;transition:transform .2s ease-out}}.cpc-user-profile-dropdown .cpc-user-profile-dropdown-icon--active{transform:rotate(180deg)}.cpc-user-profile-dropdown .cpc-user-profile-dropdown-drawer{color:var(--cpc-colors-charcoal)}@media screen and (min-width: 992px){.cpc-user-profile-dropdown{padding:0 20px;border-color:var(--cpc-colors-light-gray);border-style:solid;border-width:0 1px 0 1px;border-radius:0!important;pointer-events:all}.cpc-user-profile-dropdown:hover,.cpc-user-profile-dropdown.pseudo-states--hover{color:var(--cpc-colors-hover)}.cpc-user-profile-dropdown:hover:not(:disabled):not(:active),.cpc-user-profile-dropdown.pseudo-states--hover{color:var(--cpc-colors-hover)}}\n"] }]
    }], function () { return [{ type: i0.ElementRef }]; }, { photo: [{
            type: Input
        }], name: [{
            type: Input
        }] }); })();

function InvestmentsComponent_h2_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.title);
} }
const _c0$9 = ["*"];
class InvestmentsComponent {
}
InvestmentsComponent.ɵfac = function InvestmentsComponent_Factory(t) { return new (t || InvestmentsComponent)(); };
InvestmentsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: InvestmentsComponent, selectors: [["cpc-investments"]], inputs: { title: "title" }, ngContentSelectors: _c0$9, decls: 3, vars: 1, consts: [[1, "cpc-investments"], ["class", "cpc-investments_title", 4, "ngIf"], [1, "cpc-investments_title"]], template: function InvestmentsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, InvestmentsComponent_h2_1_Template, 2, 1, "h2", 1);
        i0.ɵɵprojection(2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.title);
    } }, dependencies: [i1.NgIf], styles: ["cpc-investments{width:100%}.cpc-investments{margin:32px 0}.cpc-investments_title{padding-bottom:10px;font-weight:400;font-size:24px;line-height:32px;letter-spacing:.2px;border-bottom:1px solid var(--cpc-colors-light-gray)}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InvestmentsComponent, [{
        type: Component,
        args: [{ selector: 'cpc-investments', encapsulation: ViewEncapsulation.None, template: "<div class=\"cpc-investments\">\r\n  <h2 *ngIf=\"title\" class=\"cpc-investments_title\">{{title}}</h2>\r\n  <ng-content></ng-content>\r\n</div>\r\n", styles: ["cpc-investments{width:100%}.cpc-investments{margin:32px 0}.cpc-investments_title{padding-bottom:10px;font-weight:400;font-size:24px;line-height:32px;letter-spacing:.2px;border-bottom:1px solid var(--cpc-colors-light-gray)}\n"] }]
    }], null, { title: [{
            type: Input
        }] }); })();

var Locales;
(function (Locales) {
    Locales["az"] = "az";
    Locales["be"] = "be";
    Locales["bg"] = "bg";
    Locales["bm"] = "bm";
    Locales["bn"] = "bn";
    Locales["bo"] = "bo";
    Locales["br"] = "br";
    Locales["bs"] = "bs";
    Locales["ca"] = "ca";
    Locales["cs"] = "cs";
    Locales["cv"] = "cv";
    Locales["cy"] = "cy";
    Locales["da"] = "da";
    Locales["de-at"] = "de-at";
    Locales["de-ch"] = "de-ch";
    Locales["de"] = "de";
    Locales["dv"] = "dv";
    Locales["el"] = "el";
    Locales["en-au"] = "en-au";
    Locales["en-ca"] = "en-ca";
    Locales["en-gb"] = "en-gb";
    Locales["en-ie"] = "en-ie";
    Locales["en-nz"] = "en-nz";
    Locales["eo"] = "eo";
    Locales["es-do"] = "es-do";
    Locales["es-us"] = "es-us";
    Locales["es"] = "es";
    Locales["et"] = "et";
    Locales["eu"] = "eu";
    Locales["fa"] = "fa";
    Locales["fi"] = "fi";
    Locales["fo"] = "fo";
    Locales["fr-ca"] = "fr-ca";
    Locales["fr-ch"] = "fr-ch";
    Locales["fr"] = "fr";
    Locales["fy"] = "fy";
    Locales["gd"] = "gd";
    Locales["gl"] = "gl";
    Locales["gu"] = "gu";
    Locales["he"] = "he";
    Locales["hi"] = "hi";
    Locales["hr"] = "hr";
    Locales["hu"] = "hu";
    Locales["hy-am"] = "hy-am";
    Locales["id"] = "id";
    Locales["is"] = "is";
    Locales["it"] = "it";
    Locales["ja"] = "ja";
    Locales["jv"] = "jv";
    Locales["ka"] = "ka";
    Locales["kk"] = "kk";
    Locales["km"] = "km";
    Locales["kn"] = "kn";
    Locales["ko"] = "ko";
    Locales["ky"] = "ky";
    Locales["lb"] = "lb";
    Locales["lt"] = "lt";
    Locales["lv"] = "lv";
    Locales["ms-my"] = "ms-my";
    Locales["nb"] = "nb";
    Locales["nl-be"] = "nl-be";
    Locales["nl"] = "nl";
    Locales["nn"] = "nn";
    Locales["pl"] = "pl";
    Locales["pt-br"] = "pt-br";
    Locales["pt"] = "pt";
    Locales["ro"] = "ro";
    Locales["ru"] = "ru";
    Locales["sk"] = "sk";
    Locales["sl"] = "sl";
    Locales["sr-cyrl"] = "sr-cyrl";
    Locales["sr"] = "sr";
    Locales["sv"] = "sv";
    Locales["tr"] = "tr";
    Locales["uk"] = "uk";
    Locales["Azerbaijani"] = "az";
    Locales["Belarusian"] = "be";
    Locales["Bulgarian"] = "bg";
    Locales["Bambara"] = "bm";
    Locales["Bengali"] = "bn";
    Locales["Tibetan"] = "bo";
    Locales["Breton"] = "br";
    Locales["Bosnian"] = "bs";
    Locales["Catalan"] = "ca";
    Locales["Czech"] = "cs";
    Locales["Chuvash"] = "cv";
    Locales["Welsh"] = "cy";
    Locales["Danish"] = "da";
    Locales["GermanAustria"] = "de-at";
    Locales["GermanSwitzerland"] = "de-ch";
    Locales["German"] = "de";
    Locales["Divehi"] = "dv";
    Locales["Greek"] = "el";
    Locales["EnglishAustralia"] = "en-au";
    Locales["EnglishCanada"] = "en-ca";
    Locales["EnglishUnitedKingdom"] = "en-gb";
    Locales["EnglishIreland"] = "en-ie";
    Locales["EnglishNewZealand"] = "en-nz";
    Locales["Esperanto"] = "eo";
    Locales["SpanishDominicanRepublic"] = "es-do";
    Locales["SpanishUnitedStates"] = "es-us";
    Locales["Spanish"] = "es";
    Locales["Estonian"] = "et";
    Locales["Basque"] = "eu";
    Locales["Persian"] = "fa";
    Locales["Finnish"] = "fi";
    Locales["Faroese"] = "fo";
    Locales["FrenchCanada"] = "fr-ca";
    Locales["FrenchSwitzerland"] = "fr-ch";
    Locales["French"] = "fr";
    Locales["WesternFrisian"] = "fy";
    Locales["ScottishGaelic"] = "gd";
    Locales["Galician"] = "gl";
    Locales["Gujarati"] = "gu";
    Locales["Hebrew"] = "he";
    Locales["Hindi"] = "hi";
    Locales["Croatian"] = "hr";
    Locales["Hungarian"] = "hu";
    Locales["ArmenianArmenia"] = "hy-am";
    Locales["Indonesian"] = "id";
    Locales["Icelandic"] = "is";
    Locales["Italian"] = "it";
    Locales["Japanese"] = "ja";
    Locales["Javanese"] = "jv";
    Locales["Georgian"] = "ka";
    Locales["Kazakh"] = "kk";
    Locales["Khmer"] = "km";
    Locales["Kannada"] = "kn";
    Locales["Korean"] = "ko";
    Locales["Kirghizn"] = "ky";
    Locales["Luxembourgishn"] = "lb";
    Locales["Lithuanian"] = "lt";
    Locales["Latvian"] = "lv";
    Locales["MalayMalaysia"] = "ms-my";
    Locales["Norwegian"] = "nb";
    Locales["DutchBelgium"] = "nl-be";
    Locales["Dutch"] = "nl";
    Locales["NorwegianNynorsk"] = "nn";
    Locales["Polish"] = "pl";
    Locales["PortugueseBrazil"] = "pt-br";
    Locales["Portuguese"] = "pt";
    Locales["Romanian"] = "ro";
    Locales["Russian"] = "ru";
    Locales["Slovak"] = "sk";
    Locales["Slovenian"] = "sl";
    Locales["SerbianCyrillic"] = "sr-cyrl";
    Locales["Serbian"] = "sr";
    Locales["Swedish"] = "sv";
    Locales["Turkish"] = "tr";
    Locales["Ukrainian"] = "uk";
})(Locales || (Locales = {}));

class AreaChartComponent {
    constructor() {
        this.locale = Locales.GermanAustria;
        this.Highcharts = Highcharts;
        this.chartOptions = {};
    }
    ngOnChanges() {
        this.updateChartData();
    }
    updateChartData() {
        const valuesDataset = this.data.map((item) => [new Date(item.date).getTime(), item.value]);
        const datesDataset = this.data.map((item) => new Date(item.date));
        const selectedLocale = this.locale;
        this.chartOptions = {
            chart: {
                type: 'area',
                style: {
                    color: 'var(--cpc-colors-dark-gray)',
                },
            },
            title: { text: '' },
            credits: {
                enabled: false,
            },
            legend: { enabled: false },
            tooltip: {
                backgroundColor: 'var(--cpc-colors-charcoal)',
                borderWidth: 0,
                borderRadius: 10,
                style: {
                    color: 'var(--cpc-colors-white)',
                    fontSize: '14px',
                    fontFamily: 'var(--font-family)',
                },
                shadow: false,
                useHTML: true,
                formatter() {
                    return `<span>${String(this.y)}<br/>${datesDataset[this.point.index].toLocaleDateString(selectedLocale)}</span>`;
                },
            },
            xAxis: {
                type: 'datetime',
                minorTickLength: 0,
                tickLength: 0,
                lineColor: 'var(--cpc-colors-dark-gray)',
                crosshair: {
                    color: 'var(--cpc-colors-resolution-blue)',
                    zIndex: 3,
                },
                labels: {
                    formatter() {
                        return String(new Date(this.value).toLocaleDateString(selectedLocale, { year: 'numeric', month: '2-digit' }));
                    },
                    style: {
                        fontSize: '14px',
                        color: 'var(--cpc-colors-dark-gray)',
                        fontFamily: 'var(--font-family)',
                    },
                },
            },
            yAxis: {
                lineWidth: 1,
                lineColor: 'var(--cpc-colors-dark-gray)',
                title: {
                    text: '',
                },
                labels: {
                    format: '{value:.4f}',
                    style: {
                        fontSize: '14px',
                        color: 'var(--cpc-colors-dark-gray)',
                        fontFamily: 'var(--font-family)',
                    },
                },
            },
            plotOptions: {
                area: {
                    lineColor: 'var(--cpc-colors-resolution-blue)',
                    fillColor: {
                        linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
                        stops: [
                            [0, '#E6F4F6'],
                            [1, '#FFFFFF'],
                        ],
                    },
                    marker: {
                        enabled: false,
                        symbol: 'circle',
                        color: 'var(--cpc-colors-resolution-blue)',
                        fillColor: 'var(--cpc-colors-resolution-blue)',
                        radius: 3,
                        states: {
                            hover: {
                                enabled: true,
                            },
                        },
                    },
                },
            },
            series: [
                {
                    type: 'area',
                    data: valuesDataset,
                },
            ],
        };
    }
}
AreaChartComponent.ɵfac = function AreaChartComponent_Factory(t) { return new (t || AreaChartComponent)(); };
AreaChartComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AreaChartComponent, selectors: [["cpc-area-chart"]], inputs: { data: "data", locale: "locale" }, features: [i0.ɵɵNgOnChangesFeature], decls: 1, vars: 2, consts: [[1, "area-chart", 3, "Highcharts", "options"]], template: function AreaChartComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "highcharts-chart", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("Highcharts", ctx.Highcharts)("options", ctx.chartOptions);
    } }, dependencies: [i1$2.HighchartsChartComponent], styles: [".highcharts-grid-line{stroke-dasharray:2}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AreaChartComponent, [{
        type: Component,
        args: [{ selector: 'cpc-area-chart', encapsulation: ViewEncapsulation.None, template: "<highcharts-chart\r\n  [Highcharts]=\"Highcharts\"\r\n  [options]=\"chartOptions\"\r\n  class=\"area-chart\"\r\n></highcharts-chart>\r\n", styles: [".highcharts-grid-line{stroke-dasharray:2}\n"] }]
    }], null, { data: [{
            type: Input
        }], locale: [{
            type: Input
        }] }); })();

const _c0$8 = function (a0) { return { "cpc-tab-selector--selected": a0 }; };
function TabSelectorComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 0);
    i0.ɵɵlistener("click", function TabSelectorComponent_ng_template_0_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r2); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.handleClick()); });
    i0.ɵɵprojection(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c0$8, ctx_r0.selected));
} }
const _c1$5 = ["*"];
class TabSelectorComponent {
    constructor() {
        this.click = new EventEmitter();
    }
    handleClick() {
        this.click.emit();
    }
}
TabSelectorComponent.ɵfac = function TabSelectorComponent_Factory(t) { return new (t || TabSelectorComponent)(); };
TabSelectorComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TabSelectorComponent, selectors: [["cpc-tab-selector"]], viewQuery: function TabSelectorComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(TemplateRef, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.template = _t.first);
    } }, inputs: { selected: "selected" }, outputs: { click: "click" }, ngContentSelectors: _c1$5, decls: 1, vars: 0, consts: [[1, "cpc-tab-selector", 3, "ngClass", "click"]], template: function TabSelectorComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵtemplate(0, TabSelectorComponent_ng_template_0_Template, 2, 3, "ng-template");
    } }, dependencies: [i1.NgClass], styles: [".cpc-tab-selector{padding:6px 16px;color:var(--cpc-colors-resolution-blue);border-bottom:1px solid var(--cpc-colors-resolution-blue);cursor:pointer;-webkit-user-select:none;user-select:none}.cpc-tab-selector.cpc-tab-selector--selected{padding-bottom:4px;font-weight:700;border-bottom-width:3px}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TabSelectorComponent, [{
        type: Component,
        args: [{ selector: 'cpc-tab-selector', encapsulation: ViewEncapsulation.None, template: "<ng-template>\r\n  <div\r\n    (click)=\"handleClick()\"\r\n    [ngClass]=\"{ 'cpc-tab-selector--selected': selected }\"\r\n    class=\"cpc-tab-selector\"\r\n  >\r\n    <ng-content></ng-content>\r\n  </div>\r\n</ng-template>\r\n", styles: [".cpc-tab-selector{padding:6px 16px;color:var(--cpc-colors-resolution-blue);border-bottom:1px solid var(--cpc-colors-resolution-blue);cursor:pointer;-webkit-user-select:none;user-select:none}.cpc-tab-selector.cpc-tab-selector--selected{padding-bottom:4px;font-weight:700;border-bottom-width:3px}\n"] }]
    }], null, { selected: [{
            type: Input
        }], template: [{
            type: ViewChild,
            args: [TemplateRef]
        }], click: [{
            type: Output
        }] }); })();

function TabSelectorGroupComponent_div_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function TabSelectorGroupComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, TabSelectorGroupComponent_div_1_ng_container_1_Template, 1, 0, "ng-container", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const button_r1 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", button_r1.template);
} }
class TabSelectorGroupComponent {
    ngAfterContentInit() {
        this.buttons = this.childrenButtons.toArray();
    }
}
TabSelectorGroupComponent.ɵfac = function TabSelectorGroupComponent_Factory(t) { return new (t || TabSelectorGroupComponent)(); };
TabSelectorGroupComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TabSelectorGroupComponent, selectors: [["cpc-tab-selector-group"]], contentQueries: function TabSelectorGroupComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        i0.ɵɵcontentQuery(dirIndex, TabSelectorComponent, 4);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.childrenButtons = _t);
    } }, decls: 2, vars: 1, consts: [[1, "cpc-tab-selector-group"], ["class", "cpc-tab-selector-group_item", 4, "ngFor", "ngForOf"], [1, "cpc-tab-selector-group_item"], [4, "ngTemplateOutlet"]], template: function TabSelectorGroupComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, TabSelectorGroupComponent_div_1_Template, 2, 1, "div", 1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.buttons);
    } }, dependencies: [i1.NgForOf, i1.NgTemplateOutlet], styles: [".cpc-tab-selector-group{display:flex}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TabSelectorGroupComponent, [{
        type: Component,
        args: [{ selector: 'cpc-tab-selector-group', encapsulation: ViewEncapsulation.None, template: "<div class=\"cpc-tab-selector-group\">\r\n  <div\r\n    *ngFor=\"let button of buttons; let i = index\"\r\n    class=\"cpc-tab-selector-group_item\"\r\n  >\r\n    <ng-container *ngTemplateOutlet=\"button.template\"></ng-container>\r\n  </div>\r\n</div>\r\n", styles: [".cpc-tab-selector-group{display:flex}\n"] }]
    }], null, { childrenButtons: [{
            type: ContentChildren,
            args: [TabSelectorComponent]
        }] }); })();

const _c0$7 = function (a0, a1) { return { "cpc-legend-dot-empty": a0, "cpc-legend-dot": a1 }; };
function InvestmentComponent_ng_template_2_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 18);
} if (rf & 2) {
    const risk_r8 = ctx.$implicit;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(1, _c0$7, !risk_r8, risk_r8));
} }
function InvestmentComponent_ng_template_2_div_16_cpc_tab_selector_8_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cpc-tab-selector", 27);
    i0.ɵɵlistener("click", function InvestmentComponent_ng_template_2_div_16_cpc_tab_selector_8_Template_cpc_tab_selector_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r13); const i_r11 = restoredCtx.index; const ctx_r12 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r12.changeTabIndex(i_r11)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const tabName_r10 = ctx.$implicit;
    const i_r11 = ctx.index;
    const ctx_r9 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("selected", ctx_r9.selectedIndex === i_r11);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", tabName_r10, " ");
} }
function InvestmentComponent_ng_template_2_div_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19)(1, "div", 20);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 21)(4, "div", 22);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 23)(7, "cpc-tab-selector-group");
    i0.ɵɵtemplate(8, InvestmentComponent_ng_template_2_div_16_cpc_tab_selector_8_Template, 2, 2, "cpc-tab-selector", 24);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(9, "cpc-panel-group")(10, "cpc-panel", 25);
    i0.ɵɵelement(11, "cpc-area-chart", 26);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("@cpcSlideAnimation", ctx_r7.drawerOpen);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r7.data.chartDescription, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r7.textData.chartTitle);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r7.tabsName);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("paddingX", "0");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("data", ctx_r7.chartData[ctx_r7.selectedIndex]);
} }
function InvestmentComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7)(1, "div", 8)(2, "div", 9);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 10)(5, "span", 11);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div");
    i0.ɵɵtemplate(8, InvestmentComponent_ng_template_2_div_8_Template, 1, 4, "div", 12);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "div", 13)(10, "span", 14);
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 15);
    i0.ɵɵlistener("click", function InvestmentComponent_ng_template_2_Template_div_click_13_listener() { i0.ɵɵrestoreView(_r15); const ctx_r14 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r14.handleOpen(ctx_r14.data.name)); });
    i0.ɵɵtext(14);
    i0.ɵɵelement(15, "cpc-icon", 16);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(16, InvestmentComponent_ng_template_2_div_16_Template, 12, 6, "div", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.data.name, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.textData.riskLevel, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.riskData);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.textData.currency);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r0.data.currency, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.drawerOpen ? ctx_r0.textData.buttonHide : ctx_r0.textData.buttonShow, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r0.drawerOpen ? "cpc-investment-dropdown-icon cpc-investment-dropdown-icon--active" : "cpc-investment-dropdown-icon")("icon", ctx_r0.ndbxIcons.ChevronDown);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.drawerOpen);
} }
const _c1$4 = function (a0) { return { width: a0 }; };
function InvestmentComponent_ng_template_3_span_5_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 32)(1, "input", 33);
    i0.ɵɵlistener("input", function InvestmentComponent_ng_template_3_span_5_Template_input_input_1_listener($event) { i0.ɵɵrestoreView(_r18); const ctx_r17 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r17.handleChange($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵtext(2, "% ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("value", ctx_r16.data.next)("placeholder", ctx_r16.data.next)("ngStyle", i0.ɵɵpureFunction1(3, _c1$4, 11 * (ctx_r16.data.next ? ctx_r16.data.next.toString().length : 1) + "px"));
} }
function InvestmentComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28)(1, "div", 29);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 30);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, InvestmentComponent_ng_template_3_span_5_Template, 3, 5, "span", 31);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const _r4 = i0.ɵɵreference(7);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.data.name);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r1.data.current, "%");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r1.isNaN(ctx_r1.data.next))("ngIfElse", _r4);
} }
function InvestmentComponent_ng_template_4_span_5_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 37)(1, "input", 33);
    i0.ɵɵlistener("input", function InvestmentComponent_ng_template_4_span_5_Template_input_input_1_listener($event) { i0.ɵɵrestoreView(_r21); const ctx_r20 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r20.handleChange($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵtext(2, "% ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("value", ctx_r19.data.next)("placeholder", ctx_r19.data.next)("ngStyle", i0.ɵɵpureFunction1(3, _c1$4, 11 * (ctx_r19.data.next ? ctx_r19.data.next.toString().length : 1) + "px"));
} }
function InvestmentComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28)(1, "div", 34);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 35);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, InvestmentComponent_ng_template_4_span_5_Template, 3, 5, "span", 36);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    const _r4 = i0.ɵɵreference(7);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.data.name);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r2.data.current, "%");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.data.next ? !ctx_r2.isNaN(+ctx_r2.data.next) : false)("ngIfElse", _r4);
} }
function InvestmentComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 38)(1, "div", 29);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 32)(4, "input", 33);
    i0.ɵɵlistener("input", function InvestmentComponent_ng_template_5_Template_input_input_4_listener($event) { i0.ɵɵrestoreView(_r23); const ctx_r22 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r22.handleChange($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵtext(5, "% ");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r3.data.name);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("value", ctx_r3.data.value)("placeholder", ctx_r3.data.value)("ngStyle", i0.ɵɵpureFunction1(4, _c1$4, 11 * (ctx_r3.data.value ? ctx_r3.data.value.toString().length : 1) + "px"));
} }
function InvestmentComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 39);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r5.textData.unavailable, " ");
} }
class InvestmentComponent {
    constructor() {
        this.variant = 'programs';
        this.dataChange = new EventEmitter();
        this.drawerOpen = false;
        this.drawerOpenChange = new EventEmitter();
        this.isNaN = Number.isNaN;
        this.ndbxIcons = NdbxIcon;
        this.selectedIndex = 0;
    }
    get riskData() {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (!this.data.risk) {
            return [];
        }
        return Array(7)
            .fill(false)
            .map((_, index) => index < this.data.risk);
    }
    get chartData() {
        if (!this.data.chartData) {
            return [];
        }
        return Object.values(this.data.chartData);
    }
    get tabsName() {
        if (!this.data.chartData) {
            return [];
        }
        return Object.keys(this.data.chartData);
    }
    handleOpen(programName) {
        this.drawerOpen = !this.drawerOpen;
        const programEntry = {
            drawerOpen: this.drawerOpen,
            name: programName,
        };
        this.drawerOpenChange.emit(programEntry);
    }
    handleChange(event) {
        const value = event.target.value;
        if (value) {
            if (this.data.value || this.data.value === 0) {
                this.data.value = Number(value);
            }
            else if (this.data.next || this.data.next === 0) {
                this.data.next = Number(value);
            }
        }
        else {
            if (this.data.value || this.data.value === 0) {
                this.data.value = 0;
            }
            else if (this.data.next || this.data.next === 0) {
                this.data.next = 0;
            }
        }
        this.dataChange.emit(this.data);
    }
    changeTabIndex(i) {
        this.selectedIndex = i;
    }
}
InvestmentComponent.ɵfac = function InvestmentComponent_Factory(t) { return new (t || InvestmentComponent)(); };
InvestmentComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: InvestmentComponent, selectors: [["cpc-investment"]], inputs: { variant: "variant", data: "data", textData: "textData", last: "last", total: "total", drawerOpen: "drawerOpen" }, outputs: { dataChange: "dataChange", drawerOpenChange: "drawerOpenChange" }, decls: 8, vars: 1, consts: [[1, "cpc-investment"], [3, "ngSwitch"], ["ngSwitchCase", "programs"], ["ngSwitchCase", "topup"], ["ngSwitchCase", "transfers"], ["ngSwitchCase", "redirections"], ["unavailable", ""], [1, "cpc-investment-row_border-bottom"], [1, "cpc-investment-row", "cpc-investment-programs"], [1, "cpc-investment-row-name", "cpc-investment-row-name_border-bottom"], [1, "cpc-investment-row-risc"], [1, "cpc-investment-row-risc_title"], [3, "ngClass", 4, "ngFor", "ngForOf"], [1, "cpc-investment-row-currency"], [1, "cpc-investment-row-currency_title"], [1, "cpc-investment-row-button", "cpc-investment-row-button_border-bottom", 3, "click"], [3, "ngClass", "icon"], ["class", "cpc-investment-details", 4, "ngIf"], [3, "ngClass"], [1, "cpc-investment-details"], [1, "cpc-investment-description"], [1, "cpc-investment-chart"], [1, "cpc-investment-chart_title"], [1, "cpc-investment-chart_menu"], [3, "selected", "click", 4, "ngFor", "ngForOf"], [3, "paddingX"], [3, "data"], [3, "selected", "click"], [1, "cpc-investment-row", "cpc-investment-topup"], [1, "cpc-investment-redirections_name"], [1, "cpc-investment-top_value", "cpc-investment-topup_current"], ["class", "cpc-investment-redirections_value", 4, "ngIf", "ngIfElse"], [1, "cpc-investment-redirections_value"], ["onkeypress", "if (this.value.length === 3) return false", "type", "number", "min", "0", 1, "cpc-investment-redirections_input", 3, "value", "placeholder", "ngStyle", "input"], [1, "cpc-investment-topup_name"], [1, "cpc-investment-topup_current"], ["class", "cpc-investment-topup_value", 4, "ngIf", "ngIfElse"], [1, "cpc-investment-topup_value"], [1, "cpc-investment-row", "cpc-investment-redirections"], [1, "cpc-investment_unavailable"]], template: function InvestmentComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementContainerStart(1, 1);
        i0.ɵɵtemplate(2, InvestmentComponent_ng_template_2_Template, 17, 9, "ng-template", 2);
        i0.ɵɵtemplate(3, InvestmentComponent_ng_template_3_Template, 6, 4, "ng-template", 3);
        i0.ɵɵtemplate(4, InvestmentComponent_ng_template_4_Template, 6, 4, "ng-template", 4);
        i0.ɵɵtemplate(5, InvestmentComponent_ng_template_5_Template, 6, 6, "ng-template", 5);
        i0.ɵɵelementContainerEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(6, InvestmentComponent_ng_template_6_Template, 2, 1, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitch", ctx.variant);
    } }, dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i1.NgStyle, i1.NgSwitch, i1.NgSwitchCase, IconComponent, PanelComponent, PanelGroupComponent, AreaChartComponent, TabSelectorGroupComponent, TabSelectorComponent], styles: [".cpc-investment{margin-bottom:40px}.cpc-investment_unavailable{display:flex;justify-self:self-start;margin-left:16px}@media screen and (max-width: 703.98px){.cpc-investment_unavailable{justify-self:self-end;margin-left:0;font-size:14px;line-height:24px;letter-spacing:.16px}}@media screen and (min-width: 704px){.cpc-investment{margin:unset}}@media screen and (min-width: 704px){.cpc-investment-row_border-bottom{border-bottom:1px solid var(--cpc-colors-light-gray)}}.cpc-investment-row{display:grid;align-content:center;justify-items:center;width:100%;min-height:73px;font-size:20px}.cpc-investment-row>div{display:flex;align-items:center;justify-items:stretch;width:100%;color:var(--cpc-colors-charcoal);white-space:nowrap}@media screen and (min-width: 704px){.cpc-investment-row{display:inline-grid;grid-template-columns:4fr 4fr 2fr 7fr}}@media screen and (min-width: 992px){.cpc-investment-row{grid-template-columns:3fr 3fr 2fr 7fr}}.cpc-investment-programs{display:grid;grid-template-areas:\"name button\" \"risk risk\" \"currency currency\";row-gap:24px}.cpc-investment-programs .cpc-investment-row-name{grid-area:name}@media screen and (min-width: 704px){.cpc-investment-programs .cpc-investment-row-name{grid-area:unset}}@media screen and (min-width: 0) and (max-width: 703.98px){.cpc-investment-programs .cpc-investment-row-name_border-bottom{padding-bottom:16px;border-bottom:1px solid var(--cpc-colors-light-gray)}}.cpc-investment-programs .cpc-investment-row-currency{grid-area:currency;justify-content:space-between;margin-bottom:24px;font-weight:700;font-size:16px}.cpc-investment-programs .cpc-investment-row-currency_title{font-weight:400;font-size:20px}@media screen and (min-width: 704px){.cpc-investment-programs .cpc-investment-row-currency_title{display:none;justify-content:unset}}@media screen and (min-width: 704px){.cpc-investment-programs .cpc-investment-row-currency{grid-area:unset;margin-bottom:unset}}@media screen and (min-width: 704px){.cpc-investment-programs{row-gap:unset}}.cpc-legend-dot,.cpc-legend-dot-empty{display:inline-block;width:12px;height:12px;margin-right:8px;background-color:#007ab3;border-radius:100%}.cpc-legend-dot:last-of-type,.cpc-legend-dot-empty:last-of-type{margin-right:0}.cpc-legend-dot-empty{background-color:#fff;border:1px solid #007ab3}.cpc-investment-row-risc{grid-area:risk;justify-content:space-between}@media screen and (min-width: 704px){.cpc-investment-row-risc{grid-area:unset}}@media screen and (min-width: 704px){.cpc-investment-row-risc_title{display:none}}.cpc-investment-row-button{display:flex;grid-area:button;justify-content:flex-end;color:var(--cpc-colors-resolution-blue)!important;font-weight:600;font-size:16px;line-height:24px;cursor:pointer;-webkit-user-select:none;user-select:none}@media screen and (min-width: 704px){.cpc-investment-row-button{grid-area:unset}}@media screen and (min-width: 0) and (max-width: 703.98px){.cpc-investment-row-button_border-bottom{padding-bottom:16px;border-bottom:1px solid var(--cpc-colors-light-gray)}}.cpc-investment-dropdown-icon{margin-left:6px;font-size:24px;transition:transform .2s ease-out}.cpc-investment-dropdown-icon--active{transform:rotate(180deg)}@media screen and (min-width: 704px){.cpc-investment-dropdown-icon{margin-right:16px;margin-left:12px}}.area-chart{display:block;width:100%;overflow-x:auto!important}.cpc-investment-chart{display:flex;flex-direction:column;align-items:center;justify-content:space-between;margin-bottom:24px}.cpc-investment-chart_title{width:100%;margin-bottom:10px;color:var(--cpc-colors-charcoal);font-size:20px;line-height:30px;letter-spacing:.2px}@media screen and (min-width: 704px){.cpc-investment-chart_title{width:unset;margin-bottom:unset}}@media screen and (min-width: 704px){.cpc-investment-chart{flex-direction:unset}}.cpc-investment-details{display:flex;flex-direction:column;margin:0;white-space:normal}@media screen and (min-width: 704px){.cpc-investment-details{margin:32px 40px 40px}}.cpc-investment-description{margin:24px 0}@media screen and (min-width: 704px){.cpc-investment-description{margin-top:unset}}.cpc-checkbox{margin:0}@media screen and (min-width: 704px){.cpc-button{margin-left:40px}}.cpc-investment-redirections{grid-template-columns:5fr 6fr}@media screen and (min-width: 704px){.cpc-investment-redirections_name{padding-left:var(--invesments-row-padding-left)}}.cpc-investment-redirections_value{display:flex;width:100%;color:var(--cpc-colors-resolution-blue);line-height:25px}.cpc-investment-redirections_total-info--wrong{margin:0;color:var(--cpc-colors-cerise-red);font-size:12px;line-height:16px;letter-spacing:.5px;white-space:normal}.cpc-investment-redirections_total-value{display:block!important;justify-self:start;margin-left:16px;color:var(--cpc-colors-charcoal);white-space:nowrap}.cpc-investment-redirections_total-value--wrong{color:var(--cpc-colors-cerise-red);font-weight:600}@media screen and (min-width: 704px){.cpc-investment-redirections_total-value{white-space:unset}}.cpc-investment-redirections_input{display:flex;justify-self:flex-start;margin-right:1px;margin-left:16px;padding:0;color:var(--cpc-colors-resolution-blue);font-size:20px;border:0;outline:none;cursor:pointer;-webkit-user-select:none;user-select:none}.cpc-investment-redirections_input::-webkit-outer-spin-button,.cpc-investment-redirections_input::-webkit-inner-spin-button{margin:0;-webkit-appearance:none}.cpc-investment-redirections_input[type=number]{-moz-appearance:textfield}.cpc-investment-redirections_input::placeholder{color:var(--cpc-colors-resolution-blue)}.cpc-investment-redirections_input:focus{width:50px;border-bottom:1px solid var(--cpc-colors-charcoal)}.cpc-investment-topup{grid-template-columns:7.5fr 4fr 4fr}@media screen and (min-width: 704px){.cpc-investment-topup_name{padding-left:var(--invesments-row-padding-left)}}.cpc-investment-topup_current{justify-self:start;margin-left:16px;color:var(--cpc-colors-charcoal)}.cpc-investment-topup_value{display:flex;width:100%;color:var(--cpc-colors-resolution-blue);line-height:25px}@media screen and (min-width: 704px){.cpc-investment-topup{grid-template-columns:5fr 4fr 6fr}}\n"], encapsulation: 2, data: { animation: [animationBuilder(AngularAnimationsTypes.SLIDE, 400, 400)] } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InvestmentComponent, [{
        type: Component,
        args: [{ selector: 'cpc-investment', animations: [animationBuilder(AngularAnimationsTypes.SLIDE, 400, 400)], encapsulation: ViewEncapsulation.None, template: "<div class=\"cpc-investment\">\r\n  <ng-container [ngSwitch]=\"variant\">\r\n    <ng-template ngSwitchCase=\"programs\">\r\n      <div class=\"cpc-investment-row_border-bottom\">\r\n        <div class=\"cpc-investment-row cpc-investment-programs\">\r\n          <div class=\"cpc-investment-row-name cpc-investment-row-name_border-bottom\">\r\n            {{data.name}}\r\n          </div>\r\n          <div class=\"cpc-investment-row-risc\">\r\n            <span class=\"cpc-investment-row-risc_title\">\r\n              {{textData.riskLevel}}\r\n            </span>\r\n            <div>\r\n              <div\r\n                *ngFor=\"let risk of riskData\"\r\n                [ngClass]=\"{'cpc-legend-dot-empty' : !risk, 'cpc-legend-dot' : risk}\"\r\n              ></div>\r\n            </div>\r\n          </div>\r\n          <div class=\"cpc-investment-row-currency\">\r\n            <span class=\"cpc-investment-row-currency_title\">{{textData.currency}}</span>{{data.currency}}\r\n          </div>\r\n          <div\r\n            (click)=\"handleOpen(data.name)\"\r\n            class=\"cpc-investment-row-button cpc-investment-row-button_border-bottom\"\r\n          >\r\n            {{drawerOpen ? textData.buttonHide : textData.buttonShow}}\r\n            <cpc-icon\r\n              [ngClass]=\"drawerOpen ? 'cpc-investment-dropdown-icon cpc-investment-dropdown-icon--active' : 'cpc-investment-dropdown-icon'\"\r\n              [icon]=\"ndbxIcons.ChevronDown\"\r\n            ></cpc-icon>\r\n          </div>\r\n        </div>\r\n        <div\r\n          *ngIf=\"drawerOpen\"\r\n          [@cpcSlideAnimation]=\"drawerOpen\"\r\n          class=\"cpc-investment-details\"\r\n        >\r\n          <div class=\"cpc-investment-description\">\r\n            {{data.chartDescription}}\r\n          </div>\r\n          <div class=\"cpc-investment-chart\">\r\n            <div class=\"cpc-investment-chart_title\">{{textData.chartTitle}}</div>\r\n            <div class=\"cpc-investment-chart_menu\">\r\n              <cpc-tab-selector-group>\r\n                <cpc-tab-selector\r\n                  *ngFor=\"let tabName of tabsName; let i = index\"\r\n                  [selected]=\"selectedIndex === i\"\r\n                  (click)=\"changeTabIndex(i)\"\r\n                >\r\n                  {{tabName}}\r\n                </cpc-tab-selector>\r\n              </cpc-tab-selector-group>\r\n            </div>\r\n          </div>\r\n          <cpc-panel-group>\r\n            <cpc-panel [paddingX]=\"'0'\">\r\n              <cpc-area-chart [data]=\"chartData[selectedIndex]\"></cpc-area-chart>\r\n            </cpc-panel>\r\n          </cpc-panel-group>\r\n        </div>\r\n      </div>\r\n    </ng-template>\r\n    <ng-template ngSwitchCase=\"topup\">\r\n      <div class=\"cpc-investment-row cpc-investment-topup\">\r\n        <div class=\"cpc-investment-redirections_name\">{{data.name}}</div>\r\n        <span class=\"cpc-investment-top_value cpc-investment-topup_current\">{{data.current}}%</span>\r\n        <span\r\n          *ngIf=\"!isNaN(data.next); else unavailable\"\r\n          class=\"cpc-investment-redirections_value\"\r\n        >\r\n          <input\r\n            [value]=\"data.next\"\r\n            [placeholder]=\"data.next\"\r\n            (input)=\"handleChange($event)\"\r\n            onkeypress=\"if (this.value.length === 3) return false\"\r\n            [ngStyle]=\"{width: 11 * (data.next ? data.next.toString().length : 1) + 'px'}\"\r\n            class=\"cpc-investment-redirections_input\"\r\n            type=\"number\"\r\n            min=\"0\"\r\n          >%\r\n        </span>\r\n      </div>\r\n    </ng-template>\r\n    <ng-template ngSwitchCase=\"transfers\">\r\n      <div class=\"cpc-investment-row cpc-investment-topup\">\r\n        <div class=\"cpc-investment-topup_name\">{{data.name}}</div>\r\n        <span class=\"cpc-investment-topup_current\">{{data.current}}%</span>\r\n        <span\r\n          *ngIf=\"data.next ? !isNaN(+data.next) : false; else unavailable\"\r\n          class=\"cpc-investment-topup_value\"\r\n        >\r\n          <input\r\n            [value]=\"data.next\"\r\n            [placeholder]=\"data.next\"\r\n            (input)=\"handleChange($event)\"\r\n            onkeypress=\"if (this.value.length === 3) return false\"\r\n            [ngStyle]=\"{width: 11 * (data.next ? data.next.toString().length : 1) + 'px'}\"\r\n            class=\"cpc-investment-redirections_input\"\r\n            type=\"number\"\r\n            min=\"0\"\r\n          >%\r\n        </span>\r\n      </div>\r\n    </ng-template>\r\n    <ng-template ngSwitchCase=\"redirections\">\r\n      <div class=\"cpc-investment-row cpc-investment-redirections\">\r\n        <div class=\"cpc-investment-redirections_name\">{{data.name}}</div>\r\n        <span class=\"cpc-investment-redirections_value\">\r\n          <input\r\n            [value]=\"data.value\"\r\n            [placeholder]=\"data.value\"\r\n            (input)=\"handleChange($event)\"\r\n            onkeypress=\"if (this.value.length === 3) return false\"\r\n            [ngStyle]=\"{width: 11 * (data.value ? data.value.toString().length : 1) + 'px'}\"\r\n            class=\"cpc-investment-redirections_input\"\r\n            type=\"number\"\r\n            min=\"0\"\r\n          >%\r\n        </span>\r\n      </div>\r\n    </ng-template>\r\n  </ng-container>\r\n</div>\r\n\r\n<ng-template #unavailable>\r\n  <div class=\"cpc-investment_unavailable\">\r\n    {{textData.unavailable}}\r\n  </div>\r\n</ng-template>\r\n\r\n\r\n", styles: [".cpc-investment{margin-bottom:40px}.cpc-investment_unavailable{display:flex;justify-self:self-start;margin-left:16px}@media screen and (max-width: 703.98px){.cpc-investment_unavailable{justify-self:self-end;margin-left:0;font-size:14px;line-height:24px;letter-spacing:.16px}}@media screen and (min-width: 704px){.cpc-investment{margin:unset}}@media screen and (min-width: 704px){.cpc-investment-row_border-bottom{border-bottom:1px solid var(--cpc-colors-light-gray)}}.cpc-investment-row{display:grid;align-content:center;justify-items:center;width:100%;min-height:73px;font-size:20px}.cpc-investment-row>div{display:flex;align-items:center;justify-items:stretch;width:100%;color:var(--cpc-colors-charcoal);white-space:nowrap}@media screen and (min-width: 704px){.cpc-investment-row{display:inline-grid;grid-template-columns:4fr 4fr 2fr 7fr}}@media screen and (min-width: 992px){.cpc-investment-row{grid-template-columns:3fr 3fr 2fr 7fr}}.cpc-investment-programs{display:grid;grid-template-areas:\"name button\" \"risk risk\" \"currency currency\";row-gap:24px}.cpc-investment-programs .cpc-investment-row-name{grid-area:name}@media screen and (min-width: 704px){.cpc-investment-programs .cpc-investment-row-name{grid-area:unset}}@media screen and (min-width: 0) and (max-width: 703.98px){.cpc-investment-programs .cpc-investment-row-name_border-bottom{padding-bottom:16px;border-bottom:1px solid var(--cpc-colors-light-gray)}}.cpc-investment-programs .cpc-investment-row-currency{grid-area:currency;justify-content:space-between;margin-bottom:24px;font-weight:700;font-size:16px}.cpc-investment-programs .cpc-investment-row-currency_title{font-weight:400;font-size:20px}@media screen and (min-width: 704px){.cpc-investment-programs .cpc-investment-row-currency_title{display:none;justify-content:unset}}@media screen and (min-width: 704px){.cpc-investment-programs .cpc-investment-row-currency{grid-area:unset;margin-bottom:unset}}@media screen and (min-width: 704px){.cpc-investment-programs{row-gap:unset}}.cpc-legend-dot,.cpc-legend-dot-empty{display:inline-block;width:12px;height:12px;margin-right:8px;background-color:#007ab3;border-radius:100%}.cpc-legend-dot:last-of-type,.cpc-legend-dot-empty:last-of-type{margin-right:0}.cpc-legend-dot-empty{background-color:#fff;border:1px solid #007ab3}.cpc-investment-row-risc{grid-area:risk;justify-content:space-between}@media screen and (min-width: 704px){.cpc-investment-row-risc{grid-area:unset}}@media screen and (min-width: 704px){.cpc-investment-row-risc_title{display:none}}.cpc-investment-row-button{display:flex;grid-area:button;justify-content:flex-end;color:var(--cpc-colors-resolution-blue)!important;font-weight:600;font-size:16px;line-height:24px;cursor:pointer;-webkit-user-select:none;user-select:none}@media screen and (min-width: 704px){.cpc-investment-row-button{grid-area:unset}}@media screen and (min-width: 0) and (max-width: 703.98px){.cpc-investment-row-button_border-bottom{padding-bottom:16px;border-bottom:1px solid var(--cpc-colors-light-gray)}}.cpc-investment-dropdown-icon{margin-left:6px;font-size:24px;transition:transform .2s ease-out}.cpc-investment-dropdown-icon--active{transform:rotate(180deg)}@media screen and (min-width: 704px){.cpc-investment-dropdown-icon{margin-right:16px;margin-left:12px}}.area-chart{display:block;width:100%;overflow-x:auto!important}.cpc-investment-chart{display:flex;flex-direction:column;align-items:center;justify-content:space-between;margin-bottom:24px}.cpc-investment-chart_title{width:100%;margin-bottom:10px;color:var(--cpc-colors-charcoal);font-size:20px;line-height:30px;letter-spacing:.2px}@media screen and (min-width: 704px){.cpc-investment-chart_title{width:unset;margin-bottom:unset}}@media screen and (min-width: 704px){.cpc-investment-chart{flex-direction:unset}}.cpc-investment-details{display:flex;flex-direction:column;margin:0;white-space:normal}@media screen and (min-width: 704px){.cpc-investment-details{margin:32px 40px 40px}}.cpc-investment-description{margin:24px 0}@media screen and (min-width: 704px){.cpc-investment-description{margin-top:unset}}.cpc-checkbox{margin:0}@media screen and (min-width: 704px){.cpc-button{margin-left:40px}}.cpc-investment-redirections{grid-template-columns:5fr 6fr}@media screen and (min-width: 704px){.cpc-investment-redirections_name{padding-left:var(--invesments-row-padding-left)}}.cpc-investment-redirections_value{display:flex;width:100%;color:var(--cpc-colors-resolution-blue);line-height:25px}.cpc-investment-redirections_total-info--wrong{margin:0;color:var(--cpc-colors-cerise-red);font-size:12px;line-height:16px;letter-spacing:.5px;white-space:normal}.cpc-investment-redirections_total-value{display:block!important;justify-self:start;margin-left:16px;color:var(--cpc-colors-charcoal);white-space:nowrap}.cpc-investment-redirections_total-value--wrong{color:var(--cpc-colors-cerise-red);font-weight:600}@media screen and (min-width: 704px){.cpc-investment-redirections_total-value{white-space:unset}}.cpc-investment-redirections_input{display:flex;justify-self:flex-start;margin-right:1px;margin-left:16px;padding:0;color:var(--cpc-colors-resolution-blue);font-size:20px;border:0;outline:none;cursor:pointer;-webkit-user-select:none;user-select:none}.cpc-investment-redirections_input::-webkit-outer-spin-button,.cpc-investment-redirections_input::-webkit-inner-spin-button{margin:0;-webkit-appearance:none}.cpc-investment-redirections_input[type=number]{-moz-appearance:textfield}.cpc-investment-redirections_input::placeholder{color:var(--cpc-colors-resolution-blue)}.cpc-investment-redirections_input:focus{width:50px;border-bottom:1px solid var(--cpc-colors-charcoal)}.cpc-investment-topup{grid-template-columns:7.5fr 4fr 4fr}@media screen and (min-width: 704px){.cpc-investment-topup_name{padding-left:var(--invesments-row-padding-left)}}.cpc-investment-topup_current{justify-self:start;margin-left:16px;color:var(--cpc-colors-charcoal)}.cpc-investment-topup_value{display:flex;width:100%;color:var(--cpc-colors-resolution-blue);line-height:25px}@media screen and (min-width: 704px){.cpc-investment-topup{grid-template-columns:5fr 4fr 6fr}}\n"] }]
    }], null, { variant: [{
            type: Input
        }], data: [{
            type: Input
        }], dataChange: [{
            type: Output
        }], textData: [{
            type: Input
        }], last: [{
            type: Input
        }], total: [{
            type: Input
        }], drawerOpen: [{
            type: Input
        }], drawerOpenChange: [{
            type: Output
        }] }); })();

function InvestmentHeaderComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6)(1, "div", 7);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 8);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 9);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.textData.name);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.textData.riskLevel);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.textData.currency);
} }
function InvestmentHeaderComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10)(1, "div", 7);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 11);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.textData.name);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.textData.transferText);
} }
function InvestmentHeaderComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12)(1, "div", 7);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 13);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 14);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.textData.name);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.textData.currentAllocation);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.textData.futureAllocation);
} }
function InvestmentHeaderComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15)(1, "div", 7);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 13);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 16);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r3.textData.name);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r3.textData.currentAllocation);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r3.textData.sumAllocation);
} }
class InvestmentHeaderComponent {
    constructor() {
        this.variant = 'programs';
    }
}
InvestmentHeaderComponent.ɵfac = function InvestmentHeaderComponent_Factory(t) { return new (t || InvestmentHeaderComponent)(); };
InvestmentHeaderComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: InvestmentHeaderComponent, selectors: [["cpc-investment-header"]], inputs: { variant: "variant", data: "data", textData: "textData" }, decls: 6, vars: 1, consts: [[1, "cpc-investment"], [3, "ngSwitch"], ["ngSwitchCase", "programs"], ["ngSwitchCase", "redirections"], ["ngSwitchCase", "transfers"], ["ngSwitchCase", "topup"], [1, "cpc-investment-header"], [1, "cpc-investment-row-name"], [1, "cpc-investment-row-risc"], [1, "cpc-investment-row-currency"], [1, "cpc-investment-header", "cpc-investment-header_redirections"], [1, "cpc-investment-row-transfer"], [1, "cpc-investment-header", "cpc-investment-header_transfers"], [1, "cpc-investment-row-allocation"], [1, "cpc-investment-row-future-allocation"], [1, "cpc-investment-header", "cpc-investment-header_topup"], [1, "cpc-investment-row-investment"]], template: function InvestmentHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementContainerStart(1, 1);
        i0.ɵɵtemplate(2, InvestmentHeaderComponent_ng_template_2_Template, 7, 3, "ng-template", 2);
        i0.ɵɵtemplate(3, InvestmentHeaderComponent_ng_template_3_Template, 5, 2, "ng-template", 3);
        i0.ɵɵtemplate(4, InvestmentHeaderComponent_ng_template_4_Template, 7, 3, "ng-template", 4);
        i0.ɵɵtemplate(5, InvestmentHeaderComponent_ng_template_5_Template, 7, 3, "ng-template", 5);
        i0.ɵɵelementContainerEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitch", ctx.variant);
    } }, dependencies: [i1.NgSwitch, i1.NgSwitchCase], styles: [".cpc-investment-header{display:none;align-items:center;justify-items:center;width:100%;padding-bottom:14px;color:var(--cpc-colors-charcoal);font-weight:600;border-bottom:1px solid var(--cpc-colors-light-gray)}.cpc-investment-header_redirections{grid-template-columns:5fr 6fr!important}.cpc-investment-header_topup,.cpc-investment-header_transfers{grid-template-columns:5fr 4fr 6fr!important}.cpc-investment-header>div{display:flex;align-items:center;justify-content:space-between;justify-items:stretch;width:100%;white-space:nowrap}@media screen and (min-width: 704px){.cpc-investment-header{display:inline-grid;grid-template-columns:4fr 4fr 2fr 7fr}}@media screen and (min-width: 992px){.cpc-investment-header{grid-template-columns:3fr 3fr 2fr 7fr}}\n"], encapsulation: 2, data: { animation: [animationBuilder(AngularAnimationsTypes.SLIDE, 300, 200)] } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InvestmentHeaderComponent, [{
        type: Component,
        args: [{ selector: 'cpc-investment-header', animations: [animationBuilder(AngularAnimationsTypes.SLIDE, 300, 200)], encapsulation: ViewEncapsulation.None, template: "<div class=\"cpc-investment\">\r\n  <ng-container [ngSwitch]=\"variant\">\r\n    <ng-template ngSwitchCase=\"programs\">\r\n      <div class=\"cpc-investment-header\">\r\n        <div class=\"cpc-investment-row-name\">{{textData.name}}</div>\r\n        <div class=\"cpc-investment-row-risc\">{{textData.riskLevel}}</div>\r\n        <div class=\"cpc-investment-row-currency\">{{textData.currency}}</div>\r\n      </div>\r\n    </ng-template>\r\n    <ng-template ngSwitchCase=\"redirections\">\r\n      <div class=\"cpc-investment-header cpc-investment-header_redirections\">\r\n        <div class=\"cpc-investment-row-name\">{{textData.name}}</div>\r\n        <div class=\"cpc-investment-row-transfer\">{{textData.transferText}}</div>\r\n      </div>\r\n    </ng-template>\r\n    <ng-template ngSwitchCase=\"transfers\">\r\n      <div class=\"cpc-investment-header cpc-investment-header_transfers\">\r\n        <div class=\"cpc-investment-row-name\">{{textData.name}}</div>\r\n        <div class=\"cpc-investment-row-allocation\">{{textData.currentAllocation}}</div>\r\n        <div class=\"cpc-investment-row-future-allocation\">{{textData.futureAllocation}}</div>\r\n      </div>\r\n    </ng-template>\r\n    <ng-template ngSwitchCase=\"topup\">\r\n      <div class=\"cpc-investment-header cpc-investment-header_topup\">\r\n        <div class=\"cpc-investment-row-name\">{{textData.name}}</div>\r\n        <div class=\"cpc-investment-row-allocation\">{{textData.currentAllocation}}</div>\r\n        <div class=\"cpc-investment-row-investment\">{{textData.sumAllocation}}</div>\r\n      </div>\r\n    </ng-template>\r\n  </ng-container>\r\n</div>\r\n", styles: [".cpc-investment-header{display:none;align-items:center;justify-items:center;width:100%;padding-bottom:14px;color:var(--cpc-colors-charcoal);font-weight:600;border-bottom:1px solid var(--cpc-colors-light-gray)}.cpc-investment-header_redirections{grid-template-columns:5fr 6fr!important}.cpc-investment-header_topup,.cpc-investment-header_transfers{grid-template-columns:5fr 4fr 6fr!important}.cpc-investment-header>div{display:flex;align-items:center;justify-content:space-between;justify-items:stretch;width:100%;white-space:nowrap}@media screen and (min-width: 704px){.cpc-investment-header{display:inline-grid;grid-template-columns:4fr 4fr 2fr 7fr}}@media screen and (min-width: 992px){.cpc-investment-header{grid-template-columns:3fr 3fr 2fr 7fr}}\n"] }]
    }], null, { variant: [{
            type: Input
        }], data: [{
            type: Input
        }], textData: [{
            type: Input
        }] }); })();

function InvestmentTotalComponent_ng_container_0_p_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 6);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.textData.errorText, " ");
} }
const _c0$6 = function (a0) { return { "cpc-investment-redirections_total-value--wrong": a0 }; };
function InvestmentTotalComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 2)(2, "div", 3);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 4);
    i0.ɵɵtext(5);
    i0.ɵɵtemplate(6, InvestmentTotalComponent_ng_container_0_p_6_Template, 2, 1, "p", 5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.textData.total);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c0$6, ctx_r0.total !== 100));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r0.total, "% ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.total !== 100);
} }
function InvestmentTotalComponent_ng_template_1_p_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 6);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.textData.errorText, " ");
} }
function InvestmentTotalComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7)(1, "div", 3);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 4);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 4);
    i0.ɵɵtext(6);
    i0.ɵɵtemplate(7, InvestmentTotalComponent_ng_template_1_p_7_Template, 2, 1, "p", 5);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.textData.total);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c0$6, ctx_r2.total !== 100));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.totalForCurrent, "% ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c0$6, ctx_r2.total !== 100));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.totalForNext, "% ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.totalForNext !== 100);
} }
class InvestmentTotalComponent {
    get totalForCurrent() {
        let totalForCurrent = 0;
        this.data.forEach((dataEntity) => {
            if (dataEntity.current) {
                totalForCurrent += dataEntity.current;
            }
        });
        return totalForCurrent;
    }
    get totalForNext() {
        let totalForNext = 0;
        this.data.forEach((dataEntity) => {
            if (dataEntity.next) {
                totalForNext += dataEntity.next;
            }
        });
        return totalForNext;
    }
    get total() {
        let total = 0;
        this.data.forEach((dataSet) => {
            if (dataSet.value) {
                total += dataSet.value;
            }
        });
        return total;
    }
}
InvestmentTotalComponent.ɵfac = function InvestmentTotalComponent_Factory(t) { return new (t || InvestmentTotalComponent)(); };
InvestmentTotalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: InvestmentTotalComponent, selectors: [["cpc-investment-total"]], inputs: { variant: "variant", data: "data", textData: "textData" }, decls: 3, vars: 2, consts: [[4, "ngIf", "ngIfElse"], ["doubleCol", ""], [1, "cpc-investment-row", "cpc-investment-redirections"], [1, "cpc-investment-redirections_name"], [1, "cpc-investment-redirections_total-value", 3, "ngClass"], ["class", "cpc-investment-redirections_total-info--wrong", 4, "ngIf"], [1, "cpc-investment-redirections_total-info--wrong"], [1, "cpc-investment-row", "cpc-investment-topup"]], template: function InvestmentTotalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, InvestmentTotalComponent_ng_container_0_Template, 7, 6, "ng-container", 0);
        i0.ɵɵtemplate(1, InvestmentTotalComponent_ng_template_1_Template, 8, 10, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(2);
        i0.ɵɵproperty("ngIf", ctx.variant === "redirections")("ngIfElse", _r1);
    } }, dependencies: [i1.NgClass, i1.NgIf], styles: [".cpc-investment-footer{display:flex;flex-direction:column;row-gap:32px;align-items:center;justify-content:flex-end;width:100%;margin-top:32px;padding-bottom:14px}.cpc-investment-footer>div{display:flex;align-items:center;justify-content:space-between;justify-items:stretch;width:100%;padding-left:24px;white-space:nowrap}@media screen and (min-width: 704px){.cpc-investment-footer{flex-direction:unset;row-gap:unset}}\n"], encapsulation: 2, data: { animation: [animationBuilder(AngularAnimationsTypes.SLIDE, 300, 200)] } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InvestmentTotalComponent, [{
        type: Component,
        args: [{ selector: 'cpc-investment-total', animations: [animationBuilder(AngularAnimationsTypes.SLIDE, 300, 200)], encapsulation: ViewEncapsulation.None, template: "<ng-container *ngIf=\"variant === 'redirections';else doubleCol\">\r\n  <div class=\"cpc-investment-row cpc-investment-redirections\">\r\n    <div class=\"cpc-investment-redirections_name\">{{textData.total}}</div>\r\n    <div\r\n      [ngClass]=\"{'cpc-investment-redirections_total-value--wrong' : total !== 100}\"\r\n      class=\"cpc-investment-redirections_total-value\"\r\n    >{{total}}%\r\n      <p\r\n        *ngIf=\"total !== 100\"\r\n        class=\"cpc-investment-redirections_total-info--wrong\"\r\n      >\r\n        {{textData.errorText}}\r\n      </p>\r\n    </div>\r\n  </div>\r\n</ng-container>\r\n\r\n<ng-template #doubleCol>\r\n  <div class=\"cpc-investment-row cpc-investment-topup\">\r\n    <div class=\"cpc-investment-redirections_name\">{{textData.total}}</div>\r\n    <div\r\n      [ngClass]=\"{'cpc-investment-redirections_total-value--wrong' : total !== 100}\"\r\n      class=\"cpc-investment-redirections_total-value\"\r\n    >\r\n      {{ totalForCurrent }}%\r\n    </div>\r\n    <div\r\n      [ngClass]=\"{'cpc-investment-redirections_total-value--wrong' : total !== 100}\"\r\n      class=\"cpc-investment-redirections_total-value\"\r\n    >\r\n      {{ totalForNext }}%\r\n      <p\r\n        *ngIf=\"totalForNext !== 100\"\r\n        class=\"cpc-investment-redirections_total-info--wrong\"\r\n      >\r\n        {{textData.errorText}}\r\n      </p>\r\n    </div>\r\n  </div>\r\n</ng-template>\r\n", styles: [".cpc-investment-footer{display:flex;flex-direction:column;row-gap:32px;align-items:center;justify-content:flex-end;width:100%;margin-top:32px;padding-bottom:14px}.cpc-investment-footer>div{display:flex;align-items:center;justify-content:space-between;justify-items:stretch;width:100%;padding-left:24px;white-space:nowrap}@media screen and (min-width: 704px){.cpc-investment-footer{flex-direction:unset;row-gap:unset}}\n"] }]
    }], null, { variant: [{
            type: Input
        }], data: [{
            type: Input
        }], textData: [{
            type: Input
        }] }); })();

class InvestmentFooterComponent {
    constructor() {
        this.submitForm = new EventEmitter();
    }
    get total() {
        let total = 0;
        this.data.forEach((dataSet) => {
            if (dataSet.value) {
                total += dataSet.value;
            }
            else if (dataSet.next) {
                total += dataSet.next;
            }
        });
        return total;
    }
    submitData() {
        this.submitForm.emit(this.data);
    }
}
InvestmentFooterComponent.ɵfac = function InvestmentFooterComponent_Factory(t) { return new (t || InvestmentFooterComponent)(); };
InvestmentFooterComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: InvestmentFooterComponent, selectors: [["cpc-investment-footer"]], inputs: { data: "data", textData: "textData" }, outputs: { submitForm: "submitForm" }, decls: 5, vars: 5, consts: [[1, "cpc-investment-footer"], [3, "checked", "checkedChange"], ["size", "small", 3, "noVerticalMargin", "disabled", "click"]], template: function InvestmentFooterComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "cpc-checkbox", 1);
        i0.ɵɵlistener("checkedChange", function InvestmentFooterComponent_Template_cpc_checkbox_checkedChange_1_listener($event) { return ctx.checked = $event; });
        i0.ɵɵtext(2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "cpc-button", 2);
        i0.ɵɵlistener("click", function InvestmentFooterComponent_Template_cpc_button_click_3_listener() { return ctx.submitData(); });
        i0.ɵɵtext(4);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("checked", ctx.checked);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(ctx.textData.footerCheckboxText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("noVerticalMargin", true)("disabled", !ctx.checked || ctx.total !== 100);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.textData.footerButtonText, " ");
    } }, dependencies: [ButtonComponent, CheckboxComponent], styles: [".cpc-investment-footer{display:flex;flex-direction:column;row-gap:32px;align-items:center;justify-content:flex-end;width:100%;margin-top:32px;padding-bottom:14px}.cpc-investment-footer>div{display:flex;align-items:center;justify-content:space-between;justify-items:stretch;width:100%;padding-left:var(--invesments-row-padding-left);white-space:nowrap}.cpc-investment-footer cpc-checkbox{width:-moz-fit-content;width:fit-content}.cpc-investment-footer .cpc-checkbox{align-items:center;color:var(--cpc-colors-charcoal);-webkit-user-select:none;user-select:none}.cpc-investment-footer .cpc-checkbox_control{margin-right:16px}.cpc-investment-footer .cpc-button{width:160px!important}@media screen and (min-width: 704px){.cpc-investment-footer{flex-direction:unset;row-gap:unset}}\n"], encapsulation: 2, data: { animation: [animationBuilder(AngularAnimationsTypes.SLIDE, 300, 200)] } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InvestmentFooterComponent, [{
        type: Component,
        args: [{ selector: 'cpc-investment-footer', animations: [animationBuilder(AngularAnimationsTypes.SLIDE, 300, 200)], encapsulation: ViewEncapsulation.None, template: "<div class=\"cpc-investment-footer\">\r\n  <cpc-checkbox [(checked)]=\"checked\">{{textData.footerCheckboxText}}</cpc-checkbox>\r\n  <cpc-button\r\n    [noVerticalMargin]=\"true\"\r\n    [disabled]=\"!checked || total !== 100\"\r\n    size=\"small\"\r\n    (click)=\"submitData()\"\r\n  >\r\n    {{textData.footerButtonText}}\r\n  </cpc-button>\r\n</div>\r\n\r\n\r\n\r\n", styles: [".cpc-investment-footer{display:flex;flex-direction:column;row-gap:32px;align-items:center;justify-content:flex-end;width:100%;margin-top:32px;padding-bottom:14px}.cpc-investment-footer>div{display:flex;align-items:center;justify-content:space-between;justify-items:stretch;width:100%;padding-left:var(--invesments-row-padding-left);white-space:nowrap}.cpc-investment-footer cpc-checkbox{width:-moz-fit-content;width:fit-content}.cpc-investment-footer .cpc-checkbox{align-items:center;color:var(--cpc-colors-charcoal);-webkit-user-select:none;user-select:none}.cpc-investment-footer .cpc-checkbox_control{margin-right:16px}.cpc-investment-footer .cpc-button{width:160px!important}@media screen and (min-width: 704px){.cpc-investment-footer{flex-direction:unset;row-gap:unset}}\n"] }]
    }], null, { data: [{
            type: Input
        }], textData: [{
            type: Input
        }], submitForm: [{
            type: Output
        }] }); })();

const _c0$5 = ["claimsTable"];
function ClaimsTableComponent_cpc_claims_table_swiper_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "cpc-claims-table-swiper", 8);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const _r1 = i0.ɵɵreference(2);
    i0.ɵɵproperty("copySwiper", ctx_r0.copySwiper)("claimsTable", _r1);
} }
function ClaimsTableComponent_cpc_claims_table_col_4_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cpc-claims-table-col", 9);
    i0.ɵɵlistener("sortAscending", function ClaimsTableComponent_cpc_claims_table_col_4_Template_cpc_claims_table_col_sortAscending_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r9); const index_r7 = restoredCtx.index; const ctx_r8 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r8.sort(index_r7, ctx_r8.sortingDirection.Ascending)); })("sortDescending", function ClaimsTableComponent_cpc_claims_table_col_4_Template_cpc_claims_table_col_sortDescending_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r9); const index_r7 = restoredCtx.index; const ctx_r10 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r10.sort(index_r7, ctx_r10.sortingDirection.Descending)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const sourceDataColumn_r6 = ctx.$implicit;
    const index_r7 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("sortEnabled", true)("sortIndex", index_r7)("activeSortDirection", ctx_r2.activeSortDirection)("activeSortIndex", ctx_r2.activeSortIndex);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", sourceDataColumn_r6, " ");
} }
function ClaimsTableComponent_cpc_claims_table_row_5_cpc_claims_table_col_2_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const data_r14 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(data_r14.content);
} }
function ClaimsTableComponent_cpc_claims_table_row_5_cpc_claims_table_col_2_ng_container_2_a_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const data_r14 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("href", data_r14.url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(data_r14.content);
} }
function ClaimsTableComponent_cpc_claims_table_row_5_cpc_claims_table_col_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ClaimsTableComponent_cpc_claims_table_row_5_cpc_claims_table_col_2_ng_container_2_ng_container_1_Template, 2, 1, "ng-container", 14);
    i0.ɵɵtemplate(2, ClaimsTableComponent_cpc_claims_table_row_5_cpc_claims_table_col_2_ng_container_2_a_2_Template, 2, 2, "a", 15);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const data_r14 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !data_r14.url);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", data_r14.url);
} }
function ClaimsTableComponent_cpc_claims_table_row_5_cpc_claims_table_col_2_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "cpc-badge", 17);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const data_r14 = i0.ɵɵnextContext().$implicit;
    const ctx_r16 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("variant", data_r14.badgeType ? data_r14.badgeType : ctx_r16.badgeVariant.Default);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", data_r14.content, " ");
} }
function ClaimsTableComponent_cpc_claims_table_row_5_cpc_claims_table_col_2_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "dateFormat");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const data_r14 = i0.ɵɵnextContext().$implicit;
    const ctx_r17 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind3(2, 1, data_r14.content, ctx_r17.datePipeFormatFull, ctx_r17.datePipeFormatShort), " ");
} }
function ClaimsTableComponent_cpc_claims_table_row_5_cpc_claims_table_col_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "cpc-claims-table-col");
    i0.ɵɵelementContainerStart(1, 11);
    i0.ɵɵtemplate(2, ClaimsTableComponent_cpc_claims_table_row_5_cpc_claims_table_col_2_ng_container_2_Template, 3, 2, "ng-container", 12);
    i0.ɵɵtemplate(3, ClaimsTableComponent_cpc_claims_table_row_5_cpc_claims_table_col_2_ng_container_3_Template, 3, 2, "ng-container", 13);
    i0.ɵɵtemplate(4, ClaimsTableComponent_cpc_claims_table_row_5_cpc_claims_table_col_2_ng_container_4_Template, 3, 5, "ng-container", 13);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const data_r14 = ctx.$implicit;
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitch", data_r14.type);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngSwitchCase", ctx_r13.claimsTableDataType.Badge);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r13.claimsTableDataType.Date);
} }
function ClaimsTableComponent_cpc_claims_table_row_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "cpc-claims-table-row")(1, "div", 10);
    i0.ɵɵtemplate(2, ClaimsTableComponent_cpc_claims_table_row_5_cpc_claims_table_col_2_Template, 5, 3, "cpc-claims-table-col", 5);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const sourceData_r11 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", sourceData_r11.cols);
} }
function ClaimsTableComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵelement(1, "cpc-spinner", 19);
    i0.ɵɵelementEnd();
} }
function ClaimsTableComponent_cpc_claims_table_pagination_7_Template(rf, ctx) { if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cpc-claims-table-pagination", 20);
    i0.ɵɵlistener("changeItemsPerPage", function ClaimsTableComponent_cpc_claims_table_pagination_7_Template_cpc_claims_table_pagination_changeItemsPerPage_0_listener($event) { i0.ɵɵrestoreView(_r26); const ctx_r25 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r25.handleChangeItemsPerPage($event)); })("changePage", function ClaimsTableComponent_cpc_claims_table_pagination_7_Template_cpc_claims_table_pagination_changePage_0_listener($event) { i0.ɵɵrestoreView(_r26); const ctx_r27 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r27.handleChangePage($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("page", ctx_r5.page)("maxPage", ctx_r5.maxPage)("itemsPerPage", ctx_r5.itemsPerPage)("copyItemPerPage", ctx_r5.copyItemPerPage)("copyPrev", ctx_r5.copyPrev)("copyOf", ctx_r5.copyOf)("copyNext", ctx_r5.copyNext)("options", ctx_r5.itemsPerPageOptions);
} }
var SortingDirection;
(function (SortingDirection) {
    SortingDirection["Ascending"] = "ASC";
    SortingDirection["Descending"] = "DSC";
})(SortingDirection || (SortingDirection = {}));
var ClaimsTableDataType;
(function (ClaimsTableDataType) {
    ClaimsTableDataType["Default"] = "DEFAULT";
    ClaimsTableDataType["Date"] = "DATE";
    ClaimsTableDataType["Badge"] = "BADGE";
    ClaimsTableDataType["Url"] = "URL";
})(ClaimsTableDataType || (ClaimsTableDataType = {}));
var ClaimsTablePaginationDirections;
(function (ClaimsTablePaginationDirections) {
    ClaimsTablePaginationDirections["Next"] = "Next";
    ClaimsTablePaginationDirections["Prev"] = "Prev";
})(ClaimsTablePaginationDirections || (ClaimsTablePaginationDirections = {}));
class ClaimsTableComponent {
    constructor() {
        this.sourceDataColumns = [];
        this.sourceData = [];
        this.itemsPerPageOptions = ['5', '10', '25', '50'];
        this.datePipeFormatShort = 'dd.MM.yyyy';
        this.datePipeFormatFull = 'dd.MM.yyyy, HH:mm';
        this.copyItemPerPage = 'Show per page:';
        this.copyPrev = 'PREVIOUS';
        this.copyOf = 'of';
        this.copyNext = 'NEXT';
        this.copyTotal = 'TOTAL';
        this.copyClaims = 'CLAIMS';
        this.copySortBy = 'Sort by';
        this.copySwiper = 'Swipe to view more';
        this.itemsAtStart = 50;
        this.loadAtOnce = 50;
        this.showSpinner = true;
        this.loadingDelay = 1000;
        this.mediaQuery = setMatchMedia(Breakpoints.medium, WidthExpression.maxWidth);
        this.isMobile = this.mediaQuery?.matches;
        this.filteredData = [];
        this.sortingDirection = SortingDirection;
        this.claimsTableDataType = ClaimsTableDataType;
        this.itemsPerPage = 10;
        this.page = 0;
        this.maxPage = 0;
        this.openDrawer = -1;
        this.throttle = 50;
        this.scrollDistance = 2;
        this.loading = false;
        this.badgeVariant = CpcBadgeVariants;
        this.currentBuffer = 0;
    }
    onResize(_) {
        this.isMobile = this.mediaQuery?.matches;
        if (this.isMobile) {
            this.currentBuffer = 0;
            this.filteredData = this.sourceData.slice(0, this.itemsAtStart);
        }
        else {
            this.updateFilteredData();
        }
    }
    ngOnInit() {
        this.updateMaxPage();
        if (this.isMobile) {
            this.filteredData = this.sourceData.slice(0, this.itemsAtStart);
        }
        else {
            this.updateFilteredData();
        }
    }
    ngOnChanges(changes) {
        // tslint:disable-next-line:max-line-length
        if (changes.sourceData && !changes.sourceData.firstChange && changes.sourceData.currentValue !== changes.sourceData.previousValue) {
            this.page = 0;
        }
        this.updateMaxPage();
        if (this.isMobile) {
            this.filteredData = this.sourceData.slice(0, this.itemsAtStart);
        }
        else {
            this.updateFilteredData();
        }
        this.handleChangePage(this.maxPage);
    }
    handleChangeItemsPerPage(value) {
        this.page = 0;
        this.itemsPerPage = value;
        this.openDrawer = -1;
        this.updateMaxPage();
        this.updateFilteredData();
    }
    handleChangePage(page) {
        const minPage = 0;
        this.openDrawer = -1;
        switch (page) {
            case ClaimsTablePaginationDirections.Next:
                this.page = clamp(this.page + 1, minPage, this.maxPage);
                break;
            case ClaimsTablePaginationDirections.Prev:
                this.page = clamp(this.page - 1, minPage, this.maxPage);
                break;
            default:
                this.page = clamp(this.page, minPage, this.maxPage);
        }
        this.updateFilteredData();
        this.updateMaxPage();
    }
    handleScrollDown() {
        if (this.sourceData.length <= this.filteredData.length || this.loading) {
            return;
        }
        if (this.showSpinner) {
            this.loading = true;
            setTimeout(() => {
                this.updateData();
                this.loading = false;
            }, this.loadingDelay);
        }
        else {
            this.updateData();
        }
    }
    changeOpenDrawer(value) {
        if (value === this.openDrawer) {
            this.openDrawer = -1;
            return;
        }
        this.openDrawer = value;
    }
    updateFilteredData() {
        if (this.isMobile) {
            this.filteredData = this.sourceData.slice(0, this.currentBuffer + this.loadAtOnce);
            this.currentBuffer = this.filteredData.length;
        }
        else {
            const startValue = this.page * this.itemsPerPage;
            this.filteredData = this.sourceData.slice(startValue, startValue + this.itemsPerPage);
        }
    }
    updateData() {
        this.filteredData.push(...this.sourceData.slice(this.currentBuffer, this.currentBuffer + this.loadAtOnce));
        this.currentBuffer = this.filteredData.length;
    }
    sort(idx, direction) {
        this.activeSortDirection = direction;
        this.activeSortIndex = idx;
        this.sourceData = this.sourceData.sort((a, b) => {
            const aVal = a.cols[idx].content;
            const bVal = b.cols[idx].content;
            switch (direction) {
                case SortingDirection.Ascending:
                    if (aVal < bVal) {
                        return -1;
                    }
                    if (aVal > bVal) {
                        return 1;
                    }
                    break;
                case SortingDirection.Descending:
                    if (aVal > bVal) {
                        return -1;
                    }
                    if (aVal < bVal) {
                        return 1;
                    }
                    break;
            }
            return 0;
        });
        this.page = 0;
        this.updateFilteredData();
    }
    updateMaxPage() {
        this.maxPage = Math.ceil(this.sourceData.length / this.itemsPerPage - 1);
    }
}
ClaimsTableComponent.ɵfac = function ClaimsTableComponent_Factory(t) { return new (t || ClaimsTableComponent)(); };
ClaimsTableComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ClaimsTableComponent, selectors: [["cpc-claims-table"]], viewQuery: function ClaimsTableComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$5, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.claimsTable = _t.first);
    } }, hostBindings: function ClaimsTableComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("resize", function ClaimsTableComponent_resize_HostBindingHandler($event) { return ctx.onResize($event); }, false, i0.ɵɵresolveWindow);
    } }, inputs: { sourceDataColumns: "sourceDataColumns", sourceData: "sourceData", itemsPerPageOptions: "itemsPerPageOptions", datePipeFormatShort: "datePipeFormatShort", datePipeFormatFull: "datePipeFormatFull", copyItemPerPage: "copyItemPerPage", copyPrev: "copyPrev", copyOf: "copyOf", copyNext: "copyNext", copyTotal: "copyTotal", copyClaims: "copyClaims", copySortBy: "copySortBy", copySwiper: "copySwiper", itemsAtStart: "itemsAtStart", loadAtOnce: "loadAtOnce", showSpinner: "showSpinner", loadingDelay: "loadingDelay" }, features: [i0.ɵɵNgOnChangesFeature], decls: 8, vars: 9, consts: [[3, "copySwiper", "claimsTable", 4, "ngIf"], ["infinite-scroll", "", 1, "cpc-claims-table", 3, "infiniteScrollDistance", "infiniteScrollThrottle", "scrollWindow", "scrolled"], ["claimsTable", ""], [3, "header"], [3, "sortEnabled", "sortIndex", "activeSortDirection", "activeSortIndex", "sortAscending", "sortDescending", 4, "ngFor", "ngForOf"], [4, "ngFor", "ngForOf"], ["class", "cpc-claims-table-spinner-wrapper", 4, "ngIf"], [3, "page", "maxPage", "itemsPerPage", "copyItemPerPage", "copyPrev", "copyOf", "copyNext", "options", "changeItemsPerPage", "changePage", 4, "ngIf"], [3, "copySwiper", "claimsTable"], [3, "sortEnabled", "sortIndex", "activeSortDirection", "activeSortIndex", "sortAscending", "sortDescending"], [1, "cpc-claims-table-data"], [3, "ngSwitch"], [4, "ngSwitchDefault"], [4, "ngSwitchCase"], [4, "ngIf"], ["class", "cpc-claims-table-col-text-interactive", 3, "href", 4, "ngIf"], [1, "cpc-claims-table-col-text-interactive", 3, "href"], [3, "variant"], [1, "cpc-claims-table-spinner-wrapper"], ["size", "large", 1, "cpc-claims-table-spinner"], [3, "page", "maxPage", "itemsPerPage", "copyItemPerPage", "copyPrev", "copyOf", "copyNext", "options", "changeItemsPerPage", "changePage"]], template: function ClaimsTableComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, ClaimsTableComponent_cpc_claims_table_swiper_0_Template, 1, 2, "cpc-claims-table-swiper", 0);
        i0.ɵɵelementStart(1, "div", 1, 2);
        i0.ɵɵlistener("scrolled", function ClaimsTableComponent_Template_div_scrolled_1_listener() { return ctx.isMobile && ctx.handleScrollDown(); });
        i0.ɵɵelementStart(3, "cpc-claims-table-row", 3);
        i0.ɵɵtemplate(4, ClaimsTableComponent_cpc_claims_table_col_4_Template, 2, 5, "cpc-claims-table-col", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, ClaimsTableComponent_cpc_claims_table_row_5_Template, 3, 1, "cpc-claims-table-row", 5);
        i0.ɵɵtemplate(6, ClaimsTableComponent_div_6_Template, 2, 0, "div", 6);
        i0.ɵɵtemplate(7, ClaimsTableComponent_cpc_claims_table_pagination_7_Template, 1, 8, "cpc-claims-table-pagination", 7);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.mediaQuery && ctx.isMobile);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("infiniteScrollDistance", ctx.scrollDistance)("infiniteScrollThrottle", ctx.throttle)("scrollWindow", true);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("header", true);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.sourceDataColumns);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.filteredData);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isMobile && ctx.loading);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isMobile);
    } }, styles: ["@media screen and (min-width: 0) and (max-width: 703.98px){.cpc-claims-table{overflow-x:scroll}}cpc-claims-table,.cpc-claims-table{display:flex;justify-content:center;align-items:center;flex-direction:column;flex-wrap:inherit;width:100%;font-size:16px;background-color:var(--cpc-colors-white)}cpc-claims-table cpc-claims-table-row,.cpc-claims-table cpc-claims-table-row{position:relative;word-break:break-word}cpc-claims-table cpc-claims-table-row:last-of-type,.cpc-claims-table cpc-claims-table-row:last-of-type{margin-bottom:32px}cpc-claims-table cpc-claims-table-row .cpc-button,.cpc-claims-table cpc-claims-table-row .cpc-button{opacity:0;pointer-events:none}cpc-claims-table .cpc-claims-table-data .cpc-button,.cpc-claims-table .cpc-claims-table-data .cpc-button{opacity:1;pointer-events:auto}@media screen and (min-width: 992px){cpc-claims-table .cpc-claims-table-data:first-child,.cpc-claims-table .cpc-claims-table-data:first-child{padding-left:54px}}cpc-claims-table .cpc-claims-table-drawer,.cpc-claims-table .cpc-claims-table-drawer{top:100%;left:0;display:flex;align-items:center;justify-content:space-between;flex-direction:row;flex-wrap:inherit;width:100%;height:75px;background:var(--cpc-colors-light-blue-2);border-top:#d9d9d9 1px solid}cpc-claims-table .cpc-claims-table-spinner-wrapper,.cpc-claims-table .cpc-claims-table-spinner-wrapper{align-self:flex-start;width:100%}cpc-claims-table .cpc-claims-table-spinner-wrapper .cpc-claims-table-spinner,.cpc-claims-table .cpc-claims-table-spinner-wrapper .cpc-claims-table-spinner{position:sticky;left:50%}cpc-claims-table .cpc-badge.cpc-badge--variant-danger,.cpc-claims-table .cpc-badge.cpc-badge--variant-danger{color:var(--cpc-colors-charcoal);background-color:var(--cpc-colors-seashell-pink)}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ClaimsTableComponent, [{
        type: Component,
        args: [{ selector: 'cpc-claims-table', encapsulation: ViewEncapsulation.None, template: "<cpc-claims-table-swiper\r\n  *ngIf=\"this.mediaQuery && isMobile\"\r\n  [copySwiper]=\"copySwiper\"\r\n  [claimsTable]=\"claimsTable\">\r\n</cpc-claims-table-swiper>\r\n<div\r\n  class=\"cpc-claims-table\"\r\n  #claimsTable\r\n  [infiniteScrollDistance]=\"scrollDistance\"\r\n  [infiniteScrollThrottle]=\"throttle\"\r\n  [scrollWindow]=\"true\"\r\n  (scrolled)=\"isMobile && handleScrollDown()\"\r\n  infinite-scroll\r\n>\r\n  <cpc-claims-table-row\r\n    [header]=\"true\">\r\n    <cpc-claims-table-col\r\n      *ngFor=\"let sourceDataColumn of sourceDataColumns; let index = index\"\r\n      [sortEnabled]=\"true\"\r\n      [sortIndex]=\"index\"\r\n      [activeSortDirection]=\"activeSortDirection\"\r\n      [activeSortIndex]=\"activeSortIndex\"\r\n      (sortAscending)=\"sort(index, sortingDirection.Ascending)\"\r\n      (sortDescending)=\"sort(index, sortingDirection.Descending)\"\r\n    >\r\n      {{sourceDataColumn}}\r\n    </cpc-claims-table-col>\r\n  </cpc-claims-table-row>\r\n  <cpc-claims-table-row *ngFor=\"let sourceData of filteredData; let index = index\">\r\n    <div class=\"cpc-claims-table-data\">\r\n      <cpc-claims-table-col\r\n        *ngFor=\"let data of sourceData.cols\"\r\n      >\r\n        <ng-container [ngSwitch]=\"data.type\">\r\n          <ng-container *ngSwitchDefault>\r\n            <ng-container *ngIf=\"!data.url\">{{data.content}}</ng-container>\r\n            <a class=\"cpc-claims-table-col-text-interactive\" *ngIf=\"data.url\" [href]=\"data.url\">{{data.content}}</a>\r\n          </ng-container>\r\n          <ng-container *ngSwitchCase=\"claimsTableDataType.Badge\">\r\n            <cpc-badge [variant]=\"data.badgeType ? data.badgeType : badgeVariant.Default\">\r\n              {{data.content}}\r\n            </cpc-badge>\r\n          </ng-container>\r\n          <ng-container *ngSwitchCase=\"claimsTableDataType.Date\">\r\n            {{data.content | dateFormat: datePipeFormatFull:datePipeFormatShort}}\r\n          </ng-container>\r\n        </ng-container>\r\n      </cpc-claims-table-col>\r\n    </div>\r\n  </cpc-claims-table-row>\r\n\r\n  <div *ngIf=\"isMobile && loading\"\r\n       class=\"cpc-claims-table-spinner-wrapper\">\r\n    <cpc-spinner class=\"cpc-claims-table-spinner\" size=\"large\"></cpc-spinner>\r\n  </div>\r\n\r\n  <cpc-claims-table-pagination\r\n    *ngIf=\"!isMobile\"\r\n    [page]=\"page\"\r\n    [maxPage]=\"maxPage\"\r\n    [itemsPerPage]=\"itemsPerPage\"\r\n    (changeItemsPerPage)=\"handleChangeItemsPerPage($event)\"\r\n    (changePage)=\"handleChangePage($event)\"\r\n    [copyItemPerPage]=\"copyItemPerPage\"\r\n    [copyPrev]=\"copyPrev\"\r\n    [copyOf]=\"copyOf\"\r\n    [copyNext]=\"copyNext\"\r\n    [options]=\"itemsPerPageOptions\"\r\n  ></cpc-claims-table-pagination>\r\n</div>\r\n\r\n", styles: ["@media screen and (min-width: 0) and (max-width: 703.98px){.cpc-claims-table{overflow-x:scroll}}cpc-claims-table,.cpc-claims-table{display:flex;justify-content:center;align-items:center;flex-direction:column;flex-wrap:inherit;width:100%;font-size:16px;background-color:var(--cpc-colors-white)}cpc-claims-table cpc-claims-table-row,.cpc-claims-table cpc-claims-table-row{position:relative;word-break:break-word}cpc-claims-table cpc-claims-table-row:last-of-type,.cpc-claims-table cpc-claims-table-row:last-of-type{margin-bottom:32px}cpc-claims-table cpc-claims-table-row .cpc-button,.cpc-claims-table cpc-claims-table-row .cpc-button{opacity:0;pointer-events:none}cpc-claims-table .cpc-claims-table-data .cpc-button,.cpc-claims-table .cpc-claims-table-data .cpc-button{opacity:1;pointer-events:auto}@media screen and (min-width: 992px){cpc-claims-table .cpc-claims-table-data:first-child,.cpc-claims-table .cpc-claims-table-data:first-child{padding-left:54px}}cpc-claims-table .cpc-claims-table-drawer,.cpc-claims-table .cpc-claims-table-drawer{top:100%;left:0;display:flex;align-items:center;justify-content:space-between;flex-direction:row;flex-wrap:inherit;width:100%;height:75px;background:var(--cpc-colors-light-blue-2);border-top:#d9d9d9 1px solid}cpc-claims-table .cpc-claims-table-spinner-wrapper,.cpc-claims-table .cpc-claims-table-spinner-wrapper{align-self:flex-start;width:100%}cpc-claims-table .cpc-claims-table-spinner-wrapper .cpc-claims-table-spinner,.cpc-claims-table .cpc-claims-table-spinner-wrapper .cpc-claims-table-spinner{position:sticky;left:50%}cpc-claims-table .cpc-badge.cpc-badge--variant-danger,.cpc-claims-table .cpc-badge.cpc-badge--variant-danger{color:var(--cpc-colors-charcoal);background-color:var(--cpc-colors-seashell-pink)}\n"] }]
    }], null, { sourceDataColumns: [{
            type: Input
        }], sourceData: [{
            type: Input
        }], itemsPerPageOptions: [{
            type: Input
        }], datePipeFormatShort: [{
            type: Input
        }], datePipeFormatFull: [{
            type: Input
        }], copyItemPerPage: [{
            type: Input
        }], copyPrev: [{
            type: Input
        }], copyOf: [{
            type: Input
        }], copyNext: [{
            type: Input
        }], copyTotal: [{
            type: Input
        }], copyClaims: [{
            type: Input
        }], copySortBy: [{
            type: Input
        }], copySwiper: [{
            type: Input
        }], itemsAtStart: [{
            type: Input
        }], loadAtOnce: [{
            type: Input
        }], showSpinner: [{
            type: Input
        }], loadingDelay: [{
            type: Input
        }], claimsTable: [{
            type: ViewChild,
            args: ['claimsTable']
        }], onResize: [{
            type: HostListener,
            args: ['window:resize', ['$event']]
        }] }); })();

const _c0$4 = ["sortAscending"];
const _c1$3 = ["sortDescending"];
const _c2 = function (a0, a1) { return { "is-active": a0, "is-another-active": a1 }; };
class ClaimsTableSortComponent {
    constructor() {
        this.sortAscending = new EventEmitter();
        this.sortDescending = new EventEmitter();
        this.ndbxIcons = NdbxIcon;
        this.sortingDirection = SortingDirection;
    }
    handleClickSortAscending() {
        this.sortAscending.emit();
        this.blurElements();
    }
    handleClickSortDescending() {
        this.sortDescending.emit();
        this.blurElements();
    }
    blurElements() {
        if (this.refSortAscending && this.refSortAscending.nativeElement) {
            this.refSortAscending.nativeElement.blur();
        }
        if (this.refSortDescending && this.refSortDescending.nativeElement) {
            this.refSortDescending.nativeElement.blur();
        }
    }
}
ClaimsTableSortComponent.ɵfac = function ClaimsTableSortComponent_Factory(t) { return new (t || ClaimsTableSortComponent)(); };
ClaimsTableSortComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ClaimsTableSortComponent, selectors: [["cpc-claims-table-sort"]], viewQuery: function ClaimsTableSortComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$4, 5);
        i0.ɵɵviewQuery(_c1$3, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.refSortAscending = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.refSortDescending = _t.first);
    } }, inputs: { sortIndex: "sortIndex", activeSortIndex: "activeSortIndex", activeSortDirection: "activeSortDirection" }, outputs: { sortAscending: "sortAscending", sortDescending: "sortDescending" }, decls: 7, vars: 10, consts: [[1, "cpc-claims-table-sort"], [1, "cpc-claims-table-sort-button", "cpc-claims-table-sort-ascending", 3, "ngClass"], ["sortAscending", ""], [3, "icon"], [1, "cpc-claims-table-sort-button", "cpc-claims-table-sort-descending", 3, "ngClass"], ["sortDescending", ""]], template: function ClaimsTableSortComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "button", 1, 2);
        i0.ɵɵelement(3, "cpc-icon", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "button", 4, 5);
        i0.ɵɵelement(6, "cpc-icon", 3);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(4, _c2, ctx.activeSortIndex === ctx.sortIndex && ctx.activeSortDirection === ctx.sortingDirection.Ascending, ctx.activeSortIndex === ctx.sortIndex && ctx.activeSortDirection === ctx.sortingDirection.Descending));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("icon", ctx.ndbxIcons.ChevronUp);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(7, _c2, ctx.activeSortIndex === ctx.sortIndex && ctx.activeSortDirection === ctx.sortingDirection.Descending, ctx.activeSortIndex === ctx.sortIndex && ctx.activeSortDirection === ctx.sortingDirection.Ascending));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("icon", ctx.ndbxIcons.ChevronDown);
    } }, dependencies: [i1.NgClass, IconComponent], styles: ["cpc-claims-table-sort{position:absolute;left:0;z-index:10}cpc-claims-table-sort,.cpc-claims-table-sort{display:flex;align-items:center;justify-content:flex-start;flex-direction:row;flex-wrap:inherit;width:100%}.cpc-claims-table-sort{display:flex;justify-content:center;align-items:center;flex-direction:column;flex-wrap:inherit;width:24px;height:24px}.cpc-claims-table-sort .cpc-claims-table-sort-button{background:transparent;border:none;cursor:pointer;-webkit-appearance:none;appearance:none;width:24px;height:12px;margin:0;padding:0;font-size:14px;border-radius:4px}.cpc-claims-table-sort .cpc-claims-table-sort-button.is-active{color:var(--cpc-claims-table-active-color)}.cpc-claims-table-sort .cpc-claims-table-sort-button.is-another-active{display:none}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ClaimsTableSortComponent, [{
        type: Component,
        args: [{ selector: 'cpc-claims-table-sort', encapsulation: ViewEncapsulation.None, template: "<div class=\"cpc-claims-table-sort\">\r\n  <button\r\n    class=\"cpc-claims-table-sort-button cpc-claims-table-sort-ascending\"\r\n    [ngClass]=\"{\r\n      'is-active': activeSortIndex === sortIndex && activeSortDirection === sortingDirection.Ascending,\r\n      'is-another-active': activeSortIndex=== sortIndex && activeSortDirection === sortingDirection.Descending\r\n    }\"\r\n    #sortAscending\r\n  >\r\n    <cpc-icon [icon]=\"ndbxIcons.ChevronUp\"></cpc-icon>\r\n  </button>\r\n  <button\r\n    class=\"cpc-claims-table-sort-button cpc-claims-table-sort-descending\"\r\n    [ngClass]=\"{\r\n      'is-active': activeSortIndex === sortIndex && activeSortDirection === sortingDirection.Descending,\r\n      'is-another-active': activeSortIndex === sortIndex && activeSortDirection === sortingDirection.Ascending\r\n    }\"\r\n    #sortDescending\r\n  >\r\n    <cpc-icon [icon]=\"ndbxIcons.ChevronDown\"></cpc-icon>\r\n  </button>\r\n</div>\r\n", styles: ["cpc-claims-table-sort{position:absolute;left:0;z-index:10}cpc-claims-table-sort,.cpc-claims-table-sort{display:flex;align-items:center;justify-content:flex-start;flex-direction:row;flex-wrap:inherit;width:100%}.cpc-claims-table-sort{display:flex;justify-content:center;align-items:center;flex-direction:column;flex-wrap:inherit;width:24px;height:24px}.cpc-claims-table-sort .cpc-claims-table-sort-button{background:transparent;border:none;cursor:pointer;-webkit-appearance:none;appearance:none;width:24px;height:12px;margin:0;padding:0;font-size:14px;border-radius:4px}.cpc-claims-table-sort .cpc-claims-table-sort-button.is-active{color:var(--cpc-claims-table-active-color)}.cpc-claims-table-sort .cpc-claims-table-sort-button.is-another-active{display:none}\n"] }]
    }], null, { sortIndex: [{
            type: Input
        }], activeSortIndex: [{
            type: Input
        }], activeSortDirection: [{
            type: Input
        }], sortAscending: [{
            type: Output
        }], sortDescending: [{
            type: Output
        }], refSortAscending: [{
            type: ViewChild,
            args: ['sortAscending', { static: false }]
        }], refSortDescending: [{
            type: ViewChild,
            args: ['sortDescending', { static: false }]
        }] }); })();

function ClaimsTableColComponent_div_0_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
const _c0$3 = function (a0) { return { "is-active": a0 }; };
function ClaimsTableColComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵlistener("click", function ClaimsTableColComponent_div_0_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.handleSort()); });
    i0.ɵɵelementStart(1, "cpc-claims-table-sort", 4);
    i0.ɵɵlistener("sortAscending", function ClaimsTableColComponent_div_0_Template_cpc_claims_table_sort_sortAscending_1_listener() { i0.ɵɵrestoreView(_r7); const ctx_r8 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r8.sortAscending.emit()); })("sortDescending", function ClaimsTableColComponent_div_0_Template_cpc_claims_table_sort_sortDescending_1_listener() { i0.ɵɵrestoreView(_r7); const ctx_r9 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r9.sortDescending.emit()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "div", 5);
    i0.ɵɵtemplate(3, ClaimsTableColComponent_div_0_ng_container_3_Template, 1, 0, "ng-container", 6);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const _r3 = i0.ɵɵreference(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("activeSortDirection", ctx_r0.activeSortDirection)("activeSortIndex", ctx_r0.activeSortIndex)("sortIndex", ctx_r0.sortIndex);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c0$3, ctx_r0.sortEnabled && ctx_r0.activeSortIndex === ctx_r0.sortIndex));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
function ClaimsTableColComponent_ng_template_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ClaimsTableColComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtemplate(1, ClaimsTableColComponent_ng_template_1_ng_container_1_Template, 1, 0, "ng-container", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r3 = i0.ɵɵreference(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
function ClaimsTableColComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵprojection(0);
} }
const _c1$2 = ["*"];
class ClaimsTableColComponent {
    constructor() {
        this.sortEnabled = false;
        this.sortAscending = new EventEmitter();
        this.sortDescending = new EventEmitter();
    }
    handleSort() {
        if (this.sortIndex === this.activeSortIndex && this.activeSortDirection === SortingDirection.Ascending) {
            this.sortDescending.emit();
        }
        else {
            this.sortAscending.emit();
        }
    }
}
ClaimsTableColComponent.ɵfac = function ClaimsTableColComponent_Factory(t) { return new (t || ClaimsTableColComponent)(); };
ClaimsTableColComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ClaimsTableColComponent, selectors: [["cpc-claims-table-col"]], inputs: { sortEnabled: "sortEnabled", sortIndex: "sortIndex", activeSortIndex: "activeSortIndex", activeSortDirection: "activeSortDirection" }, outputs: { sortAscending: "sortAscending", sortDescending: "sortDescending" }, ngContentSelectors: _c1$2, decls: 5, vars: 2, consts: [["class", "cpc-claims-table-col-wrapper", 3, "click", 4, "ngIf", "ngIfElse"], ["claimsTableCol", ""], ["content", ""], [1, "cpc-claims-table-col-wrapper", 3, "click"], [3, "activeSortDirection", "activeSortIndex", "sortIndex", "sortAscending", "sortDescending"], [1, "cpc-claims-table-col", 3, "ngClass"], [4, "ngTemplateOutlet"], [1, "cpc-claims-table-col"]], template: function ClaimsTableColComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵtemplate(0, ClaimsTableColComponent_div_0_Template, 4, 7, "div", 0);
        i0.ɵɵtemplate(1, ClaimsTableColComponent_ng_template_1_Template, 2, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(3, ClaimsTableColComponent_ng_template_3_Template, 1, 0, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(2);
        i0.ɵɵproperty("ngIf", ctx.sortEnabled)("ngIfElse", _r1);
    } }, dependencies: [i1.NgClass, i1.NgIf, i1.NgTemplateOutlet, ClaimsTableSortComponent], styles: ["cpc-claims-table-col,.cpc-claims-table-col{position:relative;display:flex;align-items:center;justify-content:flex-start;flex-direction:row;flex-wrap:inherit;width:100%}cpc-claims-table-col-wrapper,.cpc-claims-table-col-wrapper{display:flex;align-items:center;min-width:165px;min-height:75px;cursor:pointer}cpc-claims-table-col-text-interactive,.cpc-claims-table-col-text-interactive{color:var(--cpc-colors-resolution-blue);font-weight:600;line-height:24px;letter-spacing:1px;text-decoration:none}cpc-claims-table-col.is-active,.cpc-claims-table-col.is-active{color:var(--cpc-claims-table-active-color);font-weight:700}cpc-claims-table-col cpc-badge,cpc-claims-table-col .cpc-badge,.cpc-claims-table-col cpc-badge,.cpc-claims-table-col .cpc-badge{width:100%}@media screen and (max-width: 703.98px){cpc-claims-table-col,.cpc-claims-table-col{justify-content:unset;min-width:-moz-fit-content;min-width:fit-content}}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ClaimsTableColComponent, [{
        type: Component,
        args: [{ selector: 'cpc-claims-table-col', encapsulation: ViewEncapsulation.None, template: "<div *ngIf=\"sortEnabled;else claimsTableCol\" class=\"cpc-claims-table-col-wrapper\" (click)=\"handleSort()\">\r\n  <cpc-claims-table-sort\r\n    [activeSortDirection]=\"activeSortDirection\"\r\n    [activeSortIndex]=\"activeSortIndex\"\r\n    [sortIndex]=\"sortIndex\"\r\n    (sortAscending)=\"sortAscending.emit()\"\r\n    (sortDescending)=\"sortDescending.emit()\"\r\n  ></cpc-claims-table-sort>\r\n\r\n  <div class=\"cpc-claims-table-col\" [ngClass]=\"{'is-active': sortEnabled && activeSortIndex === sortIndex}\">\r\n    <ng-container *ngTemplateOutlet=\"content\"></ng-container>\r\n  </div>\r\n</div>\r\n\r\n<ng-template #claimsTableCol>\r\n  <div class=\"cpc-claims-table-col\">\r\n    <ng-container *ngTemplateOutlet=\"content\"></ng-container>\r\n  </div>\r\n</ng-template>\r\n\r\n<ng-template #content>\r\n  <ng-content></ng-content>\r\n</ng-template>\r\n", styles: ["cpc-claims-table-col,.cpc-claims-table-col{position:relative;display:flex;align-items:center;justify-content:flex-start;flex-direction:row;flex-wrap:inherit;width:100%}cpc-claims-table-col-wrapper,.cpc-claims-table-col-wrapper{display:flex;align-items:center;min-width:165px;min-height:75px;cursor:pointer}cpc-claims-table-col-text-interactive,.cpc-claims-table-col-text-interactive{color:var(--cpc-colors-resolution-blue);font-weight:600;line-height:24px;letter-spacing:1px;text-decoration:none}cpc-claims-table-col.is-active,.cpc-claims-table-col.is-active{color:var(--cpc-claims-table-active-color);font-weight:700}cpc-claims-table-col cpc-badge,cpc-claims-table-col .cpc-badge,.cpc-claims-table-col cpc-badge,.cpc-claims-table-col .cpc-badge{width:100%}@media screen and (max-width: 703.98px){cpc-claims-table-col,.cpc-claims-table-col{justify-content:unset;min-width:-moz-fit-content;min-width:fit-content}}\n"] }]
    }], null, { sortEnabled: [{
            type: Input
        }], sortIndex: [{
            type: Input
        }], activeSortIndex: [{
            type: Input
        }], activeSortDirection: [{
            type: Input
        }], sortAscending: [{
            type: Output
        }], sortDescending: [{
            type: Output
        }] }); })();

class ClaimsTablePaginationComponent {
    constructor() {
        this.page = 0;
        this.maxPage = 0;
        this.itemsPerPage = 10;
        this.copyItemPerPage = 'Show per page:';
        this.copyPrev = 'PREVIOUS';
        this.copyOf = 'of';
        this.copyNext = 'NEXT';
        this.options = ['5', '10', '25', '50', '100'];
        this.sortAscending = new EventEmitter();
        this.sortDescending = new EventEmitter();
        this.changeItemsPerPage = new EventEmitter();
        this.changePage = new EventEmitter();
        this.ndbxIcons = NdbxIcon;
        this.claimsTablePaginationDirections = ClaimsTablePaginationDirections;
    }
    handleChangeItemsPerPage(value) {
        const valueAsNumber = Number(value);
        this.itemsPerPage = valueAsNumber;
        this.changeItemsPerPage.emit(valueAsNumber);
    }
    getItemsPerPageValue() {
        return String(this.itemsPerPage);
    }
}
ClaimsTablePaginationComponent.ɵfac = function ClaimsTablePaginationComponent_Factory(t) { return new (t || ClaimsTablePaginationComponent)(); };
ClaimsTablePaginationComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ClaimsTablePaginationComponent, selectors: [["cpc-claims-table-pagination"]], inputs: { page: "page", maxPage: "maxPage", itemsPerPage: "itemsPerPage", copyItemPerPage: "copyItemPerPage", copyPrev: "copyPrev", copyOf: "copyOf", copyNext: "copyNext", options: "options" }, outputs: { sortAscending: "sortAscending", sortDescending: "sortDescending", changeItemsPerPage: "changeItemsPerPage", changePage: "changePage" }, decls: 16, vars: 15, consts: [[1, "cpc-claims-table-pagination"], [1, "cpc-claims-table-pagination-item-per-page"], ["width", "100px", "direction", "up", 3, "value", "options", "changeValue"], [1, "cpc-claims-table-pagination-nav"], ["mode", "tertiary", 1, "cpc-claims-table-pagination-nav-prev", 3, "disabled", "click"], [3, "icon"], [1, "cpc-claims-table-pagination-nav-info"], ["mode", "tertiary", 1, "cpc-claims-table-pagination-nav-next", 3, "disabled", "click"], [1, "cpc-claims-table-pagination-item-per-page-hidden"], ["direction", "up", "width", "100px", 3, "value", "options", "changeValue"]], template: function ClaimsTablePaginationComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵtext(2);
        i0.ɵɵelementStart(3, "cpc-select", 2);
        i0.ɵɵlistener("changeValue", function ClaimsTablePaginationComponent_Template_cpc_select_changeValue_3_listener($event) { return ctx.handleChangeItemsPerPage($event); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(4, "div", 3)(5, "cpc-button", 4);
        i0.ɵɵlistener("click", function ClaimsTablePaginationComponent_Template_cpc_button_click_5_listener() { return ctx.changePage.emit(ctx.claimsTablePaginationDirections.Prev); });
        i0.ɵɵelement(6, "cpc-icon", 5);
        i0.ɵɵtext(7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "span", 6);
        i0.ɵɵtext(9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "cpc-button", 7);
        i0.ɵɵlistener("click", function ClaimsTablePaginationComponent_Template_cpc_button_click_10_listener() { return ctx.changePage.emit(ctx.claimsTablePaginationDirections.Next); });
        i0.ɵɵtext(11);
        i0.ɵɵelement(12, "cpc-icon", 5);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(13, "div", 8);
        i0.ɵɵtext(14);
        i0.ɵɵelementStart(15, "cpc-select", 9);
        i0.ɵɵlistener("changeValue", function ClaimsTablePaginationComponent_Template_cpc_select_changeValue_15_listener($event) { return ctx.handleChangeItemsPerPage($event); });
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.copyItemPerPage, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("value", ctx.getItemsPerPageValue())("options", ctx.options);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("disabled", ctx.page === 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("icon", ctx.ndbxIcons.ArrowLeft);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.copyPrev, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate3(" ", ctx.page + 1, " ", ctx.copyOf, " ", ctx.maxPage + 1, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("disabled", ctx.page == ctx.maxPage);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.copyNext, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("icon", ctx.ndbxIcons.ArrowRight);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.copyItemPerPage, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("value", ctx.getItemsPerPageValue())("options", ctx.options);
    } }, dependencies: [ButtonComponent, IconComponent, SelectComponent], styles: ["cpc-claims-table-pagination,.cpc-claims-table-pagination{display:flex;align-items:center;justify-content:space-between;flex-direction:row;flex-wrap:inherit;width:100%}cpc-claims-table-pagination .cpc-claims-table-pagination-item-per-page,.cpc-claims-table-pagination .cpc-claims-table-pagination-item-per-page{display:flex;align-items:center;justify-content:center;flex-direction:row;flex-wrap:inherit}cpc-claims-table-pagination .cpc-claims-table-pagination-item-per-page cpc-select,.cpc-claims-table-pagination .cpc-claims-table-pagination-item-per-page cpc-select{margin-left:8px}cpc-claims-table-pagination .cpc-claims-table-pagination-item-per-page-hidden,.cpc-claims-table-pagination .cpc-claims-table-pagination-item-per-page-hidden{opacity:0;pointer-events:none}cpc-claims-table-pagination .cpc-claims-table-pagination-nav,.cpc-claims-table-pagination .cpc-claims-table-pagination-nav{display:flex;align-items:center;justify-content:center;flex-direction:row;flex-wrap:inherit}cpc-claims-table-pagination .cpc-claims-table-pagination-nav button,.cpc-claims-table-pagination .cpc-claims-table-pagination-nav button{margin-bottom:0}.cpc-claims-table-pagination{margin-left:64px}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ClaimsTablePaginationComponent, [{
        type: Component,
        args: [{ selector: 'cpc-claims-table-pagination', encapsulation: ViewEncapsulation.None, template: "<div class=\"cpc-claims-table-pagination\">\r\n  <div class=\"cpc-claims-table-pagination-item-per-page\">\r\n    {{copyItemPerPage}}\r\n    <cpc-select\r\n      width=\"100px\"\r\n      direction=\"up\"\r\n      [value]=\"getItemsPerPageValue()\"\r\n      [options]=\"options\"\r\n      (changeValue)=\"handleChangeItemsPerPage($event)\"\r\n    ></cpc-select>\r\n  </div>\r\n  <div class=\"cpc-claims-table-pagination-nav\">\r\n    <cpc-button\r\n      class=\"cpc-claims-table-pagination-nav-prev\"\r\n      mode=\"tertiary\"\r\n      [disabled]=\"page === 0\"\r\n      (click)=\"changePage.emit(claimsTablePaginationDirections.Prev)\"\r\n    >\r\n      <cpc-icon [icon]=\"ndbxIcons.ArrowLeft\"></cpc-icon>\r\n      {{copyPrev}}\r\n    </cpc-button>\r\n    <span class=\"cpc-claims-table-pagination-nav-info\">\r\n      {{ page + 1 }} {{copyOf}} {{ maxPage + 1 }}\r\n    </span>\r\n    <cpc-button\r\n      class=\"cpc-claims-table-pagination-nav-next\"\r\n      mode=\"tertiary\"\r\n      [disabled]=\"page == maxPage\"\r\n      (click)=\"changePage.emit(claimsTablePaginationDirections.Next)\"\r\n    >\r\n      {{copyNext}}\r\n      <cpc-icon [icon]=\"ndbxIcons.ArrowRight\"></cpc-icon>\r\n    </cpc-button>\r\n  </div>\r\n  <div class=\"cpc-claims-table-pagination-item-per-page-hidden\">\r\n    {{copyItemPerPage}}\r\n    <cpc-select\r\n      direction=\"up\"\r\n      width=\"100px\"\r\n      [value]=\"getItemsPerPageValue()\"\r\n      [options]=\"options\"\r\n      (changeValue)=\"handleChangeItemsPerPage($event)\"\r\n    ></cpc-select>\r\n  </div>\r\n</div>\r\n", styles: ["cpc-claims-table-pagination,.cpc-claims-table-pagination{display:flex;align-items:center;justify-content:space-between;flex-direction:row;flex-wrap:inherit;width:100%}cpc-claims-table-pagination .cpc-claims-table-pagination-item-per-page,.cpc-claims-table-pagination .cpc-claims-table-pagination-item-per-page{display:flex;align-items:center;justify-content:center;flex-direction:row;flex-wrap:inherit}cpc-claims-table-pagination .cpc-claims-table-pagination-item-per-page cpc-select,.cpc-claims-table-pagination .cpc-claims-table-pagination-item-per-page cpc-select{margin-left:8px}cpc-claims-table-pagination .cpc-claims-table-pagination-item-per-page-hidden,.cpc-claims-table-pagination .cpc-claims-table-pagination-item-per-page-hidden{opacity:0;pointer-events:none}cpc-claims-table-pagination .cpc-claims-table-pagination-nav,.cpc-claims-table-pagination .cpc-claims-table-pagination-nav{display:flex;align-items:center;justify-content:center;flex-direction:row;flex-wrap:inherit}cpc-claims-table-pagination .cpc-claims-table-pagination-nav button,.cpc-claims-table-pagination .cpc-claims-table-pagination-nav button{margin-bottom:0}.cpc-claims-table-pagination{margin-left:64px}\n"] }]
    }], null, { page: [{
            type: Input
        }], maxPage: [{
            type: Input
        }], itemsPerPage: [{
            type: Input
        }], copyItemPerPage: [{
            type: Input
        }], copyPrev: [{
            type: Input
        }], copyOf: [{
            type: Input
        }], copyNext: [{
            type: Input
        }], options: [{
            type: Input
        }], sortAscending: [{
            type: Output
        }], sortDescending: [{
            type: Output
        }], changeItemsPerPage: [{
            type: Output
        }], changePage: [{
            type: Output
        }] }); })();

const _c0$2 = function (a0) { return { "cpc--header": a0 }; };
const _c1$1 = ["*"];
class ClaimsTableRowComponent {
    constructor() {
        this.header = false;
    }
}
ClaimsTableRowComponent.ɵfac = function ClaimsTableRowComponent_Factory(t) { return new (t || ClaimsTableRowComponent)(); };
ClaimsTableRowComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ClaimsTableRowComponent, selectors: [["cpc-claims-table-row"]], inputs: { header: "header" }, ngContentSelectors: _c1$1, decls: 2, vars: 3, consts: [[1, "cpc-claims-table-row", 3, "ngClass"]], template: function ClaimsTableRowComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵprojection(1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c0$2, ctx.header));
    } }, dependencies: [i1.NgClass], styles: ["cpc-claims-table-row,.cpc-claims-table-row{width:100%}.cpc-claims-table-row{min-width:max-content;border-bottom:#d9d9d9 1px solid}.cpc-claims-table-row .cpc-claims-table-col{min-width:165px;padding:24px 16px}@media screen and (max-width: 319.98px){.cpc-claims-table-row .cpc-claims-table-col{padding:24px 0}}@media screen and (min-width: 704px){.cpc-claims-table-row .cpc-claims-table-col{padding:24px 10px}}.cpc-claims-table-row.cpc--header{display:grid;grid-template-columns:1fr 1fr 1fr 1fr;font-weight:600;border-bottom-color:#5b5b5b;border-bottom-width:2px}.cpc-claims-table-row.cpc--header .cpc-claims-table-col{padding:24px 32px}@media screen and (min-width: 992px){.cpc-claims-table-row.cpc--header:first-child{padding-left:54px}}.cpc-claims-table-row .cpc-claims-table-data{display:flex;align-items:center;justify-content:center;flex-direction:row;flex-wrap:inherit;width:100%}@media screen and (max-width: 703.98px){.cpc-claims-table-row .cpc-claims-table-data{justify-content:unset}}@media screen and (max-width: 703.98px){.cpc-claims-table-row{justify-content:unset;min-width:-moz-fit-content;min-width:fit-content}}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ClaimsTableRowComponent, [{
        type: Component,
        args: [{ selector: 'cpc-claims-table-row', encapsulation: ViewEncapsulation.None, template: "<div class=\"cpc-claims-table-row\" [ngClass]='{ \"cpc--header\": header }'>\r\n  <ng-content></ng-content>\r\n</div>\r\n", styles: ["cpc-claims-table-row,.cpc-claims-table-row{width:100%}.cpc-claims-table-row{min-width:max-content;border-bottom:#d9d9d9 1px solid}.cpc-claims-table-row .cpc-claims-table-col{min-width:165px;padding:24px 16px}@media screen and (max-width: 319.98px){.cpc-claims-table-row .cpc-claims-table-col{padding:24px 0}}@media screen and (min-width: 704px){.cpc-claims-table-row .cpc-claims-table-col{padding:24px 10px}}.cpc-claims-table-row.cpc--header{display:grid;grid-template-columns:1fr 1fr 1fr 1fr;font-weight:600;border-bottom-color:#5b5b5b;border-bottom-width:2px}.cpc-claims-table-row.cpc--header .cpc-claims-table-col{padding:24px 32px}@media screen and (min-width: 992px){.cpc-claims-table-row.cpc--header:first-child{padding-left:54px}}.cpc-claims-table-row .cpc-claims-table-data{display:flex;align-items:center;justify-content:center;flex-direction:row;flex-wrap:inherit;width:100%}@media screen and (max-width: 703.98px){.cpc-claims-table-row .cpc-claims-table-data{justify-content:unset}}@media screen and (max-width: 703.98px){.cpc-claims-table-row{justify-content:unset;min-width:-moz-fit-content;min-width:fit-content}}\n"] }]
    }], null, { header: [{
            type: Input
        }] }); })();

const _c0$1 = ["scrollEl"];
const _c1 = function (a0) { return { width: a0 }; };
class ClaimsTableSwiperComponent {
    constructor() {
        this.copySwiper = 'Swipe to view more';
    }
    onResize(_) {
        setTimeout(() => {
            this.scrollWidth = this.claimsTable.scrollWidth;
        }, 0);
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.scrollWidth = this.claimsTable.scrollWidth;
        }, 0);
        this.claimsTable.onscroll = () => {
            this.scrollEl.nativeElement.scroll(this.claimsTable.scrollLeft, window.scrollY);
        };
        this.scrollEl.nativeElement.onscroll = (event) => {
            this.claimsTable.scroll(event.target.scrollLeft, window.scrollY);
        };
    }
}
ClaimsTableSwiperComponent.ɵfac = function ClaimsTableSwiperComponent_Factory(t) { return new (t || ClaimsTableSwiperComponent)(); };
ClaimsTableSwiperComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ClaimsTableSwiperComponent, selectors: [["cpc-claims-table-swiper"]], viewQuery: function ClaimsTableSwiperComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$1, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.scrollEl = _t.first);
    } }, hostBindings: function ClaimsTableSwiperComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("resize", function ClaimsTableSwiperComponent_resize_HostBindingHandler($event) { return ctx.onResize($event); }, false, i0.ɵɵresolveWindow);
    } }, inputs: { claimsTable: "claimsTable", copySwiper: "copySwiper" }, decls: 6, vars: 4, consts: [[1, "cpc-claims-table-swiper"], [1, "cpc-claims-table-swiper_text"], [2, "width", "90vw", "overflow-x", "auto", "overflow-y", "hidden"], ["scrollEl", ""], [2, "height", "1px", 3, "ngStyle"]], template: function ClaimsTableSwiperComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "span", 1);
        i0.ɵɵtext(2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 2, 3);
        i0.ɵɵelement(5, "div", 4);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.copySwiper);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(2, _c1, ctx.scrollWidth + "px"));
    } }, dependencies: [i1.NgStyle], styles: ["cpc-claims-table-swiper{position:sticky;top:0;left:16px;z-index:20;display:flex;align-self:baseline;margin-top:16px;color:var(--cpc-colors-charcoal);font-size:14px;line-height:20px;letter-spacing:.2px;background:var(--cpc-colors-white);box-shadow:-4px 0 0 12px var(--cpc-colors-white);-webkit-user-select:none;user-select:none}cpc-claims-table-swiper ::-webkit-scrollbar{height:8px}cpc-claims-table-swiper ::-webkit-scrollbar-track{background:var(--cpc-colors-light-gray)}cpc-claims-table-swiper ::-webkit-scrollbar-thumb{background:var(--cpc-colors-cerulean)}.cpc-claims-table-swiper{z-index:20;width:100%;background:var(--cpc-colors-white)}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ClaimsTableSwiperComponent, [{
        type: Component,
        args: [{ selector: 'cpc-claims-table-swiper', encapsulation: ViewEncapsulation.None, template: "<div\r\n  class=\"cpc-claims-table-swiper\">\r\n  <span class=\"cpc-claims-table-swiper_text\">{{copySwiper}}</span>\r\n  <div\r\n    #scrollEl\r\n    style=\"width: 90vw;overflow-x: auto;overflow-y: hidden;\">\r\n    <div\r\n      [ngStyle]=\"{width: scrollWidth + 'px'}\"\r\n      style=\"height: 1px\"\r\n    ></div>\r\n  </div>\r\n</div>\r\n", styles: ["cpc-claims-table-swiper{position:sticky;top:0;left:16px;z-index:20;display:flex;align-self:baseline;margin-top:16px;color:var(--cpc-colors-charcoal);font-size:14px;line-height:20px;letter-spacing:.2px;background:var(--cpc-colors-white);box-shadow:-4px 0 0 12px var(--cpc-colors-white);-webkit-user-select:none;user-select:none}cpc-claims-table-swiper ::-webkit-scrollbar{height:8px}cpc-claims-table-swiper ::-webkit-scrollbar-track{background:var(--cpc-colors-light-gray)}cpc-claims-table-swiper ::-webkit-scrollbar-thumb{background:var(--cpc-colors-cerulean)}.cpc-claims-table-swiper{z-index:20;width:100%;background:var(--cpc-colors-white)}\n"] }]
    }], null, { claimsTable: [{
            type: Input
        }], copySwiper: [{
            type: Input
        }], scrollEl: [{
            type: ViewChild,
            args: ['scrollEl']
        }], onResize: [{
            type: HostListener,
            args: ['window:resize', ['$event']]
        }] }); })();

function ErrorPageComponent_cpc_illustration_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "cpc-illustration", 7);
} }
function ErrorPageComponent_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "cpc-illustration", 8);
} }
var ErrorType;
(function (ErrorType) {
    ErrorType["Forbidden"] = "forbidden";
    ErrorType["NotFound"] = "notFound";
})(ErrorType || (ErrorType = {}));
class ErrorPageComponent {
    constructor() {
        this.errorText = { title: '', subtitle: '', button: '' };
        this.prevPage = new EventEmitter();
    }
    goToPrevPage() {
        this.prevPage.emit();
    }
}
ErrorPageComponent.ɵfac = function ErrorPageComponent_Factory(t) { return new (t || ErrorPageComponent)(); };
ErrorPageComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ErrorPageComponent, selectors: [["cpc-error-page"]], inputs: { errorType: "errorType", errorText: "errorText" }, outputs: { prevPage: "prevPage" }, decls: 11, vars: 7, consts: [[1, "cpc-error-page"], [1, "cpc-error-page_wrapper"], ["name", "forbidden", "class", "cpc-error-page_img", 4, "ngIf", "ngIfElse"], [1, "cpc-error-page_title"], [1, "cpc-error-page_subtitle"], ["size", "medium", 3, "noVerticalMargin", "noHorizontalMargin", "click"], ["notFound", ""], ["name", "forbidden", 1, "cpc-error-page_img"], ["name", "notFound", "width", "305px", 1, "cpc-error-page_img"]], template: function ErrorPageComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵtemplate(2, ErrorPageComponent_cpc_illustration_2_Template, 1, 0, "cpc-illustration", 2);
        i0.ɵɵelementStart(3, "span", 3);
        i0.ɵɵtext(4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "span", 4);
        i0.ɵɵtext(6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "cpc-button", 5);
        i0.ɵɵlistener("click", function ErrorPageComponent_Template_cpc_button_click_7_listener() { return ctx.goToPrevPage(); });
        i0.ɵɵtext(8);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(9, ErrorPageComponent_ng_template_9_Template, 1, 0, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(10);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.errorType === "forbidden")("ngIfElse", _r1);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.errorText.title, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.errorText.subtitle, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("noVerticalMargin", true)("noHorizontalMargin", true);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.errorText.button, " ");
    } }, dependencies: [i1.NgIf, ButtonComponent, IllustrationComponent], styles: ["[_ngcontent-%COMP%]:root{--font-family: Allianz Neo, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\" !important;--cpc-colors-blue: #003583;--cpc-colors-resolution-blue: #006192;--cpc-colors-dark-cerulian: #003781;--cpc-colors-light-teal: #007d8c;--cpc-colors-light-gray: #d9d9d9;--cpc-colors-silver: #c2c2c2;--cpc-colors-cerulean: #007ab3;--cpc-colors-sonic-silver: #767676;--cpc-colors-whisper: #ececec;--cpc-colors-white-smoke: #f5f5f5;--cpc-colors-dark-gray: #999999;--cpc-colors-pixie-green: #c0ddbd;--cpc-colors-light-peach: #eacfc0;--cpc-colors-rose-white: #f9f2ef;--cpc-colors-charcoal: #414141;--cpc-colors-light-blue: #cfe9ee;--cpc-colors-faux-green: #3da556;--cpc-colors-light-blue-2: #f1f9fa;--cpc-colors-dark-blue: #002567;--cpc-colors-whispers: #e6e6e6;--cpc-colors-seashell-pink: #f7c7c3;--cpc-colors-cerise-red: #dc3149;--cpc-colors-forest-green: #1e8927;--cpc-colors-kashmir-blue: #49648c;--cpc-colors-light-yellow: #fff4d8;--cpc-colors-gold-orange: #edcd03;--cpc-colors-dark-yellow: rgba(255, 232, 176, .5);--cpc-colors-white: #fff;--cpc-colors-light-peach-2: var(--cpc-colors-rose-white);--cpc-colors-light-green: var(--cpc-colors-pixie-green);--cpc-colors-banana-mania: #ffe8b0;--cpc-colors-dark-opacity: rgba(0, 0, 0, .3);--cpc-colors-text: var(--cpc-colors-charcoal);--cpc-colors-border: var(--cpc-colors-light-gray);--cpc-colors-hover: var(--cpc-colors-resolution-blue);--cpc-colors-active: var(--cpc-colors-dark-cerulian);--cpc-colors-active-background: var(--cpc-colors-light-blue-2);--cpc-user-profile-photo-size: 32px;--cpc-agent-profile-photo-size: 104px;--cpc-border: solid 1px var(--cpc-colors-border);--cpc-badge-text: var(--cpc-colors-text);--cpc-badge-background: var(--cpc-colors-white);--cpc-badge-success: #e3ebaf;--cpc-badge-warning: #f7caab;--cpc-badge-text-danger: var(--cpc-colors-white);--cpc-badge-danger: var(--cpc-colors-cerise-red);--cpc-badge-important: #fdd25c;--cpc-badge-text-inactive: var(--cpc-colors-dark-gray);--cpc-badge-inactive: var(--cpc-colors-white);--cpc-badge-icon-active: var(--cpc-colors-resolution-blue);--cpc-badge-icon-inactive: var(--cpc-colors-dark-gray);--cpc-card-divide-bar: var(--cpc-colors-light-blue);--cpc-card-background: var(--cpc-colors-light-blue-2);--cpc-card-background-inactive: var(--cpc-colors-white-smoke);--cpc-document-upload-name-weight: 600;--cpc-document-upload-success-icon-color: var(--cpc-colors-forest-green);--cpc-policy-card-border: solid 1px var(--cpc-colors-light-gray);--cpc-policy-card-border-mobile: solid 1px var(--cpc-colors-light-blue);--cpc-policy-card-header-background: var(--cpc-colors-light-blue-2);--cpc-policy-card-header-background-inactive: var(--cpc-colors-white-smoke);--cpc-policy-card-header-title-color-inactive: #999999;--cpc-policy-progress-track: var(--cpc-colors-whisper);--cpc-policy-progress-progress: var(--cpc-colors-cerulean);--cpc-payments-background-danger-panel: rgba(220, 49, 73, .1);--cpc-payments-danger-border: rgba(220, 49, 73, .4);--cpc-spinner-active-color: var(--cpc-colors-cerulean);--cpc-spinner-background-color: var(--cpc-colors-whisper);--icon-background-color: var(--cpc-colors-faux-green);--icon-color-inactive: var(--cpc-colors-light-gray);--button-primary-background-color: var(--cpc-colors-cerulean);--button-primary-border-color: transparent;--button-primary-text-color: var(--cpc-colors-white);--button-primary-hover-background-color: var(--cpc-colors-resolution-blue);--button-primary-hover-border-color: transparent;--button-primary-hover-text-color: var(--cpc-colors-white);--button-primary-active-background-color: var(--cpc-colors-dark-cerulian);--button-primary-active-text-color: var(--cpc-colors-white);--button-primary-active-border-color: transparent;--button-primary-disabled-background-color: rgba(0, 122, 179, .4);--button-primary-disabled-text-color: hsla(0, 0%, 100%, .4);--button-primary-disabled-border-color: transparent;--button-secondary-background-color: transparent;--button-secondary-border-color: var(--cpc-colors-cerulean);--button-secondary-text-color: var(--cpc-colors-resolution-blue);--button-secondary-hover-background-color: var(--cpc-colors-resolution-blue);--button-secondary-hover-border-color: transparent;--button-secondary-hover-text-color: var(--cpc-colors-white);--button-secondary-active-background-color: var(--cpc-colors-dark-cerulian);--button-secondary-active-text-color: var(--cpc-colors-white);--button-secondary-active-border-color: transparent;--button-secondary-disabled-background-color: transparent;--button-secondary-disabled-text-color: rgba(0, 97, 146, .4);--button-secondary-disabled-border-color: rgba(0, 122, 179, .4);--button-tertiary-background-color: transparent;--button-tertiary-border-color: transparent;--button-tertiary-text-color: var(--button-secondary-text-color);--button-tertiary-hover-background-color: var(--cpc-colors-whisper);--button-tertiary-hover-border-color: transparent;--button-tertiary-hover-text-color: var(--button-secondary-text-color);--button-tertiary-active-background-color: var(--cpc-colors-light-gray);--button-tertiary-active-text-color: var(--button-secondary-text-color);--button-tertiary-active-border-color: transparent;--button-tertiary-disabled-background-color: var(--button-secondary-background-color);--button-tertiary-disabled-text-color: var(--button-secondary-disabled-text-color);--button-tertiary-disabled-border-color: transparent;--button-emphasis-background-color: #f86200;--button-emphasis-border-color: transparent;--button-emphasis-text-color: var(--cpc-colors-white);--button-emphasis-hover-background-color: #e15200;--button-emphasis-hover-border-color: transparent;--button-emphasis-hover-text-color: var(--cpc-colors-white);--button-emphasis-active-background-color: #c15500;--button-emphasis-active-text-color: var(--cpc-colors-white);--button-emphasis-active-border-color: transparent;--button-emphasis-disabled-background-color: rgba(248, 98, 0, .4);--button-emphasis-disabled-text-color: hsla(0, 0%, 100%, .4);--button-emphasis-disabled-border-color: transparent;--button-cta-background-color: var(--cpc-colors-faux-green);--button-cta-border-color: transparent;--button-cta-text-color: var(--cpc-colors-white);--button-cta-hover-background-color: #348357;--button-cta-hover-border-color: transparent;--button-cta-hover-text-color: var(--cpc-colors-white);--button-cta-active-background-color: #276442;--button-cta-active-text-color: var(--cpc-colors-white);--button-cta-active-border-color: transparent;--button-cta-disabled-background-color: rgba(61, 165, 86, .4);--button-cta-disabled-text-color: hsla(0, 0%, 100%, .4);--button-cta-disabled-border-color: transparent;--button-primary-danger-background-color: var(--cpc-colors-cerise-red);--button-primary-danger-border-color: transparent;--button-primary-danger-text-color: var(--cpc-colors-white);--button-primary-danger-hover-background-color: #c51322;--button-primary-danger-hover-border-color: transparent;--button-primary-danger-hover-text-color: var(--cpc-colors-white);--button-primary-danger-active-background-color: #b0050c;--button-primary-danger-active-text-color: var(--cpc-colors-white);--button-primary-danger-active-border-color: transparent;--button-primary-danger-disabled-background-color: rgba(220, 49, 73, .4);--button-primary-danger-disabled-text-color: hsla(0, 0%, 100%, .4);--button-primary-danger-disabled-border-color: transparent;--button-secondary-danger-background-color: transparent;--button-secondary-danger-border-color: var(--cpc-colors-cerise-red);--button-secondary-danger-text-color: var(--cpc-colors-cerise-red);--button-secondary-danger-hover-background-color: #c51322;--button-secondary-danger-hover-border-color: transparent;--button-secondary-danger-hover-text-color: var(--cpc-colors-white);--button-secondary-danger-active-background-color: #b0050c;--button-secondary-danger-active-text-color: var(--cpc-colors-white);--button-secondary-danger-active-border-color: transparent;--button-secondary-danger-disabled-background-color: transparent;--button-secondary-danger-disabled-text-color: rgba(220, 49, 73, .4);--button-secondary-danger-disabled-border-color: rgba(220, 49, 73, .4);--button-tertiary-danger-background-color: transparent;--button-tertiary-danger-border-color: transparent;--button-tertiary-danger-text-color: var(--cpc-colors-cerise-red);--button-tertiary-danger-hover-background-color: #ececec;--button-tertiary-danger-hover-border-color: transparent;--button-tertiary-danger-hover-text-color: var(--cpc-colors-cerise-red);--button-tertiary-danger-active-background-color: var(--cpc-colors-light-gray);--button-tertiary-danger-active-text-color: var(--cpc-colors-cerise-red);--button-tertiary-danger-active-border-color: transparent;--button-tertiary-danger-disabled-background-color: transparent;--button-tertiary-danger-disabled-text-color: rgba(220, 49, 73, .4);--button-tertiary-danger-disabled-border-color: transparent;--button-text-transform: uppercase;--button-border-radius: 4px;--button-border-width: 2px;--button-small-height: 32px;--button-small-medium-height: 40px;--button-medium-height: 48px;--button-large-height: 72px;--button-small-icon-size: 16px;--button-small-medium-icon-size: 20px;--button-medium-icon-size: 24px;--button-large-icon-size: 24px;--help-modal-fab-color: var(--cpc-colors-resolution-blue);--help-modal-font-size: 16px;--help-modal-font-weight: 600;--help-modal-line-height: 1.5;--help-modal-letter-spacing: 1px;--help-modal-background-color: var(--cpc-colors-white);--help-modal-box-shadow-color: #e3e6e6;--help-modal-icon-size: 24px;--help-modal-icon-info-size: 40px;--help-modal-icon-info-color: var(--cpc-colors-white);--help-modal-icon-info-background: var(--cpc-colors-cerulean);--help-modal-content-color: var(--cpc-colors-resolution-blue);--help-modal-content-border-color: #d3e3e5;--help-modal-content-list-font-size: 16px;--help-modal-content-selected: 700;--help-modal-content-font-size: 16px;--help-modal-min-width: 280px;--help-modal-max-width: 888px;--help-modal-width:calc(100vw - 32px);--help-modal-max-width-large: 100%;--help-modal-position-bottom: 115px;--help-modal-group-content-max-width: 375px;--paging-input-color: #5b686e;--invesments-row-padding-left: 16px;--error-page-text-color: var(--cpc-colors-charcoal);--error-page-title-weight: 300;--error-page-title-size: 54px;--error-page-subtitle-weight: 400;--error-page-subtitle-size: 24px;--logout-page-text-color: var(--cpc-colors-charcoal);--logout-page-text-font-weight: 500;--logout-page-title-font-size: 26px;--logout-page-title-line-height: 32px;--logout-page-title-letter-spacing: .26px;--logout-page-subtitle-font-size: 16px;--logout-page-subtitle-line-height: 24px;--popup-change-agent-active-background: var(--cpc-colors-light-blue-2);--popup-change-agent-active-border: var(--cpc-colors-cerulean)}.cpc-error-page_wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:column;color:var(--error-page-text-color);font-family:var(--font-family);text-align:center}.cpc-error-page_img[_ngcontent-%COMP%]{display:flex;align-items:flex-end;height:200px;margin:auto}.cpc-error-page_title[_ngcontent-%COMP%]{margin:55px auto 20px;font-weight:var(--error-page-title-weight);font-size:var(--error-page-title-size);line-height:60px;letter-spacing:.3px}.cpc-error-page_subtitle[_ngcontent-%COMP%]{margin-bottom:40px;font-weight:var(--error-page-subtitle-weight);font-size:var(--error-page-subtitle-size);line-height:24px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ErrorPageComponent, [{
        type: Component,
        args: [{ selector: 'cpc-error-page', template: "<div class=\"cpc-error-page\">\r\n  <div class=\"cpc-error-page_wrapper\">\r\n    <cpc-illustration\r\n      *ngIf=\"errorType === 'forbidden'; else notFound\"\r\n      name=\"forbidden\"\r\n      class=\"cpc-error-page_img\"\r\n    ></cpc-illustration>\r\n    <span class=\"cpc-error-page_title\">\r\n      {{ errorText.title }}\r\n    </span>\r\n    <span class=\"cpc-error-page_subtitle\">\r\n      {{ errorText.subtitle }}\r\n    </span>\r\n    <cpc-button\r\n      size=\"medium\"\r\n      [noVerticalMargin]=\"true\"\r\n      [noHorizontalMargin]=\"true\"\r\n      (click)=\"goToPrevPage()\"\r\n    >\r\n      {{ errorText.button }}\r\n    </cpc-button>\r\n  </div>\r\n\r\n  <ng-template #notFound>\r\n    <cpc-illustration\r\n      name=\"notFound\"\r\n      width=\"305px\"\r\n      class=\"cpc-error-page_img\"\r\n    ></cpc-illustration>\r\n  </ng-template>\r\n</div>\r\n", styles: [":root{--font-family: Allianz Neo, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\" !important;--cpc-colors-blue: #003583;--cpc-colors-resolution-blue: #006192;--cpc-colors-dark-cerulian: #003781;--cpc-colors-light-teal: #007d8c;--cpc-colors-light-gray: #d9d9d9;--cpc-colors-silver: #c2c2c2;--cpc-colors-cerulean: #007ab3;--cpc-colors-sonic-silver: #767676;--cpc-colors-whisper: #ececec;--cpc-colors-white-smoke: #f5f5f5;--cpc-colors-dark-gray: #999999;--cpc-colors-pixie-green: #c0ddbd;--cpc-colors-light-peach: #eacfc0;--cpc-colors-rose-white: #f9f2ef;--cpc-colors-charcoal: #414141;--cpc-colors-light-blue: #cfe9ee;--cpc-colors-faux-green: #3da556;--cpc-colors-light-blue-2: #f1f9fa;--cpc-colors-dark-blue: #002567;--cpc-colors-whispers: #e6e6e6;--cpc-colors-seashell-pink: #f7c7c3;--cpc-colors-cerise-red: #dc3149;--cpc-colors-forest-green: #1e8927;--cpc-colors-kashmir-blue: #49648c;--cpc-colors-light-yellow: #fff4d8;--cpc-colors-gold-orange: #edcd03;--cpc-colors-dark-yellow: rgba(255, 232, 176, .5);--cpc-colors-white: #fff;--cpc-colors-light-peach-2: var(--cpc-colors-rose-white);--cpc-colors-light-green: var(--cpc-colors-pixie-green);--cpc-colors-banana-mania: #ffe8b0;--cpc-colors-dark-opacity: rgba(0, 0, 0, .3);--cpc-colors-text: var(--cpc-colors-charcoal);--cpc-colors-border: var(--cpc-colors-light-gray);--cpc-colors-hover: var(--cpc-colors-resolution-blue);--cpc-colors-active: var(--cpc-colors-dark-cerulian);--cpc-colors-active-background: var(--cpc-colors-light-blue-2);--cpc-user-profile-photo-size: 32px;--cpc-agent-profile-photo-size: 104px;--cpc-border: solid 1px var(--cpc-colors-border);--cpc-badge-text: var(--cpc-colors-text);--cpc-badge-background: var(--cpc-colors-white);--cpc-badge-success: #e3ebaf;--cpc-badge-warning: #f7caab;--cpc-badge-text-danger: var(--cpc-colors-white);--cpc-badge-danger: var(--cpc-colors-cerise-red);--cpc-badge-important: #fdd25c;--cpc-badge-text-inactive: var(--cpc-colors-dark-gray);--cpc-badge-inactive: var(--cpc-colors-white);--cpc-badge-icon-active: var(--cpc-colors-resolution-blue);--cpc-badge-icon-inactive: var(--cpc-colors-dark-gray);--cpc-card-divide-bar: var(--cpc-colors-light-blue);--cpc-card-background: var(--cpc-colors-light-blue-2);--cpc-card-background-inactive: var(--cpc-colors-white-smoke);--cpc-document-upload-name-weight: 600;--cpc-document-upload-success-icon-color: var(--cpc-colors-forest-green);--cpc-policy-card-border: solid 1px var(--cpc-colors-light-gray);--cpc-policy-card-border-mobile: solid 1px var(--cpc-colors-light-blue);--cpc-policy-card-header-background: var(--cpc-colors-light-blue-2);--cpc-policy-card-header-background-inactive: var(--cpc-colors-white-smoke);--cpc-policy-card-header-title-color-inactive: #999999;--cpc-policy-progress-track: var(--cpc-colors-whisper);--cpc-policy-progress-progress: var(--cpc-colors-cerulean);--cpc-payments-background-danger-panel: rgba(220, 49, 73, .1);--cpc-payments-danger-border: rgba(220, 49, 73, .4);--cpc-spinner-active-color: var(--cpc-colors-cerulean);--cpc-spinner-background-color: var(--cpc-colors-whisper);--icon-background-color: var(--cpc-colors-faux-green);--icon-color-inactive: var(--cpc-colors-light-gray);--button-primary-background-color: var(--cpc-colors-cerulean);--button-primary-border-color: transparent;--button-primary-text-color: var(--cpc-colors-white);--button-primary-hover-background-color: var(--cpc-colors-resolution-blue);--button-primary-hover-border-color: transparent;--button-primary-hover-text-color: var(--cpc-colors-white);--button-primary-active-background-color: var(--cpc-colors-dark-cerulian);--button-primary-active-text-color: var(--cpc-colors-white);--button-primary-active-border-color: transparent;--button-primary-disabled-background-color: rgba(0, 122, 179, .4);--button-primary-disabled-text-color: hsla(0, 0%, 100%, .4);--button-primary-disabled-border-color: transparent;--button-secondary-background-color: transparent;--button-secondary-border-color: var(--cpc-colors-cerulean);--button-secondary-text-color: var(--cpc-colors-resolution-blue);--button-secondary-hover-background-color: var(--cpc-colors-resolution-blue);--button-secondary-hover-border-color: transparent;--button-secondary-hover-text-color: var(--cpc-colors-white);--button-secondary-active-background-color: var(--cpc-colors-dark-cerulian);--button-secondary-active-text-color: var(--cpc-colors-white);--button-secondary-active-border-color: transparent;--button-secondary-disabled-background-color: transparent;--button-secondary-disabled-text-color: rgba(0, 97, 146, .4);--button-secondary-disabled-border-color: rgba(0, 122, 179, .4);--button-tertiary-background-color: transparent;--button-tertiary-border-color: transparent;--button-tertiary-text-color: var(--button-secondary-text-color);--button-tertiary-hover-background-color: var(--cpc-colors-whisper);--button-tertiary-hover-border-color: transparent;--button-tertiary-hover-text-color: var(--button-secondary-text-color);--button-tertiary-active-background-color: var(--cpc-colors-light-gray);--button-tertiary-active-text-color: var(--button-secondary-text-color);--button-tertiary-active-border-color: transparent;--button-tertiary-disabled-background-color: var(--button-secondary-background-color);--button-tertiary-disabled-text-color: var(--button-secondary-disabled-text-color);--button-tertiary-disabled-border-color: transparent;--button-emphasis-background-color: #f86200;--button-emphasis-border-color: transparent;--button-emphasis-text-color: var(--cpc-colors-white);--button-emphasis-hover-background-color: #e15200;--button-emphasis-hover-border-color: transparent;--button-emphasis-hover-text-color: var(--cpc-colors-white);--button-emphasis-active-background-color: #c15500;--button-emphasis-active-text-color: var(--cpc-colors-white);--button-emphasis-active-border-color: transparent;--button-emphasis-disabled-background-color: rgba(248, 98, 0, .4);--button-emphasis-disabled-text-color: hsla(0, 0%, 100%, .4);--button-emphasis-disabled-border-color: transparent;--button-cta-background-color: var(--cpc-colors-faux-green);--button-cta-border-color: transparent;--button-cta-text-color: var(--cpc-colors-white);--button-cta-hover-background-color: #348357;--button-cta-hover-border-color: transparent;--button-cta-hover-text-color: var(--cpc-colors-white);--button-cta-active-background-color: #276442;--button-cta-active-text-color: var(--cpc-colors-white);--button-cta-active-border-color: transparent;--button-cta-disabled-background-color: rgba(61, 165, 86, .4);--button-cta-disabled-text-color: hsla(0, 0%, 100%, .4);--button-cta-disabled-border-color: transparent;--button-primary-danger-background-color: var(--cpc-colors-cerise-red);--button-primary-danger-border-color: transparent;--button-primary-danger-text-color: var(--cpc-colors-white);--button-primary-danger-hover-background-color: #c51322;--button-primary-danger-hover-border-color: transparent;--button-primary-danger-hover-text-color: var(--cpc-colors-white);--button-primary-danger-active-background-color: #b0050c;--button-primary-danger-active-text-color: var(--cpc-colors-white);--button-primary-danger-active-border-color: transparent;--button-primary-danger-disabled-background-color: rgba(220, 49, 73, .4);--button-primary-danger-disabled-text-color: hsla(0, 0%, 100%, .4);--button-primary-danger-disabled-border-color: transparent;--button-secondary-danger-background-color: transparent;--button-secondary-danger-border-color: var(--cpc-colors-cerise-red);--button-secondary-danger-text-color: var(--cpc-colors-cerise-red);--button-secondary-danger-hover-background-color: #c51322;--button-secondary-danger-hover-border-color: transparent;--button-secondary-danger-hover-text-color: var(--cpc-colors-white);--button-secondary-danger-active-background-color: #b0050c;--button-secondary-danger-active-text-color: var(--cpc-colors-white);--button-secondary-danger-active-border-color: transparent;--button-secondary-danger-disabled-background-color: transparent;--button-secondary-danger-disabled-text-color: rgba(220, 49, 73, .4);--button-secondary-danger-disabled-border-color: rgba(220, 49, 73, .4);--button-tertiary-danger-background-color: transparent;--button-tertiary-danger-border-color: transparent;--button-tertiary-danger-text-color: var(--cpc-colors-cerise-red);--button-tertiary-danger-hover-background-color: #ececec;--button-tertiary-danger-hover-border-color: transparent;--button-tertiary-danger-hover-text-color: var(--cpc-colors-cerise-red);--button-tertiary-danger-active-background-color: var(--cpc-colors-light-gray);--button-tertiary-danger-active-text-color: var(--cpc-colors-cerise-red);--button-tertiary-danger-active-border-color: transparent;--button-tertiary-danger-disabled-background-color: transparent;--button-tertiary-danger-disabled-text-color: rgba(220, 49, 73, .4);--button-tertiary-danger-disabled-border-color: transparent;--button-text-transform: uppercase;--button-border-radius: 4px;--button-border-width: 2px;--button-small-height: 32px;--button-small-medium-height: 40px;--button-medium-height: 48px;--button-large-height: 72px;--button-small-icon-size: 16px;--button-small-medium-icon-size: 20px;--button-medium-icon-size: 24px;--button-large-icon-size: 24px;--help-modal-fab-color: var(--cpc-colors-resolution-blue);--help-modal-font-size: 16px;--help-modal-font-weight: 600;--help-modal-line-height: 1.5;--help-modal-letter-spacing: 1px;--help-modal-background-color: var(--cpc-colors-white);--help-modal-box-shadow-color: #e3e6e6;--help-modal-icon-size: 24px;--help-modal-icon-info-size: 40px;--help-modal-icon-info-color: var(--cpc-colors-white);--help-modal-icon-info-background: var(--cpc-colors-cerulean);--help-modal-content-color: var(--cpc-colors-resolution-blue);--help-modal-content-border-color: #d3e3e5;--help-modal-content-list-font-size: 16px;--help-modal-content-selected: 700;--help-modal-content-font-size: 16px;--help-modal-min-width: 280px;--help-modal-max-width: 888px;--help-modal-width:calc(100vw - 32px);--help-modal-max-width-large: 100%;--help-modal-position-bottom: 115px;--help-modal-group-content-max-width: 375px;--paging-input-color: #5b686e;--invesments-row-padding-left: 16px;--error-page-text-color: var(--cpc-colors-charcoal);--error-page-title-weight: 300;--error-page-title-size: 54px;--error-page-subtitle-weight: 400;--error-page-subtitle-size: 24px;--logout-page-text-color: var(--cpc-colors-charcoal);--logout-page-text-font-weight: 500;--logout-page-title-font-size: 26px;--logout-page-title-line-height: 32px;--logout-page-title-letter-spacing: .26px;--logout-page-subtitle-font-size: 16px;--logout-page-subtitle-line-height: 24px;--popup-change-agent-active-background: var(--cpc-colors-light-blue-2);--popup-change-agent-active-border: var(--cpc-colors-cerulean)}.cpc-error-page_wrapper{display:flex;flex-direction:column;color:var(--error-page-text-color);font-family:var(--font-family);text-align:center}.cpc-error-page_img{display:flex;align-items:flex-end;height:200px;margin:auto}.cpc-error-page_title{margin:55px auto 20px;font-weight:var(--error-page-title-weight);font-size:var(--error-page-title-size);line-height:60px;letter-spacing:.3px}.cpc-error-page_subtitle{margin-bottom:40px;font-weight:var(--error-page-subtitle-weight);font-size:var(--error-page-subtitle-size);line-height:24px}\n"] }]
    }], null, { errorType: [{
            type: Input
        }], errorText: [{
            type: Input
        }], prevPage: [{
            type: Output
        }] }); })();

const illustrationSVG = [
    'confirmationLetter',
    'forbidden',
    'lightbulbFloatsOverHand',
    'manAndWomanUnderUmbrelaButDogWillGetWet',
    'manHoldingBox',
    'manHoldingCertificate',
    'notFound',
    'ok',
    'womanInFrontOfComputer',
    'womanLookingAtThePhone',
    'womanWithBinoculars',
    'womanWithComputerDisplayingChecks',
    'womanWithLaptopTalkingOnThePhone',
];
var Illustrations;
(function (Illustrations) {
    Illustrations["ConfirmationLetter"] = "confirmationLetter";
    Illustrations["Forbidden"] = "forbidden";
    Illustrations["LightBulbFloatsOverHand"] = "lightbulbFloatsOverHand";
    Illustrations["ManAndWomanUnderUmbrelaButDogWillGetWet"] = "manAndWomanUnderUmbrelaButDogWillGetWet";
    Illustrations["ManHoldingBox"] = "manHoldingBox";
    Illustrations["ManHoldingCertificate"] = "manHoldingCertificate";
    Illustrations["NotFound"] = "notFound";
    Illustrations["Ok"] = "ok";
    Illustrations["WomanInFrontOfComputer"] = "womanInFrontOfComputer";
    Illustrations["WomanLookingAtThePhone"] = "womanLookingAtThePhone";
    Illustrations["WomanWithBinoculars"] = "womanWithBinoculars";
    Illustrations["WomanWithComputerDisplayingChecks"] = "womanWithComputerDisplayingChecks";
    Illustrations["WomanWithLaptopTalkingOnThePhone"] = "womanWithLaptopTalkingOnThePhone";
})(Illustrations || (Illustrations = {}));

function LogoutPageComponent_li_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 12);
    i0.ɵɵelement(1, "cpc-icon", 13);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const infoItem_r1 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("icon", ctx_r0.ndbxIcons.Check);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", infoItem_r1, " ");
} }
class LogoutPageComponent {
    constructor() {
        this.backToLogin = new EventEmitter();
        this.illustrations = Illustrations;
        this.ndbxIcons = NdbxIcon;
        this.backgrounds = PanelComponentPropBackground;
    }
    goToLogin() {
        this.backToLogin.emit();
    }
}
LogoutPageComponent.ɵfac = function LogoutPageComponent_Factory(t) { return new (t || LogoutPageComponent)(); };
LogoutPageComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LogoutPageComponent, selectors: [["cpc-logout-page"]], inputs: { logoutLeftContent: "logoutLeftContent", logoutRightContent: "logoutRightContent" }, outputs: { backToLogin: "backToLogin" }, decls: 20, vars: 13, consts: [["col", "12,12,6", 3, "background"], [1, "cpc-logout-container"], ["name", "ok", "width", "96px"], [1, "cpc-logout-page_title"], [1, "cpc-logout-page_subtitle"], ["size", "medium", 3, "noVerticalMargin", "noHorizontalMargin", "click"], ["col", "12,12,6", 1, "cpc-logout-page_container-magin-button", 3, "background"], [1, "cpc-logout-page_title", "cpc-logout-page_title-margin-top"], [1, "cpc-logout-page_subtitle", "cpc-logout-page_subtitle-margin-bottom"], [1, "cpc-logout-page_info-list"], ["class", "cpc-logout-page_info-item", 4, "ngFor", "ngForOf"], ["width", "232px", 3, "name"], [1, "cpc-logout-page_info-item"], ["color", "#3BA455", 1, "cpc-logout-page_info-item-icon", 2, "font-size", "24px", 3, "icon"]], template: function LogoutPageComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "cpc-panel-group")(1, "cpc-panel", 0)(2, "div", 1);
        i0.ɵɵelement(3, "cpc-illustration", 2);
        i0.ɵɵelementStart(4, "h1", 3);
        i0.ɵɵtext(5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "h3", 4);
        i0.ɵɵtext(7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "cpc-button", 5);
        i0.ɵɵlistener("click", function LogoutPageComponent_Template_cpc_button_click_8_listener() { return ctx.goToLogin(); });
        i0.ɵɵtext(9);
        i0.ɵɵpipe(10, "uppercase");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(11, "cpc-panel", 6)(12, "div", 1)(13, "h1", 7);
        i0.ɵɵtext(14);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(15, "h3", 8);
        i0.ɵɵtext(16);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(17, "ul", 9);
        i0.ɵɵtemplate(18, LogoutPageComponent_li_18_Template, 3, 2, "li", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(19, "cpc-illustration", 11);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("background", ctx.backgrounds.white);
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate1(" ", ctx.logoutLeftContent.title, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.logoutLeftContent.subtitle, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("noVerticalMargin", false)("noHorizontalMargin", true);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(10, 11, ctx.logoutLeftContent.button), " ");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("background", ctx.backgrounds.lightBlue);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.logoutRightContent.title, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.logoutRightContent.subtitle, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.logoutRightContent.infoList);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("name", ctx.illustrations.WomanInFrontOfComputer);
    } }, dependencies: [i1.NgForOf, ButtonComponent, IconComponent, IllustrationComponent, PanelComponent, PanelGroupComponent, i1.UpperCasePipe], styles: [".cpc-panel{padding:40px 25px 0!important}@media screen and (min-width: 704px){.cpc-panel{padding:70px 35px 0!important}}.cpc-panel .cpc-illustration{margin:auto!important}@media screen and (min-width: 704px){.cpc-panel:first-child .cpc-illustration{margin:0!important}}.cpc-logout-container{max-width:339px;margin:auto}.cpc-logout-container .cpc-button{width:100%!important;margin-bottom:48.5px!important}.cpc-logout-page_title{margin:32px 0 25px;color:var(--logout-page-text-color);font-weight:var(--logout-page-text-font-weight);font-size:var(--logout-page-title-font-size);line-height:var(--logout-page-title-line-height);letter-spacing:var(--logout-page-title-letter-spacing);text-align:left}.cpc-logout-page_title-margin-top{margin-top:0}.cpc-logout-page_subtitle{margin-bottom:40px;color:var(--logout-page-text-color);font-weight:var(--logout-page-text-font-weight);font-size:var(--logout-page-subtitle-font-size);line-height:var(--logout-page-subtitle-line-height);text-align:left}@media screen and (min-width: 704px){.cpc-logout-page_subtitle{margin-bottom:32px}}.cpc-logout-page_subtitle-margin-bottom{margin-bottom:25px}.cpc-logout-page_info-list{margin-bottom:40px}@media screen and (min-width: 704px){.cpc-logout-page_info-list{margin-bottom:48px}}.cpc-logout-page_info-item{position:relative;margin-bottom:16px;list-style:none}@media screen and (min-width: 704px){.cpc-logout-page_info-item{margin-bottom:22px}}.cpc-logout-page_info-item-icon{position:absolute;top:0;left:-40px}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LogoutPageComponent, [{
        type: Component,
        args: [{ selector: 'cpc-logout-page', encapsulation: ViewEncapsulation.None, template: "<cpc-panel-group>\r\n  <cpc-panel\r\n    [background]=\"backgrounds.white\"\r\n    col=\"12,12,6\"\r\n  >\r\n    <div class=\"cpc-logout-container\">\r\n      <cpc-illustration\r\n        name=\"ok\"\r\n        width=\"96px\"\r\n      ></cpc-illustration>\r\n      <h1 class=\"cpc-logout-page_title\">\r\n        {{ logoutLeftContent.title }}\r\n      </h1>\r\n      <h3 class=\"cpc-logout-page_subtitle\">\r\n        {{ logoutLeftContent.subtitle }}\r\n      </h3>\r\n      <cpc-button\r\n        size=\"medium\"\r\n        [noVerticalMargin]=\"false\"\r\n        [noHorizontalMargin]=\"true\"\r\n        (click)=\"goToLogin()\"\r\n      >\r\n        {{ logoutLeftContent.button | uppercase }}\r\n      </cpc-button>\r\n    </div>\r\n  </cpc-panel>\r\n\r\n  <cpc-panel\r\n    [background]=\"backgrounds.lightBlue\"\r\n    col=\"12,12,6\"\r\n    class=\"cpc-logout-page_container-magin-button\"\r\n  >\r\n    <div class=\"cpc-logout-container\">\r\n      <h1 class=\"cpc-logout-page_title cpc-logout-page_title-margin-top\">\r\n        {{ logoutRightContent.title }}\r\n      </h1>\r\n      <h3 class=\"cpc-logout-page_subtitle cpc-logout-page_subtitle-margin-bottom \">\r\n        {{ logoutRightContent.subtitle }}\r\n      </h3>\r\n      <ul class=\"cpc-logout-page_info-list\">\r\n        <li\r\n          *ngFor=\"let infoItem of logoutRightContent.infoList\"\r\n          class=\"cpc-logout-page_info-item\"\r\n        >\r\n          <cpc-icon\r\n            [icon]=\"ndbxIcons.Check\"\r\n            color=\"#3BA455\"\r\n            style=\"font-size: 24px\"\r\n            class=\"cpc-logout-page_info-item-icon\"\r\n          ></cpc-icon>\r\n          {{ infoItem }}\r\n        </li>\r\n      </ul>\r\n      <cpc-illustration\r\n        [name]=\"illustrations.WomanInFrontOfComputer\"\r\n        width=\"232px\"\r\n      ></cpc-illustration>\r\n    </div>\r\n  </cpc-panel>\r\n</cpc-panel-group>\r\n", styles: [".cpc-panel{padding:40px 25px 0!important}@media screen and (min-width: 704px){.cpc-panel{padding:70px 35px 0!important}}.cpc-panel .cpc-illustration{margin:auto!important}@media screen and (min-width: 704px){.cpc-panel:first-child .cpc-illustration{margin:0!important}}.cpc-logout-container{max-width:339px;margin:auto}.cpc-logout-container .cpc-button{width:100%!important;margin-bottom:48.5px!important}.cpc-logout-page_title{margin:32px 0 25px;color:var(--logout-page-text-color);font-weight:var(--logout-page-text-font-weight);font-size:var(--logout-page-title-font-size);line-height:var(--logout-page-title-line-height);letter-spacing:var(--logout-page-title-letter-spacing);text-align:left}.cpc-logout-page_title-margin-top{margin-top:0}.cpc-logout-page_subtitle{margin-bottom:40px;color:var(--logout-page-text-color);font-weight:var(--logout-page-text-font-weight);font-size:var(--logout-page-subtitle-font-size);line-height:var(--logout-page-subtitle-line-height);text-align:left}@media screen and (min-width: 704px){.cpc-logout-page_subtitle{margin-bottom:32px}}.cpc-logout-page_subtitle-margin-bottom{margin-bottom:25px}.cpc-logout-page_info-list{margin-bottom:40px}@media screen and (min-width: 704px){.cpc-logout-page_info-list{margin-bottom:48px}}.cpc-logout-page_info-item{position:relative;margin-bottom:16px;list-style:none}@media screen and (min-width: 704px){.cpc-logout-page_info-item{margin-bottom:22px}}.cpc-logout-page_info-item-icon{position:absolute;top:0;left:-40px}\n"] }]
    }], null, { logoutLeftContent: [{
            type: Input
        }], logoutRightContent: [{
            type: Input
        }], backToLogin: [{
            type: Output
        }] }); })();

class MaintenancePageComponent {
    constructor() {
        this.maintenanceText = {
            title: '',
            unavailable: '',
            inconvenience: '',
            valediction: '',
            contact: '',
            callCenter: '',
            daysAvailability: '',
        };
        this.mediaQuery = setMatchMedia(Breakpoints.large);
        this.isMobile = !this.mediaQuery?.matches;
        this.ndbxIcons = NdbxIcon;
    }
    onResize(_) {
        this.isMobile = !this.mediaQuery?.matches;
    }
}
MaintenancePageComponent.ɵfac = function MaintenancePageComponent_Factory(t) { return new (t || MaintenancePageComponent)(); };
MaintenancePageComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MaintenancePageComponent, selectors: [["cpc-maintenance-page"]], hostBindings: function MaintenancePageComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("resize", function MaintenancePageComponent_resize_HostBindingHandler($event) { return ctx.onResize($event); }, false, i0.ɵɵresolveWindow);
    } }, inputs: { phoneNumber: "phoneNumber", maintenanceText: "maintenanceText" }, decls: 28, vars: 12, consts: [[1, "cpc-maintenance-page"], [1, "cpc-maintenance-page_wrapper"], [1, "cpc-maintenance-page_info"], [1, "cpc-allianz-logo", 3, "width", "height"], [1, "cpc-maintenance-page_title"], [1, "cpc-maintenance-page_description-wrapper"], [1, "cpc-maintenance-page_description-unavailable"], [1, "cpc-maintenance-page_description-inconvenience"], [1, "cpc-maintenance-page_description-valediction"], [1, "horizontal-rule"], [1, "cpc-maintenance-page_contact"], [1, "cpc-maintenance-page_contact-content"], [1, "cpc-maintenance-page_contact-content-title"], [1, "cpc-maintenance-page_contact-phone-contact"], [1, "cpc-maintenance-page_phone-icon", 3, "icon"], [1, "cpc-maintenance-page_phone-contact-content"], [1, "cpc-maintenance-page_phone-number-wrapper"], [1, "cpc-maintenance-page_phone-number"], [1, "cpc-maintenance-page_days-availability"], ["name", "womanWithLaptopTalkingOnThePhone", 1, "cpc-illustration", 3, "width"]], template: function MaintenancePageComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
        i0.ɵɵelement(3, "cpc-allianz-logo", 3);
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵtext(5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 5)(7, "div", 6);
        i0.ɵɵtext(8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "div", 7);
        i0.ɵɵtext(10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "div", 8);
        i0.ɵɵtext(12);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelement(13, "div", 9);
        i0.ɵɵelementStart(14, "div", 10)(15, "div", 11)(16, "div", 12);
        i0.ɵɵtext(17);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(18, "div", 13);
        i0.ɵɵelement(19, "cpc-icon", 14);
        i0.ɵɵelementStart(20, "div", 15)(21, "div", 16);
        i0.ɵɵtext(22);
        i0.ɵɵelementStart(23, "span", 17);
        i0.ɵɵtext(24);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(25, "div", 18);
        i0.ɵɵtext(26);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelement(27, "cpc-illustration", 19);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("width", ctx.isMobile ? "162px" : "259px")("height", ctx.isMobile ? "40px" : "64px");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.maintenanceText.title, " ");
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.maintenanceText.unavailable, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.maintenanceText.inconvenience, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.maintenanceText.valediction, " ");
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate1(" ", ctx.maintenanceText.contact, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("icon", ctx.ndbxIcons.PhoneO);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.maintenanceText.callCenter, ": ");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.phoneNumber);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.maintenanceText.daysAvailability, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("width", ctx.isMobile ? "231px" : "362px");
    } }, dependencies: [AllianzLogoComponent, IconComponent, IllustrationComponent], styles: ["[_ngcontent-%COMP%]:root{--font-family: Allianz Neo, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\" !important;--cpc-colors-blue: #003583;--cpc-colors-resolution-blue: #006192;--cpc-colors-dark-cerulian: #003781;--cpc-colors-light-teal: #007d8c;--cpc-colors-light-gray: #d9d9d9;--cpc-colors-silver: #c2c2c2;--cpc-colors-cerulean: #007ab3;--cpc-colors-sonic-silver: #767676;--cpc-colors-whisper: #ececec;--cpc-colors-white-smoke: #f5f5f5;--cpc-colors-dark-gray: #999999;--cpc-colors-pixie-green: #c0ddbd;--cpc-colors-light-peach: #eacfc0;--cpc-colors-rose-white: #f9f2ef;--cpc-colors-charcoal: #414141;--cpc-colors-light-blue: #cfe9ee;--cpc-colors-faux-green: #3da556;--cpc-colors-light-blue-2: #f1f9fa;--cpc-colors-dark-blue: #002567;--cpc-colors-whispers: #e6e6e6;--cpc-colors-seashell-pink: #f7c7c3;--cpc-colors-cerise-red: #dc3149;--cpc-colors-forest-green: #1e8927;--cpc-colors-kashmir-blue: #49648c;--cpc-colors-light-yellow: #fff4d8;--cpc-colors-gold-orange: #edcd03;--cpc-colors-dark-yellow: rgba(255, 232, 176, .5);--cpc-colors-white: #fff;--cpc-colors-light-peach-2: var(--cpc-colors-rose-white);--cpc-colors-light-green: var(--cpc-colors-pixie-green);--cpc-colors-banana-mania: #ffe8b0;--cpc-colors-dark-opacity: rgba(0, 0, 0, .3);--cpc-colors-text: var(--cpc-colors-charcoal);--cpc-colors-border: var(--cpc-colors-light-gray);--cpc-colors-hover: var(--cpc-colors-resolution-blue);--cpc-colors-active: var(--cpc-colors-dark-cerulian);--cpc-colors-active-background: var(--cpc-colors-light-blue-2);--cpc-user-profile-photo-size: 32px;--cpc-agent-profile-photo-size: 104px;--cpc-border: solid 1px var(--cpc-colors-border);--cpc-badge-text: var(--cpc-colors-text);--cpc-badge-background: var(--cpc-colors-white);--cpc-badge-success: #e3ebaf;--cpc-badge-warning: #f7caab;--cpc-badge-text-danger: var(--cpc-colors-white);--cpc-badge-danger: var(--cpc-colors-cerise-red);--cpc-badge-important: #fdd25c;--cpc-badge-text-inactive: var(--cpc-colors-dark-gray);--cpc-badge-inactive: var(--cpc-colors-white);--cpc-badge-icon-active: var(--cpc-colors-resolution-blue);--cpc-badge-icon-inactive: var(--cpc-colors-dark-gray);--cpc-card-divide-bar: var(--cpc-colors-light-blue);--cpc-card-background: var(--cpc-colors-light-blue-2);--cpc-card-background-inactive: var(--cpc-colors-white-smoke);--cpc-document-upload-name-weight: 600;--cpc-document-upload-success-icon-color: var(--cpc-colors-forest-green);--cpc-policy-card-border: solid 1px var(--cpc-colors-light-gray);--cpc-policy-card-border-mobile: solid 1px var(--cpc-colors-light-blue);--cpc-policy-card-header-background: var(--cpc-colors-light-blue-2);--cpc-policy-card-header-background-inactive: var(--cpc-colors-white-smoke);--cpc-policy-card-header-title-color-inactive: #999999;--cpc-policy-progress-track: var(--cpc-colors-whisper);--cpc-policy-progress-progress: var(--cpc-colors-cerulean);--cpc-payments-background-danger-panel: rgba(220, 49, 73, .1);--cpc-payments-danger-border: rgba(220, 49, 73, .4);--cpc-spinner-active-color: var(--cpc-colors-cerulean);--cpc-spinner-background-color: var(--cpc-colors-whisper);--icon-background-color: var(--cpc-colors-faux-green);--icon-color-inactive: var(--cpc-colors-light-gray);--button-primary-background-color: var(--cpc-colors-cerulean);--button-primary-border-color: transparent;--button-primary-text-color: var(--cpc-colors-white);--button-primary-hover-background-color: var(--cpc-colors-resolution-blue);--button-primary-hover-border-color: transparent;--button-primary-hover-text-color: var(--cpc-colors-white);--button-primary-active-background-color: var(--cpc-colors-dark-cerulian);--button-primary-active-text-color: var(--cpc-colors-white);--button-primary-active-border-color: transparent;--button-primary-disabled-background-color: rgba(0, 122, 179, .4);--button-primary-disabled-text-color: hsla(0, 0%, 100%, .4);--button-primary-disabled-border-color: transparent;--button-secondary-background-color: transparent;--button-secondary-border-color: var(--cpc-colors-cerulean);--button-secondary-text-color: var(--cpc-colors-resolution-blue);--button-secondary-hover-background-color: var(--cpc-colors-resolution-blue);--button-secondary-hover-border-color: transparent;--button-secondary-hover-text-color: var(--cpc-colors-white);--button-secondary-active-background-color: var(--cpc-colors-dark-cerulian);--button-secondary-active-text-color: var(--cpc-colors-white);--button-secondary-active-border-color: transparent;--button-secondary-disabled-background-color: transparent;--button-secondary-disabled-text-color: rgba(0, 97, 146, .4);--button-secondary-disabled-border-color: rgba(0, 122, 179, .4);--button-tertiary-background-color: transparent;--button-tertiary-border-color: transparent;--button-tertiary-text-color: var(--button-secondary-text-color);--button-tertiary-hover-background-color: var(--cpc-colors-whisper);--button-tertiary-hover-border-color: transparent;--button-tertiary-hover-text-color: var(--button-secondary-text-color);--button-tertiary-active-background-color: var(--cpc-colors-light-gray);--button-tertiary-active-text-color: var(--button-secondary-text-color);--button-tertiary-active-border-color: transparent;--button-tertiary-disabled-background-color: var(--button-secondary-background-color);--button-tertiary-disabled-text-color: var(--button-secondary-disabled-text-color);--button-tertiary-disabled-border-color: transparent;--button-emphasis-background-color: #f86200;--button-emphasis-border-color: transparent;--button-emphasis-text-color: var(--cpc-colors-white);--button-emphasis-hover-background-color: #e15200;--button-emphasis-hover-border-color: transparent;--button-emphasis-hover-text-color: var(--cpc-colors-white);--button-emphasis-active-background-color: #c15500;--button-emphasis-active-text-color: var(--cpc-colors-white);--button-emphasis-active-border-color: transparent;--button-emphasis-disabled-background-color: rgba(248, 98, 0, .4);--button-emphasis-disabled-text-color: hsla(0, 0%, 100%, .4);--button-emphasis-disabled-border-color: transparent;--button-cta-background-color: var(--cpc-colors-faux-green);--button-cta-border-color: transparent;--button-cta-text-color: var(--cpc-colors-white);--button-cta-hover-background-color: #348357;--button-cta-hover-border-color: transparent;--button-cta-hover-text-color: var(--cpc-colors-white);--button-cta-active-background-color: #276442;--button-cta-active-text-color: var(--cpc-colors-white);--button-cta-active-border-color: transparent;--button-cta-disabled-background-color: rgba(61, 165, 86, .4);--button-cta-disabled-text-color: hsla(0, 0%, 100%, .4);--button-cta-disabled-border-color: transparent;--button-primary-danger-background-color: var(--cpc-colors-cerise-red);--button-primary-danger-border-color: transparent;--button-primary-danger-text-color: var(--cpc-colors-white);--button-primary-danger-hover-background-color: #c51322;--button-primary-danger-hover-border-color: transparent;--button-primary-danger-hover-text-color: var(--cpc-colors-white);--button-primary-danger-active-background-color: #b0050c;--button-primary-danger-active-text-color: var(--cpc-colors-white);--button-primary-danger-active-border-color: transparent;--button-primary-danger-disabled-background-color: rgba(220, 49, 73, .4);--button-primary-danger-disabled-text-color: hsla(0, 0%, 100%, .4);--button-primary-danger-disabled-border-color: transparent;--button-secondary-danger-background-color: transparent;--button-secondary-danger-border-color: var(--cpc-colors-cerise-red);--button-secondary-danger-text-color: var(--cpc-colors-cerise-red);--button-secondary-danger-hover-background-color: #c51322;--button-secondary-danger-hover-border-color: transparent;--button-secondary-danger-hover-text-color: var(--cpc-colors-white);--button-secondary-danger-active-background-color: #b0050c;--button-secondary-danger-active-text-color: var(--cpc-colors-white);--button-secondary-danger-active-border-color: transparent;--button-secondary-danger-disabled-background-color: transparent;--button-secondary-danger-disabled-text-color: rgba(220, 49, 73, .4);--button-secondary-danger-disabled-border-color: rgba(220, 49, 73, .4);--button-tertiary-danger-background-color: transparent;--button-tertiary-danger-border-color: transparent;--button-tertiary-danger-text-color: var(--cpc-colors-cerise-red);--button-tertiary-danger-hover-background-color: #ececec;--button-tertiary-danger-hover-border-color: transparent;--button-tertiary-danger-hover-text-color: var(--cpc-colors-cerise-red);--button-tertiary-danger-active-background-color: var(--cpc-colors-light-gray);--button-tertiary-danger-active-text-color: var(--cpc-colors-cerise-red);--button-tertiary-danger-active-border-color: transparent;--button-tertiary-danger-disabled-background-color: transparent;--button-tertiary-danger-disabled-text-color: rgba(220, 49, 73, .4);--button-tertiary-danger-disabled-border-color: transparent;--button-text-transform: uppercase;--button-border-radius: 4px;--button-border-width: 2px;--button-small-height: 32px;--button-small-medium-height: 40px;--button-medium-height: 48px;--button-large-height: 72px;--button-small-icon-size: 16px;--button-small-medium-icon-size: 20px;--button-medium-icon-size: 24px;--button-large-icon-size: 24px;--help-modal-fab-color: var(--cpc-colors-resolution-blue);--help-modal-font-size: 16px;--help-modal-font-weight: 600;--help-modal-line-height: 1.5;--help-modal-letter-spacing: 1px;--help-modal-background-color: var(--cpc-colors-white);--help-modal-box-shadow-color: #e3e6e6;--help-modal-icon-size: 24px;--help-modal-icon-info-size: 40px;--help-modal-icon-info-color: var(--cpc-colors-white);--help-modal-icon-info-background: var(--cpc-colors-cerulean);--help-modal-content-color: var(--cpc-colors-resolution-blue);--help-modal-content-border-color: #d3e3e5;--help-modal-content-list-font-size: 16px;--help-modal-content-selected: 700;--help-modal-content-font-size: 16px;--help-modal-min-width: 280px;--help-modal-max-width: 888px;--help-modal-width:calc(100vw - 32px);--help-modal-max-width-large: 100%;--help-modal-position-bottom: 115px;--help-modal-group-content-max-width: 375px;--paging-input-color: #5b686e;--invesments-row-padding-left: 16px;--error-page-text-color: var(--cpc-colors-charcoal);--error-page-title-weight: 300;--error-page-title-size: 54px;--error-page-subtitle-weight: 400;--error-page-subtitle-size: 24px;--logout-page-text-color: var(--cpc-colors-charcoal);--logout-page-text-font-weight: 500;--logout-page-title-font-size: 26px;--logout-page-title-line-height: 32px;--logout-page-title-letter-spacing: .26px;--logout-page-subtitle-font-size: 16px;--logout-page-subtitle-line-height: 24px;--popup-change-agent-active-background: var(--cpc-colors-light-blue-2);--popup-change-agent-active-border: var(--cpc-colors-cerulean)}.cpc-maintenance-page[_ngcontent-%COMP%]   .cpc-allianz-logo[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center;margin-bottom:40px;padding:0 22px}@media screen and (min-width: 992px){.cpc-maintenance-page[_ngcontent-%COMP%]   .cpc-allianz-logo[_ngcontent-%COMP%]{margin-bottom:56px}}.cpc-maintenance-page_info[_ngcontent-%COMP%]{text-align:center}.cpc-maintenance-page_title[_ngcontent-%COMP%]{margin-bottom:24px;color:var(--cpc-colors-charcoal);font-weight:300;font-size:26px;line-height:32px;letter-spacing:.3px}@media screen and (min-width: 992px){.cpc-maintenance-page_title[_ngcontent-%COMP%]{margin-bottom:39px;font-size:40px;line-height:48px}}.cpc-maintenance-page_description-wrapper[_ngcontent-%COMP%]{max-width:602px;margin:0 auto 40px;color:var(--cpc-colors-charcoal)}@media screen and (min-width: 992px){.cpc-maintenance-page_description-wrapper[_ngcontent-%COMP%]{margin-bottom:0 auto 32px}}.cpc-maintenance-page_description-inconvenience[_ngcontent-%COMP%], .cpc-maintenance-page_description-unavailable[_ngcontent-%COMP%]{margin-bottom:24px;font-size:16px}@media screen and (min-width: 992px){.cpc-maintenance-page_description-inconvenience[_ngcontent-%COMP%], .cpc-maintenance-page_description-unavailable[_ngcontent-%COMP%]{margin-bottom:32px;font-size:20px}}.cpc-maintenance-page_description-valediction[_ngcontent-%COMP%]{font-size:20px}@media screen and (min-width: 992px){.cpc-maintenance-page_description-valediction[_ngcontent-%COMP%]{font-size:24px}}.horizontal-rule[_ngcontent-%COMP%]{width:304px;height:1px;margin:0 auto 34px;background-color:var(--cpc-colors-light-gray)}@media screen and (min-width: 992px){.horizontal-rule[_ngcontent-%COMP%]{margin:0 auto 42px}}.cpc-maintenance-page_contact[_ngcontent-%COMP%]{display:flex;flex-direction:column;justify-content:space-between;max-width:960px;margin:0 auto}@media screen and (min-width: 992px){.cpc-maintenance-page_contact[_ngcontent-%COMP%]{flex-direction:row}}.cpc-maintenance-page_contact-content[_ngcontent-%COMP%]{margin:0 auto 32px}@media screen and (min-width: 992px){.cpc-maintenance-page_contact-content[_ngcontent-%COMP%]{margin-bottom:0}}.cpc-maintenance-page_contact-content-title[_ngcontent-%COMP%]{margin-bottom:33px;color:var(--cpc-colors-charcoal);font-size:20px;line-height:32px;letter-spacing:.2px}@media screen and (min-width: 992px){.cpc-maintenance-page_contact-content-title[_ngcontent-%COMP%]{margin-bottom:50px;font-size:24px}}.cpc-maintenance-page_contact-phone-contact[_ngcontent-%COMP%]{display:flex}.cpc-maintenance-page_phone-icon[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center;width:104px;height:104px;margin-right:29px;color:var(--cpc-colors-resolution-blue);font-size:48px;background-color:var(--cpc-colors-light-blue-2);border-radius:100%}.cpc-maintenance-page_phone-icon[_ngcontent-%COMP%]   .cpc-icon[_ngcontent-%COMP%]{display:flex}.cpc-maintenance-page_phone-number-wrapper[_ngcontent-%COMP%]{margin-bottom:4px;color:var(--cpc-colors-resolution-blue);font-size:20px;line-height:32px;letter-spacing:.3px}@media screen and (min-width: 992px){.cpc-maintenance-page_phone-number-wrapper[_ngcontent-%COMP%]{margin-top:15px;margin-bottom:16px;font-size:26px}}.cpc-maintenance-page_phone-number[_ngcontent-%COMP%]{display:inline-block;font-weight:700}@media screen and (min-width: 992px){.cpc-maintenance-page_phone-number[_ngcontent-%COMP%]{display:inline}}.cpc-maintenance-page_days-availability[_ngcontent-%COMP%]{color:var(--cpc-colors-charcoal);font-size:14px;line-height:16px}@media screen and (min-width: 992px){.cpc-maintenance-page_days-availability[_ngcontent-%COMP%]{font-size:18px}}.cpc-maintenance-page[_ngcontent-%COMP%]   .cpc-illustration[_ngcontent-%COMP%]{margin:0 auto}@media screen and (min-width: 992px){.cpc-maintenance-page[_ngcontent-%COMP%]   .cpc-illustration[_ngcontent-%COMP%]{margin:unset}}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MaintenancePageComponent, [{
        type: Component,
        args: [{ selector: 'cpc-maintenance-page', template: "<div class=\"cpc-maintenance-page\">\r\n  <div class=\"cpc-maintenance-page_wrapper\">\r\n    <div class=\"cpc-maintenance-page_info\">\r\n      <cpc-allianz-logo\r\n        [width]=\"isMobile ? '162px' : '259px'\"\r\n        [height]=\"isMobile ? '40px' : '64px'\"\r\n        class=\"cpc-allianz-logo\"\r\n      ></cpc-allianz-logo>\r\n      <div class=\"cpc-maintenance-page_title\">\r\n        {{ maintenanceText.title }}\r\n      </div>\r\n      <div class=\"cpc-maintenance-page_description-wrapper\">\r\n        <div class=\"cpc-maintenance-page_description-unavailable\">\r\n          {{ maintenanceText.unavailable }}\r\n        </div>\r\n        <div class=\"cpc-maintenance-page_description-inconvenience\">\r\n          {{ maintenanceText.inconvenience }}\r\n        </div>\r\n        <div class=\"cpc-maintenance-page_description-valediction\">\r\n          {{ maintenanceText.valediction }}\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"horizontal-rule\"></div>\r\n    <div class=\"cpc-maintenance-page_contact\">\r\n      <div class=\"cpc-maintenance-page_contact-content\">\r\n        <div class=\"cpc-maintenance-page_contact-content-title\">\r\n          {{ maintenanceText.contact }}\r\n        </div>\r\n        <div class=\"cpc-maintenance-page_contact-phone-contact\">\r\n          <cpc-icon\r\n            [icon]=\"ndbxIcons.PhoneO\"\r\n            class=\"cpc-maintenance-page_phone-icon\"\r\n          ></cpc-icon>\r\n          <div class=\"cpc-maintenance-page_phone-contact-content\">\r\n            <div class=\"cpc-maintenance-page_phone-number-wrapper\">\r\n              {{ maintenanceText.callCenter }}:\r\n              <span class=\"cpc-maintenance-page_phone-number\">{{ phoneNumber }}</span>\r\n            </div>\r\n            <div class=\"cpc-maintenance-page_days-availability\">\r\n              {{ maintenanceText.daysAvailability }}\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <cpc-illustration\r\n        [width]=\"isMobile ? '231px' : '362px'\"\r\n        name=\"womanWithLaptopTalkingOnThePhone\"\r\n        class=\"cpc-illustration\"\r\n      ></cpc-illustration>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [":root{--font-family: Allianz Neo, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\" !important;--cpc-colors-blue: #003583;--cpc-colors-resolution-blue: #006192;--cpc-colors-dark-cerulian: #003781;--cpc-colors-light-teal: #007d8c;--cpc-colors-light-gray: #d9d9d9;--cpc-colors-silver: #c2c2c2;--cpc-colors-cerulean: #007ab3;--cpc-colors-sonic-silver: #767676;--cpc-colors-whisper: #ececec;--cpc-colors-white-smoke: #f5f5f5;--cpc-colors-dark-gray: #999999;--cpc-colors-pixie-green: #c0ddbd;--cpc-colors-light-peach: #eacfc0;--cpc-colors-rose-white: #f9f2ef;--cpc-colors-charcoal: #414141;--cpc-colors-light-blue: #cfe9ee;--cpc-colors-faux-green: #3da556;--cpc-colors-light-blue-2: #f1f9fa;--cpc-colors-dark-blue: #002567;--cpc-colors-whispers: #e6e6e6;--cpc-colors-seashell-pink: #f7c7c3;--cpc-colors-cerise-red: #dc3149;--cpc-colors-forest-green: #1e8927;--cpc-colors-kashmir-blue: #49648c;--cpc-colors-light-yellow: #fff4d8;--cpc-colors-gold-orange: #edcd03;--cpc-colors-dark-yellow: rgba(255, 232, 176, .5);--cpc-colors-white: #fff;--cpc-colors-light-peach-2: var(--cpc-colors-rose-white);--cpc-colors-light-green: var(--cpc-colors-pixie-green);--cpc-colors-banana-mania: #ffe8b0;--cpc-colors-dark-opacity: rgba(0, 0, 0, .3);--cpc-colors-text: var(--cpc-colors-charcoal);--cpc-colors-border: var(--cpc-colors-light-gray);--cpc-colors-hover: var(--cpc-colors-resolution-blue);--cpc-colors-active: var(--cpc-colors-dark-cerulian);--cpc-colors-active-background: var(--cpc-colors-light-blue-2);--cpc-user-profile-photo-size: 32px;--cpc-agent-profile-photo-size: 104px;--cpc-border: solid 1px var(--cpc-colors-border);--cpc-badge-text: var(--cpc-colors-text);--cpc-badge-background: var(--cpc-colors-white);--cpc-badge-success: #e3ebaf;--cpc-badge-warning: #f7caab;--cpc-badge-text-danger: var(--cpc-colors-white);--cpc-badge-danger: var(--cpc-colors-cerise-red);--cpc-badge-important: #fdd25c;--cpc-badge-text-inactive: var(--cpc-colors-dark-gray);--cpc-badge-inactive: var(--cpc-colors-white);--cpc-badge-icon-active: var(--cpc-colors-resolution-blue);--cpc-badge-icon-inactive: var(--cpc-colors-dark-gray);--cpc-card-divide-bar: var(--cpc-colors-light-blue);--cpc-card-background: var(--cpc-colors-light-blue-2);--cpc-card-background-inactive: var(--cpc-colors-white-smoke);--cpc-document-upload-name-weight: 600;--cpc-document-upload-success-icon-color: var(--cpc-colors-forest-green);--cpc-policy-card-border: solid 1px var(--cpc-colors-light-gray);--cpc-policy-card-border-mobile: solid 1px var(--cpc-colors-light-blue);--cpc-policy-card-header-background: var(--cpc-colors-light-blue-2);--cpc-policy-card-header-background-inactive: var(--cpc-colors-white-smoke);--cpc-policy-card-header-title-color-inactive: #999999;--cpc-policy-progress-track: var(--cpc-colors-whisper);--cpc-policy-progress-progress: var(--cpc-colors-cerulean);--cpc-payments-background-danger-panel: rgba(220, 49, 73, .1);--cpc-payments-danger-border: rgba(220, 49, 73, .4);--cpc-spinner-active-color: var(--cpc-colors-cerulean);--cpc-spinner-background-color: var(--cpc-colors-whisper);--icon-background-color: var(--cpc-colors-faux-green);--icon-color-inactive: var(--cpc-colors-light-gray);--button-primary-background-color: var(--cpc-colors-cerulean);--button-primary-border-color: transparent;--button-primary-text-color: var(--cpc-colors-white);--button-primary-hover-background-color: var(--cpc-colors-resolution-blue);--button-primary-hover-border-color: transparent;--button-primary-hover-text-color: var(--cpc-colors-white);--button-primary-active-background-color: var(--cpc-colors-dark-cerulian);--button-primary-active-text-color: var(--cpc-colors-white);--button-primary-active-border-color: transparent;--button-primary-disabled-background-color: rgba(0, 122, 179, .4);--button-primary-disabled-text-color: hsla(0, 0%, 100%, .4);--button-primary-disabled-border-color: transparent;--button-secondary-background-color: transparent;--button-secondary-border-color: var(--cpc-colors-cerulean);--button-secondary-text-color: var(--cpc-colors-resolution-blue);--button-secondary-hover-background-color: var(--cpc-colors-resolution-blue);--button-secondary-hover-border-color: transparent;--button-secondary-hover-text-color: var(--cpc-colors-white);--button-secondary-active-background-color: var(--cpc-colors-dark-cerulian);--button-secondary-active-text-color: var(--cpc-colors-white);--button-secondary-active-border-color: transparent;--button-secondary-disabled-background-color: transparent;--button-secondary-disabled-text-color: rgba(0, 97, 146, .4);--button-secondary-disabled-border-color: rgba(0, 122, 179, .4);--button-tertiary-background-color: transparent;--button-tertiary-border-color: transparent;--button-tertiary-text-color: var(--button-secondary-text-color);--button-tertiary-hover-background-color: var(--cpc-colors-whisper);--button-tertiary-hover-border-color: transparent;--button-tertiary-hover-text-color: var(--button-secondary-text-color);--button-tertiary-active-background-color: var(--cpc-colors-light-gray);--button-tertiary-active-text-color: var(--button-secondary-text-color);--button-tertiary-active-border-color: transparent;--button-tertiary-disabled-background-color: var(--button-secondary-background-color);--button-tertiary-disabled-text-color: var(--button-secondary-disabled-text-color);--button-tertiary-disabled-border-color: transparent;--button-emphasis-background-color: #f86200;--button-emphasis-border-color: transparent;--button-emphasis-text-color: var(--cpc-colors-white);--button-emphasis-hover-background-color: #e15200;--button-emphasis-hover-border-color: transparent;--button-emphasis-hover-text-color: var(--cpc-colors-white);--button-emphasis-active-background-color: #c15500;--button-emphasis-active-text-color: var(--cpc-colors-white);--button-emphasis-active-border-color: transparent;--button-emphasis-disabled-background-color: rgba(248, 98, 0, .4);--button-emphasis-disabled-text-color: hsla(0, 0%, 100%, .4);--button-emphasis-disabled-border-color: transparent;--button-cta-background-color: var(--cpc-colors-faux-green);--button-cta-border-color: transparent;--button-cta-text-color: var(--cpc-colors-white);--button-cta-hover-background-color: #348357;--button-cta-hover-border-color: transparent;--button-cta-hover-text-color: var(--cpc-colors-white);--button-cta-active-background-color: #276442;--button-cta-active-text-color: var(--cpc-colors-white);--button-cta-active-border-color: transparent;--button-cta-disabled-background-color: rgba(61, 165, 86, .4);--button-cta-disabled-text-color: hsla(0, 0%, 100%, .4);--button-cta-disabled-border-color: transparent;--button-primary-danger-background-color: var(--cpc-colors-cerise-red);--button-primary-danger-border-color: transparent;--button-primary-danger-text-color: var(--cpc-colors-white);--button-primary-danger-hover-background-color: #c51322;--button-primary-danger-hover-border-color: transparent;--button-primary-danger-hover-text-color: var(--cpc-colors-white);--button-primary-danger-active-background-color: #b0050c;--button-primary-danger-active-text-color: var(--cpc-colors-white);--button-primary-danger-active-border-color: transparent;--button-primary-danger-disabled-background-color: rgba(220, 49, 73, .4);--button-primary-danger-disabled-text-color: hsla(0, 0%, 100%, .4);--button-primary-danger-disabled-border-color: transparent;--button-secondary-danger-background-color: transparent;--button-secondary-danger-border-color: var(--cpc-colors-cerise-red);--button-secondary-danger-text-color: var(--cpc-colors-cerise-red);--button-secondary-danger-hover-background-color: #c51322;--button-secondary-danger-hover-border-color: transparent;--button-secondary-danger-hover-text-color: var(--cpc-colors-white);--button-secondary-danger-active-background-color: #b0050c;--button-secondary-danger-active-text-color: var(--cpc-colors-white);--button-secondary-danger-active-border-color: transparent;--button-secondary-danger-disabled-background-color: transparent;--button-secondary-danger-disabled-text-color: rgba(220, 49, 73, .4);--button-secondary-danger-disabled-border-color: rgba(220, 49, 73, .4);--button-tertiary-danger-background-color: transparent;--button-tertiary-danger-border-color: transparent;--button-tertiary-danger-text-color: var(--cpc-colors-cerise-red);--button-tertiary-danger-hover-background-color: #ececec;--button-tertiary-danger-hover-border-color: transparent;--button-tertiary-danger-hover-text-color: var(--cpc-colors-cerise-red);--button-tertiary-danger-active-background-color: var(--cpc-colors-light-gray);--button-tertiary-danger-active-text-color: var(--cpc-colors-cerise-red);--button-tertiary-danger-active-border-color: transparent;--button-tertiary-danger-disabled-background-color: transparent;--button-tertiary-danger-disabled-text-color: rgba(220, 49, 73, .4);--button-tertiary-danger-disabled-border-color: transparent;--button-text-transform: uppercase;--button-border-radius: 4px;--button-border-width: 2px;--button-small-height: 32px;--button-small-medium-height: 40px;--button-medium-height: 48px;--button-large-height: 72px;--button-small-icon-size: 16px;--button-small-medium-icon-size: 20px;--button-medium-icon-size: 24px;--button-large-icon-size: 24px;--help-modal-fab-color: var(--cpc-colors-resolution-blue);--help-modal-font-size: 16px;--help-modal-font-weight: 600;--help-modal-line-height: 1.5;--help-modal-letter-spacing: 1px;--help-modal-background-color: var(--cpc-colors-white);--help-modal-box-shadow-color: #e3e6e6;--help-modal-icon-size: 24px;--help-modal-icon-info-size: 40px;--help-modal-icon-info-color: var(--cpc-colors-white);--help-modal-icon-info-background: var(--cpc-colors-cerulean);--help-modal-content-color: var(--cpc-colors-resolution-blue);--help-modal-content-border-color: #d3e3e5;--help-modal-content-list-font-size: 16px;--help-modal-content-selected: 700;--help-modal-content-font-size: 16px;--help-modal-min-width: 280px;--help-modal-max-width: 888px;--help-modal-width:calc(100vw - 32px);--help-modal-max-width-large: 100%;--help-modal-position-bottom: 115px;--help-modal-group-content-max-width: 375px;--paging-input-color: #5b686e;--invesments-row-padding-left: 16px;--error-page-text-color: var(--cpc-colors-charcoal);--error-page-title-weight: 300;--error-page-title-size: 54px;--error-page-subtitle-weight: 400;--error-page-subtitle-size: 24px;--logout-page-text-color: var(--cpc-colors-charcoal);--logout-page-text-font-weight: 500;--logout-page-title-font-size: 26px;--logout-page-title-line-height: 32px;--logout-page-title-letter-spacing: .26px;--logout-page-subtitle-font-size: 16px;--logout-page-subtitle-line-height: 24px;--popup-change-agent-active-background: var(--cpc-colors-light-blue-2);--popup-change-agent-active-border: var(--cpc-colors-cerulean)}.cpc-maintenance-page .cpc-allianz-logo{display:flex;align-items:center;justify-content:center;margin-bottom:40px;padding:0 22px}@media screen and (min-width: 992px){.cpc-maintenance-page .cpc-allianz-logo{margin-bottom:56px}}.cpc-maintenance-page_info{text-align:center}.cpc-maintenance-page_title{margin-bottom:24px;color:var(--cpc-colors-charcoal);font-weight:300;font-size:26px;line-height:32px;letter-spacing:.3px}@media screen and (min-width: 992px){.cpc-maintenance-page_title{margin-bottom:39px;font-size:40px;line-height:48px}}.cpc-maintenance-page_description-wrapper{max-width:602px;margin:0 auto 40px;color:var(--cpc-colors-charcoal)}@media screen and (min-width: 992px){.cpc-maintenance-page_description-wrapper{margin-bottom:0 auto 32px}}.cpc-maintenance-page_description-inconvenience,.cpc-maintenance-page_description-unavailable{margin-bottom:24px;font-size:16px}@media screen and (min-width: 992px){.cpc-maintenance-page_description-inconvenience,.cpc-maintenance-page_description-unavailable{margin-bottom:32px;font-size:20px}}.cpc-maintenance-page_description-valediction{font-size:20px}@media screen and (min-width: 992px){.cpc-maintenance-page_description-valediction{font-size:24px}}.horizontal-rule{width:304px;height:1px;margin:0 auto 34px;background-color:var(--cpc-colors-light-gray)}@media screen and (min-width: 992px){.horizontal-rule{margin:0 auto 42px}}.cpc-maintenance-page_contact{display:flex;flex-direction:column;justify-content:space-between;max-width:960px;margin:0 auto}@media screen and (min-width: 992px){.cpc-maintenance-page_contact{flex-direction:row}}.cpc-maintenance-page_contact-content{margin:0 auto 32px}@media screen and (min-width: 992px){.cpc-maintenance-page_contact-content{margin-bottom:0}}.cpc-maintenance-page_contact-content-title{margin-bottom:33px;color:var(--cpc-colors-charcoal);font-size:20px;line-height:32px;letter-spacing:.2px}@media screen and (min-width: 992px){.cpc-maintenance-page_contact-content-title{margin-bottom:50px;font-size:24px}}.cpc-maintenance-page_contact-phone-contact{display:flex}.cpc-maintenance-page_phone-icon{display:flex;align-items:center;justify-content:center;width:104px;height:104px;margin-right:29px;color:var(--cpc-colors-resolution-blue);font-size:48px;background-color:var(--cpc-colors-light-blue-2);border-radius:100%}.cpc-maintenance-page_phone-icon .cpc-icon{display:flex}.cpc-maintenance-page_phone-number-wrapper{margin-bottom:4px;color:var(--cpc-colors-resolution-blue);font-size:20px;line-height:32px;letter-spacing:.3px}@media screen and (min-width: 992px){.cpc-maintenance-page_phone-number-wrapper{margin-top:15px;margin-bottom:16px;font-size:26px}}.cpc-maintenance-page_phone-number{display:inline-block;font-weight:700}@media screen and (min-width: 992px){.cpc-maintenance-page_phone-number{display:inline}}.cpc-maintenance-page_days-availability{color:var(--cpc-colors-charcoal);font-size:14px;line-height:16px}@media screen and (min-width: 992px){.cpc-maintenance-page_days-availability{font-size:18px}}.cpc-maintenance-page .cpc-illustration{margin:0 auto}@media screen and (min-width: 992px){.cpc-maintenance-page .cpc-illustration{margin:unset}}\n"] }]
    }], null, { phoneNumber: [{
            type: Input
        }], maintenanceText: [{
            type: Input
        }], onResize: [{
            type: HostListener,
            args: ['window:resize', ['$event']]
        }] }); })();

function PreferredAgentComponent_ng_container_0_cpc_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cpc-button", 17);
    i0.ɵɵlistener("click", function PreferredAgentComponent_ng_container_0_cpc_button_2_Template_cpc_button_click_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.handleClick()); });
    i0.ɵɵelement(1, "cpc-icon", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("mode", "tertiary")("noHorizontalMargin", true)("noVerticalMargin", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("icon", ctx_r1.ndbxIcons.Close)("color", "var(--cpc-colors-sonic-silver)");
} }
function PreferredAgentComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 1);
    i0.ɵɵtemplate(2, PreferredAgentComponent_ng_container_0_cpc_button_2_Template, 2, 5, "cpc-button", 2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p", 3);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 4)(6, "div", 5)(7, "div", 6);
    i0.ɵɵelement(8, "img", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "p", 8);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(11, "div", 9)(12, "p", 6);
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "span", 10);
    i0.ɵɵtext(15);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(16, "div", 9)(17, "p", 6);
    i0.ɵɵtext(18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "span", 11);
    i0.ɵɵtext(20);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(21, "div", 9)(22, "p", 6);
    i0.ɵɵtext(23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "span", 12);
    i0.ɵɵtext(25);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(26, "cpc-button", 13);
    i0.ɵɵlistener("click", function PreferredAgentComponent_ng_container_0_Template_cpc_button_click_26_listener() { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.setAgent(ctx_r4.prefferedAgent)); });
    i0.ɵɵtext(27);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(28, "button", 14);
    i0.ɵɵlistener("click", function PreferredAgentComponent_ng_container_0_Template_button_click_28_listener() { i0.ɵɵrestoreView(_r5); const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.handleAgent()); });
    i0.ɵɵelement(29, "cpc-icon", 15);
    i0.ɵɵelementStart(30, "span", 16);
    i0.ɵɵtext(31);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.showCloseButton);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.title, " ");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("src", ctx_r0.prefferedAgent.avatar, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.prefferedAgent.name);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.agentDetailsText.phoneNumber, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.prefferedAgent.phoneNumber, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.agentDetailsText.email, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.prefferedAgent.addressEmail, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.agentDetailsText.website, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.prefferedAgent.website, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("noHorizontalMargin", true);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.setButtonText, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("icon", ctx_r0.ndbxIcons.Edit);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.editButtonText, " ");
} }
class PreferredAgentComponent {
    constructor() {
        this.title = 'Preferred servicing agent';
        this.isVisiblePopup = false;
        this.showCloseButton = true;
        this.selectedAgent = new EventEmitter();
        this.editAgent = new EventEmitter();
        this.isVisiblePopupChange = new EventEmitter();
        this.ndbxIcons = NdbxIcon;
    }
    handleAgent() {
        this.editAgent.emit();
    }
    setAgent(agent) {
        this.selectedAgent.emit(agent);
    }
    handleClick() {
        this.isVisiblePopup = false;
        this.isVisiblePopupChange.emit(this.isVisiblePopup);
    }
}
PreferredAgentComponent.ɵfac = function PreferredAgentComponent_Factory(t) { return new (t || PreferredAgentComponent)(); };
PreferredAgentComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PreferredAgentComponent, selectors: [["cpc-preferred-agent"]], inputs: { title: "title", isVisiblePopup: "isVisiblePopup", prefferedAgent: "prefferedAgent", agentDetailsText: "agentDetailsText", setButtonText: "setButtonText", editButtonText: "editButtonText", showCloseButton: "showCloseButton" }, outputs: { selectedAgent: "selectedAgent", editAgent: "editAgent", isVisiblePopupChange: "isVisiblePopupChange" }, decls: 1, vars: 1, consts: [[4, "ngIf"], [1, "cpc-preferred-agent_exit-wrapper"], ["size", "small", "class", "cpc-preferred-agent_exit", 3, "mode", "noHorizontalMargin", "noVerticalMargin", "click", 4, "ngIf"], [2, "text-align", "center", "font-size", "26px", "line-height", "36px", "letter-spacing", "0.3px", "color", "#414141", "margin", "0 0 30px 0"], [1, "cpc-preferred-agent_content"], [1, "cpc-preferred-agent_info", "cpc-preferred-agent_info-align-center"], [1, "cpc-preferred-agent_info-width"], ["alt", "agent", 1, "cpc-preferred-agent_avatar", 3, "src"], [1, "cpc-preferred-agent_info-name"], [1, "cpc-preferred-agent_info"], [1, "cpc-preferred-agent_info-number"], [1, "cpc-preferred-agent_info-email"], [1, "cpc-preferred-agent_info-website"], ["mode", "primary", 1, "popup_agent-button-submit", 3, "noHorizontalMargin", "click"], [1, "cpc-preferred-agent_edit-button", "cpc-preferred-agent_button-focus", 3, "click"], [3, "icon"], [1, "cpc-preferred-agent_edit-button-text"], ["size", "small", 1, "cpc-preferred-agent_exit", 3, "mode", "noHorizontalMargin", "noVerticalMargin", "click"], [3, "icon", "color"]], template: function PreferredAgentComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PreferredAgentComponent_ng_container_0_Template, 32, 14, "ng-container", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.isVisiblePopup);
    } }, dependencies: [i1.NgIf, ButtonComponent, IconComponent], styles: ["[_ngcontent-%COMP%]:root{--font-family: Allianz Neo, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\" !important;--cpc-colors-blue: #003583;--cpc-colors-resolution-blue: #006192;--cpc-colors-dark-cerulian: #003781;--cpc-colors-light-teal: #007d8c;--cpc-colors-light-gray: #d9d9d9;--cpc-colors-silver: #c2c2c2;--cpc-colors-cerulean: #007ab3;--cpc-colors-sonic-silver: #767676;--cpc-colors-whisper: #ececec;--cpc-colors-white-smoke: #f5f5f5;--cpc-colors-dark-gray: #999999;--cpc-colors-pixie-green: #c0ddbd;--cpc-colors-light-peach: #eacfc0;--cpc-colors-rose-white: #f9f2ef;--cpc-colors-charcoal: #414141;--cpc-colors-light-blue: #cfe9ee;--cpc-colors-faux-green: #3da556;--cpc-colors-light-blue-2: #f1f9fa;--cpc-colors-dark-blue: #002567;--cpc-colors-whispers: #e6e6e6;--cpc-colors-seashell-pink: #f7c7c3;--cpc-colors-cerise-red: #dc3149;--cpc-colors-forest-green: #1e8927;--cpc-colors-kashmir-blue: #49648c;--cpc-colors-light-yellow: #fff4d8;--cpc-colors-gold-orange: #edcd03;--cpc-colors-dark-yellow: rgba(255, 232, 176, .5);--cpc-colors-white: #fff;--cpc-colors-light-peach-2: var(--cpc-colors-rose-white);--cpc-colors-light-green: var(--cpc-colors-pixie-green);--cpc-colors-banana-mania: #ffe8b0;--cpc-colors-dark-opacity: rgba(0, 0, 0, .3);--cpc-colors-text: var(--cpc-colors-charcoal);--cpc-colors-border: var(--cpc-colors-light-gray);--cpc-colors-hover: var(--cpc-colors-resolution-blue);--cpc-colors-active: var(--cpc-colors-dark-cerulian);--cpc-colors-active-background: var(--cpc-colors-light-blue-2);--cpc-user-profile-photo-size: 32px;--cpc-agent-profile-photo-size: 104px;--cpc-border: solid 1px var(--cpc-colors-border);--cpc-badge-text: var(--cpc-colors-text);--cpc-badge-background: var(--cpc-colors-white);--cpc-badge-success: #e3ebaf;--cpc-badge-warning: #f7caab;--cpc-badge-text-danger: var(--cpc-colors-white);--cpc-badge-danger: var(--cpc-colors-cerise-red);--cpc-badge-important: #fdd25c;--cpc-badge-text-inactive: var(--cpc-colors-dark-gray);--cpc-badge-inactive: var(--cpc-colors-white);--cpc-badge-icon-active: var(--cpc-colors-resolution-blue);--cpc-badge-icon-inactive: var(--cpc-colors-dark-gray);--cpc-card-divide-bar: var(--cpc-colors-light-blue);--cpc-card-background: var(--cpc-colors-light-blue-2);--cpc-card-background-inactive: var(--cpc-colors-white-smoke);--cpc-document-upload-name-weight: 600;--cpc-document-upload-success-icon-color: var(--cpc-colors-forest-green);--cpc-policy-card-border: solid 1px var(--cpc-colors-light-gray);--cpc-policy-card-border-mobile: solid 1px var(--cpc-colors-light-blue);--cpc-policy-card-header-background: var(--cpc-colors-light-blue-2);--cpc-policy-card-header-background-inactive: var(--cpc-colors-white-smoke);--cpc-policy-card-header-title-color-inactive: #999999;--cpc-policy-progress-track: var(--cpc-colors-whisper);--cpc-policy-progress-progress: var(--cpc-colors-cerulean);--cpc-payments-background-danger-panel: rgba(220, 49, 73, .1);--cpc-payments-danger-border: rgba(220, 49, 73, .4);--cpc-spinner-active-color: var(--cpc-colors-cerulean);--cpc-spinner-background-color: var(--cpc-colors-whisper);--icon-background-color: var(--cpc-colors-faux-green);--icon-color-inactive: var(--cpc-colors-light-gray);--button-primary-background-color: var(--cpc-colors-cerulean);--button-primary-border-color: transparent;--button-primary-text-color: var(--cpc-colors-white);--button-primary-hover-background-color: var(--cpc-colors-resolution-blue);--button-primary-hover-border-color: transparent;--button-primary-hover-text-color: var(--cpc-colors-white);--button-primary-active-background-color: var(--cpc-colors-dark-cerulian);--button-primary-active-text-color: var(--cpc-colors-white);--button-primary-active-border-color: transparent;--button-primary-disabled-background-color: rgba(0, 122, 179, .4);--button-primary-disabled-text-color: hsla(0, 0%, 100%, .4);--button-primary-disabled-border-color: transparent;--button-secondary-background-color: transparent;--button-secondary-border-color: var(--cpc-colors-cerulean);--button-secondary-text-color: var(--cpc-colors-resolution-blue);--button-secondary-hover-background-color: var(--cpc-colors-resolution-blue);--button-secondary-hover-border-color: transparent;--button-secondary-hover-text-color: var(--cpc-colors-white);--button-secondary-active-background-color: var(--cpc-colors-dark-cerulian);--button-secondary-active-text-color: var(--cpc-colors-white);--button-secondary-active-border-color: transparent;--button-secondary-disabled-background-color: transparent;--button-secondary-disabled-text-color: rgba(0, 97, 146, .4);--button-secondary-disabled-border-color: rgba(0, 122, 179, .4);--button-tertiary-background-color: transparent;--button-tertiary-border-color: transparent;--button-tertiary-text-color: var(--button-secondary-text-color);--button-tertiary-hover-background-color: var(--cpc-colors-whisper);--button-tertiary-hover-border-color: transparent;--button-tertiary-hover-text-color: var(--button-secondary-text-color);--button-tertiary-active-background-color: var(--cpc-colors-light-gray);--button-tertiary-active-text-color: var(--button-secondary-text-color);--button-tertiary-active-border-color: transparent;--button-tertiary-disabled-background-color: var(--button-secondary-background-color);--button-tertiary-disabled-text-color: var(--button-secondary-disabled-text-color);--button-tertiary-disabled-border-color: transparent;--button-emphasis-background-color: #f86200;--button-emphasis-border-color: transparent;--button-emphasis-text-color: var(--cpc-colors-white);--button-emphasis-hover-background-color: #e15200;--button-emphasis-hover-border-color: transparent;--button-emphasis-hover-text-color: var(--cpc-colors-white);--button-emphasis-active-background-color: #c15500;--button-emphasis-active-text-color: var(--cpc-colors-white);--button-emphasis-active-border-color: transparent;--button-emphasis-disabled-background-color: rgba(248, 98, 0, .4);--button-emphasis-disabled-text-color: hsla(0, 0%, 100%, .4);--button-emphasis-disabled-border-color: transparent;--button-cta-background-color: var(--cpc-colors-faux-green);--button-cta-border-color: transparent;--button-cta-text-color: var(--cpc-colors-white);--button-cta-hover-background-color: #348357;--button-cta-hover-border-color: transparent;--button-cta-hover-text-color: var(--cpc-colors-white);--button-cta-active-background-color: #276442;--button-cta-active-text-color: var(--cpc-colors-white);--button-cta-active-border-color: transparent;--button-cta-disabled-background-color: rgba(61, 165, 86, .4);--button-cta-disabled-text-color: hsla(0, 0%, 100%, .4);--button-cta-disabled-border-color: transparent;--button-primary-danger-background-color: var(--cpc-colors-cerise-red);--button-primary-danger-border-color: transparent;--button-primary-danger-text-color: var(--cpc-colors-white);--button-primary-danger-hover-background-color: #c51322;--button-primary-danger-hover-border-color: transparent;--button-primary-danger-hover-text-color: var(--cpc-colors-white);--button-primary-danger-active-background-color: #b0050c;--button-primary-danger-active-text-color: var(--cpc-colors-white);--button-primary-danger-active-border-color: transparent;--button-primary-danger-disabled-background-color: rgba(220, 49, 73, .4);--button-primary-danger-disabled-text-color: hsla(0, 0%, 100%, .4);--button-primary-danger-disabled-border-color: transparent;--button-secondary-danger-background-color: transparent;--button-secondary-danger-border-color: var(--cpc-colors-cerise-red);--button-secondary-danger-text-color: var(--cpc-colors-cerise-red);--button-secondary-danger-hover-background-color: #c51322;--button-secondary-danger-hover-border-color: transparent;--button-secondary-danger-hover-text-color: var(--cpc-colors-white);--button-secondary-danger-active-background-color: #b0050c;--button-secondary-danger-active-text-color: var(--cpc-colors-white);--button-secondary-danger-active-border-color: transparent;--button-secondary-danger-disabled-background-color: transparent;--button-secondary-danger-disabled-text-color: rgba(220, 49, 73, .4);--button-secondary-danger-disabled-border-color: rgba(220, 49, 73, .4);--button-tertiary-danger-background-color: transparent;--button-tertiary-danger-border-color: transparent;--button-tertiary-danger-text-color: var(--cpc-colors-cerise-red);--button-tertiary-danger-hover-background-color: #ececec;--button-tertiary-danger-hover-border-color: transparent;--button-tertiary-danger-hover-text-color: var(--cpc-colors-cerise-red);--button-tertiary-danger-active-background-color: var(--cpc-colors-light-gray);--button-tertiary-danger-active-text-color: var(--cpc-colors-cerise-red);--button-tertiary-danger-active-border-color: transparent;--button-tertiary-danger-disabled-background-color: transparent;--button-tertiary-danger-disabled-text-color: rgba(220, 49, 73, .4);--button-tertiary-danger-disabled-border-color: transparent;--button-text-transform: uppercase;--button-border-radius: 4px;--button-border-width: 2px;--button-small-height: 32px;--button-small-medium-height: 40px;--button-medium-height: 48px;--button-large-height: 72px;--button-small-icon-size: 16px;--button-small-medium-icon-size: 20px;--button-medium-icon-size: 24px;--button-large-icon-size: 24px;--help-modal-fab-color: var(--cpc-colors-resolution-blue);--help-modal-font-size: 16px;--help-modal-font-weight: 600;--help-modal-line-height: 1.5;--help-modal-letter-spacing: 1px;--help-modal-background-color: var(--cpc-colors-white);--help-modal-box-shadow-color: #e3e6e6;--help-modal-icon-size: 24px;--help-modal-icon-info-size: 40px;--help-modal-icon-info-color: var(--cpc-colors-white);--help-modal-icon-info-background: var(--cpc-colors-cerulean);--help-modal-content-color: var(--cpc-colors-resolution-blue);--help-modal-content-border-color: #d3e3e5;--help-modal-content-list-font-size: 16px;--help-modal-content-selected: 700;--help-modal-content-font-size: 16px;--help-modal-min-width: 280px;--help-modal-max-width: 888px;--help-modal-width:calc(100vw - 32px);--help-modal-max-width-large: 100%;--help-modal-position-bottom: 115px;--help-modal-group-content-max-width: 375px;--paging-input-color: #5b686e;--invesments-row-padding-left: 16px;--error-page-text-color: var(--cpc-colors-charcoal);--error-page-title-weight: 300;--error-page-title-size: 54px;--error-page-subtitle-weight: 400;--error-page-subtitle-size: 24px;--logout-page-text-color: var(--cpc-colors-charcoal);--logout-page-text-font-weight: 500;--logout-page-title-font-size: 26px;--logout-page-title-line-height: 32px;--logout-page-title-letter-spacing: .26px;--logout-page-subtitle-font-size: 16px;--logout-page-subtitle-line-height: 24px;--popup-change-agent-active-background: var(--cpc-colors-light-blue-2);--popup-change-agent-active-border: var(--cpc-colors-cerulean)}.cpc-preferred-agent_exit-wrapper[_ngcontent-%COMP%]{display:flex;justify-content:end;min-height:43.64px}.cpc-preferred-agent_exit[_ngcontent-%COMP%]{font-size:24px;background:transparent;border:none;border-radius:4px;cursor:pointer;transition:all 125ms linear;-webkit-appearance:none;appearance:none}.cpc-preferred-agent_button-focus[_ngcontent-%COMP%]{background:transparent;border-radius:0;-webkit-appearance:none;appearance:none;transition:all 125ms linear;padding:0;background-color:transparent;border:none;cursor:pointer}.cpc-preferred-agent_button-focus[_ngcontent-%COMP%]:focus, .cpc-preferred-agent_button-focus.pseudo-states--focus[_ngcontent-%COMP%]{outline:0;box-shadow:var(--focus-box-shadow, 0 0 0 2px #fff, 0 0 0 6px #009de6)}.cpc-preferred-agent_content[_ngcontent-%COMP%]{display:flex;flex-direction:column;max-width:320px;margin:0 auto 20px;text-align:left}@media screen and (min-width: 704px){.cpc-preferred-agent_content[_ngcontent-%COMP%]{width:90%}}.cpc-preferred-agent_avatar[_ngcontent-%COMP%]{position:relative;display:block;width:64px;height:64px;margin-bottom:16px;border-radius:var(--cpc-agent-profile-photo-size)}@media screen and (min-width: 704px){.cpc-preferred-agent_avatar[_ngcontent-%COMP%]{width:104px;height:104px}}.cpc-preferred-agent_info[_ngcontent-%COMP%]{display:flex;align-items:baseline;justify-content:space-between;word-break:break-word}@media screen and (min-width: 704px){.cpc-preferred-agent_info[_ngcontent-%COMP%]{justify-content:initial;word-break:normal}}.cpc-preferred-agent_info[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin:4px 0}@media screen and (min-width: 0) and (max-width: 703.98px){.cpc-preferred-agent_info[_ngcontent-%COMP%]:not(:first-of-type)   p[_ngcontent-%COMP%]{margin-right:5px}}.cpc-preferred-agent_info[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-weight:600;line-height:24px;text-align:end}.cpc-preferred-agent_info-align-center[_ngcontent-%COMP%]{align-items:center}.cpc-preferred-agent_info-width[_ngcontent-%COMP%]{max-width:50%;margin-right:5px;color:var(--cpc-colors-charcoal);line-height:24px;word-break:initial}@media screen and (min-width: 704px){.cpc-preferred-agent_info-width[_ngcontent-%COMP%]{min-width:50%}}.cpc-preferred-agent_info-name[_ngcontent-%COMP%]{width:100%;margin-bottom:21px;color:var(--cpc-colors-text);font-weight:600;font-size:24px;line-height:32px;letter-spacing:.3px;text-align:right}@media screen and (min-width: 704px){.cpc-preferred-agent_info-name[_ngcontent-%COMP%]{font-size:26px;text-align:left}}.cpc-preferred-agent_info-email[_ngcontent-%COMP%], .cpc-preferred-agent_info-website[_ngcontent-%COMP%]{color:var(--cpc-colors-resolution-blue)}.popup_agent-button-submit[_ngcontent-%COMP%]{display:grid;margin-top:40px;margin-bottom:10px}@media screen and (min-width: 704px){.popup_agent-button-submit[_ngcontent-%COMP%]{display:flex;justify-content:center;margin-bottom:0}}.cpc-preferred-agent_edit-button[_ngcontent-%COMP%]{display:flex;align-items:center;margin:6px auto 0;color:var(--cpc-colors-resolution-blue);background:transparent;--icon-size: 24px}@media screen and (min-width: 704px){.cpc-preferred-agent_edit-button[_ngcontent-%COMP%]{margin-bottom:16px}}.cpc-preferred-agent_edit-button-text[_ngcontent-%COMP%]{margin-left:10px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PreferredAgentComponent, [{
        type: Component,
        args: [{ selector: 'cpc-preferred-agent', template: "<ng-container\r\n  *ngIf=\"isVisiblePopup\">\r\n  <div class=\"cpc-preferred-agent_exit-wrapper\">\r\n  <cpc-button\r\n    *ngIf=\"showCloseButton\"\r\n    [mode]=\"'tertiary'\"\r\n    size=\"small\"\r\n    [noHorizontalMargin]=\"true\"\r\n    [noVerticalMargin]=\"true\"\r\n    (click)=\"handleClick()\"\r\n    class=\"cpc-preferred-agent_exit\">\r\n    <cpc-icon [icon]=\"ndbxIcons.Close\" [color]=\"'var(--cpc-colors-sonic-silver)'\"></cpc-icon>\r\n  </cpc-button>\r\n  </div>\r\n  <p\r\n    style=\"text-align: center; font-size: 26px; line-height: 36px; letter-spacing: 0.3px; color: #414141; margin: 0 0 30px 0\"> {{title}} </p>\r\n  <div class=\"cpc-preferred-agent_content\">\r\n    <div class=\"cpc-preferred-agent_info cpc-preferred-agent_info-align-center\">\r\n      <div class=\"cpc-preferred-agent_info-width\">\r\n        <img\r\n          [src]=\"prefferedAgent.avatar\"\r\n          alt=\"agent\"\r\n          class=\"cpc-preferred-agent_avatar\"\r\n        >\r\n      </div>\r\n      <p class=\"cpc-preferred-agent_info-name\">{{ prefferedAgent.name }}</p>\r\n    </div>\r\n    <div class=\"cpc-preferred-agent_info\">\r\n      <p class=\"cpc-preferred-agent_info-width\"> {{ agentDetailsText.phoneNumber }} </p>\r\n      <span class=\"cpc-preferred-agent_info-number\"> {{ prefferedAgent.phoneNumber }} </span>\r\n    </div>\r\n    <div class=\"cpc-preferred-agent_info\">\r\n      <p class=\"cpc-preferred-agent_info-width\"> {{ agentDetailsText.email }} </p>\r\n      <span class=\"cpc-preferred-agent_info-email\"> {{ prefferedAgent.addressEmail }} </span>\r\n    </div>\r\n    <div class=\"cpc-preferred-agent_info\">\r\n      <p class=\"cpc-preferred-agent_info-width\"> {{ agentDetailsText.website }} </p>\r\n      <span class=\"cpc-preferred-agent_info-website\"> {{ prefferedAgent.website }} </span>\r\n    </div>\r\n    <cpc-button\r\n      mode=\"primary\"\r\n      [noHorizontalMargin]=\"true\"\r\n      (click)=\"setAgent(prefferedAgent)\"\r\n      class=\"popup_agent-button-submit\"\r\n    > {{ setButtonText }}\r\n    </cpc-button>\r\n    <button\r\n      (click)=\"handleAgent()\"\r\n      class=\"cpc-preferred-agent_edit-button cpc-preferred-agent_button-focus\"\r\n    >\r\n      <cpc-icon [icon]=\"ndbxIcons.Edit\"></cpc-icon>\r\n      <span class=\"cpc-preferred-agent_edit-button-text\"> {{ editButtonText }} </span>\r\n    </button>\r\n  </div>\r\n</ng-container>\r\n", styles: [":root{--font-family: Allianz Neo, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\" !important;--cpc-colors-blue: #003583;--cpc-colors-resolution-blue: #006192;--cpc-colors-dark-cerulian: #003781;--cpc-colors-light-teal: #007d8c;--cpc-colors-light-gray: #d9d9d9;--cpc-colors-silver: #c2c2c2;--cpc-colors-cerulean: #007ab3;--cpc-colors-sonic-silver: #767676;--cpc-colors-whisper: #ececec;--cpc-colors-white-smoke: #f5f5f5;--cpc-colors-dark-gray: #999999;--cpc-colors-pixie-green: #c0ddbd;--cpc-colors-light-peach: #eacfc0;--cpc-colors-rose-white: #f9f2ef;--cpc-colors-charcoal: #414141;--cpc-colors-light-blue: #cfe9ee;--cpc-colors-faux-green: #3da556;--cpc-colors-light-blue-2: #f1f9fa;--cpc-colors-dark-blue: #002567;--cpc-colors-whispers: #e6e6e6;--cpc-colors-seashell-pink: #f7c7c3;--cpc-colors-cerise-red: #dc3149;--cpc-colors-forest-green: #1e8927;--cpc-colors-kashmir-blue: #49648c;--cpc-colors-light-yellow: #fff4d8;--cpc-colors-gold-orange: #edcd03;--cpc-colors-dark-yellow: rgba(255, 232, 176, .5);--cpc-colors-white: #fff;--cpc-colors-light-peach-2: var(--cpc-colors-rose-white);--cpc-colors-light-green: var(--cpc-colors-pixie-green);--cpc-colors-banana-mania: #ffe8b0;--cpc-colors-dark-opacity: rgba(0, 0, 0, .3);--cpc-colors-text: var(--cpc-colors-charcoal);--cpc-colors-border: var(--cpc-colors-light-gray);--cpc-colors-hover: var(--cpc-colors-resolution-blue);--cpc-colors-active: var(--cpc-colors-dark-cerulian);--cpc-colors-active-background: var(--cpc-colors-light-blue-2);--cpc-user-profile-photo-size: 32px;--cpc-agent-profile-photo-size: 104px;--cpc-border: solid 1px var(--cpc-colors-border);--cpc-badge-text: var(--cpc-colors-text);--cpc-badge-background: var(--cpc-colors-white);--cpc-badge-success: #e3ebaf;--cpc-badge-warning: #f7caab;--cpc-badge-text-danger: var(--cpc-colors-white);--cpc-badge-danger: var(--cpc-colors-cerise-red);--cpc-badge-important: #fdd25c;--cpc-badge-text-inactive: var(--cpc-colors-dark-gray);--cpc-badge-inactive: var(--cpc-colors-white);--cpc-badge-icon-active: var(--cpc-colors-resolution-blue);--cpc-badge-icon-inactive: var(--cpc-colors-dark-gray);--cpc-card-divide-bar: var(--cpc-colors-light-blue);--cpc-card-background: var(--cpc-colors-light-blue-2);--cpc-card-background-inactive: var(--cpc-colors-white-smoke);--cpc-document-upload-name-weight: 600;--cpc-document-upload-success-icon-color: var(--cpc-colors-forest-green);--cpc-policy-card-border: solid 1px var(--cpc-colors-light-gray);--cpc-policy-card-border-mobile: solid 1px var(--cpc-colors-light-blue);--cpc-policy-card-header-background: var(--cpc-colors-light-blue-2);--cpc-policy-card-header-background-inactive: var(--cpc-colors-white-smoke);--cpc-policy-card-header-title-color-inactive: #999999;--cpc-policy-progress-track: var(--cpc-colors-whisper);--cpc-policy-progress-progress: var(--cpc-colors-cerulean);--cpc-payments-background-danger-panel: rgba(220, 49, 73, .1);--cpc-payments-danger-border: rgba(220, 49, 73, .4);--cpc-spinner-active-color: var(--cpc-colors-cerulean);--cpc-spinner-background-color: var(--cpc-colors-whisper);--icon-background-color: var(--cpc-colors-faux-green);--icon-color-inactive: var(--cpc-colors-light-gray);--button-primary-background-color: var(--cpc-colors-cerulean);--button-primary-border-color: transparent;--button-primary-text-color: var(--cpc-colors-white);--button-primary-hover-background-color: var(--cpc-colors-resolution-blue);--button-primary-hover-border-color: transparent;--button-primary-hover-text-color: var(--cpc-colors-white);--button-primary-active-background-color: var(--cpc-colors-dark-cerulian);--button-primary-active-text-color: var(--cpc-colors-white);--button-primary-active-border-color: transparent;--button-primary-disabled-background-color: rgba(0, 122, 179, .4);--button-primary-disabled-text-color: hsla(0, 0%, 100%, .4);--button-primary-disabled-border-color: transparent;--button-secondary-background-color: transparent;--button-secondary-border-color: var(--cpc-colors-cerulean);--button-secondary-text-color: var(--cpc-colors-resolution-blue);--button-secondary-hover-background-color: var(--cpc-colors-resolution-blue);--button-secondary-hover-border-color: transparent;--button-secondary-hover-text-color: var(--cpc-colors-white);--button-secondary-active-background-color: var(--cpc-colors-dark-cerulian);--button-secondary-active-text-color: var(--cpc-colors-white);--button-secondary-active-border-color: transparent;--button-secondary-disabled-background-color: transparent;--button-secondary-disabled-text-color: rgba(0, 97, 146, .4);--button-secondary-disabled-border-color: rgba(0, 122, 179, .4);--button-tertiary-background-color: transparent;--button-tertiary-border-color: transparent;--button-tertiary-text-color: var(--button-secondary-text-color);--button-tertiary-hover-background-color: var(--cpc-colors-whisper);--button-tertiary-hover-border-color: transparent;--button-tertiary-hover-text-color: var(--button-secondary-text-color);--button-tertiary-active-background-color: var(--cpc-colors-light-gray);--button-tertiary-active-text-color: var(--button-secondary-text-color);--button-tertiary-active-border-color: transparent;--button-tertiary-disabled-background-color: var(--button-secondary-background-color);--button-tertiary-disabled-text-color: var(--button-secondary-disabled-text-color);--button-tertiary-disabled-border-color: transparent;--button-emphasis-background-color: #f86200;--button-emphasis-border-color: transparent;--button-emphasis-text-color: var(--cpc-colors-white);--button-emphasis-hover-background-color: #e15200;--button-emphasis-hover-border-color: transparent;--button-emphasis-hover-text-color: var(--cpc-colors-white);--button-emphasis-active-background-color: #c15500;--button-emphasis-active-text-color: var(--cpc-colors-white);--button-emphasis-active-border-color: transparent;--button-emphasis-disabled-background-color: rgba(248, 98, 0, .4);--button-emphasis-disabled-text-color: hsla(0, 0%, 100%, .4);--button-emphasis-disabled-border-color: transparent;--button-cta-background-color: var(--cpc-colors-faux-green);--button-cta-border-color: transparent;--button-cta-text-color: var(--cpc-colors-white);--button-cta-hover-background-color: #348357;--button-cta-hover-border-color: transparent;--button-cta-hover-text-color: var(--cpc-colors-white);--button-cta-active-background-color: #276442;--button-cta-active-text-color: var(--cpc-colors-white);--button-cta-active-border-color: transparent;--button-cta-disabled-background-color: rgba(61, 165, 86, .4);--button-cta-disabled-text-color: hsla(0, 0%, 100%, .4);--button-cta-disabled-border-color: transparent;--button-primary-danger-background-color: var(--cpc-colors-cerise-red);--button-primary-danger-border-color: transparent;--button-primary-danger-text-color: var(--cpc-colors-white);--button-primary-danger-hover-background-color: #c51322;--button-primary-danger-hover-border-color: transparent;--button-primary-danger-hover-text-color: var(--cpc-colors-white);--button-primary-danger-active-background-color: #b0050c;--button-primary-danger-active-text-color: var(--cpc-colors-white);--button-primary-danger-active-border-color: transparent;--button-primary-danger-disabled-background-color: rgba(220, 49, 73, .4);--button-primary-danger-disabled-text-color: hsla(0, 0%, 100%, .4);--button-primary-danger-disabled-border-color: transparent;--button-secondary-danger-background-color: transparent;--button-secondary-danger-border-color: var(--cpc-colors-cerise-red);--button-secondary-danger-text-color: var(--cpc-colors-cerise-red);--button-secondary-danger-hover-background-color: #c51322;--button-secondary-danger-hover-border-color: transparent;--button-secondary-danger-hover-text-color: var(--cpc-colors-white);--button-secondary-danger-active-background-color: #b0050c;--button-secondary-danger-active-text-color: var(--cpc-colors-white);--button-secondary-danger-active-border-color: transparent;--button-secondary-danger-disabled-background-color: transparent;--button-secondary-danger-disabled-text-color: rgba(220, 49, 73, .4);--button-secondary-danger-disabled-border-color: rgba(220, 49, 73, .4);--button-tertiary-danger-background-color: transparent;--button-tertiary-danger-border-color: transparent;--button-tertiary-danger-text-color: var(--cpc-colors-cerise-red);--button-tertiary-danger-hover-background-color: #ececec;--button-tertiary-danger-hover-border-color: transparent;--button-tertiary-danger-hover-text-color: var(--cpc-colors-cerise-red);--button-tertiary-danger-active-background-color: var(--cpc-colors-light-gray);--button-tertiary-danger-active-text-color: var(--cpc-colors-cerise-red);--button-tertiary-danger-active-border-color: transparent;--button-tertiary-danger-disabled-background-color: transparent;--button-tertiary-danger-disabled-text-color: rgba(220, 49, 73, .4);--button-tertiary-danger-disabled-border-color: transparent;--button-text-transform: uppercase;--button-border-radius: 4px;--button-border-width: 2px;--button-small-height: 32px;--button-small-medium-height: 40px;--button-medium-height: 48px;--button-large-height: 72px;--button-small-icon-size: 16px;--button-small-medium-icon-size: 20px;--button-medium-icon-size: 24px;--button-large-icon-size: 24px;--help-modal-fab-color: var(--cpc-colors-resolution-blue);--help-modal-font-size: 16px;--help-modal-font-weight: 600;--help-modal-line-height: 1.5;--help-modal-letter-spacing: 1px;--help-modal-background-color: var(--cpc-colors-white);--help-modal-box-shadow-color: #e3e6e6;--help-modal-icon-size: 24px;--help-modal-icon-info-size: 40px;--help-modal-icon-info-color: var(--cpc-colors-white);--help-modal-icon-info-background: var(--cpc-colors-cerulean);--help-modal-content-color: var(--cpc-colors-resolution-blue);--help-modal-content-border-color: #d3e3e5;--help-modal-content-list-font-size: 16px;--help-modal-content-selected: 700;--help-modal-content-font-size: 16px;--help-modal-min-width: 280px;--help-modal-max-width: 888px;--help-modal-width:calc(100vw - 32px);--help-modal-max-width-large: 100%;--help-modal-position-bottom: 115px;--help-modal-group-content-max-width: 375px;--paging-input-color: #5b686e;--invesments-row-padding-left: 16px;--error-page-text-color: var(--cpc-colors-charcoal);--error-page-title-weight: 300;--error-page-title-size: 54px;--error-page-subtitle-weight: 400;--error-page-subtitle-size: 24px;--logout-page-text-color: var(--cpc-colors-charcoal);--logout-page-text-font-weight: 500;--logout-page-title-font-size: 26px;--logout-page-title-line-height: 32px;--logout-page-title-letter-spacing: .26px;--logout-page-subtitle-font-size: 16px;--logout-page-subtitle-line-height: 24px;--popup-change-agent-active-background: var(--cpc-colors-light-blue-2);--popup-change-agent-active-border: var(--cpc-colors-cerulean)}.cpc-preferred-agent_exit-wrapper{display:flex;justify-content:end;min-height:43.64px}.cpc-preferred-agent_exit{font-size:24px;background:transparent;border:none;border-radius:4px;cursor:pointer;transition:all 125ms linear;-webkit-appearance:none;appearance:none}.cpc-preferred-agent_button-focus{background:transparent;border-radius:0;-webkit-appearance:none;appearance:none;transition:all 125ms linear;padding:0;background-color:transparent;border:none;cursor:pointer}.cpc-preferred-agent_button-focus:focus,.cpc-preferred-agent_button-focus.pseudo-states--focus{outline:0;box-shadow:var(--focus-box-shadow, 0 0 0 2px #fff, 0 0 0 6px #009de6)}.cpc-preferred-agent_content{display:flex;flex-direction:column;max-width:320px;margin:0 auto 20px;text-align:left}@media screen and (min-width: 704px){.cpc-preferred-agent_content{width:90%}}.cpc-preferred-agent_avatar{position:relative;display:block;width:64px;height:64px;margin-bottom:16px;border-radius:var(--cpc-agent-profile-photo-size)}@media screen and (min-width: 704px){.cpc-preferred-agent_avatar{width:104px;height:104px}}.cpc-preferred-agent_info{display:flex;align-items:baseline;justify-content:space-between;word-break:break-word}@media screen and (min-width: 704px){.cpc-preferred-agent_info{justify-content:initial;word-break:normal}}.cpc-preferred-agent_info p{margin:4px 0}@media screen and (min-width: 0) and (max-width: 703.98px){.cpc-preferred-agent_info:not(:first-of-type) p{margin-right:5px}}.cpc-preferred-agent_info span{font-weight:600;line-height:24px;text-align:end}.cpc-preferred-agent_info-align-center{align-items:center}.cpc-preferred-agent_info-width{max-width:50%;margin-right:5px;color:var(--cpc-colors-charcoal);line-height:24px;word-break:initial}@media screen and (min-width: 704px){.cpc-preferred-agent_info-width{min-width:50%}}.cpc-preferred-agent_info-name{width:100%;margin-bottom:21px;color:var(--cpc-colors-text);font-weight:600;font-size:24px;line-height:32px;letter-spacing:.3px;text-align:right}@media screen and (min-width: 704px){.cpc-preferred-agent_info-name{font-size:26px;text-align:left}}.cpc-preferred-agent_info-email,.cpc-preferred-agent_info-website{color:var(--cpc-colors-resolution-blue)}.popup_agent-button-submit{display:grid;margin-top:40px;margin-bottom:10px}@media screen and (min-width: 704px){.popup_agent-button-submit{display:flex;justify-content:center;margin-bottom:0}}.cpc-preferred-agent_edit-button{display:flex;align-items:center;margin:6px auto 0;color:var(--cpc-colors-resolution-blue);background:transparent;--icon-size: 24px}@media screen and (min-width: 704px){.cpc-preferred-agent_edit-button{margin-bottom:16px}}.cpc-preferred-agent_edit-button-text{margin-left:10px}\n"] }]
    }], null, { title: [{
            type: Input
        }], isVisiblePopup: [{
            type: Input
        }], prefferedAgent: [{
            type: Input
        }], agentDetailsText: [{
            type: Input
        }], setButtonText: [{
            type: Input
        }], editButtonText: [{
            type: Input
        }], showCloseButton: [{
            type: Input
        }], selectedAgent: [{
            type: Output
        }], editAgent: [{
            type: Output
        }], isVisiblePopupChange: [{
            type: Output
        }] }); })();

function ChangeAgentComponent_ng_container_0_cpc_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cpc-button", 9);
    i0.ɵɵlistener("click", function ChangeAgentComponent_ng_container_0_cpc_button_2_Template_cpc_button_click_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r3.handleClick()); });
    i0.ɵɵelement(1, "cpc-icon", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("mode", "tertiary")("noHorizontalMargin", true)("noVerticalMargin", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("icon", ctx_r1.ndbxIcons.Close)("color", "var(--cpc-colors-sonic-silver)");
} }
const _c0 = function (a0) { return { "cpc-change-agent_agent-active": a0 }; };
function ChangeAgentComponent_ng_container_0_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵlistener("click", function ChangeAgentComponent_ng_container_0_div_9_Template_div_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r8); const i_r6 = restoredCtx.index; const ctx_r7 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r7.selectAgent(i_r6)); });
    i0.ɵɵelement(1, "img", 12);
    i0.ɵɵelementStart(2, "p", 13);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "p", 14);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const agent_r5 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c0, (ctx_r2.selectedAgent == null ? null : ctx_r2.selectedAgent.name) === (agent_r5 == null ? null : agent_r5.name)));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("src", agent_r5.avatar, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", agent_r5.name, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", agent_r5.specialty, " ");
} }
function ChangeAgentComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 1);
    i0.ɵɵtemplate(2, ChangeAgentComponent_ng_container_0_cpc_button_2_Template, 2, 5, "cpc-button", 2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 3)(4, "p", 4);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "p", 5);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 6);
    i0.ɵɵtemplate(9, ChangeAgentComponent_ng_container_0_div_9_Template, 6, 6, "div", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "cpc-button", 8);
    i0.ɵɵlistener("click", function ChangeAgentComponent_ng_container_0_Template_cpc_button_click_10_listener() { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r9.handleAgent(ctx_r9.selectedAgent)); });
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.showCloseButton);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.headTitle, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.title, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.agents);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.submitButtonText, " ");
} }
class ChangeAgentComponent {
    constructor(cdr) {
        this.cdr = cdr;
        this.headTitle = 'Preferred servicing agent';
        this.isVisiblePopup = false;
        this.showCloseButton = true;
        this.setAgent = new EventEmitter();
        this.isVisiblePopupChange = new EventEmitter();
        this.ndbxIcons = NdbxIcon;
    }
    ngOnChanges() {
        this.cdr.detectChanges();
        this.setActiveAgent();
    }
    setActiveAgent() {
        this.selectedAgent = undefined;
        this.agents.forEach((agent) => {
            if (agent.name === this.currentAgent?.name) {
                this.selectedAgent = agent;
            }
        });
        if (!this.selectedAgent) {
            const defaultAgent = this.agents[0];
            this.selectedAgent = defaultAgent;
        }
    }
    selectAgent(agent) {
        this.selectedAgent = this.agents[agent];
    }
    handleAgent(agent) {
        if (!agent) {
            return;
        }
        this.setAgent.emit(agent);
    }
    handleClick() {
        this.isVisiblePopup = false;
        this.isVisiblePopupChange.emit(this.isVisiblePopup);
    }
}
ChangeAgentComponent.ɵfac = function ChangeAgentComponent_Factory(t) { return new (t || ChangeAgentComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
ChangeAgentComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ChangeAgentComponent, selectors: [["cpc-change-agent"]], inputs: { headTitle: "headTitle", isVisiblePopup: "isVisiblePopup", title: "title", agents: "agents", currentAgent: "currentAgent", submitButtonText: "submitButtonText", showCloseButton: "showCloseButton" }, outputs: { setAgent: "setAgent", isVisiblePopupChange: "isVisiblePopupChange" }, features: [i0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [[4, "ngIf"], [1, "cpc-change-agent_exit-wrapper"], ["size", "small", "class", "cpc-change-agent_exit", 3, "mode", "noHorizontalMargin", "noVerticalMargin", "click", 4, "ngIf"], [1, "cpc-change-agent"], [2, "text-align", "center", "font-size", "30px", "line-height", "36px", "letter-spacing", "0.3px", "color", "#414141", "margin", "0 0 18px 0"], [1, "cpc-change-agent_title"], [1, "cpc-change-agent_container"], ["class", "cpc-change-agent_agent", 3, "ngClass", "click", 4, "ngFor", "ngForOf"], ["mode", "primary", 3, "click"], ["size", "small", 1, "cpc-change-agent_exit", 3, "mode", "noHorizontalMargin", "noVerticalMargin", "click"], [3, "icon", "color"], [1, "cpc-change-agent_agent", 3, "ngClass", "click"], ["alt", "agent", 1, "cpc-change-agent_agent-avatar", 3, "src"], [1, "cpc-change-agent_agent-name"], [1, "cpc-change-agent_agent-specialty"]], template: function ChangeAgentComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, ChangeAgentComponent_ng_container_0_Template, 12, 5, "ng-container", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.isVisiblePopup);
    } }, dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, ButtonComponent, IconComponent], styles: [".cpc-change-agent[_ngcontent-%COMP%]{position:relative;display:grid;text-align:center}.cpc-change-agent_exit-wrapper[_ngcontent-%COMP%]{display:flex;justify-content:end;min-height:43.64px}.cpc-change-agent_exit[_ngcontent-%COMP%]{font-size:24px;background:transparent;border:none;border-radius:4px;cursor:pointer;transition:all 125ms linear;-webkit-appearance:none;appearance:none}.cpc-change-agent_title[_ngcontent-%COMP%]{margin-bottom:48px;color:var(--cpc-colors-text);font-weight:600;font-size:18px;line-height:24px;text-align:center}.cpc-change-agent_container[_ngcontent-%COMP%]{display:flex;margin-bottom:50px;overflow-x:auto;-webkit-user-select:none;user-select:none}.cpc-change-agent_agent[_ngcontent-%COMP%]{flex-basis:168px;flex-shrink:0;min-height:176px;margin:0 8px 24px;padding:16px;border:1px solid var(--cpc-colors-light-gray);cursor:pointer}.cpc-change-agent_agent[_ngcontent-%COMP%]:first-of-type{margin-left:0}.cpc-change-agent_agent-active[_ngcontent-%COMP%]{background:var(--popup-change-agent-active-background);border:1px solid var(--popup-change-agent-active-border)}.cpc-change-agent_agent-avatar[_ngcontent-%COMP%]{width:80px;height:80px;border-radius:var(--cpc-agent-profile-photo-size)}.cpc-change-agent_agent-name[_ngcontent-%COMP%]{margin:10px 0 0;font-weight:600}.cpc-change-agent_agent-specialty[_ngcontent-%COMP%]{margin-top:0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ChangeAgentComponent, [{
        type: Component,
        args: [{ selector: 'cpc-change-agent', template: "<ng-container\r\n  *ngIf=\"isVisiblePopup\">\r\n  <div class=\"cpc-change-agent_exit-wrapper\">\r\n    <cpc-button\r\n      *ngIf=\"showCloseButton\"\r\n      [mode]=\"'tertiary'\"\r\n      size=\"small\"\r\n      [noHorizontalMargin]=\"true\"\r\n      [noVerticalMargin]=\"true\"\r\n      (click)=\"handleClick()\"\r\n      class=\"cpc-change-agent_exit\">\r\n      <cpc-icon [icon]=\"ndbxIcons.Close\" [color]=\"'var(--cpc-colors-sonic-silver)'\"></cpc-icon>\r\n    </cpc-button>\r\n  </div>\r\n  <div class=\"cpc-change-agent\">\r\n    <p\r\n      style=\"text-align: center; font-size: 30px; line-height: 36px; letter-spacing: 0.3px; color: #414141; margin: 0 0 18px 0\"> {{headTitle}} </p>\r\n    <p class=\"cpc-change-agent_title\"> {{ title }} </p>\r\n    <div class=\"cpc-change-agent_container\">\r\n      <div\r\n        *ngFor=\"let agent of agents; let i = index\"\r\n        [ngClass]=\"{'cpc-change-agent_agent-active': selectedAgent?.name === agent?.name}\"\r\n        (click)=\"selectAgent(i)\"\r\n        class=\"cpc-change-agent_agent\"\r\n      >\r\n        <img\r\n          [src]=\"agent.avatar\"\r\n          alt=\"agent\"\r\n          class=\"cpc-change-agent_agent-avatar\"\r\n        >\r\n        <p class=\"cpc-change-agent_agent-name\"> {{ agent.name }} </p>\r\n        <p class=\"cpc-change-agent_agent-specialty\"> {{ agent.specialty }} </p>\r\n      </div>\r\n    </div>\r\n    <cpc-button\r\n      mode=\"primary\"\r\n      (click)=\"handleAgent(selectedAgent)\"\r\n    > {{ submitButtonText }}\r\n    </cpc-button>\r\n  </div>\r\n</ng-container>\r\n\r\n", styles: [".cpc-change-agent{position:relative;display:grid;text-align:center}.cpc-change-agent_exit-wrapper{display:flex;justify-content:end;min-height:43.64px}.cpc-change-agent_exit{font-size:24px;background:transparent;border:none;border-radius:4px;cursor:pointer;transition:all 125ms linear;-webkit-appearance:none;appearance:none}.cpc-change-agent_title{margin-bottom:48px;color:var(--cpc-colors-text);font-weight:600;font-size:18px;line-height:24px;text-align:center}.cpc-change-agent_container{display:flex;margin-bottom:50px;overflow-x:auto;-webkit-user-select:none;user-select:none}.cpc-change-agent_agent{flex-basis:168px;flex-shrink:0;min-height:176px;margin:0 8px 24px;padding:16px;border:1px solid var(--cpc-colors-light-gray);cursor:pointer}.cpc-change-agent_agent:first-of-type{margin-left:0}.cpc-change-agent_agent-active{background:var(--popup-change-agent-active-background);border:1px solid var(--popup-change-agent-active-border)}.cpc-change-agent_agent-avatar{width:80px;height:80px;border-radius:var(--cpc-agent-profile-photo-size)}.cpc-change-agent_agent-name{margin:10px 0 0;font-weight:600}.cpc-change-agent_agent-specialty{margin-top:0}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }]; }, { headTitle: [{
            type: Input
        }], isVisiblePopup: [{
            type: Input
        }], title: [{
            type: Input
        }], agents: [{
            type: Input
        }], currentAgent: [{
            type: Input
        }], submitButtonText: [{
            type: Input
        }], showCloseButton: [{
            type: Input
        }], setAgent: [{
            type: Output
        }], isVisiblePopupChange: [{
            type: Output
        }] }); })();

var TextDirectivePropsVariants;
(function (TextDirectivePropsVariants) {
    TextDirectivePropsVariants["loginHeader"] = "loginHeader";
    TextDirectivePropsVariants["sectionHeader"] = "sectionHeader";
    TextDirectivePropsVariants["sectionHeaderBolded"] = "sectionHeaderBolded";
    TextDirectivePropsVariants["modalHeader"] = "modalHeader";
    TextDirectivePropsVariants["cardComponentHeader"] = "cardComponentHeader";
    TextDirectivePropsVariants["basicText"] = "basicText";
    TextDirectivePropsVariants["basicTextBolded"] = "basicTextBolded";
    TextDirectivePropsVariants["smallerText"] = "smallerText";
    TextDirectivePropsVariants["smallerTextBolded"] = "smallerTextBolded";
    TextDirectivePropsVariants["helplineAvailability"] = "helplineAvailability";
    TextDirectivePropsVariants["hint"] = "hint";
    TextDirectivePropsVariants["insuranceStatus"] = "insuranceStatus";
    TextDirectivePropsVariants["subject"] = "subject";
    TextDirectivePropsVariants["subjectTheWord"] = "subjectTheWord";
    TextDirectivePropsVariants["sender"] = "sender";
    TextDirectivePropsVariants["senderPosition"] = "senderPosition";
    TextDirectivePropsVariants["messageText"] = "messageText";
    TextDirectivePropsVariants["messageHasBeenSent"] = "messageHasBeenSent";
    TextDirectivePropsVariants["writeNewMessage"] = "writeNewMessage";
    TextDirectivePropsVariants["pleaseChooseSubjec"] = "pleaseChooseSubjec";
})(TextDirectivePropsVariants || (TextDirectivePropsVariants = {}));

const LIGHT = 300;
const REGULAR = 400;
const SEMI_BOLD = 600;
const BOLD = 700;
const calcLineHeight = (fontSize, lineHeight) => String(Number(lineHeight) / Number(fontSize));
const values = {
    loginHeader: {
        fontSize: '30px',
        lineHeight: calcLineHeight('36', '30'),
        letterSpacing: '0.3px',
        fontWeight: LIGHT,
    },
    sectionHeader: {
        fontSize: '24px',
        lineHeight: calcLineHeight('32', '24'),
        letterSpacing: '0.2px',
        fontWeight: LIGHT,
    },
    sectionHeaderBolded: {
        fontSize: '30px',
        lineHeight: calcLineHeight('36', '30'),
        letterSpacing: '0.3px',
        fontWeight: BOLD,
    },
    modalHeader: {
        fontSize: '30px',
        lineHeight: calcLineHeight('36', '30'),
        letterSpacing: '0.3px',
        fontWeight: LIGHT,
    },
    cardComponentHeader: {
        fontSize: '26px',
        lineHeight: calcLineHeight('32', '26'),
        letterSpacing: '0.3px',
        fontWeight: BOLD,
    },
    basicText: {
        fontSize: '18px',
        lineHeight: calcLineHeight('24', '18'),
        letterSpacing: '0',
        fontWeight: REGULAR,
    },
    basicTextBolded: {
        fontSize: '18px',
        lineHeight: calcLineHeight('24', '18'),
        letterSpacing: '0',
        fontWeight: BOLD,
    },
    smallerText: {
        fontSize: '16px',
        lineHeight: calcLineHeight('24', '16'),
        letterSpacing: '0',
        fontWeight: REGULAR,
    },
    smallerTextBolded: {
        fontSize: '16px',
        lineHeight: calcLineHeight('24', '16'),
        letterSpacing: '0',
        fontWeight: BOLD,
        textAlign: 'center',
    },
    helplineAvailability: {
        fontSize: '18px',
        lineHeight: calcLineHeight('16', '18'),
        letterSpacing: '0',
        textAlign: 'center',
    },
    hint: {
        fontSize: '12x',
        lineHeight: calcLineHeight('16', '12'),
        letterSpacing: '0.5px',
        textAlign: 'right',
    },
    insuranceStatus: {
        fontSize: '16px',
        lineHeight: calcLineHeight('24', '16'),
        letterSpacing: '0',
        textAlign: 'center',
    },
    subject: {
        fontSize: '20px',
        lineHeight: calcLineHeight('24', '20'),
        letterSpacing: '0.2px',
        fontWeight: SEMI_BOLD,
    },
    subjectTheWord: {
        fontSize: '20px',
        lineHeight: calcLineHeight('20', '18'),
        letterSpacing: '0.18px',
        fontWeight: REGULAR,
    },
    sender: {
        fontSize: '16px',
        lineHeight: calcLineHeight('24', '16'),
        letterSpacing: '0',
        fontWeight: SEMI_BOLD,
    },
    senderPosition: {
        fontSize: '12px',
        lineHeight: calcLineHeight('15', '12'),
        letterSpacing: '0',
    },
    messageText: {
        fontSize: '16px',
        lineHeight: calcLineHeight('24', '16'),
        letterSpacing: '0',
    },
    messageHasBeenSent: {
        fontSize: '24px',
        lineHeight: calcLineHeight('32', '24'),
        letterSpacing: '0.2px',
        fontWeight: LIGHT,
    },
    writeNewMessage: {
        fontSize: '20px',
        lineHeight: calcLineHeight('24', '20'),
        letterSpacing: '0.2px',
        fontWeight: SEMI_BOLD,
    },
    pleaseChooseSubjec: {
        fontSize: '24px',
        lineHeight: calcLineHeight('32', '24'),
        letterSpacing: '0.2px',
        fontWeight: LIGHT,
    },
};
class TextDirective {
    constructor(ref) {
        this.ref = ref;
        this.cpcText = TextDirectivePropsVariants.basicText;
    }
    ngOnChanges() {
        if (this.cpcText in values) {
            const cssValues = values[this.cpcText];
            Object.keys(cssValues).forEach((key) => {
                const value = cssValues[key];
                this.ref.nativeElement.style[key] = value;
            });
        }
    }
}
TextDirective.ɵfac = function TextDirective_Factory(t) { return new (t || TextDirective)(i0.ɵɵdirectiveInject(i0.ElementRef)); };
TextDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: TextDirective, selectors: [["", "cpcText", ""]], inputs: { cpcText: "cpcText" }, features: [i0.ɵɵNgOnChangesFeature] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TextDirective, [{
        type: Directive,
        args: [{
                selector: '[cpcText]',
            }]
    }], function () { return [{ type: i0.ElementRef }]; }, { cpcText: [{
            type: Input
        }] }); })();

class SafeUrlPipe {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    transform(url) {
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
}
SafeUrlPipe.ɵfac = function SafeUrlPipe_Factory(t) { return new (t || SafeUrlPipe)(i0.ɵɵdirectiveInject(i1$1.DomSanitizer, 16)); };
SafeUrlPipe.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "safeUrl", type: SafeUrlPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SafeUrlPipe, [{
        type: Pipe,
        args: [{ name: 'safeUrl' }]
    }], function () { return [{ type: i1$1.DomSanitizer }]; }, null); })();

class DateFormatPipe {
    transform(value, formatFull = 'dd.MM.yyyy, HH:mm', formatShort = 'dd.MM.yyyy') {
        const date = new Date(value);
        const missingTime = date.getHours() === 0 && date.getMinutes() === 0 && date.getSeconds() === 0;
        if (missingTime) {
            return new DatePipe('en').transform(value, formatShort);
        }
        return new DatePipe('en').transform(value, formatFull);
    }
}
DateFormatPipe.ɵfac = function DateFormatPipe_Factory(t) { return new (t || DateFormatPipe)(); };
DateFormatPipe.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "dateFormat", type: DateFormatPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DateFormatPipe, [{
        type: Pipe,
        args: [{
                name: 'dateFormat',
            }]
    }], null, null); })();

const pipes = [SafeUrlPipe, SafeHtmlPipe, DateFormatPipe];
class PipesModule {
}
PipesModule.ɵfac = function PipesModule_Factory(t) { return new (t || PipesModule)(); };
PipesModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: PipesModule });
PipesModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PipesModule, [{
        type: NgModule,
        args: [{
                declarations: [...pipes],
                imports: [CommonModule],
                exports: [...pipes],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(PipesModule, { declarations: [SafeUrlPipe, SafeHtmlPipe, DateFormatPipe], imports: [CommonModule], exports: [SafeUrlPipe, SafeHtmlPipe, DateFormatPipe] }); })();

const componentsLists = [
    AgentComponent,
    AgentEntryComponent,
    AgentsComponent,
    AllianzLogoComponent,
    AnimationLoaderComponent,
    BackdropComponent,
    BadgeComponent,
    ButtonComponent,
    CardEntryComponent,
    CardGroupComponent,
    CardHeaderComponent,
    CardComponent,
    ClaimsTableColComponent,
    ClaimsTableSortComponent,
    ClaimsTableSwiperComponent,
    ClaimsTablePaginationComponent,
    ClaimsTableComponent,
    ClaimsTableRowComponent,
    ChangeAgentComponent,
    DocumentComponent,
    DocumentUploadComponent,
    DocumentsComponent,
    DropdownDrawerComponent,
    HelpModalComponent,
    HelpModalContentComponent,
    HelpModalGroupComponent,
    IconComponent,
    IllustrationComponent,
    LanguageSwitchComponent,
    MailItemComponent,
    MailListComponent,
    MaintenancePageComponent,
    MenuComponent,
    MenuItemComponent,
    MessagePreviewAttachmentComponent,
    MessagePreviewAttachmentsComponent,
    MessagePreviewContentComponent,
    MessagePreviewFooterComponent,
    MessagePreviewHeaderComponent,
    MessagePreviewItemComponent,
    MessagePreviewTextareaComponent,
    MessagePreviewComponent,
    ModalContentComponent,
    NavItemComponent,
    PaginationComponent,
    PanelComponent,
    PanelGroupComponent,
    PaymentButtonComponent,
    PaymentsRowComponent,
    PaymentsTableComponent,
    PhoneLinkComponent,
    PolicyCardContentComponent,
    PolicyCardEntryComponent,
    PolicyCardFooterComponent,
    PolicyCardHeaderComponent,
    PolicyCardComponent,
    PolicyProgressComponent,
    PreferredAgentComponent,
    SelectComponent,
    SideNavComponent,
    SpinnerComponent,
    StarRatingComponent,
    TopbarComponent,
    TopbarMobileComponent,
    UserProfileDropdownComponent,
    CheckboxComponent,
    AreaChartComponent,
    InvestmentsComponent,
    InvestmentComponent,
    InvestmentHeaderComponent,
    InvestmentTotalComponent,
    InvestmentFooterComponent,
    TabSelectorGroupComponent,
    TabSelectorComponent,
];
const pagesList = [ErrorPageComponent, LogoutPageComponent];
const popupList = [PreferredAgentComponent, ChangeAgentComponent];
class UiComponentsModule {
}
UiComponentsModule.ɵfac = function UiComponentsModule_Factory(t) { return new (t || UiComponentsModule)(); };
UiComponentsModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: UiComponentsModule });
UiComponentsModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, HighchartsChartModule, PipesModule, InfiniteScrollModule, HighchartsChartModule, InfiniteScrollModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UiComponentsModule, [{
        type: NgModule,
        args: [{
                declarations: [...componentsLists, ...pagesList, ...popupList],
                imports: [CommonModule, HighchartsChartModule, PipesModule, InfiniteScrollModule],
                exports: [...componentsLists, ...pagesList, ...popupList, HighchartsChartModule, InfiniteScrollModule],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(UiComponentsModule, { declarations: [AgentComponent,
        AgentEntryComponent,
        AgentsComponent,
        AllianzLogoComponent,
        AnimationLoaderComponent,
        BackdropComponent,
        BadgeComponent,
        ButtonComponent,
        CardEntryComponent,
        CardGroupComponent,
        CardHeaderComponent,
        CardComponent,
        ClaimsTableColComponent,
        ClaimsTableSortComponent,
        ClaimsTableSwiperComponent,
        ClaimsTablePaginationComponent,
        ClaimsTableComponent,
        ClaimsTableRowComponent,
        ChangeAgentComponent,
        DocumentComponent,
        DocumentUploadComponent,
        DocumentsComponent,
        DropdownDrawerComponent,
        HelpModalComponent,
        HelpModalContentComponent,
        HelpModalGroupComponent,
        IconComponent,
        IllustrationComponent,
        LanguageSwitchComponent,
        MailItemComponent,
        MailListComponent,
        MaintenancePageComponent,
        MenuComponent,
        MenuItemComponent,
        MessagePreviewAttachmentComponent,
        MessagePreviewAttachmentsComponent,
        MessagePreviewContentComponent,
        MessagePreviewFooterComponent,
        MessagePreviewHeaderComponent,
        MessagePreviewItemComponent,
        MessagePreviewTextareaComponent,
        MessagePreviewComponent,
        ModalContentComponent,
        NavItemComponent,
        PaginationComponent,
        PanelComponent,
        PanelGroupComponent,
        PaymentButtonComponent,
        PaymentsRowComponent,
        PaymentsTableComponent,
        PhoneLinkComponent,
        PolicyCardContentComponent,
        PolicyCardEntryComponent,
        PolicyCardFooterComponent,
        PolicyCardHeaderComponent,
        PolicyCardComponent,
        PolicyProgressComponent,
        PreferredAgentComponent,
        SelectComponent,
        SideNavComponent,
        SpinnerComponent,
        StarRatingComponent,
        TopbarComponent,
        TopbarMobileComponent,
        UserProfileDropdownComponent,
        CheckboxComponent,
        AreaChartComponent,
        InvestmentsComponent,
        InvestmentComponent,
        InvestmentHeaderComponent,
        InvestmentTotalComponent,
        InvestmentFooterComponent,
        TabSelectorGroupComponent,
        TabSelectorComponent, ErrorPageComponent, LogoutPageComponent, PreferredAgentComponent, ChangeAgentComponent], imports: [CommonModule, HighchartsChartModule, PipesModule, InfiniteScrollModule], exports: [AgentComponent,
        AgentEntryComponent,
        AgentsComponent,
        AllianzLogoComponent,
        AnimationLoaderComponent,
        BackdropComponent,
        BadgeComponent,
        ButtonComponent,
        CardEntryComponent,
        CardGroupComponent,
        CardHeaderComponent,
        CardComponent,
        ClaimsTableColComponent,
        ClaimsTableSortComponent,
        ClaimsTableSwiperComponent,
        ClaimsTablePaginationComponent,
        ClaimsTableComponent,
        ClaimsTableRowComponent,
        ChangeAgentComponent,
        DocumentComponent,
        DocumentUploadComponent,
        DocumentsComponent,
        DropdownDrawerComponent,
        HelpModalComponent,
        HelpModalContentComponent,
        HelpModalGroupComponent,
        IconComponent,
        IllustrationComponent,
        LanguageSwitchComponent,
        MailItemComponent,
        MailListComponent,
        MaintenancePageComponent,
        MenuComponent,
        MenuItemComponent,
        MessagePreviewAttachmentComponent,
        MessagePreviewAttachmentsComponent,
        MessagePreviewContentComponent,
        MessagePreviewFooterComponent,
        MessagePreviewHeaderComponent,
        MessagePreviewItemComponent,
        MessagePreviewTextareaComponent,
        MessagePreviewComponent,
        ModalContentComponent,
        NavItemComponent,
        PaginationComponent,
        PanelComponent,
        PanelGroupComponent,
        PaymentButtonComponent,
        PaymentsRowComponent,
        PaymentsTableComponent,
        PhoneLinkComponent,
        PolicyCardContentComponent,
        PolicyCardEntryComponent,
        PolicyCardFooterComponent,
        PolicyCardHeaderComponent,
        PolicyCardComponent,
        PolicyProgressComponent,
        PreferredAgentComponent,
        SelectComponent,
        SideNavComponent,
        SpinnerComponent,
        StarRatingComponent,
        TopbarComponent,
        TopbarMobileComponent,
        UserProfileDropdownComponent,
        CheckboxComponent,
        AreaChartComponent,
        InvestmentsComponent,
        InvestmentComponent,
        InvestmentHeaderComponent,
        InvestmentTotalComponent,
        InvestmentFooterComponent,
        TabSelectorGroupComponent,
        TabSelectorComponent, ErrorPageComponent, LogoutPageComponent, PreferredAgentComponent, ChangeAgentComponent, HighchartsChartModule, InfiniteScrollModule] }); })();
i0.ɵɵsetComponentScope(ClaimsTableComponent, [i1.NgForOf, i1.NgIf, i1.NgSwitch, i1.NgSwitchCase, i1.NgSwitchDefault, i2.InfiniteScrollDirective, BadgeComponent,
    ClaimsTableColComponent,
    ClaimsTableSwiperComponent,
    ClaimsTablePaginationComponent,
    ClaimsTableRowComponent,
    SpinnerComponent], [DateFormatPipe]);
i0.ɵɵsetComponentScope(PaymentsTableComponent, [i1.NgForOf, i1.NgIf, BadgeComponent,
    ButtonComponent,
    PaginationComponent,
    PaymentsRowComponent], [i1.TitleCasePipe]);

/*
 * Public API Surface of ui-components
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AgentComponent, AgentEntryComponent, AgentsComponent, AllianzLogoComponent, AngularAnimationsTypes, AnimationLoaderComponent, AreaChartComponent, BackdropComponent, BadgeComponent, Breakpoints, ButtonComponent, CardComponent, CardEntryComponent, CardGroupComponent, CardHeaderComponent, ChangeAgentComponent, CheckboxComponent, ClaimsTableColComponent, ClaimsTableComponent, ClaimsTableDataType, ClaimsTablePaginationComponent, ClaimsTablePaginationDirections, ClaimsTableRowComponent, ClaimsTableSortComponent, ClaimsTableSwiperComponent, CpcBadgeSizes, CpcBadgeVariants, CpcCardGroupVariants, CpcCardHeaderTitle, CpcCardHeaderVariants, CpcMailVariants, CpcPaymentsGroupVariants, CpcPaymentsRowVariants, CpcPolicyCardVariant, DEFAULT_BORDER_STYLE, DEFAULT_BORDER_WIDTH, DocumentComponent, DocumentUploadComponent, DocumentsComponent, DropdownDrawerComponent, ErrorPageComponent, ErrorType, HelpModalComponent, HelpModalContentComponent, HelpModalGroupComponent, IconComponent, IllustrationComponent, InvestmentComponent, InvestmentFooterComponent, InvestmentHeaderComponent, InvestmentTotalComponent, InvestmentsComponent, LanguageSwitchComponent, Locales, LogoutPageComponent, MailItemComponent, MailListComponent, MaintenancePageComponent, MenuComponent, MenuItemComponent, MessagePreviewAttachmentComponent, MessagePreviewAttachmentsComponent, MessagePreviewComponent, MessagePreviewContentComponent, MessagePreviewFooterComponent, MessagePreviewHeaderComponent, MessagePreviewItemComponent, MessagePreviewTextareaComponent, ModalContentComponent, NavItemComponent, PaginationComponent, PaginationDirections, PanelComponent, PanelGroupComponent, PaymentButtonComponent, PaymentsRowComponent, PaymentsTableComponent, PhoneLinkComponent, PolicyCardComponent, PolicyCardContentComponent, PolicyCardEntryComponent, PolicyCardFooterComponent, PolicyCardHeaderComponent, PolicyCardHeaderVariants, PolicyProgressComponent, PreferredAgentComponent, SelectComponent, SideNavComponent, SortingDirection, SpinnerComponent, StarRatingComponent, TabSelectorComponent, TabSelectorGroupComponent, TextDirective, TopbarComponent, TopbarMobileComponent, UiComponentsModule, UserProfileDropdownComponent, WidthExpression, animationBuilder, blurRefChildren, clamp, createTemplate, cssVariables, formatCurrency, isWholeNumber, lengthToIndex, nextSlide, prevSlide, randomNumber, randomString, scrollTo, setBorders, setMatchMedia };
